(function() { /*

 Copyright 2015 Google Inc. All Rights Reserved.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
var componentHandler={upgradeDom:function(optJsClass,optCssClass){},upgradeElement:function(element,optJsClass){},upgradeElements:function(elements){},upgradeAllRegistered:function(){},registerUpgradedCallback:function(jsClass,callback){},register:function(config){},downgradeElements:function(nodes){}};
componentHandler=function(){var registeredComponents_=[];var createdComponents_=[];var componentConfigProperty_="mdlComponentConfigInternal_";function findRegisteredClass_(name,optReplace){for(var i=0;i<registeredComponents_.length;i++)if(registeredComponents_[i].className===name){if(typeof optReplace!=="undefined")registeredComponents_[i]=optReplace;return registeredComponents_[i]}return false}function getUpgradedListOfElement_(element){var dataUpgraded=element.getAttribute("data-upgraded");return dataUpgraded===
null?[""]:dataUpgraded.split(",")}function isElementUpgraded_(element,jsClass){var upgradedList=getUpgradedListOfElement_(element);return upgradedList.indexOf(jsClass)!==-1}function createEvent_(eventType,bubbles,cancelable){if("CustomEvent"in window&&typeof window.CustomEvent==="function")return new CustomEvent(eventType,{bubbles:bubbles,cancelable:cancelable});else{var ev=document.createEvent("Events");ev.initEvent(eventType,bubbles,cancelable);return ev}}function upgradeDomInternal(optJsClass,
optCssClass){if(typeof optJsClass==="undefined"&&typeof optCssClass==="undefined")for(var i=0;i<registeredComponents_.length;i++)upgradeDomInternal(registeredComponents_[i].className,registeredComponents_[i].cssClass);else{var jsClass=(optJsClass);if(typeof optCssClass==="undefined"){var registeredClass=findRegisteredClass_(jsClass);if(registeredClass)optCssClass=registeredClass.cssClass}var elements=document.querySelectorAll("."+optCssClass);for(var n=0;n<elements.length;n++)upgradeElementInternal(elements[n],
jsClass)}}function upgradeElementInternal(element,optJsClass){if(!(typeof element==="object"&&element instanceof Element))throw new Error("Invalid argument provided to upgrade MDL element.");var upgradingEv=createEvent_("mdl-componentupgrading",true,true);element.dispatchEvent(upgradingEv);if(upgradingEv.defaultPrevented)return;var upgradedList=getUpgradedListOfElement_(element);var classesToUpgrade=[];if(!optJsClass){var classList=element.classList;registeredComponents_.forEach(function(component){if(classList.contains(component.cssClass)&&
classesToUpgrade.indexOf(component)===-1&&!isElementUpgraded_(element,component.className))classesToUpgrade.push(component)})}else if(!isElementUpgraded_(element,optJsClass))classesToUpgrade.push(findRegisteredClass_(optJsClass));for(var i=0,n=classesToUpgrade.length,registeredClass;i<n;i++){registeredClass=classesToUpgrade[i];if(registeredClass){upgradedList.push(registeredClass.className);element.setAttribute("data-upgraded",upgradedList.join(","));var instance=new registeredClass.classConstructor(element);
instance[componentConfigProperty_]=registeredClass;createdComponents_.push(instance);for(var j=0,m=registeredClass.callbacks.length;j<m;j++)registeredClass.callbacks[j](element);if(registeredClass.widget)element[registeredClass.className]=instance}else throw new Error("Unable to find a registered component for the given class.");var upgradedEv=createEvent_("mdl-componentupgraded",true,false);element.dispatchEvent(upgradedEv)}}function upgradeElementsInternal(elements){if(!Array.isArray(elements))if(elements instanceof
Element)elements=[elements];else elements=Array.prototype.slice.call(elements);for(var i=0,n=elements.length,element;i<n;i++){element=elements[i];if(element instanceof HTMLElement){upgradeElementInternal(element);if(element.children.length>0)upgradeElementsInternal(element.children)}}}function registerInternal(config){var widgetMissing=typeof config.widget==="undefined"&&typeof config["widget"]==="undefined";var widget=true;if(!widgetMissing)widget=config.widget||config["widget"];var newConfig=({classConstructor:config.constructor||
config["constructor"],className:config.classAsString||config["classAsString"],cssClass:config.cssClass||config["cssClass"],widget:widget,callbacks:[]});registeredComponents_.forEach(function(item){if(item.cssClass===newConfig.cssClass)throw new Error("The provided cssClass has already been registered: "+item.cssClass);if(item.className===newConfig.className)throw new Error("The provided className has already been registered");});if(config.constructor.prototype.hasOwnProperty(componentConfigProperty_))throw new Error("MDL component classes must not have "+
componentConfigProperty_+" defined as a property.");var found=findRegisteredClass_(config.classAsString,newConfig);if(!found)registeredComponents_.push(newConfig)}function registerUpgradedCallbackInternal(jsClass,callback){var regClass=findRegisteredClass_(jsClass);if(regClass)regClass.callbacks.push(callback)}function upgradeAllRegisteredInternal(){for(var n=0;n<registeredComponents_.length;n++)upgradeDomInternal(registeredComponents_[n].className)}function deconstructComponentInternal(component){if(component){var componentIndex=
createdComponents_.indexOf(component);createdComponents_.splice(componentIndex,1);var upgrades=component.element_.getAttribute("data-upgraded").split(",");var componentPlace=upgrades.indexOf(component[componentConfigProperty_].classAsString);upgrades.splice(componentPlace,1);component.element_.setAttribute("data-upgraded",upgrades.join(","));var ev=createEvent_("mdl-componentdowngraded",true,false);component.element_.dispatchEvent(ev)}}function downgradeNodesInternal(nodes){var downgradeNode=function(node){createdComponents_.filter(function(item){return item.element_===
node}).forEach(deconstructComponentInternal)};if(nodes instanceof Array||nodes instanceof NodeList)for(var n=0;n<nodes.length;n++)downgradeNode(nodes[n]);else if(nodes instanceof Node)downgradeNode(nodes);else throw new Error("Invalid argument provided to downgrade MDL nodes.");}return{upgradeDom:upgradeDomInternal,upgradeElement:upgradeElementInternal,upgradeElements:upgradeElementsInternal,upgradeAllRegistered:upgradeAllRegisteredInternal,registerUpgradedCallback:registerUpgradedCallbackInternal,
register:registerInternal,downgradeElements:downgradeNodesInternal}}();componentHandler.ComponentConfigPublic;componentHandler.ComponentConfig;componentHandler.Component;componentHandler["upgradeDom"]=componentHandler.upgradeDom;componentHandler["upgradeElement"]=componentHandler.upgradeElement;componentHandler["upgradeElements"]=componentHandler.upgradeElements;componentHandler["upgradeAllRegistered"]=componentHandler.upgradeAllRegistered;componentHandler["registerUpgradedCallback"]=componentHandler.registerUpgradedCallback;
componentHandler["register"]=componentHandler.register;componentHandler["downgradeElements"]=componentHandler.downgradeElements;window.componentHandler=componentHandler;window["componentHandler"]=componentHandler;
window.addEventListener("load",function(){if("classList"in document.createElement("div")&&"querySelector"in document&&"addEventListener"in window&&Array.prototype.forEach){document.documentElement.classList.add("mdl-js");componentHandler.upgradeAllRegistered()}else{componentHandler.upgradeElement=function(){};componentHandler.register=function(){}}});(function(){var MaterialButton=function MaterialButton(element){this.element_=element;this.init()};window["MaterialButton"]=MaterialButton;MaterialButton.prototype.Constant_={};MaterialButton.prototype.CssClasses_={RIPPLE_EFFECT:"mdl-js-ripple-effect",RIPPLE_CONTAINER:"mdl-button__ripple-container",RIPPLE:"mdl-ripple"};MaterialButton.prototype.blurHandler_=function(event){if(event)this.element_.blur()};MaterialButton.prototype.disable=function(){this.element_.disabled=true};MaterialButton.prototype["disable"]=
MaterialButton.prototype.disable;MaterialButton.prototype.enable=function(){this.element_.disabled=false};MaterialButton.prototype["enable"]=MaterialButton.prototype.enable;MaterialButton.prototype.init=function(){if(this.element_){if(this.element_.classList.contains(this.CssClasses_.RIPPLE_EFFECT)){var rippleContainer=document.createElement("span");rippleContainer.classList.add(this.CssClasses_.RIPPLE_CONTAINER);this.rippleElement_=document.createElement("span");this.rippleElement_.classList.add(this.CssClasses_.RIPPLE);
rippleContainer.appendChild(this.rippleElement_);this.boundRippleBlurHandler=this.blurHandler_.bind(this);this.rippleElement_.addEventListener("mouseup",this.boundRippleBlurHandler);this.element_.appendChild(rippleContainer)}this.boundButtonBlurHandler=this.blurHandler_.bind(this);this.element_.addEventListener("mouseup",this.boundButtonBlurHandler);this.element_.addEventListener("mouseleave",this.boundButtonBlurHandler)}};componentHandler.register({constructor:MaterialButton,classAsString:"MaterialButton",
cssClass:"mdl-js-button",widget:true})})();(function(){var MaterialProgress=function MaterialProgress(element){this.element_=element;this.init()};window["MaterialProgress"]=MaterialProgress;MaterialProgress.prototype.Constant_={};MaterialProgress.prototype.CssClasses_={INDETERMINATE_CLASS:"mdl-progress__indeterminate"};MaterialProgress.prototype.setProgress=function(p){if(this.element_.classList.contains(this.CssClasses_.INDETERMINATE_CLASS))return;this.progressbar_.style.width=p+"%"};MaterialProgress.prototype["setProgress"]=MaterialProgress.prototype.setProgress;
MaterialProgress.prototype.setBuffer=function(p){this.bufferbar_.style.width=p+"%";this.auxbar_.style.width=100-p+"%"};MaterialProgress.prototype["setBuffer"]=MaterialProgress.prototype.setBuffer;MaterialProgress.prototype.init=function(){if(this.element_){var el=document.createElement("div");el.className="progressbar bar bar1";this.element_.appendChild(el);this.progressbar_=el;el=document.createElement("div");el.className="bufferbar bar bar2";this.element_.appendChild(el);this.bufferbar_=el;el=document.createElement("div");
el.className="auxbar bar bar3";this.element_.appendChild(el);this.auxbar_=el;this.progressbar_.style.width="0%";this.bufferbar_.style.width="100%";this.auxbar_.style.width="0%";this.element_.classList.add("is-upgraded")}};componentHandler.register({constructor:MaterialProgress,classAsString:"MaterialProgress",cssClass:"mdl-js-progress",widget:true})})();(function(){var MaterialTextfield=function MaterialTextfield(element){this.element_=element;this.maxRows=this.Constant_.NO_MAX_ROWS;this.init()};window["MaterialTextfield"]=MaterialTextfield;MaterialTextfield.prototype.Constant_={NO_MAX_ROWS:-1,MAX_ROWS_ATTRIBUTE:"maxrows"};MaterialTextfield.prototype.CssClasses_={LABEL:"mdl-textfield__label",INPUT:"mdl-textfield__input",IS_DIRTY:"is-dirty",IS_FOCUSED:"is-focused",IS_DISABLED:"is-disabled",IS_INVALID:"is-invalid",IS_UPGRADED:"is-upgraded",HAS_PLACEHOLDER:"has-placeholder"};
MaterialTextfield.prototype.onKeyDown_=function(event){var currentRowCount=event.target.value.split("\n").length;if(event.keyCode===13)if(currentRowCount>=this.maxRows)event.preventDefault()};MaterialTextfield.prototype.onFocus_=function(event){this.element_.classList.add(this.CssClasses_.IS_FOCUSED)};MaterialTextfield.prototype.onBlur_=function(event){this.element_.classList.remove(this.CssClasses_.IS_FOCUSED)};MaterialTextfield.prototype.onReset_=function(event){this.updateClasses_()};MaterialTextfield.prototype.updateClasses_=
function(){this.checkDisabled();this.checkValidity();this.checkDirty();this.checkFocus()};MaterialTextfield.prototype.checkDisabled=function(){if(this.input_.disabled)this.element_.classList.add(this.CssClasses_.IS_DISABLED);else this.element_.classList.remove(this.CssClasses_.IS_DISABLED)};MaterialTextfield.prototype["checkDisabled"]=MaterialTextfield.prototype.checkDisabled;MaterialTextfield.prototype.checkFocus=function(){if(Boolean(this.element_.querySelector(":focus")))this.element_.classList.add(this.CssClasses_.IS_FOCUSED);
else this.element_.classList.remove(this.CssClasses_.IS_FOCUSED)};MaterialTextfield.prototype["checkFocus"]=MaterialTextfield.prototype.checkFocus;MaterialTextfield.prototype.checkValidity=function(){if(this.input_.validity)if(this.input_.validity.valid)this.element_.classList.remove(this.CssClasses_.IS_INVALID);else this.element_.classList.add(this.CssClasses_.IS_INVALID)};MaterialTextfield.prototype["checkValidity"]=MaterialTextfield.prototype.checkValidity;MaterialTextfield.prototype.checkDirty=
function(){if(this.input_.value&&this.input_.value.length>0)this.element_.classList.add(this.CssClasses_.IS_DIRTY);else this.element_.classList.remove(this.CssClasses_.IS_DIRTY)};MaterialTextfield.prototype["checkDirty"]=MaterialTextfield.prototype.checkDirty;MaterialTextfield.prototype.disable=function(){this.input_.disabled=true;this.updateClasses_()};MaterialTextfield.prototype["disable"]=MaterialTextfield.prototype.disable;MaterialTextfield.prototype.enable=function(){this.input_.disabled=false;
this.updateClasses_()};MaterialTextfield.prototype["enable"]=MaterialTextfield.prototype.enable;MaterialTextfield.prototype.change=function(value){this.input_.value=value||"";this.updateClasses_()};MaterialTextfield.prototype["change"]=MaterialTextfield.prototype.change;MaterialTextfield.prototype.init=function(){if(this.element_){this.label_=this.element_.querySelector("."+this.CssClasses_.LABEL);this.input_=this.element_.querySelector("."+this.CssClasses_.INPUT);if(this.input_){if(this.input_.hasAttribute((this.Constant_.MAX_ROWS_ATTRIBUTE))){this.maxRows=
parseInt(this.input_.getAttribute((this.Constant_.MAX_ROWS_ATTRIBUTE)),10);if(isNaN(this.maxRows))this.maxRows=this.Constant_.NO_MAX_ROWS}if(this.input_.hasAttribute("placeholder"))this.element_.classList.add(this.CssClasses_.HAS_PLACEHOLDER);this.boundUpdateClassesHandler=this.updateClasses_.bind(this);this.boundFocusHandler=this.onFocus_.bind(this);this.boundBlurHandler=this.onBlur_.bind(this);this.boundResetHandler=this.onReset_.bind(this);this.input_.addEventListener("input",this.boundUpdateClassesHandler);
this.input_.addEventListener("focus",this.boundFocusHandler);this.input_.addEventListener("blur",this.boundBlurHandler);this.input_.addEventListener("reset",this.boundResetHandler);if(this.maxRows!==this.Constant_.NO_MAX_ROWS){this.boundKeyDownHandler=this.onKeyDown_.bind(this);this.input_.addEventListener("keydown",this.boundKeyDownHandler)}var invalid=this.element_.classList.contains(this.CssClasses_.IS_INVALID);this.updateClasses_();this.element_.classList.add(this.CssClasses_.IS_UPGRADED);if(invalid)this.element_.classList.add(this.CssClasses_.IS_INVALID);
if(this.input_.hasAttribute("autofocus")){this.element_.focus();this.checkFocus()}}}};componentHandler.register({constructor:MaterialTextfield,classAsString:"MaterialTextfield",cssClass:"mdl-js-textfield",widget:true})})();(function(){var h,l=this;function m(a){return void 0!==a}function aa(){}function ba(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=
typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return"function"}else return"null";else if("function"==b&&"undefined"==typeof a.call)return"object";return b}function ca(a){return null!=a}function da(a){return"array"==ba(a)}function ea(a){var b=ba(a);return"array"==b||"object"==b&&"number"==typeof a.length}function n(a){return"string"==typeof a}function p(a){return"function"==ba(a)}function fa(a){var b=typeof a;return"object"==b&&null!=a||"function"==b}var ga="closure_uid_"+(1E9*Math.random()>>>
0),ha=0;function ia(a,b,c){return a.call.apply(a.bind,arguments)}function ja(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}}function q(a,b,c){q=Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?ia:ja;return q.apply(null,arguments)}function ka(a,b){var c=
Array.prototype.slice.call(arguments,1);return function(){var b=c.slice();b.push.apply(b,arguments);return a.apply(this,b)}}function r(a,b){for(var c in b)a[c]=b[c]}var la=Date.now||function(){return+new Date};function ma(a,b){var c=a.split("."),d=l;c[0]in d||!d.execScript||d.execScript("var "+c[0]);for(var e;c.length&&(e=c.shift());)!c.length&&m(b)?d[e]=b:d=d[e]?d[e]:d[e]={}}function t(a,b){function c(){}c.prototype=b.prototype;a.c=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.Md=function(a,
c,f){for(var g=Array(arguments.length-2),k=2;k<arguments.length;k++)g[k-2]=arguments[k];return b.prototype[c].apply(a,g)}}function v(a){if(Error.captureStackTrace)Error.captureStackTrace(this,v);else{var b=Error().stack;b&&(this.stack=b)}a&&(this.message=String(a))}t(v,Error);v.prototype.name="CustomError";var oa;function pa(a,b){for(var c=a.split("%s"),d="",e=Array.prototype.slice.call(arguments,1);e.length&&1<c.length;)d+=c.shift()+e.shift();return d+c.join("%s")}var qa=String.prototype.trim?function(a){return a.trim()}:
function(a){return a.replace(/^[\s\xa0]+|[\s\xa0]+$/g,"")};function ra(a){if(!sa.test(a))return a;-1!=a.indexOf("&")&&(a=a.replace(ta,"&amp;"));-1!=a.indexOf("<")&&(a=a.replace(ua,"&lt;"));-1!=a.indexOf(">")&&(a=a.replace(va,"&gt;"));-1!=a.indexOf('"')&&(a=a.replace(wa,"&quot;"));-1!=a.indexOf("'")&&(a=a.replace(xa,"&#39;"));-1!=a.indexOf("\x00")&&(a=a.replace(ya,"&#0;"));return a}var ta=/&/g,ua=/</g,va=/>/g,wa=/"/g,xa=/'/g,ya=/\x00/g,sa=/[\x00&<>"']/;function za(a,b){return a<b?-1:a>b?1:0}function Aa(a,
b){b.unshift(a);v.call(this,pa.apply(null,b));b.shift()}t(Aa,v);Aa.prototype.name="AssertionError";function Ba(a,b){throw new Aa("Failure"+(a?": "+a:""),Array.prototype.slice.call(arguments,1));}var Ca=Array.prototype.indexOf?function(a,b,c){return Array.prototype.indexOf.call(a,b,c)}:function(a,b,c){c=null==c?0:0>c?Math.max(0,a.length+c):c;if(n(a))return n(b)&&1==b.length?a.indexOf(b,c):-1;for(;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1},Da=Array.prototype.forEach?function(a,b,c){Array.prototype.forEach.call(a,
b,c)}:function(a,b,c){for(var d=a.length,e=n(a)?a.split(""):a,f=0;f<d;f++)f in e&&b.call(c,e[f],f,a)};function Ea(a,b){for(var c=n(a)?a.split(""):a,d=a.length-1;0<=d;--d)d in c&&b.call(void 0,c[d],d,a)}var Fa=Array.prototype.filter?function(a,b,c){return Array.prototype.filter.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=[],f=0,g=n(a)?a.split(""):a,k=0;k<d;k++)if(k in g){var u=g[k];b.call(c,u,k,a)&&(e[f++]=u)}return e},Ga=Array.prototype.map?function(a,b,c){return Array.prototype.map.call(a,
b,c)}:function(a,b,c){for(var d=a.length,e=Array(d),f=n(a)?a.split(""):a,g=0;g<d;g++)g in f&&(e[g]=b.call(c,f[g],g,a));return e},Ha=Array.prototype.some?function(a,b,c){return Array.prototype.some.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=n(a)?a.split(""):a,f=0;f<d;f++)if(f in e&&b.call(c,e[f],f,a))return!0;return!1};function Ia(a,b,c){for(var d=a.length,e=n(a)?a.split(""):a,f=0;f<d;f++)if(f in e&&b.call(c,e[f],f,a))return f;return-1}function Ja(a,b){return 0<=Ca(a,b)}function Ka(a,b){var c=
Ca(a,b),d;(d=0<=c)&&La(a,c);return d}function La(a,b){return 1==Array.prototype.splice.call(a,b,1).length}function Ma(a,b){var c=Ia(a,b,void 0);0<=c&&La(a,c)}function Na(a,b){var c=0;Ea(a,function(d,e){b.call(void 0,d,e,a)&&La(a,e)&&c++})}function Oa(a){return Array.prototype.concat.apply(Array.prototype,arguments)}function Pa(a){var b=a.length;if(0<b){for(var c=Array(b),d=0;d<b;d++)c[d]=a[d];return c}return[]}var Qa;a:{var Ra=l.navigator;if(Ra){var Sa=Ra.userAgent;if(Sa){Qa=Sa;break a}}Qa=""}function w(a){return-1!=
Qa.indexOf(a)}function Ta(a,b,c){for(var d in a)b.call(c,a[d],d,a)}function Ua(a,b){for(var c in a)if(b.call(void 0,a[c],c,a))return!0;return!1}function Va(a){var b=[],c=0,d;for(d in a)b[c++]=a[d];return b}function Wa(a){var b=[],c=0,d;for(d in a)b[c++]=d;return b}var Xa="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");function Ya(a,b){for(var c,d,e=1;e<arguments.length;e++){d=arguments[e];for(c in d)a[c]=d[c];for(var f=0;f<Xa.length;f++)c=
Xa[f],Object.prototype.hasOwnProperty.call(d,c)&&(a[c]=d[c])}}var Za=w("Opera"),x=w("Trident")||w("MSIE"),$a=w("Edge"),ab=$a||x,bb=w("Gecko")&&!(-1!=Qa.toLowerCase().indexOf("webkit")&&!w("Edge"))&&!(w("Trident")||w("MSIE"))&&!w("Edge"),y=-1!=Qa.toLowerCase().indexOf("webkit")&&!w("Edge"),cb=y&&w("Mobile"),db=w("Macintosh");function eb(){var a=l.document;return a?a.documentMode:void 0}var fb;a:{var gb="",hb=function(){var a=Qa;if(bb)return/rv\:([^\);]+)(\)|;)/.exec(a);if($a)return/Edge\/([\d\.]+)/.exec(a);
if(x)return/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);if(y)return/WebKit\/(\S+)/.exec(a);if(Za)return/(?:Version)[ \/]?(\S+)/.exec(a)}();hb&&(gb=hb?hb[1]:"");if(x){var ib=eb();if(null!=ib&&ib>parseFloat(gb)){fb=String(ib);break a}}fb=gb}var jb={};function z(a){var b;if(!(b=jb[a])){b=0;for(var c=qa(String(fb)).split("."),d=qa(String(a)).split("."),e=Math.max(c.length,d.length),f=0;0==b&&f<e;f++){var g=c[f]||"",k=d[f]||"",u=RegExp("(\\d*)(\\D*)","g"),B=RegExp("(\\d*)(\\D*)","g");do{var na=u.exec(g)||
["","",""],W=B.exec(k)||["","",""];if(0==na[0].length&&0==W[0].length)break;b=za(0==na[1].length?0:parseInt(na[1],10),0==W[1].length?0:parseInt(W[1],10))||za(0==na[2].length,0==W[2].length)||za(na[2],W[2])}while(0==b)}b=jb[a]=0<=b}return b}var kb=l.document,lb=kb&&x?eb()||("CSS1Compat"==kb.compatMode?parseInt(fb,10):5):void 0;var mb=!x||9<=Number(lb),nb=!bb&&!x||x&&9<=Number(lb)||bb&&z("1.9.1");x&&z("9");function ob(){this.pa="";this.Lc=pb}ob.prototype.oc=!0;ob.prototype.mc=function(){return 1};ob.prototype.toString=
function(){return"SafeUrl{"+this.pa+"}"};function qb(a){if(a instanceof ob&&a.constructor===ob&&a.Lc===pb)return a.pa;Ba("expected object of type SafeUrl, got '"+a+"' of type "+ba(a));return"type_error:SafeUrl"}var rb=/^(?:(?:https?|mailto|ftp):|[^&:/?#]*(?:[/?#]|$))/i;function sb(a){if(a instanceof ob)return a;a=a.oc?a.pa:String(a);rb.test(a)||(a="about:invalid#zClosurez");return tb(a)}var pb={};function tb(a){var b=new ob;b.pa=a;return b}tb("about:blank");function ub(){this.pa="";this.Kc=vb;this.hc=
null}ub.prototype.mc=function(){return this.hc};ub.prototype.oc=!0;ub.prototype.toString=function(){return"SafeHtml{"+this.pa+"}"};function wb(a){if(a instanceof ub&&a.constructor===ub&&a.Kc===vb)return a.pa;Ba("expected object of type SafeHtml, got '"+a+"' of type "+ba(a));return"type_error:SafeHtml"}var vb={};ub.prototype.fd=function(a){this.pa=a;this.hc=null;return this};function xb(a){return a?new yb(zb(a)):oa||(oa=new yb)}function Ab(a,b){var c=b||document;return c.querySelectorAll&&c.querySelector?
c.querySelectorAll("."+a):Bb(a,b)}function Bb(a,b){var c,d,e,f;c=document;c=b||c;if(c.querySelectorAll&&c.querySelector&&a)return c.querySelectorAll(""+(a?"."+a:""));if(a&&c.getElementsByClassName){var g=c.getElementsByClassName(a);return g}g=c.getElementsByTagName("*");if(a){f={};for(d=e=0;c=g[d];d++){var k=c.className;"function"==typeof k.split&&Ja(k.split(/\s+/),a)&&(f[e++]=c)}f.length=e;return f}return g}function Cb(a,b){Ta(b,function(b,d){"style"==d?a.style.cssText=b:"class"==d?a.className=b:
"for"==d?a.htmlFor=b:Db.hasOwnProperty(d)?a.setAttribute(Db[d],b):0==d.lastIndexOf("aria-",0)||0==d.lastIndexOf("data-",0)?a.setAttribute(d,b):a[d]=b})}var Db={cellpadding:"cellPadding",cellspacing:"cellSpacing",colspan:"colSpan",frameborder:"frameBorder",height:"height",maxlength:"maxLength",nonce:"nonce",role:"role",rowspan:"rowSpan",type:"type",usemap:"useMap",valign:"vAlign",width:"width"};function Eb(a,b,c,d){function e(c){c&&b.appendChild(n(c)?a.createTextNode(c):c)}for(;d<c.length;d++){var f=
c[d];!ea(f)||fa(f)&&0<f.nodeType?e(f):Da(Fb(f)?Pa(f):f,e)}}function Gb(a){return a&&a.parentNode?a.parentNode.removeChild(a):null}function zb(a){return 9==a.nodeType?a:a.ownerDocument||a.document}function Fb(a){if(a&&"number"==typeof a.length){if(fa(a))return"function"==typeof a.item||"string"==typeof a.item;if(p(a))return"function"==typeof a.item}return!1}function Hb(a){return Ib(a,function(a){return n(a.className)&&Ja(a.className.split(/\s+/),"firebaseui-textfield")})}function Ib(a,b){for(var c=
0;a;){if(b(a))return a;a=a.parentNode;c++}return null}function yb(a){this.ua=a||l.document||document}h=yb.prototype;h.ib=xb;h.L=function(a){return n(a)?this.ua.getElementById(a):a};h.Mb=function(a,b){return Ab(a,b||this.ua)};h.C=function(a,b){var c=b||this.ua,d=c||document;return(d.getElementsByClassName?d.getElementsByClassName(a)[0]:d.querySelectorAll&&d.querySelector?d.querySelector("."+a):Bb(a,c)[0])||null};h.Ib=function(a,b,c){var d=this.ua,e=arguments,f=String(e[0]),g=e[1];if(!mb&&g&&(g.name||
g.type)){f=["<",f];g.name&&f.push(' name="',ra(g.name),'"');if(g.type){f.push(' type="',ra(g.type),'"');var k={};Ya(k,g);delete k.type;g=k}f.push(">");f=f.join("")}f=d.createElement(f);g&&(n(g)?f.className=g:da(g)?f.className=g.join(" "):Cb(f,g));2<e.length&&Eb(d,f,e,2);return f};h.createElement=function(a){return this.ua.createElement(String(a))};h.createTextNode=function(a){return this.ua.createTextNode(String(a))};h.appendChild=function(a,b){a.appendChild(b)};h.append=function(a,b){Eb(zb(a),a,
arguments,1)};h.canHaveChildren=function(a){if(1!=a.nodeType)return!1;switch(a.tagName){case "APPLET":case "AREA":case "BASE":case "BR":case "COL":case "COMMAND":case "EMBED":case "FRAME":case "HR":case "IMG":case "INPUT":case "IFRAME":case "ISINDEX":case "KEYGEN":case "LINK":case "NOFRAMES":case "NOSCRIPT":case "META":case "OBJECT":case "PARAM":case "SCRIPT":case "SOURCE":case "STYLE":case "TRACK":case "WBR":return!1}return!0};h.removeNode=Gb;h.lc=function(a){return nb&&void 0!=a.children?a.children:
Fa(a.childNodes,function(a){return 1==a.nodeType})};h.contains=function(a,b){if(!a||!b)return!1;if(a.contains&&1==b.nodeType)return a==b||a.contains(b);if("undefined"!=typeof a.compareDocumentPosition)return a==b||!!(a.compareDocumentPosition(b)&16);for(;b&&a!=b;)b=b.parentNode;return b==a};x&&z(8);var Jb={$d:!0},Kb={be:!0},Lb={ae:!0};function A(){throw Error("Do not instantiate directly");}A.prototype.ha=null;A.prototype.toString=function(){return this.content};function Mb(a,b,c,d){a:if(a=a(b||Nb,
void 0,c),d=(d||xb()).createElement("DIV"),a=Ob(a),a.match(Pb),d.innerHTML=a,1==d.childNodes.length&&(a=d.firstChild,1==a.nodeType)){d=a;break a}return d}function Ob(a){if(!fa(a))return String(a);if(a instanceof A){if(a.U===Jb)return a.content;if(a.U===Lb)return ra(a.content)}Ba("Soy template output is unsafe for use as HTML: "+a);return"zSoyz"}var Pb=/^<(body|caption|col|colgroup|head|html|tr|td|th|tbody|thead|tfoot)>/i,Nb={};function Qb(a){if(null!=a)switch(a.ha){case 1:return 1;case -1:return-1;
case 0:return 0}return null}function Rb(){A.call(this)}t(Rb,A);Rb.prototype.U=Jb;function C(a){return null!=a&&a.U===Jb?a:a instanceof ub?D(wb(a),a.mc()):D(ra(String(String(a))),Qb(a))}function Sb(){A.call(this)}t(Sb,A);Sb.prototype.U={Zd:!0};Sb.prototype.ha=1;function Tb(){A.call(this)}t(Tb,A);Tb.prototype.U=Kb;Tb.prototype.ha=1;function Ub(){A.call(this)}t(Ub,A);Ub.prototype.U={Yd:!0};Ub.prototype.ha=1;function Vb(){A.call(this)}t(Vb,A);Vb.prototype.U={Xd:!0};Vb.prototype.ha=1;function Wb(a,b){this.content=
String(a);this.ha=null!=b?b:null}t(Wb,A);Wb.prototype.U=Lb;function Xb(a){function b(a){this.content=a}b.prototype=a.prototype;return function(a){return new b(String(a))}}function E(a){return new Wb(a,void 0)}var D=function(a){function b(a){this.content=a}b.prototype=a.prototype;return function(a,d){var e=new b(String(a));void 0!==d&&(e.ha=d);return e}}(Rb);Xb(Sb);var Yb=Xb(Tb);Xb(Ub);Xb(Vb);function Zb(a){var b={label:$b("New password")};function c(){}c.prototype=a;a=new c;for(var d in b)a[d]=b[d];
return a}function $b(a){return(a=String(a))?new Wb(a,void 0):""}(function(a){function b(a){this.content=a}b.prototype=a.prototype;return function(a,d){var e=String(a);if(!e)return"";e=new b(e);void 0!==d&&(e.ha=d);return e}})(Rb);function ac(a){return null!=a&&a.U===Jb?String(String(a.content).replace(bc,"").replace(cc,"&lt;")).replace(dc,ec):ra(String(a))}function fc(a){null!=a&&a.U===Kb?a=String(a).replace(gc,hc):a instanceof ob?a=String(qb(a)).replace(gc,hc):(a=String(a),ic.test(a)?a=a.replace(gc,
hc):(Ba("Bad value `%s` for |filterNormalizeUri",[a]),a="#zSoyz"));return a}var jc={"\x00":"&#0;","\t":"&#9;","\n":"&#10;","\x0B":"&#11;","\f":"&#12;","\r":"&#13;"," ":"&#32;",'"':"&quot;","&":"&amp;","'":"&#39;","-":"&#45;","/":"&#47;","<":"&lt;","=":"&#61;",">":"&gt;","`":"&#96;","\u0085":"&#133;","\u00a0":"&#160;","\u2028":"&#8232;","\u2029":"&#8233;"};function ec(a){return jc[a]}var kc={"\x00":"%00","\u0001":"%01","\u0002":"%02","\u0003":"%03","\u0004":"%04","\u0005":"%05","\u0006":"%06","\u0007":"%07",
"\b":"%08","\t":"%09","\n":"%0A","\x0B":"%0B","\f":"%0C","\r":"%0D","\u000e":"%0E","\u000f":"%0F","\u0010":"%10","\u0011":"%11","\u0012":"%12","\u0013":"%13","\u0014":"%14","\u0015":"%15","\u0016":"%16","\u0017":"%17","\u0018":"%18","\u0019":"%19","\u001a":"%1A","\u001b":"%1B","\u001c":"%1C","\u001d":"%1D","\u001e":"%1E","\u001f":"%1F"," ":"%20",'"':"%22","'":"%27","(":"%28",")":"%29","<":"%3C",">":"%3E","\\":"%5C","{":"%7B","}":"%7D","\u007f":"%7F","\u0085":"%C2%85","\u00a0":"%C2%A0","\u2028":"%E2%80%A8",
"\u2029":"%E2%80%A9","\uff01":"%EF%BC%81","\uff03":"%EF%BC%83","\uff04":"%EF%BC%84","\uff06":"%EF%BC%86","\uff07":"%EF%BC%87","\uff08":"%EF%BC%88","\uff09":"%EF%BC%89","\uff0a":"%EF%BC%8A","\uff0b":"%EF%BC%8B","\uff0c":"%EF%BC%8C","\uff0f":"%EF%BC%8F","\uff1a":"%EF%BC%9A","\uff1b":"%EF%BC%9B","\uff1d":"%EF%BC%9D","\uff1f":"%EF%BC%9F","\uff20":"%EF%BC%A0","\uff3b":"%EF%BC%BB","\uff3d":"%EF%BC%BD"};function hc(a){return kc[a]}var dc=/[\x00\x22\x27\x3c\x3e]/g,gc=/[\x00- \x22\x27-\x29\x3c\x3e\\\x7b\x7d\x7f\x85\xa0\u2028\u2029\uff01\uff03\uff04\uff06-\uff0c\uff0f\uff1a\uff1b\uff1d\uff1f\uff20\uff3b\uff3d]/g,
ic=/^(?![^#?]*\/(?:\.|%2E){2}(?:[\/?#]|$))(?:(?:https?|mailto):|[^&:\/?#]*(?:[\/?#]|$))/i,bc=/<(?:!|\/?([a-zA-Z][a-zA-Z0-9:\-]*))(?:[^>'"]|"[^"]*"|'[^']*')*>/g,cc=/</g;function lc(a){a.prototype.then=a.prototype.then;a.prototype.$goog_Thenable=!0}function mc(a){if(!a)return!1;try{return!!a.$goog_Thenable}catch(b){return!1}}function nc(a,b,c){this.hd=c;this.Rc=a;this.sd=b;this.sb=0;this.nb=null}nc.prototype.get=function(){var a;0<this.sb?(this.sb--,a=this.nb,this.nb=a.next,a.next=null):a=this.Rc();
return a};nc.prototype.put=function(a){this.sd(a);this.sb<this.hd&&(this.sb++,a.next=this.nb,this.nb=a)};function oc(){this.Bb=this.La=null}var qc=new nc(function(){return new pc},function(a){a.reset()},100);oc.prototype.add=function(a,b){var c=qc.get();c.set(a,b);this.Bb?this.Bb.next=c:this.La=c;this.Bb=c};oc.prototype.remove=function(){var a=null;this.La&&(a=this.La,this.La=this.La.next,this.La||(this.Bb=null),a.next=null);return a};function pc(){this.next=this.scope=this.Lb=null}pc.prototype.set=
function(a,b){this.Lb=a;this.scope=b;this.next=null};pc.prototype.reset=function(){this.next=this.scope=this.Lb=null};function rc(a){l.setTimeout(function(){throw a;},0)}var sc;function tc(){var a=l.MessageChannel;"undefined"===typeof a&&"undefined"!==typeof window&&window.postMessage&&window.addEventListener&&!w("Presto")&&(a=function(){var a=document.createElement("IFRAME");a.style.display="none";a.src="";document.documentElement.appendChild(a);var b=a.contentWindow,a=b.document;a.open();a.write("");
a.close();var c="callImmediate"+Math.random(),d="file:"==b.location.protocol?"*":b.location.protocol+"//"+b.location.host,a=q(function(a){if(("*"==d||a.origin==d)&&a.data==c)this.port1.onmessage()},this);b.addEventListener("message",a,!1);this.port1={};this.port2={postMessage:function(){b.postMessage(c,d)}}});if("undefined"!==typeof a&&!w("Trident")&&!w("MSIE")){var b=new a,c={},d=c;b.port1.onmessage=function(){if(m(c.next)){c=c.next;var a=c.ec;c.ec=null;a()}};return function(a){d.next={ec:a};d=d.next;
b.port2.postMessage(0)}}return"undefined"!==typeof document&&"onreadystatechange"in document.createElement("SCRIPT")?function(a){var b=document.createElement("SCRIPT");b.onreadystatechange=function(){b.onreadystatechange=null;b.parentNode.removeChild(b);b=null;a();a=null};document.documentElement.appendChild(b)}:function(a){l.setTimeout(a,0)}}function uc(a,b){vc||wc();xc||(vc(),xc=!0);yc.add(a,b)}var vc;function wc(){if(l.Promise&&l.Promise.resolve){var a=l.Promise.resolve(void 0);vc=function(){a.then(zc)}}else vc=
function(){var a=zc;!p(l.setImmediate)||l.Window&&l.Window.prototype&&!w("Edge")&&l.Window.prototype.setImmediate==l.setImmediate?(sc||(sc=tc()),sc(a)):l.setImmediate(a)}}var xc=!1,yc=new oc;function zc(){for(var a;a=yc.remove();){try{a.Lb.call(a.scope)}catch(b){rc(b)}qc.put(a)}xc=!1}function F(a,b){this.T=Ac;this.da=void 0;this.Ca=this.ea=this.j=null;this.kb=this.Kb=!1;if(a!=aa)try{var c=this;a.call(b,function(a){Bc(c,Cc,a)},function(a){if(!(a instanceof Dc))try{if(a instanceof Error)throw a;throw Error("Promise rejected.");
}catch(b$0){}Bc(c,Ec,a)})}catch(d){Bc(this,Ec,d)}}var Ac=0,Cc=2,Ec=3;function Fc(){this.next=this.context=this.Ga=this.Ya=this.sa=null;this.cb=!1}Fc.prototype.reset=function(){this.context=this.Ga=this.Ya=this.sa=null;this.cb=!1};var Gc=new nc(function(){return new Fc},function(a){a.reset()},100);function Hc(a,b,c){var d=Gc.get();d.Ya=a;d.Ga=b;d.context=c;return d}function Ic(a){if(a instanceof F)return a;var b=new F(aa);Bc(b,Cc,a);return b}function Jc(a){return new F(function(b,c){c(a)})}F.prototype.then=
function(a,b,c){return Kc(this,p(a)?a:null,p(b)?b:null,c)};lc(F);function Lc(a){var b=Ic(Mc());return Kc(b,null,a,void 0)}F.prototype.cancel=function(a){this.T==Ac&&uc(function(){var b=new Dc(a);Nc(this,b)},this)};function Nc(a,b){if(a.T==Ac)if(a.j){var c=a.j;if(c.ea){for(var d=0,e=null,f=null,g=c.ea;g&&(g.cb||(d++,g.sa==a&&(e=g),!(e&&1<d)));g=g.next)e||(f=g);e&&(c.T==Ac&&1==d?Nc(c,b):(f?(d=f,d.next==c.Ca&&(c.Ca=d),d.next=d.next.next):Oc(c),Pc(c,e,Ec,b)))}a.j=null}else Bc(a,Ec,b)}function Qc(a,b){a.ea||
a.T!=Cc&&a.T!=Ec||Rc(a);a.Ca?a.Ca.next=b:a.ea=b;a.Ca=b}function Kc(a,b,c,d){var e=Hc(null,null,null);e.sa=new F(function(a,g){e.Ya=b?function(c){try{var e=b.call(d,c);a(e)}catch(B){g(B)}}:a;e.Ga=c?function(b){try{var e=c.call(d,b);!m(e)&&b instanceof Dc?g(b):a(e)}catch(B){g(B)}}:g});e.sa.j=a;Qc(a,e);return e.sa}F.prototype.Ad=function(a){this.T=Ac;Bc(this,Cc,a)};F.prototype.Bd=function(a){this.T=Ac;Bc(this,Ec,a)};function Bc(a,b,c){if(a.T==Ac){a===c&&(b=Ec,c=new TypeError("Promise cannot resolve to itself"));
a.T=1;var d;a:{var e=c,f=a.Ad,g=a.Bd;if(e instanceof F)Qc(e,Hc(f||aa,g||null,a)),d=!0;else if(mc(e))e.then(f,g,a),d=!0;else{if(fa(e))try{var k=e.then;if(p(k)){Sc(e,k,f,g,a);d=!0;break a}}catch(u){g.call(a,u);d=!0;break a}d=!1}}d||(a.da=c,a.T=b,a.j=null,Rc(a),b!=Ec||c instanceof Dc||Tc(a,c))}}function Sc(a,b,c,d,e){function f(a){k||(k=!0,d.call(e,a))}function g(a){k||(k=!0,c.call(e,a))}var k=!1;try{b.call(a,g,f)}catch(u){f(u)}}function Rc(a){a.Kb||(a.Kb=!0,uc(a.Vc,a))}function Oc(a){var b=null;a.ea&&
(b=a.ea,a.ea=b.next,b.next=null);a.ea||(a.Ca=null);return b}F.prototype.Vc=function(){for(var a;a=Oc(this);)Pc(this,a,this.T,this.da);this.Kb=!1};function Pc(a,b,c,d){if(c==Ec&&b.Ga&&!b.cb)for(;a&&a.kb;a=a.j)a.kb=!1;if(b.sa)b.sa.j=null,Uc(b,c,d);else try{b.cb?b.Ya.call(b.context):Uc(b,c,d)}catch(e){Vc.call(null,e)}Gc.put(b)}function Uc(a,b,c){b==Cc?a.Ya.call(a.context,c):a.Ga&&a.Ga.call(a.context,c)}function Tc(a,b){a.kb=!0;uc(function(){a.kb&&Vc.call(null,b)})}var Vc=rc;function Dc(a){v.call(this,
a)}t(Dc,v);Dc.prototype.name="cancel";function Wc(){0!=Xc&&(Yc[this[ga]||(this[ga]=++ha)]=this);this.Da=this.Da;this.za=this.za}var Xc=0,Yc={};Wc.prototype.Da=!1;Wc.prototype.i=function(){if(!this.Da&&(this.Da=!0,this.b(),0!=Xc)){var a=this[ga]||(this[ga]=++ha);delete Yc[a]}};function Zc(a,b){a.Da?m(void 0)?b.call(void 0):b():(a.za||(a.za=[]),a.za.push(m(void 0)?q(b,void 0):b))}Wc.prototype.b=function(){if(this.za)for(;this.za.length;)this.za.shift()()};function $c(a){a&&"function"==typeof a.i&&a.i()}
var ad=!x||9<=Number(lb),bd=x&&!z("9");!y||z("528");bb&&z("1.9b")||x&&z("8")||Za&&z("9.5")||y&&z("528");bb&&!z("8")||x&&z("9");function cd(a,b){this.type=a;this.currentTarget=this.target=b;this.defaultPrevented=this.Aa=!1;this.Ac=!0}cd.prototype.stopPropagation=function(){this.Aa=!0};cd.prototype.preventDefault=function(){this.defaultPrevented=!0;this.Ac=!1};function dd(a){dd[" "](a);return a}dd[" "]=aa;function G(a,b){cd.call(this,a?a.type:"");this.relatedTarget=this.currentTarget=this.target=null;
this.charCode=this.keyCode=this.button=this.screenY=this.screenX=this.clientY=this.clientX=this.offsetY=this.offsetX=0;this.metaKey=this.shiftKey=this.altKey=this.ctrlKey=!1;this.W=this.state=null;a&&this.init(a,b)}t(G,cd);G.prototype.init=function(a,b){var c=this.type=a.type,d=a.changedTouches?a.changedTouches[0]:null;this.target=a.target||a.srcElement;this.currentTarget=b;var e=a.relatedTarget;if(e){if(bb){var f;a:{try{dd(e.nodeName);f=!0;break a}catch(g){}f=!1}f||(e=null)}}else"mouseover"==c?e=
a.fromElement:"mouseout"==c&&(e=a.toElement);this.relatedTarget=e;null===d?(this.offsetX=y||void 0!==a.offsetX?a.offsetX:a.layerX,this.offsetY=y||void 0!==a.offsetY?a.offsetY:a.layerY,this.clientX=void 0!==a.clientX?a.clientX:a.pageX,this.clientY=void 0!==a.clientY?a.clientY:a.pageY,this.screenX=a.screenX||0,this.screenY=a.screenY||0):(this.clientX=void 0!==d.clientX?d.clientX:d.pageX,this.clientY=void 0!==d.clientY?d.clientY:d.pageY,this.screenX=d.screenX||0,this.screenY=d.screenY||0);this.button=
a.button;this.keyCode=a.keyCode||0;this.charCode=a.charCode||("keypress"==c?a.keyCode:0);this.ctrlKey=a.ctrlKey;this.altKey=a.altKey;this.shiftKey=a.shiftKey;this.metaKey=a.metaKey;this.state=a.state;this.W=a;a.defaultPrevented&&this.preventDefault()};G.prototype.stopPropagation=function(){G.c.stopPropagation.call(this);this.W.stopPropagation?this.W.stopPropagation():this.W.cancelBubble=!0};G.prototype.preventDefault=function(){G.c.preventDefault.call(this);var a=this.W;if(a.preventDefault)a.preventDefault();
else if(a.returnValue=!1,bd)try{if(a.ctrlKey||112<=a.keyCode&&123>=a.keyCode)a.keyCode=-1}catch(b){}};var ed="closure_listenable_"+(1E6*Math.random()|0);function fd(a){return!(!a||!a[ed])}var gd=0;function hd(a,b,c,d,e){this.listener=a;this.vb=null;this.src=b;this.type=c;this.Ma=!!d;this.mb=e;this.key=++gd;this.Ja=this.eb=!1}function id(a){a.Ja=!0;a.listener=null;a.vb=null;a.src=null;a.mb=null}function jd(a){this.src=a;this.F={};this.bb=0}h=jd.prototype;h.add=function(a,b,c,d,e){var f=a.toString();
a=this.F[f];a||(a=this.F[f]=[],this.bb++);var g=kd(a,b,d,e);-1<g?(b=a[g],c||(b.eb=!1)):(b=new hd(b,this.src,f,!!d,e),b.eb=c,a.push(b));return b};h.remove=function(a,b,c,d){a=a.toString();if(!(a in this.F))return!1;var e=this.F[a];b=kd(e,b,c,d);return-1<b?(id(e[b]),La(e,b),0==e.length&&(delete this.F[a],this.bb--),!0):!1};function ld(a,b){var c=b.type;c in a.F&&Ka(a.F[c],b)&&(id(b),0==a.F[c].length&&(delete a.F[c],a.bb--))}h.wb=function(a){a=a&&a.toString();var b=0,c;for(c in this.F)if(!a||c==a){for(var d=
this.F[c],e=0;e<d.length;e++)++b,id(d[e]);delete this.F[c];this.bb--}return b};h.Ta=function(a,b,c,d){a=this.F[a.toString()];var e=-1;a&&(e=kd(a,b,c,d));return-1<e?a[e]:null};h.hasListener=function(a,b){var c=m(a),d=c?a.toString():"",e=m(b);return Ua(this.F,function(a){for(var g=0;g<a.length;++g)if(!(c&&a[g].type!=d||e&&a[g].Ma!=b))return!0;return!1})};function kd(a,b,c,d){for(var e=0;e<a.length;++e){var f=a[e];if(!f.Ja&&f.listener==b&&f.Ma==!!c&&f.mb==d)return e}return-1}var md="closure_lm_"+(1E6*
Math.random()|0),nd={},od=0;function pd(a,b,c,d,e){if(da(b)){for(var f=0;f<b.length;f++)pd(a,b[f],c,d,e);return null}c=qd(c);return fd(a)?a.ma(b,c,d,e):rd(a,b,c,!1,d,e)}function rd(a,b,c,d,e,f){if(!b)throw Error("Invalid event type");var g=!!e,k=sd(a);k||(a[md]=k=new jd(a));c=k.add(b,c,d,e,f);if(c.vb)return c;d=td();c.vb=d;d.src=a;d.listener=c;if(a.addEventListener)a.addEventListener(b.toString(),d,g);else if(a.attachEvent)a.attachEvent(ud(b.toString()),d);else throw Error("addEventListener and attachEvent are unavailable.");
od++;return c}function td(){var a=vd,b=ad?function(c){return a.call(b.src,b.listener,c)}:function(c){c=a.call(b.src,b.listener,c);if(!c)return c};return b}function wd(a,b,c,d,e){if(da(b)){for(var f=0;f<b.length;f++)wd(a,b[f],c,d,e);return null}c=qd(c);return fd(a)?a.qc(b,c,d,e):rd(a,b,c,!0,d,e)}function xd(a,b,c,d,e){if(da(b))for(var f=0;f<b.length;f++)xd(a,b[f],c,d,e);else c=qd(c),fd(a)?a.ac(b,c,d,e):a&&(a=sd(a))&&(b=a.Ta(b,c,!!d,e))&&yd(b)}function yd(a){if("number"==typeof a||!a||a.Ja)return;var b=
a.src;if(fd(b)){ld(b.V,a);return}var c=a.type,d=a.vb;b.removeEventListener?b.removeEventListener(c,d,a.Ma):b.detachEvent&&b.detachEvent(ud(c),d);od--;(c=sd(b))?(ld(c,a),0==c.bb&&(c.src=null,b[md]=null)):id(a)}function ud(a){return a in nd?nd[a]:nd[a]="on"+a}function zd(a,b,c,d){var e=!0;if(a=sd(a))if(b=a.F[b.toString()])for(b=b.concat(),a=0;a<b.length;a++){var f=b[a];f&&f.Ma==c&&!f.Ja&&(f=Ad(f,d),e=e&&!1!==f)}return e}function Ad(a,b){var c=a.listener,d=a.mb||a.src;a.eb&&yd(a);return c.call(d,b)}
function vd(a,b){if(a.Ja)return!0;if(!ad){var c;if(!(c=b))a:{c=["window","event"];for(var d=l,e;e=c.shift();)if(null!=d[e])d=d[e];else{c=null;break a}c=d}e=c;c=new G(e,this);d=!0;if(!(0>e.keyCode||void 0!=e.returnValue)){a:{var f=!1;if(0==e.keyCode)try{e.keyCode=-1;break a}catch(u){f=!0}if(f||void 0==e.returnValue)e.returnValue=!0}e=[];for(f=c.currentTarget;f;f=f.parentNode)e.push(f);for(var f=a.type,g=e.length-1;!c.Aa&&0<=g;g--){c.currentTarget=e[g];var k=zd(e[g],f,!0,c),d=d&&k}for(g=0;!c.Aa&&g<
e.length;g++)c.currentTarget=e[g],k=zd(e[g],f,!1,c),d=d&&k}return d}return Ad(a,new G(b,this))}function sd(a){a=a[md];return a instanceof jd?a:null}var Bd="__closure_events_fn_"+(1E9*Math.random()>>>0);function qd(a){if(p(a))return a;a[Bd]||(a[Bd]=function(b){return a.handleEvent(b)});return a[Bd]}function H(){Wc.call(this);this.V=new jd(this);this.Mc=this;this.ub=null}t(H,Wc);H.prototype[ed]=!0;h=H.prototype;h.Yb=function(a){this.ub=a};h.addEventListener=function(a,b,c,d){pd(this,a,b,c,d)};h.removeEventListener=
function(a,b,c,d){xd(this,a,b,c,d)};h.dispatchEvent=function(a){var b,c=this.ub;if(c)for(b=[];c;c=c.ub)b.push(c);var c=this.Mc,d=a.type||a;if(n(a))a=new cd(a,c);else if(a instanceof cd)a.target=a.target||c;else{var e=a;a=new cd(d,c);Ya(a,e)}var e=!0,f;if(b)for(var g=b.length-1;!a.Aa&&0<=g;g--)f=a.currentTarget=b[g],e=Cd(f,d,!0,a)&&e;a.Aa||(f=a.currentTarget=c,e=Cd(f,d,!0,a)&&e,a.Aa||(e=Cd(f,d,!1,a)&&e));if(b)for(g=0;!a.Aa&&g<b.length;g++)f=a.currentTarget=b[g],e=Cd(f,d,!1,a)&&e;return e};h.b=function(){H.c.b.call(this);
this.V&&this.V.wb(void 0);this.ub=null};h.ma=function(a,b,c,d){return this.V.add(String(a),b,!1,c,d)};h.qc=function(a,b,c,d){return this.V.add(String(a),b,!0,c,d)};h.ac=function(a,b,c,d){return this.V.remove(String(a),b,c,d)};function Cd(a,b,c,d){b=a.V.F[String(b)];if(!b)return!0;b=b.concat();for(var e=!0,f=0;f<b.length;++f){var g=b[f];if(g&&!g.Ja&&g.Ma==c){var k=g.listener,u=g.mb||g.src;g.eb&&ld(a.V,g);e=!1!==k.call(u,d)&&e}}return e&&0!=d.Ac}h.Ta=function(a,b,c,d){return this.V.Ta(String(a),b,c,
d)};h.hasListener=function(a,b){return this.V.hasListener(m(a)?String(a):void 0,b)};function Dd(a,b){if(p(a))b&&(a=q(a,b));else if(a&&"function"==typeof a.handleEvent)a=q(a.handleEvent,a);else throw Error("Invalid listener argument");return 2147483647<Number(0)?-1:l.setTimeout(a,0)}function Ed(a){if(a.P&&"function"==typeof a.P)return a.P();if(n(a))return a.split("");if(ea(a)){for(var b=[],c=a.length,d=0;d<c;d++)b.push(a[d]);return b}return Va(a)}function Fd(a,b,c){if(a.forEach&&"function"==typeof a.forEach)a.forEach(b,
c);else if(ea(a)||n(a))Da(a,b,c);else{var d;if(a.ia&&"function"==typeof a.ia)d=a.ia();else if(a.P&&"function"==typeof a.P)d=void 0;else if(ea(a)||n(a)){d=[];for(var e=a.length,f=0;f<e;f++)d.push(f)}else d=Wa(a);for(var e=Ed(a),f=e.length,g=0;g<f;g++)b.call(c,e[g],d&&d[g],a)}}var Gd="StopIteration"in l?l.StopIteration:{message:"StopIteration",stack:""};function Hd(){}Hd.prototype.next=function(){throw Gd;};Hd.prototype.ra=function(){return this};function Id(a){if(a instanceof Hd)return a;if("function"==
typeof a.ra)return a.ra(!1);if(ea(a)){var b=0,c=new Hd;c.next=function(){for(;;){if(b>=a.length)throw Gd;if(b in a)return a[b++];b++}};return c}throw Error("Not implemented");}function Jd(a,b){if(ea(a))try{Da(a,b,void 0)}catch(c){if(c!==Gd)throw c;}else{a=Id(a);try{for(;;)b.call(void 0,a.next(),void 0,a)}catch(c$1){if(c$1!==Gd)throw c$1;}}}function Kd(a){if(ea(a))return Pa(a);a=Id(a);var b=[];Jd(a,function(a){b.push(a)});return b}function Ld(a,b){this.R={};this.m=[];this.Ka=this.w=0;var c=arguments.length;
if(1<c){if(c%2)throw Error("Uneven number of arguments");for(var d=0;d<c;d+=2)this.set(arguments[d],arguments[d+1])}else a&&this.addAll(a)}h=Ld.prototype;h.P=function(){Md(this);for(var a=[],b=0;b<this.m.length;b++)a.push(this.R[this.m[b]]);return a};h.ia=function(){Md(this);return this.m.concat()};h.Oa=function(a){return Nd(this.R,a)};h.clear=function(){this.R={};this.Ka=this.w=this.m.length=0};h.remove=function(a){return Nd(this.R,a)?(delete this.R[a],this.w--,this.Ka++,this.m.length>2*this.w&&
Md(this),!0):!1};function Md(a){if(a.w!=a.m.length){for(var b=0,c=0;b<a.m.length;){var d=a.m[b];Nd(a.R,d)&&(a.m[c++]=d);b++}a.m.length=c}if(a.w!=a.m.length){for(var e={},c=b=0;b<a.m.length;)d=a.m[b],Nd(e,d)||(a.m[c++]=d,e[d]=1),b++;a.m.length=c}}h.get=function(a,b){return Nd(this.R,a)?this.R[a]:b};h.set=function(a,b){Nd(this.R,a)||(this.w++,this.m.push(a),this.Ka++);this.R[a]=b};h.addAll=function(a){var b;a instanceof Ld?(b=a.ia(),a=a.P()):(b=Wa(a),a=Va(a));for(var c=0;c<b.length;c++)this.set(b[c],
a[c])};h.forEach=function(a,b){for(var c=this.ia(),d=0;d<c.length;d++){var e=c[d],f=this.get(e);a.call(b,f,e,this)}};h.clone=function(){return new Ld(this)};h.ra=function(a){Md(this);var b=0,c=this.Ka,d=this,e=new Hd;e.next=function(){if(c!=d.Ka)throw Error("The map has changed since the iterator was created");if(b>=d.m.length)throw Gd;var e=d.m[b++];return a?e:d.R[e]};return e};function Nd(a,b){return Object.prototype.hasOwnProperty.call(a,b)}function Od(a,b,c,d,e){this.reset(a,b,c,d,e)}Od.prototype.Jb=
null;var Pd=0;Od.prototype.reset=function(a,b,c,d,e){"number"==typeof e||Pd++;this.Hc=d||la();this.ya=a;this.tc=b;this.sc=c;delete this.Jb};Od.prototype.Cc=function(a){this.ya=a};function Qd(a){this.uc=a;this.Wa=this.ga=this.ya=this.j=null}function Rd(a,b){this.name=a;this.value=b}Rd.prototype.toString=function(){return this.name};var Sd=new Rd("SHOUT",1200),Td=new Rd("SEVERE",1E3),Ud=new Rd("WARNING",900),Vd=new Rd("INFO",800),Wd=new Rd("CONFIG",700);h=Qd.prototype;h.getName=function(){return this.uc};
h.getParent=function(){return this.j};h.lc=function(){this.ga||(this.ga={});return this.ga};h.Cc=function(a){this.ya=a};function Xd(a){if(a.ya)return a.ya;if(a.j)return Xd(a.j);Ba("Root logger has no level set.");return null}h.log=function(a,b,c){if(a.value>=Xd(this).value)for(p(b)&&(b=b()),a=new Od(a,String(b),this.uc),c&&(a.Jb=c),c="log:"+a.tc,l.console&&(l.console.timeStamp?l.console.timeStamp(c):l.console.markTimeline&&l.console.markTimeline(c)),l.msWriteProfilerMark&&l.msWriteProfilerMark(c),
c=this;c;){b=c;var d=a;if(b.Wa)for(var e=0,f;f=b.Wa[e];e++)f(d);c=c.getParent()}};h.info=function(a,b){this.log(Vd,a,b)};var Yd={},Zd=null;function $d(){Zd||(Zd=new Qd(""),Yd[""]=Zd,Zd.Cc(Wd))}function ae(a){$d();var b;if(!(b=Yd[a])){b=new Qd(a);var c=a.lastIndexOf("."),d=a.substr(c+1),c=ae(a.substr(0,c));c.lc()[d]=b;b.j=c;Yd[a]=b}return b}function be(){this.zc=la()}var ce=new be;be.prototype.set=function(a){this.zc=a};be.prototype.reset=function(){this.set(la())};be.prototype.get=function(){return this.zc};
function de(a){this.oa=a||"";this.xd=ce}h=de.prototype;h.dc=!0;h.Dc=!0;h.ud=!0;h.td=!0;h.Ec=!1;h.vd=!1;function ee(a){return 10>a?"0"+a:String(a)}function fe(a,b){var c=(a.Hc-b)/1E3,d=c.toFixed(3),e=0;if(1>c)e=2;else for(;100>c;)e++,c*=10;for(;0<e--;)d=" "+d;return d}function ge(a){de.call(this,a)}t(ge,de);function he(){this.qd=q(this.Nc,this);this.hb=new ge;this.hb.Dc=!1;this.hb.Ec=!1;this.pc=this.hb.dc=!1;this.rc="";this.Xc={}}he.prototype.Nc=function(a){if(!this.Xc[a.sc]){var b;b=this.hb;var c=
[];c.push(b.oa," ");if(b.Dc){var d=new Date(a.Hc);c.push("[",ee(d.getFullYear()-2E3)+ee(d.getMonth()+1)+ee(d.getDate())+" "+ee(d.getHours())+":"+ee(d.getMinutes())+":"+ee(d.getSeconds())+"."+ee(Math.floor(d.getMilliseconds()/10)),"] ")}b.ud&&c.push("[",fe(a,b.xd.get()),"s] ");b.td&&c.push("[",a.sc,"] ");b.vd&&c.push("[",a.ya.name,"] ");c.push(a.tc);b.Ec&&(d=a.Jb)&&c.push("\n",d instanceof Error?d.message:d.toString());b.dc&&c.push("\n");b=c.join("");if(c=ie)switch(a.ya){case Sd:je(c,"info",b);break;
case Td:je(c,"error",b);break;case Ud:je(c,"warn",b);break;default:je(c,"debug",b)}else this.rc+=b}};var ie=l.console;function je(a,b,c){if(a[b])a[b](c);else a.log(c)}function ke(a){if(a.altKey&&!a.ctrlKey||a.metaKey||112<=a.keyCode&&123>=a.keyCode)return!1;switch(a.keyCode){case 18:case 20:case 93:case 17:case 40:case 35:case 27:case 36:case 45:case 37:case 224:case 91:case 144:case 12:case 34:case 33:case 19:case 255:case 44:case 39:case 145:case 16:case 38:case 252:case 224:case 92:return!1;case 0:return!bb;
default:return 166>a.keyCode||183<a.keyCode}}function le(a,b,c,d,e){if(!(x||$a||y&&z("525")))return!0;if(db&&e)return me(a);if(e&&!d)return!1;"number"==typeof b&&(b=ne(b));if(!c&&(17==b||18==b||db&&91==b))return!1;if((y||$a)&&d&&c)switch(a){case 220:case 219:case 221:case 192:case 186:case 189:case 187:case 188:case 190:case 191:case 192:case 222:return!1}if(x&&d&&b==a)return!1;switch(a){case 13:return!0;case 27:return!(y||$a)}return me(a)}function me(a){if(48<=a&&57>=a||96<=a&&106>=a||65<=a&&90>=
a||(y||$a)&&0==a)return!0;switch(a){case 32:case 43:case 63:case 64:case 107:case 109:case 110:case 111:case 186:case 59:case 189:case 187:case 61:case 188:case 190:case 191:case 192:case 222:case 219:case 220:case 221:return!0;default:return!1}}function ne(a){if(bb)a=oe(a);else if(db&&y)a:switch(a){case 93:a=91;break a}return a}function oe(a){switch(a){case 61:return 187;case 59:return 186;case 173:return 189;case 224:return 91;case 0:return 224;default:return a}}function pe(a,b){this.yb=[];this.vc=
a;this.gc=b||null;this.Va=this.Ea=!1;this.da=void 0;this.$b=this.Pc=this.Eb=!1;this.Ab=0;this.j=null;this.Fb=0}pe.prototype.cancel=function(a){if(this.Ea)this.da instanceof pe&&this.da.cancel();else{if(this.j){var b=this.j;delete this.j;a?b.cancel(a):(b.Fb--,0>=b.Fb&&b.cancel())}this.vc?this.vc.call(this.gc,this):this.$b=!0;this.Ea||(a=new qe,re(this),se(this,!1,a))}};pe.prototype.fc=function(a,b){this.Eb=!1;se(this,a,b)};function se(a,b,c){a.Ea=!0;a.da=c;a.Va=!b;te(a)}function re(a){if(a.Ea){if(!a.$b)throw new ue;
a.$b=!1}}function ve(a,b,c){a.yb.push([b,c,void 0]);a.Ea&&te(a)}pe.prototype.then=function(a,b,c){var d,e,f=new F(function(a,b){d=a;e=b});ve(this,d,function(a){a instanceof qe?f.cancel():e(a)});return f.then(a,b,c)};lc(pe);function we(a){return Ha(a.yb,function(a){return p(a[1])})}function te(a){if(a.Ab&&a.Ea&&we(a)){var b=a.Ab,c=xe[b];c&&(l.clearTimeout(c.va),delete xe[b]);a.Ab=0}a.j&&(a.j.Fb--,delete a.j);for(var b=a.da,d=c=!1;a.yb.length&&!a.Eb;){var e=a.yb.shift(),f=e[0],g=e[1],e=e[2];if(f=a.Va?
g:f)try{var k=f.call(e||a.gc,b);m(k)&&(a.Va=a.Va&&(k==b||k instanceof Error),a.da=b=k);if(mc(b)||"function"===typeof l.Promise&&b instanceof l.Promise)d=!0,a.Eb=!0}catch(u){b=u,a.Va=!0,we(a)||(c=!0)}}a.da=b;d&&(k=q(a.fc,a,!0),d=q(a.fc,a,!1),b instanceof pe?(ve(b,k,d),b.Pc=!0):b.then(k,d));c&&(b=new ye(b),xe[b.va]=b,a.Ab=b.va)}function ue(){v.call(this)}t(ue,v);ue.prototype.message="Deferred has already fired";ue.prototype.name="AlreadyCalledError";function qe(){v.call(this)}t(qe,v);qe.prototype.message=
"Deferred was canceled";qe.prototype.name="CanceledError";function ye(a){this.va=l.setTimeout(q(this.yd,this),0);this.Uc=a}ye.prototype.yd=function(){delete xe[this.va];throw this.Uc;};var xe={};var ze=/^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#(.*))?$/;function Ae(a,b){if(a)for(var c=a.split("&"),d=0;d<c.length;d++){var e=c[d].indexOf("="),f,g=null;0<=e?(f=c[d].substring(0,e),g=c[d].substring(e+1)):f=c[d];b(f,g?decodeURIComponent(g.replace(/\+/g,
" ")):"")}}function Be(a,b,c,d){for(var e=c.length;0<=(b=a.indexOf(c,b))&&b<d;){var f=a.charCodeAt(b-1);if(38==f||63==f)if(f=a.charCodeAt(b+e),!f||61==f||38==f||35==f)return b;b+=e+1}return-1}var Ce=/#|$/;function De(a,b){var c=a.search(Ce),d=Be(a,0,b,c);if(0>d)return null;var e=a.indexOf("&",d);if(0>e||e>c)e=c;d+=b.length+1;return decodeURIComponent(a.substr(d,e-d).replace(/\+/g," "))}var Ee=/[?&]($|#)/;function Fe(a,b){this.$=this.Ba=this.qa="";this.Ia=null;this.Sa=this.Y="";this.M=this.gd=!1;var c;
if(a instanceof Fe)this.M=m(b)?b:a.M,Ge(this,a.qa),c=a.Ba,I(this),this.Ba=c,c=a.$,I(this),this.$=c,He(this,a.Ia),c=a.Y,I(this),this.Y=c,Ie(this,a.ca.clone()),Je(this,a.Sa);else if(a&&(c=String(a).match(ze))){this.M=!!b;Ge(this,c[1]||"",!0);var d=c[2]||"";I(this);this.Ba=Ke(d);d=c[3]||"";I(this);this.$=Ke(d,!0);He(this,c[4]);d=c[5]||"";I(this);this.Y=Ke(d,!0);Ie(this,c[6]||"",!0);Je(this,c[7]||"",!0)}else this.M=!!b,this.ca=new Le(null,0,this.M)}Fe.prototype.toString=function(){var a=[],b=this.qa;
b&&a.push(Me(b,Ne,!0),":");var c=this.$;if(c||"file"==b)a.push("//"),(b=this.Ba)&&a.push(Me(b,Ne,!0),"@"),a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g,"%$1")),c=this.Ia,null!=c&&a.push(":",String(c));if(c=this.Y)this.$&&"/"!=c.charAt(0)&&a.push("/"),a.push(Me(c,"/"==c.charAt(0)?Oe:Pe,!0));(c=this.ca.toString())&&a.push("?",c);(c=this.Sa)&&a.push("#",Me(c,Qe));return a.join("")};Fe.prototype.resolve=function(a){var b=this.clone(),c=!!a.qa;c?Ge(b,a.qa):c=!!a.Ba;if(c){var d=a.Ba;
I(b);b.Ba=d}else c=!!a.$;c?(d=a.$,I(b),b.$=d):c=null!=a.Ia;d=a.Y;if(c)He(b,a.Ia);else if(c=!!a.Y){if("/"!=d.charAt(0))if(this.$&&!this.Y)d="/"+d;else{var e=b.Y.lastIndexOf("/");-1!=e&&(d=b.Y.substr(0,e+1)+d)}e=d;if(".."==e||"."==e)d="";else if(-1!=e.indexOf("./")||-1!=e.indexOf("/.")){for(var d=0==e.lastIndexOf("/",0),e=e.split("/"),f=[],g=0;g<e.length;){var k=e[g++];"."==k?d&&g==e.length&&f.push(""):".."==k?((1<f.length||1==f.length&&""!=f[0])&&f.pop(),d&&g==e.length&&f.push("")):(f.push(k),d=!0)}d=
f.join("/")}else d=e}c?(I(b),b.Y=d):c=""!==a.ca.toString();c?Ie(b,Ke(a.ca.toString())):c=!!a.Sa;c&&Je(b,a.Sa);return b};Fe.prototype.clone=function(){return new Fe(this)};function Ge(a,b,c){I(a);a.qa=c?Ke(b,!0):b;a.qa&&(a.qa=a.qa.replace(/:$/,""))}function He(a,b){I(a);if(b){b=Number(b);if(isNaN(b)||0>b)throw Error("Bad port number "+b);a.Ia=b}else a.Ia=null}function Ie(a,b,c){I(a);b instanceof Le?(a.ca=b,a.ca.Xb(a.M)):(c||(b=Me(b,Re)),a.ca=new Le(b,0,a.M));return a}function Je(a,b,c){I(a);a.Sa=c?
Ke(b):b;return a}function I(a){if(a.gd)throw Error("Tried to modify a read-only Uri");}Fe.prototype.Xb=function(a){this.M=a;this.ca&&this.ca.Xb(a);return this};function Se(a){return a instanceof Fe?a.clone():new Fe(a,void 0)}function Te(a){var b=window.location.href;b instanceof Fe||(b=Se(b));a instanceof Fe||(a=Se(a));return b.resolve(a)}function Ke(a,b){return a?b?decodeURI(a.replace(/%25/g,"%2525")):decodeURIComponent(a):""}function Me(a,b,c){return n(a)?(a=encodeURI(a).replace(b,Ue),c&&(a=a.replace(/%25([0-9a-fA-F]{2})/g,
"%$1")),a):null}function Ue(a){a=a.charCodeAt(0);return"%"+(a>>4&15).toString(16)+(a&15).toString(16)}var Ne=/[#\/\?@]/g,Pe=/[\#\?:]/g,Oe=/[\#\?]/g,Re=/[\#\?@]/g,Qe=/#/g;function Le(a,b,c){this.w=this.v=null;this.I=a||null;this.M=!!c}function Ve(a){a.v||(a.v=new Ld,a.w=0,a.I&&Ae(a.I,function(b,c){a.add(decodeURIComponent(b.replace(/\+/g," ")),c)}))}h=Le.prototype;h.add=function(a,b){Ve(this);this.I=null;a=We(this,a);var c=this.v.get(a);c||this.v.set(a,c=[]);c.push(b);this.w+=1;return this};h.remove=
function(a){Ve(this);a=We(this,a);return this.v.Oa(a)?(this.I=null,this.w-=this.v.get(a).length,this.v.remove(a)):!1};h.clear=function(){this.v=this.I=null;this.w=0};h.Oa=function(a){Ve(this);a=We(this,a);return this.v.Oa(a)};h.ia=function(){Ve(this);for(var a=this.v.P(),b=this.v.ia(),c=[],d=0;d<b.length;d++)for(var e=a[d],f=0;f<e.length;f++)c.push(b[d]);return c};h.P=function(a){Ve(this);var b=[];if(n(a))this.Oa(a)&&(b=Oa(b,this.v.get(We(this,a))));else{a=this.v.P();for(var c=0;c<a.length;c++)b=
Oa(b,a[c])}return b};h.set=function(a,b){Ve(this);this.I=null;a=We(this,a);this.Oa(a)&&(this.w-=this.v.get(a).length);this.v.set(a,[b]);this.w+=1;return this};h.get=function(a,b){var c=a?this.P(a):[];return 0<c.length?String(c[0]):b};h.toString=function(){if(this.I)return this.I;if(!this.v)return"";for(var a=[],b=this.v.ia(),c=0;c<b.length;c++)for(var d=b[c],e=encodeURIComponent(String(d)),d=this.P(d),f=0;f<d.length;f++){var g=e;""!==d[f]&&(g+="="+encodeURIComponent(String(d[f])));a.push(g)}return this.I=
a.join("&")};h.clone=function(){var a=new Le;a.I=this.I;this.v&&(a.v=this.v.clone(),a.w=this.w);return a};function We(a,b){var c=String(b);a.M&&(c=c.toLowerCase());return c}h.Xb=function(a){a&&!this.M&&(Ve(this),this.I=null,this.v.forEach(function(a,c){var d=c.toLowerCase();c!=d&&(this.remove(c),this.remove(d),0<a.length&&(this.I=null,this.v.set(We(this,d),Pa(a)),this.w+=a.length))},this));this.M=a};h.extend=function(a){for(var b=0;b<arguments.length;b++)Fd(arguments[b],function(a,b){this.add(b,a)},
this)};function Xe(a){a=String(a);if(/^\s*$/.test(a)?0:/^[\],:{}\s\u2028\u2029]*$/.test(a.replace(/\\["\\\/bfnrtu]/g,"@").replace(/(?:"[^"\\\n\r\u2028\u2029\x00-\x08\x0a-\x1f]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)[\s\u2028\u2029]*(?=:|,|]|}|$)/g,"]").replace(/(?:^|:|,)(?:[\s\u2028\u2029]*\[)+/g,"")))try{return eval("("+a+")")}catch(b){}throw Error("Invalid JSON string: "+a);}function Ye(a){var b=[];Ze(new $e,a,b);return b.join("")}function $e(){this.xb=void 0}function Ze(a,b,c){if(null==
b)c.push("null");else{if("object"==typeof b){if(da(b)){var d=b;b=d.length;c.push("[");for(var e="",f=0;f<b;f++)c.push(e),e=d[f],Ze(a,a.xb?a.xb.call(d,String(f),e):e,c),e=",";c.push("]");return}if(b instanceof String||b instanceof Number||b instanceof Boolean)b=b.valueOf();else{c.push("{");f="";for(d in b)Object.prototype.hasOwnProperty.call(b,d)&&(e=b[d],"function"!=typeof e&&(c.push(f),af(d,c),c.push(":"),Ze(a,a.xb?a.xb.call(b,d,e):e,c),f=","));c.push("}");return}}switch(typeof b){case "string":af(b,
c);break;case "number":c.push(isFinite(b)&&!isNaN(b)?String(b):"null");break;case "boolean":c.push(String(b));break;case "function":c.push("null");break;default:throw Error("Unknown type: "+typeof b);}}}var bf={'"':'\\"',"\\":"\\\\","/":"\\/","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t","\x0B":"\\u000b"},cf=/\uffff/.test("\uffff")?/[\\\"\x00-\x1f\x7f-\uffff]/g:/[\\\"\x00-\x1f\x7f-\xff]/g;function af(a,b){b.push('"',a.replace(cf,function(a){var b=bf[a];b||(b="\\u"+(a.charCodeAt(0)|65536).toString(16).substr(1),
bf[a]=b);return b}),'"')}function df(a){Wc.call(this);this.Pb=a;this.m={}}t(df,Wc);var ef=[];h=df.prototype;h.ma=function(a,b,c,d){da(b)||(b&&(ef[0]=b.toString()),b=ef);for(var e=0;e<b.length;e++){var f=pd(a,b[e],c||this.handleEvent,d||!1,this.Pb||this);if(!f)break;this.m[f.key]=f}return this};h.qc=function(a,b,c,d){return ff(this,a,b,c,d)};function ff(a,b,c,d,e,f){if(da(c))for(var g=0;g<c.length;g++)ff(a,b,c[g],d,e,f);else{b=wd(b,c,d||a.handleEvent,e,f||a.Pb||a);if(!b)return a;a.m[b.key]=b}return a}
h.ac=function(a,b,c,d,e){if(da(b))for(var f=0;f<b.length;f++)this.ac(a,b[f],c,d,e);else c=c||this.handleEvent,e=e||this.Pb||this,c=qd(c),d=!!d,b=fd(a)?a.Ta(b,c,d,e):a?(a=sd(a))?a.Ta(b,c,d,e):null:null,b&&(yd(b),delete this.m[b.key]);return this};h.wb=function(){Ta(this.m,function(a,b){this.m.hasOwnProperty(b)&&yd(a)},this);this.m={}};h.b=function(){df.c.b.call(this);this.wb()};h.handleEvent=function(){throw Error("EventHandler.handleEvent not implemented");};function gf(){}gf.Yc=function(){return gf.aa?
gf.aa:gf.aa=new gf};gf.prototype.ld=0;function hf(a){H.call(this);this.Pa=a||xb();this.va=null;this.wa=!1;this.f=null;this.ka=void 0;this.fb=this.ga=this.j=null;this.Dd=!1}t(hf,H);h=hf.prototype;h.cd=gf.Yc();h.L=function(){return this.f};h.Mb=function(a){return this.f?this.Pa.Mb(a,this.f):[]};h.C=function(a){return this.f?this.Pa.C(a,this.f):null};function jf(a){a.ka||(a.ka=new df(a));return a.ka}h.getParent=function(){return this.j};h.Yb=function(a){if(this.j&&this.j!=a)throw Error("Method not supported");
hf.c.Yb.call(this,a)};h.ib=function(){return this.Pa};h.Ib=function(){this.f=this.Pa.createElement("DIV")};function J(a,b){if(a.wa)throw Error("Component already rendered");a.f||a.Ib();b?b.insertBefore(a.f,null):a.Pa.ua.body.appendChild(a.f);a.j&&!a.j.wa||a.l()}h.l=function(){this.wa=!0;kf(this,function(a){!a.wa&&a.L()&&a.l()})};h.Ra=function(){kf(this,function(a){a.wa&&a.Ra()});this.ka&&this.ka.wb();this.wa=!1};h.b=function(){this.wa&&this.Ra();this.ka&&(this.ka.i(),delete this.ka);kf(this,function(a){a.i()});
!this.Dd&&this.f&&Gb(this.f);this.j=this.f=this.fb=this.ga=null;hf.c.b.call(this)};function kf(a,b){a.ga&&Da(a.ga,b,void 0)}h.removeChild=function(a,b){if(a){var c=n(a)?a:a.va||(a.va=":"+(a.cd.ld++).toString(36)),d;this.fb&&c?(d=this.fb,d=(null!==d&&c in d?d[c]:void 0)||null):d=null;a=d;if(c&&a){d=this.fb;c in d&&delete d[c];Ka(this.ga,a);b&&(a.Ra(),a.f&&Gb(a.f));c=a;if(null==c)throw Error("Unable to set parent component");c.j=null;hf.c.Yb.call(c,null)}}if(!a)throw Error("Child is not in parent component");
return a};function lf(a){if(a.classList)return a.classList;a=a.className;return n(a)&&a.match(/\S+/g)||[]}function mf(a,b){return a.classList?a.classList.contains(b):Ja(lf(a),b)}function nf(a,b){a.classList?a.classList.add(b):mf(a,b)||(a.className+=0<a.className.length?" "+b:b)}function of(a,b){a.classList?a.classList.remove(b):mf(a,b)&&(a.className=Fa(lf(a),function(a){return a!=b}).join(" "))}function pf(a,b){H.call(this);a&&(this.qb&&this.detach(),this.f=a,this.pb=pd(this.f,"keypress",this,b),
this.Tb=pd(this.f,"keydown",this.lb,b,this),this.qb=pd(this.f,"keyup",this.bd,b,this))}t(pf,H);h=pf.prototype;h.f=null;h.pb=null;h.Tb=null;h.qb=null;h.K=-1;h.la=-1;h.Db=!1;var qf={3:13,12:144,63232:38,63233:40,63234:37,63235:39,63236:112,63237:113,63238:114,63239:115,63240:116,63241:117,63242:118,63243:119,63244:120,63245:121,63246:122,63247:123,63248:44,63272:46,63273:36,63275:35,63276:33,63277:34,63289:144,63302:45},rf={Up:38,Down:40,Left:37,Right:39,Enter:13,F1:112,F2:113,F3:114,F4:115,F5:116,
F6:117,F7:118,F8:119,F9:120,F10:121,F11:122,F12:123,"U+007F":46,Home:36,End:35,PageUp:33,PageDown:34,Insert:45},sf=x||$a||y&&z("525"),tf=db&&bb;h=pf.prototype;h.lb=function(a){if(y||$a)if(17==this.K&&!a.ctrlKey||18==this.K&&!a.altKey||db&&91==this.K&&!a.metaKey)this.la=this.K=-1;-1==this.K&&(a.ctrlKey&&17!=a.keyCode?this.K=17:a.altKey&&18!=a.keyCode?this.K=18:a.metaKey&&91!=a.keyCode&&(this.K=91));sf&&!le(a.keyCode,this.K,a.shiftKey,a.ctrlKey,a.altKey)?this.handleEvent(a):(this.la=ne(a.keyCode),tf&&
(this.Db=a.altKey))};h.bd=function(a){this.la=this.K=-1;this.Db=a.altKey};h.handleEvent=function(a){var b=a.W,c,d,e=b.altKey;x&&"keypress"==a.type?(c=this.la,d=13!=c&&27!=c?b.keyCode:0):(y||$a)&&"keypress"==a.type?(c=this.la,d=0<=b.charCode&&63232>b.charCode&&me(c)?b.charCode:0):Za&&!y?(c=this.la,d=me(c)?b.keyCode:0):(c=b.keyCode||this.la,d=b.charCode||0,tf&&(e=this.Db),db&&63==d&&224==c&&(c=191));var f=c=ne(c),g=b.keyIdentifier;c?63232<=c&&c in qf?f=qf[c]:25==c&&a.shiftKey&&(f=9):g&&g in rf&&(f=
rf[g]);a=f==this.K;this.K=f;b=new uf(f,d,a,b);b.altKey=e;this.dispatchEvent(b)};h.L=function(){return this.f};h.detach=function(){this.pb&&(yd(this.pb),yd(this.Tb),yd(this.qb),this.qb=this.Tb=this.pb=null);this.f=null;this.la=this.K=-1};h.b=function(){pf.c.b.call(this);this.detach()};function uf(a,b,c,d){G.call(this,d);this.type="key";this.keyCode=a;this.charCode=b;this.repeat=c}t(uf,G);var vf=!x;function K(a){var b=a.type;if(!m(b))return null;switch(b.toLowerCase()){case "checkbox":case "radio":return a.checked?
a.value:null;case "select-one":return b=a.selectedIndex,0<=b?a.options[b].value:null;case "select-multiple":for(var b=[],c,d=0;c=a.options[d];d++)c.selected&&b.push(c.value);return b.length?b:null;default:return m(a.value)?a.value:null}}function wf(a){H.call(this);this.f=a;pd(a,xf,this.lb,!1,this);pd(a,"click",this.nc,!1,this)}t(wf,H);var xf=bb?"keypress":"keydown";wf.prototype.lb=function(a){(13==a.keyCode||y&&3==a.keyCode)&&yf(this,a)};wf.prototype.nc=function(a){yf(this,a)};function yf(a,b){var c=
new zf(b);if(a.dispatchEvent(c)){c=new Af(b);try{a.dispatchEvent(c)}finally{b.stopPropagation()}}}wf.prototype.b=function(){wf.c.b.call(this);xd(this.f,xf,this.lb,!1,this);xd(this.f,"click",this.nc,!1,this);delete this.f};function Af(a){G.call(this,a.W);this.type="action"}t(Af,G);function zf(a){G.call(this,a.W);this.type="beforeaction"}t(zf,G);function Bf(a){H.call(this);this.f=a;a=x?"focusout":"blur";this.jd=pd(this.f,x?"focusin":"focus",this,!x);this.kd=pd(this.f,a,this,!x)}t(Bf,H);Bf.prototype.handleEvent=
function(a){var b=new G(a.W);b.type="focusin"==a.type||"focus"==a.type?"focusin":"focusout";this.dispatchEvent(b)};Bf.prototype.b=function(){Bf.c.b.call(this);yd(this.jd);yd(this.kd);delete this.f};function Cf(a){H.call(this);this.$a=null;this.f=a;a=x||$a||y&&!z("531")&&"TEXTAREA"==a.tagName;this.kc=new df(this);this.kc.ma(this.f,a?["keydown","paste","cut","drop","input"]:"input",this)}t(Cf,H);Cf.prototype.handleEvent=function(a){if("input"==a.type)x&&z(10)&&0==a.keyCode&&0==a.charCode||(Df(this),
this.dispatchEvent(Ef(a)));else if("keydown"!=a.type||ke(a)){var b="keydown"==a.type?this.f.value:null;x&&229==a.keyCode&&(b=null);var c=Ef(a);Df(this);this.$a=Dd(function(){this.$a=null;this.f.value!=b&&this.dispatchEvent(c)},this)}};function Df(a){null!=a.$a&&(l.clearTimeout(a.$a),a.$a=null)}function Ef(a){a=new G(a.W);a.type="input";return a}Cf.prototype.b=function(){Cf.c.b.call(this);this.kc.i();Df(this);delete this.f};var Ff=/^[+a-zA-Z0-9_.!#$%&'*\/=?^`{|}~-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z0-9]{2,63}$/;
function Mc(){var a={},b=a.document||document,c=document.createElement("SCRIPT"),d={Bc:c,Ic:void 0},e=new pe(Gf,d),f=null,g=null!=a.timeout?a.timeout:5E3;0<g&&(f=window.setTimeout(function(){Hf(c,!0);var a=new If(Jf,"Timeout reached for loading script //www.gstatic.com/accountchooser/client.js");re(e);se(e,!1,a)},g),d.Ic=f);c.onload=c.onreadystatechange=function(){c.readyState&&"loaded"!=c.readyState&&"complete"!=c.readyState||(Hf(c,a.Pd||!1,f),re(e),se(e,!0,null))};c.onerror=function(){Hf(c,!0,f);
var a=new If(Kf,"Error while loading script //www.gstatic.com/accountchooser/client.js");re(e);se(e,!1,a)};d=a.attributes||{};Ya(d,{type:"text/javascript",charset:"UTF-8",src:"//www.gstatic.com/accountchooser/client.js"});Cb(c,d);Lf(b).appendChild(c);return e}function Lf(a){var b=a.getElementsByTagName("HEAD");return b&&0!=b.length?b[0]:a.documentElement}function Gf(){if(this&&this.Bc){var a=this.Bc;a&&"SCRIPT"==a.tagName&&Hf(a,!0,this.Ic)}}function Hf(a,b,c){null!=c&&l.clearTimeout(c);a.onload=aa;
a.onerror=aa;a.onreadystatechange=aa;b&&window.setTimeout(function(){Gb(a)},0)}var Kf=0,Jf=1;function If(a,b){var c="Jsloader error (code #"+a+")";b&&(c+=": "+b);v.call(this,c);this.code=a}t(If,v);function Mf(a){this.rb=a}Mf.prototype.set=function(a,b){m(b)?this.rb.set(a,Ye(b)):this.rb.remove(a)};Mf.prototype.get=function(a){var b;try{b=this.rb.get(a)}catch(c){return}if(null!==b)try{return Xe(b)}catch(c$2){throw"Storage: Invalid value was encountered";}};Mf.prototype.remove=function(a){this.rb.remove(a)};
function Nf(){}function Of(){}t(Of,Nf);Of.prototype.clear=function(){var a=Kd(this.ra(!0)),b=this;Da(a,function(a){b.remove(a)})};function Pf(a){this.N=a}t(Pf,Of);function Qf(a){if(!a.N)return!1;try{return a.N.setItem("__sak","1"),a.N.removeItem("__sak"),!0}catch(b){return!1}}h=Pf.prototype;h.set=function(a,b){try{this.N.setItem(a,b)}catch(c){if(0==this.N.length)throw"Storage mechanism: Storage disabled";throw"Storage mechanism: Quota exceeded";}};h.get=function(a){a=this.N.getItem(a);if(!n(a)&&null!==
a)throw"Storage mechanism: Invalid value was encountered";return a};h.remove=function(a){this.N.removeItem(a)};h.ra=function(a){var b=0,c=this.N,d=new Hd;d.next=function(){if(b>=c.length)throw Gd;var d=c.key(b++);if(a)return d;d=c.getItem(d);if(!n(d))throw"Storage mechanism: Invalid value was encountered";return d};return d};h.clear=function(){this.N.clear()};h.key=function(a){return this.N.key(a)};function Rf(){var a=null;try{a=window.localStorage||null}catch(b){}this.N=a}t(Rf,Pf);function Sf(){var a=
null;try{a=window.sessionStorage||null}catch(b){}this.N=a}t(Sf,Pf);function Tf(a,b){this.Xa=a;this.oa=b+"::"}t(Tf,Of);Tf.prototype.set=function(a,b){this.Xa.set(this.oa+a,b)};Tf.prototype.get=function(a){return this.Xa.get(this.oa+a)};Tf.prototype.remove=function(a){this.Xa.remove(this.oa+a)};Tf.prototype.ra=function(a){var b=this.Xa.ra(!0),c=this,d=new Hd;d.next=function(){for(var d=b.next();d.substr(0,c.oa.length)!=c.oa;)d=b.next();return a?d.substr(c.oa.length):c.Xa.get(d)};return d};function Uf(a){a=
a||{};var b=a.email,c=a.disabled;return D('<div class="firebaseui-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label"><label class="mdl-textfield__label firebaseui-label" for="email">'+(a.Nd?"Enter new email address":"Email")+'</label><input type="email" name="email" autocomplete="username" class="mdl-textfield__input firebaseui-input firebaseui-id-email" value="'+ac(null!=b?b:"")+'"'+(c?"disabled":"")+'></div><div class="firebaseui-error-wrapper"><p class="firebaseui-error firebaseui-hidden firebaseui-id-email-error"></p></div>')}
function L(a){a=a||{};a=a.label;return D('<button type="submit" class="firebaseui-id-submit firebaseui-button mdl-button mdl-js-button mdl-button--raised mdl-button--colored">'+(a?C(a):"Next")+"</button>")}function Vf(a){a=a||{};a=a.label;return D('<div class="firebaseui-new-password-component"><div class="firebaseui-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label"><label class="mdl-textfield__label firebaseui-label" for="newPassword">'+(a?C(a):"Choose password")+'</label><input type="password" name="newPassword" autocomplete="new-password" class="mdl-textfield__input firebaseui-input firebaseui-id-new-password"></div><a href="javascript:void(0)" class="firebaseui-input-floating-button firebaseui-id-password-toggle firebaseui-input-toggle-on firebaseui-input-toggle-blur"></a><div class="firebaseui-error-wrapper"><p class="firebaseui-error firebaseui-hidden firebaseui-id-new-password-error"></p></div></div>')}
function Wf(){var a;a={};return D('<div class="firebaseui-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label"><label class="mdl-textfield__label firebaseui-label" for="password">'+(a.current?"Current password":"Password")+'</label><input type="password" name="password" autocomplete="current-password" class="mdl-textfield__input firebaseui-input firebaseui-id-password"></div><div class="firebaseui-error-wrapper"><p class="firebaseui-error firebaseui-hidden firebaseui-id-password-error"></p></div>')}
function Xf(){return D('<a class="firebaseui-link firebaseui-id-secondary-link" href="javascript:void(0)">Trouble signing in?</a>')}function Yf(){return D('<button class="firebaseui-id-secondary-link firebaseui-button mdl-button mdl-js-button mdl-button--raised mdl-button--colored">Cancel</button>')}function Zf(a){return D('<div class="firebaseui-info-bar firebaseui-id-info-bar"><p class="firebaseui-info-bar-message">'+C(a.message)+'&nbsp;&nbsp;<a href="javascript:void(0)" class="firebaseui-link firebaseui-id-dismiss-info-bar">Dismiss</a></p></div>')}
Zf.B="firebaseui.auth.soy2.element.infoBar";function $f(){return D('<div class="mdl-progress mdl-js-progress mdl-progress__indeterminate firebaseui-busy-indicator firebaseui-id-busy-indicator"></div>')}$f.B="firebaseui.auth.soy2.element.busyIndicator";function ag(a){a=a||{};var b="";switch(a.providerId){case "google.com":b+="Google";break;case "github.com":b+="Github";break;case "facebook.com":b+="Facebook";break;case "twitter.com":b+="Twitter";break;default:b+="Password"}return E(b)}function bg(a){return D('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-sign-in"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in with email</h1></div><div class="firebaseui-card-content"><div class="firebaseui-relative-wrapper">'+
Uf(a)+'</div></div><div class="firebaseui-card-footer"><div class="firebaseui-form-actions">'+Yf()+L(null)+"</div></div></form></div>")}bg.B="firebaseui.auth.soy2.page.signIn";function cg(a){return D('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-sign-in"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in</h1></div><div class="firebaseui-card-content">'+Uf(a)+Wf()+'</div><div class="firebaseui-card-footer"><div class="firebaseui-form-actions">'+
D(L({label:$b("Sign In")}))+"</div>"+Xf()+"</div></form></div>")}cg.B="firebaseui.auth.soy2.page.passwordSignIn";function dg(a){a=a||{};var b=a.rd,c=a.Jc,d=a.Cb,e=D,f='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-sign-up"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Create account</h1></div><div class="firebaseui-card-content">'+Uf(a);b?(b=a||{},b=b.name,b=D('<div class="firebaseui-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label"><label class="mdl-textfield__label firebaseui-label" for="name">First &amp; last name</label><input type="text" name="name" autocomplete="name" class="mdl-textfield__input firebaseui-input firebaseui-id-name" value="'+
ac(null!=b?b:"")+'"></div><div class="firebaseui-error-wrapper"><p class="firebaseui-error firebaseui-hidden firebaseui-id-name-error"></p></div>')):b="";f=f+b+Vf({Od:!0});c?(a=a||{},a=D('<p class="firebaseui-tos">By tapping SAVE, you are indicating that you agree to the <a href="'+ac(fc(a.Jc))+'" class="firebaseui-link" target="_blank">Terms of Service</a></p>')):a="";return e(f+a+'</div><div class="firebaseui-card-footer"><div class="firebaseui-form-actions">'+(d?Yf():"")+D(L({label:$b("Save")}))+
"</div></div></form></div>")}dg.B="firebaseui.auth.soy2.page.passwordSignUp";function eg(a){a=a||{};var b=a.Cb;return D('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-recovery"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Recover password</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">Get instructions sent to this email that explain how to reset your password</p>'+Uf(a)+'</div><div class="firebaseui-card-footer"><div class="firebaseui-form-actions">'+
(b?Yf():"")+L({label:$b("Send")})+"</div></div></form></div>")}eg.B="firebaseui.auth.soy2.page.passwordRecovery";function fg(a){var b=a.H;return D('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-recovery-email-sent"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Check your email</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">Follow the instructions sent to <strong>'+C(a.email)+'</strong> to recover your password</p></div><div class="firebaseui-card-footer">'+
(b?'<div class="firebaseui-form-actions">'+L({label:$b("Done")})+"</div>":"")+"</div></div>")}fg.B="firebaseui.auth.soy2.page.passwordRecoveryEmailSent";function gg(){return D('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-callback"><div class="firebaseui-callback-indicator-container">'+$f()+"</div></div>")}gg.B="firebaseui.auth.soy2.page.callback";function hg(a){return D('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-linking"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in</h1></div><div class="firebaseui-card-content"><h2 class="firebaseui-subtitle">You already have an account</h2><p class="firebaseui-text">You\u2019ve already used <strong>'+
C(a.email)+"</strong> to sign in. Enter your password for that account.</p>"+Wf()+'</div><div class="firebaseui-card-footer">'+Xf()+'<div class="firebaseui-form-actions">'+D(L({label:$b("Sign In")}))+"</div></div></form></div>")}hg.B="firebaseui.auth.soy2.page.passwordLinking";function ig(a){var b=a.email;a=""+ag(a);a=$b(a);b=""+('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-federated-linking"><form onsubmit="return false;"><div class="firebaseui-card-content">As you have previously linked to '+C(a)+' with the same email (<strong>'+
C(b)+"</strong>), please sign in with "+C(a)+' instead to continue.</p></div><div class="firebaseui-card-footer"><div class="firebaseui-form-actions">'+L({label:$b("Sign in with "+a)})+"</div></div></form></div>");return D(b)}ig.B="firebaseui.auth.soy2.page.federatedLinking";function jg(a){return D('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-reset"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Reset your password</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">for <strong>'+
C(a.email)+"</strong></p>"+Vf(Zb(a))+'</div><div class="firebaseui-card-footer"><div class="firebaseui-form-actions">'+D(L({label:$b("Save")}))+"</div></div></form></div>")}jg.B="firebaseui.auth.soy2.page.passwordReset";function kg(a){a=a||{};return D('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-reset-success"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Password changed</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">You can now sign in with your new password</p></div><div class="firebaseui-card-footer">'+
(a.H?'<div class="firebaseui-form-actions">'+L(null)+"</div>":"")+"</div></div>")}kg.B="firebaseui.auth.soy2.page.passwordResetSuccess";function lg(a){a=a||{};return D('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-reset-failure"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Try resetting your password again</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">Your request to reset your password has expired or the link has already been used</p></div><div class="firebaseui-card-footer">'+
(a.H?'<div class="firebaseui-form-actions">'+L(null)+"</div>":"")+"</div></div>")}lg.B="firebaseui.auth.soy2.page.passwordResetFailure";function mg(a){var b=a.H;return D('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-change-revoke-success"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Updated email address</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">Your sign-in email address has been changed back to <strong>'+
C(a.email)+'</strong>.</p><p class="firebaseui-text">If you didn\u2019t ask to change your sign-in email, it\u2019s possible someone is trying to access your account and you should <a class="firebaseui-link firebaseui-id-reset-password-link" href="javascript:void(0)">change your password right away</a>.</p></div><div class="firebaseui-card-footer">'+(b?'<div class="firebaseui-form-actions">'+L(null)+"</div>":"")+"</div></form></div>")}mg.B="firebaseui.auth.soy2.page.emailChangeRevokeSuccess";function ng(a){a=
a||{};return D('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-change-revoke-failure"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Unable to update your email address</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">There was a problem changing your sign-in email back.</p><p class="firebaseui-text">If you try again and still can\u2019t reset your email, try asking your administrator for help.</p></div><div class="firebaseui-card-footer">'+
(a.H?'<div class="firebaseui-form-actions">'+L(null)+"</div>":"")+"</div></div>")}ng.B="firebaseui.auth.soy2.page.emailChangeRevokeFailure";function og(a){a=a||{};return D('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-verification-success"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Your email has been verified</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">You can now sign in with your new account</p></div><div class="firebaseui-card-footer">'+
(a.H?'<div class="firebaseui-form-actions">'+L(null)+"</div>":"")+"</div></div>")}og.B="firebaseui.auth.soy2.page.emailVerificationSuccess";function pg(a){a=a||{};return D('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-verification-failure"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Try verifying your email again</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">Your request to verify your email has expired or the link has already been used</p></div><div class="firebaseui-card-footer">'+
(a.H?'<div class="firebaseui-form-actions">'+L(null)+"</div>":"")+"</div></div>")}pg.B="firebaseui.auth.soy2.page.emailVerificationFailure";function qg(a){return D('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-unrecoverable-error"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Error encountered</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">'+C(a.Tc)+"</p></div></div>")}qg.B="firebaseui.auth.soy2.page.unrecoverableError";
function rg(a){var b=a.nd;return D('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-mismatch"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in</h1></div><div class="firebaseui-card-content"><h2 class="firebaseui-subtitle">Continue with '+C(a.Cd)+'?</h2><p class="firebaseui-text">You originally wanted to sign in with '+C(b)+'</p></div><div class="firebaseui-card-footer"><div class="firebaseui-form-actions">'+
Yf()+L({label:$b("Continue")})+"</div></div></form></div>")}rg.B="firebaseui.auth.soy2.page.emailMismatch";function sg(a,b,c){var d='<div class="firebaseui-container firebaseui-page-provider-sign-in firebaseui-id-page-provider-sign-in"><div class="firebaseui-card-content"><form onsubmit="return false;"><ul class="firebaseui-idp-list">';a=a.pd;b=a.length;for(var e=0;e<b;e++){var f;f={providerId:a[e]};var g=c,k=f.providerId,u=f,u=u||{},B="";switch(u.providerId){case "google.com":B+="firebaseui-idp-google";
break;case "github.com":B+="firebaseui-idp-github";break;case "facebook.com":B+="firebaseui-idp-facebook";break;case "twitter.com":B+="firebaseui-idp-twitter";break;default:B+="firebaseui-idp-password"}var u=D,B='<button class="firebaseui-idp-button mdl-button mdl-js-button mdl-button--raised '+ac(E(B))+' firebaseui-id-idp-button " data-provider-id="'+ac(k)+'"><img class="firebaseui-idp-icon" src="',na=f,na=na||{},W="";switch(na.providerId){case "google.com":W+=fc(g.ad);break;case "github.com":W+=
fc(g.$c);break;case "facebook.com":W+=fc(g.Wc);break;case "twitter.com":W+=fc(g.zd);break;default:W+=fc(g.md)}g=Yb(W);f=u(B+ac(fc(g))+'">'+("password"==k?'<span class="firebaseui-idp-text firebaseui-idp-text-long">Sign in with email</span><span class="firebaseui-idp-text firebaseui-idp-text-short">Email</span>':'<span class="firebaseui-idp-text firebaseui-idp-text-long">Sign In with '+C(ag(f))+'</span><span class="firebaseui-idp-text firebaseui-idp-text-short">'+C(ag(f))+"</span>")+"</button>");d+=
'<li class="firebaseui-list-item">'+f+"</li>"}return D(d+"</ul></form></div></div>")}sg.B="firebaseui.auth.soy2.page.providerSignIn";function tg(){return E("This email already exists without any means of sign-in. Please reset the password to recover.")}function ug(){return E("Please login again to perform this operation")}function vg(a,b,c,d){this.Qa=a;this.jc=b||null;this.od=c||null;this.Vb=d||null}vg.prototype.D=function(){return this.Qa};vg.prototype.ab=function(){return{email:this.Qa,displayName:this.jc,
photoUrl:this.od,providerId:this.Vb}};function wg(a){return a.email?new vg(a.email,a.displayName,a.photoUrl,a.providerId):null}var xg=null;function yg(a){return!(!a||-32E3!=a.code||"Service unavailable"!=a.message)}function zg(a,b,c,d){xg||(a={callbacks:{empty:a,select:function(a,d){a&&a.account&&b?b(wg(a.account)):c&&c(!yg(d))},store:a,update:a},language:"en",providers:void 0,ui:d},"undefined"!=typeof accountchooser&&accountchooser.Api&&accountchooser.Api.init?xg=accountchooser.Api.init(a):(xg=new Ag(a),
Bg()))}function Cg(a,b,c){function d(){var a=Te(c).toString();xg.select(Ga(b||[],function(a){return a.ab()}),{clientCallbackUrl:a})}b&&b.length?d():xg.checkEmpty(function(b,c){b||c?a(!yg(c)):d()})}function Ag(a){this.a=a;this.a.callbacks=this.a.callbacks||{}}function Bg(){var a=xg;p(a.a.callbacks.empty)&&a.a.callbacks.empty()}var Dg={code:-32E3,message:"Service unavailable",data:"Service is unavailable."};h=Ag.prototype;h.store=function(){p(this.a.callbacks.store)&&this.a.callbacks.store(void 0,Dg)};
h.select=function(){p(this.a.callbacks.select)&&this.a.callbacks.select(void 0,Dg)};h.update=function(){p(this.a.callbacks.update)&&this.a.callbacks.update(void 0,Dg)};h.checkDisabled=function(a){a(!0)};h.checkEmpty=function(a){a(void 0,Dg)};h.checkAccountExist=function(a,b){b(void 0,Dg)};h.checkShouldUpdate=function(a,b){b(void 0,Dg)};function Eg(a){a=fa(a)&&1==a.nodeType?a:document.querySelector(String(a));if(null==a)throw Error("Could not find the FirebaseUI widget element on the page.");return a}
function Fg(){this.aa={}}function M(a,b,c){if(b.toLowerCase()in a.aa)throw Error("Configuration "+b+" has already been defined.");a.aa[b.toLowerCase()]=c}Fg.prototype.update=function(a,b){if(!(a.toLowerCase()in this.aa))throw Error("Configuration "+a+" is not defined.");this.aa[a.toLowerCase()]=b};Fg.prototype.get=function(a){if(!(a.toLowerCase()in this.aa))throw Error("Configuration "+a+" is not defined.");return this.aa[a.toLowerCase()]};function Gg(a,b){var c=a.get(b);if(!c)throw Error("Configuration "+
b+" is required.");return c}var N={},Hg=0;function Ig(a,b){if(!a)throw Error("Event target element must be provided!");var c=Jg(a);if(N[c]&&N[c].length)for(var d=0;d<N[c].length;d++)N[c][d].dispatchEvent(b)}function Kg(a){var b=Jg(a.L());N[b]&&N[b].length&&(Ma(N[b],function(b){return b==a}),N[b].length||delete N[b])}function Jg(a){"undefined"===typeof a.ic&&(a.ic=Hg,Hg++);return a.ic}function Lg(a){if(!a)throw Error("Event target element must be provided!");this.Sc=a;H.call(this)}t(Lg,H);Lg.prototype.L=
function(){return this.Sc};Lg.prototype.register=function(){var a=Jg(this.L());N[a]?Ja(N[a],this)||N[a].push(this):N[a]=[this]};Lg.prototype.unregister=function(){Kg(this)};var Mg={"facebook.com":"FacebookAuthProvider","github.com":"GithubAuthProvider","google.com":"GoogleAuthProvider",password:"EmailAuthProvider","twitter.com":"TwitterAuthProvider"};var Ng;Ng=ae("firebaseui");var Og=new he;if(1!=Og.pc){$d();var Pg=Zd,Qg=Og.qd;Pg.Wa||(Pg.Wa=[]);Pg.Wa.push(Qg);Og.pc=!0}function Rg(a){Ng&&Ng.log(Td,
a,void 0)}function Sg(a,b){this.Qa=a;this.ta=b||null}Sg.prototype.D=function(){return this.Qa};Sg.prototype.ab=function(){var a;if(a=this.ta){a=this.ta;var b={},c;for(c in a)b[c]=a[c];a=b}return{email:this.Qa,credential:a}};function Tg(a){if(a&&a.email){var b;if(b=a.credential){var c=(b=a.credential)&&b.provider;b=Mg[c]&&firebase.auth[Mg[c]]?b.secret&&b.accessToken?firebase.auth[Mg[c]].credential(b.accessToken,b.secret):c==firebase.auth.GoogleAuthProvider.PROVIDER_ID?firebase.auth[Mg[c]].credential(b.idToken,
b.accessToken):firebase.auth[Mg[c]].credential(b.accessToken):null}return new Sg(a.email,b)}return null}var Ug=/MSIE ([\d.]+).*Windows NT ([\d.]+)/,Vg=/Firefox\/([\d.]+)/,Wg=/Opera[ \/]([\d.]+)(.*Version\/([\d.]+))?/,Xg=/Chrome\/([\d.]+)/,Yg=/((Windows NT ([\d.]+))|(Mac OS X ([\d_]+))).*Version\/([\d.]+).*Safari/,Zg=/Mac OS X;.*(?!(Version)).*Safari/,$g=/Android ([\d.]+).*Safari/,ah=/OS ([\d_]+) like Mac OS X.*Mobile.*Safari/,bh=/Konqueror\/([\d.]+)/,ch=/MSIE ([\d.]+).*Windows Phone OS ([\d.]+)/;
function O(a,b){this.Ka=a;var c=a.split(b||".");this.Na=[];for(var d=0;d<c.length;d++)this.Na.push(parseInt(c[d],10))}O.prototype.compare=function(a){a instanceof O||(a=new O(String(a)));for(var b=Math.max(this.Na.length,a.Na.length),c=0;c<b;c++){var d=this.Na[c],e=a.Na[c];if(void 0!==d&&void 0!==e&&d!==e)return d-e;if(void 0===d)return-1;if(void 0===e)return 1}return 0};function P(a,b){return 0<=a.compare(b)}function dh(){var a=window.navigator&&window.navigator.userAgent;if(a){var b;if(b=a.match(Wg)){var c=
new O(b[3]||b[1]);return 0<=a.indexOf("Opera Mini")?!1:0<=a.indexOf("Opera Mobi")?0<=a.indexOf("Android")&&P(c,"10.1"):P(c,"8.0")}if(b=a.match(Vg))return P(new O(b[1]),"2.0");if(b=a.match(Xg))return P(new O(b[1]),"6.0");if(b=a.match(Yg))return c=new O(b[6]),a=b[3]&&new O(b[3]),b=b[5]&&new O(b[5],"_"),(!(!a||!P(a,"6.0"))||!(!b||!P(b,"10.5.6")))&&P(c,"3.0");if(b=a.match($g))return P(new O(b[1]),"3.0");if(b=a.match(ah))return P(new O(b[1],"_"),"4.0");if(b=a.match(bh))return P(new O(b[1]),"4.7");if(b=
a.match(ch))return c=new O(b[1]),a=new O(b[2]),P(c,"7.0")&&P(a,"7.0");if(b=a.match(Ug))return c=new O(b[1]),a=new O(b[2]),P(c,"7.0")&&P(a,"6.0");if(a.match(Zg))return!1}return!0}var eh,fh=new Rf;eh=Qf(fh)?new Tf(fh,"firebaseui"):null;var gh=new Mf(eh),hh,ih=new Sf;hh=Qf(ih)?new Tf(ih,"firebaseui"):null;var jh=new Mf(hh),kh={name:"pendingEmailCredential",Ha:!1},lh={name:"redirectUrl",Ha:!1},mh={name:"rememberAccount",Ha:!1},nh={name:"rememberedAccounts",Ha:!0};function oh(a,b){return(a.Ha?gh:jh).get(b?
a.name+":"+b:a.name)}function ph(a,b){(a.Ha?gh:jh).remove(b?a.name+":"+b:a.name)}function qh(a,b,c){(a.Ha?gh:jh).set(c?a.name+":"+c:a.name,b)}function rh(a){a=oh(nh,a)||[];a=Ga(a,function(a){return wg(a)});return Fa(a,ca)}function sh(a,b){var c=rh(b),d=Ia(c,function(b){return b.D()==a.D()&&(b.Vb||null)==(a.Vb||null)});-1<d&&La(c,d);c.unshift(a);qh(nh,Ga(c,function(a){return a.ab()}),b)}function th(a){a=oh(kh,a)||null;return Tg(a)}function uh(){this.a=new Fg;M(this.a,"acUiConfig");M(this.a,"callbacks");
M(this.a,"credentialHelper",vh);M(this.a,"popupMode",!1);M(this.a,"queryParameterForSignInSuccessUrl","signInSuccessUrl");M(this.a,"queryParameterForWidgetMode","mode");M(this.a,"signInFlow");M(this.a,"signInOptions");M(this.a,"signInSuccessUrl");M(this.a,"siteName");M(this.a,"tosUrl");M(this.a,"widgetUrl")}var vh="accountchooser.com",wh={Ed:vh,NONE:"none"},xh={Gd:"popup",Id:"redirect"};function yh(a){return a.a.get("acUiConfig")||null}var zh={Fd:"callback",Hd:"recoverEmail",Jd:"resetPassword",Kd:"select",
Ld:"verifyEmail"};function Ah(a){var b=a.a.get("widgetUrl");b||(b=Je(Se(window.location.href),""),b=Ie(b,"",void 0).toString());return Bh(a,b)}function Bh(a,b){for(var c=Ch(a),d=b.search(Ce),e=0,f,g=[];0<=(f=Be(b,e,c,d));)g.push(b.substring(e,f)),e=Math.min(b.indexOf("&",f)+1||d,d);g.push(b.substr(e));c=[g.join("").replace(Ee,"$1"),"&",c];c.push("=",encodeURIComponent("select"));c[1]&&(d=c[0],e=d.indexOf("#"),0<=e&&(c.push(d.substr(e)),c[0]=d=d.substr(0,e)),e=d.indexOf("?"),0>e?c[1]="?":e==d.length-
1&&(c[1]=void 0));return c.join("")}function Dh(a){a=a.a.get("signInOptions")||[];for(var b=[],c=0;c<a.length;c++){var d=a[c],d=fa(d)?d:{provider:d};Mg[d.provider]&&b.push(d)}return b}function Eh(a){return Ga(Dh(a),function(a){return a.provider})}function Fh(a,b){for(var c=Dh(a),d=0;d<c.length;d++)if(c[d].provider===b)return c=c[d].scopes,da(c)?c:[];return[]}function Ch(a){return Gg(a.a,"queryParameterForWidgetMode")}function Gh(a){a=Dh(a);for(var b=0;b<a.length;b++)if(a[b].provider==firebase.auth.EmailAuthProvider.PROVIDER_ID&&
"undefined"!==typeof a[b].requireDisplayName)return!!a[b].requireDisplayName;return!0}function Hh(a){a=a.a.get("signInFlow");for(var b in xh)if(xh[b]==a)return xh[b];return"redirect"}function Ih(a){return a.a.get("callbacks")||{}}function Jh(a){a=a.a.get("credentialHelper");for(var b in wh)if(wh[b]==a)return wh[b];return vh}uh.prototype.zb=function(a){for(var b in a)try{this.a.update(b,a[b])}catch(c){Rg('Invalid config: "'+b+'"')}cb&&this.a.update("popupMode",!1)};uh.prototype.update=function(a,b){this.a.update(a,
b)};var Q={};function R(a,b,c,d){Q[a].apply(null,Array.prototype.slice.call(arguments,1))}function S(a,b){var c;c=Hb(a);b?(of(a,"firebaseui-input-invalid"),nf(a,"firebaseui-input"),c&&of(c,"firebaseui-textfield-invalid")):(of(a,"firebaseui-input"),nf(a,"firebaseui-input-invalid"),c&&nf(c,"firebaseui-textfield-invalid"))}function Kh(a,b,c){b=new Cf(b);Zc(a,ka($c,b));jf(a).ma(b,"input",c)}function Lh(a,b,c){b=new pf(b);Zc(a,ka($c,b));jf(a).ma(b,"key",function(a){13==a.keyCode&&(a.stopPropagation(),
a.preventDefault(),c(a))})}function Mh(a,b,c){b=new Bf(b);Zc(a,ka($c,b));jf(a).ma(b,"focusin",c)}function Nh(a,b,c){b=new Bf(b);Zc(a,ka($c,b));jf(a).ma(b,"focusout",c)}function Oh(a,b,c){b=new wf(b);Zc(a,ka($c,b));jf(a).ma(b,"action",function(a){a.stopPropagation();a.preventDefault();c(a)})}function Ph(a){nf(a,"firebaseui-hidden")}function T(a,b){if(b)if("textContent"in a)a.textContent=b;else if(3==a.nodeType)a.data=b;else if(a.firstChild&&3==a.firstChild.nodeType){for(;a.lastChild!=a.firstChild;)a.removeChild(a.lastChild);
a.firstChild.data=b}else{for(var c;c=a.firstChild;)a.removeChild(c);a.appendChild(zb(a).createTextNode(String(b)))}of(a,"firebaseui-hidden")}function Qh(a){return!mf(a,"firebaseui-hidden")&&"none"!=a.style.display}function Rh(){Gb(Sh.call(this))}function Sh(){return this.C("firebaseui-id-info-bar")}function Th(){return this.C("firebaseui-id-dismiss-info-bar")}var Uh={Qd:"https://www.gstatic.com/firebasejs/ui/0.5.0/images/auth/profile-picture-small.png",ad:"https://www.gstatic.com/firebasejs/ui/0.5.0/images/auth/google.svg",
$c:"https://www.gstatic.com/firebasejs/ui/0.5.0/images/auth/github.svg",Wc:"https://www.gstatic.com/firebasejs/ui/0.5.0/images/auth/facebook.svg",zd:"https://www.gstatic.com/firebasejs/ui/0.5.0/images/auth/twitter.svg",md:"https://www.gstatic.com/firebasejs/ui/0.5.0/images/auth/mail.svg",Vd:"https://www.gstatic.com/firebasejs/ui/0.5.0/images/auth/"};function Vh(a,b,c){cd.call(this,a,b);for(var d in c)this[d]=c[d]}t(Vh,cd);function U(a,b,c,d){hf.call(this,c);this.Gc=a;this.Fc=b;this.ob=!1;this.yc=
d||null;this.Z=this.Za=null}t(U,hf);U.prototype.Ib=function(){var a=Mb(this.Gc,this.Fc,Uh,this.ib());Wh(a,"upgradeElement");this.f=a};var Xh=["mdl-js-textfield","mdl-js-progress","mdl-js-button"];function Wh(a,b){a&&window.componentHandler&&window.componentHandler[b]&&Da(Xh,function(c){if(mf(a,c))window.componentHandler[b](a);c=Ab(c,a);Da(c,function(a){window.componentHandler[b](a)})})}U.prototype.l=function(){U.c.l.call(this);Ig(V(this),new Vh("pageEnter",V(this),{pageId:this.yc}))};U.prototype.Ra=
function(){Ig(V(this),new Vh("pageExit",V(this),{pageId:this.yc}));U.c.Ra.call(this)};U.prototype.b=function(){window.clearTimeout(this.Za);this.Fc=this.Gc=this.Za=null;this.ob=!1;this.Z=null;Wh(this.L(),"downgradeElements");U.c.b.call(this)};function Yh(a){a.ob=!0;a.Za=window.setTimeout(function(){a.L()&&null===a.Z&&(a.Z=Mb($f,null,null,a.ib()),a.L().appendChild(a.Z),Wh(a.Z,"upgradeElement"))},500)}function Zh(a,b,c,d,e){function f(){if(a.Da)return null;a.ob=!1;window.clearTimeout(a.Za);a.Za=null;
a.Z&&(Wh(a.Z,"downgradeElements"),Gb(a.Z),a.Z=null)}if(a.ob)return null;Yh(a);return b.apply(null,c).then(d,e).then(f,f)}function V(a){return a.L().parentElement||a.L().parentNode}function $h(a,b,c){Lh(a,b,function(){c.focus()})}function ai(a,b,c){Lh(a,b,function(){c()})}r(U.prototype,{G:function(a){Rh.call(this);var b=Mb(Zf,{message:a},null,this.ib());this.L().appendChild(b);Oh(this,Th.call(this),function(){Gb(b)})},Rd:Rh,Td:Sh,Sd:Th});function bi(){return this.C("firebaseui-id-submit")}function ci(){return this.C("firebaseui-id-secondary-link")}
function di(a,b){var c=bi.call(this);Oh(this,c,function(){a()});(c=ci.call(this))&&b&&Oh(this,c,function(){b()})}function ei(){return this.C("firebaseui-id-password")}function fi(){return this.C("firebaseui-id-password-error")}function gi(){var a=ei.call(this),b=fi.call(this);Kh(this,a,function(){Qh(b)&&(S(a,!0),Ph(b))})}function hi(){var a=ei.call(this),b;b=fi.call(this);K(a)?(S(a,!0),Ph(b),b=!0):(S(a,!1),T(b,E("Enter your password").toString()),b=!1);return b?K(a):null}function ii(a,b,c,d){U.call(this,
hg,{email:a},d,"passwordLinking");this.o=b;this.tb=c}t(ii,U);ii.prototype.l=function(){this.Rb();this.A(this.o,this.tb);ai(this,this.X(),this.o);this.X().focus();ii.c.l.call(this)};ii.prototype.b=function(){this.o=null;ii.c.b.call(this)};ii.prototype.fa=function(){return K(this.C("firebaseui-id-email"))};r(ii.prototype,{X:ei,Ob:fi,Rb:gi,Hb:hi,J:bi,ja:ci,A:di});function ji(){return this.C("firebaseui-id-email")}function ki(){return this.C("firebaseui-id-email-error")}function li(a){var b=ji.call(this),
c=ki.call(this);Kh(this,b,function(){Qh(c)&&(S(b,!0),Ph(c))});a&&Lh(this,b,function(){a()})}function mi(){return qa(K(ji.call(this))||"")}function ni(){var a=ji.call(this),b;b=ki.call(this);var c=K(a)||"";c?Ff.test(c)?(S(a,!0),Ph(b),b=!0):(S(a,!1),T(b,E("That email address isn't correct").toString()),b=!1):(S(a,!1),T(b,E("Enter your email address to continue").toString()),b=!1);return b?qa(K(a)):null}function oi(a,b,c,d){U.call(this,cg,{email:c},d,"passwordSignIn");this.o=a;this.tb=b}t(oi,U);oi.prototype.l=
function(){this.xa();this.Rb();this.A(this.o,this.tb);$h(this,this.u(),this.X());ai(this,this.X(),this.o);K(this.u())?this.X().focus():this.u().focus();oi.c.l.call(this)};oi.prototype.b=function(){this.tb=this.o=null;oi.c.b.call(this)};r(oi.prototype,{u:ji,Fa:ki,xa:li,D:mi,fa:ni,X:ei,Ob:fi,Rb:gi,Hb:hi,J:bi,ja:ci,A:di});function X(a,b,c,d,e){U.call(this,a,b,d,e||"notice");this.ba=c||null}t(X,U);X.prototype.l=function(){this.ba&&(this.A(this.ba),this.J().focus());X.c.l.call(this)};X.prototype.b=function(){this.ba=
null;X.c.b.call(this)};r(X.prototype,{J:bi,ja:ci,A:di});function pi(a,b,c){X.call(this,fg,{email:a,H:!!b},b,c,"passwordRecoveryEmailSent")}t(pi,X);function qi(a,b){X.call(this,og,{H:!!a},a,b,"emailVerificationSuccess")}t(qi,X);function ri(a,b){X.call(this,pg,{H:!!a},a,b,"emailVerificationFailure")}t(ri,X);function si(a,b){X.call(this,kg,{H:!!a},a,b,"passwordResetSuccess")}t(si,X);function ti(a,b){X.call(this,lg,{H:!!a},a,b,"passwordResetFailure")}t(ti,X);function ui(a,b){X.call(this,ng,{H:!!a},a,
b,"emailChangeRevokeFailure")}t(ui,X);function vi(a,b){X.call(this,qg,{Tc:a},void 0,b,"unrecoverableError")}t(vi,X);var wi=!1,xi=null;function yi(a,b){wi=!!b;xi||(xi="undefined"==typeof accountchooser&&dh()?Lc(function(){}):Ic());xi.then(a,a)}function zi(a,b){var c=Ih(a.a).accountChooserInvoked||null;c?c(b):b()}function Ai(a,b,c){(a=Ih(a.a).accountChooserResult||null)?a(b,c):c()}function Bi(a,b,c,d,e){d?(R("callback",a,b),wi&&c()):zi(a,function(){Cg(function(d){Ai(a,d?"empty":"unavailable",function(){R("signIn",
a,b);(d||wi)&&c()})},rh(a.h),e)})}function Ci(a,b,c,d){function e(a){a=Y(a);Di(b,c,void 0,a);d()}Ai(b,"accountSelected",function(){qh(mh,!1,b.h);Z(b,b.g.fetchProvidersForEmail(a.D()).then(function(e){Ei(b,c,e,a.D(),a.jc||null||void 0);d()},e))})}function Fi(a,b,c,d){Ai(b,a?"addAccount":"unavailable",function(){R("signIn",b,c);(a||wi)&&d()})}function Gi(a,b,c,d){function e(){var b=a();b&&(b=Ih(b.a).uiShown||null)&&b()}zg(function(){var f=a();f&&Bi(f,b,e,c,d)},function(c){var d=a();d&&Ci(c,d,b,e)},
function(c){var d=a();d&&Fi(c,d,b,e)},a()&&yh(a().a))}function Hi(a,b,c,d){function e(c){if(!c.name||"cancel"!=c.name){var d;a:{var e=c.message;try{var f=((JSON.parse(e).error||{}).message||"").toLowerCase().match(/invalid.+(access|id)_token/);if(f&&f.length){d=!0;break a}}catch(g$3){}d=!1}d?(c=V(b),b.i(),Di(a,c,void 0,E("Your sign-in session has expired. Please try again.").toString())):(d=c&&c.message||"",c.code&&(d=Y(c)),b.G(d))}}var f=c;c.provider&&"password"==c.provider&&(f=null);var g=a.g.currentUser||
d;if(!g)throw Error("User not logged in.");Z(a,a.g.signOut().then(function(){var b=new vg(g.email,g.displayName,g.photoURL,f&&f.provider);null!=oh(mh,a.h)&&!oh(mh,a.h)||sh(b,a.h);ph(mh,a.h);Z(a,a.Oc.signInWithCredential(c).then(function(b){var c=Ih(a.a).signInSuccess||null,d=oh(lh,a.h)||null||void 0;ph(lh,a.h);var e=!1;if(window.opener&&window.opener.location&&window.opener.location.assign){if(!c||c(b,f,d))e=!0,window.opener.location.assign(Ii(a,d));c||window.close()}else if(!c||c(b,f,d))e=!0,window.location.assign(Ii(a,
d));e||a.reset()},e).then(function(){},e))},e))}function Ii(a,b){var c=b||a.a.a.get("signInSuccessUrl");if(!c)throw Error("No redirect URL has been found. You must either specify a signInSuccessUrl in the configuration, pass in a redirect URL to the widget URL, or return false from the callback.");return c}function Y(a){var b="";switch(a.code){case "auth/email-already-in-use":b+="The email address is already used by another account";break;case "auth/requires-recent-login":b+=ug();break;case "auth/too-many-requests":b+=
"You have entered an incorrect password too many times. Please try again in a few minutes.";break;case "auth/user-cancelled":b+="Please authorize the required permissions to sign in to the application";break;case "auth/user-not-found":b+="That email address doesn't match an existing account";break;case "auth/user-token-expired":b+=ug();break;case "auth/weak-password":b+="Strong passwords have at least 6 characters and a mix of letters and numbers";break;case "auth/wrong-password":b+="The email and password you entered don't match";
break;case "auth/network-request-failed":b+="A network error has occurred."}if(b=E(b).toString())return b;try{return JSON.parse(a.message),Rg("Internal error: "+a.message),E("An internal error has occurred.").toString()}catch(c){return a.message}}function Ji(a,b,c,d){function e(){Z(a,Zh(b,q(a.g.signInWithRedirect,a.g),[k],function(){},f))}function f(a){a.name&&"cancel"==a.name||(Rg("signInWithRedirect: "+a.code),a=Y(a),b.G(a))}var g=V(b),k=Mg[c]&&firebase.auth[Mg[c]]?new firebase.auth[Mg[c]]:null;
if(!k)throw Error("Invalid Firebase Auth provider!");var u=Fh(a.a,c);if(k&&k.addScope)for(var B=0;B<u.length;B++)k.addScope(u[B]);k&&k.setCustomParameters&&c==firebase.auth.GoogleAuthProvider.PROVIDER_ID&&d&&k.setCustomParameters({login_hint:d});"redirect"==Hh(a.a)?e():Z(a,a.g.signInWithPopup(k).then(function(c){b.i();R("callback",a,g,Ic(c))},function(c){if(!c.name||"cancel"!=c.name)switch(c.code){case "auth/popup-blocked":e();break;case "auth/popup-closed-by-user":case "auth/cancelled-popup-request":break;
case "auth/network-request-failed":case "auth/too-many-requests":case "auth/user-cancelled":b.G(Y(c));break;default:b.i(),R("callback",a,g,Jc(c))}}))}function Ki(a,b){var c=b.fa(),d=b.Hb();if(c)if(d){var e=firebase.auth.EmailAuthProvider.credential(c,d);Z(a,Zh(b,q(a.g.signInWithEmailAndPassword,a.g),[c,d],function(){Hi(a,b,e)},function(a){if(!a.name||"cancel"!=a.name)switch(a.code){case "auth/email-exists":S(b.u(),!1);T(b.Fa(),Y(a));break;case "auth/too-many-requests":case "auth/wrong-password":S(b.X(),
!1);T(b.Ob(),Y(a));break;default:Rg("verifyPassword: "+a.message),b.G(Y(a))}}))}else b.X().focus();else b.u().focus()}function Li(a){a=Eh(a.a);return 1==a.length&&a[0]==firebase.auth.EmailAuthProvider.PROVIDER_ID}function Di(a,b,c,d){Li(a)?d?R("signIn",a,b,c,d):Mi(a,b,c):R("providerSignIn",a,b,d)}function Ni(a,b,c,d){var e=V(b);Z(a,Zh(b,q(a.g.fetchProvidersForEmail,a.g),[c],function(f){var g=Jh(a.a)==vh;qh(mh,g,a.h);b.i();Ei(a,e,f,c,void 0,d)},function(a){a=Y(a);b.G(a)}))}function Ei(a,b,c,d,e,f){c.length?
Ja(c,firebase.auth.EmailAuthProvider.PROVIDER_ID)?R("passwordSignIn",a,b,d):(qh(kh,(new Sg(d)).ab(),a.h),R("federatedSignIn",a,b,d,c[0],f)):R("passwordSignUp",a,b,d,e)}function Mi(a,b,c){Jh(a.a)==vh?yi(function(){xg?zi(a,function(){Cg(function(d){Ai(a,d?"empty":"unavailable",function(){R("signIn",a,b,c)})},rh(a.h),Ah(a.a))}):Gi(Oi,b,!1,Ah(a.a))},!1):(wi=!1,zi(a,function(){Ai(a,"unavailable",function(){R("signIn",a,b,c)})}))}function Pi(a){var b=window.location.href;a=Ch(a.a);var b=De(b,a)||"",c;for(c in zh)if(zh[c].toLowerCase()==
b.toLowerCase())return zh[c];return"callback"}function Qi(a){var b=window.location.href;a=Gg(a.a.a,"queryParameterForSignInSuccessUrl");return De(b,a)}function Ri(){return De(window.location.href,"oobCode")}function Si(a,b){if(Qf(new Rf)&&Qf(new Sf))Ti(a,b);else{var c=Eg(b),d=new vi(E("The browser you are using does not support Web Storage. Please try again in a different browser.").toString());J(d,c);a.s=d}}function Ti(a,b){var c=Eg(b);switch(Pi(a)){case "callback":var d=Qi(a);d&&qh(lh,d,a.h);R("callback",
a,c);break;case "resetPassword":R("passwordReset",a,c,Ri());break;case "recoverEmail":R("emailChangeRevocation",a,c,Ri());break;case "verifyEmail":R("emailVerification",a,c,Ri());break;case "select":if((d=Qi(a))&&qh(lh,d,a.h),xg){Di(a,c);break}else{yi(function(){Gi(Oi,c,!0)},!0);return}default:throw Error("Unhandled widget operation.");}(d=Ih(a.a).uiShown||null)&&d()}function Ui(a){U.call(this,gg,void 0,a,"callback")}t(Ui,U);function Vi(a,b,c){if(c.user){var d=th(a.h),e=d&&d.D();if(e&&!Wi(c.user,
e))Xi(a,b,c.user,c.credential);else{var f=d&&d.ta;f?Z(a,c.user.link(f).then(function(){Yi(a,b,f)},function(c){Zi(a,b,c)})):Yi(a,b,c.credential)}}else c=V(b),b.i(),ph(kh,a.h),Di(a,c)}function Yi(a,b,c){ph(kh,a.h);Hi(a,b,c)}function Zi(a,b,c){var d=V(b);ph(kh,a.h);c=Y(c);b.i();Di(a,d,void 0,c)}function $i(a,b,c,d){var e=V(b);Z(a,a.g.fetchProvidersForEmail(c).then(function(f){b.i();f.length?"password"==f[0]?R("passwordLinking",a,e,c):R("federatedLinking",a,e,c,f[0],d):(ph(kh,a.h),R("passwordRecovery",
a,e,c,!1,tg().toString()))},function(c){Zi(a,b,c)}))}function Xi(a,b,c,d){var e=V(b);Z(a,a.g.signOut().then(function(){b.i();R("emailMismatch",a,e,c,d)},function(a){a.name&&"cancel"==a.name||(a=Y(a.code),b.G(a))}))}function Wi(a,b){if(b==a.email)return!0;if(a.providerData)for(var c=0;c<a.providerData.length;c++)if(b==a.providerData[c].email)return!0;return!1}Q.callback=function(a,b,c){var d=new Ui;J(d,b);a.s=d;b=c||a.getRedirectResult();Z(a,b.then(function(b){Vi(a,d,b)},function(b){if(b&&"auth/account-exists-with-different-credential"==
b.code&&b.email&&b.credential){var c=Tg(b);qh(kh,c.ab(),a.h);$i(a,d,b.email)}else if(b&&"auth/user-cancelled"==b.code){var c=th(a.h),g=Y(b);c&&c.ta?$i(a,d,c.D(),g):c?Ni(a,d,c.D(),g):Zi(a,d,b)}else b&&"auth/operation-not-supported-in-this-environment"==b.code&&Li(a)?Vi(a,d,{user:null}):Zi(a,d,b)}))};function aj(a,b,c,d){U.call(this,mg,{email:a,H:!!c},d,"emailChangeRevoke");this.xc=b;this.ba=c||null}t(aj,U);aj.prototype.l=function(){var a=this;Oh(this,this.C("firebaseui-id-reset-password-link"),function(){a.xc()});
this.ba&&(this.A(this.ba),this.J().focus());aj.c.l.call(this)};aj.prototype.b=function(){this.xc=this.ba=null;aj.c.b.call(this)};r(aj.prototype,{J:bi,ja:ci,A:di});function bj(){return this.C("firebaseui-id-new-password")}function cj(){return this.C("firebaseui-id-password-toggle")}function dj(){this.Sb=!this.Sb;var a=cj.call(this),b=bj.call(this);this.Sb?(b.type="text",nf(a,"firebaseui-input-toggle-off"),of(a,"firebaseui-input-toggle-on")):(b.type="password",nf(a,"firebaseui-input-toggle-on"),of(a,
"firebaseui-input-toggle-off"));b.focus()}function ej(){return this.C("firebaseui-id-new-password-error")}function fj(){this.Sb=!1;var a=bj.call(this);a.type="password";var b=ej.call(this);Kh(this,a,function(){Qh(b)&&(S(a,!0),Ph(b))});var c=cj.call(this);nf(c,"firebaseui-input-toggle-on");of(c,"firebaseui-input-toggle-off");Mh(this,a,function(){nf(c,"firebaseui-input-toggle-focus");of(c,"firebaseui-input-toggle-blur")});Nh(this,a,function(){nf(c,"firebaseui-input-toggle-blur");of(c,"firebaseui-input-toggle-focus")});
Oh(this,c,q(dj,this))}function gj(){var a=bj.call(this),b;b=ej.call(this);K(a)?(S(a,!0),Ph(b),b=!0):(S(a,!1),T(b,E("Enter your password").toString()),b=!1);return b?K(a):null}function hj(a,b,c){U.call(this,jg,{email:a},c,"passwordReset");this.o=b}t(hj,U);hj.prototype.l=function(){this.Qb();this.A(this.o);ai(this,this.O(),this.o);this.O().focus();hj.c.l.call(this)};hj.prototype.b=function(){this.o=null;hj.c.b.call(this)};r(hj.prototype,{O:bj,Nb:ej,Zc:cj,Qb:fj,Gb:gj,J:bi,ja:ci,A:di});function ij(a,
b,c,d){var e=c.Gb();e&&Z(a,Zh(c,q(a.g.confirmPasswordReset,a.g),[d,e],function(){c.i();var d=new si;J(d,b);a.s=d},function(d){jj(a,b,c,d)}))}function jj(a,b,c,d){"auth/weak-password"==(d&&d.code)?(a=Y(d),S(c.O(),!1),T(c.Nb(),a),c.O().focus()):(c&&c.i(),c=new ti,J(c,b),a.s=c)}function kj(a,b,c){var d=new aj(c,function(){Z(a,Zh(d,q(a.g.sendPasswordResetEmail,a.g),[c],function(){d.i();d=new pi(c);J(d,b);a.s=d},function(){d.G(E("Unable to send password reset code to specified email.").toString())}))});
J(d,b);a.s=d}Q.passwordReset=function(a,b,c){Z(a,a.g.verifyPasswordResetCode(c).then(function(d){var e=new hj(d,function(){ij(a,b,e,c)});J(e,b);a.s=e},function(){jj(a,b)}))};Q.emailChangeRevocation=function(a,b,c){var d=null;Z(a,a.g.checkActionCode(c).then(function(b){d=b.data.email;return a.g.applyActionCode(c)}).then(function(){kj(a,b,d)},function(){var c=new ui;J(c,b);a.s=c}))};Q.emailVerification=function(a,b,c){Z(a,a.g.applyActionCode(c).then(function(){var c=new qi;J(c,b);a.s=c},function(){var c=
new ri;J(c,b);a.s=c}))};function lj(a,b,c,d,e){U.call(this,rg,{Cd:a,nd:b},e,"emailMismatch");this.ba=c;this.S=d}t(lj,U);lj.prototype.l=function(){this.A(this.ba,this.S);this.J().focus();lj.c.l.call(this)};lj.prototype.b=function(){this.S=this.o=null;lj.c.b.call(this)};r(lj.prototype,{J:bi,ja:ci,A:di});Q.emailMismatch=function(a,b,c,d){var e=th(a.h);if(e){var f=new lj(c.email,e.D(),function(){var b=f;ph(kh,a.h);Hi(a,b,d,c)},function(){var b=d.provider,c=V(f);f.i();e.ta?R("federatedLinking",a,c,e.D(),
b):R("federatedSignIn",a,c,e.D(),b)});J(f,b);a.s=f}else Di(a,b)};function mj(a,b,c,d){U.call(this,ig,{email:a,providerId:b},d,"federatedLinking");this.o=c}t(mj,U);mj.prototype.l=function(){this.A(this.o);this.J().focus();mj.c.l.call(this)};mj.prototype.b=function(){this.o=null;mj.c.b.call(this)};r(mj.prototype,{J:bi,A:di});Q.federatedLinking=function(a,b,c,d,e){var f=th(a.h);if(f&&f.ta){var g=new mj(c,d,function(){Ji(a,g,d,c)});J(g,b);a.s=g;e&&g.G(e)}else Di(a,b)};Q.federatedSignIn=function(a,b,c,
d,e){var f=new mj(c,d,function(){Ji(a,f,d,c)});J(f,b);a.s=f;e&&f.G(e)};function nj(a,b,c,d){var e=b.Hb();e?Z(a,Zh(b,q(a.g.signInWithEmailAndPassword,a.g),[c,e],function(c){return Z(a,c.link(d).then(function(){Hi(a,b,d)}))},function(a){if(!a.name||"cancel"!=a.name)switch(a.code){case "auth/wrong-password":S(b.X(),!1);T(b.Ob(),Y(a));break;case "auth/too-many-requests":b.G(Y(a));break;default:Rg("signInWithEmailAndPassword: "+a.message),b.G(Y(a))}})):b.X().focus()}Q.passwordLinking=function(a,b,c){var d=
th(a.h);ph(kh,a.h);var e=d&&d.ta;if(e){var f=new ii(c,function(){nj(a,f,c,e)},function(){f.i();R("passwordRecovery",a,b,c)});J(f,b);a.s=f}else Di(a,b)};function oj(a,b,c,d){U.call(this,eg,{email:c,Cb:!!b},d,"passwordRecovery");this.o=a;this.S=b}t(oj,U);oj.prototype.l=function(){this.xa();this.A(this.o,this.S);K(this.u())||this.u().focus();ai(this,this.u(),this.o);oj.c.l.call(this)};oj.prototype.b=function(){this.S=this.o=null;oj.c.b.call(this)};r(oj.prototype,{u:ji,Fa:ki,xa:li,D:mi,fa:ni,J:bi,ja:ci,
A:di});function pj(a,b){var c=b.fa();if(c){var d=V(b);Z(a,Zh(b,q(a.g.sendPasswordResetEmail,a.g),[c],function(){b.i();var e=new pi(c,function(){e.i();Di(a,d)});J(e,d);a.s=e},function(a){S(b.u(),!1);T(b.Fa(),Y(a))}))}else b.u().focus()}Q.passwordRecovery=function(a,b,c,d,e){var f=new oj(function(){pj(a,f)},d?void 0:function(){f.i();Di(a,b)},c);J(f,b);a.s=f;e&&f.G(e)};Q.passwordSignIn=function(a,b,c){var d=new oi(function(){Ki(a,d)},function(){var c=d.D();d.i();R("passwordRecovery",a,b,c)},c);J(d,b);
a.s=d};function qj(){return this.C("firebaseui-id-name")}function rj(){return this.C("firebaseui-id-name-error")}function sj(a,b,c,d,e,f,g){U.call(this,dg,{email:e,rd:b,name:f,Jc:a,Cb:!!d},g,"passwordSignUp");this.o=c;this.S=d;this.Wb=b}t(sj,U);sj.prototype.l=function(){this.xa();this.Wb&&this.ed();this.Qb();this.A(this.o,this.S);this.Zb();sj.c.l.call(this)};sj.prototype.b=function(){this.S=this.o=null;sj.c.b.call(this)};sj.prototype.Zb=function(){this.Wb?($h(this,this.u(),this.Ua()),$h(this,this.Ua(),
this.O())):$h(this,this.u(),this.O());this.o&&ai(this,this.O(),this.o);K(this.u())?this.Wb&&!K(this.Ua())?this.Ua().focus():this.O().focus():this.u().focus()};r(sj.prototype,{u:ji,Fa:ki,xa:li,D:mi,fa:ni,Ua:qj,Ud:rj,ed:function(){var a=qj.call(this),b=rj.call(this);Kh(this,a,function(){Qh(b)&&(S(a,!0),Ph(b))})},Qc:function(){var a=qj.call(this),b;b=rj.call(this);var c=K(a),c=!/^[\s\xa0]*$/.test(null==c?"":String(c));S(a,c);c?(Ph(b),b=!0):(T(b,E("Enter your account name").toString()),b=!1);return b?
qa(K(a)):null},O:bj,Nb:ej,Zc:cj,Qb:fj,Gb:gj,J:bi,ja:ci,A:di});function tj(a,b){var c=Gh(a.a),d=b.fa(),e=null;c&&(e=b.Qc());var f=b.Gb();if(d)if(c&&!e)b.Ua().focus();else if(f){var g=firebase.auth.EmailAuthProvider.credential(d,f);Z(a,Zh(b,q(a.g.createUserWithEmailAndPassword,a.g),[d,f],function(d){return c?Z(a,d.updateProfile({displayName:e}).then(function(){Hi(a,b,g)})):Hi(a,b,g)},function(c){if(!c.name||"cancel"!=c.name){var e=Y(c);switch(c.code){case "auth/email-already-in-use":return uj(a,b,d,
c);case "auth/too-many-requests":e=E("Too many account requests are coming from your IP address. Try again in a few minutes.").toString();case "auth/operation-not-allowed":case "auth/weak-password":S(b.O(),!1);T(b.Nb(),e);break;default:Rg("setAccountInfo: "+Ye(c)),b.G(e)}}}))}else b.O().focus();else b.u().focus()}function uj(a,b,c,d){function e(){var a=Y(d);S(b.u(),!1);T(b.Fa(),a);b.u().focus()}var f=a.g.fetchProvidersForEmail(c).then(function(d){d.length?e():(d=V(b),b.i(),R("passwordRecovery",a,
d,c,!1,tg().toString()))},function(){e()});Z(a,f);return f}Q.passwordSignUp=function(a,b,c,d,e){function f(){g.i();Di(a,b)}var g=new sj(a.a.a.get("tosUrl")||null,Gh(a.a),function(){tj(a,g)},e?void 0:f,c,d);J(g,b);a.s=g};function vj(a,b,c){U.call(this,sg,{pd:b},c,"providerSignIn");this.wc=a}t(vj,U);vj.prototype.l=function(){this.dd(this.wc);vj.c.l.call(this)};vj.prototype.b=function(){this.wc=null;vj.c.b.call(this)};r(vj.prototype,{dd:function(a){function b(b){a(b)}for(var c=this.Mb("firebaseui-id-idp-button"),
d=0;d<c.length;d++){var e=c[d],f=vf&&e.dataset?"providerId"in e.dataset?e.dataset.providerId:null:e.getAttribute("data-"+"providerId".replace(/([A-Z])/g,"-$1").toLowerCase());Oh(this,e,ka(b,f))}}});Q.providerSignIn=function(a,b,c){var d=new vj(function(c){c==firebase.auth.EmailAuthProvider.PROVIDER_ID?(d.i(),Mi(a,b)):Ji(a,d,c)},Eh(a.a));J(d,b);a.s=d;c&&d.G(c)};function wj(a,b,c,d){U.call(this,bg,{email:c},d,"signIn");this.Ub=a;this.S=b}t(wj,U);wj.prototype.l=function(){this.xa(this.Ub);this.A(this.Ub,
this.S);this.Zb();wj.c.l.call(this)};wj.prototype.b=function(){this.S=this.Ub=null;wj.c.b.call(this)};wj.prototype.Zb=function(){this.u().focus();var a=this.u(),b=(this.u().value||"").length,c;try{c="number"==typeof a.selectionStart}catch(d){c=!1}c?(a.selectionStart=b,a.selectionEnd=b):x&&("textarea"==a.type&&(b=a.value.substring(0,b).replace(/(\r\n|\r|\n)/g,"\n").length),a=a.createTextRange(),a.collapse(!0),a.move("character",b),a.select())};r(wj.prototype,{u:ji,Fa:ki,xa:li,D:mi,fa:ni,J:bi,ja:ci,
A:di});Q.signIn=function(a,b,c,d){var e=new wj(function(){var b=e,c=b.fa()||"";c&&Ni(a,b,c)},function(){e.i();Di(a,b,c)},c);J(e,b);a.s=e;d&&e.G(d)};function xj(a,b){this.Oc=a;this.g=firebase.initializeApp({apiKey:a.app.options.apiKey,authDomain:a.app.options.authDomain},a.app.name+"-firebaseui-temp").auth();this.h=b;this.a=new uh;this.s=this.bc=this.jb=this.cc=null;this.na=[]}xj.prototype.getRedirectResult=function(){this.jb||(this.jb=Ic(this.g.getRedirectResult()));return this.jb};var yj=null;function Oi(){return yj}
xj.prototype.start=function(a,b){function c(){yj&&(th(yj.h)&&Ng&&Ng.log(Ud,"UI Widget is already rendered on the page and is pending some user interaction. Only one widget instance can be rendered per page. The previous instance has been automatically reset.",void 0),yj.reset());yj=d}var d=this;this.zb(b);if("complete"==l.document.readyState){var e=Eg(a);c();d.bc=e;zj(d,e);Si(d,a)}else wd(window,"load",function(){var b=Eg(a);c();d.bc=b;zj(d,b);Si(d,a)})};function Z(a,b){if(b){a.na.push(b);var c=function(){Na(a.na,
function(a){return a==b})};"function"!=typeof b&&b.then(c,c)}}xj.prototype.reset=function(){this.jb=Ic({user:null,credential:null});yj==this&&(yj=null);this.bc=null;for(var a=0;a<this.na.length;a++)if("function"==typeof this.na[a])this.na[a]();else this.na[a].cancel&&this.na[a].cancel();this.na=[];ph(kh,this.h);this.s&&(this.s.i(),this.s=null);this.gb=null};function zj(a,b){a.gb=null;a.cc=new Lg(b);a.cc.register();pd(a.cc,"pageEnter",function(b){b=b&&b.Wd;if(a.gb!=b){var d=Ih(a.a).uiChanged||null;
d&&d(a.gb,b);a.gb=b}})}xj.prototype.zb=function(a){this.a.zb(a)};xj.prototype.wd=function(){var a,b=this.a,c=Gg(b.a,"widgetUrl");a=Bh(b,c);if(this.a.a.get("popupMode")){var b=(window.screen.availHeight-600)/2,c=(window.screen.availWidth-500)/2,d=a||"about:blank",b={width:500,height:600,top:0<b?b:0,left:0<c?c:0,location:!0,resizable:!0,statusbar:!0,toolbar:!1};b.target=b.target||d.target||"google_popup";b.width=b.width||690;b.height=b.height||500;var e;(c=b)||(c={});b=window;a=d instanceof ob?d:sb("undefined"!=
typeof d.href?d.href:String(d));var d=c.target||d.target,f=[];for(e in c)switch(e){case "width":case "height":case "top":case "left":f.push(e+"="+c[e]);break;case "target":case "noreferrer":break;default:f.push(e+"="+(c[e]?1:0))}e=f.join(",");(w("iPhone")&&!w("iPod")&&!w("iPad")||w("iPad")||w("iPod"))&&b.navigator&&b.navigator.standalone&&d&&"_self"!=d?(e=b.document.createElement("A"),a=a instanceof ob?a:sb(a),e.href=qb(a),e.setAttribute("target",d),c.noreferrer&&e.setAttribute("rel","noreferrer"),
c=document.createEvent("MouseEvent"),c.initMouseEvent("click",!0,!0,b,1),e.dispatchEvent(c),e={}):c.noreferrer?(e=b.open("",d,e),b=qb(a),e&&(ab&&-1!=b.indexOf(";")&&(b="'"+b.replace(/'/g,"%27")+"'"),e.opener=null,b='<META HTTP-EQUIV="refresh" content="0; url='+ra(b)+'">',e.document.write(wb((new ub).fd(b))),e.document.close())):e=b.open(qb(a),d,e);e&&e.focus()}else window.location.assign(a)};ma("firebaseui.auth.AuthUI",xj);ma("firebaseui.auth.AuthUI.prototype.start",xj.prototype.start);ma("firebaseui.auth.AuthUI.prototype.setConfig",
xj.prototype.zb);ma("firebaseui.auth.AuthUI.prototype.signIn",xj.prototype.wd);ma("firebaseui.auth.AuthUI.prototype.reset",xj.prototype.reset);ma("firebaseui.auth.CredentialHelper.ACCOUNT_CHOOSER_COM",vh);ma("firebaseui.auth.CredentialHelper.NONE","none")})(); })();


var MessageBirdChatWidgetSettings = {     
    widgetId: "d9a281bd-cbfc-4547-afcd-11e530849e92",     
    initializeOnLoad: true,   
};  

!function(){
    "use strict";if(Boolean(document.getElementById("live-chat-widget-script")))console.error("MessageBirdChatWidget: Snippet loaded twice on page");else{var e,t;window.MessageBirdChatWidget={},window.MessageBirdChatWidget.queue=[];for(var i=["init","setConfig","toggleChat","identify","hide","on","shutdown","setAttributes"],n=function(){var e=i[d];window.MessageBirdChatWidget[e]=function(){for(var t=arguments.length,i=new Array(t),n=0;n<t;n++)i[n]=arguments[n];window.MessageBirdChatWidget.queue.push([[e,i]])}},d=0;d<i.length;d++)n();var a=(null===(e=window)||void 0===e||null===(t=e.MessageBirdChatWidgetSettings)||void 0===t?void 0:t.widgetId)||"",o=function(){var e,t=document.createElement("script");t.type="text/javascript",t.src="https://livechat.messagebird.com/bootstrap.js?widgetId=".concat(a),t.async=!0,t.id="live-chat-widget-script";var i=document.getElementsByTagName("script")[0];null==i||null===(e=i.parentNode)||void 0===e||e.insertBefore(t,i)};"complete"===document.readyState?o():window.attachEvent?window.attachEvent("onload",o):window.addEventListener("load",o,!1)}}();

'use strict';

/**
 * @ngdoc overview
 * @name coutureApp
 * @description
 * # coutureApp
 *
 * Main module of the application.
 */

angular
  .module('coutureApp', [
    'ui.bootstrap',
    'hl.sticky',  //https://github.com/harm-less/angular-sticky
    'ui.router',
    'mwl.calendar', //https://mattlewis92.github.io/angular-bootstrap-calendar/#
    'ngAnimate',
    'ngCookies',
    'ngResource',
    'ngSanitize',
    'angular.filter',
    // 'isteven-multi-select',  //http://isteven.github.io/angular-multi-select/#/getting-started  DAY 2 LOGIC ALLOW ADMIN TO CHANGE ROLE. EG UPGRADE MEMBERSHIP
    'timer',   //http://siddii.github.io/angular-timer/index.html#
    'rzModule', //https://github.com/angular-slider/angularjs-slider
    'ngTouch',
    'moment-picker',  //http://indrimuska.github.io/angular-moment-picker/
    'angularUtils.directives.dirDisqus',
    'authCheckDirectives',
    'carouselDirective',
    'LocalStorageModule', // https://github.com/grevory/angular-local-storage
    'angularGrid', // https://github.com/s-yadav/angulargrid
    'ngFileUpload', // https://github.com/danialfarid/ng-file-upload
    'angularSpinner', // https://github.com/urish/angular-spinner
    'angular-inview', // https://github.com/thenikso/angular-inview
    'xeditable', // http://vitalets.github.io/angular-xeditable/
    'ngTagsInput', // http://mbenford.github.io/ngTagsInput/
    'angularMoment', // https://github.com/urish/angular-moment
    'ngTable', // https://github.com/esvit/ng-table
    'pascalprecht.translate', //https://angular-translate.github.io
    'templates.component', // templates file generated by gulp.  See gulpfile.js. https://www.npmjs.com/package/gulp-angular-templatecache
    'templates.view',
    'directive.contextMenu',
    'environment', // https://www.npmjs.com/package/angular-environment
     'firebase',
     'angularTrix',
     'draggableModule',
     'lrDragNDrop'
  ])

  // Disabling Debug Data
  // https://docs.angularjs.org/guide/production
  .config(['$compileProvider', function ($compileProvider) {
    $compileProvider.debugInfoEnabled(false);
  }])

  //TRANSLATION SERVICE
  .config(["$translateProvider", "$translatePartialLoaderProvider", function($translateProvider, $translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('general');
    $translatePartialLoaderProvider.addPart('landing');
    $translatePartialLoaderProvider.addPart('listing');
    $translatePartialLoaderProvider.addPart('commentComponent');

    $translateProvider.useLoader('$translatePartialLoader', {
      urlTemplate: '/nls/{part}/{lang}.json'
    });

    //REGISTER A SET OF SUPPORTED LANGUAGE AND THE CORRESPONDING KEY MAPPING
    $translateProvider.registerAvailableLanguageKeys(['en', 'fr'], {
      'en_US': 'en',
      'en_UK': 'en',
      'fr_CA': 'fr',
      'fr_FR': 'fr',
      'fr': 'fr',
      '*': 'en' //IF ALL FAILED TO MATCH ABOVE, THE FAIL BACK LANGUAGE IS EN
    });

    //TEST COMMAND FOR LANGUAGE THAT IS NOT DEFINED Eg. DE
    // $translateProvider.preferredLanguage('fr');

    //HAVE THE TRANSLATION SERVICE PRODIVDER TO DETERMINE THE LANGUAGE BASED ON THE BROWSER
    $translateProvider.determinePreferredLanguage();

    //CACHE THE TRANSLATION
    $translateProvider.useLocalStorage();

    //USE FOR UTF-8 SANITIZE
    $translateProvider.useSanitizeValueStrategy('escaped');
  }]).run(["$rootScope", "$translate", function($rootScope, $translate) {
    $rootScope.$on('$translatePartialLoaderStructureChanged', function() {
      $translate.refresh();
    });
  }])
  //TRANSLATION SERVICE

  .config(["$stateProvider", "$urlRouterProvider", "$locationProvider", function($stateProvider, $urlRouterProvider,$locationProvider) {

    $stateProvider.state('main', {
      url: '/',
      templateUrl: 'scripts/components/main/main.html',
      controller: 'LandingCtrl as landCtrl',
      onEnter: ["PageCtx", "$anchorScroll", "$state", "$rootScope", "utilities", function(PageCtx,$anchorScroll,$state,$rootScope,utilities) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }]
    })
    $stateProvider.state('listings-edit', {
      url: '/main/listing/edit/:id?duplicate',
      template: '<listings-edit></listings-edit>',
      onEnter: ["$anchorScroll", function($anchorScroll) {
          $anchorScroll('top');
      }]
    });
    $stateProvider.state('reset-password', {
      url: '/main/resetpassword?token?p',
      template: '<reset-password></reset-password>'
    })
    $stateProvider.state('account-verified', {
      url: '/main/account-verified',
      template: '<account-verified></account-verified>'
    })
    $stateProvider.state('account-verified-quick-sign-up', {
      url: '/main/account-verified-quick-sign-up',
      template: '<account-verified-quick-sign-up></account-verified-quick-sign-up>'
    })
    $stateProvider.state('style-posts', {
      url: '/main/style-posts',
      template: '<style-posts></style-posts>',
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }]
    })
    $stateProvider.state('deleted-listings', {
      url: '/main/deleted-listings',
      template: '<deleted-listings></deleted-listings>',
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }]
    })
    $stateProvider.state('rental-listings', {
      url: '/main/rental-listings',
      template: '<rental-listings></rental-listings>',
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }]
    })
    $stateProvider.state('wishlists', {
      url: '/main/wishlists',
      template: '<wishlists></wishlists',
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }]
    })
    $stateProvider.state('buy-listings', {
      url: '/main/buy-listings',
      template: '<buy-listings></buy-listings>',
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }]
    })
    $stateProvider.state('profile', {
      url: '/main/profile',
      template: '<profile></profile>',
      controller: ["$rootScope", "Session", function($rootScope,Session){
        //ACCESS THE OWNER CLOSET, REMOVE
        //VIEW OTHER PROFILE PARAMS
        delete($rootScope.viewOtherProfile);
      }],
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }]
    })
    $stateProvider.state('listings-create', {
      url: '/main/listings/create?type',
      templateUrl: 'scripts/components/listings-create/listings-create.html',
      controller: 'ListingCreateCtrl as $createCtrl'
    })
    $stateProvider.state('my-account', {
      url: '/main/my-account',
      template: '<my-account></my-account>',
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }]
    })
    $stateProvider.state('payment-options', {
      url: '/main/payment-options',
      template: '<payment-options></payment-options>',
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }]
    })
    $stateProvider.state('custom-brand-listing', {
      url: '/main/custom-brand-listing',
      template: '<custom-brand-listing></custom-brand-listing>'
    })
    $stateProvider.state('admin-subscription-pricing', {
      url: '/main/admin-subscription-pricing',
      template: '<admin-subscription-pricing></admin-subscription-pricing>'
    })
    $stateProvider.state('admin-subscription-user', {
      url: '/main/admin-subscription-user',
      template: '<admin-subscription-user></admin-subscription-user>'
    })
    $stateProvider.state('admin-settings', {
      url: '/main/admin-settings',
      template: '<admin-settings></admin-settings>'
    })
    $stateProvider.state('payout-requests', {
      url: '/main/payout-requests',
      template: '<payout-requests></payout-requests>'
    })
    $stateProvider.state('credit-balance', {
      url: '/main/credit-balance',
      template: '<credit-balance></credit-balance>',
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }]
    })
    $stateProvider.state('get-paid', {
      url: '/main/get-paid',
      template: '<get-paid></get-paid>',
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }]
    })
    $stateProvider.state('order-history', {
      url: '/main/order-history',
      template: '<order-history></order-history>',
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }]
    })
    $stateProvider.state('customer-buy-orders', {
      url: '/main/customer-buy-orders',
      template: '<customer-buy-orders></customer-buy-orders>',
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }]
    })
    $stateProvider.state('my-membership', {
      url: '/main/my-membership',
      template: '<my-membership></my-membership>'
    })
    $stateProvider.state('my-listings', {
      url: '/main/my-listings',
      template: '<my-listings></my-listings>'
    })
    $stateProvider.state('my-rentals', {
      url: '/main/my-rentals',
      template: '<my-rentals></my-rentals>',
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }]
    })
    $stateProvider.state('merchant-all-orders', {
      url: '/main/merchant-all-orders',
      template: '<merchant-all-orders></merchant-all-orders>',
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }]
    })
    $stateProvider.state('merchant-awaiting-dispatch', {
      url: '/main/merchant-awaiting-dispatch',
      template: '<merchant-awaiting-dispatch></merchant-awaiting-dispatch>',
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }]
    })
    $stateProvider.state('merchant-buy-orders', {
      url: '/main/merchant-buy-orders',
      template: '<merchant-buy-orders></merchant-buy-orders>',
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }]
    })
    $stateProvider.state('merchant-rental-orders', {
      url: '/main/merchant-rental-orders',
      template: '<merchant-rental-orders></merchant-rental-orders>',
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }]
    })
    $stateProvider.state('merchant-dispatching-orders', {
      url: '/main/merchant-dispatching-orders',
      template: '<merchant-dispatching-orders></merchant-dispatching-orders>',
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }]
    })
    $stateProvider.state('privacy-policy', {
      url: '/main/privacy-policy',
      template: "<privacy-policy></privacy-policy>"
    })
    /*CC-1286 : Terms and Condition will be using the one from wp page
    $stateProvider.state('terms-conditions', {
       url: '/main/terms-conditions',
       template: '<terms-conditions></terms-conditions>'
    })*/
    $stateProvider.state('adminDashboard', {
      url: '/main/admin',
      templateUrl: 'scripts/components/product-dashboard/productDashboard.html',
      controller: 'ProductDashboardCtrl as ctrl'
    })
    $stateProvider.state('search', {
      url: '/main/search?brand&category&min&max&feeMin&feeMax&color&status&sort&size&fdmin&fdmax&page&q&type&id&creditMin&creditMax&startDate&endDate&itemCondition&country',
      templateUrl: 'scripts/components/search/search.html',
      controller: 'SearchCtrl as $searchCtrl',
      metadata: {
          description: '',
          keywords: '',
          title: ''
      }
    })
    // $stateProvider.state('fav', {
    //   url: '/fav',
    //   templateUrl: 'views/fav.html',
    //   controller: 'FavCtrl as $favCtrl'
    // })
    $stateProvider.state('listing', {
      url: '/main/listing/{id:int}/{urlSlug}',
      templateUrl: 'scripts/components/listings/listings.html',
      controller: 'ListingCtrl as $listCtrl',
      metadata: {
        description: '',
        keywords: '',
        title: ''
      }
    })
    $stateProvider.state('activate', {
      url: '/main/activate?token',
      templateUrl: 'views/activate.html',
      controller: 'ActCtrl as $actCtrl'
    })
    $stateProvider.state('activate-quick-register', {
      url: '/main/activate2?token',
      template: '<activate-quick-register></activate-quick-register>',
    })
    $stateProvider.state('request', {
      url: '/main/rentalrequest',
      templateUrl: 'scripts/components/main/main.html',
      controller: 'LandingCtrl as landCtrl'
    })
    $stateProvider.state('buy-subscription', {
      url: '/main/buy/subscription/{id:int}',
      templateUrl: 'scripts/components/buy-subscription/buy-subscription.html',
      // templateUrl: function($stateParams){
      //   if ($stateParams.type=='credit'){
      //     return 'scripts/components/buy-subscription/buy-credit.html';
      //   } else return 'scripts/components/buy-subscription/buy-subscription.html';
      // },
      controller: 'BuySubCtrl as $bsCtrl',
      params: {
        ctx: null // Don't show in url, for data passing
      },
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }]
    })
    $stateProvider.state('buy-credit', {
      url: '/main/buy/credit/{id:int}',
      templateUrl: 'scripts/components/buy-subscription/buy-credit.html',
      // templateUrl: function($stateParams){
      //   if ($stateParams.type=='credit'){
      //     return 'scripts/components/buy-subscription/buy-credit.html';
      //   } else return 'scripts/components/buy-subscription/buy-subscription.html';
      // },
      controller: 'BuyCreditCtrl as $bcCtrl',
      params: {
        ctx: null // Don't show in url, for data passing
      },
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }]
    })
    $stateProvider.state('checkout', {
      url: '/main/checkout',
      templateUrl: 'scripts/components/checkout/checkout.html',
      controller: 'CheckoutCtrl as $coCtrl',
      params: {
        ctx: null // Don't show in url, for data passing
      },
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }],
      /*onExit: function(PageCtx,$anchorScroll) {
        alert('gfg');
      },*/
    })
    $stateProvider.state('direct-checkout', {
      url: '/main/direct-checkout',
      templateUrl: 'scripts/components/checkout/checkout.html',
      controller: 'DirectCheckoutCtrl as $directCoCtrl',
      params: {
        ctx: null 
      },
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }],
    })
    $stateProvider.state('direct-checkout-multi-region', {
      url: '/{country}/direct-checkout',
      templateUrl: 'scripts/components/checkout/checkout.html',
      controller: 'DirectCheckoutCtrl as $directCoCtrl',
      params: {
        ctx: null 
      },
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }],
    })
    $stateProvider.state('updatePaymentProfile', {
      url: '/main/updatePaymentProfile',
      templateUrl: 'views/update-profile-payment.html',
      controller: 'CheckoutCtrl as $coCtrl',
      params: {
        ctx: null // Don't show in url, for data passing
      }
    })
    $stateProvider.state('viewOtherUserStylePosts', {
      url: '/{otherUsername}/style-posts',
      template: '<style-posts></style-posts>', 
      params: {
        otherUsername: ''
      }
    })
    $stateProvider.state('viewOtherUserStylePosts-multi-region', {
      url: '/{country}/{otherUsername}/style-posts',
      template: '<style-posts></style-posts>', 
      params: {
        country: '',
        otherUsername: ''
      }
    })

    $stateProvider.state('viewOtherUserDeletedListings', {
      url: '/{otherUsername}/deleted-listings',
      template: '<deleted-listings></deleted-listings>', 
      params: {
        otherUsername: ''
      }
    })
    $stateProvider.state('viewOtherUserDeletedListings-multi-region', {
      url: '/{country}/{otherUsername}/deleted-listings',
      template: '<deleted-listings></deleted-listings>', 
      params: {
        country: '',
        otherUsername: ''
      }
    })

    $stateProvider.state('viewOtherUserRentalListings', {
      url: '/{otherUsername}/rental-listings',
      template: '<rental-listings></rental-listings>',
      metadata: {
        description: '',
        keywords: '',
        title: ''
      }, 
      params: {
        otherUsername: ''
      }
    })

    $stateProvider.state('viewOtherUserRentalListings-multi-region', {
      url: '/{country}/{otherUsername}/rental-listings',
      template: '<rental-listings></rental-listings>',
      metadata: {
        description: '',
        keywords: '',
        title: ''
      }, 
      params: {
        country: '',
        otherUsername: ''
      }
    })

    $stateProvider.state('viewOtherUserBuyListings-multi-region', {
      url: '/{country}/{otherUsername}/buy-listings',
      template: '<buy-listings></buy-listings>',
      metadata: {
        description: '',
        keywords: '',
        title: ''
      }
    })

    $stateProvider.state('viewOtherUserBuyListings', {
      url: '/{otherUsername}/buy-listings',
      template: '<buy-listings></buy-listings>',
      metadata: {
        description: '',
        keywords: '',
        title: ''
      }
    })


    $stateProvider.state('signin', {
      url: '/main/signin?rid',
      onEnter: ["DialogAlertService", "$state", "$rootScope", function(DialogAlertService,$state,$rootScope) {
        if($rootScope.isLogon) {
          $state.go('main');
        }else{
          DialogAlertService.openLogon(
            function(){
              $state.go('main');
            },function(){
            //ON CANCEL OR CLOSE THE LOGON
            $state.go('main');
          });
        }
      }]
    })

    $stateProvider.state('waitlist', {
      url: '/main/waitlist',
      onEnter: ["DialogAlertService", "$state", "$rootScope", "$q", function(DialogAlertService,$state,$rootScope,$q) {
        if($rootScope.isLogon) {
          delete $rootScope.isOpenQuickRegister;
          $state.go('main');
        }else{
          var deferred = $q.defer();
          $rootScope.isOpenQuickRegister = $rootScope.isOpenQuickRegister == undefined ? true:false;
          DialogAlertService.openLogon(function(value){
            if (value != undefined || value != null){
              switch (value) {
                case 'LOGON_PAGE':
                  $rootScope.isOpenQuickRegister = false;
                  $state.reload();
                  break;
                case 'SHOW_CONFIRM':
                  break;
                case 'CLOSED':
                  break;
                default:
                  $state.reload();
              }
            }
            deferred.resolve(value);
          },function(){
            delete $rootScope.isOpenQuickRegister;
            $state.go('main');
          },false,false,$rootScope.isOpenQuickRegister);
        }
      }]
    })


    $stateProvider.state('feedback', {
      url: '/main/feedback',
      onEnter: ["DialogAlertService", "$state", "$rootScope", function(DialogAlertService,$state,$rootScope) {
        DialogAlertService.openFeedback(function(){
          $state.go('main');
        },function(){
          $state.go('main');
        });
      }]
    });

    $stateProvider.state('feedback-multi-region', {
      url: '/{country}/feedback',
      onEnter: ["DialogAlertService", "$state", "$rootScope", function(DialogAlertService,$state,$rootScope) {
        DialogAlertService.openFeedback(function(){
          $state.go('main-multi-region');
        },function(){
          $state.go('main-multi-region');
        });
      }]
    })

    //CUSTOM BRANDING URL
    $stateProvider.state('wardrobe', {
      url: '/{otherUsername}',
      controller: ["$rootScope", "$state", function($rootScope,$state){
        //INITIAL DUMMY STRING TO INDICATING IT IS CHECKING FOR VALID CUSTOM URL
        $state.go('viewOtherUserRentalListings',{otherUsername:$state.params.otherUsername});
      }]
    })

    $stateProvider.state('main-multi-region', {
      url: '/{country}/',
      templateUrl: 'scripts/components/main/main.html',
      controller: 'LandingCtrl as landCtrl',
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }]
    })
    $stateProvider.state('listings-edit-multi-region', {
      url: '/{country}/listing/edit/:id?duplicate',
      template: '<listings-edit></listings-edit>',
      onEnter: ["$anchorScroll", function($anchorScroll) {
          $anchorScroll('top');
      }]
    });
    $stateProvider.state('reset-password-multi-region', {
      url: '/{country}/resetpassword?token?p',
      template: '<reset-password></reset-password>'
    })
    $stateProvider.state('account-verified-multi-region', {
      url: '/{country}/account-verified',
      template: '<account-verified></account-verified>'
    })
    $stateProvider.state('account-verified-quick-sign-up-multi-region', {
      url: '/{country}/account-verified-quick-sign-up',
      template: '<account-verified-quick-sign-up></account-verified-quick-sign-up>'
    })
    $stateProvider.state('style-posts-multi-region', {
      url: '/main/style-posts/{country}',
      template: '<style-posts></style-posts>',
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }]
    })
    $stateProvider.state('listings-create-multi-region', {
      url: '/{country}/listings/create?type',
      templateUrl: 'scripts/components/listings-create/listings-create.html',
      controller: 'ListingCreateCtrl as $createCtrl'
    })
    $stateProvider.state('my-account-multi-region', {
      url: '/{country}/my-account',
      template: '<my-account></my-account>',
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }]
    })
    $stateProvider.state('payment-options-multi-region', {
      url: '/{country}/payment-options',
      template: '<payment-options></payment-options>',
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }]
    })
    $stateProvider.state('custom-brand-listing-multi-region', {
      url: '/{country}/custom-brand-listing',
      template: '<custom-brand-listing></custom-brand-listing>'
    })
    $stateProvider.state('admin-subscription-pricing-multi-region', {
      url: '/{country}/admin-subscription-pricing',
      template: '<admin-subscription-pricing></admin-subscription-pricing>'
    })
    $stateProvider.state('admin-subscription-user-multi-region', {
      url: '/{country}/admin-subscription-user',
      template: '<admin-subscription-user></admin-subscription-user>'
    })
    $stateProvider.state('admin-settings-multi-region', {
      url: '/{country}/admin-settings',
      template: '<admin-settings></admin-settings>'
    })
    $stateProvider.state('payout-requests-multi-region', {
      url: '/{country}/payout-requests',
      template: '<payout-requests></payout-requests>'
    })
    $stateProvider.state('credit-balance-multi-region', {
      url: '/{country}/credit-balance',
      template: '<credit-balance></credit-balance>',
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }]
    })
    $stateProvider.state('get-paid-multi-region', {
      url: '/{country}/get-paid',
      template: '<get-paid></get-paid>',
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }]
    })
    $stateProvider.state('order-history-multi-region', {
      url: '/{country}/order-history',
      template: '<order-history></order-history>',
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }]
    })
    $stateProvider.state('my-membership-multi-region', {
      url: '/{country}/my-membership',
      template: '<my-membership></my-membership>'
    })
    $stateProvider.state('my-listings-multi-region', {
      url: '/{country}/my-listings',
      template: '<my-listings></my-listings>'
    })
    $stateProvider.state('my-rentals-multi-region', {
      url: '/{country}/my-rentals',
      template: '<my-rentals></my-rentals>',
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }]
    })
    $stateProvider.state('merchant-all-orders-multi-region', {
      url: '/{country}/merchant-all-orders',
      template: '<merchant-all-orders></merchant-all-orders>',
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }]
    })
    $stateProvider.state('merchant-awaiting-dispatch-multi-region', {
      url: '/{country}/merchant-awaiting-dispatch',
      template: '<merchant-awaiting-dispatch></merchant-awaiting-dispatch>',
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }]
    })
    $stateProvider.state('merchant-buy-orders-multi-region', {
      url: '/{country}/merchant-buy-orders',
      template: '<merchant-buy-orders></merchant-buy-orders>',
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }]
    })
    $stateProvider.state('merchant-rental-orders-multi-region', {
      url: '/{country}/merchant-rental-orders',
      template: '<merchant-rental-orders></merchant-rental-orders>',
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }]
    })
    $stateProvider.state('merchant-dispatching-orders-multi-region', {
      url: '/{country}/merchant-dispatching-orders',
      template: '<merchant-dispatching-orders></merchant-dispatching-orders>',
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }]
    })
    $stateProvider.state('customer-buy-orders-multi-region', {
      url: '/{country}/customer-buy-orders',
      template: '<customer-buy-orders></customer-buy-orders>',
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }]
    })
    $stateProvider.state('privacy-policy-multi-region', {
      url: '/{country}/privacy-policy',
      template: "<privacy-policy></privacy-policy>"
    })
    $stateProvider.state('terms-conditions-multi-region', {
       url: '/{country}/terms-conditions',
       template: '<terms-conditions></terms-conditions>'
    })
    $stateProvider.state('adminDashboard-multi-region', {
      url: '/{country}/admin',
      templateUrl: 'scripts/components/product-dashboard/productDashboard.html',
      controller: 'ProductDashboardCtrl as ctrl'
    })
    $stateProvider.state('search-multi-region', {
      url: '/{country}/search?brand&category&min&max&feeMin&feeMax&color&status&sort&size&fdmin&fdmax&page&q&type&id&creditMin&creditMax&startDate&endDate&itemCondition',
      templateUrl: 'scripts/components/search/search.html',
      controller: 'SearchCtrl as $searchCtrl',
      metadata: {
          description: '',
          keywords: '',
          title: ''
      }
    })
    $stateProvider.state('listing-multi-region', {
      url: '/{country}/listing/{id:int}/{urlSlug}',
      templateUrl: 'scripts/components/listings/listings.html',
      controller: 'ListingCtrl as $listCtrl',
      metadata: {
        description: '',
        keywords: '',
        title: ''
      }
    })
    $stateProvider.state('activate-multi-region', {
      url: '/{country}/activate?token',
      templateUrl: 'views/activate.html',
      controller: 'ActCtrl as $actCtrl'
    })
    $stateProvider.state('activate-quick-register-multi-region', {
      url: '/{country}/activate2?token',
      template: '<activate-quick-register></activate-quick-register>',
    })
    $stateProvider.state('request-multi-region', {
      url: '/{country}/rentalrequest',
      templateUrl: 'scripts/components/main/main.html',
      controller: 'LandingCtrl as landCtrl'
    })
    $stateProvider.state('buy-subscription-multi-region', {
      url: '/{country}/buy/subscription/{id:int}',
      templateUrl: 'scripts/components/buy-subscription/buy-subscription.html',
      controller: 'BuySubCtrl as $bsCtrl',
      params: {
        ctx: null // Don't show in url, for data passing
      },
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }]
    })
    $stateProvider.state('buy-credit-multi-region', {
      url: '/{country}/buy/credit/{id:int}',
      templateUrl: 'scripts/components/buy-subscription/buy-credit.html',
      controller: 'BuyCreditCtrl as $bcCtrl',
      params: {
        ctx: null // Don't show in url, for data passing
      },
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }]
    })
    $stateProvider.state('checkout-multi-region', {
      url: '/{country}/checkout',
      templateUrl: 'scripts/components/checkout/checkout.html',
      controller: 'CheckoutCtrl as $coCtrl',
      params: {
        ctx: null // Don't show in url, for data passing
      },
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }]
    })
    $stateProvider.state('updatePaymentProfile-multi-region', {
      url: '/{country}/updatePaymentProfile',
      templateUrl: 'views/update-profile-payment.html',
      controller: 'CheckoutCtrl as $coCtrl',
      params: {
        ctx: null // Don't show in url, for data passing
      }
    })
    $stateProvider.state('rental-listings-multi-region', {
      url: '/main/rental-listings/{country}', //keep "main" as this conflicts with viewOtherUserRentalListings
      template: '<rental-listings></rental-listings>',
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }]
    })
    $stateProvider.state('profile-multi-region', {
      url: '/{country}/profile',
      template: '<profile></profile>',
      controller: ["$rootScope", "Session", function($rootScope,Session){
        //ACCESS THE OWNER CLOSET, REMOVE
        //VIEW OTHER PROFILE PARAMS
        delete($rootScope.viewOtherProfile);
      }],
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }]
    })
    $stateProvider.state('wishlists-multi-region', {
      url: '/{country}/wishlists',
      template: '<wishlists></wishlists',
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }]
    })


    $stateProvider.state('buy-listings-multi-region', {
      url: '/main/{country}/buy-listings',
      template: '<buy-listings></buy-listings>',
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }]
    })
    $stateProvider.state('deleted-listings-multi-region', {
      url: '/main/{country}/deleted-listings',
      template: '<deleted-listings></deleted-listings>',
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }]
    })

    $stateProvider.state('shopify-installed', {
      url: '/main/shopify/{shopName}',
      template: '<shopify></shopify>',
      onEnter: ["PageCtx", "$anchorScroll", function(PageCtx,$anchorScroll) {
          PageCtx.autoscroll = false;
          $anchorScroll('top');
      }]
    })

    $stateProvider.state('sign-up-thank-you-multi-region', {
      url: '/{country}/sign-up-thank-you',
      template: '<sign-up-thank-you></sign-up-thank-you>',
    })

    $stateProvider.state('sign-up-thank-you', {
      url: '/main/sign-up-thank-you',
      template: '<sign-up-thank-you></sign-up-thank-you>',
    })



    $stateProvider.state('buy-credit-package', {
      url: '/main/buy-credit-package',
      onEnter: ["DialogAlertService", "$state", "$rootScope", function(DialogAlertService,$state,$rootScope) {
        DialogAlertService.openCreditPackage();
      }]
    })

    $stateProvider.state('buy-credit-package-multi-region', {
      url: '/{country}/buy-credit-package',
      onEnter: ["DialogAlertService", "$state", "$rootScope", function(DialogAlertService,$state,$rootScope) {
        DialogAlertService.openCreditPackage();
      }]
    })

    $urlRouterProvider.otherwise('/');
  }])
  .config(["$httpProvider", function($httpProvider) {
    $httpProvider.interceptors.push('AuthInterceptor');
  }])
  .config(["$locationProvider", function($locationProvider) {
    $locationProvider.html5Mode(true);
  }])
  .config(["localStorageServiceProvider", function(localStorageServiceProvider) {
    localStorageServiceProvider
      .setPrefix('couture')
      .setStorageCookie(30, '/', false); // Default values.  Set to true in production (need HTTPS)
  }])
  .config(["usSpinnerConfigProvider", function(usSpinnerConfigProvider) {
    usSpinnerConfigProvider.setDefaults({
      color: '#363636',
      radius: 30,
      width: 8,
      length: 16,
      shadow: true
    });
  }])
  .config(["$qProvider", "envServiceProvider", function($qProvider,envServiceProvider){
    //NOT LOGGING THE UNHANDLED REGJECTION FROM HTTPS
    //THERE IS A BUG WHERE EVEN THOUGHT IT IS HANDLED THE ERROR STILL SHOW UP
    //ONLY SHOW UP IN DEVELOPMENT ENV, NOT IN PRODUCTION.
    var isShowUnhandledError = envServiceProvider.environment == "development" ? true:false;
    $qProvider.errorOnUnhandledRejections(isShowUnhandledError);
  }])
  .run(["$rootScope", "$anchorScroll", "PageCtx", "Session", "AuthService", "utilities", "envService", "CONFIG", "RefDataService", function($rootScope, $anchorScroll, PageCtx,Session,AuthService,utilities,envService,CONFIG,RefDataService) {

    //THIS AUTHENTICATED IS ONLY USED WHEN USER CLICK ON RELOAD BUTTON OR CLOSED THE BROWSER AND BACK TO THE SITE AGAIN.
    if (AuthService.isAuthenticated() && !$rootScope.isLogon){
      $rootScope.isLogon = true;
      $rootScope.user = Session.user;

       window.MessageBirdChatWidget.identify($rootScope.user.userid, {
        displayName: $rootScope.user.firstName + " " + $rootScope.user.lastName,
        firstName: $rootScope.user.firstName,
        lastName: $rootScope.user.lastName,
        phoneNumber: $rootScope.user.phone1,
        email: $rootScope.user.email,
      });
    }else if (!AuthService.isAuthenticated() && $rootScope.isLogon){
      $rootScope.isLogon = false;
      delete ($rootScope.user);
      delete (Session.user);
    }else{
      $rootScope.isLogon = null;
      delete ($rootScope.user);
      delete (Session.user);
    }

    //SET DEFAULT TIMEZONE
    $rootScope.ServerTimezoneOffset = CONFIG.DEFAULT_SERVER_TIMEZONE_OFFSET;
    $rootScope.ServerTimezone = CONFIG.DEFAULT_SERVER_TIMEZONE;
    $rootScope.currentTimezone = CONFIG.DEFAULT_TIMEZONE;

    //CREDIT PRICING AND SELECTED PLAN - to be accessed by multiple screens
    $rootScope.credit= {};
    // $rootScope.credit.selectedPlan=0;
    $rootScope.credit.longestPlanMonth=CONFIG.LONGEST_PLAN_MONTH;

    //INSERT THE UUID TO THE XHR HEADER
    $rootScope.UUID = Session.UUID;
    var ES = envService.read();
    ES['XHR_REQ_HEADER']['X-CorrId']=$rootScope.UUID;

    //ENABLE OR DISABLE THE CONSOLE LOG
    $rootScope.enableLog = ES['SHOW_CONSOLE_LOG'];

    // Handle state change
    $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
      PageCtx.hide = true;
      $anchorScroll('view');
    });
    $rootScope.$on('$viewContentLoaded', function(event, toState, toParams, fromState, fromParams) {
      //HIDE THE PAGECTX WHEN LOGON DIALOG IS PRESENTING.
      PageCtx.hide = $rootScope.isModalOpen ? true:false;
    });

  }])
  // .config(function($qProvider){
    //NOT LOGGING THE UNHANDLED REGJECTION FROM HTTPS
    //THERE IS A BUG WHERE EVEN THOUGHT IT IS HANDLED THE ERROR STILL SHOW UP
    //ONLY SHOW UP IN DEVELOPMENT ENV, NOT IN PRODUCTION.
    // $qProvider.errorOnUnhandledRejections(false);
  // })
  .run(["$window", "envService", function($window,envService) {
      $window.Stripe.setPublishableKey(envService.read('STRIP_KEY'));
  }])
  .run(["envService", function(envService){
    // Initialize the Firebase SDK
    firebase.initializeApp(envService.read('FIREBASE_CONFIG'));
  }])
  .run(["RefDataService", "$rootScope", function(RefDataService, $rootScope){
    // Initialize banner
    $rootScope.bannerList = RefDataService.getBannerList();

    //Initialize shopfront
    $rootScope.shopfrontList = RefDataService.getShopfrontList();
  }])
  // .config(function ($uiViewScrollProvider) {
  //   $uiViewScrollProvider.useAnchorScroll();
  // })
  // For xeditable
  .run(["editableOptions", "editableThemes", function(editableOptions, editableThemes) {
    editableOptions.theme = 'bs3'; // bootstrap3 theme. Can be also 'bs2', 'default'
    editableThemes.bs3.inputClass = 'input-sm';
    editableThemes.bs3.buttonsClass = 'btn-sm btn-edit';
  }])
  .directive('focusMe', ['$timeout',
    function($timeout) {
      return {
        link: {
          pre: function preLink(scope, element, attr) {
            // ...
          },
          post: function postLink(scope, element, attr) {
            $timeout(function() {
              element[0].focus();
            }, 300);


          }
        }
      }
    }
  ]
)
  .directive('ngRightClick', ["$parse", function($parse) {
    // Rightclick directive
    return function(scope, element, attrs) {
        var fn = $parse(attrs.ngRightClick);
        element.bind('contextmenu', function(event) {
            scope.$apply(function() {
                event.preventDefault();
                fn(scope, {$event:event});
            });
        });
    };
}]
);

angular.module('coutureApp')
.config(["envServiceProvider", function(envServiceProvider) {
    // set the domains and variables for each environment
    envServiceProvider.config({
        domains: {
            development: ['localhost', '172.0.0.1'],
            production: ['couturecarousel.com', 'www.couturecarousel.com', 'beta.couturecarousel.com','www.stylecarousel.com','stylecarousel.com'],
            test: ['dev*.couturecarousel.com','dev*.stylecarousel.com'],
        },
        vars: {
            development: {
                // Mandatory headers
                'XHR_REQ_HEADER': {
                    'X-Requested-With': 'XMLHttpRequest',
                    'X-CorrId':'visitor'
                },

                //SHOWING LOG IN CONSOLE
                'SHOW_CONSOLE_LOG': true,

                // XHR timeout in ms
                'XHR_TIMEOUT': 30000,

                // Image upload S3 bucket name
                'IMG_UPLOAD_S3_BUCKET': 'cc-listing-img',

                // Image upload S3 region
                'IMG_UPLOAD_S3_REGION': 'ap-southeast-1',

                // This is the path for the images.  i.e. <FQDN>/path.  This should match the IMG_DOMAIN
                'IMG_UPLOAD_S3_PATH': 'images',

                'STRIP_KEY' : 'pk_test_1LKvvC3Jaui910S50xVv0J93',
                'STRIP_KEY_SG' : 'pk_test_51KoGoSJ6BqFYndDUPhIAqsbTgVOVg4DjDkzqjgNzKDtQdt9nCW8qSYyCC5FjYQCjw3xIls6NO3C5j6XadrCyUD4j00mkR5nuPI',

                // Endpoints
                'SERVICE_DOMAIN': 'https://api-dev1.couturecarousel.com',
                'IMG_DOMAIN': 'https://static-dev1.couturecarousel.com',

                'FIREBASE_CONFIG' : {
                  apiKey: "AIzaSyBoPJ9r4wDDqJgalv69hh7xCLMjLxjE0ss",
                  authDomain: "cc-firebase-dev.firebaseapp.com",
                  projectId: "cc-firebase-dev",
                  appId: "1:1034141225412:web:188a9e5c284ce77b2a5491",
                  measurementId: "G-2BY18PJ3Z9"
                },

                'MESSAGEBIRD_PUSHER_INSTANCE_ID': 'f0fe4c12-bcbf-4c5e-93a4-c7a325d903f1',
                'REFERRAL_URL': "https://dev.stylecarousel.com/main/signin?rid=",
                'APP_URL': "https://app-dev.stylecarousel.com"
            },
            test: {
                // Mandatory headers
                'XHR_REQ_HEADER': {
                    'X-Requested-With': 'XMLHttpRequest'
                },

                //SHOWING LOG IN CONSOLE
                'SHOW_CONSOLE_LOG': true,

                // XHR timeout in ms
                'XHR_TIMEOUT': 30000,

                // Image upload S3 bucket name
                'IMG_UPLOAD_S3_BUCKET': 'cc-listing-img',

                // Image upload S3 region
                'IMG_UPLOAD_S3_REGION': 'ap-southeast-1',

                // This is the path for the images.  i.e. <FQDN>/path.  This should match the IMG_DOMAIN
                'IMG_UPLOAD_S3_PATH': 'images',

                'STRIP_KEY' : 'pk_test_1LKvvC3Jaui910S50xVv0J93',
                'STRIP_KEY_SG' : 'pk_test_51KoGoSJ6BqFYndDUPhIAqsbTgVOVg4DjDkzqjgNzKDtQdt9nCW8qSYyCC5FjYQCjw3xIls6NO3C5j6XadrCyUD4j00mkR5nuPI',

                // Endpoints
                'SERVICE_DOMAIN': 'https://api-dev1.couturecarousel.com',
                'IMG_DOMAIN': 'https://static-dev1.couturecarousel.com',
                'FIREBASE_CONFIG' : {
                  apiKey: "AIzaSyBoPJ9r4wDDqJgalv69hh7xCLMjLxjE0ss",
                  authDomain: "cc-firebase-dev.firebaseapp.com",
                  projectId: "cc-firebase-dev",
                  appId: "1:1034141225412:web:188a9e5c284ce77b2a5491",
                  measurementId: "G-2BY18PJ3Z9"
                },

                'MESSAGEBIRD_PUSHER_INSTANCE_ID': 'f0fe4c12-bcbf-4c5e-93a4-c7a325d903f1',
                'REFERRAL_URL': "https://dev.stylecarousel.com/main/signin?rid=",
                'APP_URL': "https://app-dev.stylecarousel.com"

            },
            production: {
                // Mandatory headers
                'XHR_REQ_HEADER': {
                    'X-Requested-With': 'XMLHttpRequest',
                    'X-CorrId':'visitor'
                },

                // XHR timeout in ms
                'XHR_TIMEOUT': 30000,

                // Image upload S3 bucket name
                'IMG_UPLOAD_S3_BUCKET': 'cc-listing-img-prod',

                // Image upload S3 region
                'IMG_UPLOAD_S3_REGION': 'ap-southeast-1',

                // This is the path for the images.  i.e. <FQDN>/path.  This should match the IMG_DOMAIN
                'IMG_UPLOAD_S3_PATH': 'images',

                'STRIP_KEY' : 'pk_live_6ZSl4j6mo2ybGHIobk9LR6Cu',
                'STRIP_KEY_SG' : 'pk_live_51KoGoSJ6BqFYndDUUaiLYO2VeUVjHKIOHsgBqFTzimnjMayhi261iyHepdXuXaE9n7AqephrAGaAD1P0iYiNk5ou00ZsAMtvMk',

                // Endpoints
                'SERVICE_DOMAIN': 'https://api.couturecarousel.com',
                'IMG_DOMAIN': 'https://static.couturecarousel.com',
                'FIREBASE_CONFIG' : {
                    apiKey: "AIzaSyD3fpxBkwbVdzWXf3uCtxOho66dKCWEMp4",
                    authDomain: "cc-firebase-prod.firebaseapp.com",
                    projectId: "cc-firebase-prod",
                    appId: "1:1031128981077:web:3d5fc0c5443131908a7edc"
                },

                'MESSAGEBIRD_PUSHER_INSTANCE_ID': 'f0fe4c12-bcbf-4c5e-93a4-c7a325d903f1',
                'REFERRAL_URL': "https://stylecarousel.com/main/signin?rid=",
                'APP_URL': "https://app.stylecarousel.com"

            },
            defaults: {
                'SHOW_CONSOLE_LOG': false,
                'SERVICE_DOMAIN': 'https://api.couturecarousel.com',
                'IMG_DOMAIN': 'https://static.couturecarousel.com'
            }
        }
    });

    // run the environment check, so the comprobation is made
    // before controllers and services are built
    envServiceProvider.check();
}]);

'use strict';

angular.module('coutureApp')
  .constant('CONFIG', {

    'BUNDLES_ENABLED': true,

    //RENTAL TYPE
    'STYLE_POST' : 2,
    'RENTAL_LISTING': 1,
    'DELETED_LISTING': 5,
    'DEFAULT_RENTAL_WEEK': 1,

  	'PRICE_MIN_INT' : 10,
  	'PRICE_MIN' : '10',
  	'PRICE_MAX' : '300000',
  	'PRICE_MIN_SG' : '1',
  	'PRICE_MIN_AU' : '1',
  	'PRICE_MAX_SG' : '52000',
  	'PRICE_MAX_AU' : '52000',
    'CREDIT_MIN' : '1',
  	'CREDIT_MAX' : '8',
    'DEFAULT_SEARCH_TYPE':'1',    //1 - RENTAL LISTING ONLY
    'DEFAULT_SEARCH_TYPE_ADMIN':'1|3',
    'UPLOAD_PHOTO_LIMIT': 8,
    'PHOTO_SIZE_LIMIT_MIN' : '50KB',
    'PHOTO_SIZE_LIMIT_MAX' : '20MB',
    'PHOTO_RESIZE_RATIO' : '0.5',
    'PHOTO_RESIZE_WIDTH' : '1000',
    'PHOTO_RESIZE_HEIGHT' : '1000',

    //SEARCH RESULT
    'ITEM_PER_PAGE' : '20',

    //AREAS IN PAYMENT OPTION AND CHECKOUT
    'AREAS':[
      {'id': 'HK_ISLAND','name': 'Hong Kong Island'},
      {'id': 'KOWLOON','name': 'Kowloon'},
      {'id': 'NEW_TERR','name': 'New Territories'},
      {'id': 'OUT_ISLAND','name': 'Outlying Islands'},
    ],

    //THE STATE NAME: FOUND IN APP.JS BY DEFAULT ALL PAGES NEED AUTHENTICATION FOR ACCESS
    //THE LIST CONTAINS THE WHITELISTED PAGE THAT NO AUTHENTICATION IS RQUIRED.
    'AUTHCHECK':[
      'main',
      'main-multi-region',
      'customURL',
      'reset-password',
      'account-verified',
      'account-verified-multi-region',
      'account-verified-quick-sign-up',
      'account-verified-quick-sign-up-multi-region',
      'sign-up-thank-you',
      'sign-up-thank-you-multi-region',
      'account-multi-region',
      'faq-general',
      'about-us',
      'privacy-policy',
      'terms-conditions',
      'activate',
      'activate-multi-region',
      'activate-quick-register',
      'activate-quick-register-multi-region',
      'style-posts',
      'style-posts-multi-region',
      'rental-listings',
      'rental-listings-posts-multi-region',
      'profile',
      'profile-multi-region',
      'wardrobe',
      'buy-subscription',
      'signin',
      'waitlist'
    ],
    'AUTHCHECK_CLICK': 8,       //NUMBER OF CLICKS BEFORE POPUP REGISTERATION REQUEST, IF NOT ALREADY LOGON.
    'AUTHCHECK_CLICK_SECOND_POPUP': 18,      

    //DEFAULT COUNTRY FOR PAYMENT OPTION AND CHECKOUT
    'HONG_KONG': 'Hong Kong',
    'DEFAULT_COUNTRY': 'Hong Kong',
    'DEFAULT_CURRENCY' : 'HK',
    'SHIPPING_TO_HONG_KONG_ONLY' : false,
    'SINGAPORE': 'Singapore',

    //CALENDAR RELATED
    'DEFAULT_TIMEZONE':'Asia/Hong_Kong',
    'DEFAULT_SERVER_TIMEZONE':'Asia/Hong_Kong',
    'DEFAULT_SERVER_TIMEZONE_OFFSET':'+0800',
    'DEFAULT_RENTAL_DURATION': 6,
    'DEFAULT_WEEKLY_RENTAL': 7,

    //DEFAULT SORT ORDER FOR MY CLOSET RENTAL LISTING AND STYLE POST
    'DEFAULT_SORT_STYLE_POST' : 'latest',
    'DEFAULT_SORT_RENTAL_LISTING' : 'recommended',
    'DEFAULT_SEARCH_SORT_ORDER': 'recommended',
    'DEFAULT_SORT_ORDER_HISTORY': '-creationDate',
    'DEFAULT_SORT_WISHLIST': '-id',

    // CREDIT
    'ORIGINAL_CREDIT_PRICE': 399,
    'ORIGINAL_CREDIT_PRICE_SG': 66,
    'LONGEST_PLAN_MONTH': 12,
    'EARNING_FROM':120,
    'EARNING_TO':300,
    'MONTH_1_PER_CREDIT_PRICE': 259, //330
    'MONTH_3_PER_CREDIT_PRICE': 259, //330
    'MONTH_12_PER_CREDIT_PRICE': 259, //330
    'PLAN_1_MTH_CREDIT_PRICE': 259,
    'PLAN_SG_1_TIME_CREDIT_PRICE': 43,
    'PLAN_HK_1_TIME_CREDIT_PRICE': 259,

    //EARNING
    'EARNING_PERCENTAGE': 0.35,

    //SUBSCRIPTION PLAN ID
    'DEFAULT_SUBSCRIPTION_PLAN_ID': 0,
    'PLAN_ONE_TIME':0,
    //'PLAN_1_MTH':4,
    //'PLAN_3_MTH':5,
    //'PLAN_12_MTH':3,
    //'PLAN_HK_ONE_TIME': 15,
    //'PLAN_SG_ONE_TIME': 14,
    //'PLAN_SG_3_MTH': 16,

    //HK Subscription. Renamed PLAN_1_MTH, PLAN_3_MTH, PLAN_12_MTH to avoid confusion. Plan months can be changed by admin at admin dashboard
    'PLAN_SUBSCRIPTION_5':5, //PLAN_3_MTH
    'PLAN_SUBSCRIPTION_4':4, //PLAN_1_MTH
    'PLAN_SUBSCRIPTION_3':3, //PLAN_12_MTH
    'PLAN_SUBSCRIPTION_15':15, //PLAN_HK_ONE_TIME

    //SG Sunscription. Renamed PLAN_SG_3_MTH to avoid confusion. Plan months can be changed by admin at admin dashboard
    'PLAN_SUBSCRIPTION_16':16, //PLAN_SG_3_MTH
    'PLAN_SUBSCRIPTION_14':14, //PLAN_SG_ONE_TIME

    //////////////////////////////////
    //FEATURES
    //SAME PRODUCT SUPPORT MULTI SIZES
    'LISTING_SUPPORT_MULTISIZE' : true,

    //Transaction type
    'TRANSACTION_TYPE_BUY' : 'BUY',
    'TRANSACTION_TYPE_RENT' : 'RENT',
    
    'COUNTRY_CURRENCY_CODE' : {
      'HK' : {'id' : 'hk', 'region' : 'Hong Kong', 'country_code' : 'HK', 'currency_code' : 'HKD'},
      'SG' : {'id' : 'sg', 'region' : 'Singapore', 'country_code' : 'SG', 'currency_code' : 'SGD'},
      'AU' : {'id' : 'au', 'region' : 'Australia', 'country_code' : 'AU', 'currency_code' : 'AUD'}
    },

    'EUR_SUPPORTED_COUNTRIES' : ['AT', 'BE', 'BG', 'CY', 'CY', 'FR', 'DE', 'ES', 'GB', 'GR', 'HR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL' , 'PT', 'RO', 'SE', 'SK', 'SI'],

    'ITEM_CONDITION' : [
      'NEW',
      'PRISTINE',
      'EXCELLENT',
      'GOOD',
      'FAIR',
    ],

    'ITEM_CONDITION_BUY' : [
      'NEW',
      'PRISTINE',
      'EXCELLENT',
      'GOOD',
      'FAIR',
    ],

    'ITEM_CONDITION_RENT' : [
      'NEW',
      'PRISTINE',
      'EXCELLENT'
    ],

    'ITEM_CONDITION_OPT' : [
      {'id' : 4, 'code' : 'NEW'},
      {'id' : 3, 'code' : 'PRISTINE'},
      {'id' : 2, 'code' : 'EXCELLENT'},
      {'id' : 1, 'code' : 'GOOD'},
      {'id' : 0, 'code' : 'FAIR'}
    ],

    'SG_PROTECTION_FEE': 35,
    'HK_PROTECTION_FEE': 200,
    'ADDRESS_TYPE_SHIPPING': 1,
    'ADDRESS_TYPE_PICKUP': 2,
    'ADDRESS_TYPE_BILLING': 3,

    'SELF_DISPATCH': 'SELF_DISPATCH',
    'SCHEDULE_COLLECTION': 'SCHEDULE_COLLECTION',

    //DEFAULT PARCEL WEIGHT AND DIMENSION (kg and cm)
    'PARCEL_WEIGHT' : 1,
    'PARCEL_LENGTH' : 25,
    'PARCEL_WIDTH' : 20,
    'PARCEL_HEIGHT' : 5,

    'DHL_TRACKING_URL' : "https://www.dhl.com/global-en/home/tracking/tracking-express.html?submit=1&tracking-id=",

    'MESSAGEBIRD_PUSHER_DEVICE_INTEREST_ABANDONED_CART_GENERAL_GUEST': 'abandoned_cart_general_guest',
    'MESSAGEBIRD_PUSHER_DEVICE_INTEREST_ABANDONED_CART_PRODUCT_GUEST': 'abandoned_cart_product_guest',
    'MESSAGEBIRD_PUSHER_DEVICE_INTEREST_ABANDONED_CART_GENERAL_REGISTERED': 'abandoned_cart_general_registered',
    'MESSAGEBIRD_PUSHER_DEVICE_INTEREST_ABANDONED_CART_PRODUCT_REGISTERED': 'abandoned_cart_product_registered',
    'MESSAGEBIRD_PUSHER_DEVICE_INTEREST_ACCOUNT_ACTIVATION': 'account_activation',
    'IPINFO_URL' : 'https://ipinfo.io/json?token=61e19f007b9e37',
    'FREE_SHIPPING_SIDE_BAR_0' : 0,
    'FREE_SHIPPING_SIDE_BAR_1' : 1,
    'FREE_SHIPPING_SIDE_BAR_2' : 2,
    'FREE_SHIPPING_SIDE_BAR_3' : 3,

    'SG_FLAG_SRC': "assets/images/SG_Flag.png",
    'HK_FLAG_SRC': "assets/images/HK_Flag.png",
    "SVG_FLAG_SRC": "https://cdn.jsdelivr.net/npm/svg-country-flags@1.2.10/svg/",

    "BUNDLE_PROMO": "two-for-one",

    "SG_MEMBER_RENTAL_DAYS_TOPUP": 10,
    "SG_NONMEMBER_RENTAL_DAYS_TOPUP": 10,
    "HK_MEMBER_RENTAL_DAYS_TOPUP": 60,
    "HK_NONMEMBER_RENTAL_DAYS_TOPUP": 60,

    "SHOP_FRONT": [
      'agatah',
      'akalia',
      'neverfullydressed',
      'sarvin',
      'angelikajosefczyk',
      'lmomo',
      'lexi',
      'qipology',
      'yi-ming',
      'emmawallace',
      'trafficpeople'
    ]

  });

'use strict';

/**
 * @ngdoc function
 * @name coutureApp.controller:AppCtrl
 * @description
 * # AppCtrl
 * Controller of the coutureApp
 */
 angular.module('coutureApp')
 .controller('AuthCtrl', ["$scope", "$state", "utilities", "$location", "UserService", "usSpinnerService", "ErrorHandler", "Session", "$uibModalInstance", "$timeout", "AuthService", "localStorageService", "PageCtx", "$log", "$translatePartialLoader", "$rootScope", "$anchorScroll", "openCreateAccount", "isQuickRegisterPage", "RefDataService", "NotificationService", "$http", "CONFIG", "isSignUpWishlist", "DialogAlertService", "WishlistService", "envService", function ($scope, $state, utilities, $location, UserService, usSpinnerService,ErrorHandler,Session,
   $uibModalInstance,$timeout, AuthService, localStorageService, PageCtx, $log,$translatePartialLoader,$rootScope,
   $anchorScroll,openCreateAccount,isQuickRegisterPage,RefDataService,NotificationService,$http,CONFIG,isSignUpWishlist,DialogAlertService,WishlistService,envService) {

 	PageCtx.headerUrl = 'views/plain-header.html';
	var self = this;
  $translatePartialLoader.addPart('logon_off');
  $scope.isShowSignin = true;
  self.lk_reg = false;
  self.usernameErr = false;

	this.$onInit = function() {
    self.referralId = $state.params ? $state.params.rid : null;
    $scope.phoneCodeList = RefDataService.getCountryList();
    self.defaultPhoneCode = utilities.getLocationPhoneCode();
    self.phoneCodeFlag = utilities.getPhoneCountryFlag(self.defaultPhoneCode);
		if($location.path().includes('logoff')) {
        	$scope.$emit('header:logout', null);
          if(utilities.isShowMainRegion()){
			      $state.go('main');
          } else {
            $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
          }
  	} else {

      //ALLOW THE SCREEN SHOW AS SIGN IN OR SIGN UP
      if (openCreateAccount){
        $scope.isShowCreateAccount = true;
        $scope.isShowSignin = false;
        $scope.isSignUpWishlist = false;
        self.scrollUp();
      }

      //QUICK REGISTER USE QUESTREGISTER.HTML
      if (isQuickRegisterPage){
        $scope.isShowCreateAccount = false;
        $scope.isShowSignin = false;
        $scope.isSignUpWishlist = false;
        $scope.isQuickRegisterPage = isQuickRegisterPage;
        $scope.isSignUpWishlist = isSignUpWishlist;
      }

      //CLIENT CLICK ON THE SIGN-IN BUTTON IN THE QUICK REGISTERATION FORM.
      //CLOSE THE QUEST REGISTRATION FORM AND OPEN THE LOGON PAGE.
      self.GotoLogon = function(){
        $uibModalInstance.close('LOGON_PAGE');
      }

			// Remember me checkbox
			self.rememberMe = !!localStorageService.get('username');
			// LOGON MODEL
			self.req_logon = {
			  'username' : "",
			  'password' : ""
			};
      // REGISTRATION MODEL
      self.reg_info = {
            "username": "",
            "password": "",
            "email": "",
            "firstName": "",
            "lastName": "",
            "phone1": "",
            "phoneCode": self.defaultPhoneCode,
            "registeredCountry": utilities.isShowMainRegion() ? "HK" : $rootScope.geoLocation.country
      };

      self.clickedSubmitted = false;

      self.error_msg = {
        "password":"Passwords don’t match or have less than 8 characters.",
        "email": "Email address not valid.",
        "name": "Please enter your name.",
        "phonenum": "Please enter your phone number.",
        "username": "Please enter a valid username."
      };

      self.resetErrorMsg()

      self.loggedIn = false;
      self.formError = false;

      self.disableLogonForm = false;

      // FirebaseUI config.
      self.uiConfig = {
        callbacks: {
            signInSuccess: function(currentUser, credential, redirectUrl) {

              try {
                var country = utilities.isShowMainRegion() ? "HK" : $rootScope.geoLocation.country;
                var userObj = JSON.parse(JSON.stringify(currentUser));
                self.disableLogonForm = true;

                $http.get(CONFIG.IPINFO_URL).then(function (response){
                var userLocation = response.data.country;
                // //LOGON FOR EXISTING USER AND REGISTER NEW USER.
                AuthService.socialLogin({"firebaseToken":userObj.stsTokenManager.accessToken, "country": country, "userLocation": userLocation}).$promise.then(
                  function(resp){
                    $uibModalInstance.close();
                    $scope.$emit('header:setUser', resp.User);

                    // Remember username
                    if(self.rememberMe) {
                      localStorageService.set('username', self.req_logon.username);
                    }

                    self.loggedIn = true;
                    $scope.isLogon = true;
                    utilities.loadCartFromServer(Session.getCart());

                    var isNewSignUp = resp.newSignUp;
                    
                    if(isNewSignUp && $scope.isQuickRegisterPage){
                      if(utilities.isShowMainRegion()){
                        $state.go('sign-up-thank-you');
                      } else {
                        $state.go('sign-up-thank-you-multi-region', {country: $rootScope.geoLocation.country});
                      }
                    }

                  },function(err){
                    self.lk_submit = false;
                    delete($scope.isLogon);
                    var err = ErrorHandler.resolveErrorToString(err);
                    self.errors = err;
                    $rootScope.enableLog ? $log.error($rootScope.UUID + ":AuthCtrl:socialLogin - Logon error: " + err):'';
                    if ($scope.isQuickRegisterPage){
                      ui.start('#firebaseui-auth-container_quick_register', self.uiConfig);
                    }else if ($scope.isShowCreateAccount){
                      ui.start('#firebaseui-auth-container_signup', self.uiConfig);
                    }else{
                      ui.start('#firebaseui-auth-container', self.uiConfig);
                    }
                });
                });
              } catch (e) {
                self.lk_submit = false;
                delete($scope.isLogon);
                var err = ErrorHandler.resolveErrorToString(e);
                self.errors = err;
                $rootScope.enableLog ? $log.error($rootScope.UUID + ":AuthCtrl:signInSuccess - Logon error: Not able to parse accessToken."):'';
                $scope.$apply();  //UPDATE THE UI IMMEDIATELY
                if ($scope.isQuickRegisterPage){
                  ui.start('#firebaseui-auth-container_quick_register', self.uiConfig);
                }else if ($scope.isShowCreateAccount){
                  ui.start('#firebaseui-auth-container_signup', self.uiConfig);
                }else{
                  ui.start('#firebaseui-auth-container', self.uiConfig);
                }
              }
              return false;
            },
            uiShown: function() {
              // The widget is rendered. Hide the loader.
              self.lk_reg = false;
              self.lk_submit = false;
              self.disableLogonForm = false;
              if ($scope.isQuickRegisterPage){
                document.getElementById('loader_quick_register').style.display = 'none';
              }else if ($scope.isShowCreateAccount){
                document.getElementById('loader_signup').style.display = 'none';
              }else{
                document.getElementById('loader').style.display = 'none';
              }
            }
          },
        signInFlow: 'popup',
        signInOptions: [
          // Leave the lines as is for the providers you want to offer your users.
          firebase.auth.GoogleAuthProvider.PROVIDER_ID,
          firebase.auth.FacebookAuthProvider.PROVIDER_ID
        ]

      };

      // Initialize the FirebaseUI Widget using Firebase.
      let ui = $rootScope.firebaseuiAuthObj;
      if (!ui) {
        ui = new firebaseui.auth.AuthUI(firebase.auth());
        $rootScope.firebaseuiAuthObj = ui;
      }


      //START THE FIREBASEUI ONCE THE MODAL WINDOW IS RENDERED
      $uibModalInstance.rendered.then(function(){
        if ($scope.isQuickRegisterPage){
          ui.start('#firebaseui-auth-container_quick_register', self.uiConfig);
        }else if ($scope.isShowCreateAccount){
          ui.start('#firebaseui-auth-container_signup', self.uiConfig);
        }else{
          ui.start('#firebaseui-auth-container', self.uiConfig);
        }
      });

			if(self.rememberMe) {
			  self.req_logon.username = localStorageService.get('username');
			}
		}

    if(!$rootScope.isLogon && self.referralId != null){
      UserService.updateViewReferralLinkCount(self.referralId).$promise.then(
        function(resp) {
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":myAccount:updateViewReferralLinkCount - Success"):'';
        }), function(err){
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":myAcct:updateViewReferralLinkCount - Error:" + err):'';
        };
    }

    // fix for input caret
    // moving when modal is scrolled
    $timeout(function() {
        var modalEl = document.querySelector('.modal');
        modalEl.style.position = 'absolute';
        modalEl.style.height = '100vh';
    });
	};

	this.changeRememberMe = function () {
		if(!self.rememberMe) {
		  localStorageService.remove('username');
		}
	};

  ///////////////////////////////////////////////
  // RELOAD THE SOCIAL SIGN UP WHEN REGISTER A NEW ACCOUNT
  ///////////////////////////////////////////////
  $scope.$watch('isShowCreateAccount', function(value) {
    let ui = $rootScope.firebaseuiAuthObj;
    ui.start('#firebaseui-auth-container_signup', self.uiConfig);
  });

  ////////////////////////////
  // SCROLL TO TOP
  ////////////////////////////
  this.scrollUp = function(){
    $anchorScroll('top');
  }

  ////////////////////////////
  // RESET PASSWORD
  ////////////////////////////
	this.forgotPassword = function(event) {

    usSpinnerService.spin('spinner');
		self.lk_reg = true;
		UserService.resetPasswordEmail(self.forgot.email).$promise.then(
			function(resp){
				usSpinnerService.stop('spinner');
				self.lk_reg = false;
        $scope.showEmailRequest = true;
        $scope.showForgotPassword = false;
        if(utilities.isShowMainRegion()){
          $state.go('reset-password');
        } else {
          $state.go('reset-password-multi-region', {country: $rootScope.geoLocation.country});
        }
			},
			function(err){
				usSpinnerService.stop('spinner');
        self.lk_reg = false;
				var err = ErrorHandler.resolveErrorToString(err);
				self.errors = err;
        $rootScope.enableLog ? $log.error($rootScope.UUID + ":AuthCtrl:forgotPassword - Error: " + err):'';
			});
	};

  ////////////////////////////
  //  QUICK REGISTRATION SERVICE
  ////////////////////////////
	this.quickRegSignUp = function(event, isSignUpWishlist) {
    self.reg_info.registeredCountry = utilities.isShowMainRegion() ? "HK" : $rootScope.geoLocation.country;
    self.reg_errors.email = false;

    if (self.reg_info.email.length == 0 || $scope.quickRegStep1Form.email.$error.email) {
      self.reg_errors.email = true;
    }

    if (!self.reg_errors.email){

      usSpinnerService.spin('spinner');
  		self.lk_reg = true;
      $rootScope.registeredUsername = self.reg_info.username;
      $rootScope.registeredEmailAddress = self.reg_info.email;
      $http.get(CONFIG.IPINFO_URL).then(function (response){
      self.reg_info.userLocation = response.data.country;
  		UserService.quickRegEmail(self.reg_info.email, self.reg_info.registeredCountry, self.reg_info.userLocation, isSignUpWishlist).$promise.then(
  			function(resp){
          self.captureWaitlistSignUp();
  				usSpinnerService.stop('spinner');
          var wishlistsSession = utilities.loadWishlistFromServer();
          if(wishlistsSession && isSignUpWishlist){
            if(wishlistsSession.wishlists){
              wishlistsSession.email = self.reg_info.email;
              WishlistService.saveWishlist(wishlistsSession).$promise.then(
                function(resp) {
                  Session.clearWishlistSession();
                },
                function(err) {
                  $rootScope.enableLog ? $log.error($rootScope.UUID + ':productCardList:addToWishlist - addToWishlist error: ' + err ) : '';
                }
              );
            }
          }
  				self.lk_reg = false;
          $uibModalInstance.close('SHOW_CONFIRM');
  				$log.info('Quick registration of '+ self.reg_info.email +' succeeded on ' + new Date());
          
          if(isSignUpWishlist){
            if(utilities.isShowMainRegion()){
              $state.go('account-verified');
            } else {
              $state.go('account-verified-multi-region', {country: $rootScope.geoLocation.country});
            }
          } else {
            if(utilities.isShowMainRegion()){
              $state.go('account-verified-quick-sign-up');
            } else {
              $state.go('account-verified-quick-sign-up-multi-region', {country: $rootScope.geoLocation.country});
            }
          }
  			},
  			function(err){
  				usSpinnerService.stop('spinner');
  				self.lk_reg = false;
  				var err = ErrorHandler.resolveErrorToString(err);
  				self.errors = err;
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":AuthCtrl:quickRegSignUp - Quick registration error: " + err):'';
			});
      });
    }
	};

  ////////////////////////////
  //  USER REGISTRATION SERVICE
  ////////////////////////////
	this.signUp = function(event) {
    self.clickedSubmitted = true;
    self.validateForm();
    $rootScope.registeredUsername = self.reg_info.username;
    $rootScope.registeredEmailAddress = self.reg_info.email;
    $rootScope.signUpPromoCode = null;
    if (!self.formError){
      self.errors = "";
      usSpinnerService.spin('spinner');
  		self.lk_reg = true;
      $http.get(CONFIG.IPINFO_URL).then(function (response){
      self.reg_info.userLocation = response.data.country;

  		UserService.register(self.reg_info, self.referralId).$promise.then(
  			function(resp){
          self.captureNormalSignUp();
  				usSpinnerService.stop('spinner');
  				self.lk_reg = false;
  				$log.info('Registration of '+ self.reg_info.username +' succeeded on ' + new Date());
  				$uibModalInstance.close();

          NotificationService.subscribeDeviceForAccountActivation();
          if(resp.rewardCode){
            Session.setReferralRewardCode(resp);
            if(utilities.isShowMainRegion()){
              $state.go('sign-up-thank-you');
            } else {
              $state.go('sign-up-thank-you-multi-region', {country: $rootScope.geoLocation.country});
            }
          } else {
            if(utilities.isShowMainRegion()){
              $state.go('account-verified');
            } else {
              $state.go('account-verified-multi-region', {country: $rootScope.geoLocation.country});
            }
          }
  			},
  			function(err){
  				usSpinnerService.stop('spinner');
  				self.lk_reg = false;
  				var err = ErrorHandler.resolveErrorToString(err);
  				self.errors = err;
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":AuthCtrl:signUp - Registration error: " + err):'';
  			});
      });
    }
	};

  ////////////////////////////
  //  LOGON FUNCTION
  ////////////////////////////
	this.logon = function() {
		self.lk_submit = true;
    self.error_code = null;
		AuthService.logon(self.req_logon).$promise.then(
			function(resp){
      		$scope.$emit('header:setUser', resp.User);

	        // Remember username
	        if(self.rememberMe) {
	          localStorageService.set('username', self.req_logon.username);
	        }

          $uibModalInstance.close();
          self.loggedIn = true;
          $scope.isLogon = true;
          utilities.loadCartFromServer(Session.getCart());
          var wishlistsSession = utilities.loadWishlistFromServer();
          if(wishlistsSession){
            if(wishlistsSession.wishlists && wishlistsSession.wishlists.length > 0){
              DialogAlertService.saveWishlistFromSession(wishlistsSession);
            }
          }
          if ($location.path().includes('buy/subscription')) window.location.reload(false);
          if ($location.path().includes('my-rentals')) window.location.reload(false);
          
			},
			function(err){
        self.errorCode = err.data.reasons[0].code;
				self.lk_submit = false;
        delete($scope.isLogon);
        var err = ErrorHandler.resolveErrorToString(err);
        self.errors = err;
        $rootScope.enableLog ? $log.error($rootScope.UUID + ":AuthCtrl:logon - Logon error: " + err):'';
			});
	};

  ////////////////////////////
  //  RESET REGISTRATION ERROR MESSAGE
  ////////////////////////////
  this.resetErrorMsg = function(){
    self.formError = false;
    self.errors = false;
    self.reg_errors = {
      "password":false,
      "email":false,
      "name":false,
      "username":false,
      "phonenum":false
    }
    self.usernameErr = false;
  }

  ////////////////////////////
  //FORM VALIDATION
  ////////////////////////////
  this.validateUsername = function(){
    if (self.reg_info.username == ""){
      self.usernameErr = false;
    }
    self.usernameErr = !utilities.isUsernameValid(self.reg_info.username);
  }

  this.validateForm = function(){
    if (self.clickedSubmitted){
      self.resetErrorMsg();

      if (self.reg_info.username == "" || !utilities.isUsernameValid(self.reg_info.username)){
        self.reg_errors.username = true;
      }
      if (self.reg_info.firstName == "" || self.reg_info.lastName == ""){
        self.reg_errors.name = true;
      }
      if (self.reg_info.phone1 == ""){
        self.reg_errors.phonenum = true;
      }
      if (self.reg_info.password == ""){
        self.reg_errors.password = true;
      }
      if (self.reg_info.email == "" || $scope.signUpForm.email.$error.email){
        self.reg_errors.email = true;
      }

      utilities.validatePassword(self.register_password , self.reg_info.password) ? self.reg_errors.password = true : '';

      for (let key in self.reg_errors){
         if(self.reg_errors.hasOwnProperty(key) && self.reg_errors[key]){
           self.formError = true;
         }
      }
    }
  }

  $scope.setSelectedPhoneCode = function(countryCode, phoneCode, phoneCodeFlag) {
    self.reg_info.phoneCode = countryCode + " " + phoneCode;
    self.phoneCodeFlag = phoneCodeFlag;
  }

  this.resendVerificationEmail = function() {

    usSpinnerService.spin('spinner');
		self.lk_reg = true;
		UserService.resendVerificationEmail(self.req_logon.username).$promise.then(
			function(resp){
				usSpinnerService.stop('spinner');
				self.lk_reg = false;
        $scope.showVerificationEmailRequest = true;
        $scope.showResendVerification = false;
        $scope.isShowSignin = false;
			},
			function(err){
				usSpinnerService.stop('spinner');
        self.lk_reg = false;
				var err = ErrorHandler.resolveErrorToString(err);
				self.errors = err;
        $rootScope.enableLog ? $log.error($rootScope.UUID + ":AuthCtrl:resendVerificationEmail - Error: " + err):'';
			});
	};
      
  self.openLogon = function(){
    $uibModalInstance.close('LOGON_PAGE');
    DialogAlertService.openLogon();
  }

  self.captureNormalSignUp = function(){
    dataLayer.push({ ecommerce: null });  
    dataLayer.push({
        "environment" : envService.environment === "production" ? "prod" : "dev",
        "currentUserID" : "new_sign_up",
        "currentUserEmail" : self.reg_info.email,
    event: "signup_normal",
    });
  };

  self.captureWaitlistSignUp = function(){
    dataLayer.push({ ecommerce: null });  
    dataLayer.push({
        "environment" : envService.environment === "production" ? "prod" : "dev",
        "currentUserID" : "new_sign_up",
        "currentUserEmail" : self.reg_info.email,
    event: "signup_waitlist",
    });
  };

 }]);

'use strict';

/**
 * @ngdoc function
 * @name coutureApp.controller:AppCtrl
 * @description
 * # AppCtrl
 * Controller of the coutureApp
 */
 angular.module('coutureApp')
 .controller('AppCtrl', ["$rootScope", "$scope", "$anchorScroll", "$location", "$state", "envService", "AuthService", "UserService", "RentalService", "DialogAlertService", "Session", "PageCtx", "$uibModal", "$log", "LocaleService", "utilities", "USER_ROLES", "$window", "$sce", "$translate", "CONFIG", "RefDataService", "localStorageService", "NotificationService", function ($rootScope, $scope, $anchorScroll, $location, $state, envService, AuthService, UserService, RentalService,
   DialogAlertService, Session, PageCtx, $uibModal, $log,LocaleService,utilities,USER_ROLES,$window, $sce, $translate,CONFIG, RefDataService,localStorageService,
   NotificationService) {
 	$scope.currentUser = null;
 	$scope.isAuthorized = AuthService.isAuthorized;

 	// Set the page context, to load header based on location (defined by controllers)
 	$scope.pageCtx = PageCtx;
  var self = this;

 	// Init method, self executing
 	this.$onInit = function () {
    $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - AppCtrl"):'';

    //CREATE CC DATA STRUCTURE
    $rootScope.cc = {};
    $rootScope.cc.cart = [];
    $rootScope.cc.allowedDates = {};
    $rootScope.transactionType = CONFIG.TRANSACTION_TYPE_RENT;

    $rootScope.geoLocation = {};
    $rootScope.geoLocation.country = null;  
    $rootScope.geoLocation.currency = null;  
    $rootScope.forex = null;
    $rootScope.currencyList = null;
    $rootScope.countryList = null;
    $rootScope.euroCountryList = null;
    $rootScope.availableCountryList = null;
    Session.clearReferralRewardCode();

 		if(AuthService.isAuthenticated()) {
      $rootScope.isLogon = true;
 		}


    RentalService.getSubscriptionTopupPricing().$promise.then(function (resp) {
      $rootScope.credit.pricing = [];
      $rootScope.credit.pricing = resp;
    });

    RefDataService.getGeoLocation();

    $rootScope.$on("CallLoadDatesFromServer", function(evt, data){
      utilities.loadAllowedDatesFromServer(data ? data.country : null);
    });

    $rootScope.forex = RefDataService.getForexList();

 		// Empty the FQDN to use relative path, except when testing locally
 		// if(!$location.host().includes('localhost')) {
 		// 	CONSTANT.SERVICE_DOMAIN = '';
 		// }
    $rootScope.$on("header:logout", function (event, data) {
      $rootScope.enableLog ? $log.info($rootScope.UUID + ":AppCtrl:logoff - Logged off succeeded on " + new Date()):'';
      AuthService.logoff();
      $rootScope.isLogon = AuthService.isAuthenticated();
      window.MessageBirdChatWidget.logout();

      const beamsClient = new PusherPushNotifications.Client({
        instanceId: envService.read('MESSAGEBIRD_PUSHER_INSTANCE_ID'),
      });
      beamsClient.clearAllState();
 		});

    // isModalOpen - DETERMINE IF LOGON DIALOG IS PRESENTED
    $rootScope.$watch('isModalOpen', function() {
        if(!$rootScope.isModalOpen) {
          PageCtx.hide = false;
        }
    }, true);

    $rootScope.$watch('isLogon', function() {
        if($rootScope.isLogon) {
          utilities.loadCartFromServer(Session.getCart());
          AuthService.isAuthorized(USER_ROLES.admin) ? self.admin = true : self.admin = false;
        }
        //DEFAULT ALL CLIENT SELECTED SUBSCRIPTION_PLAN WITH ID
        UserService.storeSelectedPlan(CONFIG.DEFAULT_SUBSCRIPTION_PLAN_ID);
        NotificationService.subscribeDevice();
    }, true);

 		$rootScope.$on("header:setUser", function (event, user) {
      $rootScope.UUID = Session.UUID;

      //INSERT THE UUID TO THE XHR HEADER
      var ES = envService.read();
      ES['XHR_REQ_HEADER']['X-CorrId']=$rootScope.UUID;

      $rootScope.isLogon = AuthService.isAuthenticated();
      $rootScope.user = user;
      Session.user = user;
      $rootScope.enableLog ? $log.info($rootScope.UUID + ":AppCtrl:header:setUser - Logged on succeeded on " + new Date()):'';
 		});

 		$rootScope.$on("header:listings-create", function (event, data) {
 			$scope.listingsCreate();
 		});

    loadOtherUserProfileAfterReload();

	}();

  ///////////////////////////////////////////////////////////////
  // LOAD OTHER DESIGNER/RENTER PROFILE AFTER CLICK ON RELOAD BUTTON
  // AND WHEN THE URL CONTAINS
  ///////////////////////////////////////////////////////////////
  function loadOtherUserProfileAfterReload(){
    if ($state.params.otherUsername != null){
      UserService.isUserExists($state.params.otherUsername).$promise.then(function(resp){

        if (resp.profileImg && resp.profileImg.indexOf('https://') == -1){
          resp.profileImg = envService.read('IMG_DOMAIN') + "/" + resp.profileImg;
        }else if (resp.profileImg && resp.profileImg.indexOf('https://') != -1){
          //DO NOTHING, PROFILE FROM SOCIAL ACCOUNT
        }else{
          resp.profileImg = null;
        }
        if (resp.profileBanner && resp.profileBanner.indexOf('https://') == -1){
            resp.profileBanner = envService.read('IMG_DOMAIN') + "/" + resp.profileBanner;
          }else if (resp.profileBanner && resp.profileBanner.indexOf('https://') != -1){
            //DO NOTHING, PROFILE FROM SOCIAL ACCOUNT
          }else{
            resp.profileBanner = null;
          }
        $rootScope.viewOtherProfile = resp;
      },function(err){
        delete($rootScope.viewOtherProfile);
      });
    }
  }

  $rootScope.setSelectedProductID = function(id, product){
    self.SelectedProductID = id;
    self.SelectedProduct = product;
  }

  $scope.openInTab = function(){
    var productBrand = utilities.getCustomBrandName(self.SelectedProduct);
    var urlSlug = utilities.getPrettyUrl(self.SelectedProduct.category.code, self.SelectedProduct.subCategory.code, productBrand, self.SelectedProduct.productLine);
    if(utilities.isShowMainRegion()){
      $window.open('/main/listing/'+self.SelectedProductID+'/'+urlSlug,'_blank');
    } else {
      $window.open('/' + $rootScope.geoLocation.country + '/listing/'+self.SelectedProductID+'/'+urlSlug,'_blank');
    }
  }

  //SPECIAL HANDLING OF STATE CHANGE
  $rootScope.$on('$stateChangeSuccess',
  function(event, toState, toParams, fromState, fromParams){
    
    //FROM SEARCH RESULT TO PRODUCT DETAILS. RECORD THE POSITION OF THE PRODUCT ITEM
    if (fromState.name == 'listing' && toState.name == 'search'){
      toParams.id = fromParams.id;
    //FROM PRODUCT DETAILS BACK TO SEARCH RESULT. REPOSITION THE LIST TO SHOW THE LAST POSITION OF THE PRODUCT CLICKED.
    }else if (fromState.name == 'search' && toState.name == 'listing') {
      Session.prev_searchParams.id = toParams.id;
    } else if (fromState.name == 'listing-multi-region' && toState.name == 'search-multi-region'){
      toParams.id = fromParams.id;
      toParams.country = fromParams.country;
    //FROM PRODUCT DETAILS BACK TO SEARCH RESULT. REPOSITION THE LIST TO SHOW THE LAST POSITION OF THE PRODUCT CLICKED.
    } else if (fromState.name == 'search-multi-region' && toState.name == 'listing-multi-region') {
      Session.prev_searchParams.id = toParams.id;
      Session.prev_searchParams.country = toParams.country;
    } else if(toState.name == 'order-history' || toState.name == 'order-history-multi-region'){
     if(!$rootScope.isLogon & !$rootScope.isModalOpen){
      DialogAlertService.openLogon(function(){
        $state.go(toState.name);
      },function(){
        $state.go('main');
      });
     }
    }


    //show feedback when leaving checkout page without checking out
    //commented to not show the feedback page for now. this will be reused later.
    /*if($rootScope.cc){
      if (fromState.name == 'checkout' && toState.name != 'checkout'){
        if($rootScope.cc.cart.length > 0){
          DialogAlertService.openFeedback(function(){
            $state.go('main');
          },function(){
            $state.go('main');
          });
        }
      }

      if (fromState.name == 'checkout-multi-region' && toState.name != 'checkout-multi-region'){
        if($rootScope.cc.cart.length > 0){
          DialogAlertService.openFeedback(function(){
            $state.go('main-multi-region');
          },function(){
            $state.go('main-multi-region');
          });
        }
      }
    }

    //show feedback when leaving buy scription page
        var subscribed = Session.getSubscribed();
    if (fromState.name == 'buy-subscription' && !(toState.name == 'buy-subscription' || toState.name == 'buy-subscription-multi-region') && !subscribed){
        DialogAlertService.openFeedback(function(){
          $state.go('main');
        },function(){
          $state.go('main');
        });
    }

    if (fromState.name == 'buy-subscription-multi-region'  && !(toState.name == 'buy-subscription' || toState.name == 'buy-subscription-multi-region') && !subscribed){
        DialogAlertService.openFeedback(function(){
          $state.go('main-multi-region');
        },function(){
          $state.go('main-multi-region');
        });
    }*/

    $rootScope.sliderCountry = CONFIG.COUNTRY_CURRENCY_CODE.HK.country_code;
    if(toParams){
      if(toParams.country != undefined){
        $rootScope.sliderCountry = toParams.country.toUpperCase();
        RefDataService.refreshGeoLocation(toParams.country);
        if($rootScope.isLogon){
          UserService.retrieveCreditBalance(toParams.country);
        }
      } else {
        var session = Session.getGeoLocation();
        var country = session ? session.country : null;
        RefDataService.refreshGeoLocation(country);
        if($rootScope.isLogon){
          UserService.retrieveCreditBalance(toParams.country);
        }
      }
    }

  })

  //TODO REMOVE ONCE TEST LANGUAGE TOGGLE
  $scope.changeLang = function(){
    //TEST THE DIALOGALERTSERVICE
    // DialogAlertService.promptDialog('GENERAL.ERROR.TEST_ERROR');

    LocaleService.getLanguage() === 'en' ? LocaleService.updateLanguage('fr') :LocaleService.updateLanguage('en');
  }

	// Trigger create Listing service
	$scope.listingsCreate = function(){
    if(utilities.isShowMainRegion()){
      $state.go('listings-create',{type:1});
    } else {
      $state.go('listings-create-multi-region', {type:1, country: $rootScope.geoLocation.country});
    }
	};

  $rootScope.$watch('geoLocation', function() {
    var q = $state.params ? $state.params.q : null;
    if($rootScope.geoLocation && $rootScope.geoLocation.country != null && $rootScope.geoLocation.currency != null){
      $state.params.country = $rootScope.geoLocation.country;
      if($rootScope.geoLocation.country == 'AU' || $rootScope.geoLocation.country == 'SG') {
        if($state.$current.name == 'search') {
          $state.go('search-multi-region', {country: $rootScope.geoLocation.country, q:q});
        } else if($state.$current.name == 'listing') {
          $state.go('listing-multi-region', {id: $state.params.id, urlSlug: $state.params.urlSlug, country: $rootScope.geoLocation.country});
        } else if($state.$current.name == 'viewOtherUserRentalListings') {
          $state.go('viewOtherUserRentalListings-multi-region', {otherUsername: $state.params.otherUsername, country: $rootScope.geoLocation.country});
        }
      }
      
      if($rootScope.isLogon){
        UserService.retrieveCreditBalance($rootScope.geoLocation.country);
      }
    }
  }, true);

 }]);

'use strict';

/**
 * @ngdoc function
 * @name coutureApp.controller:SuccessmodalinstanceCtrl
 * @description
 * # SuccessmodalinstanceCtrl
 * Controller of the coutureApp
 */
 angular.module('coutureApp')
 .controller('DialogAlertModalInstanceCtrl', ["$uibModalInstance", "msg", "hasCancel", "noDismiss", "cancelLabel", "submitLabel", "cancelButtonColor", "submitButtonColor", function ($uibModalInstance, msg, hasCancel, noDismiss, cancelLabel, submitLabel,cancelButtonColor,submitButtonColor) {

	var $ctrl = this;
	$ctrl.msg = msg;
	$ctrl.hasCancel = hasCancel || false;
  $ctrl.hasDismiss = noDismiss || false;
	$ctrl.cancelLabel = cancelLabel || 'Cancel';
	$ctrl.submitLabel = submitLabel || 'OK';
  $ctrl.cancelButtonColor = cancelButtonColor;
  $ctrl.submitButtonColor = submitButtonColor;

  if (submitButtonColor){
    $ctrl.submitButtonColor = "{'background-color':'"+submitButtonColor+"'}";
  }

  if (cancelButtonColor){
    $ctrl.cancelButtonColor = "{'background-color':'"+cancelButtonColor+"'}";
  }

 	this.close = function () {
    // console.log("DialogAlertModalInstanceCtrl : close");
 		$uibModalInstance.close();
 	};

 	this.dismiss = function () {
    // console.log("DialogAlertModalInstanceCtrl : dismiss");
 		$uibModalInstance.dismiss();
 	}
 }]);

'use strict';

/**
 * @ngdoc function
 * @name coutureApp.controller:LandingCtrl
 * @description
 * # LandingCtrl
 * Controller of the coutureApp
 */
angular.module('coutureApp')
  .controller('ActCtrl', ["$rootScope", "$state", "$log", "AuthService", "PageCtx", "NotificationService", "utilities", "$anchorScroll", "$scope", function($rootScope,$state, $log, AuthService, PageCtx,NotificationService, utilities,$anchorScroll,$scope) {
  	PageCtx.headerUrl = 'views/plain-header.html';
    PageCtx.footerUrl = '';

  	var $ctrl = this;
  	$ctrl.lk_act = false;

  	function init() {
      if($state.params.token) {
        $ctrl.activate($state.params.token);
      }
      utilities.goToTop();
    };

    this.activate = function(token) {
  		$ctrl.lk_act = true;
    	AuthService.activate(token).$promise.then(
    		function(resp){
          var activationDate = resp.activationDate;
    			var date = activationDate === null || !activationDate ? new Date() : new Date(activationDate);
          $ctrl.status = 'Your account has been activated successfully on ' + date + '!';
    			$ctrl.lk_act = false;
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":ActCtrl:activate - Account activated on " + date):'';
          NotificationService.unsubscribeDeviceForAccountActivation();
    		},
    		function(err){
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":ActCtrl:activate - Error: " + JSON.stringify(err)):'';
          $ctrl.status = 'Account activation failed!  Please try again later or contact support.';
          $ctrl.lk_act = false;
    		}
    	);
    };

    this.goShop = function() {
      if(utilities.isShowMainRegion()){
        $state.go('main');
      } else {
        $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
      }
    }

    init();
}]);

'use strict';

(function(){
  angular.module('coutureApp')
    .component('commentComponent', {
      template: '<dir-disqus config="disqusConfig"></dir-disqus>',
      controllerAs : 'comCtrl',
      bindings:{
        isOwner : '<'
      },
      controller: ["$scope", "AuthService", "Session", "$state", "$location", "CommentService", "$translatePartialLoader", "envService", function($scope,AuthService, Session,$state,$location,CommentService,$translatePartialLoader,envService) {
        //INFO ON CREATE AND RESET NEW THREADS
        //https://help.disqus.com/en/articles/1717316-reset-and-archive-large-threads

        this.$onInit = function(){

          this.question_data = {};
          this.selectedCategoryKey = "";
          this.tab = 2;
          this.showAnswerQuestionForm = false;
          this.textarea_maxlength = 2048;
          this.answerForm = {text:""};
          this.questionForm = {text:""};

          //LABLE & DESCRIPTION & PLACEHOLDER
          this.categoryLabel = {'1':'COMMENT_COMPONENT.LABEL.GENERAL','2':'COMMENT_COMPONENT.LABEL.SIZE_FIT','3':'COMMENT_COMPONENT.LABEL.DESIGNER'};

        };

        //DEFINE SCOPE OF this
        var $ctrl = this;
        var dirDisqusCommentVersion = envService.environment + '_v1_0_'
        $translatePartialLoader.addPart('commentComponent');

        $scope.disqusConfig = {
            disqus_shortname: 'couturecarousel',
            disqus_identifier: dirDisqusCommentVersion + $state.params.id,
            disqus_url: 'http://www.stylecarousel.com/'+ dirDisqusCommentVersion + '/#!/'+$state.params.id+'.html',
            disqus_remote_auth_s3: {},
            disqus_public_api_key: 'O7tjyZvpVyIwAX0BbP2VqiRJqmnnRwcY942vqSEM3vd7lzvbBASoJooLJFnmaWLN',
            disqus_public_secret_key: '5enfEksnmlWnmvROH6iv3yyEGOv0I9qhcOiojNEi6d52OPYZJhuTT8JEAZiyAEpq'
        };

        this.resetShowHideQuestionForm = function() {
          this.showAnswerQuestionForm = false;
        };

        //LOAD ALL THE COMMENTS FOR THIS ITEM
        this.getCommentList = function(){
          CommentService.getList($state.params.id).$promise.then(function(resp){
                $ctrl.question_data = resp;
              }
          );
        };

        //GET THE LIST TO FILL THE DDL
        this.getCommentList();

        this.setTab = function(selectedTabNum){
          this.tab = selectedTabNum;
        };

        this.isSet = function(tabNum){
          return this.tab === tabNum;
        };

        this.openItem = function(needAnswer,isAnswerSectionShown,isItemOwner){
          if ((angular.isUndefined(needAnswer) || needAnswer === null) && isItemOwner && !isAnswerSectionShown ){
            this.showAnswerQuestionForm = true;
          }else{
            this.showAnswerQuestionForm = false;
          }
        };

        /*
        cat = 1 : general, 2:Size & fit, 3:designer
        type = 1 : Question, 2: Comment  (2 is not needed for now), 3: Answer (owner only)
        id =  Unique id for each question. Used to provide answer to question.  For now, only 1 response per question.
        */
        this.submitRequest = function(index){
          var requestMsg = {};
          requestMsg.cat = this.selectedCategoryKey;
          requestMsg.type = this.showAnswerQuestionForm ? 3 : 1;
          requestMsg.msg = this.showAnswerQuestionForm ? this.answerForm.text : this.questionForm.text;
          if (index != undefined){
            requestMsg.id = this.question_data[this.selectedCategoryKey][index].id;
          }

          CommentService.create($state.params.id,requestMsg).$promise.then(
            function(resp){

              //REFRESH LIST
              $ctrl.getCommentList();
              $ctrl.resetShowHideQuestionForm();
              $ctrl.answerForm.text = "";
              $ctrl.questionForm.text = "";
              $scope.questionForm.$setPristine()
              $scope.answerForm.$setPristine()
            }
          )

        };


        // this.question_data = {"generalKey":[{"user":"test1 test1","id":3,"q":"First comment !!","qt":1487230150000,"a":null,"at":null},{"user":"test1 test1","id":4,"q":"First comment !!","qt":1487230358000,"a":null,"at":null}],"sizeKey":[],"designerKey":[]};
/*
        this.question_data = {
          generalKey:[{user:'234',id:'1',q:'What color is it ?',a:'Fire red'},{user:'333',id:'3',q:'How heavy is it ?',a:'6lbs'}],
          sizeKey:[{user:'345',id:'4',q:'How big is the bag ?',a:'5 x 6 in'},{user:'432',id:'7',q:'Can it fit a ipad ?',a:'Yes, you can fit a iPad Pro'}],
          designerKey:[{user:'674',id:'5',q:'What is the name of the designer ?',a:'Anya Hindmarsh.'},{user:'674',id:'71',q:'What is the name of the owner ?'}]
        };
*/


        /*
        DISQUS INTEGRATION
        */
        this.disqusSignon = function(user) {
            var disqusData = {
              id: user.id,
              username: user.username,
              email: user.email
            };

            var disqusStr = JSON.stringify(disqusData);
            var timestamp = Math.round(+new Date() / 1000);

            /*
             * Note that `Buffer` is part of node.js
             * For pure Javascript or client-side methods of
             * converting to base64, refer to this link:
             * http://stackoverflow.com/questions/246801/how-can-you-encode-a-string-to-base64-in-javascript
            var message = new Buffer(disqusStr).toString('base64');
            */

            var message = btoa(disqusStr);

            /*
             * CryptoJS is required for hashing (included in dir)
             * https://code.google.com/p/crypto-js/
             */
            var result = CryptoJS.HmacSHA1(message + " " + timestamp, $scope.disqusConfig.disqus_public_secret_key);
            var hexsig = CryptoJS.enc.Hex.stringify(result);

            return {
              pubKey: $scope.disqusConfig.disqus_public_api_key,
              auth: message + " " + hexsig + " " + timestamp
            };
        };

        if(AuthService.isAuthenticated()) {
          $scope.disqusConfig.disqus_remote_auth_s3 = this.disqusSignon({id:Session.user.userid,username:Session.user.username.toUpperCase(),email:Session.user.email}).auth;
          $scope.disqusConfig.disqus_sso_logout = $location.absUrl().replace($location.url(),"")+"/logoff";
        }else{
          $scope.disqusConfig.disqus_remote_auth_s3 = {};
        }

      }]
    });
})()

'use strict';
(function () {

    var moduleName = 'lrDragNDrop';
    var module;
    try {
        module = angular.module(moduleName);
    } catch (err) {
        module = angular.module(moduleName, []);
    }
    

    module.service('lrDragStore', ['$document', function (document) {

        var store = {};

        this.hold = function hold(key, item, collectionFrom, safe) {
            store[key] = {
                item: item,
                collection: collectionFrom,
                safe: safe === true
            }
        };

        this.get = function (namespace) {
            var
                modelItem = store[namespace], itemIndex;

            if (modelItem) {
                itemIndex = modelItem.collection.indexOf(modelItem.item);
                return modelItem.safe === true ? modelItem.item : modelItem.collection.splice(itemIndex, 1)[0];
            } else {
                return null;
            }
        };

        this.clean = function clean() {
            store = {};
        };

        this.isHolding = function (namespace) {
            return store[namespace] !== undefined;
        };

        document.bind('dragend', this.clean);
    }]);

    module.service('lrDragHelper', function () {
        var th = this;

        th.parseRepeater = function(scope, attr) {
            var
                repeatExpression = attr.ngRepeat,
                match;

            if (!repeatExpression) {
                throw Error('this directive must be used with ngRepeat directive');
            }
            match = repeatExpression.match(/^(.*\sin).(\S*)/);
            if (!match) {
                throw Error("Expected ngRepeat in form of '_item_ in _collection_' but got '" +
                    repeatExpression + "'.");
            }

            return scope.$eval(match[2]);
        };

        th.lrDragSrcDirective = function(store, safe) {
            return function compileFunc(el, iattr) {
                iattr.$set('draggable', true);
                return function linkFunc(scope, element, attr) {
                    var
                        collection,
                        key = (safe === true ? attr.lrDragSrcSafe : attr.lrDragSrc ) || 'temp';

                    if(attr.lrDragData) {
                        scope.$watch(attr.lrDragData, function (newValue) {
                            collection = newValue;
                        });
                    } else {
                        collection = th.parseRepeater(scope, attr);
                    }

                    element.bind('dragstart', function (evt) {
                        store.hold(key, collection[scope.$index], collection, safe);
                        if(angular.isDefined(evt.dataTransfer)) {
                            evt.dataTransfer.setData('text/html', null); //FF/jQuery fix
                        }
                    });
                }
            }
        }
    });

    module.directive('lrDragSrc', ['lrDragStore', 'lrDragHelper', function (store, dragHelper) {
        return{
            compile: dragHelper.lrDragSrcDirective(store)
        };
    }]);

    module.directive('lrDragSrcSafe', ['lrDragStore', 'lrDragHelper', function (store, dragHelper) {
        return{
            compile: dragHelper.lrDragSrcDirective(store, true)
        };
    }]);

    module.directive('lrDropTarget', ['lrDragStore', 'lrDragHelper', '$parse', function (store, dragHelper, $parse) {
        return {
            link: function (scope, element, attr) {
                var
                    collection,
                    key = attr.lrDropTarget || 'temp',
                    classCache = null;

                function isAfter(x, y) {
                    //check if below or over the diagonal of the box element
                    return (element[0].offsetHeight - x * element[0].offsetHeight / element[0].offsetWidth) < y;
                }

                function resetStyle() {
                    if (classCache !== null) {
                        element.removeClass(classCache);
                        classCache = null;
                    }
                }

                if(attr.lrDragData) {
                    scope.$watch(attr.lrDragData, function (newValue) {
                        collection = newValue;
                    });
                } else {
                    collection = dragHelper.parseRepeater(scope, attr);
                }

                element.bind('drop', function (evt) {
                    var
                        collectionCopy = angular.copy(collection),
                        item = store.get(key),
                        dropIndex, i, l;
                    if (item !== null) {
                        dropIndex = scope.$index;
                        dropIndex = isAfter(evt.offsetX, evt.offsetY) ? dropIndex + 1 : dropIndex;
                        //srcCollection=targetCollection => we may need to apply a correction
                        if (collectionCopy.length > collection.length) {
                            for (i = 0, l = Math.min(dropIndex, collection.length - 1); i <= l; i++) {
                                if (!angular.equals(collectionCopy[i], collection[i])) {
                                    dropIndex = dropIndex - 1;
                                    break;
                                }
                            }
                        }
                        scope.$apply(function () {
                            collection.splice(dropIndex, 0, item);
                            var fn = $parse(attr.lrDropSuccess) || angular.noop;
                            fn(scope, {e: evt, item: item, collection: collection});
                        });
                        evt.preventDefault();
                        resetStyle();
                        store.clean();
                    }
                });

                element.bind('dragleave', resetStyle);

                element.bind('dragover', function (evt) {
                    var className;
                    if (store.isHolding(key)) {
                        className = isAfter(evt.offsetX, evt.offsetY) ? 'lr-drop-target-after' : 'lr-drop-target-before';
                        if (classCache !== className && classCache !== null) {
                            element.removeClass(classCache);
                        }
                        if (classCache !== className) {
                            element.addClass(className);
                        }
                        classCache = className;
                    }
                    evt.preventDefault();
                });
            }
        };
    }]);
})();
'use strict';

angular.module('draggableModule', []).
directive('draggable', ['$document', function($document) {
    return {
        restrict: 'A',
        link: function(scope, elm, attrs) {
            var startX, startY, initialMouseX, initialMouseY;
            elm.css({ position: 'absolute' });

            elm.bind('mousedown', function($event) {
                startX = elm.prop('offsetLeft');
                startY = elm.prop('offsetTop');
                initialMouseX = $event.clientX;
                initialMouseY = $event.clientY;
                $document.bind('mousemove', mousemove);
                $document.bind('mouseup', mouseup);
                return false;
            });

            function mousemove($event) {
                var dx = $event.clientX - initialMouseX;
                var dy = $event.clientY - initialMouseY;
                elm.css({
                    top: startY + dy + 'px',
                    left: startX + dx + 'px'
                });
                return false;
            }

            function mouseup() {
                $document.unbind('mousemove', mousemove);
                $document.unbind('mouseup', mouseup);
            }
        }
    };
}]);
(function () {
    "use strict";
  
    function touchHandler(event) {
      var touch = event.changedTouches[0];
  
      var simulatedEvent = document.createEvent("MouseEvent");
      simulatedEvent.initMouseEvent({
        touchstart: "mousedown",
        touchmove: "mousemove",
        touchend: "mouseup"
      }[event.type], true, true, window, 1, touch.screenX, touch.screenY, touch.clientX, touch.clientY, false, false, false, false, 0, null);
  
      touch.target.dispatchEvent(simulatedEvent);
      // event.preventDefault();
    }
  
    function init() {
      document.addEventListener("touchstart", touchHandler, true);
      document.addEventListener("touchmove", touchHandler, true);
      document.addEventListener("touchend", touchHandler, true);
      document.addEventListener("touchcancel", touchHandler, true);
    }
    init();
  })();
'use strict';

/**
 * @ngdoc service
 * @name coutureApp.DialogAlertService
 * @description
 * # DialogAlertService
 * Factory in the coutureApp.
 */
angular.module('coutureApp')
  .config(['calendarConfig', function(calendarConfig) {
    calendarConfig.dateFormatter = 'moment';
    calendarConfig.allDateFormats.moment.date.weekDay = 'dd';
  }])
  .factory('DialogAlertService', ["$uibModal", "moment", "RentalService", "RefDataService", "utilities", "priceUtilities", "$anchorScroll", "PageCtx", "$rootScope", "$state", "envService", "$log", "Session", function($uibModal, moment,RentalService, RefDataService,utilities,priceUtilities,$anchorScroll,PageCtx,$rootScope,$state,envService,$log,Session) {
    var dialogService = {};

    dialogService.promptDialog = function(msg, size, hasCancel, cancelLabel, submitLabel, closeCallback, dismissCallback,
      noDismiss, cancelButtonColor, submitButtonColor) {

      // Delegate control to modal instance controller
      var modalInstance = $uibModal.open({
        animation: true,
        ariaLabelledBy: 'modal-header',
        ariaDescribedBy: 'modal-body',
        templateUrl: 'views/modals/alert.html',
        controller: 'DialogAlertModalInstanceCtrl',
        controllerAs: '$ctrl',
        size: size || 'sm',
        backdrop: 'static',
        resolve: {
          msg: function() {
            return msg;
          },
          hasCancel: function() {
            if (hasCancel) {
              return hasCancel;
            }
          },
          noDismiss: function() {
            if (noDismiss) {
              return noDismiss;
            }
          },
          cancelLabel: function() {
            return cancelLabel;
          },
          submitLabel: function() {
            return submitLabel;
          },
          cancelButtonColor: function() {
            return cancelButtonColor;
          },
          submitButtonColor: function() {
            return submitButtonColor;
          }
        }
      });

      modalInstance.result.then(function() {
        if (angular.isFunction(closeCallback)) {
          closeCallback();
        }
      }, function(reason) {
        if (angular.isFunction(dismissCallback)) {
          dismissCallback();
        }
      });
    };


    /////////////////////////////////
    //  LOGON AND REGISTRATION FORM
    /////////////////////////////////
    dialogService.openLogon = function(successCallback,failCallback,isBackDropAllowed,isCreateAccount,isQuickRegisterPage,isSignUpWishlist) {

      var modalInstance = $uibModal.open({
        // templateUrl: isQuickRegisterPage?'views/modals/quickRegister.html':'views/modals/register.html',
        templateUrl: 'views/modals/register.html',
        controller: 'AuthCtrl',
        controllerAs: 'authCtrl',
        backdrop:isBackDropAllowed|false,  //MODAL CANNOT DIMISS FROM BACKDROP
        resolve:{
          openCreateAccount:function(){
            return isCreateAccount || false;
          },
          isQuickRegisterPage:function(){
            return isQuickRegisterPage || false;
          },
          isSignUpWishlist:function(){
            return isSignUpWishlist || false;
          }
        }
      });

      var orgHide = PageCtx.hide;
      var orgScroll = PageCtx.autoscroll;

      $rootScope.isModalOpen = true;

      // HIDE THE MAIN CONTEND AND SCROLL TO TOP
      PageCtx.autoscroll = false;
      PageCtx.hide = true;
      $anchorScroll('top');

      modalInstance.result.then(function(value) {

        // RESET TO DEFAULT AFTER LOGON
        PageCtx.autoscroll = orgScroll;
        PageCtx.hide = orgHide;
        if (angular.isFunction(successCallback)) {
          successCallback(value);
        }
        $rootScope.isModalOpen = value=='LOGON_PAGE' ? true: false;
      }, function() {

        // RESET TO DEFAULT AFTER LOGON
        PageCtx.autoscroll = orgScroll;
        PageCtx.hide = orgHide;
        if (angular.isFunction(failCallback)){
          failCallback();
        }
        $rootScope.isModalOpen = false;
      });
    };


    dialogService.openLogonWishlist = function(successCallback,failCallback,isBackDropAllowed,isCreateAccount,isQuickRegisterPage,isSignUpWishlist) {

      var modalInstance = $uibModal.open({
        // templateUrl: isQuickRegisterPage?'views/modals/quickRegister.html':'views/modals/register.html',
        templateUrl: 'views/modals/register.html',
        controller: 'AuthCtrl',
        controllerAs: 'authCtrl',
        backdrop:isBackDropAllowed|false,  //MODAL CANNOT DIMISS FROM BACKDROP
        resolve:{
          openCreateAccount:function(){
            return isCreateAccount || false;
          },
          isQuickRegisterPage:function(){
            return isQuickRegisterPage || false;
          },
          isSignUpWishlist:function(){
            return isSignUpWishlist || false;
          }
        }
      });

      var orgHide = PageCtx.hide;
      var orgScroll = PageCtx.autoscroll;

      $rootScope.isModalOpen = true;

      // HIDE THE MAIN CONTEND AND SCROLL TO TOP
      PageCtx.autoscroll = false;
      PageCtx.hide = true;
      $anchorScroll('top');

      modalInstance.result.then(function(value) {

        // RESET TO DEFAULT AFTER LOGON
        PageCtx.autoscroll = orgScroll;
        PageCtx.hide = orgHide;
        if (angular.isFunction(successCallback)) {
          successCallback(value);
        }
        $rootScope.isModalOpen = value=='LOGON_PAGE' ? true: false;
      }, function() {

        // RESET TO DEFAULT AFTER LOGON
        PageCtx.autoscroll = orgScroll;
        PageCtx.hide = orgHide;
        if (angular.isFunction(failCallback)){
          failCallback();
        }
        $rootScope.isModalOpen = false;
      });
    };

    /////////////////////////////////
    //  SUBSCRIPTION PURCHASE CONFIRMATION FORM
    /////////////////////////////////
    dialogService.openSubscriptionConfirmation = function(paymentRef,starts,subscriptionProductInfo,closeCallback) {

      var modalInstance = $uibModal.open({
        component: 'buySubscriptionConfirmation',
        resolve: {
          paymentRef: ()=>{return paymentRef},
          starts: ()=>{return starts},
          subscriptionProductInfo: subscriptionProductInfo 
        }
      });

      modalInstance.result.then(function(value) {
        if (angular.isFunction(closeCallback)) {
          closeCallback();
        }
        // console.log("Modal :", value);
      }, function() {
          if (closeCallback){
            closeCallback();
          }
        // console.log('modal-component dismissed at: ' + new Date());
      });
    };
    /////////////////////////////////
    //  CONFIRMATION FORM
    /////////////////////////////////
    dialogService.openConfirmation = function(checkoutRefID,orderIDs,checkoutProductsInfo,topUp,checkoutPurchaseProductsInfo, closeCallback) {
      
      var modalInstance = $uibModal.open({
        component: 'checkoutConfirmation',
        resolve: {
          checkoutRefID: ()=>{return checkoutRefID},
          orderIDs: ()=>{return orderIDs},
          topUp: ()=>{return topUp},
          checkoutProductsInfo: checkoutProductsInfo,
          checkoutPurchaseProductsInfo: checkoutPurchaseProductsInfo
        }
      });

      modalInstance.result.then(function(value) {
        if (angular.isFunction(closeCallback)) {
          closeCallback();
        }
        // console.log("Modal :", value);
      }, function() {
          if (closeCallback){
            closeCallback();
          }
        // console.log('modal-component dismissed at: ' + new Date());
      });
    };


    /////////////////////////////////
    //  OPEN ALERT FORM
    /////////////////////////////////
    dialogService.openAlert = function(options) {
      var modalInstance =  $uibModal.open({
        templateUrl: 'views/modals/openAlert.html',
        controller: ["$scope", function($scope) {
                    $scope.options = options;
        }]
      });

      modalInstance.result.then(function(){
        // console.log("Info: dialogService.openAlert : Dismiss");
      },function(){
        // console.log("Info: dialogService.openAlert : Backdrop");
      })
    },

    /////////////////////////////////////////////
    //  DISPLAY ORDER DETAILS IN ADMIN SCREEN
    /////////////////////////////////////////////
    dialogService.displayOrderDetails = function(orderRentalId,orderDetails) {
      var modalInstance = $uibModal.open({
        templateUrl:'views/modals/displayOrderDetails.html',
        controllerAs: 'dialogServiceCtrl',
        controller: ["$scope", function($scope) {
          $scope.orderDetails = orderDetails;
          $scope.brand = utilities.getCustomBrandName(orderDetails.product);
          $scope.orderRentalId = orderRentalId;
          $scope.orderDetails._shippingFee = orderDetails.shippingFee | 0;
          $scope.orderDetails._giftCardSaving = priceUtilities.getRentalPrice(orderDetails.netTagPrice) - orderDetails.periodFee;
          $scope.orderDetails._rentalProtectionFee = priceUtilities.getRentalProtectionFee(orderDetails.netTagPrice);
          $scope.orderDetails._weeklyDiscountedPrice = priceUtilities.getRentalPrice(orderDetails.netTagPrice);
          $scope.orderDetails._netTagPrice = orderDetails.netTagPrice | 0;
          $scope.orderDetails._nonReturnFee = priceUtilities.getNonReturnFeeWithTagPrice(orderDetails.netTagPrice);
          $scope.orderDetails._totalDue = $scope.orderDetails._rentalProtectionFee + $scope.orderDetails._shippingFee;
          $scope.orderDetails._currency = priceUtilities.getCurrency();
          moment.tz.setDefault($rootScope.currentTimezone);
          var dateRented= moment(orderDetails.dateRented).add(8,"hours").format('ddd DD[/]MM');
          var dateReturn= moment(orderDetails.dateReturn).add(8,"hours").format('ddd DD[/]MM');
          $scope.orderDetails._rentalPeriod= dateRented + ' - ' + dateReturn;


          /**************************
          //VIEW PRODUCT DETAILS
          **************************/
          $scope.viewDetails = function(){
            this.$close();
            
            var url;
            var productBrand = utilities.getCustomBrandName($scope.orderDetails.product);
            var urlSlug = utilities.getPrettyUrl($scope.orderDetails.product.category.code, $scope.orderDetails.product.subCategory.code, productBrand, $scope.orderDetails.product.productLine);
            
            if(utilities.isShowMainRegion()){
              url = $state.href('listing', {id: $scope.orderDetails.product.id, urlSlug: urlSlug});
            } else {
              url = $state.href('listing-multi-region', {id: $scope.orderDetails.product.id, urlSlug: urlSlug, country: $rootScope.geoLocation.country});
            }
            window.open(url,'_blank');
          }

        }]
      });

      modalInstance.result.then(function(){
        // console.log("Info: dialogService.confirmApproval : Dismiss" );
      },function(){
        // console.log("Info: dialogService.confirmApproval : Backdrop" );
      })
    },

    dialogService.displayBuyOrderDetails = function(orderID,orderDetails) {
      var modalInstance = $uibModal.open({
        templateUrl:'views/modals/displayBuyOrderDetails.html',
        controllerAs: 'dialogServiceCtrl',
        controller: ["$scope", function($scope) {
          $scope.orderDetails = orderDetails;
          $scope.brand = utilities.getCustomBrandName(orderDetails.product);
          $scope.orderID = orderDetails.purchaseReferenceNumber;
          var purchaseDate = moment(orderDetails.datePurchased).format('DD MMM YY');
          $scope._purchasedDate = purchaseDate;
          $scope._productID = orderDetails.product.id + "-" + orderDetails.item.id;
          $scope._purchasePrice = orderDetails.country + priceUtilities.currencyFormat(orderDetails.purchasePrice);
          $scope._originalPrice = orderDetails.country + priceUtilities.currencyFormat(orderDetails.product.price);
          $scope._merchantUsername = orderDetails.merchant.username;
          $scope._customerUsername = orderDetails.customer.username;

          /**************************
          //VIEW PRODUCT DETAILS
          **************************/
          $scope.viewDetails = function(){
            this.$close();
            
            var url;
            var productBrand = utilities.getCustomBrandName(orderDetails.product);
            var urlSlug = utilities.getPrettyUrl(orderDetails.product.category.code, orderDetails.product.subCategory.code, productBrand, orderDetails.product.productLine);
            
            if(utilities.isShowMainRegion()){
              url = $state.href('listing', {id: orderDetails.product.id, urlSlug: urlSlug});
            } else {
              url = $state.href('listing-multi-region', {id: orderDetails.product.id, urlSlug: urlSlug, country: $rootScope.geoLocation.country});
            }
            window.open(url,'_blank');
          }

        }]
      });

      modalInstance.result.then(function(){
        // console.log("Info: dialogService.confirmApproval : Dismiss" );
      },function(){
        // console.log("Info: dialogService.confirmApproval : Backdrop" );
      })
    },

    dialogService.displayAddToCartBuyConfirmation = function(cartDetails, productDetails) {
      var modalInstance = $uibModal.open({
        templateUrl:'views/modals/add-to-cart-buy-confirmation.html',
        controllerAs: 'dialogServiceCtrl',
        controller: ["$scope", "$rootScope", "DialogAlertService", "priceUtilities", function($scope, $rootScope, DialogAlertService, priceUtilities) {
          $scope.productDetails = productDetails;
          $scope.cartDetails = cartDetails;
          $scope._purchasePrice = priceUtilities.getFormattedAmountByRate(cartDetails.price.purchasePrice);

          $scope.checkout = function() {
            if(!$rootScope.isLogon){
              DialogAlertService.openLogon(function(){
                if(utilities.isShowMainRegion()){
                  $state.go('checkout');
                } else {
                  $state.go('checkout-multi-region', {country: $rootScope.geoLocation.country});
                }
              });
            } else {
                if(utilities.isShowMainRegion()){
                  $state.go('checkout');
                } else {
                  $state.go('checkout-multi-region', {country: $rootScope.geoLocation.country});
                }
            }
            this.$close();
          };

          $scope.saveCart = function() {
            saveCart();
            this.$close();
          };
        

        }]
      });
    },

    dialogService.viewInvoice = function(checkoutReferenceNumber, invoice) {
      var modalInstance = $uibModal.open({
        templateUrl:'views/modals/invoice-details.html',
        controllerAs: 'dialogServiceCtrl',
        controller: ["$scope", "$translate", "utilities", "CONFIG", function($scope,$translate, utilities, CONFIG) {
          var checkoutDate = moment(invoice.checkoutDate).format('ddd DD MMM YY');
          $scope.INVOICE_INFO = $translate.instant('GENERAL.LABEL.INVOICE_INFO', {checkoutDate: checkoutDate, checkoutReferenceNumber, checkoutReferenceNumber});
          $scope.checkoutReferenceNumber = checkoutReferenceNumber;
          invoice.rentalOrders.forEach(item => {
            
            item._dateRented = moment(item.dateRented).format('ddd, DD/MM');
            item._dateReturned = moment(item.dateReturn).format('ddd, DD/MM');
            item.product.pictures.forEach(function(pic) {
              pic._url = pic.pathSrc === 'shopify' ? pic.path : envService.read('IMG_DOMAIN') + "/" + pic.path;
            });
            
            item.rentalWeeks = utilities.getRentalWeeks(item.dateRented, item.dateReturn);
            item.additionalDays = getRentalAdditionalDays(item.dateRented, item.dateReturn);
            item.rentalDays = utilities.getRentalDays(item.dateRented, item.dateReturn);
          });
          invoice.purchaseOrders.forEach(item => {
            item.product.pictures.forEach(function(pic) {
              pic._url = pic.pathSrc === 'shopify' ? pic.path : envService.read('IMG_DOMAIN') + "/" + pic.path;
            });
          });
          $scope.invoiceDetails = invoice;
          $scope.currency = invoice.country + "$";

          $scope.onprint = function () { 
            window.print();
          } 
          
          function getRentalAdditionalDays(startDate, endDate) {
            var rentalDays = utilities.getRentalDays(startDate, endDate);
            return rentalDays % CONFIG.DEFAULT_WEEKLY_RENTAL;
          }

        }]
      });
    },

    /////////////////////////////////
    //  OPEN FORM FOR LOGON AND REGISTER
    /////////////////////////////////
    dialogService.openForm = function() {
			var modalInstance =  $uibModal.open({
				templateUrl: 'views/modals/register.html',
				controller: ["$scope", "$rootScope", "$timeout", function($scope, $rootScope, $timeout) {
					$scope.createAccount = false;

                    // fix for input caret
                    // moving when modal is scrolled
                    $timeout(function() {
                        let modalEl = document.querySelector('.modal');
                        modalEl.style.position = 'absolute';
                        modalEl.style.height = '100vh';
                    });

                    $scope.signIn = function(event) {
                        event.preventDefault();
                        this.$close();
                    };

                    $scope.signUp = function(event) {
                        event.preventDefault();
                        this.$close();
                        if(utilities.isShowMainRegion()){
                          $state.go('account-verified');
                        } else {
                          $state.go('account-verified-multi-region', {country: $rootScope.geoLocation.country});
                        }
                    };
				}]
			});
		},


    /////////////////////////////////
    //  OPEN SIGN IN FORM, THIS DIRECT FROM WISHLIST
    /////////////////////////////////
    dialogService.openSignIn = function() {
			var modalInstance = $uibModal.open({
				templateUrl: 'views/modals/sign-in.html',
				controller: ["$scope", "$rootScope", function($scope, $rootScope) {
                    $scope.signIn = function(event) {
                        event.preventDefault();
                        this.$close();
                        dialogService.openForm();
                    };

                    $scope.signUp = function(event) {
                        event.preventDefault();
                        this.$close();
                        if(utilities.isShowMainRegion()){
                          $state.go('account-verified');
                        } else {
                          $state.go('account-verified-multi-region', {country: $rootScope.geoLocation.country});
                        }
                    };

                    $scope.joinNow = function(event) {
                        event.preventDefault();
                        this.$close();
                        dialogService.openForm();
                    };
				}]
			});
		},

    /////////////////////////////////
    //  OPEN SOCIAL PROFILE
    /////////////////////////////////
    dialogService.openProfileSocial = function(type) {
      return $uibModal.open({
        template: require('./profile-social.html'),
        controller: ["$scope", function($scope) {
          $scope.type = type;
        }]
      });
    },

    /////////////////////////////////
    //  OPEN PREFERENCE SIZE SETUP WINDOW IN PROFILE
    /////////////////////////////////
    dialogService.openPreferredSizes = function(type) {
      return $uibModal.open({
        template: require('views/modals/preferred-sizes.html')
      });
    },


    //MOVE TO WISHLIST
    dialogService.moveToWishlist = function(cartDetails) {
      var modalInstance = $uibModal.open({
        templateUrl:'views/modals/move-to-wishlist.html',
        backdrop: 'static',
        controllerAs: 'dialogServiceCtrl',
        controller: ["$scope", "CONFIG", function($scope, CONFIG) {
          $scope.cartDetails = cartDetails;

          var rentals = cartDetails.filter(p=> p.transactionType == CONFIG.TRANSACTION_TYPE_RENT);
          $scope.displayRentals = rentals.length > 0;

          var purchases = cartDetails.filter(p=> p.transactionType == CONFIG.TRANSACTION_TYPE_BUY);
          $scope.displayPurchases = purchases.length > 0;
        }]
      });
    }

    dialogService.openAdminUserSubscription = function(userDetails,allSubscriptionPlan) {
      var modalInstance = $uibModal.open({
        templateUrl:'views/modals/admin-user-subscription.html',
        controllerAs: 'dialogServiceCtrl',
        controller: ["$scope", "usSpinnerService", "$log", function($scope, usSpinnerService, $log) {
          $scope.allSubscriptionPlan = allSubscriptionPlan;
          $scope.userDetails = userDetails;
          $scope.selected = {};
          $scope.selected.subscription_id = null;
          $scope.showForm = true;

          $scope.subscribe = function(){
            $scope.showForm = false;
            $scope.subscriptionMessage = "Processing....";
            usSpinnerService.spin('spinner');
            RentalService.buySubscriptionAdmin($scope.selected.subscription_id,userDetails.userid).$promise.then(
              function(resp){
              $scope.subscriptionMessage = "User is successfully subscribed to StylePass.";
              $rootScope.enableLog ? $log.info($rootScope.UUID + ":dialogServiceCtrl:subscribe user to plan - Successfully"):'';
              usSpinnerService.stop('spinner');
            },
            function(err){
              $scope.subscriptionMessage = "Failed: " + err.data.reasons[0].message;
              usSpinnerService.stop('spinner');
              $rootScope.enableLog ? $log.error($rootScope.UUID + ":dialogServiceCtrl:subscribe user to plan - - failed: " + JSON.stringify(err)):'';
            });
          }
        }]
      });

      
    }
    

    dialogService.saveWishlist = function(product) {
      var modalInstance = $uibModal.open({
        templateUrl: 'views/modals/notify-me.html',
        controller: ["$scope", "$rootScope", "WishlistService", function($scope, $rootScope, WishlistService) {

          var self = this;
          //$scope.showForm = $rootScope.isLogon ? false : true; no longer applicable
          $scope.showForm = false;
          var productID = product.id;
          var country = $rootScope.geoLocation.country;
  
          self.allWishlists = {
            'productId' : product.id,
            'wishlists': []
          };
          var allSizes = product.sizes;
          allSizes.forEach(function(size){
            var sizeWishlist = size.wishlist;
            if(sizeWishlist){
              var wishlist_info = {
                "userID": null,
                "email": null,
                "productId": productID,
                "size": size.key,
                "country": country,
                "itemCondition": null,
                "subscribed": true
              };
              self.allWishlists.wishlists.push(wishlist_info);
            } 
          });
          $scope.removeWishlist = self.allWishlists.wishlists.length == 0;

          if(!$scope.showForm){
            WishlistService.saveWishlist(self.allWishlists).$promise.then(
              function(resp) {
                $scope.showForm = false;
                product.existInWishlist = true;
                product.existInWishlistNotification = true;
                $scope.removeWishlist = self.allWishlists.wishlists.length == 0;
              },
              function(err) {
                $rootScope.enableLog ? $log.error($rootScope.UUID + ':productCardList:addToWishlist - addToWishlist error: ' + err ) : '';
              }
            );
          }

          $scope.sendNotifyMeEmail = function() {
            if ($scope.validate()){
              $scope.showForm = false;
              self.allWishlists.email = $scope.emailAddress;
              WishlistService.saveWishlist(self.allWishlists).$promise.then(
                function(resp) {
                  $scope.removeWishlist = self.allWishlists.wishlists.length == 0;
                  product.existInWishlist = true;
                  product.existInWishlistNotification = true;
                },
                function(err) {
                  $rootScope.enableLog ? $log.error($rootScope.UUID + ':productCardList:addToWishlist - addToWishlist error: ' + err ) : '';
                }
              );
            }
          };


          $scope.validate = function() {
            var isValid = true;
            if (!$scope.emailAddress) {
              isValid = false;
              $scope.error_emailAddress = 'GENERAL.ERROR.MISSING_EMAIL_ADDRESS';
            }
            return isValid;
          }
        }]
      });

    }


    dialogService.openFeedback = function(successCallback,failCallback) {

      var modalInstance = $uibModal.open({
        templateUrl: 'views/modals/feedback.html',
        backdrop:false,  
      });

      var orgHide = PageCtx.hide;
      var orgScroll = PageCtx.autoscroll;


      // HIDE THE MAIN CONTEND AND SCROLL TO TOP
      PageCtx.autoscroll = false;
      PageCtx.hide = true;
      $anchorScroll('top');

      modalInstance.result.then(function(value) {

        // RESET TO DEFAULT AFTER LOGON
        PageCtx.autoscroll = orgScroll;
        PageCtx.hide = orgHide;
        if (angular.isFunction(successCallback)) {
          successCallback(value);
        }
      }, function() {

        // RESET TO DEFAULT AFTER LOGON
        PageCtx.autoscroll = orgScroll;
        PageCtx.hide = orgHide;
        if (angular.isFunction(failCallback)){
          failCallback();
        }
      });

    };
    
    dialogService.saveWishlistFromSession = function(wishlists) {
      var modalInstance = $uibModal.open({
        templateUrl: 'views/modals/notify-me.html',
        controller: ["$scope", "$rootScope", "WishlistService", function($scope, $rootScope, WishlistService) {

          var self = this;
          $scope.showForm = false;
          $scope.removeWishlist = wishlists.length == 0;

          if(!$scope.showForm){
            WishlistService.saveWishlist(wishlists).$promise.then(
              function(resp) {
                $scope.showForm = false;
                $scope.removeWishlist = wishlists.length == 0;
                Session.clearWishlistSession();
              },
              function(err) {
                $rootScope.enableLog ? $log.error($rootScope.UUID + ':productCardList:addToWishlist - addToWishlist error: ' + err ) : '';
              }
            );
          }

        }]
      });

    }

    dialogService.createShop = function() {
      var modalInstance = $uibModal.open({
        templateUrl:'views/modals/create-shop.html',
        backdrop:'static',
        keyboard:false,
        controllerAs: 'createShopCtrl',
        controller: ["$scope", "$translate", function($scope,$translate) {
          $scope.toggleMessagebird = function() {
            window.MessageBirdChatWidget.toggleChat();
          }

        }]
      });
    }

    dialogService.appInfo = function(_params) {
      var modalInstance = $uibModal.open({
        templateUrl:'views/modals/app-info.html',
        backdrop:'static',
        keyboard:false,
        controllerAs: 'appInfoCtrl',
        controller: ["$scope", "$window", "envService", function($scope,$window, envService) {
          $scope.routeToApp = function(){
            if(_params){
              $window.location.href = envService.read('APP_URL') + "/listings?"+_params;
            } else {
              $window.location.href = envService.read('APP_URL') + "/listings";
            }
          }
        }]
      });
    }

    dialogService.checkoutPreference = function(usualPricePerCredit, rentalFeePerDay) {
      var modalInstance = $uibModal.open({
        component: 'checkoutPreference',
        backdrop:true,
        resolve: {
          usualPricePerCredit: usualPricePerCredit,
          rentalFeePerDay: rentalFeePerDay
        }
      });

    },

    dialogService.getPayoutTransactions = function(payout) {
      var modalInstance = $uibModal.open({
        templateUrl: 'views/modals/payout-details.html',
        controllerAs: 'dialogServiceCtrl',
        controller: ["$scope", "priceUtilities", "PayoutService", "envService", function($scope,priceUtilities,PayoutService,envService) {
            PayoutService.getPayoutTransactionDetails(payout.payoutReferenceNumber).$promise.then(function(resp) {
              resp.forEach(function (item){
                item._url = item.pictureSrc === 'shopify' ? item.pictureUrl : envService.read('IMG_DOMAIN') + "/" + item.pictureUrl;
                item._earnings = priceUtilities.formatWithCountryCode(item.earnings, item.country);
                item._rentalPeriod = getRentalPeriod(item.startDate, item.returnDate);
              });
              $scope.payoutdetails = resp;
            });

            function getRentalPeriod (startDate, endDate){
              if(startDate == null || endDate == null) {
                return null;
              }
              moment.tz.setDefault('UTC');
              var s= moment(startDate).format('DD MMM YY') + " - " + moment(endDate).format('DD MMM YY');
              return s;
            };

        }]
      });
    },



    dialogService.openCreditPackage = function() {
      var modalInstance = $uibModal.open({
        component: 'creditPackage',
        backdrop:false,
      });

    }

    return dialogService;
  }]);

'use strict';

/**
 * @ngdoc service
 * @name coutureApp.CalendarService
 * @description
 * # CalendarService
 * Factory in the coutureApp.
 */
angular.module('coutureApp')
  .config(['calendarConfig', function(calendarConfig) {
    calendarConfig.dateFormatter = 'moment';
    calendarConfig.allDateFormats.moment.date.weekDay = 'dd';
  }])
  .factory('CalendarService', ["$uibModal", "moment", "RentalService", "CONFIG", "RefDataService", "utilities", "priceUtilities", "$anchorScroll", "PageCtx", "$rootScope", "$state", "DialogAlertService", "$compile", function($uibModal, moment,RentalService, CONFIG,RefDataService,utilities,priceUtilities,$anchorScroll,PageCtx,$rootScope,$state,DialogAlertService,$compile) {
    var calendarService = {};

    // icons will show based on the set days
    // with the selected starting day as the basis
    var expectedDeliveryDateInDays = 0;
    var EndDateInDays = CONFIG.DEFAULT_RENTAL_DURATION;


    /////////////////////////////////
    //  DELIVERY TIME FORM
    /////////////////////////////////
    calendarService.openDeliveryTime = function(closeCallback) {
      var modalInstance = $uibModal.open({
        templateUrl: 'views/modals/delivery-time.html',
        controllerAs : 'dialogCtrl',
        controller: ["$scope", "$rootScope", function($scope, $rootScope) {

          var self = this;
          var today = new Date();
          this.selectedPickupTimeIndex = null;

          // utilities.days = ["Sun","Mon","Tues","Wed","Thurs","Fri","Sat"];
          //GET A LIST OF DATE AVAILABLE. AM/PM AND WEEKDAY ONLY
          //CC-169 PICK UP DATE TIME IS NOT REQUIRED
          this.pickupTimeList = RefDataService.getDeliverySchedule(today);

          this.getDate = function(timestamp){
            var tempDate = new Date(timestamp);
            var formatDate = (utilities.days[tempDate.getDay()] + " " + tempDate.getDate() + "/" + (tempDate.getMonth()+1));
            return formatDate;
          }

          this.getPickupTime = function(timestamp){
            var tempDate = new Date(timestamp);
            var formatDate = utilities.formatAPMP(tempDate);
            return formatDate;
          }

          $scope.confirm = function() {
              this.$close(self.pickupTimeList[self.selectedPickupTimeIndex]);
          };

        }]
      });

      modalInstance.result.then(function(selectedPickupTime) {
        if (angular.isFunction(closeCallback)) {
          closeCallback(selectedPickupTime);
        }
      }, function() {
        closeCallback();
        // console.log('calendarService.openDeliveryTime dismissed : ');
      });

    },


    /////////////////////////////////
    //  CALENDAR SELECTOR
    /////////////////////////////////
    calendarService.openCalendar = function(checkout, saveCart, callbackFN, availableDates, rentalCredit, rentalWeeks, isShowDismissButton) {

      var modalInstance = $uibModal.open({
        templateUrl: 'views/modals/calendar.html',
        backdrop:'static',
        keyboard:false,
        controller: ["$scope", "calendarEventTitle", "utilities", function($scope, calendarEventTitle, utilities) {

          //moment.tz.setDefault($rootScope.currentTimezone);

          var EndDateInDays = CONFIG.DEFAULT_RENTAL_DURATION;
          EndDateInDays = rentalWeeks == 2 ? (EndDateInDays * 2)+1 : EndDateInDays;
          $scope.isDateSelected = false;
          $scope.isShowDismissButton = isShowDismissButton || true;
          $scope.receiveBy = null;
          $scope.returnBy = null;
          $scope.lastAvailableDate = null;
          $scope.firstAvailableDate = null;
          $scope.testChange = "orig";
          $scope.rentalFeeCredits = 0;
          $scope.rentalFeeAmount = 0;
          $scope.rentalFeeAmountCurrency = 0;
          defaultRentalFee();
          if (checkout === null) {
            $scope.isCheckout = false;
          } else {
            $scope.isCheckout = true;
          }

          function isMobileView(){
            return utilities.isMobileView();
          }

          function defaultRentalFee(){
            if($rootScope.isLogon && $rootScope.credit.balance && $rootScope.credit.balance.activeSubscriptionId != null){
              $scope.rentalFeeCredits = rentalCredit * rentalWeeks;
            } else {
              var amt = 0;
              if($rootScope.geoLocation && $rootScope.geoLocation.country == "SG"){
                amt = (rentalCredit * rentalWeeks) * CONFIG.ORIGINAL_CREDIT_PRICE_SG; 
                $scope.rentalFeeAmount = amt;
              } else {
                amt = (rentalCredit * rentalWeeks) * CONFIG.ORIGINAL_CREDIT_PRICE; 
                $scope.rentalFeeAmount = amt;
              } 
              $scope.rentelFeeAmountCurrency = priceUtilities.currencyFormat(amt);
            }
          }

          // CANNOT MAKE RENTAL IN THE PAST. BLOCK OFF DATE 1 YEAR AGO TIL YESTERDAY
          var unavailableDates = [{
            startsAt: new Date(moment().startOf('year').subtract(1,'y').format('LLLL')),
            endsAt: new Date(moment().endOf('day').subtract(1,'d').format('LLLL')),
            cssClass: '-unavailable',
            incrementsBadgeTotal: false }];

          // block off from tmr till first avail date (if there's such a gap)
          //THE AVAILABLE DATE RETURNED IS IN HKT.
          if (moment().startOf('day').format('LLLL') !=moment.tz(availableDates[0],$rootScope.ServerTimezone).utc().format('LLLL')){
            unavailableDates.push({
              startsAt: new Date(moment().startOf('day').format('LLLL')),
              endsAt: new Date(moment.tz(availableDates[0],$rootScope.ServerTimezone).utc().endOf('day').subtract(1,'d').format('LLLL')),
              cssClass: '-unavailable',
              incrementsBadgeTotal: false });
          }

          // block off from last avail date till one year after
          unavailableDates.push( {
            startsAt: new Date(moment(availableDates[availableDates.length-1]).startOf('day').add(1,'d').format('LLLL')),
            endsAt: new Date(moment(availableDates[availableDates.length-1]).add(1,'y').startOf('day').format('LLLL')),
            cssClass: '-unavailable',
            incrementsBadgeTotal: false,
            eventType: "lastAvailableDates"
           });

          var availDatesWithoutTime=[];
          for (var i = 0; i < availableDates.length; i++){
            availDatesWithoutTime[i]=moment(availableDates[i]).startOf('day').format('ll');
          }
          $scope.lastAvailableDate = new Date(moment(availableDates[availableDates.length-1]).startOf('day').add(1,'d').format('LLLL'));
          $scope.firstAvailableDate = new Date(moment(availableDates[0]).startOf('day').format('LLLL'));
          $scope.events = [];
          $scope.events = $scope.events.concat(unavailableDates);
          $scope.calendarView = 'month';
          $scope.viewDate = new Date(moment(availableDates[0]).startOf('month').format('LLLL'));
          $scope.currentMonth = moment($scope.viewDate).format('MMMM');
          $scope.nextAvailableDate = {};
          $scope.nextAvailableDate.date = moment(availableDates[0]).startOf('day').format('ll');
          $scope.nextAvailableDate.nextDate = new Date(moment(availableDates[0]).startOf('day').format('LLLL'));
          $scope.nextAvailableDate.cell = moment(availableDates[0]);
          var originalEventTitle = angular.copy(calendarEventTitle);
          goToNextAvailableDate();
          calendarEventTitle.monthViewTooltip = calendarEventTitle.weekViewTooltip = calendarEventTitle.dayViewTooltip = function() {
            return '';
          };

          // required so other demos work as before
          $scope.$on('$destroy', function() {
            angular.extend(calendarEventTitle, originalEventTitle);
          });

          $scope.checkout = function() {
            checkout();
            this.$close();
          };

          $scope.saveCart = function() {
            saveCart();
            this.$close();
          };

          // updates the MM label
          $scope.$watch('viewDate', function(newDate) {
            $scope.currentMonth = moment(newDate).format('MMMM');
          });
          
          $scope.cellModifier = function(cell){
            if (cell.events && cell.events[0] && cell.events[0].cssClass){

              //CHECK IF THERE ARE EVENTS IN THE CELL, IF SO REMOVE THE UNAVAILABLE EVENT AND MARK IT AS PART OF THE RENTAL
              //eg. RENTAL PERIOD FROM MONDAY TO NEXT TUESDAY. THE WEEKEND IS PART OF THE RENTAL PERIOD, SO NEED TO REMOVE THE
              //-unavailable EVENT AND MARK THE DATE AS -selectedRentalPeriod
              if (cell.events.length > 1 && cell.events.filter(x=>x.cssClass == '-unavailable').length > 0 
              && cell.events.filter(x=>x.cssClass == '-rental-period' 
              || x.cssClass == '-rental-period-credit' 
              || x.cssClass == '-rental-period-dollar').length > 0){
                cell.events = cell.events.filter(x=>x.cssClass != '-unavailable');
              }

              //AT THIS POINT THERE SHOULD ONLY BE ONE EVENT PER CELL.
              switch (cell.events.map(x=>x.cssClass)[0]) {
                case '-rental-period':
                  cell.cssClass = '-selectedRentalPeriod';
                  break;
                case '-rental-period-credit':
                  cell.cssClass = '-selectedRentalPeriodCredit';
                  break;
                case '-rental-period-dollar':
                  getAdditionalRentalPrice(cell, rentalCredit);
                  break;
                case '-delivery-icon':
                  cell.cssClass = '-selectedRentalPeriodStart';
                  break;
                case '-delivery-returns':
                  cell.cssClass = '-selectedRentalPeriodEnd';
                  break;
                case '-delivery-returns-credit':
                  cell.cssClass = '-selectedRentalPeriodCreditEnd';
                  break;
                case '-delivery-returns-dollar':
                  getAdditionalRentalPriceEnd(cell, rentalCredit);
                  break;

                default:
                  cell.cssClass = '-unavailable';
              }
            }
          }

          $scope.timespanClicked = function(date, cell) {
            var selected = moment(date).startOf('day').valueOf();
            var lastAvailableDate = moment($scope.lastAvailableDate).startOf('day').valueOf();
            var firstAvailableDate = moment($scope.firstAvailableDate).startOf('day').valueOf();
            var currentStartDate = moment($scope.receiveBy).startOf('day').valueOf();
            var default7days = moment(date).startOf('day').add(EndDateInDays, 'd').valueOf();


            if($scope.firstDateClicked == null && $scope.lastDateClicked == null && selected <= lastAvailableDate && selected >= firstAvailableDate){
              $scope.firstDateClicked = date;
              adjustDateSelection($scope.firstDateClicked, default7days);
              $scope.firstDateClicked = date;
              $scope.lastDateClicked = null;


              var idx = null;
              $scope.events.forEach((evt, index) => {
                if(evt.eventType == "lastAvailableDates"){
                  idx = index;
                }
              });
              if(idx != null) {
                $scope.events.splice(idx, 1);
              }
              
            } else if($scope.firstDateClicked != null && $scope.lastDateClicked == null && selected <= currentStartDate){
              $scope.firstDateClicked = date;
              adjustDateSelection($scope.firstDateClicked, default7days);
              $scope.firstDateClicked = date;
              $scope.lastDateClicked = null;
            } else if($scope.firstDateClicked != null && $scope.lastDateClicked == null){
              $scope.lastDateClicked = date;
              cell.cssClass = '-rental-period';
            } 

            if($scope.firstDateClicked != null && $scope.lastDateClicked != null) {
              adjustDateSelection($scope.firstDateClicked, $scope.lastDateClicked );
              $scope.firstDateClicked = null;
              $scope.lastDateClicked = null;
              $scope.events.concat(unavailableDates);
            }
          }

          function timeRangeClick(date, cell) {
              //CONVERT THE LOCAL TIME TO HKT
              date = moment(date).startOf('day').valueOf();
              var endDate = moment(date).startOf('day').add(EndDateInDays, 'd').valueOf();
              $scope.firstDateClicked = date;
              $scope.lastDateClicked = endDate;
              $scope.receiveBy = date;
              $scope.returnBy = endDate;

              if (availDatesWithoutTime.includes(cell.date.format('ll')) || !cell.events) {

                //MARK THE RENTAL PERIOD, FROM expectedDeliveryDateInDays - EndDateInDays
                let rentalDates = [];
                for (var i = 1; i < EndDateInDays; i++) {
                  rentalDates.push({
                    startsAt: new Date(moment(date).startOf('day').add(expectedDeliveryDateInDays + i, 'd').format('LLLL')),
                    cssClass: '-rental-period',
                    incrementsBadgeTotal: false });
                }

                let newEvent = [{
                    startsAt: new Date(moment(date).startOf('day').add(expectedDeliveryDateInDays, 'd').format('LLLL')),
                    cssClass: '-delivery-icon',
                    incrementsBadgeTotal: false
                  },
                  {
                    startsAt: new Date(moment(date).startOf('day').add(EndDateInDays, 'd').format('LLLL')),
                    cssClass: '-delivery-returns',
                    incrementsBadgeTotal: false
                  }
                ];
                $scope.events = [];
                $scope.events = $scope.events.concat(newEvent);
                $scope.events = $scope.events.concat(unavailableDates);
                $scope.events = $scope.events.concat(rentalDates);
                $scope.isDateSelected = true;
                callbackFN(date, endDate);
              }
          };

          $scope.closeCalender = function() {
            $rootScope.$emit("CallUpdateDateSelectButton", {});
            this.$close();
          };

          function goToNextAvailableDate() {
            var cell = {};
            cell.date = $scope.nextAvailableDate.cell;
            var nextDate = new Date(moment($scope.nextAvailableDate.nextDate).startOf('day').format('LLLL'));
            timeRangeClick(nextDate, cell);
            $scope.firstDateClicked = null;
            $scope.lastDateClicked = null;
          };


          function getRentalAdditionalDays(startDate, endDate){
            var rentalDays = utilities.getRentalDays(startDate, endDate);
            return rentalDays % CONFIG.DEFAULT_WEEKLY_RENTAL;
          }

          function adjustDateSelection (startDate, endDate) {
            var diffDays = utilities.getRentalDays(startDate, endDate)-1; 
            var rentalDays = diffDays < EndDateInDays ? EndDateInDays : diffDays;
            var add = diffDays < EndDateInDays ? EndDateInDays - diffDays : 0;

            startDate = moment(startDate).startOf('day').valueOf();
            endDate = moment(endDate).startOf('day').add(add, 'd').valueOf();
            var additionalRentalDays = getRentalAdditionalDays(moment(startDate), moment(endDate));

            $scope.firstDateClicked = startDate;
            $scope.lastDateClicked = endDate;
            $scope.receiveBy = startDate;
            $scope.returnBy = endDate;




            var creditCnt = utilities.getRentalWeeks(startDate, endDate);
            var daysCnt = utilities.getRentalDays(startDate, endDate) % CONFIG.DEFAULT_WEEKLY_RENTAL; 
            var amt = 0;
            if($rootScope.isLogon && $rootScope.credit.balance && $rootScope.credit.balance.activeSubscriptionId != null){
              $scope.rentalFeeCredits = rentalCredit * creditCnt;
              if($rootScope.geoLocation && $rootScope.geoLocation.country == "SG"){
                var additionalFee = (daysCnt * CONFIG.SG_MEMBER_RENTAL_DAYS_TOPUP) * rentalCredit;
                amt = amt + additionalFee;
              } else {
                var additionalFee = (daysCnt * CONFIG.HK_MEMBER_RENTAL_DAYS_TOPUP) * rentalCredit;
                amt = amt + additionalFee;
              }
            } else {
              if($rootScope.geoLocation && $rootScope.geoLocation.country == "SG"){
                var additionalFee = (daysCnt * CONFIG.SG_NONMEMBER_RENTAL_DAYS_TOPUP) * rentalCredit;
                amt = (rentalCredit * creditCnt) * CONFIG.ORIGINAL_CREDIT_PRICE_SG; 
                amt = amt + additionalFee;
              } else {
                var additionalFee = (daysCnt * CONFIG.HK_NONMEMBER_RENTAL_DAYS_TOPUP) * rentalCredit;
                amt = (rentalCredit * creditCnt) * CONFIG.ORIGINAL_CREDIT_PRICE; 
                amt = amt + additionalFee;
              } 
            }
            $scope.rentalFeeAmount = amt;
            $scope.rentelFeeAmountCurrency = priceUtilities.currencyFormat(amt);

            if (availDatesWithoutTime.includes(moment(startDate).startOf('day').format('ll'))) {
              let rentalDates = [];
              for (var i = 1; i < rentalDays; i++) {
                rentalDates.push({
                  startsAt: new Date(moment(startDate).startOf('day').add(expectedDeliveryDateInDays + i, 'd').format('LLLL')),
                  cssClass: '-rental-period',
                  incrementsBadgeTotal: false,
                });
              }

              for(var i = 0; i < rentalDates.length; i++) {
                var diff = utilities.getRentalDays(moment(startDate), moment(rentalDates[i].startsAt));
                var additionalDays = rentalDays - diff;
                if(diff % 7 == 0 && diff > 7) {
                  rentalDates[i].cssClass = '-rental-period-credit';
                } else if(additionalDays < additionalRentalDays && diff > 7) {
                  rentalDates[i].cssClass = '-rental-period-dollar';
                }
              }
              
              let newEvent = [{
                  startsAt: new Date(moment(startDate).startOf('day').add(expectedDeliveryDateInDays, 'd').format('LLLL')),
                  cssClass: '-delivery-icon',
                  incrementsBadgeTotal: false,
                },
                {
                  startsAt: new Date(moment(startDate).startOf('day').add(rentalDays, 'd').format('LLLL')),
                  cssClass: '-delivery-returns',
                  incrementsBadgeTotal: false
                }
              ];

              for(var i = 0; i < newEvent.length; i++) {
                var diff = utilities.getRentalDays(moment(startDate), moment(newEvent[i].startsAt));
                var additionalDays = rentalDays - diff;
                if(diff % 7 == 0 && diff > 7) {
                  newEvent[i].cssClass = '-delivery-returns-credit';
                } else if(additionalDays < additionalRentalDays && diff > 7) {
                  newEvent[i].cssClass = '-delivery-returns-dollar';
                }
              }
              
              $scope.events = [];
              $scope.events = $scope.events.concat(newEvent);
              $scope.events = $scope.events.concat(unavailableDates);
              $scope.events = $scope.events.concat(rentalDates);
              $scope.isDateSelected = true;
              callbackFN(startDate, endDate);
            }
          }

          function getAdditionalRentalPrice(cell, rentalCredit){
            if($rootScope.isLogon && $rootScope.credit.balance && $rootScope.credit.balance.activeSubscriptionId != null){
              if($rootScope.geoLocation && $rootScope.geoLocation.country == "SG"){
                cell.cssClass = '-selectedRentalPeriodDollarSGMember';
                cell.isTopUp = true;
                cell.topUp = '+$' + rentalCredit * CONFIG.SG_MEMBER_RENTAL_DAYS_TOPUP;
              } else {
                cell.cssClass = '-selectedRentalPeriodDollarHKMember';
                cell.isTopUp = true;
                cell.topUp = '+$' + rentalCredit * CONFIG.HK_MEMBER_RENTAL_DAYS_TOPUP;

              }
            } else {
              if($rootScope.geoLocation && $rootScope.geoLocation.country == "SG"){
                cell.cssClass = '-selectedRentalPeriodDollarSGNonMember';
                cell.isTopUp = true;
                cell.topUp = '+$' + rentalCredit * CONFIG.SG_NONMEMBER_RENTAL_DAYS_TOPUP;
              } else {
                cell.cssClass = '-selectedRentalPeriodDollarHKNonMember';
                cell.isTopUp = true;
                cell.topUp = '+$' + rentalCredit * CONFIG.HK_NONMEMBER_RENTAL_DAYS_TOPUP;
              } 
            }
          }

          function getAdditionalRentalPriceEnd(cell, rentalCredit){
            if($rootScope.isLogon && $rootScope.credit.balance && $rootScope.credit.balance.activeSubscriptionId != null){
              if($rootScope.geoLocation && $rootScope.geoLocation.country == "SG"){
                cell.cssClass = '-selectedRentalPeriodDollarSGMemberEnd';
                cell.isTopUp = true;
                cell.topUp = '+$' + rentalCredit * CONFIG.SG_MEMBER_RENTAL_DAYS_TOPUP;
              } else {
                cell.cssClass = '-selectedRentalPeriodDollarHKMemberEnd';
                cell.isTopUp = true;
                cell.topUp = '+$' + rentalCredit * CONFIG.HK_MEMBER_RENTAL_DAYS_TOPUP;
              }
            } else {
              if($rootScope.geoLocation && $rootScope.geoLocation.country == "SG"){
                cell.cssClass = '-selectedRentalPeriodDollarSGNonMemberEnd';
                cell.isTopUp = true;
                cell.topUp = '+$' + rentalCredit * CONFIG.SG_NONMEMBER_RENTAL_DAYS_TOPUP;
              } else {
                cell.cssClass = '-selectedRentalPeriodDollarHKNonMemberEnd';
                cell.isTopUp = true;
                cell.topUp = '+$' + rentalCredit * CONFIG.HK_NONMEMBER_RENTAL_DAYS_TOPUP;
              } 
            }
          }
        }]
      });
    }

    return calendarService;
  }])
.directive("calendarHover", ["$document", function($document) {
  return{
      restrict: 'EA',
      scope: false,
      link: function(scope, element){

        $(document).on('mouseover', '.cal-month-day', function (ev) {
          var $calMonthElements = element.find('.cal-month-day');
          var $unavailablelements = element.find('.cal-month-day.-unavailable');

          var selectedStart = $(".-selectedRentalPeriodStart").first();
          var selectedEnd = null;

          var end1 = $(".-selectedRentalPeriodEnd").first();
          var end2 = $(".-selectedRentalPeriodCreditEnd").first();
          var end3 = $(".-selectedRentalPeriodDollarSGMemberEnd").first();
          var end4 = $(".-selectedRentalPeriodDollarHKMemberEnd").first();
          var end5 = $(".-selectedRentalPeriodDollarSGNonMemberEnd").first();
          var end6 = $(".-selectedRentalPeriodDollarHKNonMemberEnd").first();

          if(end1.length != 0){
            selectedEnd = end1;
          } else if(end2.length != 0){
            selectedEnd = end2;
          } else if(end3.length != 0){
            selectedEnd = end3;
          } else if(end4.length != 0){
            selectedEnd = end4;
          } else if(end5.length != 0){
            selectedEnd = end5;
          } else if(end6.length != 0){
            selectedEnd = end6;
          } else {
            selectedEnd = $calMonthElements[$calMonthElements.length-1];
          }


          var deliveryReceive = $(".deliveryReceive").first();
          var deliveryReturn = $(".deliveryReturn").first();

          var first = $(".cal-month-day").first();
          var start_index = $(".cal-month-day").index(selectedStart);
          var end_index = $(".cal-month-day").index(selectedEnd);
          var current_index = $(".cal-month-day").index(this);
          

          if(parseInt(current_index) >= parseInt(end_index) && deliveryReturn.length > 0){
            var ctr = end_index + 1;
            while(parseInt(ctr) < parseInt(current_index)){
              var e = $calMonthElements[ctr];
              $(e).addClass("-calendar-hover");
              ctr++;
            }
          } else if(parseInt(start_index) >= parseInt(current_index) && $unavailablelements.length) {
            var ctr = start_index - 1;
           
            //keep below code for backwards highlighting later
            /*while(parseInt(ctr) > parseInt(current_index)){
              var e = $calMonthElements[ctr];
              if(!$(e).hasClass("-unavailable")){
                $(e).addClass("-calendar-hover");
              }
              ctr--;
            }*/
              
          }
        });	

        $(document).on('mouseleave', '.cal-month-day', function () {
          $(".cal-month-day").removeClass('-calendar-hover');
      
        });
      }
      
  }
}]);
'use strict';
/**
 * @ngdoc factory
 * @name coutureApp.authCheck
 * @description
 * # authCheck
 * Factory in the coutureApp.
 */
 angular.module('coutureApp')
 .factory('authCheck', ["DialogAlertService", "$rootScope", "$q", "$state", "CONFIG", "Session", function (DialogAlertService,$rootScope,$q,$state,CONFIG,Session) {

  var instance = {};

    //LOGIC WHERE PAGE REQUIRE LOGON BEFORE PROCEED.
    instance.authorityCheck = function(){
      var deferred = $q.defer();
      if (!$rootScope.isLogon){
        var clickCount = Session.getPopCount() >= 1 ? CONFIG.AUTHCHECK_CLICK_SECOND_POPUP : CONFIG.AUTHCHECK_CLICK;
        if (CONFIG.AUTHCHECK_CLICK != 0 && Session.getClickCount() >= clickCount){
          Session.updatePopCount();
          //BY DEFAULT OPENED THE QUICK REGISTER BEFORE CLIENT CAN ACCESS THE SITE.
          $rootScope.isOpenQuickRegister = $rootScope.isOpenQuickRegister == undefined ? true:false;
          DialogAlertService.openLogon(function(value){

            //WHEN THE OPENLOGON DIALOGBOX CLOSE WITH ANY VALUE
            //THE NEXT TIME THE DIALOGBOX WILL BE OPEN AS REQUIRE FULL LOGON.
            if (value != undefined || value != null){
              switch (value) {
                case 'LOGON_PAGE':
                  $rootScope.isOpenQuickRegister = false;
                  $state.reload();
                  break;
                case 'SHOW_CONFIRM':
                  //RETURN VALUE AND THE SUB-SEQUENCE FLOW SHOULD USE THIS AS INDICATOR TO STOP UI-ROUTE
                  break;

                case 'CLOSED':
                  //DO NOTHING JUST CLOSE THE MODAL WINDOW
                  break;
                default:

                  $state.reload();
              }
            }

            deferred.resolve(value);
          },function(){

            delete $rootScope.isOpenQuickRegister;
            Session.clearClickCount();
          },false,false,$rootScope.isOpenQuickRegister);
        }else{
          Session.updateClickCount();
          deferred.resolve();
        }
      }else{

        delete $rootScope.isOpenQuickRegister;
        deferred.resolve();
      }
      return deferred.promise;
    }
    return instance;
  }]);

'use strict';

/**
 * @ngdoc service
 * @name coutureApp.UserService
 * @description
 * # UserService
 * Factory in the coutureApp.
 */
angular.module('coutureApp')
  .factory('UserService', ["$rootScope", "$resource", "envService", "Session", "AuthService", function ($rootScope, $resource, envService,Session,AuthService) {
    var userService = {};

    // Interact with the RESTful API of the server.
    userService.api = $resource(
      envService.read('SERVICE_DOMAIN') + "/api/pub/profile/register",
      {}, // param defaults
      {
          // Custom method to register
          'register' : { 
            method: "POST",
            timeout: 30000,
            params: {
              referralId: '@referralId'
            }
        },
          'updateAddressAuth' : { method: "POST",
            url: envService.read('SERVICE_DOMAIN')  + "/api/auth/address/save"
        },
          'updateAddressPub' : { method: "POST",
            url: envService.read('SERVICE_DOMAIN')  + "/api/pub/address/save"
        },
        'retrievePickupAddress' : { method: "POST",
            url: envService.read('SERVICE_DOMAIN') + "/api/pub/address/pickup/get"
        },
          'retrieveUserProfile' : { method: "GET",
            url: envService.read('SERVICE_DOMAIN')+ "/api/auth/profile"
        },
        'updateAboutMe' : { method: "POST",
          url: envService.read('SERVICE_DOMAIN')+ "/api/auth/profile/update-about-me"
      },
          'retrieveCreditBalance' : { method: "GET",
            url: envService.read('SERVICE_DOMAIN') + "/api/auth/credit/balance?country=:country",
            params: {
              country: '@country'
            }
        },
          'updateUserProfile' : {method:"POST",
            url: envService.read('SERVICE_DOMAIN') + "/api/auth/profile/update"
        },
          'retrievePickupAddressNoToken' : { method: "GET",
            url: envService.read('SERVICE_DOMAIN') + "/api/auth/address/pickup"
        },
          'changePassword' : { method: "POST",
            url: envService.read('SERVICE_DOMAIN') + "/api/auth/password/change"
        },
          'resetPasswordEmail' : { method: "POST",
            url: envService.read('SERVICE_DOMAIN') + "/api/pub/password/reset/send-email"
        },
        'resendVerificationEmail' : { 
          method: "POST",
          url: envService.read('SERVICE_DOMAIN') + "/api/pub/verification/send-email"
        },
          'validResetPasswordToken' : { method: "POST",
            url: envService.read('SERVICE_DOMAIN') + "/api/pub/password/reset/validate-token"
        },
          'resetPassword' : { method: "PUT",
            url: envService.read('SERVICE_DOMAIN') + "/api/pub/password/reset"
        },
          'createTempAccount' : { method: "POST",
            url: envService.read('SERVICE_DOMAIN') + "/api/pub/profile/temp/account"
        },
          'confirmTempAccount' : { method: "POST",
            url: envService.read('SERVICE_DOMAIN') + "/api/pub/profile/temp/account/confirm"
        },
          'isUserExists' :{method: "GET",
            url:envService.read('SERVICE_DOMAIN')+ "/api/pub/profile"
        },
          'updateProfileImg' : { method: "POST",
            url: envService.read('SERVICE_DOMAIN') + "/api/auth/profile/image"
        },
          'deleteProfileImg' : { method: "DELETE",
            url: envService.read('SERVICE_DOMAIN') + "/api/auth/profile/image"
        },
        'updateProfileBanner' : { method: "POST",
          url: envService.read('SERVICE_DOMAIN') + "/api/auth/profile/banner"
        },
        'deleteProfileBanner' : { method: "DELETE",
          url: envService.read('SERVICE_DOMAIN') + "/api/auth/profile/banner"
        },
          'quickRegEmail' : { method: "POST",
            url: envService.read('SERVICE_DOMAIN') + "/api/pub/profile/non-social-register-step1",
            params: {
              referralId: '@referralId'
            }
        },
          'quickRegActivateToken' : { method: "POST",
            url: envService.read('SERVICE_DOMAIN') + "/api/pub/profile/activation/verify"
        },
          'saveSelectedPlan' : { method: "POST",
            url: envService.read('SERVICE_DOMAIN') + "/api/auth/profile/selected-plan/save/:subId", params: {subId: '@subId'}
        },
          'getSelectedPlan' : { method: "GET",
            url: envService.read('SERVICE_DOMAIN') + "/api/auth/profile/selected-plan/get"
        },
          'quickRegCompleteAccountInfo' : { method: "POST",
            url: envService.read('SERVICE_DOMAIN') + "/api/auth/profile/non-social-register-step2"
        },
        'getActivationDate' : { 
          method: "POST",
          url: envService.read('SERVICE_DOMAIN') + "/api/pub/profile/get-activation-date"
        },
        'updateSalesChannel' :{
          method: "POST",
          url: envService.read('SERVICE_DOMAIN')+ "/api/auth/profile/update/australia-channel"
        },
        'retrievePickupAddressV2' : { 
          method: "GET",
          url: envService.read('SERVICE_DOMAIN') + "/api/auth/v2/address/pickup"
        },
        'retrieveShippingAddressV2' : { 
          method: "GET",
          url: envService.read('SERVICE_DOMAIN')  + "/api/auth/v2/address/shipping"
        },
        'getUserPromos' : { 
          method: "GET",
          url: envService.read('SERVICE_DOMAIN') + "/api/auth/profile/promo/user-promos",
          isArray : true,
        },
        'updateShareReferralLinkCount' : { 
          method: "POST",
          url: envService.read('SERVICE_DOMAIN') + "/api/auth/profile/update/increase-referral-share-count",
        },
        'updateViewReferralLinkCount' : { 
          method: "POST",
          url: envService.read('SERVICE_DOMAIN') + "/api/pub/profile/update/increase-referral-view-count",
          params: {
            referralCode: '@referralCode'
          }
        },
    });

    userService.getUserPromos = function() {
      return userService.api.getUserPromos();
    };

    userService.updateShareReferralLinkCount = function() {
      return userService.api.updateShareReferralLinkCount();
    };

    userService.updateViewReferralLinkCount = function(referralCode) {
      return userService.api.updateViewReferralLinkCount({'referralCode': referralCode});
    };

    userService.retrievePickupAddressV2 = function() {
      return userService.api.retrievePickupAddressV2();
    };

    userService.retrieveShippingAddressV2 = function() {
      return userService.api.retrieveShippingAddressV2();
    };

    userService.getActivationDate = function(token) {
      return userService.api.getActivationDate({}, {'token': token});
    };

    userService.quickRegCompleteAccountInfo = function(accountInfo) {
      return userService.api.quickRegCompleteAccountInfo({},accountInfo,function(resp){
        // Create a new Session object
        Session.create(resp["X-Authorization"], resp.User);
      });
    };

    userService.quickRegActivateToken = function(token) {
      return userService.api.quickRegActivateToken({}, {'token': token},
      // success callback
      function(resp) {
          // Create a DUMMY Session object
          Session.create(resp["X-Authorization"], resp.User);
      });
    };

    userService.quickRegEmail = function(clientEmail, country, userLocation, isSignUpWishlist, referralId) {
      return userService.api.quickRegEmail({'referralId':referralId},{'email':clientEmail, 'registeredCountry':country, 'userLocation':userLocation, 'wishlistSignUp':isSignUpWishlist});
    };

    userService.deleteProfileImg = function() {
      return userService.api.deleteProfileImg();
    };

    userService.updateProfileBanner = function(photo) {
      return userService.api.updateProfileBanner(
        {},{'imgPath':photo});
    };

    userService.deleteProfileBanner = function() {
      return userService.api.deleteProfileBanner();
    };

    userService.updateProfileImg = function(photo) {
      return userService.api.updateProfileImg(
        {},{'imgPath':photo});
    };

    userService.isUserExists = function(username) {
      return userService.api.isUserExists(
        {'user':username},{});
    };

    userService.resetPassword = function(token,newPW) {
      return userService.api.resetPassword(
        // params
        {},
        // post data
        {'token': token,'newPassword':newPW});
    };

    userService.createTempAccount = function(email,password,name, userLocation, registeredCountry) {
      return userService.api.createTempAccount(
        // params
        {},
        // post data
        {'email': email,'password':password,'name':name, 'userLocation': userLocation, 'registeredCountry': registeredCountry});
    };
    userService.confirmTempAccount = function() {
      return userService.api.confirmTempAccount(
        // params
        {},
        // post data
        {'tempToken': $rootScope.tempToken});
    };

    userService.validResetPasswordToken = function(token) {
      return userService.api.validResetPasswordToken(
        // params
        {},
        // post data
        {'token': token});
    };

    userService.resetPasswordEmail = function(resetPWEmail) {
      return userService.api.resetPasswordEmail(
        // params
        {},
        // post data
        {'emailAddress': resetPWEmail});
    };

    userService.resendVerificationEmail = function(username) {
      return userService.api.resendVerificationEmail({'username' : username}, {});
    };

    userService.changePassword = function(userReset) {
      return userService.api.changePassword(
        // params
        {},
        // post data
        userReset);
    };

    userService.updateUserProfile = function(user_profile) {
      return userService.api.updateUserProfile(
        // params
        {},
        // post data
        user_profile);
    };

    userService.updateAboutMe = function(user_profile) {
      return userService.api.updateAboutMe({}, user_profile);
    };

    userService.retrieveUserProfile = function() {
      return userService.api.retrieveUserProfile({},{},function(resp) {
        if (resp.profileImg && resp.profileImg.indexOf('https://') == -1){
          resp.profileImg = envService.read('IMG_DOMAIN') + "/" + resp.profileImg;
        }else if (resp.profileImg && resp.profileImg.indexOf('https://') != -1){
          //DO NOTHING, PROFILE FROM SOCIAL ACCOUNT
        }else{
          resp.profileImg = null;
        }
      });
    };

    userService.retrieveCreditBalance= function(country) {
      return userService.api.retrieveCreditBalance({},{'country':country},function(resp) {
        $rootScope.credit.balance=resp;
      });
    };

    userService.register = function(registration_info, referralId) {
      return userService.api.register(
      // params
      {'referralId': referralId},
      // post data
      registration_info);
    };
    userService.storeSelectedPlan=function(subId){
        Session.setSelectedPlan(Number(subId));
        $rootScope.credit.selectedPlan=Session.getSelectedPlan();
        if (AuthService.isAuthenticated()) {
          userService.saveSelectedPlan(subId);
        }
    }
    userService.saveSelectedPlan= function(subId) {
      return userService.api.saveSelectedPlan(
      // params
      // {}
      {subId : subId});
      // post data
      // registration_info);
    };
    userService.getSelectedPlan= function(subId) {
      return userService.api.getSelectedPlan();
      // params
      // {},
      // {subId : '@subId'});
      // post data
      // registration_info);
    };
    userService.syncSelectedPlan = function (ServerSubId) {
      // from local to BE
      if (Session.getSelectedPlan() != null){
        if (ServerSubId == null){
          userService.storeSelectedPlan(Session.getSelectedPlan());
        } else{
            var serverSubMonth = $rootScope.credit.pricing.filter(p => p.id == Number(ServerSubId))[0].numContractMonths;
            var localSubMonth = $rootScope.credit.pricing.filter(p => p.id == Number(Session.getSelectedPlan()))[0].numContractMonths;
            var currentSubMonth = $rootScope.credit.balance.numContractMonths;
            $rootScope.credit.selectedPlan = Session.getSelectedPlan();
            if (localSubMonth> serverSubMonth && localSubMonth > currentSubMonth) userService.storeSelectedPlan(Session.getSelectedPlan());
        }
      }
      // from BE to local
      if (ServerSubId != null) {
        if (Session.getSelectedPlan() == null) {
          userService.storeSelectedPlan(ServerSubId);
        } else {
          var serverSubMonth = $rootScope.credit.pricing.filter(p => p.id == Number(ServerSubId))[0].numContractMonths;
          var localSubMonth = $rootScope.credit.pricing.filter(p => p.id == Number(Session.getSelectedPlan()))[0].numContractMonths;
          var currentSubMonth = $rootScope.credit.balance.numContractMonths;
          if (serverSubMonth > localSubMonth && serverSubMonth > currentSubMonth) userService.storeSelectedPlan(ServerSubId);
        }
      }
    }

    userService.updateAddress = function(addr) {
      if (AuthService.isAuthenticated()){
        return userService.api.updateAddressAuth({},addr);
      } else {
        return userService.api.updateAddressPub({},addr);
      }
    };

    userService.retrievePickupAddress = function(token) {
      return userService.api.retrievePickupAddress(
      // params
      {},
      // post data
      {'token': token});
    };

    userService.retrievePickupAddressNoToken = function(token) {
      return userService.api.retrievePickupAddressNoToken(
      // params
      {},
      // post data
      {});
    };

    userService.updateSalesChannel = function(australiaOnlineStoreEnabled) {
      return userService.api.updateSalesChannel(
        {
          'australiaOnlineStoreEnabled':australiaOnlineStoreEnabled
        }, 
        {});
    };

    // Public API here
    return userService;
  }]);

'use strict';

var authCheckDirectives = angular.module('authCheckDirectives', []);
authCheckDirectives.directive('sitePreviewCount', ['listenService', function (listenService) {

  return {
    restrict : 'A',
    link: function (scope, element) {

      element.on('click', function(){
         listenService.checkSitePreview();
      });
    }
  };
}]) //You can use your API in a service, here called listenService. It is used in the directive

.service('listenService', ["authCheck", "CONFIG", "$rootScope", "$state", "Session", "utilities", function(authCheck,CONFIG,$rootScope,$state,Session,utilities){
    this.checkSitePreview = function(){

      authCheck.authorityCheck().then(function(){
        //ALL IS OK. AUTHORITY CHECK PASSED
      },function(){
        Session.updateClickCount('TO_MAX');
        if(utilities.isShowMainRegion()){
          $state.go('main');
        } else {
          $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
        }
      })

    };
}]);

'use strict';

/**
 * @ngdoc service
 * @name coutureApp.AuthService
 * @description
 * # AuthService
 * Factory in the coutureApp.
 */
angular.module('coutureApp')
  .factory('AuthService', ["$resource", "envService", "Session", "$rootScope", "$injector", "$state", "CONFIG", function ($resource, envService, Session,$rootScope,$injector,$state,CONFIG) {
    // Service logic

    var authService = {};

    //////////////////////////////////////////////////////////////////////////////////////////////
    // AUTHENTICATION LOGIC TO POPUP LOGON DIALOG BOX
    //////////////////////////////////////////////////////////////////////////////////////////////
    $rootScope.$on('$stateChangeStart',function(event, toState, toParams, fromState, fromParams, options) {

      //ONLY THE STATE DEFINED BELOW WILL NOT REQUIRE LOGON
      var noLogonRequired = CONFIG.AUTHCHECK;

      if (noLogonRequired.indexOf(toState.name) == -1){
        $injector.get('authCheck').authorityCheck().then(function(){
          //ALL IS GOOD. PROCEED TO LOAD CONTROLLER
        },function(){
          //HAVE TO DO A THROW CATCH TO STOP THE PROCESS
          event.preventDefault();

          //CHECK IF THE USER IS NAV FROM ONE OF THE PUBLIC PAGE DEFINED.
          //IF NOT DIRECT THEM BACK TO MAIN PAGE.
          var backToPage = noLogonRequired.indexOf(fromState.name) == -1 ? ($rootScope.geoLocation.country == null ? 'main' : 'main-multi-region' ) :fromState.name;
          $state.go(backToPage, fromParams, { reload: true });
        })
      }
    });


    // Interact with the RESTful API of the server.
    authService.api = $resource(
      envService.read('SERVICE_DOMAIN')+ "/api/auth/login",
      {}, // param defaults
      {
        // Custom method to logon
        'logon' : { method: "POST"
        },
        'activate' : { method: "POST",
          url: envService.read('SERVICE_DOMAIN') + "/api/pub/profile/activation/verify"
        },
        //FOR NEW AND UPDATE SOCIAL LOGIN
        'socialLogin' : {method: "POST",
          url: envService.read('SERVICE_DOMAIN')+ "/api/pub/profile/social/login"
        },
        'socialDelete' : {method: "POST",
          url: envService.read('SERVICE_DOMAIN') + "/api/auth/profile/social/delete"
        },
        'socialAdd' : {method: "POST",
          url: envService.read('SERVICE_DOMAIN') + "/api/auth/profile/social/add"
        }
      });
    authService.socialDelete = function(password) {
      return authService.api.socialDelete(
      // params
      {},
      // post data
      password,
      // success callback
      function(resp) {
          // Create a Session object
          // resp.User.profileImg = resp.User.profileImg ? envService.read('IMG_DOMAIN') + "/" + resp.User.profileImg:null;
          // Session.create(resp["X-Authorization"], resp.User);
      });
    };

    authService.socialAdd = function(accessToken) {
      return authService.api.socialAdd(
      // params
      {},
      // post data
      accessToken,
      // success callback
      function(resp) {

      });
    };

    authService.socialLogin = function(accessToken) {
      return authService.api.socialLogin(
      // params
      {},
      // post data
      accessToken,
      // success callback
      function(resp) {
          // Create a Session object
          resp.User.profileImg = resp.User.profileImg ? envService.read('IMG_DOMAIN') + "/" + resp.User.profileImg:null;
          Session.create(resp["X-Authorization"], resp.User);
      });
    };

    authService.logon = function(credential) {
      return authService.api.logon(
      // params
      {},
      // post data
      credential,
      // success callback
      function(resp) {
          // Create a Session object
          resp.User.profileImg = resp.User.profileImg ? envService.read('IMG_DOMAIN') + "/" + resp.User.profileImg:null;
          Session.create(resp["X-Authorization"], resp.User);
      });
    };

    authService.activate = function(token) {
      return authService.api.activate({}, {'token': token},function(resp){
        // Create a new Session object
        Session.create(resp["X-Authorization"], resp.User);
      });
    };


    authService.logoff = function() {
      Session.destroy();
      var saveAllowedRentalDate = $rootScope.cc.allowedDates;
      $rootScope.cc = {};
      $rootScope.cc.cart = [];
      $rootScope.cc.allowedDates = saveAllowedRentalDate;
      delete $rootScope.credit.balance;
      // $rootScope.credit.selectedPlan=0;
      Session.setSelectedPlan(null);
      $rootScope.credit.selectedPlan=Session.getSelectedPlan();

      //REMOVE THE UUID FROM THE XHR HEADER
      $rootScope.UUID = "visitor";
      var ES = envService.read();
      ES['XHR_REQ_HEADER']['X-CorrId']=$rootScope.UUID;

      // Call a service to tell server to logoff?
    };

    // Helper method to check if user is authenticated
    authService.isAuthenticated = function () {
      return !!Session.token;
    };

    // Helper method to check if user is authorized
    authService.isAuthorized = function(authorizedRoles) {
      if (!angular.isArray(authorizedRoles)) {
        authorizedRoles = [authorizedRoles];
      }

      if(authService.isAuthenticated()) {
        return Session.userRoles.some(function(role) {
            return authorizedRoles.indexOf(role) >= 0;
        });
      } else {
        return false;
      }
    };

    // Public API here
    return authService;
  }]);

'use strict';

/**
 * @ngdoc service
 * @name coutureApp.AUTHEVENTS
 * @description
 * # AUTHEVENTS
 * Constant in the coutureApp.
 */
angular.module('coutureApp')
  .constant('AUTH_EVENTS', {
  loginSuccess: 'auth-login-success',
  loginFailed: 'auth-login-failed',
  logoutSuccess: 'auth-logout-success',
  sessionTimeout: 'auth-session-timeout',
  notAuthenticated: 'auth-not-authenticated',
  notAuthorized: 'auth-not-authorized'
});


'use strict';

/**
 * @ngdoc service
 * @name coutureApp.USERROLES
 * @description
 * # USERROLES
 * Constant in the coutureApp.
 */
angular.module('coutureApp')
  .constant('USER_ROLES', {
  all: '*',
  admin: 'ROLE_ADMIN',
  premium: 'ROLE_PREMIUM_MEMBER',
  member: 'ROLE_MEMBER'
});

'use strict';

/**
 * @ngdoc service
 * @name coutureApp.Session
 * @description
 * # Session
 * Service in the coutureApp.  Used to keep track of current authenticated session
 */
angular.module('coutureApp')
  .service('Session', ["localStorageService", "CONFIG", function(localStorageService,CONFIG) { // https://github.com/grevory/angular-local-storage

    this.UUID = localStorageService.get('UUID') || "visitor";
    this.token = localStorageService.get('token');
    this.user = localStorageService.get('user');
    this.userRoles = localStorageService.get('userRoles');
    this.clickCount = localStorageService.get('clickCount');
    this.popCount = localStorageService.get('popCount');
    this.bundleID = localStorageService.get('bundleID');
    localStorageService.get('cart') === null || localStorageService.get('cart') === undefined ? this.cart = []: this.cart = localStorageService.get('cart');


    this.create = function(token, user) {
      var roles = [];
      user.authorities.forEach(function(role) {
        roles.push(role.authority);
      });

      this.UUID = user.userid+'-'+create_UUID();
      this.token = token;
      this.user = user;
      this.userRoles = roles;
      localStorageService.set('UUID', this.UUID);
      localStorageService.set('token', token);
      localStorageService.set('user', user);
      localStorageService.set('userRoles', roles);
      localStorageService.set('cart',this.cart);
    };
    this.getSelectedPlan=function(){
      return localStorageService.get('selectedPlan');
    }
    this.setSelectedPlan=function(subId){
      localStorageService.set('selectedPlan',subId);
    }

    /*
    * UPDATE THE ITEMS SAVED IN LOCAL STORAGE
    * cartID: COMPOSITE KEY WITH PRODUCTID + SUBITEMID (EG. IN FORMAT OF 1234-455) length might vary
    * productID : THE MASTER PRODUCT ID, NOT THE SUB-ID AS WE DIDN'T KNOW WHICH SPECIFIC ONE IS AVAILABLE IN BE
    * size : PRODUCT SIZE
    * startDate : REQUEST RENTAL START DATE
    * returnDate : REQUEST RENTAL END DATE
    */
    this.updateCart = function(cartID, productID, size, startDate, returnDate, transactionType, itemCondition){
      var type = transactionType ? transactionType : CONFIG.TRANSACTION_TYPE_RENT; // to handle old data in session
      this.cart = this.cart.filter(p=> p.cartID != cartID);
      this.cart.push({'cartID': cartID, 'id':productID,'size':size,'startDate':startDate,'returnDate':returnDate, 'transactionType': type, 'itemCondition' : itemCondition});
      localStorageService.set('cart', this.cart);
    }
    this.updateCartV2 = function(cartDetails){
      var type = cartDetails.transactionType ? cartDetails.transactionType : CONFIG.TRANSACTION_TYPE_RENT; // to handle old data in session
      this.cart = this.cart.filter(p=> p.cartID != cartDetails.cartID);
      var purchasePrice = cartDetails.price.purchasePrice ? cartDetails.price.purchasePrice : 0;
      var originalPrice = cartDetails.price.originalPrice ? cartDetails.price.originalPrice : 0;
      var salePrice = cartDetails.price.salePrice ? cartDetails.price.salePrice : 0;
      this.cart.push({
        'cartID': cartDetails.cartID, 
        'id':cartDetails.productID,
        'size':cartDetails.size,
        'startDate':cartDetails.startDate,
        'returnDate':cartDetails.returnDate, 
        'transactionType': type, 
        'price': {
          'purchasePrice': Math.round(purchasePrice.toFixed(2)),
          'originalPrice': Math.round(originalPrice.toFixed(2)),
          'salePrice': Math.round(salePrice.toFixed(2))
        },
        'itemCondition': cartDetails.itemCondition,
        'bundleID': cartDetails.bundleID,
        'country': cartDetails.country,
      });
      localStorageService.set('cart', this.cart);
    }


    /*
    * EMPTY THE LOCAL STORAGE
    */
    this.emptyCart = function(){
      this.cart = [];
      localStorageService.set('cart', this.cart);
    }


    /*
    * REMOVE THE ITEMS SAVED IN LOCAL STORAGE BASED ON THE COMPOSITE KEY
    * cartID: COMPOSITE KEY WITH PRODUCTID + SUBITEMID (EG. IN FORMAT OF 1234-455) length might vary
    */
    this.removeCart = function(cartID){

      var itemIndexInCart;
      itemIndexInCart = this.cart.findIndex(p=> (p.cartID == cartID));
      if (itemIndexInCart != -1){
        this.cart.splice(itemIndexInCart,1);
      }
      localStorageService.set('cart', this.cart);
    }

    /*
    * GET THE ITEMS STORED IN THE LOCAL STORAGE
    */
    this.getCart = function(){
      return localStorageService.get('cart');
    }

    this.updateToken = function(token) {
      this.token = token;
      localStorageService.set('token', token);
    }

    this.getClickCount = function(){
      return this.clickCount;
    }

    this.getPopCount = function(){
      return this.popCount;
    }

    this.updateClickCount = function(max) {
      if (max){
        this.clickCount = CONFIG.AUTHCHECK_CLICK;
      }else{
        this.clickCount += 1;
      }
      localStorageService.set('clickCount', this.clickCount);
    }

    this.clearClickCount = function() {
      this.clickCount = 0;
      localStorageService.set('clickCount', this.clickCount);
    }

    this.destroy = function() {
      this.token = null;
      this.user = null;
      this.userRoles = null;
      this.UUID = null;
      this.clickCount = 0;
      this.popCount = 0;
      this.cart = [];
      localStorageService.remove('clickCount');
      localStorageService.remove('popCount');
      localStorageService.remove('UUID');
      localStorageService.remove('token');
      localStorageService.remove('user');
      localStorageService.remove('userRoles');
      localStorageService.remove('cart');
      localStorageService.remove('megaMenuSearchKey');
    };

    ////////////////////////////
    //  CREATE A UUID
    ////////////////////////////
    function create_UUID(){
        var dt = new Date().getTime();
        var uuid = 'xxxxxxxx-xxxx-xxxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = (dt + Math.random()*16)%16 | 0;
            dt = Math.floor(dt/16);
            return (c=='x' ? r :(r&0x3|0x8)).toString(16);
        });
        return uuid;
    }
    this.getGeoLocation=function(){
      return localStorageService.get('geoLocation');
    }
    this.getSubscribed = function(){
      return localStorageService.get('subscribed');
    }
    this.setSubscribed = function(){
      localStorageService.set('subscribed', true);
    }

    this.updatePopCount = function() {
      this.popCount += 1;
      localStorageService.set('popCount', this.popCount);
    }

    this.getWishlistSession=function(){
      return localStorageService.get('wishlist');
    }

    this.saveWishlistSession = function (wishlist_info){
      localStorageService.set('wishlist', wishlist_info);
    }

    this.clearWishlistSession = function (){
      localStorageService.set('wishlist', {});
    }

    this.getBundleID = function() {
      return localStorageService.get('bundleID');
    }

    this.setBundleID = function(bundleID) {
      localStorageService.set('bundleID', bundleID);
    }

    this.clearBundleID = function() {
      localStorageService.set('bundleID', null);
    }

    this.setReferralRewardCode = function(friendReferral) {
      localStorageService.set('friendReferral', friendReferral);
    }

    this.clearReferralRewardCode = function() {
      localStorageService.set('friendReferral', null);
    }

    this.getReferralRewardCode = function() {
      return localStorageService.get('friendReferral');
    }


  }]);

'use strict';

/**
 * @ngdoc service
 * @name coutureApp.PageCtx
 * @description
 * # PageCtx
 * Provider in the coutureApp.
 */
angular.module('coutureApp')
  .provider('PageCtx', function () {

  // Default context and page url
  var defaultCtx = {
    // title: 'Style Carousel',
    // headerUrl: 'views/default-header.html',
    // footerUrl: 'views/footer.html',
    // bgStyle: 'body-background',
    autoscroll: true
  };

  // Private variable
  var currentCtx = angular.copy(defaultCtx);

  return {
    $get: ["$rootScope", function($rootScope) {

      // Fallback to the default whenever the location is changed
      $rootScope.$on('$stateChangeStart', function() {
        angular.extend(currentCtx, defaultCtx);
      });

      return currentCtx;
    }]
  };
});

'use strict';

/**
 * @ngdoc service
 * @name coutureApp.AuthInterceptor
 * @description
 * # AuthInterceptor
 * Factory in the coutureApp.
 */
angular.module('coutureApp')
  .factory('AuthInterceptor', ["$rootScope", "$q", "Session", "envService", "$location", function ($rootScope, $q, Session, envService,$location) {

    return {
      request: function (config) {
        config.headers = config.headers || {};
        // Add default request headers (e.g. X-Requested-With)
        angular.extend(config.headers, envService.read('XHR_REQ_HEADER'));

        // Add authorization token if logged on
        if(!!Session.token) {
          config.headers['X-Authorization'] = Session.token;
        }

        // Add XHR timeout if not existed
        if(!config.timeout) {
          config.timeout = envService.read('XHR_TIMEOUT');
        }

        return config;
      },
      response: function (response) {
        return response || $q.when(response);
      },
      responseError: function (rejection) {
        // Do something on error
        if(rejection === 'LIMIT REACHED'){
          rejection = null;
        }else if(rejection.status === 404){
           //$location.path('/404/');
        } else if( rejection.status === 401 ) {
          // HANDLE TOKEN EXPIRED OR ENTER INCORRECT USER/PW
          $rootScope.$emit('header:logout', null);
          Session.destroy();
        }

        return $q.reject(rejection);
      },
      requestError: function(rejection) {
        return $q.reject(rejection);
      }
    };
  }]);

'use strict';

/**
 * @ngdoc service
 * @name coutureApp.ListingService
 * @description
 * # ListingService
 * Factory in the coutureApp.
 */
angular.module('coutureApp')
    .factory('ListingService', ["$resource", "envService", "AuthService", "$q", "$filter", "$translate", "$translatePartialLoader", "productStatus", "localStorageService", "$rootScope", "$log", function($resource, envService, AuthService, $q,$filter,$translate,$translatePartialLoader,productStatus, localStorageService, $rootScope, $log) {
        var listingService = {};
        var defaultPageIndex = 1;
        listingService.defaultPageSize = 20; // Aligning server settings.

        var isAuth = function() {
            if (AuthService.isAuthenticated()) {
                return "auth";
            } else {
                return "pub";
            }
        };

        var getListingCallback = function(resp) {
            for (var i = 0; i < resp.pictures.length; i++) {
                resp.pictures[i]._url = resp.pictures[i].pathSrc === 'shopify' ? resp.pictures[i].path : (envService.read('IMG_DOMAIN') + "/" + resp.pictures[i].path);
            }

            /*if(resp.completeTheLook){
                resp.completeTheLook.forEach(function(item) {
                    for (var i = 0; i < item.pictures.length; i++) {
                        item.pictures[i]._url = item.pictures[i].pathSrc === 'shopify' ? item.pictures[i].path : (envService.read('IMG_DOMAIN') + "/" + item.pictures[i].path);
                    }
                });
            }*/

            // Map status value
            resp._status_displayValue = productStatus.getListingStatusDisplay(resp.status) ? productStatus.getListingStatusDisplay(resp.status) : '';
        };

        var getLookBookCallBack = function(resp) {
            if(resp){
                resp.forEach(function(item) {
                    for (var i = 0; i < item.pictures.length; i++) {
                        item.pictures[i]._url = item.pictures[i].pathSrc === 'shopify' ? item.pictures[i].path : (envService.read('IMG_DOMAIN') + "/" + item.pictures[i].path);
                    }
                });
            }
        };

        var searchCallBack = function(resp) {
            for (var i = 0; i < resp.length; i++) {
              if (!resp[i]['searchResult']){
                resp[i].pictures.forEach(function(item) {
                    item._url = item.pathSrc === 'shopify' ? item.path : envService.read('IMG_DOMAIN') + "/" + item.path;
                });

                // Map status value
                resp[i]._status_displayValue = productStatus.getListingStatusDisplay(resp[i].status) ? productStatus.getListingStatusDisplay(resp[i].status) : '';
              }
            }
        };

        //////////////////////////////////////////////////////////////
        // TRANSFORM THE TOTAL NUMBER OF MATCHING RECORDS
        // AND PAGE NUMBER FROM HEAD TO THE DATA ARRAY
        //////////////////////////////////////////////////////////////
        var transformTotalRecordCount = function(data, header, status){
          // To be removed once server response is fixed
          data = angular.fromJson(data);
          var searchResult = {'totalRecordCount':header()["x-total-count"],'totalPageCount':header()["x-total-page"]};
          data.reasons ? '' : data.push({searchResult});
          return data;
        }

        function base64toBlob(base64Data, contentType) {
            contentType = contentType || '';
            var sliceSize = 1024;
            var byteCharacters = atob(base64Data);
            var bytesLength = byteCharacters.length;
            var slicesCount = Math.ceil(bytesLength / sliceSize);
            var byteArrays = new Array(slicesCount);
        
            for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
                var begin = sliceIndex * sliceSize;
                var end = Math.min(begin + sliceSize, bytesLength);
        
                var bytes = new Array(end - begin);
                for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
                    bytes[i] = byteCharacters[offset].charCodeAt(0);
                }
                byteArrays[sliceIndex] = new Uint8Array(bytes);
            }
            return new Blob(byteArrays, { type: contentType });
        }
        

        var transformFileDownload = function(data, headers) {
            var filename = headers('X-filename');
            var contentType = headers('content-type');
            var linkElement = document.createElement('a');
            try {
                var blob = base64toBlob(data, contentType);
                var url = window.URL.createObjectURL(blob);
     
                linkElement.setAttribute('href', url);
                linkElement.setAttribute("download", filename);
     
                var clickEvent = new MouseEvent("click", {
                    "view": window,
                    "bubbles": true,
                    "cancelable": false
                });
                linkElement.dispatchEvent(clickEvent);
            } catch (err) {
                $rootScope.enableLog ? $log.error($rootScope.UUID + ":transformFileDownload - Failed") :'';
            }
        }


        // Interact with the RESTful API of the server.
        listingService.api = $resource(
            envService.read('SERVICE_DOMAIN') + "/api/auth/listing/create", {}, // param defaults
            {
                // Custom method to create listing
                'create': {
                    method: "POST",
                    transformResponse: function(data, header) {
                        // To be removed once server response is fixed
                        data = angular.fromJson(data);
                        return data;
                    }
                },
                // REPLACED WITH THE NEW SERACH API WITH FULL CAPABILITY OF DOING FILTER AS WELL.
                // 'search': {
                //     method: "POST",
                //     url: envService.read('SERVICE_DOMAIN') + "/api/:isAuth/listing/get/",
                //     params: {
                //         isAuth: '@isAuth'
                //     },
                //     isArray: true
                // },
                // 'getFilterListing': {
                //     method: "POST",
                //     url: envService.read('SERVICE_DOMAIN') + "/api/pub/listing/get",
                //     isArray: true
                // },
                'getListing': {
                    method: "POST",
                    url: envService.read('SERVICE_DOMAIN')+ "/api/:isAuth/product/get/:id?country=:country",
                    params: {
                        id: '@id',
                        isAuth: '@isAuth',
                        country: '@country'
                    }
                },
                'getListingV2': {
                    method: "POST",
                    url: envService.read('SERVICE_DOMAIN')+ "/api/v2/:isAuth/product/get/:id?country=:country",
                    params: {
                        id: '@id',
                        isAuth: '@isAuth',
                        country: '@country'
                    }
                },
                'getListingCompleteTheLook': {
                    method: "POST",
                    url: envService.read('SERVICE_DOMAIN')+ "/api/v2/pub/product/get/look-book/:id?country=:country",
                    params: {
                        id: '@id',
                        country: '@country'
                    },
                    isArray: true
                },
                'getListingRecommendedLook': {
                    method: "POST",
                    url: envService.read('SERVICE_DOMAIN')+ "/api/v2/pub/product/get/recommended-look/:id?country=:country",
                    params: {
                        id: '@id',
                        country: '@country'
                    },
                    isArray: true
                },
                'getMyListing': {
                    method: "POST",
                    url: envService.read('SERVICE_DOMAIN') + "/api/auth/listing/mine/get",
                    isArray: true
                },
                'update': {
                    method: "POST",
                    url: envService.read('SERVICE_DOMAIN') + "/api/auth/listing/update"
                },
                'delete': {
                    method: "GET",
                    url: envService.read('SERVICE_DOMAIN') + "/api/auth/listing/delete/:id",
                    params: {
                        id: '@id'
                    }
                },
                'deleteByProduct': {
                    method: "GET",
                    url: envService.read('SERVICE_DOMAIN') + "/api/auth/v2/listing/delete/:id",
                    params: {
                        id: '@id'
                    }
                },
                'updateCollection': {
                    method: "POST",
                    url: envService.read('SERVICE_DOMAIN') + "/api/auth/listing/collection/update"
                },
                //   'deleteImage' : { method: "GET",
                //     url: SERVICE_DOMAIN + "/api/auth/picture/delete/:id",
                //     params: {id : '@id'}
                // },
                'getPendingListing': {
                    method: "GET",
                    url: envService.read('SERVICE_DOMAIN') + "/api/auth/admin/listing/pending/get",
                    isArray: true
                },
                // 'getListingByCategory': {
                //     method: "GET",
                //     url: envService.read('SERVICE_DOMAIN') + "/api/pub/listing?category=:category&page=:page",
                //     isArray: true
                // },
                'getImgPaths': {
                    method: "GET",
                    url: envService.read('SERVICE_DOMAIN') + "/api/pub/pictures",
                    params: {
                        productId: '@id'
                    },
                    isArray: true
                },
                'deleteImage': {
                    method: "DELETE",
                    url: envService.read('SERVICE_DOMAIN') + "/api/auth/pictures/:id",
                    params: {
                        id: '@id'
                    },
                },
                'addImagePaths': {
                    method: "POST",
                    url: envService.read('SERVICE_DOMAIN') + "/api/auth/pictures"
                },
                'getListingsV2': {
                    method: "GET",
                    url:  envService.read('SERVICE_DOMAIN') + "/api/v2/:isAuth/listing",
                    isArray: true,
                    cache: false,
                    params: {
                        isAuth: '@isAuth'
                    },
                    transformResponse: transformTotalRecordCount
                },
                'getListingByOwner':{
                  method:"GET",
                  url: envService.read('SERVICE_DOMAIN')  + "/api/v2/:isAuth/listing",
                  isArray:true,
                  params: {
                      isAuth: '@isAuth'
                  },
                  transformResponse: transformTotalRecordCount
                },
                'getListingSuggestions':{
                  method:"GET",
                  url: envService.read('SERVICE_DOMAIN') + "/api/pub/listing/suggestion"
                },
                'downloadProductCatalogue':{
                  method:"GET",
                  url: envService.read('SERVICE_DOMAIN')+ "/api/auth/admin/listing/download-catalogue", 
                  timeout: 300000,
                  transformResponse: transformFileDownload
                },
                'reorder': {
                    method: "POST",
                    url: envService.read('SERVICE_DOMAIN') + "/api/auth/admin/listing/reorder"
                },
            });

        listingService.getListingByOwner = function(params) {

            return listingService.api.getListingByOwner(params, {'isAuth': isAuth()}, searchCallBack);
        };

        listingService.getListing = function(id) {
            return listingService.api.getListing({
                'id': id,
                'isAuth': isAuth(),
                'country': $rootScope.geoLocation.country
            }, {}, getListingCallback);
        };

        listingService.getListingV2 = function(id) {
            return listingService.api.getListingV2({
                'id': id,
                'isAuth': isAuth(),
                'country': $rootScope.geoLocation.country
            }, {}, getListingCallback);
        };

        listingService.getListingCompleteTheLook = function(id) {
            return listingService.api.getListingCompleteTheLook({
                'id': id,
                'isAuth': isAuth(),
                'country': $rootScope.geoLocation.country
            }, {}, getLookBookCallBack);
        };

        listingService.getListingRecommendedLook = function(id) {
            return listingService.api.getListingRecommendedLook({
                'id': id,
                'isAuth': isAuth(),
                'country': $rootScope.geoLocation.country
            }, {}, getLookBookCallBack);
        };

        listingService.getMyListing = function() {
            return listingService.api.getMyListing({}, {}, searchCallBack);
        };

        listingService.update = function(listing_info) {
            return listingService.api.update({}, listing_info);
        };

        listingService.updateCollection = function(listing_info) {
            return listingService.api.updateCollection({}, listing_info);
        };

        listingService.delete = function(id) {
            return listingService.api.delete({
                'id': id
            }, {});
        };

        listingService.deleteByProduct = function(id) {
            return listingService.api.deleteByProduct({
                'id': id
            }, {});
        };

        // listingService.getFilterListing = function(tags,page) {
        //
        //     if (!angular.isArray(tags)) {
        //         tags = [tags];
        //     }
        //
        //     return listingService.api.getFilterListing({}, {
        //       "tags": tags,
        //       "page": page || defaultPageIndex
        //     }, searchCallBack);
        // };

        // listingService.getListingByCategory = function(category,page) {
        //
        //     return listingService.api.getListingByCategory({
        //         'category': category,
        //         "page": page || defaultPageIndex
        //
        //     }, {}, searchCallBack);
        // };

        listingService.getPendingListing = function() {
            return listingService.api.getPendingListing({}, {}, searchCallBack);
        };

        listingService.getMyListing = function() {
            return listingService.api.getMyListing({}, {}, searchCallBack);
        };

        listingService.create = function(listing_info) {
            return listingService.api.create(
                // params
                {},
                // post data
                listing_info);
            // var deferred = $q.defer();
            // setTimeout(function(){ deferred.resolve({id: 123}); }, 1000);
            // return deferred.promise;
        };

        // REPLACED WITH THE NEW SERACH API WITH FULL CAPABILITY OF DOING FILTER AS WELL.
        // listingService.search = function(tags, page) {
        //     if (!tags) {
        //         return;
        //     }
        //
        //     if (!angular.isArray(tags)) {
        //         tags = [tags];
        //     }
        //
        //     return listingService.api.search(
        //         // params
        //         {
        //             'isAuth': isAuth()
        //         },
        //         // post data
        //         {
        //             "tags": tags,
        //             "page": page || defaultPageIndex
        //         },
        //         searchCallBack
        //     );
        //
        // };

        listingService.getImgPaths = function(id) {
            return listingService.api.getImgPaths({
                'id': id
            }, {});
        };

        listingService.deleteImage = function(id) {
            return listingService.api.deleteImage({
                'id': id
            }, {});
        };

        listingService.addImagePaths = function(req) {
            return listingService.api.addImagePaths({}, req).$promise;
        };

        listingService.getListingsWithFilters = function(filters) {
            return listingService.api.getListingsV2(filters,{'isAuth': isAuth()},searchCallBack);
        }

        listingService.getListingSuggestions = function(filters) {
            return listingService.api.getListingSuggestions(filters);
        }

        listingService.captureViewItem = function(productObj,size){
            let currentUser = localStorageService.get('user');
            let geoLocation = $rootScope.geoLocation;//localStorageService.get('geoLocation');
            let sessionCurrency = geoLocation ? geoLocation.currency : "HKD";
            let sessionCountry = geoLocation ? geoLocation.country : "HK";
            dataLayer.push({ ecommerce: null });  
            dataLayer.push({
                "environment" : envService.environment === "production" ? "prod" : "dev",
                "currentUserID" : currentUser ? currentUser.userid : "guest",
                "currentUserName" : currentUser ? currentUser.firstName + " " + currentUser.lastName : "guest",
                "currentUserEmail" : currentUser ? currentUser.email : "guest",
                "currency": sessionCurrency ? sessionCurrency : "HKD",
                "country": sessionCountry ? sessionCountry : "HK",
                "size": size ? size : "no-size-defined",
                "color": productObj ? productObj.color : "Multicolor",
                "subCategory": productObj ? (productObj.subCategory ? productObj.subCategory.name : productObj.category)  : productObj.category,
            event: "view_item",
            ecommerce: {
              items: [{
                item_name: productObj.productLine,       
                item_id: productObj.id,
                price: productObj.price,
                item_brand: productObj.brand,
                item_category: productObj.category.name
              }]}
              });

            fbq('track', 'ViewContent', 
            {
                content_ids: [
                    productObj.id,
                ], 
                content_name: productObj.productLine, 
                content_type: "product",
                contents: [{'id': productObj.id, 'quantity': 1}],
                currency: sessionCurrency ? sessionCurrency : "HKD",
                value: productObj.price ? productObj.price : 0
            });
          };

        listingService.downloadProductCatalogue = function(params) {
            return listingService.api.downloadProductCatalogue(params);
        }

        listingService.reorder = function(listing_info) {
            return listingService.api.reorder({}, listing_info);
        };

        // Public API here
        return listingService;
    }]);

'use strict';

/**
 * @ngdoc service
 * @name coutureApp.WishlistService
 * @description
 * # WishlistService
 * Factory in the coutureApp.
 */
angular.module('coutureApp')
    .factory('WishlistService', ["$resource", "envService", "AuthService", "$rootScope", "$log", function($resource, envService, AuthService, $rootScope, $log) {

        function base64toBlob(base64Data, contentType) {
            contentType = contentType || '';
            var sliceSize = 1024;
            var byteCharacters = atob(base64Data);
            var bytesLength = byteCharacters.length;
            var slicesCount = Math.ceil(bytesLength / sliceSize);
            var byteArrays = new Array(slicesCount);
        
            for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
                var begin = sliceIndex * sliceSize;
                var end = Math.min(begin + sliceSize, bytesLength);
        
                var bytes = new Array(end - begin);
                for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
                    bytes[i] = byteCharacters[offset].charCodeAt(0);
                }
                byteArrays[sliceIndex] = new Uint8Array(bytes);
            }
            return new Blob(byteArrays, { type: contentType });
        }

        var transformFileDownload = function(data, headers) {
            var filename = headers('X-filename');
            var contentType = headers('content-type');
            var linkElement = document.createElement('a');
            try {
                var blob = base64toBlob(data, contentType);
                var url = window.URL.createObjectURL(blob);
     
                linkElement.setAttribute('href', url);
                linkElement.setAttribute("download", filename);
     
                var clickEvent = new MouseEvent("click", {
                    "view": window,
                    "bubbles": true,
                    "cancelable": false
                });
                linkElement.dispatchEvent(clickEvent);
            } catch (err) {
                $rootScope.enableLog ? $log.error($rootScope.UUID + ":transformFileDownload - Failed") :'';
            }
        }

        var wishlistService = {};

        var isAuth = function() {
            if (AuthService.isAuthenticated()) {
                return "auth";
            } else {
                return "pub";
            }
        };

        // Interact with the RESTful API of the server.
        wishlistService.api = $resource(
            envService.read('SERVICE_DOMAIN') + "/api/v2/:isAuth/wishlist/add", {}, // param defaults
            {
                'addToWishlist': {
                    method: "POST",
                    params: {
                        isAuth: '@isAuth'
                    }
                },
                'saveWishlist': {
                    method: "POST",
                    url: envService.read('SERVICE_DOMAIN') + "/api/v2/:isAuth/wishlist/save", 
                    params: {
                        isAuth: '@isAuth'
                    }
                },
                'quickAddToWishlist': {
                    method: "POST",
                    url: envService.read('SERVICE_DOMAIN') + "/api/v2/:isAuth/wishlist/quick-add", 
                    params: {
                        isAuth: '@isAuth'
                    }
                },
                'downloadWishlist':{
                  method: "GET",
                  url: envService.read('SERVICE_DOMAIN') + "/api/v2/auth/admin/wishlist/download-wishlist", 
                  timeout: 300000,
                  transformResponse: transformFileDownload
                },
                'getUserWishlist':{
                  method: "GET",
                  url: envService.read('SERVICE_DOMAIN') + "/api/v2/auth/wishlist/list", 
                  isArray: true
                },
                'getUserWishlistByProduct':{
                  method: "GET",
                  url: envService.read('SERVICE_DOMAIN')+ "/api/v2/auth/wishlist-product/list", 
                  isArray: true,
                  params: {
                    country: 'country'
                  }
                },
                'deleteWishlist':{
                  method: "POST",
                  url: envService.read('SERVICE_DOMAIN') + "/api/v2/auth/wishlist/delete", 
                  params: {
                    wishlistID: 'wishlistID'
                  }
                },
                'updateWishlist':{
                  method: "POST",
                  url: envService.read('SERVICE_DOMAIN') + "/api/v2/auth/wishlist/update", 
                  params: {
                    wishlistID: 'wishlistID',
                    subscription: 'subscription'
                  }
                },
                'updateSubscription':{
                  method: "POST",
                  url: envService.read('SERVICE_DOMAIN') + "/api/v2/auth/wishlist/product/update", 
                  params: {
                    productID: 'productID',
                    subscription: 'subscription'
                  }
                }
            }
        );

        wishlistService.addToWishlist = function(wishlist_info) {
            return wishlistService.api.addToWishlist({'isAuth': isAuth()}, wishlist_info);
        }

        wishlistService.quickAddToWishlist = function(wishlists) {
            return wishlistService.api.quickAddToWishlist({'isAuth': isAuth()}, wishlists);
        }

        wishlistService.saveWishlist = function(wishlists) {
            return wishlistService.api.saveWishlist({'isAuth': isAuth()}, wishlists);
        }

        wishlistService.downloadWishlist = function() {
            return wishlistService.api.downloadWishlist();
        }

        wishlistService.getUserWishlist = function() {
            return wishlistService.api.getUserWishlist();
        }

        wishlistService.getUserWishlistByProduct = function(country) {
            return wishlistService.api.getUserWishlistByProduct({
                'country' : country
            }, {});
        }

        wishlistService.deleteWishlist = function(wishlistID) {
            return wishlistService.api.deleteWishlist({
                'wishlistID' : wishlistID
            }, {});
        }

        wishlistService.updateWishlist = function(wishlistID, subscription) {
            return wishlistService.api.updateWishlist({
                'wishlistID' : wishlistID,
                'subscription' : subscription
            }, {});
        }

        wishlistService.updateSubscription = function(productID, subscription) {
            return wishlistService.api.updateSubscription({
                'productID' : productID,
                'subscription' : subscription
            }, {});
        }

        // Public API here
        return wishlistService;
    }]);

'use strict';

/**
 * @ngdoc service
 * @name coutureApp.CartService
 * @description
 * # CartService
 * Factory in the coutureApp.
 */
angular.module('coutureApp')
    .factory('CartService', ["$resource", "envService", "AuthService", "$rootScope", "localStorageService", function($resource, envService,  AuthService, $rootScope, localStorageService) {
        var cartService = {};

        var isAuth = function() {
            if (AuthService.isAuthenticated()) {
                return "auth";
            } else {
                return "pub";
            }
        };

        var getCartCallback = function(resp) {

        };

        // Interact with the RESTful API of the server.
        cartService.api = $resource(
            envService.read('SERVICE_DOMAIN') + "/api",
            {}, // param defaults
            {
                'getCart': {
                    method: "GET",
                    url: envService.read('SERVICE_DOMAIN') + "/api/v2/auth/cart/list",
                    params: {
                      country: '@country'
                    },
                    isArray: true,
                    transformResponse: function(data, header) {
                      return JSON.parse(data);
                    }
                },
                'addCart': {
                    method: "POST",
                    url: envService.read('SERVICE_DOMAIN') + "/api/v2/auth/cart/add"
                },
                'deleteCart': {
                    method: "DELETE",
                    url: envService.read('SERVICE_DOMAIN') + "/api/v2/auth/cart/delete/:cartID"
                }
            });

        cartService.getCart = function() {
            if (isAuth() === 'auth') {
              return cartService.api.getCart({}, {'country' : $rootScope.geoLocation.country}, getCartCallback);
            }
        };

        cartService.addCart = function(cartDetails) {
          if (isAuth() == 'auth'){
            moment.tz.setDefault($rootScope.currentTimezone);
            let startDateOnly = moment(Number(cartDetails.startDate)).format("YYYYMMDD");
            let returnDateOnly = moment(Number(cartDetails.returnDate)).format("YYYYMMDD");
            return cartService.api.addCart({}, {
              'cartID': cartDetails.cartID,
              'productID': cartDetails.productID,
              'size': cartDetails.size,
              'startDate': cartDetails.startDate,
              'returnDate': cartDetails.returnDate,
              'startDateOnly': startDateOnly,
              'returnDateOnly': returnDateOnly,
              'transactionType': cartDetails.transactionType,
              'itemCondition': cartDetails.itemCondition,
              'bundleID': cartDetails.bundleID,
              'country': cartDetails.country
            });
          }else{
            return;
          }
        };

        cartService.deleteCart = function(cartID) {
          if (isAuth() == 'auth'){
            return cartService.api.deleteCart({ cartID });
          }else{
            return
          }
        };

  
        cartService.captureAddToCart = function(productObj, rental){
          
          if(!productObj.category){
            return;
          }

          let currentUser = localStorageService.get('user');
          let geoLocation = $rootScope.geoLocation;//localStorageService.get('geoLocation');
          let sessionCurrency = geoLocation ? geoLocation.currency : "HKD";
          let sessionCountry = geoLocation ? geoLocation.country : "HK";
          let cartID = rental ? (rental.cartID ? rental.cartID : productObj.id) : productObj.id;

          dataLayer.push({ ecommerce: null });  
          dataLayer.push({
              "environment" : envService.environment === "production" ? "prod" : "dev",
              "currentUserID" : currentUser ? currentUser.userid : "guest",
              "currentUserName" : currentUser ? currentUser.firstName + " " + currentUser.lastName : "guest",
              "currentUserEmail" : currentUser ? currentUser.email : "guest",
              "currency": sessionCurrency ? sessionCurrency : "HKD",
              "masterID": cartID,
              "size": rental ? rental.size : "no-size-defined",
              "country": sessionCountry ? sessionCountry : "HK",
              "color": productObj ? productObj.color : "Multicolor",
              "subCategory": productObj ? (productObj.subCategory ? productObj.subCategory.name : productObj.category)  : productObj.category,
              event: "add_to_cart",
              ecommerce: {
                items: [{
                  item_name: productObj.productLine,       
                  item_id: productObj.id,
                  price: productObj.price,
                  item_brand: productObj.brand,
                  item_category: productObj.category.name,
                }]}
          });
          fbq('track', 'AddToCart', 
          {
            content_ids: [
              productObj.id
            ], 
            content_name: productObj.productLine,
            content_type: "product",
            contents: [{'id': productObj.id, 'quantity': 1}],
            currency: sessionCurrency ? sessionCurrency : "HKD",
            value: productObj.price
          });
        };

        // Public API here
        return cartService;
    }]);

'use strict';

/**
 * @ngdoc service
 * @name coutureApp.CommentService
 * @description
 * # CommentService
 * Factory in the coutureApp.
 */
angular.module('coutureApp')
  .factory('CommentService', ["$resource", "envService", "AuthService", function ($resource, envService, AuthService) {
    var commentService = {};

    var categoryLabel = {'generalKey':'General','sizeKey':'Size, Fit & Condition','designerKey':'Designer'};

    var isAuth = function() {
      if(AuthService.isAuthenticated()) {
        return "auth";
      } else {
        return "pub";
      }
    };

    // Interact with the RESTful API of the server.
    commentService.api = $resource(
      envService.read('SERVICE_DOMAIN') + "/api/",
      {}, // param defaults
      {
        'create' : { method: "POST",
          url: envService.read('SERVICE_DOMAIN') + "/api/auth/questions/add/:id",
          params: {id : '@id'},
          isArray : false
        },
        'getList' : { method: "GET",
          url: envService.read('SERVICE_DOMAIN') + "/api/pub/comments/get/:id",
          params: {id : '@id'},
          isArray : false
        },
        'getAllListing' : { method: "GET",
          url: envService.read('SERVICE_DOMAIN') + "/api/admin/listing/get",
          isArray : true
        }
      }
    );

    commentService.getList = function(id) {
        return commentService.api.getList({'id' : id}, {});
    };

    commentService.create = function(id,comment_details) {
        return commentService.api.create({'id' : id} , comment_details);
    };


    commentService.getAllListing = function(){
      return commentService.api.getAllListing();
    }

    // Public API here
    return commentService;
  }]);

'use strict';

/**
 * @ngdoc service
 * @name coutureApp.ProductService
 * @description
 * # ProductService
 * Factory in the coutureApp.
 */
angular.module('coutureApp')
  .factory('ProductService', ["$resource", "envService", "AuthService", function ($resource, envService, AuthService) {
    var productService = {};

    var isAuth = function() {
      if(AuthService.isAuthenticated()) {
        return "auth";
      } else {
        return "pub";
      }
    };

    var transformTotalRecordCount = function(data, header, status){
      // To be removed once server response is fixed
      data = angular.fromJson(data);
      var searchResult = {'totalRecordCount':header()["x-total-count"],'totalPageCount':header()["x-total-page"]};
      data.reasons ? '' : data.push({searchResult});
      return data;
    }

    // Interact with the RESTful API of the server.
    productService.api = $resource(
      envService.read('SERVICE_DOMAIN') + "/api/",
      {}, // param defaults
      {
        'deleteChildProduct' : { method: "GET",
          url: envService.read('SERVICE_DOMAIN') + "/api/auth/product/item/delete/:childID",
          params: {id : '@childID'}
        },
        'getChildProducts' : { method: "GET",
          url: envService.read('SERVICE_DOMAIN') + "/api/auth/product/item/:productID",
          params: {id : '@productID'},
          isArray : true
        },
        'deleteProduct' : { method: "GET",
          url: envService.read('SERVICE_DOMAIN') + "/api/auth/product/item/delete/:productID",
          params: {id : '@productID'}
        },
        'addProductWithSize' : { method: "POST",
          url: envService.read('SERVICE_DOMAIN') + "/api/auth/product/item/add/:id?size=:size&quantity=:quantity&condition=:condition",
          params: {
            id : '@productID',
            size:'size',
            quantity:'quantity',
            condition: 'condition'
          }
        },
        'removeProductWithSize' : { method: "POST",
          url: envService.read('SERVICE_DOMAIN') + "/api/auth/product/item/reduce/:id?size=:size&quantity=:quantity",
          params: {id : '@productID',size:'size',quantity:'quantity'}
        },
        'getProductWithSize' : { method: "GET",
          url: envService.read('SERVICE_DOMAIN') + "/api/auth/product/item/:id",
          params: {id : '@productID'}
        },
        'updateUnlinkProducts' : { method: "GET",
          url: envService.read('SERVICE_DOMAIN') + "/api/auth/product/unlink/:id",
          params: {id : '@productID'}
        },
        'updateLinkProducts' : { method: "GET",
          url: envService.read('SERVICE_DOMAIN') + "/api/auth/product/link/:A_id/:B_id",
          params: {A_id : '@productA_id',B_id : '@productB_id'},
          isArray : false
        },
        'getAlsoAvailableProducts' : { method: "GET",
          url: envService.read('SERVICE_DOMAIN') + "/api/auth/product/also-available/:productID",
          params: {id : '@productID'},
          isArray : true
        },
        'getAllProductListing' : { 
          method: "GET",
          url: envService.read('SERVICE_DOMAIN') + "/api/admin/listing/get",
          isArray : true
        },
        'getAllProductListingV2' : { 
          method: "GET",
          url: envService.read('SERVICE_DOMAIN')+ "/api/v2/auth/admin/listing/get",
          isArray : true,
          transformResponse: transformTotalRecordCount
        },
        'getAllRentalListing' : { method: "GET",
          url: envService.read('SERVICE_DOMAIN') + "/api/auth/admin/rental/get",
          isArray : true
        },
        'getAllRentalListingV2' : { method: "GET",
          url: envService.read('SERVICE_DOMAIN') + "/api/v2/transaction/auth/admin/list",
          isArray : true,
          transformResponse: transformTotalRecordCount
        },
        'updateProductStatus_FailedDeliver' : { method: "GET",
          url: envService.read('SERVICE_DOMAIN') + "/api/auth/admin/rental/:rentalID/delivery/fail",
          params: {id : '@rentalID'},
          isArray : false
        },
        'updateProductStatus_ApproveRental' : { method: "GET",
          url: envService.read('SERVICE_DOMAIN') + "/api/auth/admin/rental/:rentalID/confirm",
          params: {id : '@rentalID'},
          isArray : false
        },
        'updateProductStatus_FailedInspection' : { method: "GET",
          url: envService.read('SERVICE_DOMAIN') + "/api/auth/admin/rental/:rentalID/inspection/fail",
          params: {id : '@rentalID'},
          isArray : false
        },
        'updateProductItem' : { method: "POST",
          url: envService.read('SERVICE_DOMAIN') + "/api/v2/auth/product/item/update/:productID",
          params: {id : '@productID'}
        },
      }
    );
    productService.addProductWithSize = function(productID,size,quantity, condition) {

        return productService.api.addProductWithSize({
            'id' : productID,
            'size': size,
            "quantity": quantity,
            "condition": condition
        }, {});
    };
    productService.removeProductWithSize = function(productID,size,quantity) {

        return productService.api.removeProductWithSize({
            'id' : productID,
            'size': size,
            "quantity": quantity
        }, {});
    };
    productService.deleteChildProduct = function(childID) {
        return productService.api.deleteChildProduct({'childID' : childID}, {});
    };
    productService.getChildProductList = function(productID) {
        return productService.api.getChildProducts({'productID' : productID}, {});
    };

    productService.deleteProduct = function(productID) {
        return productService.api.deleteProduct({'productID' : productID}, {});
    };

    productService.getProductWithSize = function(productID) {
        return productService.api.getProductWithSize({'productID' : productID}, {});
    };

    productService.updateUnlinkProducts = function(productID) {
        return productService.api.updateUnlinkProducts({'id' : productID}, {});
    };

    productService.updateLinkProducts = function(productID_A, productID_B) {
        return productService.api.updateLinkProducts({'A_id' : productID_A,'B_id' : productID_B}, {});
    };

    productService.getAlsoAvailableProducts = function(productID) {
        return productService.api.getAlsoAvailableProducts({'productID' : productID}, {});
    };

    productService.getAllProductListingV2 = function(filters){
      return productService.api.getAllProductListingV2(filters);
    };

    productService.getAllProductListing = function(){
      return productService.api.getAllProductListing();
    };

    productService.getAllRentalListing = function(){
      return productService.api.getAllRentalListing();
    };

    productService.getAllRentalListingV2 = function(filters){
      return productService.api.getAllRentalListingV2(filters);
    };

    productService.updateProductStatus_FailedDeliver = function(rentalID) {
        return productService.api.updateProductStatus_FailedDeliver({'rentalID' : rentalID}, {});
    };

    productService.updateProductStatus_ApproveRental = function(rentalID) {
        return productService.api.updateProductStatus_ApproveRental({'rentalID' : rentalID}, {});
    };

    productService.updateProductStatus_FailedInspection = function(rentalID) {
        return productService.api.updateProductStatus_FailedInspection({'rentalID' : rentalID}, {});
    };

    productService.updateProductItem = function(productID, productItems) {
        return productService.api.updateProductItem({'productID' : productID}, productItems);
    };


    // Public API here
    return productService;
  }]);

'use strict';

/**
 * @ngdoc service
 * @name coutureApp.UploadService
 * @description
 * # UploadService
 * Factory in the coutureApp.
 */
 angular.module('coutureApp')
 .factory('UploadService', ["$q", "$log", "Upload", "ListingService", "Session", "envService", "$rootScope", "utilities", function ($q, $log, Upload, ListingService, Session, envService,$rootScope,utilities) {
  var uploadService = {};

    // Make the call to obtain credentials
    AWS.config.credentials.get(function(){
        // Credentials will be available when this function is called.
        var accessKeyId = AWS.config.credentials.accessKeyId;
        var secretAccessKey = AWS.config.credentials.secretAccessKey;
        var sessionToken = AWS.config.credentials.sessionToken;
    });

    var s3 = new AWS.S3({
      apiVersion: '2006-03-01',
      region: envService.read('IMG_UPLOAD_S3_REGION'),
      //endpoint: 'https://cc-listing-img.s3.amazonaws.com',
      params: {Bucket: envService.read('IMG_UPLOAD_S3_BUCKET')}
    });

    uploadService.uploadPhotos = function(files, id) {
      var promises = [];
      var deferred = $q.defer();
      var uploadedPaths = [];

      if (files && files.length) {
        var arrayBuffer;

        files.forEach(function (file) {
          var innerDef = $q.defer();
          promises.push(innerDef.promise);
          var key = envService.read('IMG_UPLOAD_S3_PATH') + '/' + id + '/' + file.newName;
          //THIS SHOULD ONLY RESOLVED ONCE ALL PHOTOS HAS BEEN UPLOADED
          s3.upload({
            Key: key,
            Body: file,
            ContentType: file.type,
            CacheControl: 'max-age=31536000'
          }, function(err, data) {
            if (err) {
              innerDef.reject();
              $rootScope.enableLog ? $log.error($rootScope.UUID + ":UploadService:uploadPhotos - Error: " + err.message):'';
            } else {
              //THIS SHOULD ONLY RESOLVED ONCE ALL PHOTOS HAS BEEN UPLOADED
              $rootScope.enableLog ? $log.info($rootScope.UUID + ":UploadService:uploadPhotos - Successfully uploaded photo " + file.name +" (" +  file.newName + ")"):'';
              uploadedPaths.push({FILENAME:file.newName,PATH:key});
              innerDef.resolve();
            }
          });
        });
      }
      $q.all(promises).then(function() {
        deferred.resolve(uploadedPaths);
      },function(){
        deferred.reject('Upload error');
      })
      return deferred.promise;
    }

    uploadService.uploadProfileImg = function(file) {
      var promises = [];
      var deferred = $q.defer();
      var uploadedPaths = [];

      if (file) {
        var innerDef = $q.defer();
        promises.push(innerDef.promise);
        var hexValue = file["$ngfBlobUrl"] ? file["$ngfBlobUrl"] : file['_url'];
        var hash = asmCrypto.SHA256.hex(hexValue).substr(0,30);
        var filename = file.name ? file.name : file.path;
        var key = envService.read('IMG_UPLOAD_S3_PATH') + '/profile/' + hash + '.' + filename.split('.').pop();
        s3.upload({
          Key: key,
          Body: file,
          ContentType: file.type,
          CacheControl: 'max-age=31536000'
        }, function(err, data) {
          if (err) {
            innerDef.reject();
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":UploadService:uploadProfileImg - Error: " + err.message):'';
          } else {
            //THIS SHOULD ONLY RESOLVED ONCE ALL PHOTOS HAS BEEN UPLOADED
            $rootScope.enableLog ? $log.info($rootScope.UUID + ":UploadService:uploadProfileImg - Successfully uploaded profile image " + file.name):'';
            uploadedPaths.push({FILENAME:file.name,PATH:key});
            innerDef.resolve();
          }
        });
      }
      $q.all(promises).then(function() {
        deferred.resolve(uploadedPaths);
      },function(){
        deferred.reject('Upload error');
      })
      return deferred.promise;
    }

    /**
     * @param  {Blob[]} files Array of selected files
     * @param  {string} id User Id returned from {@link ListingService#create}
     * @return {Promise}
     */
    uploadService.uploadProfileImgsWithPaths = function(files, userid) {
      var deferred = $q.defer();

      this.uploadProfileImg(files[0]).then( function (paths) {
        // Call ListingService to update image paths
        var req = {
            id: userid,
            picturesPath:  paths.map(photo => photo.PATH)
        };

        var tt = ListingService.addImagePaths(req).then(
          function(res) {
            //RETURN THE PAIRED IMAGE KEY AND PATH
            deferred.resolve(paths);
          },
          function(err){
            $rootScope.enableLog ? $log.info($rootScope.UUID + ":UploadService:uploadProfileImgsWithPaths - Error: " + JSON.stringify(err)):'';
            deferred.reject(err);
          }
        )
      },function(err){
        deferred.reject(err)
      });
      return deferred.promise;
    };


    /**
     * @param  {Blob[]} files Array of selected files
     * @param  {string} id Product Id returned from {@link ListingService#create}
     * @return {Promise}
     */
    uploadService.uploadPhotosWithPaths = function(files, id) {
      var deferred = $q.defer();

      this.uploadPhotos(files, id).then( function (paths) {
        // Call ListingService to update image paths

        //REORDER THE PHOTO AS PER THE ARRAY ORDER, WHICH SHOULD ALIGN WITH THE SCREEN
        var newReOrderedPictures = [];
        files.forEach(function(pic,index){
          newReOrderedPictures.push(paths.filter(function(p){ return p.FILENAME == pic.newName})[0].PATH);
        })

        var req = {
            productId: id,
            picturesPath:  newReOrderedPictures
        };

        var tt = ListingService.addImagePaths(req).then(
          function(res) {
            //RETURN THE PAIRED IMAGE KEY AND PATH
            deferred.resolve(paths);
          },
          function(err){
            $rootScope.enableLog ? $log.info($rootScope.UUID + ":UploadService:uploadPhotosWithPaths - Error: " + JSON.stringify(err)):'';
            deferred.reject(err);
          }
        )
      },function(err){
        deferred.reject(err)
      });
      return deferred.promise;
    };

    uploadService.uploadProfileBanner = function(file) {
      var promises = [];
      var deferred = $q.defer();
      var uploadedPaths = [];

      if (file) {
        var innerDef = $q.defer();
        promises.push(innerDef.promise);
        var hexValue = file["$ngfBlobUrl"] ? file["$ngfBlobUrl"] : file['_url'];
        var hash = asmCrypto.SHA256.hex(hexValue).substr(0,30);
        var filename = file.name ? file.name : file.path;
        var key = envService.read('IMG_UPLOAD_S3_PATH') + '/profile/banner/' + hash + '.' + filename.split('.').pop();
        s3.upload({
          Key: key,
          Body: file,
          ContentType: file.type,
          CacheControl: 'max-age=31536000'
        }, function(err, data) {
          if (err) {
            innerDef.reject();
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":UploadService:uploadProfileBanner - Error: " + err.message):'';
          } else {
            //THIS SHOULD ONLY RESOLVED ONCE ALL PHOTOS HAS BEEN UPLOADED
            $rootScope.enableLog ? $log.info($rootScope.UUID + ":UploadService:uploadProfileBanner - Successfully uploaded profile image " + file.name):'';
            uploadedPaths.push({FILENAME:file.name,PATH:key});
            innerDef.resolve();
          }
        });
      }
      
      $q.all(promises).then(function() {
        deferred.resolve(uploadedPaths);
      },function(){
        deferred.reject('Upload error');
      })
      return deferred.promise;
    }

      // Public API here
      return uploadService;
    }]);

'use strict';

/**
 * @ngdoc service
 * @name coutureApp.LocaleService
 * @description
 * # Session
 * Service in the coutureApp.  Used to keep track of current locale and provide the service to change the locale
 */
angular.module('coutureApp')
  .service('LocaleService', ["$translate", function($translate) { //https://angular-translate.github.io/

    this.getLanguagesList = function(){
      var languageList = [];
      for (var i = 0,keyArray = $translate.getAvailableLanguageKeys(); i < keyArray.length; i++) {
        languageList.push({id:keyArray[i],value:"GENERAL.LABEL." + keyArray[i].toUpperCase()});
      }
      return languageList;
    };

    this.getLanguage = function(){
      return $translate.use();
    };

    this.updateLanguage = function(lang){
      $translate.use(lang);
    };

  }]);

'use strict';

/**
 * @ngdoc service
 * @name coutureApp.FavoriteService
 * @description
 * # FavoriteService
 * Factory in the coutureApp.
 */
 angular.module('coutureApp')
 .factory('FavoriteService', ["$resource", "envService", function ($resource, envService) {

  var favService = {};

    // Interact with the RESTful API of the server.
    favService.api = $resource(
      envService.read('SERVICE_DOMAIN') + "/api/auth/fav/get",
      {}, // param defaults
      {
        'getFav' : { method: "POST", isArray : true },
        'delFav' : { method: "GET", url: envService.read('SERVICE_DOMAIN') + "/api/auth/fav/delete/:id", params: {id : '@id'} },
        'addFav' : { method: "GET", url: envService.read('SERVICE_DOMAIN') + "/api/auth/fav/add/:id", params: {id : '@id'} }
      });

    favService.addFav = function(id) {
        return favService.api.addFav({'id' : id});
    };

    favService.delFav = function(id) {
        return favService.api.delFav({'id' : id});
    };

    favService.getFav = function() {
        return favService.api.getFav({},{},function(resp) {
            for(var i = 0; i < resp.length; i++) {
              resp[i].pictures.forEach(function(item) {
                  item._url = item.pathSrc === 'shopify' ? item.path : (envService.read('IMG_DOMAIN') + "/" + item.path);
              });
            }
        });
    };

    return favService;
  }]);

'use strict';

/**
 * @ngdoc service
 * @name coutureApp.ErrorHandler
 * @description
 * # ErrorHandler
 * Factory in the coutureApp.
 */
 angular.module('coutureApp')
 .factory('ErrorHandler', ["$filter", function ($filter) {
  var errorHandler = {};

  errorHandler.getErrorMessage = function(data) {
    var errMsg;
    if(data.code) {
      errMsg = $filter('translate')('GENERAL.ERROR.'+data.code) == 'GENERAL.ERROR.'.concat(data.code) ? data.message : $filter('translate')('GENERAL.ERROR.'+data.code);
      return errMsg;
    }else{
      return $filter('translate')('GENERAL.ERROR.SYS_ERR');
    }
  }

  errorHandler.resolveError = function(resp) {
    var errors = [];
    if(resp.data && resp.data.reasons && resp.data.reasons.length > 0) {
      for(var i = 0; i < resp.data.reasons.length; i++) {
        var msg = errorHandler.getErrorMessage(resp.data.reasons[i]);
        if(!msg && resp.data.reasons[i].message) {
          msg = resp.data.reasons[i].message;
        }
        errors.push(msg);
      }

    return errors;

    } else {
      return [$filter('translate')('GENERAL.ERROR.SYS_ERR')];
    }
  }

  errorHandler.resolveErrorToString = function(resp) {
    var errors = errorHandler.resolveError(resp);
    var str = '';
    if(errors && errors.length > 0) {
      for(var i = 0; i < errors.length; i++) {
        str = str + errors[i] + '  ';
      }
    }

    return str;
  }

  return errorHandler;
}]);

'use strict';

/**
 * @ngdoc factory
 * @name coutureApp.utilities
 * @description
 * # utilities
 * Factory in the coutureApp.
 */
 angular.module('coutureApp')
 .factory('utilities', ["$rootScope", "$log", "Session", "CartService", "ListingService", "AuthService", "RentalService", "RefDataService", "dateUtilities", "USER_ROLES", "$window", "CONFIG", "$q", "TransactionService", "$state", "envService", "$anchorScroll", "$http", function ($rootScope,$log,Session, CartService,ListingService,AuthService, RentalService,
   RefDataService,dateUtilities,USER_ROLES,$window,CONFIG, $q, TransactionService, $state, envService, $anchorScroll, $http) {

  var instance = {};

    instance.days = ["Sun","Mon","Tues","Wed","Thurs","Fri","Sat"];

    //FUNCTION - RETURN TRUE IF ITEM EXISTED IN CART
    //array = {product:product, selectedDate:date}
    instance.isItemInArray = function(item,array) {
      if (item && array){
        return array.filter(p=> p.product.id === item.id).length > 0
      }else{
        return false;
      }
    }

    /////////////////////////////////////////////
    //RETURN THE MATCHING SIZE OBJECT
    ////////////////////////////////////////////
    instance.returnMatchedSizeObject = function(category,sizeKey){

      var fullSize = RefDataService.getSizes();
      var sizeListOfCategory = null;
      var resultSizeObj = null;
      //CREATE FILTER SIZE BASED ON CATEGORY eg.Clothing , Accessories, Bags & Luggage, Shoes
      for (var item in fullSize) {
        if (fullSize[item].category.toUpperCase() === category.name.toUpperCase()) {
          sizeListOfCategory = angular.copy(fullSize[item].options);
          break;
        }
      }
      if (sizeListOfCategory){
        for (var sizeItemIndex in sizeListOfCategory){
          if (sizeListOfCategory[sizeItemIndex].KEY === sizeKey){
            resultSizeObj = sizeListOfCategory[sizeItemIndex];
            break;
          }
        }
      }

      return resultSizeObj;
    }


    /////////////////////////////////////////////
    //CHECK IF THE PRODUCT IS AVAIABLE FOR EDIT
    ////////////////////////////////////////////
    instance.isProductEditable = function(product){
      var isEditAllowed = true;

      isEditAllowed = instance.isProductOwner(product);

      //CANNOT EDIT INSTANT RENTAL
      if (product.instantRental){
        isEditAllowed = false;
      }

      //ADMIN CAN EDIT ANY PRODUCT REGARDS OF STATUS
      if (!isEditAllowed && AuthService.isAuthorized(USER_ROLES.admin)){
        isEditAllowed = true;
      }

      return isEditAllowed;
    }

    ///////////////////////////////////////////////////////////////
    // RETURN THE PHOTO ARRAY ACCORDING TO TIMESTAMP AS PART OF THE FILENAME
    // IF NO TIMESTAMP EXISTED IN THE FILENAME, SORT BY ID
    ///////////////////////////////////////////////////////////////
    instance.returnSortedPhotos = function(orgPhotoArray){

      var arrayNoTimestamp = [];
      var arrayWithTimestamp = [];
      // ONLY RETURN PHOTOS WITH TIMESTAMP IN THE FILENAME
      arrayWithTimestamp = orgPhotoArray.filter(function(item){return item.path.split('_').length>1;});
      // PHOTOS WITHOUT TIMESTAMP IN THE FILENAME
      arrayNoTimestamp = orgPhotoArray.filter(function(item){return item.path.split('_').length == 1;});
      // SORTING THE PHOTO BASED ON TIMESTAMP
      var timestampOrderedPhoto = reorderPhotoByTimestamp(arrayWithTimestamp);
      // SORTING THE PHOTO BASED ON ID
      var idOrderedPhoto = arrayNoTimestamp.sort(function(a, b){return b.id-a.id;});
      return timestampOrderedPhoto.concat(idOrderedPhoto);
    }

    /*******************************************************
    // SORT BY TIMESTAMP EMBEDDED IN THE FILENAME
    *******************************************************/
    function reorderPhotoByTimestamp(fileArray){
      return fileArray.sort(function(a, b){
          var x = a.path.split('_').pop();
          var y = b.path.split('_').pop();
          if (x < y) {return 1;}
          if (x > y) {return -1;}
          return 0;
      })
    }




    /////////////////////////////////////////////
    //CHECK IF OWNER OF PRODUCT
    ////////////////////////////////////////////
    instance.isProductOwner = function(product){
      var isOwner = false;

      if (Session.user){
        if (product.owner.id === Session.user.userid) {
          isOwner = true;
        }
      }
      return isOwner;
    }

    /////////////////////////////////////////////
    //CHECK IF THE PRODUCT IS AVAIABLE FOR RETNAL
    ////////////////////////////////////////////
    instance.isProductAvailableForRental = function(product){
      return true;
      // return product.canRental;
    }

    //FUNCTION - REPLACE ITEM IN ARRAY
    //rentalObj/rentalProductArray = {product:product, selectedDate:date}
    //AS WE ALLOW MORE THEN ONE ITEMS OF THE SAME SIZE/SAME PRODUCT ON THE CART
    //WE WILL ADD THE TIMESTAMP AS PART OF THE COMBINATION KEY TO UNIQUELY IDENTIFIY
    //THE PRODUCT. AS BE WILL DETERMINE WHICH EXACT PRODUCT ID WILL BE RENTING OUT
    //THEREFORE, IT IS NO NECESSARY TO HAVE THE EXACT PRODUCT-SUBITEM ID
    instance.replaceItemInArray = function(rentalObj,rentalProductArray) {

      var itemInCart = false;
      if (rentalObj && rentalProductArray && rentalObj.cartID){

        var itemIndex = rentalProductArray.findIndex(p=>p.cartID == rentalObj.cartID)
        if (itemIndex != -1){
          rentalProductArray.splice(itemIndex,1);
          rentalProductArray.splice(itemIndex,0,rentalObj);
          itemInCart = true;
        }
        !itemInCart ? rentalProductArray.push(rentalObj) : '';
      }
    }

    //FUNCTION - GET THE PENDIGN ITEM COUNT
    instance.getPendingCount = function(){
      $rootScope.cc = typeof $rootScope.cc != 'undefined' ? $rootScope.cc : $rootScope.cc = { cart: [] };
      $rootScope.cc.pendingCount != 'undefined' ? '' : $rootScope.cc = { pendingCount: [] };

      // START - RETRIEVE THE WHOLE PENDING LIST BUT MANUALLY REMOVE THE INSTANT RENTAL TO ENSURE THE COUNT IS CORRECT FOR DAY 1.
      RentalService.pendingApproval().$promise.then(function(resp) {
        var pendingItems = [];
        for (var i = 0; i < resp.length; i++) {
          if (!resp[i].instantRental) {
            pendingItems.push(resp[i]);
          }
        }
        $rootScope.cc.pendingCount = pendingItems.length;
      }, function(err) {
        $rootScope.enableLog ? $log.error($rootScope.UUID + ":utilities:getPendingCount - Error: " + JSON.stringify(err)):'';
      });

      // END - RETRIEVE THE WHOLE PENDING LIST BUT MANUALLY REMOVE THE INSTANT RENTAL TO ENSURE THE COUNT IS CORRECT FOR DAY 1.
    }

    instance.getTransactionCount = function(){
      $rootScope.cc.orderRequestsCount != 'undefined' ? '' : $rootScope.cc = { orderRequestsCount: [] };
      $rootScope.cc.dispatchingOrdersCount != 'undefined' ? '' : $rootScope.cc = { dispatchingOrdersCount: [] };
      $rootScope.cc.rentalOrdersCount != 'undefined' ? '' : $rootScope.cc = { rentalOrdersCount: [] };
      $rootScope.cc.buyOrdersCount != 'undefined' ? '' : $rootScope.cc = { buyOrdersCount: [] };
      $rootScope.cc.allOrdersCount != 'undefined' ? '' : $rootScope.cc = { allOrdersCount: [] };
      $rootScope.cc.awaitingDispatchCount != 'undefined' ? '' : $rootScope.cc = { awaitingDispatchCount: [] };

      // START - RETRIEVE THE WHOLE PENDING LIST BUT MANUALLY REMOVE THE INSTANT RENTAL TO ENSURE THE COUNT IS CORRECT FOR DAY 1.
      if($rootScope.isLogon){
        TransactionService.requestsCount().$promise.then(function(resp) {
          $rootScope.cc.orderRequestsCount = resp.orderRequestsCount;
          $rootScope.cc.dispatchingOrdersCount = resp.dispatchingOrdersCount;
          $rootScope.cc.rentalOrdersCount = resp.rentalOrdersCount;
          $rootScope.cc.buyOrdersCount = resp.buyOrdersCount;
          $rootScope.cc.allOrdersCount = resp.allOrdersCount;
          $rootScope.cc.awaitingDispatchCount = resp.awaitingDispatchCount;
        }, function(err) {
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":utilities:getTransactionCount - Error: " + JSON.stringify(err)):'';
        });
      }
      // END - RETRIEVE THE WHOLE PENDING LIST BUT MANUALLY REMOVE THE INSTANT RENTAL TO ENSURE THE COUNT IS CORRECT FOR DAY 1.
    }



    instance.getAvailableDatesWithSize= function(selectedSize,productDetails,selectedConditon){
      var country = productDetails.owner.merchantCountry ? productDetails.owner.merchantCountry : null;
      var destinationCountry = $rootScope.geoLocation.country;
      var sizeHasIR = false;
      if(productDetails == null) {
        return sizeHasIR;
      }

      if (productDetails.ir_items || productDetails.ir_items!=null){
        sizeHasIR = productDetails.ir_items.filter(function(item){ return item.size == selectedSize && item.itemCondition == selectedConditon}).length > 0 ? true : false;
      }

      //CHECK WHICH HUB IS THE ITEM AVAILABLE
      var datesByCountry = $rootScope.cc.allowedDates ? $rootScope.cc.allowedDates.DATES_BY_COUNTRY :null;
      if(sizeHasIR && destinationCountry && (productDetails.ir_itemsHub || productDetails.ir_itemsHub != null)){
        var isInHub = productDetails.ir_itemsHub.filter(d=>d.hub == destinationCountry && d.size == selectedSize);
        if(isInHub.length > 0){
          var allowedDatesByCountry = datesByCountry.filter(d=>d.country == destinationCountry);
          if (allowedDatesByCountry.length > 0) {
            return allowedDatesByCountry[0].INSTANT_RENTAL;
          }
        } else {
          if(productDetails.ir_itemsHub.length > 0){
            var itemHub = productDetails.ir_itemsHub.filter(d=>d.hub !== null && d.size == selectedSize);
            var nearestHub = itemHub.length > 0 ? itemHub[0].hub : destinationCountry;
            var allowedDatesByCountry = datesByCountry.filter(d=>d.country == nearestHub);
            if (allowedDatesByCountry.length > 0) {
              return allowedDatesByCountry[0].RENTAL_REQUEST;
            }
          }
        }
      }

      if(country != null && datesByCountry){
        var allowedDatesByCountry = datesByCountry.filter(d=>d.country == country);
        if (allowedDatesByCountry.length > 0) {
          return sizeHasIR ? allowedDatesByCountry[0].INSTANT_RENTAL : allowedDatesByCountry[0].RENTAL_REQUEST;
        }
      }
      return sizeHasIR ? $rootScope.cc.allowedDates.INSTANT_RENTAL : $rootScope.cc.allowedDates.RENTAL_REQUEST;
    }

    instance.getAvailableDatesWithSizeByMerchant = function(selectedSize,productDetails,selectedConditon){

      var destinationCountry = $rootScope.geoLocation.country;
      var sizeHasIR = false;
      if(productDetails == null) {
        return sizeHasIR;
      }

      if (productDetails.ir_items || productDetails.ir_items!=null){
        sizeHasIR = productDetails.ir_items.filter(function(item){ return item.size == selectedSize && item.itemCondition == selectedConditon}).length > 0 ? true : false;
      }

      var datesByCountry = $rootScope.cc.allowedDates ? $rootScope.cc.allowedDates.DATES_BY_COUNTRY :null;
      if(sizeHasIR && destinationCountry && (productDetails.ir_itemsHub || productDetails.ir_itemsHub != null)){
        var isInDestinationHub = productDetails.ir_itemsHub.filter(d=>d.hub == destinationCountry && d.size == selectedSize);
        var isInHub = productDetails.ir_itemsHub.filter(d=>d.hub != null && d.size == selectedSize);
        var instantCutOffTime = new Date(moment().format('YYYY-MM-DD') + " " + "11:00:00");
        var currentTime = new Date(moment().format('YYYY-MM-DD HH:mm:00'));
        var isAfterCutOff = moment(currentTime).isAfter(moment(instantCutOffTime));
        var isWeekend = moment(currentTime).day() == 6 || moment(currentTime).day() == 7;

        if(isInHub.length > 0){
          var allowedDatesByCountry = datesByCountry.filter(d=>d.country == destinationCountry);
          if (allowedDatesByCountry.length > 0) {
            if(isInDestinationHub.length > 0){
              var allowedIRDates = allowedDatesByCountry[0].INSTANT_RENTAL;
              return allowedIRDates;
            } else {
              if(!isAfterCutOff) {
                if(isWeekend) {
                  return allowedDatesByCountry[0].RENTAL_REQUEST;
                } else {
                  var itemHub = productDetails.ir_itemsHub.filter(d=>d.hub !== null && d.size == selectedSize);
                  var nearestHub = itemHub.length > 0 ? itemHub[0].hub : destinationCountry;
                  var allowedDatesByCountry = datesByCountry.filter(d=>d.country == nearestHub);
                  if (allowedDatesByCountry.length > 0) {
                    return allowedDatesByCountry[0].INSTANT_RENTAL;
                  }
                  //return allowedDatesByCountry[0].INSTANT_RENTAL;
                }
              } else {
                var itemHub = productDetails.ir_itemsHub.filter(d=>d.hub !== null && d.size == selectedSize);
                var nearestHub = itemHub.length > 0 ? itemHub[0].hub : destinationCountry;
                var allowedDatesByCountry = datesByCountry.filter(d=>d.country == nearestHub);
                if (allowedDatesByCountry.length > 0) {
                  return allowedDatesByCountry[0].RENTAL_REQUEST;
                }
              }
            }
          }
        } else {
          if(productDetails.ir_itemsHub.length > 0){
            var itemHub = productDetails.ir_itemsHub.filter(d=>d.hub !== null && d.size == selectedSize);
            var nearestHub = itemHub.length > 0 ? itemHub[0].hub : destinationCountry;
            var allowedDatesByCountry = datesByCountry.filter(d=>d.country == nearestHub);
            if (allowedDatesByCountry.length > 0) {
              return allowedDatesByCountry[0].RENTAL_REQUEST;
            }
          }
        }
      } 
      
    return sizeHasIR ? $rootScope.cc.allowedDates.DATES_BY_MERCHANT.INSTANT_RENTAL : $rootScope.cc.allowedDates.DATES_BY_MERCHANT.RENTAL_REQUEST;

    }

    instance.loadAllowedDatesByMerchant = function(merchantId, productId) {
      $rootScope.cc.allowedDates.DATES_BY_MERCHANT = {};
      RentalService.getAllowedDatesV4($rootScope.geoLocation.country, merchantId, productId).$promise.then(
        function(resp){
          var tempDate = {'INSTANT_RENTAL':null, 'RENTAL_REQUEST':null}
          var irDates =resp.ir.map(function(value) {
            return value;
          });
          var rrDates =resp.rr.map(function(value) {
            return value;
          });

          tempDate.INSTANT_RENTAL = irDates;
          tempDate.RENTAL_REQUEST = rrDates;
          $rootScope.cc.allowedDates.DATES_BY_MERCHANT = tempDate;

        },
        function(err){
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":utilities:getAvailableDatesWithSizeByMerchant - Error : " + JSON.stringify(err)):'';
        });
    }

    //deprecated
    instance.getAvailableDates= function(status){
      if (status==6){
        return $rootScope.cc.allowedDates.INSTANT_RENTAL;
      } else {
        return $rootScope.cc.allowedDates.RENTAL_REQUEST;
      }
    }

    instance.loadAllowedDatesFromServer = function(country){
      var sessionCountry = "HK";
      if($rootScope.geoLocation){
        sessionCountry = $rootScope.geoLocation.country ? $rootScope.geoLocation.country : "HK";
      }
      var destinationCountry = country ? country : sessionCountry;
      RentalService.getAllowedDatesV3(destinationCountry).$promise.then(
      function(resp){
        $rootScope.cc.allowedDates={'INSTANT_RENTAL':null, 'RENTAL_REQUEST':null, 'DATES_BY_COUNTRY': null}
        $rootScope.cc.allowedDates.INSTANT_RENTAL=resp.ir.map(function(value) {
          return value;
        });
        $rootScope.cc.allowedDates.RENTAL_REQUEST=resp.rr.map(function(value) {
          return value;
        });
        var leadTimePerCountry = [];
        var datesByCountry = resp.datesByCountry;
        if(datesByCountry){
          for (var i = 0; i < datesByCountry.length; i++) {
            var tempDate = {country: null, 'INSTANT_RENTAL':null, 'RENTAL_REQUEST':null}
            tempDate.country = datesByCountry[i].country;
            tempDate.INSTANT_RENTAL = datesByCountry[i].ir;
            tempDate.RENTAL_REQUEST = datesByCountry[i].rr;
            leadTimePerCountry.push(tempDate);
          }
          $rootScope.cc.allowedDates.DATES_BY_COUNTRY = leadTimePerCountry;
        }
      },
      function(err){
        $rootScope.enableLog ? $log.error($rootScope.UUID + ":utilities:loadAllowedDatesFromServer - Error : " + JSON.stringify(err)):'';
      });
    }

    //LOAD & UPDATE THE LOCAL CART SESSION WITH PRODUCT INFO.
    instance.loadLocalCartWithProductInfo = function(){
      var cartItems = Session.getCart();
      var loadedCartProducts = [];
      var promises = [];

      if (cartItems){
        cartItems.forEach(function(item){
          promises.push(ListingService.getListing(item.id).$promise.then(
            function(resp){
              var rental = { product: null, selectedDate: null };
              rental.product = resp;
              rental.price = {};
              rental.price.purchasePrice= rental.product.purchasePrice,
              rental.price.originalPrice= rental.product.price,
              rental.price.salePrice= rental.product.salePrice,
              rental.itemCondition= item.itemCondition,
              rental.cartID = item.cartID,
              rental.size = item.size,
              rental.transactionType = item.transactionType,
              rental.bundleID = item.bundleID,
              rental.selectedDate = {'START_DATE':cartItems.filter(p=>p.id == resp.id)[0].startDate, 'RETURN_DATE':cartItems.filter(p=>p.id == resp.id)[0].returnDate};
              $rootScope.cc.cart.push(rental);
          },function(err){
            //IGNORE ERROR
          }));
        });

        //UPDATE THE SESSION WITH THE LATEST PRODUCTS IN CART.
        $q.all(promises).then(function() {
          Session.emptyCart();
          $rootScope.cc.cart.forEach(function(item){
            var startDt = item.selectedDate.START_DATE;
            var endDt = item.selectedDate.RETURN_DATE;
            if(item.transactionType == CONFIG.TRANSACTION_TYPE_BUY){
              startDt = null;
              endDt = null;
            }
            var cartDetails = {
              cartID:item.cartID,
              productID:item.product.id,
              size:item.size,
              startDate: startDt,
              returnDate: endDt,
              transactionType: item.transactionType,
              price: {
                purchasePrice: item.price.purchasePrice,
                originalPrice: item.price.originalPrice,
                salePrice: item.price.salePrice
              },
              itemCondition: item.itemCondition,
              bundleID: item.bundleID,
              country: $rootScope.geoLocation.country
            };
            Session.updateCartV2(cartDetails);
          })
        });
      }
    }


    //FUNCTION - LOAD THE SAVED CART FROM REMOTE SERVER TO LOCAL
    //AND UPDATE/ADD ITEM FROM THE LOCAL CART TO REMOTE (IF localCart provided)
    instance.loadCartFromServer = function(localCart){


      if (AuthService.isAuthenticated()){

        CartService.getCart().$promise.then(
        function(resp){
        var remoteCartItems = resp;    //ORIGINAL CODE

          var loadedCartProducts = [];
          //instance.getPendingCount();
          instance.getTransactionCount();

          //UPDATE THE SAME PRODUCT IN REMOTE CART IF IT EXISTED IN THE LOCAL CART
          var isCartUpdateRequired = false;

          if (localCart && localCart.length > 0){
            Session.emptyCart();
            localCart.forEach((item) => {
              var itemIndexInCart;
              itemIndexInCart = remoteCartItems.findIndex(p=> p.cartID == item.cartID);
              if (itemIndexInCart != -1){ // identical local item found in remote
                //UPDATE THE REMOTE ITEM WITH THE LOCAL CART ITEM
                remoteCartItems.splice(itemIndexInCart,1);
                isCartUpdateRequired = true;
              }
              remoteCartItems.push(item);
            });
          }

          //REMOTE ANY POSSIBLE INVALID CART ITEMS

          remoteCartItems = remoteCartItems.filter(p=> p.id != null);

          //CONSTRUCT THE MERGED CART BASED ON THE UPDATED REMOTE CART.
          var promises = [];
          for (var index in remoteCartItems) {

            if (remoteCartItems[index]){
              //UPDATE THE ITEM IN CART (WHICH ONLY HAVE PRODUCT ID) WITH PRODUCT DETAILS

              //INITIALIZE THE RENTAL OBJECT
              var rental = {
                cartID:null,
                productID:null ,
                product: null,
                size:null,
                selectedDate: null,
                transactionType: null,
                price: {
                  purchasePrice: 0,
                  originalPrice: 0,
                  salePrice: 0
                },
                bundleID: null
              };
              rental.selectedDate = {'START_DATE':null, 'RETURN_DATE':null};

              rental.cartID = remoteCartItems[index].cartID;
              rental.productID = remoteCartItems[index].id;
              rental.size = remoteCartItems[index].size;
              rental.price.purchasePrice = remoteCartItems[index].purchasePrice;
              rental.price.originalPrice = remoteCartItems[index].originalPrice;
              rental.price.salePrice = remoteCartItems[index].salePrice;
              rental.bundleID = remoteCartItems[index].bundleID;

              if(remoteCartItems[index].transactionType == CONFIG.TRANSACTION_TYPE_RENT){

                //START DATE
                if (remoteCartItems[index] && remoteCartItems[index].cartStartDateOnly){  // if the item is really from remote cart, aka not in local before
                  moment.tz.setDefault($rootScope.currentTimezone);
                  rental.selectedDate.START_DATE = moment(remoteCartItems[index].cartStartDateOnly,"YYYYMMDD").valueOf();

                } else if (remoteCartItems[index] && remoteCartItems[index].cartStartDate){
                  rental.selectedDate.START_DATE = parseInt(remoteCartItems[index].cartStartDate);

                } else { // a local item, attribute startDate (not cartStartDate)
                  rental.selectedDate.START_DATE = parseInt(remoteCartItems[index].startDate);
                }

                //RETURN DATE
                if (remoteCartItems[index] && remoteCartItems[index].cartReturnDateOnly){  // if the item is really from remote cart, aka not in local before
                  moment.tz.setDefault($rootScope.currentTimezone);
                  rental.selectedDate.RETURN_DATE = moment(remoteCartItems[index].cartReturnDateOnly,"YYYYMMDD").valueOf();

                } else if (remoteCartItems[index] && remoteCartItems[index].cartReturnDate){
                  rental.selectedDate.RETURN_DATE = parseInt(remoteCartItems[index].cartReturnDate);

                } else { // a local item, attribute startDate (not cartReturnDate)
                  rental.selectedDate.RETURN_DATE = parseInt(remoteCartItems[index].returnDate);
                }

              }
              rental.transactionType = remoteCartItems[index].transactionType;
              rental.itemCondition = remoteCartItems[index].itemCondition;
              loadedCartProducts.push(rental);
            }

          }

          //CREATE A UNIQUE PRODUCT ID LIST
          var uniqueProductListToGetProductDetails = new Set();
          loadedCartProducts.forEach((item) => {
            uniqueProductListToGetProductDetails.add(item.productID)
          });

          //FILL IN THE LATEST PRODUCT DETAILS IN THE MERGED CART
          uniqueProductListToGetProductDetails.forEach((productID) => {

            promises.push(ListingService.getListing(productID).$promise.then(
              function(resp){
                loadedCartProducts.filter(p=> p.productID == resp.id).forEach((sameProduct) => {
                  sameProduct.product = resp;
                });
              },function(err){
                $rootScope.enableLog ? $log.error($rootScope.UUID + ":utilities:loadCartFromServer - Error remove invalid product from cart: " + JSON.stringify(err)):'';
              })
            );

          });

          //UPDATE THE REMOTE CART WITH THE MERGED AND SYNC CART DATA
          $q.all(promises).then(function() {

            if (isCartUpdateRequired){
              loadedCartProducts.forEach((product) => {
                var sessionCartDetails = {
                  cartID:product.cartID,
                  productID:product.productID,
                  size:product.size,
                  startDate: null,
                  returnDate: null,
                  transactionType: rental.transactionType,
                  price: {
                    purchasePrice: rental.product.purchasePrice,
                    originalPrice: rental.product.price,
                    salePrice: rental.product.salePrice
                  },
                  itemCondition: rental.itemCondition,
                  bundleID: product.bundleID,
                  country: $rootScope.geoLocation.country
                };

                var cartDetails = {
                  'cartID' : rental.cartID, 
                  'productID' : rental.product.id, 
                  'size' : rental.size, 
                  'startDate' : null, 
                  'returnDate' : null, 
                  'transactionType' : rental.transactionType, 
                  'itemCondition' : rental.itemCondition,
                  'bundleID': null,
                  'country': $rootScope.geoLocation.country
                };
                if(rental.transactionType == CONFIG.TRANSACTION_TYPE_BUY){
                  Session.updateCartV2(sessionCartDetails);
                  CartService.addCart(cartDetails);
                } else {
                  sessionCartDetails.startDate = rental.selectedDate.START_DATE;
                  sessionCartDetails.returnDate = rental.selectedDate.RETURN_DATE;
                  Session.updateCartV2(sessionCartDetails);

                  cartDetails.bundleID = rental.bundleID;
                  cartDetails.startDate = rental.selectedDate.START_DATE;
                  cartDetails.returnDate = rental.selectedDate.RETURN_DATE;
                  CartService.addCart(cartDetails);
                }
                //[START] CC-1082 for analytics
                CartService.captureAddToCart(product, rental);
                //[END] CC-1082 for analytics
              });
            };
          });

          $rootScope.cc.cart = loadedCartProducts;

        },
        function(err){
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":utilities:loadCartFromServer - Error : " + JSON.stringify(err)):'';
        });
      }
    }


    ///////////////////////////////////////////
    //RETURN THE PICK UP DATE
    //productDetails = {product:product, selectedDate:date}
    ///////////////////////////////////////////
    instance.getPickupDate = function(productDetails){

      if (productDetails === undefined || productDetails.selectedDate === null || productDetails.selectedDate === undefined) {
        return null;
      }else{
        return (new Date(productDetails.selectedDate));
      }
    }

    ///////////////////////////////////////////
    //RETURN THE RETURN DATE
    //productDetails = {product:product, selectedDate:date}
    ///////////////////////////////////////////
    instance.getReturnDate = function(productDetails){

      if (productDetails === undefined || productDetails.selectedDate === null || productDetails.selectedDate === undefined) {
        return null;
      }else{
        var returnDate = new Date(productDetails.selectedDate)
        return returnDate.setDate(productDetails.selectedDate.getDate() + 7);
      }
    };


    ///////////////////////////////////////////
    //RETURN STRING OF AM/PM TIME
    //date = Date()
    ///////////////////////////////////////////
    instance.formatAPMP = function(date){
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0'+minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    };


    ///////////////////////////////////////////////////////////
    // VALIDATE PASSWORD CHANGES
    ///////////////////////////////////////////////////////////
    instance.validatePassword = function(password,verifyPass){
      if (password || verifyPass){
        return ((password != verifyPass) || (verifyPass && verifyPass.length < 8)) ? true: false;
      }
      return false;
    }

    ///////////////////////////////////////////////////////////
    // VALIDATE USERNAME
    ///////////////////////////////////////////////////////////
    instance.isUsernameValid = function(username){
      var whitespace = new RegExp("\\s");
      if (!/^[a-zA-Z0-9!#$'*+-=?_|.@]{3,64}$/g.test(username)) {
        return false;
    }
      return true;
    }

    instance.getColorList = function(){
	    return [{
				'id': 0,'value': '#f00','name': 'Red','url':''},
	      {'id': 1,'value': 'green','name': 'Green','url':''},
	      {'id': 2,'value': 'blue','name': 'Blue','url':''},
	      {'id': 3,'value': '#000','name': 'Black','url':''},
	      {'id': 4,'value': '#fff','name': 'White','url':''},
	      {'id': 5,'value': 'brown','name': 'Brown','url':''},
	      {'id': 6,'value': 'beige','name': 'Neutral','url':''},
	      {'id': 7,'value': 'orange','name': 'Orange','url':''},
	      {'id': 8,'value': 'yellow','name': 'Yellow','url':''},
	      {'id': 9,'value': 'purple','name': 'Purple','url':''},
	      {'id': 10,'value': 'pink','name': 'Pink','url':''},
	      {'id': 11,'value': 'Metallic','name': 'Metallic','url':'/assets/images/metallic.png'},
				{'id': 12,'value': '#808080','name': 'Grey','url':''},
				{'id': 13,'value': 'Multicolor','name': 'Multicolor','url':'/assets/images/multicolor.png'}
	    ]
    }

    ///////////////////////////////////////////////////////////
    // GET BRAND NAME FOR A USER INPUT BRAND NAME
    //ADD SPECIAL LOGIC WHEN USER ENTER OTHER BRAND, THE req_listing WILL REMAINS '-- OTHER BRAND --'
    //BUT THE ACTUAL BRAND WILL BE STORED IN TAG. HOWEVER IT WILL NOT GOING TO DISPLAY ON SCREEN.
    //////////////////////////////////////////////////////////////////
    instance.getCustomBrandName = function(product){
      var rtnProductBrand = !!product ? product.brand: '';
      if (rtnProductBrand === '-- Other Brand --') {
        for (var i = 0; i < product.tags.length; i++) {
          if (product.tags[i].capitalName.includes("*^/")){
            var regEx = /-/gi
            rtnProductBrand = product.tags[i].capitalName.substring(3).replace(regEx," ");
            break;
          }
        }
      }
      return rtnProductBrand;
    }

    instance.inViewPort = function(productID){
      var h1 = document.getElementById(productID);
      if(!h1){
        return false;
      }

      // Get it's position in the viewport
      var bounding = h1.getBoundingClientRect();

      if (
      	bounding.top >= 0 &&
      	bounding.left >= 0 &&
      	bounding.right <= (window.innerWidth || document.documentElement.clientWidth) &&
      	bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight)
      ) {
        return true;
      } else {
        return false;
      }
    }

    ////////////////////////////////////
    // DETECT IF DEVICE IS MOBILE
    ////////////////////////////////////
    instance.isMobileView = function(){
      return instance.findBootstrapEnvironment() == 'xs' || instance.findBootstrapEnvironment() == 'sm' ? true:false;
    }

    ////////////////////////////////////
    // DETECT THE SCREEN SIZE IS XS, SM, MD, LG
    // IT WILL RETURN ONE OF THE 4.
    ////////////////////////////////////
    instance.findBootstrapEnvironment = function() {
        var envs = ['xs', 'sm', 'md', 'lg'];

        var $el = $('<div>');
        $el.appendTo($('body'));

        for (var i = envs.length - 1; i >= 0; i--) {
            var env = envs[i];

            $el.addClass('hidden-'+env);
            if ($el.is(':hidden')) {
                $el.remove();
                return env;
            }
        }
    }


    //////////////////////////////////////////////////////////////
    // UPDATE THE USER OBJECT IN THE ROOTSCOPE AND SESSION
    //////////////////////////////////////////////////////////////
    instance.updateLocalUserProfile = function(newUserDetails) {
      //ONLY UPDATE THE MUTABLE PROPERTIES
      $rootScope.user.username = newUserDetails.username;
      $rootScope.user.email = newUserDetails.email;
      $rootScope.user.firstName = newUserDetails.firstName;
      $rootScope.user.lastName = newUserDetails.lastName;
      $rootScope.user.phone1 = newUserDetails.phone1;
      $rootScope.user.aboutMe = newUserDetails.aboutMe;
      $rootScope.user.enabled = newUserDetails.enabled;
      $rootScope.user.profileImg = newUserDetails.profileImg;
      $rootScope.user.australiaStoreEnabled = newUserDetails.australiaStoreEnabled;
      $rootScope.user.phoneCode = newUserDetails.phoneCode;
      $rootScope.user.dispatchType = newUserDetails.dispatchType;
      if (newUserDetails.profileBanner && newUserDetails.profileBanner.indexOf('https://') == -1){
        newUserDetails.profileBanner = envService.read('IMG_DOMAIN') + "/" + newUserDetails.profileBanner;
      }else if (newUserDetails.profileBanner && newUserDetails.profileBanner.indexOf('https://') != -1){
      }else{
        newUserDetails.profileBanner = null;
      }
      $rootScope.user.profileBanner = newUserDetails.profileBanner;
      $rootScope.user.storeApproved = newUserDetails.storeApproved;
      $rootScope.user.merchantCountry = newUserDetails.merchantCountry;
      $rootScope.user.hasPendingReturn = newUserDetails.withPendingReturnItems;
      Session.user = $rootScope.user;
    }

    /////////////////////////////////////////////////////////////
    //CREATE NEW FILENAME FOR THE SPECIFIC PHOTO
    /////////////////////////////////////////////////////////////
    instance.getNewPhotoFilename = function(file){
      var hexValue = file["$ngfBlobUrl"] ? file["$ngfBlobUrl"] : file['_url'];
      var hash = asmCrypto.SHA256.hex(hexValue).substr(0,30);
      var TempTS = new Date();
      var filename = file.name ? file.name : file.path;
      return hash + '.' + filename.split('.').pop();
    }

    /////////////////////////////////////////////////////////////
    //RETURN THE FIRST AVAILABLE RENTAL DATE BASED ON PRODUCT TYPE
    //INSTANT RENTAL (IR) OR REQUEST RENTAL (RR).
    /////////////////////////////////////////////////////////////
    instance.getAllowedStartDateForIntantRental = function(isInstantRental){
      if (isInstantRental){
        return $rootScope.cc.allowedDates.INSTANT_RENTAL[0];
      } else {
        return $rootScope.cc.allowedDates.RENTAL_REQUEST[0];
      }
    }

    //SORT SIZE IN ASC ORDER
    instance.sortSizeAsc = function sortSizeAsc(a,b){
      if (a.size > b.size)
          return -1;
      if (a.size < b.size)
          return 1;
      return 0;
    }

    instance.getColorDetails = function(color) {
      var colorData = this.getColorList();
      return colorData.filter(element => element.name.toUpperCase() === color.toUpperCase());
    }

    instance.prepareSearchFilters = function prepareSearchFilters(params) {
      return {
        owner:params.owner,
        brand: params.brand,
        category: params.category,
        priceMin: params.min,
        priceMax: params.max,
        rentalFeeMin: params.feeMin,
        rentalFeeMax: params.feeMax,
        color: params.color,
        rentStatus: params.status,
        sort: params.sort,
        size: params.size,
        discountRateMin: params.fdmin,
        discountRateMax: params.fdmax,
        page: params.page,
        tags: params.q,
        types: params.type
      };
    }

    instance.getPrettyUrl = function(productCategory, productSubCategory, productBrand, productLine) {
      var subCategory = productSubCategory ? productSubCategory.replace('_', '-') : '';
      var category = productCategory.toLowerCase() === 'bags_luggage' ? 'bags-and-luggage' : productCategory;
      var categoryUrl = productSubCategory ? category + '-' +  subCategory : category;

      var urlSlug = 'rent-' + categoryUrl + '-' + productBrand + (productLine ? '-' + productLine : '');
      urlSlug = urlSlug.toLowerCase();
      //remove diacritics
      urlSlug = urlSlug.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      //trim
      urlSlug = urlSlug.replace(/^\s+|\s+$/g, '');
      //remove invalid chars
      urlSlug = urlSlug.replace(/[^a-z0-9 -]/g, '');
      //collapse whitespace and replace by -
      urlSlug = urlSlug.replace(/\s+/g, '-');
      //collapse dashes
      urlSlug = urlSlug.replace(/-+/g, '-');
      return urlSlug;
    }


    instance.capitalizeFirstLetter = function(word){
      if(word){
        if(word.length > 1){
          return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        }
        return word.toUpperCase();
      } else {
        return "";
      }
    }

    instance.isShowMainRegion = function(){
      var location = $rootScope.geoLocation;
      if(!location){
        return true;
      } else {
        if(location.country == CONFIG.COUNTRY_CURRENCY_CODE.SG.country_code || location.country == CONFIG.COUNTRY_CURRENCY_CODE.AU.country_code){
          return false;
        }
      }

      return true;
    }

    instance.isFunctionEnabled = function(){
      var location = $rootScope.geoLocation;
      if(!location){
        return true;
      } else {
        if(location.country == CONFIG.COUNTRY_CURRENCY_CODE.AU.country_code){
          return false;
        }
      }
      return true;
    }

    instance.getLocationPhoneCode = function(){
      return $rootScope.geoLocation.country == CONFIG.COUNTRY_CURRENCY_CODE.SG.country_code ? "SG +65" : "HK +852";
    }


    instance.showListing = function(productID, product) {
      var productBrand = instance.getCustomBrandName(product);
      var urlSlug = instance.getPrettyUrl(product.category.code, product.subCategory.code, productBrand, product.productLine);

      if(instance.isShowMainRegion()){
        $state.go('listing', {id: productID, urlSlug: urlSlug});
      } else {
        $state.go('listing-multi-region', {id: productID, country: $rootScope.geoLocation.country, urlSlug: urlSlug});
      }
    };

    instance.getMainPhoto = function(product){
      var mainPhoto = product.pictures.length > 0 ? (product.pictures.filter(function(p){return p.picOrder == 0})[0])._url : '';
      return mainPhoto;
    }

    instance.getDisplayPhoto = function(product, position){
      var photo = '';
      if(product.pictures.length > 0) {
        if(product.pictures.length > position) {
          photo = (product.pictures.filter(function(p){return p.picOrder == position})[0])._url;
        } else {
          photo = (product.pictures.filter(function(p){return p.picOrder == 0})[0])._url;
        }
      }

      return photo;
    }

    instance.base64toBlob = function (base64Data, contentType) {
      contentType = contentType || '';
      var sliceSize = 1024;
      var byteCharacters = atob(base64Data);
      var bytesLength = byteCharacters.length;
      var slicesCount = Math.ceil(bytesLength / sliceSize);
      var byteArrays = new Array(slicesCount);

      for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
          var begin = sliceIndex * sliceSize;
          var end = Math.min(begin + sliceSize, bytesLength);

          var bytes = new Array(end - begin);
          for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
              bytes[i] = byteCharacters[offset].charCodeAt(0);
          }
          byteArrays[sliceIndex] = new Uint8Array(bytes);
      }
      return new Blob(byteArrays, { type: contentType });
    }

    instance.getPhoneCountryFlag= function(phoneCode){
      var code = phoneCode ? phoneCode .substring(0,2) : null;

      if(code) {
        var flag = CONFIG.SVG_FLAG_SRC + code.toLowerCase() + '.svg';
        return flag;
      }
      return "";
    }

    instance.containsEmoji = function(text) {
      var unified_emoji_ranges = [
        '\ud83c[\udf00-\udfff]', // U+1F300 to U+1F3FF
        '\ud83d[\udc00-\ude4f]', // U+1F400 to U+1F64F
        '\ud83d[\ude80-\udeff]'  // U+1F680 to U+1F6FF
      ];

      var reg = new RegExp(unified_emoji_ranges.join('|'), 'g');
      return reg.test(text);
    }

    instance.getProfileBanner = function(bannerPath) {
      return bannerPath == null ? '/assets/images/image-upload-placeholder1.png' : bannerPath;
    }

    instance.goToTop = function() {
      setTimeout(function () {
        $anchorScroll();
      },300);
    }

    instance.ordinalSuffixOf = function(i) {
      var j = i % 10,
          k = i % 100;
      if (j == 1 && k != 11) {
          return i + "st";
      }
      if (j == 2 && k != 12) {
          return i + "nd";
      }
      if (j == 3 && k != 13) {
          return i + "rd";
      }
      return i + "th";
    }

    instance.loadWishlistFromServer = function() {
      return Session.getWishlistSession();
    }

    instance.getPayoutStatusFilter = function(){
      var resultList = [];
      resultList.push({id:'REQUESTED',title:'REQUESTED',value:'REQUESTED'});
      resultList.push({id:'APPROVED',title:'APPROVED',value:'APPROVED'});
      resultList.push({id:'DECLINED',title:'DECLINED',value:'DECLINED'});
      resultList.push({id:'SENT',title:'SENT',value:'SENT'});
      return resultList;
    }

    instance.getBrowser= function(){
      let userAgent = navigator.userAgent;
      let browserName;

        if(userAgent.match(/chrome|chromium|crios/i)){
          browserName = "chrome";
        }else if(userAgent.match(/firefox|fxios/i)){
          browserName = "firefox";
        }  else if(userAgent.match(/safari/i)){
          browserName = "safari";
        }else if(userAgent.match(/opr\//i)){
          browserName = "opera";
        } else if(userAgent.match(/edg/i)){
          browserName = "edge";
        }else{
          browserName="No browser detection";
        }
        return browserName;
    }

    instance.getDefaultTypeFilterParams = function(){
      /*if($rootScope.isLogon){
        var isAdmin = AuthService.isAuthorized(USER_ROLES.admin);
        if(isAdmin){
          return CONFIG.DEFAULT_SEARCH_TYPE_ADMIN;
        }
      }*/
      return CONFIG.DEFAULT_SEARCH_TYPE;
    }

    instance.generateUUID = function(){
      var result = '';
      var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
      var charactersLength = characters.length;
      for ( var i = 0; i < 8; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    }

    instance.goToSearch = function() {
      var search = {
        creditMin: CONFIG.CREDIT_MIN,
        creditMax: CONFIG.CREDIT_MAX,
        status: "bundles",
        sort: CONFIG.DEFAULT_SEARCH_SORT_ORDER,
        page: "1",
        type: CONFIG.DEFAULT_SEARCH_TYPE,
        country: $rootScope.geoLocation.country
      };
      if(instance.isShowMainRegion()){
        $state.go('search', search);
      } else {
        $state.go('search-multi-region', search);
      }
    }

    instance.getRentalDays = function(startDate, endDate){
      startDate = moment(Number(startDate)).startOf('day').valueOf();
      endDate = moment(Number(endDate)).startOf('day').valueOf();
      var dt_Start = new Date(moment(startDate).startOf('day').format('LLLL'));
      var dt_End = new Date(moment(endDate).startOf('day').format('LLLL'));

      var diffTime = Math.abs(dt_End - dt_Start);
      var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
      return diffDays + 1; //inclusive of start date
    }

    instance.getRentalWeeks = function(startDate, endDate){
      var diffDays = instance.getRentalDays(startDate, endDate); 
      var rentalWeeks = Math.trunc(diffDays / 7);
      return rentalWeeks;
    }

    instance.generateBundleID = function(product, startDate, returnDate, cartID) {
      var selectedRentalPeriod = startDate + "_" + returnDate;
      if(product.twoForOnePromo){
        if($rootScope.cc.cart.length > 0){
          var rentalCart = $rootScope.cc.cart.filter(c => c.transactionType === CONFIG.TRANSACTION_TYPE_RENT);
          var groupByBundleRentalDate = rentalCart.reduce(function(obj,item){
            var rentalDates = item.selectedDate.START_DATE + "_" + item.selectedDate.RETURN_DATE;
            obj[rentalDates] = obj[rentalDates] || [];
            obj[rentalDates].push(item);
            return obj;
          }, {});
        
          var cartByDates = Object.keys(groupByBundleRentalDate).map(function(key){
            return {rentalDates: key, items: groupByBundleRentalDate[key]};
          });

          var filterCartByRentalPeriod = cartByDates.filter(c => c.rentalDates === selectedRentalPeriod && c.cartID !== cartID);
          if(filterCartByRentalPeriod.length > 0){
            var groupByBundleID = filterCartByRentalPeriod[0].items.reduce(function(obj,item){
              obj[item.bundleID] = obj[item.bundleID] || [];
              obj[item.bundleID].push(item.cartID);
              return obj;
            }, {});
            var countByBundleID = Object.keys(groupByBundleID).map(function(key){
              return {bundleID: key, count: groupByBundleID[key].length};
            });
            var noPair = countByBundleID.filter(b => b.count <= 1 && b.bundleID !== 'null');
            if(noPair.length > 0) {
              return noPair[0].bundleID;
            } else {
              return instance.generateUUID();
            }
          } else {
            return instance.generateUUID();
          }

        } else {
          return instance.generateUUID();
        }
      }
      return null;
    }

    instance.generateSignUpReferralLink = function(referralCode) {
      return envService.read('REFERRAL_URL') + referralCode;
    }

    return instance;
  }]);

'use strict';

/**
 * @ngdoc factory
 * @name coutureApp.rentalStatus
 * @description
 * # utilities
 * Factory in the coutureApp.
 */
 angular.module('coutureApp')
 .factory('productStatus', ["$filter", function ($filter) {

  var instance = {};


    instance.rentalStatusMapping = {
        '1': "GENERAL.RENTAL_STATUS.REQUESTED",
        '2': "GENERAL.RENTAL_STATUS.ACCEPTED",
        '4': "GENERAL.RENTAL_STATUS.DECLINED",
        '8': "GENERAL.RENTAL_STATUS.RENTED",
        '16': "GENERAL.RENTAL_STATUS.EXPIRED",
        '32': "GENERAL.RENTAL_STATUS.FAILED_TO_DELIVER",
        '64': "GENERAL.RENTAL_STATUS.FAILED_INSPECTION",
        '101': "GENERAL.RENTAL_STATUS.RETURNED_PENDING_INSPECTION",
        '102': "GENERAL.RENTAL_STATUS.RETURNED_SERVICING",
        '103': "GENERAL.RENTAL_STATUS.COMPLETED",
        '104': "GENERAL.RENTAL_STATUS.RETURNED_DAMAGED",
        '105': "GENERAL.RENTAL_STATUS.RETURNED_PENDING_QUOTE",
        '106': "GENERAL.RENTAL_STATUS.RETURNED_REPAIRING",
        '107': "GENERAL.RENTAL_STATUS.RETURNED_REPAIRED",
        '108': "GENERAL.RENTAL_STATUS.DAMAGED_SOLD",
        '109': "GENERAL.RENTAL_STATUS.NOT_RETURN",
        '110': "GENERAL.RENTAL_STATUS.REFUNDED",
        '400': "GENERAL.RENTAL_STATUS.ACCEPTED_TO_INSPECT",
        '410': "GENERAL.RENTAL_STATUS.ACCEPTED_PASSED_INSPECTION",
        '420': "GENERAL.RENTAL_STATUS.RENTED_SHIPPED_TO_PLACE_2ND_PRE_AUTH",
        '120': "GENERAL.RENTAL_STATUS.RENTED_TO_SOLD",
    };

    instance.getRentalStatusDisplay = function(code){
      return $filter("translate")(instance.rentalStatusMapping[code]);
    };


    instance.listingStatusMapping = {
        '1': "GENERAL.LISTING_STATUS.PENDING",
        '4': "GENERAL.LISTING_STATUS.REJECTED",
        '6': "GENERAL.LISTING_STATUS.AVAILABLE_INSTANT",
        '8': "GENERAL.LISTING_STATUS.AVAILABLE",
        '16': "GENERAL.LISTING_STATUS.RENTED",
        '32': "GENERAL.LISTING_STATUS.DELETED",
        '64': "GENERAL.LISTING_STATUS.RESERVED",
        '101': "GENERAL.LISTING_STATUS.RETURNED_PENDING_INSPECTION",
        '102': "GENERAL.LISTING_STATUS.RETURNED_SERVICING",
        '104': "GENERAL.LISTING_STATUS.RETURNED_DAMAGED",
        '105': "GENERAL.LISTING_STATUS.RETURNED_PENDING_QUOTE",
        '106': "GENERAL.LISTING_STATUS.RETURNED_REPAIRING",
        '107': "GENERAL.LISTING_STATUS.RETURNED_REPAIRED",
        '108': "GENERAL.LISTING_STATUS.DAMAGED_SOLD",
        '109': "GENERAL.LISTING_STATUS.NOT_RETURN",
        '110': "GENERAL.RENTAL_STATUS.REFUNDED",
        '600': "GENERAL.RENTAL_STATUS.SOLD"
    };

    instance.getListingStatusDisplay = function(code){
      return $filter("translate")(instance.listingStatusMapping[code]);
    };

    instance.purchaseStatusMapping = {
        '1': "GENERAL.PURCHASE_STATUS.REQUESTED",
        '2': "GENERAL.PURCHASE_STATUS.ACCEPTED",
        '4': "GENERAL.PURCHASE_STATUS.DECLINED",
        '8': "GENERAL.PURCHASE_STATUS.SOLD",
        '16': "GENERAL.PURCHASE_STATUS.EXPIRED",
        '32': "GENERAL.PURCHASE_STATUS.FAILED_TO_DELIVER",
        '64': "GENERAL.PURCHASE_STATUS.FAILED_INSPECTION",
        '400': "GENERAL.PURCHASE_STATUS.ACCEPTED_TO_INSPECT",
        '410': "GENERAL.PURCHASE_STATUS.ACCEPTED_PASSED_INSPECTION",
        '601': "GENERAL.PURCHASE_STATUS.SOLD_SHIPPED"
    };

    instance.allStatusMapping = {
      '1': "GENERAL.RENTAL_STATUS.REQUESTED",
      '2': "GENERAL.RENTAL_STATUS.ACCEPTED",
      '4': "GENERAL.RENTAL_STATUS.DECLINED",
      '8': "GENERAL.RENTAL_STATUS.RENTED",
      '16': "GENERAL.RENTAL_STATUS.EXPIRED",
      '32': "GENERAL.RENTAL_STATUS.FAILED_TO_DELIVER",
      '64': "GENERAL.RENTAL_STATUS.FAILED_INSPECTION",
      '101': "GENERAL.RENTAL_STATUS.RETURNED_PENDING_INSPECTION",
      '102': "GENERAL.RENTAL_STATUS.RETURNED_SERVICING",
      '103': "GENERAL.RENTAL_STATUS.COMPLETED",
      '104': "GENERAL.RENTAL_STATUS.RETURNED_DAMAGED",
      '105': "GENERAL.RENTAL_STATUS.RETURNED_PENDING_QUOTE",
      '106': "GENERAL.RENTAL_STATUS.RETURNED_REPAIRING",
      '107': "GENERAL.RENTAL_STATUS.RETURNED_REPAIRED",
      '108': "GENERAL.RENTAL_STATUS.DAMAGED_SOLD",
      '109': "GENERAL.RENTAL_STATUS.NOT_RETURN",
      '110': "GENERAL.RENTAL_STATUS.REFUNDED",
      '400': "GENERAL.RENTAL_STATUS.ACCEPTED_TO_INSPECT",
      '410': "GENERAL.RENTAL_STATUS.ACCEPTED_PASSED_INSPECTION",
      '420': "GENERAL.RENTAL_STATUS.RENTED_SHIPPED_TO_PLACE_2ND_PRE_AUTH",
      '120': "GENERAL.RENTAL_STATUS.RENTED_TO_SOLD",
      '8': "GENERAL.PURCHASE_STATUS.SOLD",
      '601': "GENERAL.PURCHASE_STATUS.SOLD_SHIPPED"
  };

    instance.getPurchaseStatusDisplay = function(code){
      return $filter("translate")(instance.purchaseStatusMapping[code]);
    };

    instance.payoutStatusMapping = {
      'REQUESTED': "GENERAL.PAYOUT_STATUS.REQUESTED",
      'APPROVED': "GENERAL.PAYOUT_STATUS.APPROVED",
      'DECLINED': "GENERAL.RENTAL_STATUS.DECLINED",
      'SENT': "GENERAL.PAYOUT_STATUS.SENT",
    }

    instance.getPayoutStatus = function(code){
      return $filter("translate")(instance.payoutStatusMapping[code]);
    };


    return instance;
  }]);

'use strict';

/**
 * @ngdoc factory
 * @name coutureApp.priceUtilities
 * @description
 * # priceUtilities
 * Factory in the coutureApp.
 */
 angular.module('coutureApp')
 .factory('priceUtilities', ["CONFIG", "RentalService", "$log", "$rootScope", "$q", "$state", "$sce", function (CONFIG,RentalService,$log,$rootScope,$q,$state,$sce) {

  var instance = {};

  ///////////////////////////////////////////////////////////
  // GET CURRENCY
  ///////////////////////////////////////////////////////////
    instance.getCurrency = function() {
      if($rootScope.geoLocation.country == CONFIG.COUNTRY_CURRENCY_CODE.SG.country_code || $rootScope.geoLocation.country == CONFIG.COUNTRY_CURRENCY_CODE.AU.country_code){
        return $rootScope.geoLocation.country + "$";
      } 
      return CONFIG.DEFAULT_CURRENCY + "$";
    }

    /////////////////////////////////////////////
    //RETURN Equivalent Credit Value
    ////////////////////////////////////////////
    instance.returnEquivalentCreditValue= function(price){
      if (price <= 3520){
        return 1;
      } else if ( price > 3520 && price <=10560){
        return 3
      } else if ( price > 10560){
        return 5;
      }
    }
    ///////////////////////////////////////////////////////////
    // GET RENTAL PRICE
    ///////////////////////////////////////////////////////////
    instance.getRentalPrice = function(originalPrice, discountRate) {

      //TAG PRICE IS EQUAL TO ORIGINAL PRICE * DISCOUNT RATE
      //Weekly Rental Fee = 25% if Tag Price < $10K, otherwise 20%
      var tagPrice = discountRate > 0 ? originalPrice * (1-discountRate): originalPrice;
      var rentalPriceRatio = tagPrice < 10000 ? 0.25:0.2;
      return discountRate > 0 ? tagPrice * rentalPriceRatio : tagPrice * rentalPriceRatio;
    }

    ///////////////////////////////////////////////////////////
    // GET RENTAL PROTECTION FEE
    ///////////////////////////////////////////////////////////
    instance.getRentalProtectionFee = function(netTagPrice) {
      return (netTagPrice * 0.025)+ 100;
    }


    ///////////////////////////////////////////////////////////
    // CALCULATE EARNING
    ///////////////////////////////////////////////////////////
    instance.getEarning = function(periodFee) {
      return periodFee >0 ? periodFee*0.8 : 0;
    }

    ///////////////////////////////////////////////////////////
    // GET NON_RETURN FEE
    ///////////////////////////////////////////////////////////
    instance.getNonReturnFeeWithTagPrice = function(netTagPrice) {
      return netTagPrice * 0.25;
    }
    instance.getNonReturnFee = function(price,discountRate) {
      return (price * (1 - discountRate))* 0.25;
    }


    ///////////////////////////////////////////////////////////
    // GET DAMAGE DEPOSIT
    ///////////////////////////////////////////////////////////
    instance.getDamageDeposit = function(netTagPrice,discountRate) {
      return (netTagPrice * 0.8 * (1 - discountRate));
    }

    ///////////////////////////////////////////////////////////
    // GET THE DISCOUNT BETWEEN ORIGINAL AND TAG PRICE
    ///////////////////////////////////////////////////////////
    instance.setDiscount = function(originalPrice, tagPrice) {

      var discounted = 0;
      // if (originalPrice < tagPrice) {
      //   originalPrice = tagPrice;
      // }

      // if (originalPrice > 0 && tagPrice > 0 && (originalPrice > tagPrice)) {
        // CALCULATE THE DISCOUNT PRICE.
        discounted = ((originalPrice - tagPrice) / originalPrice);
      // } else {
      //   discounted = 0;
      // }

      return discounted;
   }

   ///////////////////////////////////////////////////////////
   // GET THE RENTAL PRICING FOR THE PROVIDED ARRAY OF PRODUCT WITH PROMOTION CODE
   ///////////////////////////////////////////////////////////
   instance.applyPromoToMultiProducts = function(productsArray,promoCode) {
     var deferred = $q.defer();
     var promises = [];

     //ONLY SENT PRODUCTS IF DATE IS PRESENTED
     var validProductsArray = productsArray.filter(p=> p.startDate && !isNaN(p.startDate))

     promises.push(RentalService.getCreditAndOtherFeesOnMultiProducts({
       'products':validProductsArray,
       'promo':promoCode, 
       'destinationCountry': $rootScope.geoLocation.country,
       'currency': $rootScope.geoLocation.currency,
       'exchangeRate': $rootScope.geoLocation.rate  
      }).$promise);
     $q.all(promises).then(function(allResp) {
       if (allResp[0].products.filter(p=> (p.promoCode === null && promoCode)).length > 0){
         //THE APPLIED PROMOTION CODE IS INVALID
         return deferred.reject(false);
       }else{
         return deferred.resolve(allResp[0]);
       }
     });
     return deferred.promise;
   }


   ///////////////////////////////////////////////////////////
   // APPLY THE DISCOUNT TO THE PRICING AND SAVE IT AS PART OF THE productsArray($rootScope.cc.cart)
   // THE RETURN OF THIS FUNCTION IF TRUE, IS THE SUMMARY PRICING. IF FALSE, JUST RETURN FALSE.
   ///////////////////////////////////////////////////////////
   instance.applyPromo = function(promoCode,productsArray) {

     var deferred = $q.defer();
     var promises = [];

     //ONLY SENT PRODUCTS IF DATE IS PRESENTED
     var validProductsArray = productsArray.filter(p=> p.product != null)

     //GET THE PROMOTION CODE, IF PROMOTION EXISTS APPLY IT TO THE PRICING
     //THE PROMOTION PRICING '_discountPricing' WILL BE SAVED AS A SECTION WITHIN THE SELECTEDPRODUCT
     if (validProductsArray != undefined && validProductsArray.length > 0 ){
       var tempProductArray = validProductsArray.map(p=> {return {
         'productId':p.product.id,
         'startDate': (p.selectedDate ? p.selectedDate.START_DATE : null),
         'endDate': (p.selectedDate ? p.selectedDate.RETURN_DATE : null),
         'transactionType':p.transactionType
        }});
       promises.push(instance.applyPromoToMultiProducts(tempProductArray,promoCode));
     }

     $q.all(promises).then(function(resp) {
       if (resp && resp.length > 0){
         resp[0].products.forEach(function(promotionPriceItem){
           $rootScope.enableLog ? $log.info($rootScope.UUID + ":menuBarsService:toggleSidebar - : " + JSON.stringify(promotionPriceItem)) : '';
           //ADD THE DISCOUNT AFTER APPLIED GIFT CARD/CODE AS A NEW SECTION
           productsArray.filter(p=>p.product.id == promotionPriceItem.productSummary.productId)[0].product._promoPrice = promotionPriceItem;
          //  productsArray.filter(p=>p.product.id == promotionPriceItem.productSummary.productId)[0].product._promoPrice._discountedPrice = promotionPriceItem.rentalOrderBreakdown.weeklyRentalFee;
           productsArray.filter(p=>p.product.id == promotionPriceItem.productSummary.productId)[0].product._promoPrice._discountedPrice = 8888;

           //INVALID PROMOTION CODE
           if (promoCode && promotionPriceItem.promoCode === null){
             return deferred.reject(false);
           }
         });
         return deferred.resolve(resp[0].order);
       }else{
         return deferred.resolve();
       }
     },function(err){
       return deferred.reject(false);
         $rootScope.enableLog ? $log.error($rootScope.UUID + ":menuBarsService:toggleSidebar - Error getRentalFeesWithPromoCode: " + JSON.stringify(err)) : '';
     });
     return deferred.promise;
   }








   ////////////////////////////////////////////////////////////////
   //CALCULATE AND SUM OF ALL PRODUCTS IN CART.
   ////////////////////////////////////////////////////////////////
   instance.sumOfProductsInCart = function () {
     var returnMap = new Map();

     //ONLY CALCULATE THE PRICING WHEN THE PRICING SECTION IS NOT EMPTY/UNDEFINED
     if ($rootScope.hasOwnProperty('cc') && $rootScope.cc.hasOwnProperty('cart') && $rootScope.cc.cart.map(p => p.product)[0] != undefined
       && $rootScope.cc.cart.map(p => p.product._promoPrice).filter(f => f == undefined).length == 0) {
    //  if ($rootScope.hasOwnProperty('cc') && $rootScope.cc.hasOwnProperty('cart') && $rootScope.cc.cart.map(p => p.product)[0] != undefined){

      //  var originalAmount = $rootScope.cc.cart.map(p => p.product._promoPrice.rentalOrderBreakdown.originalWeeklyRentalFee).reduce((total, fee) => total + fee);

       //DISCOUNTRATE < 1 THE DISCOUNT CODE APPLIED IS DISCOUNT IN %; > 0 IT IS A GIFT CARD WITH FIXED AMOUNT.
       var giftCardRate_Amount = $rootScope.cc.cart.map(p => p.product._promoPrice.promoDiscount ? p.product._promoPrice.promoDiscount : p.product._promoPrice.promoAmount).reduce(r => r)

       //Rental Credit
       returnMap.set('subTotalRentalCredit', $rootScope.cc.cart.map(p => p.product.credit).reduce((total, credit) => total + credit));

       //NO DISCOUNT ON PROTECTION FEE AND SHPPPING FEE
       returnMap.set('subTotalProtectionFee', $rootScope.cc.cart.map(p => p.product._promoPrice.protectionFee).reduce((total, fee) => total + fee));

       // CC-390 REMOVE SHIPPING FEE AND REPLACE WITH TBD IN SIDEBAR
       returnMap.set('subTotalShippingFee', $rootScope.cc.cart.map(p => p.product._promoPrice.shippingFee).reduce((total, fee) => total + fee));

       //FOR DISCOUNT RATE CODE - discount not supported in rental checkout
      //  if (giftCardRate_Amount < 1) {
      //    returnMap.set('subTotalRentalPrice', $rootScope.cc.cart.map(p => p.product._promoPrice.rentalOrderBreakdown.weeklyRentalFee).reduce((total, fee) => total + fee));
      //    returnMap.set('totalPrice', $rootScope.cc.cart.map(p => p.product._promoPrice.rentalOrderFee).reduce((total, fee) => total + fee));
      //  } else {
      //    //FOR GIFT CARD FIX AMOUNT - ONE TIME USE
      //    returnMap.set('subTotalRentalPrice', $rootScope.cc.cart.map(p => {
      //      if (giftCardRate_Amount == 0) {
      //        p.product._promoPrice._discountedPrice = p.product._promoPrice.rentalOrderBreakdown.originalWeeklyRentalFee;
      //      } else {
      //        p.product._promoPrice._discountedPrice = p.product._promoPrice.rentalOrderBreakdown.weeklyRentalFee;
      //        //ONE TIME USE GIFT CARD. SET REMAINS AMOUNT TO ZERO.
      //        giftCardRate_Amount = 0;
      //      }
      //      return p.product._promoPrice._discountedPrice;
      //    }).reduce((total, fee) => total + fee));
      //   //  returnMap.set('totalPrice', returnMap.get('subTotalRentalPrice') + returnMap.get('subTotalProtectionFee') + returnMap.get('subTotalShippingFee'));
      //  }
      //  returnMap.set('discountApplied', originalAmount - returnMap.get('subTotalRentalPrice'));
       returnMap.set('discountApplied', 0); // discount not supported in rental checkout
       returnMap.set('subTotalRentalPrice', 0);  // keep price as placeholder under credit system
       returnMap.set('totalPrice', returnMap.get('subTotalProtectionFee') + returnMap.get('subTotalShippingFee'));
     }
     return returnMap;
   }

   instance.currencyFormat = function(num) {
      if(!num) {
        return '$0';
      }

      var p = Math.round(num.toFixed(2)); //to handle calculated sale price
      //change toString to toFixed(2) if decimal place is needed
      return '$' + p.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
   }

   instance.getSubscriptionPlanDetails = function(subId){
    if (subId != null && $rootScope.credit != null && $rootScope.credit.pricing != null){
      return $rootScope.credit.pricing.find(p => p.id == Number(subId));
    }else{
      return null;
    }
  }

   instance.getDisplayPriceV2 = function(product) {
    return "book " + instance.getListingTagPrice(product);
   }

   instance.getDisplayPurchasePriceV2 = function(product) {
    var tagPrice = getTagPrice(product.price, product.discountRate);
     return "buy " + instance.getFormattedAmountByRate(tagPrice);
   }

   instance.getListingTagPrice = function(product) {
    var currency = $rootScope.geoLocation.currency ? $rootScope.geoLocation.currency : instance.getCurrency();
    var country = $rootScope.geoLocation.country ? $rootScope.geoLocation.country : self.product_currency;

    var lblCredit = product.credit > 1 ? " Credits" : " Credit";
    //var oneMthPlan = currency == CONFIG.COUNTRY_CURRENCY_CODE.SG.currency_code ? this.getSubscriptionPlanDetails(CONFIG.PLAN_SUBSCRIPTION_16) : this.getSubscriptionPlanDetails(CONFIG.PLAN_SUBSCRIPTION_3);
    //var basePrice = oneMthPlan ? oneMthPlan.oneCreditPrice : ( currency == CONFIG.COUNTRY_CURRENCY_CODE.SG.currency_code ? CONFIG.PLAN_SG_1_TIME_CREDIT_PRICE : CONFIG.PLAN_1_MTH_CREDIT_PRICE);
    var basePrice = currency == CONFIG.COUNTRY_CURRENCY_CODE.SG.currency_code ? CONFIG.PLAN_SG_1_TIME_CREDIT_PRICE : CONFIG.PLAN_1_MTH_CREDIT_PRICE;
    
    var targetPrice = basePrice;

    var creditDisplay = product.credit + lblCredit;

    if(currency == CONFIG.COUNTRY_CURRENCY_CODE.AU.currency_code){
      targetPrice = Math.round(basePrice * $rootScope.geoLocation.rate);
    } else {
      targetPrice = Math.round(basePrice);
    }
    
    var dollarDisplay = oneMthPlan ? country + this.currencyFormat(targetPrice * product.credit) : creditDisplay;
    if($rootScope.isLogon && $rootScope.credit.balance){
      var isMemberActive = false;
      if ($rootScope.credit.balance.expire !=null ){
        var expiryDate = new Date($rootScope.credit.balance.expire.substring(0,4),$rootScope.credit.balance.expire.substring(4,6)-1,$rootScope.credit.balance.expire.substring(6));
        var now = new Date();
        now.setMinutes(0);
        now.setSeconds(0);
        now.setMilliseconds(0);

        isMemberActive = now < expiryDate;
      }
      if($rootScope.credit.balance.available > 0){
        return creditDisplay;
      } 
      return isMemberActive ? creditDisplay : dollarDisplay;
    } 

    return dollarDisplay;

   }

   instance.calculateEarnings = function (credit) {
			//lowest plan
			var oneMthPlan = this.getSubscriptionPlanDetails(CONFIG.PLAN_SUBSCRIPTION_4);
			var creditPrice = oneMthPlan ? oneMthPlan.oneCreditPrice : CONFIG.PLAN_1_MTH_CREDIT_PRICE;
			var earnings = ((credit * creditPrice) * CONFIG.EARNING_PERCENTAGE).toFixed(2);
			return instance.currencyFormat(Math.round(earnings));
   }

   instance.calculateEarningsByCurrency = function (credit, country) {
			var creditPrice = this.getDiscountedCreditPrice(country);
			var earnings = ((credit * creditPrice) * CONFIG.EARNING_PERCENTAGE).toFixed(2);
			return country + "" + instance.currencyFormat(Math.round(earnings));
   }

   instance.getDiscountedCreditPrice = function (country){
    if(country == "SGD" || country == "SG"){
      return CONFIG.PLAN_SG_1_TIME_CREDIT_PRICE;
    }
    return CONFIG.PLAN_1_MTH_CREDIT_PRICE;
   }

   instance.getAmountByOriginalAmountAndCurrency = function (price, currency){
    var targetPrice = price;
    if((currency == "SGD" || currency == "SG") || (currency == "AUD" || currency == "AU")){
      targetPrice = Math.round(price * $rootScope.geoLocation.rate);
    } 
    
    return targetPrice;
   }

   instance.getAmountByRate = function (price){
    var targetPrice = price;
    if($rootScope.geoLocation.currency == CONFIG.COUNTRY_CURRENCY_CODE.SG.currency_code || $rootScope.geoLocation.currency == CONFIG.COUNTRY_CURRENCY_CODE.AU.currency_code){
      targetPrice = Math.round(price * $rootScope.geoLocation.rate);
    } 
    
    return targetPrice;
   }

   instance.getFormattedAmountByRate = function (price){
    var targetPrice = instance.getAmountByRate(price);
    var country = $rootScope.geoLocation.country ? $rootScope.geoLocation.country : instance.getCurrency();
    //var currency = $rootScope.geoLocation.currency ? $rootScope.geoLocation.currency : instance.getCurrency();
    return country + "" + instance.currencyFormat(Math.round(targetPrice));
   }

   function getTagPrice(price, discountRate) {
    return discountRate > 0 ? price*(1-discountRate) : price;
   };

   instance.getDisplayTagOrigPrice = function(product){
    var tagPrice = getTagPrice(product.price, product.discountRate);
    var price = instance.getAmountByRate(tagPrice);
    
    if (getTagPrice(product.price, product.discountRate) != product.price){
      return instance.currencyFormat(Math.round(price));
    }else{
      return instance.currencyFormat(Math.round(getTagPrice(price)));
    }
  }


   instance.getOriginalCreditPrice = function() {
    if($rootScope.geoLocation.country == CONFIG.COUNTRY_CURRENCY_CODE.SG.country_code){
      return CONFIG.ORIGINAL_CREDIT_PRICE_SG;
    } else {
      return CONFIG.ORIGINAL_CREDIT_PRICE;
    }
   }

   instance.getMemberPrice = function() {
    if($rootScope.geoLocation.country == CONFIG.COUNTRY_CURRENCY_CODE.SG.country_code){
      return CONFIG.PLAN_SG_1_TIME_CREDIT_PRICE;
    } else {
      return CONFIG.PLAN_HK_1_TIME_CREDIT_PRICE;
    }
   }

   instance.getConvertedAmount = function (price, currency, exchangeRate){
    if((currency == "SGD" || currency == "SG") || (currency == "AUD" || currency == "AU")){
      return instance.currencyFormat(price * exchangeRate);
    } 
    
    return instance.currencyFormat(price);
   }


   instance.formatWithCountryCode = function (price, country) {
			return country + "" + instance.currencyFormat(Math.round(price));
   }

   instance.isSalePriceSameWithOrigPrice = function(price, discountRate) {
     var salePrice = getTagPrice(price, discountRate);
      return salePrice != price;
   };



   instance.getFormattedAmountByRateNoCurrency = function (price){
    var targetPrice = instance.getAmountByRate(price);
    var country = $rootScope.geoLocation.country ? $rootScope.geoLocation.country : instance.getCurrency();
    //var currency = $rootScope.geoLocation.currency ? $rootScope.geoLocation.currency : instance.getCurrency();
    return instance.currencyFormat(Math.round(targetPrice));
   }

   instance.getDisplayPriceV3 = function(product) {
    return "book " + instance.getListingTagPriceNoCurrency(product);
   }

   instance.getDisplayPurchasePriceV3 = function(product) {
    var tagPrice = getTagPrice(product.price, product.discountRate);
     return instance.getFormattedAmountByRateNoCurrency(tagPrice);
   }

   instance.getListingTagPriceNoCurrency = function(product) {
    var currency = $rootScope.geoLocation.currency ? $rootScope.geoLocation.currency : instance.getCurrency();
    var country = $rootScope.geoLocation.country ? $rootScope.geoLocation.country : self.product_currency;

    var lblCredit = product.credit > 1 ? " Credits" : " Credit";
    var oneMthPlan = currency == CONFIG.COUNTRY_CURRENCY_CODE.SG.currency_code ? this.getSubscriptionPlanDetails(CONFIG.PLAN_SUBSCRIPTION_14) : this.getSubscriptionPlanDetails(CONFIG.PLAN_SUBSCRIPTION_4);
    var basePrice = oneMthPlan ? oneMthPlan.oneCreditPrice : ( currency == CONFIG.COUNTRY_CURRENCY_CODE.SG.currency_code ? CONFIG.PLAN_SG_1_TIME_CREDIT_PRICE : CONFIG.PLAN_1_MTH_CREDIT_PRICE);
    var targetPrice = basePrice;

    var creditDisplay = product.credit + lblCredit;

    if(currency == CONFIG.COUNTRY_CURRENCY_CODE.AU.currency_code){
      targetPrice = Math.round(basePrice * $rootScope.geoLocation.rate);
    } else {
      targetPrice = Math.round(basePrice);
    }
    
    var dollarDisplay = oneMthPlan ? this.currencyFormat(targetPrice * product.credit) : creditDisplay;
    if($rootScope.isLogon && $rootScope.credit.balance){
      var isMemberActive = false;
      if ($rootScope.credit.balance.expire !=null ){
        var expiryDate = new Date($rootScope.credit.balance.expire.substring(0,4),$rootScope.credit.balance.expire.substring(4,6)-1,$rootScope.credit.balance.expire.substring(6));
        var now = new Date();
        now.setMinutes(0);
        now.setSeconds(0);
        now.setMilliseconds(0);

        isMemberActive = now < expiryDate;
      }
      if($rootScope.credit.balance.available > 0){
        return creditDisplay;
      } 
      return isMemberActive ? creditDisplay : dollarDisplay;
    } 

    return dollarDisplay;

   }


   instance.getListingRentalPrice = function(product, week) {
    var currency = $rootScope.geoLocation.currency ? $rootScope.geoLocation.currency : instance.getCurrency();
    //var oneMthPlan = currency == CONFIG.COUNTRY_CURRENCY_CODE.SG.currency_code ? this.getSubscriptionPlanDetails(CONFIG.PLAN_SUBSCRIPTION_14) : this.getSubscriptionPlanDetails(CONFIG.PLAN_SUBSCRIPTION_4);
    var basePrice = currency == CONFIG.COUNTRY_CURRENCY_CODE.SG.currency_code ? CONFIG.PLAN_SG_1_TIME_CREDIT_PRICE : CONFIG.PLAN_1_MTH_CREDIT_PRICE;
    var targetPrice = basePrice;


    if(currency == CONFIG.COUNTRY_CURRENCY_CODE.AU.currency_code){
      targetPrice = Math.round(basePrice * $rootScope.geoLocation.rate);
    } else {
      targetPrice = Math.round(basePrice);
    }
    
    return this.currencyFormat((targetPrice * product.credit)*week);

   }

   instance.getListingNonMemberRentalPrice = function(product, week) {
    var currency = $rootScope.geoLocation.currency ? $rootScope.geoLocation.currency : instance.getCurrency();
    var basePrice = currency == CONFIG.COUNTRY_CURRENCY_CODE.SG.currency_code ? CONFIG.ORIGINAL_CREDIT_PRICE_SG : CONFIG.ORIGINAL_CREDIT_PRICE;
    var targetPrice = basePrice;


    if(currency == CONFIG.COUNTRY_CURRENCY_CODE.AU.currency_code){
      targetPrice = Math.round(basePrice * $rootScope.geoLocation.rate);
    } else {
      targetPrice = Math.round(basePrice);
    }
    return this.currencyFormat((targetPrice * product.credit)*week);

   }

   instance.isPriceDisplay = function() {
    if($rootScope.isLogon && $rootScope.credit.balance){
      if($rootScope.credit.balance.activeSubscription){
        return false;
      } 
    } 

    return true;
  }
    return instance;
  }]);

'use strict';

/**
 * @ngdoc factory
 * @name coutureApp.dateUtilities
 * @description
 * # utilities
 * Factory in the coutureApp.
 */
 angular.module('coutureApp')
 .factory('dateUtilities', ["$rootScope", "RefDataService", function ($rootScope,RefDataService) {

  var instance = {};

    instance.days = ["Sun","Mon","Tues","Wed","Thurs","Fri","Sat"];

    return instance;
  }]);

'use strict';

/**
 * @ngdoc service
 * @name coutureApp.ERRORMSGS
 * @description
 * # ERRORMSGS
 * Constant in the coutureApp.
 */
angular.module('coutureApp')
  .constant('ERROR_MSGS', {
  	'ERR_REGISTER_DUPLICATE_USERNAME' : 'Username is already taken.',
  	'ERR_REGISTER_DUPLICATE_EMAIL' : 'Email is already registered with an account.',
  	'10' : 'Credential does not exist.'
  });

'use strict';

/**
 * @ngdoc service
 * @name coutureApp.RefDataService
 * @description
 * # RefDataService
 * Factory in the coutureApp.
 */
angular.module('coutureApp')
  .factory('RefDataService', ["$resource", "envService", "$http", "$rootScope", "$log", "CONFIG", "localStorageService", function ($resource, envService,$http,$rootScope,$log, CONFIG,localStorageService) {

  var refDataService = {};

    // Interact with the RESTful API of the server.
    refDataService.api = $resource(
      envService.read('SERVICE_DOMAIN') + "/api/pub/brands/get",
      {}, // param defaults
      {
        'getBrands' : {
          method: "GET", cache: true, isArray : true ,
          transformResponse: function(data, header) {
              data = angular.fromJson(data);
              return data.sort(function(a,b){
                if (a.name < b.name) return -1;
                if (a.name > b.name) return 1;
              });
          }
        },
        'getSelectedBrands' : { 
          method: "GET", 
          url: envService.read('SERVICE_DOMAIN') + "/api/pub/selected-brands/list", 
          cache: true, 
          isArray : true,
          transformResponse: function(data, header) {
            data = angular.fromJson(data);
            return data.sort(function(a,b){
              if (a < b) return -1;
              if (a > b) return 1;
            });
          }
        },
        'getCategories' : { 
          method: "GET", 
          url: envService.read('SERVICE_DOMAIN') + "/api/pub/categories/get", 
          cache: true, 
          isArray : true 
        },
        'getHolidayList' : { 
          method:"GET" , 
          url : 
          envService.read('SERVICE_DOMAIN') + "/api/pub/holidays", 
          cache: true, 
          isArray : true 
        },
        'getSizeList' : { 
          method:"GET" , 
          url : envService.read('SERVICE_DOMAIN') + "/api/pub/sizes/list", 
          cache: true, 
          isArray : true 
        },
        'getSizeFlatList' : {
          method:"GET" , 
          url : envService.read('SERVICE_DOMAIN') + "/api/pub/sizes/flat-list", 
          cache: true, 
          isArray : true 
        },
        'getCurrencyList' : {
          method:"GET" , 
          url : envService.read('SERVICE_DOMAIN') + "/api/pub/code-value/list", 
          cache: true, 
          isArray : true 
        },
        'getCountryListV2' : {
          method:"GET" , 
          url : envService.read('SERVICE_DOMAIN') + "/api/pub/code-value/list", 
          cache: true, 
          isArray : true 
        },
        'getForexList' : {
          method:"GET" , 
          url : envService.read('SERVICE_DOMAIN')  + "/api/pub/forex/list", 
          cache: true, 
          isArray : true 
        },
        'getReferralRewards' : { 
          method: "GET", 
          url: envService.read('SERVICE_DOMAIN') + "/api/pub/referral/rewards", 
          cache: true,
        },
        'getBannerList' : { 
          method: "GET", 
          url: envService.read('SERVICE_DOMAIN') + "/api/pub/banner/list", 
          cache: false, 
          isArray : true 
        },
        'getShopfrontList' : { 
          method: "GET", 
          url: envService.read('SERVICE_DOMAIN') + "/api/pub/shopfront/list", 
          cache: false, 
          isArray : true 
        }
      });

    refDataService.getBrands = function() {
      return refDataService.api.getBrands();
    };

    refDataService.getSelectedBrands = function(owner) {
      return refDataService.api.getSelectedBrands({
        "owner" : owner
      });
    };

    refDataService.getSizeList = function(countryCode, sizeCategory) {
      return refDataService.api.getSizeList({
        "countryCode" : countryCode,
        "sizeCategory" : sizeCategory
      })
    };

    refDataService.getSizeFlatList = function() {
      return refDataService.api.getSizeFlatList();
    };

    refDataService.getCurrencyList = function() {
      return refDataService.api.getCurrencyList({
        "codeType" : "CURRENCY"
      })
    };

    //for later user to change to load from server
    refDataService.getCountryListV2 = function() {
      return refDataService.api.getCountryList({
        "codeType" : "COUNTRY"
      })
    };

    refDataService.getForexList = function() {
      return refDataService.api.getForexList();
    };

    refDataService.getReferralRewards = function(country) {
      return refDataService.api.getReferralRewards({
        "countryCode" : country
      });
    };

    //ADDED HTTPS INJECT FOR GETTING COUNTRY LIST
    //THIS WILL BE MOVED TO SERVER
    function loadHolidayList(){
      $http.get('scripts/config/holiday.json').then(function successCallback(response) {
          refDataService.holidayList = response.data;
      }, function errorCallback(response) {
          // console.log(response.statusText);
      });
    }

    //https://www.ups.com/worldshiphelp/WS15/ENU/AppHelp/Codes/Countries_Territories_Requiring_Postal_Codes.htm
    //REFER SITE ON WHICH COUNTRY REQUIRE POSTAL CODE
    function loadCountryList(){
      $http.get('scripts/config/countries.json').then(function successCallback(response) {
          for (var i = 0; i < response.data.length; i++) {
            if(response.data[i].countryCode.toLowerCase() == "sg"){
              response.data[i].flag = CONFIG.SG_FLAG_SRC;
            } else if(response.data[i].countryCode.toLowerCase() == "hk"){
              response.data[i].flag = CONFIG.HK_FLAG_SRC;
            } else {
              response.data[i].flag = CONFIG.SVG_FLAG_SRC + response.data[i].countryCode.toLowerCase() + '.svg';
            }
            response.data[i].queryValue = response.data[i].countryCode + "" + response.data[i].name + response.data[i].phoneCode;
          }
          refDataService.countryList = response.data;
          $rootScope.countryList = response.data;
          $rootScope.availableCountryList = response.data.filter(c => c.countryCode == CONFIG.COUNTRY_CURRENCY_CODE.SG.country_code || c.countryCode == CONFIG.COUNTRY_CURRENCY_CODE.HK.country_code);
          $rootScope.euroCountryList = response.data.filter(function(c) {
            return CONFIG.EUR_SUPPORTED_COUNTRIES.indexOf(c.countryCode) > -1;
          });
      }, function errorCallback(response) {
          // console.log(response.statusText);
      });
    }

    loadCountryList();

    loadHolidayList();
    //THIS WILL BE MOVED TO SERVER
    //ADDED HTTPS INJECT FOR GETTING COUNTRY LIST

    refDataService.getHolidayList = function(){
      return refDataService.holidayList;
      // return refDataService.api.getHolidayList();
    }

    refDataService.getCountryList = function(){ 
      $http.get('scripts/config/countries.json').then(
        function successCallback(response) {
          for (var i = 0; i < response.data.length; i++) {
            response.data[i].flag = CONFIG.SVG_FLAG_SRC + response.data[i].countryCode.toLowerCase() + '.svg';
            response.data[i].queryValue = response.data[i].countryCode + "" + response.data[i].name + response.data[i].phoneCode;
          }
          refDataService.countryList = response.data;
          $rootScope.countryList = response.data;
          $rootScope.euroCountryList = response.data.filter(function(c) {
            return CONFIG.EUR_SUPPORTED_COUNTRIES.indexOf(c.countryCode) > -1;
          });
        }, function errorCallback(response) {}
      );

      return refDataService.countryList;
    }

    refDataService.getCategories = function() {
      return refDataService.api.getCategories();
    };


    refDataService.getSortByList_StylePosts = function(){
      return [
          {KEY:"latest",VALUE:"Latest"}
      ]
    }

    refDataService.getSortByList_Listings = function(){
      return [
          {KEY:"recommended",VALUE:"Recommended"},
          {KEY:"latest",VALUE:"Latest"},
          {KEY:"priceAsc",VALUE:"Lowest Price"},
          {KEY:"priceDesc",VALUE:"Highest Price"}
      ]
    }

    refDataService.getSortBy_OrderHistory = function(){
      return [
          {KEY:"-creationDate",VALUE:"Latest"},
          {KEY:"netTagPrice",VALUE:"Lowest Price"},
          {KEY:"-netTagPrice",VALUE:"Highest Price"}
      ]
    }

    refDataService.getSortBy_OrderBuyHistory = function(){
      return [
          {KEY:"-creationDate",VALUE:"Latest"},
          {KEY:"purchasePrice",VALUE:"Lowest Price"},
          {KEY:"-purchasePrice",VALUE:"Highest Price"}
      ]
    }

    refDataService.getSortByWishlist = function(){
      return [
          {KEY:"-id",VALUE:"Latest"},
          {KEY:"_sortPrice",VALUE:"Lowest Price"},
          {KEY:"-_sortPrice",VALUE:"Highest Price"}
      ]
    }

    refDataService.GetProductOptionsLabel = function(){
      return ['Option 1','Option 2','Option 3']
    }


    // [{id: 1, name: "Clothing"},
    // {id: 2, name: "Accessories"},
    // {id: 3, name: "Bags & Luggage"},
    // {id: 4, name: "Bridal"},   Demised
    // {id: 5, name: "Fine Jewelry"},   Demised
    // {id: 6, name: "Shoes"}]

    refDataService.getDiscountOptions = function() {
      return [
        {'name' : 'None', 'value' : 0, 'checked' : true},
        {'name' : '10%', 'value' : 0.1},
        {'name' : '30%', 'value' : 0.3},
        {'name' : '50%', 'value' : 0.5}
      ];
    }

    refDataService.getSizes = function() {
      return [
            { category: 'Clothing',
              options: [
                {KEY:'OS',VALUE: 'O/S'},
                {KEY:'XXS',VALUE: 'XXS'},
                {KEY:'XS',VALUE: 'XS'},
                {KEY:'S',VALUE: 'S'},
                {KEY:'M',VALUE: 'M'},
                {KEY:'L',VALUE: 'L'},
                {KEY:'XL',VALUE: 'XL'},
                {KEY:'XXL',VALUE: 'XXL'}
              ]
            },
            { category: 'Bags & Luggage',
              options: [
                {KEY:'MICRO',VALUE:'Micro'},
                {KEY:'MINI',VALUE:'Mini'},
                {KEY:'S',VALUE:'S'},
                {KEY:'M',VALUE:'M'},
                {KEY:'L',VALUE:'L'},
                {KEY:'XL',VALUE:'XL'},
                {KEY:'WE',VALUE:'Weekend'},
                {KEY:'CO',VALUE:'Carry-On'}
              ]
          },
          { category: 'Shoes',
            options: [
              {KEY:'IT34',VALUE: 'EU34'},
              {KEY:'IT34.5',VALUE: 'EU34.5'},
              {KEY:'IT35',VALUE: 'EU35'},
              {KEY:'IT35.5',VALUE: 'EU 35.5'},
              {KEY:'IT36',VALUE: 'EU 36'},
              {KEY:'IT36.5',VALUE: 'EU 36.5'},
              {KEY:'IT37',VALUE: 'EU 37'},
              {KEY:'IT37.5',VALUE: 'EU 37.5'},
              {KEY:'IT38',VALUE: 'EU 38'},
              {KEY:'IT38.5',VALUE: 'EU 38.5'},
              {KEY:'IT39',VALUE: 'EU 39'},
              {KEY:'IT39.5',VALUE: 'EU 39.5'},
              {KEY:'IT40',VALUE: 'EU 40'},
              {KEY:'IT40.5',VALUE: 'EU 40.5'},
              {KEY:'IT41',VALUE: 'EU 41'},
              {KEY:'IT41.5',VALUE: 'EU 41.5'},
              {KEY:'IT42',VALUE: 'EU 42'}
            ]
          },
          { category: 'Accessories',
            options: [
              {KEY:'OS',VALUE: 'O/S'},
              {KEY:'XXS',VALUE: 'XXS'},
              {KEY:'XS',VALUE: 'XS'},
              {KEY:'S',VALUE: 'S'},
              {KEY:'M',VALUE: 'M'},
              {KEY:'L',VALUE: 'L'},
              {KEY:'XL',VALUE: 'XL'}
            ]
          }
      ]
    }

    refDataService.getDeliverySchedule = function (requestedDate) {

      var now = new Date();
      // "Clean up" the time
      now.setMinutes(0);
      now.setSeconds(0);
      now.setMilliseconds(0);

      var tmp = new Date(now.getTime());
      var diff = daysDiff(new Date(requestedDate), now);
      var schedule = [];

      if( diff > 2 ) {
        // Too late.  This is now an invalid request.
        return null;
      }

      if( diff <= 2 ) {
        tmp.setDate(tmp.getDate() + 1);
        schedule.push({'time': tmp.setHours(10), 'label' : "Next Working Day AM"});
        schedule.push({'time': tmp.setHours(14), 'label' : "Next Working Day PM (Before 6pm)"});
        tmp.setDate(tmp.getDate() + 1);
        schedule.push({'time': tmp.setHours(10), 'label' : "2nd Working Day AM"});
        schedule.push({'time': tmp.setHours(14), 'label' : "2nd Working Day PM (Before 6pm)"});
      }

      if( diff <= 1 ) {
        tmp.setDate(tmp.getDate() + 1);
        schedule.push({'time': tmp.setHours(10), 'label' : "3rd Working Day AM"});
        schedule.push({'time': tmp.setHours(14), 'label' : "3rd Working Day PM (Before 6pm)"});
      }

      return schedule;
    }

    var daysDiff = function(date1, date2) {
      var oneDay = 24*60*60*1000; // hours*minutes*seconds*milliseconds
      return Math.round(Math.abs((date1.getTime() - date2.getTime())/(oneDay)));
    }

    refDataService.getGeoLocation = function(){ 
      //change to actual token.
      var sessionLocation = localStorageService.get('geoLocation');
      if(sessionLocation == null || sessionLocation.country == null) {
        $http.get(CONFIG.IPINFO_URL).then(function (response){
          var country = (response.data.country == CONFIG.COUNTRY_CURRENCY_CODE.SG.country_code || response.data.country == CONFIG.COUNTRY_CURRENCY_CODE.AU.country_code) ?  response.data.country : CONFIG.COUNTRY_CURRENCY_CODE.HK.country_code ;
          //ipinfo does not contain currency 
          refDataService.getCountryCurrency(country);
        });
      }
    }
    

    refDataService.getCountryCurrency = function(country){ 
      var exchangeRate = {
        amount: 1,
        currency: CONFIG.COUNTRY_CURRENCY_CODE.HK.currency_code
      };
      refDataService.getForexList().$promise.then(function(resp) {
      $rootScope.forex = resp;
        if(country == CONFIG.COUNTRY_CURRENCY_CODE.SG.country_code){
          $rootScope.geoLocation.country = CONFIG.COUNTRY_CURRENCY_CODE.SG.country_code;
          $rootScope.geoLocation.currency = CONFIG.COUNTRY_CURRENCY_CODE.SG.currency_code;
          exchangeRate = $rootScope.forex ? $rootScope.forex.filter(fx => fx.currency == CONFIG.COUNTRY_CURRENCY_CODE.SG.currency_code) : {};
          $rootScope.geoLocation.rate = exchangeRate ? exchangeRate[0].amount : 1;
          $rootScope.geoLocation.countryFlag = CONFIG.SG_FLAG_SRC;
        } else if(country == CONFIG.COUNTRY_CURRENCY_CODE.AU.country_code){
          $rootScope.geoLocation.country = CONFIG.COUNTRY_CURRENCY_CODE.AU.country_code;
          $rootScope.geoLocation.currency = CONFIG.COUNTRY_CURRENCY_CODE.AU.currency_code;
          exchangeRate = $rootScope.forex ? $rootScope.forex.filter(fx => fx.currency == CONFIG.COUNTRY_CURRENCY_CODE.AU.currency_code) : {};
          $rootScope.geoLocation.rate = exchangeRate ? exchangeRate[0].amount : 1;
          $rootScope.geoLocation.countryFlag = (CONFIG.SVG_FLAG_SRC + $rootScope.geoLocation.country+ '.svg').toLowerCase();
        } else {
          $rootScope.geoLocation.country = CONFIG.COUNTRY_CURRENCY_CODE.HK.country_code;
          $rootScope.geoLocation.currency = CONFIG.COUNTRY_CURRENCY_CODE.HK.currency_code;
          $rootScope.geoLocation.rate = 1;
          $rootScope.geoLocation.countryFlag = CONFIG.HK_FLAG_SRC;
        }

        localStorageService.set('geoLocation', $rootScope.geoLocation);
        $rootScope.$emit("CallLoadDatesFromServer", $rootScope.geoLocation);
      });
    }

    refDataService.refreshGeoLocation = function(countryCode){ 
        if(countryCode == null){
          $rootScope.geoLocation.country = CONFIG.COUNTRY_CURRENCY_CODE.HK.country_code;
          $rootScope.geoLocation.currency = CONFIG.COUNTRY_CURRENCY_CODE.HK.currency_code;
          $rootScope.geoLocation.rate = 1;
          localStorageService.set('geoLocation', $rootScope.geoLocation);
          $rootScope.$emit("CallLoadDatesFromServer", $rootScope.geoLocation);
        } else {
          $rootScope.geoLocation.country = countryCode.toUpperCase();
          refDataService.getCountryCurrency(countryCode.toUpperCase());
        }
    }

    refDataService.getItemConditions = function(){
      return [
          {key:"NEW",value:"New"},
          {key:"PRISTINE",value:"Pristine"},
          {key:"EXCELLENT",value:"Excellent"},
          {key:"GOOD",value:"Good"},
          {key:"FAIR",value:"Fair"}
      ]
    }
    refDataService.getAvailableShippingCountries = function () {
      var allCountries = refDataService.getCountryList();
      if(allCountries){
        var availableShippingCountry = allCountries.filter(c => c.countryCode == CONFIG.COUNTRY_CURRENCY_CODE.SG.country_code || c.countryCode == CONFIG.COUNTRY_CURRENCY_CODE.HK.country_code);
  
        return availableShippingCountry;
      }
    }
    refDataService.getItemConditionsFilter = function(){
      return [
          {key:"NEW",value:"NEW"},
          {key:"PRELOVED",value:"PRELOVED"}
      ]
    }
    refDataService.getDispatchType = function() {
      return [
        {'name' : 'SELF_DISPATCH', 'value' : 'Self Dispatch'},
        {'name' : 'SC_COLLECT', 'value' : 'SC Collect'},
      ];
    }

    refDataService.getCollections = function(){
      var collections = [
        {
          key:"main-collection",
          value:"Featured", 
          position:1, 
          enabled: true,
          order: [
            {position: 1, key: "top", value: "Top", feature: true},
            {position: 2, key: "back", value: "Back", feature: true},
            {position: 3, key: "unfeature", value: "Unfeature", feature: false}
          ]
        },
        {key:"two-for-one",value:"2 for 1", position:2, enabled: CONFIG.BUNDLES_ENABLED, order: []},
      ];
      return collections.filter(p => p.enabled == true);
    }

    refDataService.getBannerList = function() {
      return refDataService.api.getBannerList();
    };

    refDataService.getShopfrontList = function() {
      return refDataService.api.getShopfrontList();
    };

    return refDataService;
  }]);

'use strict';

/**
 * @ngdoc service
 * @name coutureApp.PayoutService
 * @description
 * # PayoutService
 * Factory in the coutureApp.
 */
angular.module('coutureApp')
  .factory('PayoutService', ["$resource", "envService", "$rootScope", function ($resource, envService,$rootScope) {

    var transformTotalRecordCount = function(data, header, status){
      // To be removed once server response is fixed
      data = angular.fromJson(data);
      var searchResult = {'totalRecordCount':header()["x-total-count"],'totalPageCount':header()["x-total-page"]};
      data.reasons ? '' : data.push({searchResult});
      return data;
    }

    var payoutService = {};

    // Interact with the RESTful API of the server.
    payoutService.api = $resource(
      envService.read('SERVICE_DOMAIN') + "/api/payout/auth/beneficiary",
      {}, // param defaults
      {
        'getPayoutDetails' : { 
          method: "GET", 
          url: envService.read('SERVICE_DOMAIN') + "/api/payout/auth/get/:referenceNumber",
          isArray : false,
          params: {
            referenceNumber : '@referenceNumber'
          } 
        },
        'getPayoutTransactionDetails' : { 
          method: "GET", 
          url: envService.read('SERVICE_DOMAIN') + "/api/payout/auth/get/transactions/:referenceNumber",
          isArray : true,
          params: {
            referenceNumber : '@referenceNumber'
          } 
        },
        'getBeneficiaryDetails' : { 
          method: "GET", 
          url: envService.read('SERVICE_DOMAIN') + "/api/payout/auth/beneficiary",
          isArray : false
        },
        'validateBeneficiaryDetails' : { 
          method: "POST", 
          url: envService.read('SERVICE_DOMAIN') + "/api/payout/auth/validate/beneficiary"
        },
        'getUserPayoutHistory' : { 
          method: "GET", 
          url: envService.read('SERVICE_DOMAIN') + "/api/payout/auth/user-list",
          isArray : true,
          transformResponse: transformTotalRecordCount
        },
        'getAllPayoutHistory' : { 
          method: "GET", 
          url: envService.read('SERVICE_DOMAIN') + "/api/payout/auth/all-list",
          isArray : true,
          transformResponse: transformTotalRecordCount
        },
        'updateBeneficiaryDetails' : { 
          method: "POST", 
          url: envService.read('SERVICE_DOMAIN')+ "/api/payout/auth/beneficiary"
        },
        'approvePayout' : { 
          method: "POST", 
          url: envService.read('SERVICE_DOMAIN') + "/api/payout/auth/approve/:referenceNumber",
          params: {
            referenceNumber : '@referenceNumber'
          } 
        },
        'declinePayout' : { 
          method: "POST", 
          url: envService.read('SERVICE_DOMAIN') + "/api/payout/auth/decline/:referenceNumber",
          params: {
            referenceNumber : '@referenceNumber'
          } 
        },
      });

      payoutService.getPayoutDetails = function(referenceNumber) {
        return payoutService.api.getPayoutDetails({'referenceNumber' : referenceNumber});
      };
      payoutService.getPayoutTransactionDetails = function(referenceNumber) {
        return payoutService.api.getPayoutTransactionDetails({'referenceNumber' : referenceNumber});
      };
      payoutService.getBeneficiaryDetails = function() {
        return payoutService.api.getBeneficiaryDetails();
      };
      payoutService.validateBeneficiaryDetails = function(beneficiary_info) {
        return payoutService.api.validateBeneficiaryDetails({}, beneficiary_info);
      };
      payoutService.getUserPayoutHistory = function(filters) {
        return payoutService.api.getUserPayoutHistory(filters);
      };
      payoutService.getAllPayoutHistory = function(filters) {
        return payoutService.api.getAllPayoutHistory(filters);
      };
      payoutService.updateBeneficiaryDetails = function(beneficiary_info) {
          return payoutService.api.updateBeneficiaryDetails({}, beneficiary_info);
      };
      payoutService.approvePayout = function(referenceNumber) {
        return payoutService.api.approvePayout({'referenceNumber' : referenceNumber});
      };
      payoutService.declinePayout = function(referenceNumber) {
        return payoutService.api.declinePayout({'referenceNumber' : referenceNumber});
      };

    return payoutService;
  }]);

'use strict';

/**
 * @ngdoc service
 * @name coutureApp.AdminService
 * @description
 * # AdminService
 * Factory in the coutureApp.
 */
angular.module('coutureApp')
  .factory('AdminService', ["$resource", "envService", function($resource, envService) {

    var adminService = {};

    // Interact with the RESTful API of the server.
    adminService.api = $resource(
      envService.read('SERVICE_DOMAIN') + "/api/auth/admin/product/approve/:id", {}, // param defaults
      {
        'approveListing': {
          method: "GET",
          params: {
            id: '@id'
          }
        },
        'rejectListing': {
          method: "GET",
          url: envService.read('SERVICE_DOMAIN') + "/api/auth/admin/product/reject/:id",
          params: {
            id: '@id'
          }
        },
        'userListing': {
          method: "GET",
          url: envService.read('SERVICE_DOMAIN')+ "/api/auth/admin/users",
          isArray: true
        },
        'updateUserProfile': {
          method: "POST",
          url: envService.read('SERVICE_DOMAIN') + "/api/auth/admin/profile/update"
        },
        'changeProductStatus': {
          method: "POST",
          url: envService.read('SERVICE_DOMAIN') + "/api/auth/admin/listing/:listingId/status/:statusId",
          params: {
            listingId: '@productID',
            statusId: '@status'
          }
        },
        'createListingWithUsername': {
          method: "POST",
          url: envService.read('SERVICE_DOMAIN') + "/api/auth/admin/listing"
        },
        'changeProductItemStatus': {
          method: "POST",
          url: envService.read('SERVICE_DOMAIN') + "/api/v2/auth/admin/listing/:itemID/status/:statusID/:itemCondition/:hub",
          params: {
            itemID: '@itemID',
            statusID: '@statusID',
            itemCondition: '@itemCondition',
            hub: '@hub'
          }
        },
        'changeProductItemCurated': {
          method: "POST",
          url: envService.read('SERVICE_DOMAIN') + "/api/auth/admin/product/curated/:productID",
          params: {
            productID: '@productID',
            curated: '@curated'
          }
        },
        'changeProductItem': {
          method: "POST",
          url: envService.read('SERVICE_DOMAIN') + "/api/v2/auth/admin/listing/:itemID/status/:statusID/:itemCondition",
          params: {
            itemID: '@itemID',
            statusID: '@statusID',
            itemCondition: '@itemCondition'
          }
        },
        'adminAddProductWithSize' : { 
          method: "POST",
          url: envService.read('SERVICE_DOMAIN')+ "/api/auth/admin/product/item/add/:id?size=:size&quantity=:quantity&isInstant=:isInstant&condition=:condition",
          params: {
            id : '@productID',
            size:'size',
            quantity:'quantity',
            isInstant:'isInstant',
            condition: 'condition'
          }
        },
        'updateAddress': {
          method: "POST",
          url: envService.read('SERVICE_DOMAIN')  + "/api/auth/admin/profile/address/save"
        },
        'retrieveHubAddress': {
          method: "GET",
          url: envService.read('SERVICE_DOMAIN')  + "/api/auth/admin/profile/address/get",
          isArray: true
        },
      });

      ///////////////////////////////////////////////////////
      ////// CHANGE THE PRODUCT STATUS                ///////
      //////  ARG1: PRODUCT ID, ARG2: PRODUCT STATUS  ///////
      ///////////////////////////////////////////////////////
    adminService.changeProductStatus = function(newStatus) {
      return adminService.api.changeProductStatus({}, newStatus);
    };



    adminService.changeProductItemCurated = function(productID,curated) {

      return adminService.api.changeProductItemCurated({
          'productID' : productID,
          'curated': curated
      }, {});
    };

    //v2 : change status by product item
    adminService.changeProductItemStatus = function(newStatus) {
      return adminService.api.changeProductItemStatus({}, newStatus);
    };
    adminService.changeProductItem = function(newStatus) {
      return adminService.api.changeProductItem({}, newStatus);
    };

    ///////////////////////////////////////////////////////
    ////// CREATE LISTING ON BEHALF OF USERNAME    ///////
    ////// {"owner" : {"username" : 'XXX'}          ///////
    //////   "instantRental": true/false   }        ///////
    ///////////////////////////////////////////////////////
    adminService.createListingWithUsername = function(updateDetails) {
      return adminService.api.createListingWithUsername({}, updateDetails);
    };

    adminService.updateUserProfile = function(user_profile) {
      return adminService.api.updateUserProfile({}, user_profile);
    };

    adminService.approveListing = function(id) {
      return adminService.api.approveListing({
        'id': id
      });
    };

    adminService.rejectListing = function(id) {
      return adminService.api.rejectListing({
        'id': id
      });
    };

    adminService.userListing = function() {
      return adminService.api.userListing();
    };


    adminService.adminAddProductWithSize = function(productID,size,quantity,isInstant, condition) {

      return adminService.api.adminAddProductWithSize({
          'id' : productID,
          'size': size,
          'quantity': quantity,
          'isInstant': isInstant,
          'condition': condition
      }, {});
    };


    adminService.updateAddress = function(addr) {
      return adminService.api.updateAddress({},addr);
    };

    adminService.retrieveHubAddress = function() {
      return adminService.api.retrieveHubAddress();
    };

    return adminService;
  }]);

'use strict';

/**
 * @ngdoc service
 * @name coutureApp.ShippingService
 * @description
 * # shippingService
 * Factory in the coutureApp.
 */
angular.module('coutureApp')
  .factory('ShippingService', ["$resource", "envService", "$rootScope", "$log", "utilities", function($resource, envService, $rootScope, $log, utilities) {

    var shippingService = {};

    var transformFileDownload = function(data, headers) {
      var filename = headers('X-filename');
      var contentType = headers('content-type');
      var linkElement = document.createElement('a');
      try {
          var blob = utilities.base64toBlob(data, contentType);
          var url = window.URL.createObjectURL(blob);

          linkElement.setAttribute('href', url);
          linkElement.setAttribute("download", filename);

          var clickEvent = new MouseEvent("click", {
              "view": window,
              "bubbles": true,
              "cancelable": false
          });
          linkElement.dispatchEvent(clickEvent);
      } catch (err) {
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":transformFileDownload - Failed") :'';
      }
    }

    // Interact with the RESTful API of the server.
    shippingService.api = $resource(
      envService.read('SERVICE_DOMAIN')+ "/api/auth/shipping/dhl/retrieve-rates", {}, // param defaults
      {
        'retrieveRates': {
          method: "POST"
        },
        'createMerchantToCustomerShipment': {
          method: "POST",
          url: envService.read('SERVICE_DOMAIN')+ "/api/auth/shipping/dhl/create-merchant-to-customer-shipment"
        },
        'downloadLabel':{
          method:"GET",
          url: envService.read('SERVICE_DOMAIN')+ "/api/auth/shipping/dhl/download-label/:trackingNumber", 
          params: {
            trackingNumber: '@trackingNumber'
          },
          timeout: 300000,
          transformResponse: transformFileDownload
        },
        'retrieveMultipleRates':{
          method:"POST",
          url: envService.read('SERVICE_DOMAIN')+ "/api/auth/shipping/dhl/retrieve-multiple-rates",
          isArray : true
        }
        
      });

    shippingService.retrieveRates = function(ratesDetails) {
      //height
      //length
      //weight
      //width
      //plannedShippingDate
      return shippingService.api.retrieveRates({}, ratesDetails);
    };

    shippingService.retrieveMultipleRates = function(ratesDetails) {
      //height
      //length
      //weight
      //width
      //plannedShippingDate
      return shippingService.api.retrieveMultipleRates({}, ratesDetails);
    };

    shippingService.createMerchantToCustomerShipment = function(shipmentDetails) {
      return shippingService.api.createMerchantToCustomerShipment({}, shipmentDetails);
    };

    shippingService.downloadLabel = function(trackingNumber) {
      return shippingService.api.downloadLabel({'trackingNumber' : trackingNumber}, {});
    };


    return shippingService;
  }]);

angular.module('coutureApp').filter('cut', function () {
        return function (value, wordwise, max, tail) {
            if (!value) return '';

            max = parseInt(max, 10);
            if (!max) return value;
            if (value.length <= max) return value;

            value = value.substr(0, max);
            if (wordwise) {
                var lastspace = value.lastIndexOf(' ');
                if (lastspace !== -1) {
                  //Also remove . and , so its gives a cleaner result.
                  if (value.charAt(lastspace-1) === '.' || value.charAt(lastspace-1) === ',') {
                    lastspace = lastspace - 1;
                  }
                  value = value.substr(0, lastspace);
                }
            }

            return value + (tail || ' …');
        };
    });

'use strict';

/**
 * @ngdoc service
 * @name coutureApp.RentalService
 * @description
 * # RentalService
 * Factory in the coutureApp.
 */
angular.module('coutureApp')
  .factory('RentalService', ["$resource", "envService", "CONFIG", "moment", "AuthService", "$rootScope", "ListingService", "localStorageService", function ($resource, envService,CONFIG,moment,AuthService,$rootScope,ListingService, localStorageService) {

  var rentalService = {};

  var updateImageURL = function(resp){
    for (var i = 0; i < resp.length; i++) {
      resp[i].pictures.forEach(function(item) {
          item._url = item.pathSrc === 'shopify' ? item.path : envService.read('IMG_DOMAIN') + "/" + item.path;
      });
    }
  };


  var updateImageURLV2 = function(resp){
    for (var i = 0; i < resp.length; i++) {
      resp[i].product.pictures.forEach(function(item) {
          item._url = item.pathSrc === 'shopify' ? item.path : envService.read('IMG_DOMAIN') + "/" + item.path;
      });
    }
  };

    // Interact with the RESTful API of the server.
    rentalService.api = $resource(
      envService.read('SERVICE_DOMAIN')  + "/api/auth/rental/precheck",
      {}, // param defaults
      {
        'preCheck' : { 
          method: "POST", 
          params: {
            country : '@country'
          }  
        },
        'getCreditCardInfo' : {method:"GET" , url :envService.read('SERVICE_DOMAIN') +"/api/auth/billing"},
        'saveStripeTokenAuth' : { 
          method: "POST", 
          url: envService.read('SERVICE_DOMAIN')+ "/api/auth/billing/save/:token", 
          params: {
            token : '@token',
            country : '@country'
          } 
        },
        'saveStripeTokenPub' : { 
          method: "POST", 
          url: envService.read('SERVICE_DOMAIN') + "/api/pub/billing/save/:token", 
          params: {
            token : '@token', 
            tempToken : '@tempToken',
            country : '@country'
          } 
        },
        'requestRental' : { method: "POST", url: envService.read('SERVICE_DOMAIN') + "/api/auth/rental/request/:id?promo=:pCode", params: {id : '@id',pCode : '@promo', startDate: '@startDate'}, timeout: 30000 },
        'requestRentalMultiItems' : { method: "POST", url: envService.read('SERVICE_DOMAIN') + "/api/auth/rental/request/multi"},
        'requestRentalMultiItemsCreditBased' : { method: "POST", url: envService.read('SERVICE_DOMAIN') + "/api/auth/rental/request/credit-based/multi"},
        //This is a wrapper endpoint that will process both purchase and rent backend
        'acceptRentalRequest' : { method: "POST", url: envService.read('SERVICE_DOMAIN') + "/api/pub/rental/accept" },
        'declineRentalRequest' : { method: "POST", url: envService.read('SERVICE_DOMAIN') + "/api/pub/rental/decline" },
        'pendingApproval' : { method: "GET", url: envService.read('SERVICE_DOMAIN') + "/api/auth/listing/pending",isArray : true },
        'pendingApprovalV2' : { method: "GET", url: envService.read('SERVICE_DOMAIN') + "/api/auth/list/pending-requests",isArray : true },
        'allRentalOrders' : { method: "GET", url: envService.read('SERVICE_DOMAIN') + "/api/auth/list/all-rentals",isArray : true },
        'getAwaitingDispatchRentals' : { 
          method: "GET", 
          url: envService.read('SERVICE_DOMAIN')+ "/api/auth/list/awaiting-dispatch",
          isArray : true 
        },
        'approvalPending' : { method: "PUT", url: envService.read('SERVICE_DOMAIN') + "/api/auth/rentals/:id/acceptance",params: {id : '@id'} },
        'approveRentalRequestV2' : { 
          method: "PUT", 
          url: envService.read('SERVICE_DOMAIN') + "/api/v2/auth/rentals/:id/acceptance",
          params: {
            id : '@id'
          } 
        },
        'declinePending' : { method: "PUT", url: envService.read('SERVICE_DOMAIN') + "/api/auth/rentals/:id/decline",params: {id : '@id'} },
        'pendingCount' : { method: "GET", url: envService.read('SERVICE_DOMAIN') + "/api/auth/listing/pending/count"},
        'getRentalPeriod' : {method:"GET" , url : envService.read('SERVICE_DOMAIN') + "/api/auth/listing/:id/rental-period",params: {id : '@id'} },
        'getAllowedDates' : {method:"GET" , url : envService.read('SERVICE_DOMAIN') + "/api/pub/listing/allowed-rental-dates"},
        'getAllowedDatesV3' : {
          method:"GET" , 
          url : envService.read('SERVICE_DOMAIN') + "/api/pub/v3/listing/allowed-rental-dates/:destinationCountry",
          params: {
            destinationCountry : '@destinationCountry'
          } 
        },
        'getAllowedDatesV4' : {
          method:"GET" , 
          url : envService.read('SERVICE_DOMAIN') + "/api/pub/v4/listing/allowed-rental-dates",
          params: {
            destinationCountry : '@destinationCountry',
            merchantId : '@merchantId',
            productId : '@productId'
          } 
        },
        // , isArray: false,transformResponse:function(data, header, status){
        //   data = angular.fromJson(data);
        //   //CONVERT THE HKT(UTC) FORMAT TO GMT(UTC) TIME
        //   if (data.ir) {
        //     data.ir = data.ir.map(m=> moment(m).tz($rootScope.ServerTimezone).utc().valueOf());
        //   }
        //   if (data.rr) {
        //     data.rr = data.rr.map(m=> moment(m).tz($rootScope.ServerTimezone).utc().valueOf());
        //   }
        //   return data;
        // }},
        'getOrderDetails' : {method:"GET" , url : envService.read('SERVICE_DOMAIN') + "/api/auth/admin/rental/:orderID",params: {orderID : '@orderID'} },
        'getRentalFeesWithPromoCode' : {method:"GET" , url : envService.read('SERVICE_DOMAIN') + "/api/auth/fees/:productID?promo=:pCode",params: {productID : '@productID',pCode : '@promoCode'} },
        'getRentalFeesWithPromoCodeOnMultiItems' : {method:"POST" , url : envService.read('SERVICE_DOMAIN') + "/api/pub/fees/multi"},
        'getCreditAndOtherFeesOnMultiProductsPub' : {method:"POST" , url : envService.read('SERVICE_DOMAIN')+ "/api/pub/fees/credit-based/multi"},
        'getCreditAndOtherFeesOnMultiProductsAuth' : {method:"POST" , url : envService.read('SERVICE_DOMAIN')+ "/api/auth/fees/credit-based/multi"},
        'getSubscriptionItemPricing'  : {method:"GET" , url : envService.read('SERVICE_DOMAIN') + "/api/pub/subscription/pricing/:id",params: {id: '@id'}},
        // 'getSubscriptionTopupPricing'  : {method:"GET" , url : envService.read('SERVICE_DOMAIN') + "/api/pub/subscription/pricing?filter=topup", isArray : true},
        'getAllSubscriptionPricingAdmin'  : {method:"GET" , url : envService.read('SERVICE_DOMAIN') + "/api/auth/admin/subscription/pricing", isArray : true},
        'updateSubscriptionPricingAdmin' : {method:"PUT" , url : envService.read('SERVICE_DOMAIN') + "/api/auth/admin/subscription/pricing/:id",params: {id: '@id'} },
        'getAllUserSubscriptionAdmin'  : {
          method:"GET" , 
          url : envService.read('SERVICE_DOMAIN')  + "/api/auth/admin/credit/balance?country=:country", 
          isArray : true,
          params: {
            country: '@country'
          }
        },
        'listUserCreditAdmin'  : {method:"GET" , url : envService.read('SERVICE_DOMAIN') + "/api/auth/admin/credit/list/:uid", params: {uid: '@uid'}, isArray : true},
        'cancelSubscriptionAndVoidCreditAdmin'  : {method:"POST" , url : envService.read('SERVICE_DOMAIN') + "/api/auth/admin/subscription/cancel-and-void/:subscriptionId", params: {subscriptionId: '@subscriptionId'}},
        'cancelSubscriptionOnlyAdmin'  : {method:"POST" , url : envService.read('SERVICE_DOMAIN') + "/api/auth/admin/subscription/cancel/:subscriptionId", params: {subscriptionId: '@subscriptionId'}},
        'voidCreditAdmin'  : {method:"POST" , url : envService.read('SERVICE_DOMAIN') + "/api/auth/admin/credit/void/:id", params: {id: '@id'}},
        'buySubscriptionAdmin'  : {method:"POST" , url : envService.read('SERVICE_DOMAIN') + "/api/auth/admin/subscription/buy/:pricingId/:userId", params: {pricingId: '@pricingId', userId:'@userId'}},
        'getTodayHKT'  : {method:"GET" , url : envService.read('SERVICE_DOMAIN') + "/api/pub/now"},
        'getNextMonthHKT'  : {method:"GET" , url : envService.read('SERVICE_DOMAIN') + "/api/pub/next-month"},
        'getSubscriptionTopupPricing'  : {
          method:"GET", 
          url : envService.read('SERVICE_DOMAIN') + "/api/pub/subscription/topup/pricing?country=:country", 
          isArray : true,
          params: {
            country: '@country'
          }
        },
        'checkSubscriptionItemPricePub'  : {
          method:"GET" , 
          url : envService.read('SERVICE_DOMAIN') + "/api/pub/subscription/price-check/:id?promo=:pCode&country=:country",
          params: {
            id: '@id', 
            pCode : '@pCode',
            country: '@country'
          }
        },
        'checkSubscriptionItemPriceAuth'  : {
          method:"GET" , 
          url : envService.read('SERVICE_DOMAIN') + "/api/auth/subscription/price-check/:id?promo=:pCode&country=:country",
          params: {
            id: '@id', 
            pCode : '@pCode',
            country: '@country'
          }
        },
        'buySubscriptionItemAuth'  : {method:"POST" , url : envService.read('SERVICE_DOMAIN') + "/api/auth/subscription/buy/:id?promo=:pCode",params: {id: '@id', pCode : '@pCode'}},
        'buySubscriptionItemPub'  : {method:"POST" , url : envService.read('SERVICE_DOMAIN') + "/api/pub/subscription/buy/:id?promo=:pCode",params: {id: '@id', pCode : '@pCode', tempToken: '@tempToken'}},
        'getCreditItemPricing'  : {method:"GET" , url : envService.read('SERVICE_DOMAIN') + "/api/pub/credit/pricing/:id",params: {id: '@id'}},
        'checkCreditItemPricePub'  : {
          method:"GET" , 
          url : envService.read('SERVICE_DOMAIN') + "/api/pub/credit/price-check/:id/:unit?promo=:pCode&country=:country",
          params: {
            id: '@id', 
            pCode : '@pCode', 
            unit: '@unit',
            country: '@country'
          }
        },
        'checkCreditItemPriceAuth'  : {
          method:"GET" , 
          url : envService.read('SERVICE_DOMAIN') + "/api/auth/credit/price-check/:id/:unit?promo=:pCode&country=:country",
          params: {
            id: '@id', 
            pCode : '@pCode', 
            unit: '@unit',
            country: '@country'
          }
        },
        'checkTopUpSubscriptionOrCreditPricePub'  : {
          method:"GET" , 
          url : envService.read('SERVICE_DOMAIN') + "/api/pub/credit/topup/price-check?promo=:pCode&subscribeId=:subscribeId&topupAfterSub=:topupAfterSub",
          params: {
            pCode : '@pCode', 
            subscribeId:'@subscribeId', 
            topupAfterSub: '@topupAfterSub',
            destinationCountry: '@destinationCountry',
            discountableCredits: '@discountableCredits',
            merchantPromo: '@merchantPromo'
          }
        },
        'checkTopUpSubscriptionOrCreditPriceAuth'  : {
          method:"GET" , 
          url : envService.read('SERVICE_DOMAIN') + "/api/auth/credit/topup/price-check?promo=:pCode&subscribeId=:subscribeId&topupAfterSub=:topupAfterSub",
          params: {
            pCode : '@pCode', 
            subscribeId:'@subscribeId', 
            topupAfterSub: '@topupAfterSub',
            destinationCountry: '@destinationCountry',
            discountableCredits: '@discountableCredits',
            merchantPromo: '@merchantPromo'
          }
        },
        'buyTopUpSubscriptionOrCredit'  : {
          method:"POST" , 
          url : envService.read('SERVICE_DOMAIN') + "/api/auth/credit/topup/buy?promo=:pCode&subscribeId=:subscribeId&topupAfterSub=:topupAfterSub&country=:country",
          params: {
            pCode : '@pCode', 
            subscribeId:'@subscribeId', 
            topupAfterSub: '@topupAfterSub', 
            country: '@country',
            discountableCredits: '@discountableCredits',
            merchantPromo: '@merchantPromo'
          }
        },
        'getCreditPackage'  : {
          method:"GET", 
          url : envService.read('SERVICE_DOMAIN') + "/api/pub/credit/package",
          isArray : true,
          params: {
            country: '@country'
          }
        },
        'buyCreditPackageAuth'  : {
          method:"POST", 
          url : envService.read('SERVICE_DOMAIN') + "/api/auth/credit/buy-package/:id",
          params: {
            id: '@id', 
            country: '@country'
          }
        },
        'buyCreditPackagePub'  : {
          method:"POST", 
          url : envService.read('SERVICE_DOMAIN') + "/api/pub/credit/buy-package/:id",
          params: {
            id: '@id', 
            country: '@country',
            tempToken: '@tempToken'
          }
        },
        'buyCreditItem'  : {
          method:"POST", 
          url : envService.read('SERVICE_DOMAIN') + "/api/auth/credit/buy/:id/:unit?promo=:pCode",
          params: {
            id: '@id', 
            pCode : '@pCode', 
            unit: '@unit'
          }
        },
        'history' : { 
          method: "GET", 
          url: envService.read('SERVICE_DOMAIN') + "/api/auth/rentals?country=:country",
          isArray : true,
          params: {
            country: '@country'
          }
        },
        'buyNow' : { 
          method: "POST", 
          url: envService.read('SERVICE_DOMAIN')  + "/api/auth/rental/:id/buy-now",
          params: {
            id : '@id',
            country: '@country',
            currency: '@currency',
            exchangeRate: '@exchangeRate'
          } 
        },
        'retrieveMerchantToCustomerAddress' : { 
          method: "GET", 
          url: envService.read('SERVICE_DOMAIN') + "/api/auth/rental/address/:id/get"
        },
        'updateOfferPreference' : { 
          method: "POST", 
          url: envService.read('SERVICE_DOMAIN')  + "/api/auth/rental/update-preference",
        },
        'scheduleReturn' : { 
          method: "POST", 
          url: envService.read('SERVICE_DOMAIN')  + "/api/auth/rental/schedule-return",
        },
        'getOverduePayments' : {
          method:"GET" ,           
          url : envService.read('SERVICE_DOMAIN') + "/api/auth/admin/rental/overdue",
          isArray : true, 
        },
        'preauthOverduePayment' : { 
          method: "GET", 
          url: envService.read('SERVICE_DOMAIN') + "/api/auth/admin/rental/overdue/invoice/preauth/:invoiceId"
        },
        'chargeOverduePayment' : { 
          method: "GET", 
          url: envService.read('SERVICE_DOMAIN') + "/api/auth/admin/rental/overdue/invoice/charge/:invoiceId"
        },
      });

    rentalService.updateOfferPreference = function(req) {
        return rentalService.api.updateOfferPreference(req);
    };
    rentalService.scheduleReturn = function(req) {
        return rentalService.api.scheduleReturn(req);
    };

    rentalService.requestRentalMultiItems = function(checkoutProducts) {

      //CONVER THE UTC DATE FORMAT TO YYYYMMDD
      // checkoutProducts.products.map(p=> moment(Number(p.startDate)).format('YYYYMMDD'));
      checkoutProducts.products.forEach(function(part, index, theArray) {
        theArray[index].startDate = moment(Number(theArray[index].startDate)).format("YYYYMMDD");
        theArray[index].endDate = moment(Number(theArray[index].endDate)).format("YYYYMMDD");
      });
      return rentalService.api.requestRentalMultiItems(checkoutProducts);
    };

    rentalService.requestRentalMultiItemsCreditBased = function(checkoutProducts) {
      //CONVERT THE UTC DATE FORMAT TO YYYYMMDD
      checkoutProducts.products.forEach(function(part, index, theArray) {
        theArray[index].startDate = moment(Number(theArray[index].startDate)).format("YYYYMMDD");
        theArray[index].endDate = moment(Number(theArray[index].endDate)).format("YYYYMMDD");
      });
      return rentalService.api.requestRentalMultiItemsCreditBased(checkoutProducts);
    }

    rentalService.getRentalFeesWithPromoCodeOnMultiItems = function(queryProducts) {
      return rentalService.api.getRentalFeesWithPromoCodeOnMultiItems(queryProducts);
    };

    rentalService.getCreditAndOtherFeesOnMultiProducts = function(queryProducts, isAuth) {
      queryProducts.products.forEach(function(part, index, theArray) {
        theArray[index].startDate = moment(Number(theArray[index].startDate)).format("YYYYMMDD");
        theArray[index].endDate = moment(Number(theArray[index].endDate)).format("YYYYMMDD");
      });
      if (isAuth) return rentalService.api.getCreditAndOtherFeesOnMultiProductsAuth(queryProducts);
      return rentalService.api.getCreditAndOtherFeesOnMultiProductsPub(queryProducts);
    };

    rentalService.getRentalFeesWithPromoCode = function(productID,promoCode) {
      return rentalService.api.getRentalFeesWithPromoCode({'productID': productID,"pCode": promoCode, 'exchangeRate': $rootScope.geoLocation.rate});
    };

    rentalService.getItemPricing = function(id, isBuyCredit) {
      if (isBuyCredit){
        return rentalService.api.getCreditItemPricing({'id': id});
      } else {
        return rentalService.api.getSubscriptionItemPricing({'id': id});
      }
    };
    rentalService.getAllSubscriptionPricingAdmin = function() {
        return rentalService.api.getAllSubscriptionPricingAdmin();
    }
    rentalService.getAllUserSubscriptionAdmin = function() {
        return rentalService.api.getAllUserSubscriptionAdmin({'country' : $rootScope.geoLocation.country});
    }
    rentalService.listUserCreditAdmin = function(uid) {
        return rentalService.api.listUserCreditAdmin({'uid' : uid});
    }
    rentalService.cancelSubscriptionAndVoidCreditAdmin= function(subscriptionId) {
        return rentalService.api.cancelSubscriptionAndVoidCreditAdmin({'subscriptionId' : subscriptionId});
    }
    rentalService.cancelSubscriptionOnlyAdmin= function(subscriptionId) {
        return rentalService.api.cancelSubscriptionOnlyAdmin({'subscriptionId' : subscriptionId});
    }
    rentalService.voidCreditAdmin= function(id) {
        return rentalService.api.voidCreditAdmin({'id' : id});
    }
    rentalService.buySubscriptionAdmin= function(pricingId, userId) {
        return rentalService.api.buySubscriptionAdmin({'pricingId' : pricingId,'userId': userId});
    }
    rentalService.getTodayHKT = function() {
        return rentalService.api.getTodayHKT();
    }
    rentalService.getNextMonthHKT= function() {
        return rentalService.api.getNextMonthHKT();
    }
    rentalService.updateSubscriptionPricingAdmin = function(refID,row) {
      return rentalService.api.updateSubscriptionPricingAdmin({'id' : refID},row);
    };
    rentalService.getSubscriptionTopupPricing = function(id, isBuyCredit) {
        return rentalService.api.getSubscriptionTopupPricing({'country': $rootScope.geoLocation.country});
    }
    rentalService.checkCreditItemPrice= function(id, unit, pCode, isAuth) {
      if (isAuth) return rentalService.api.checkCreditItemPriceAuth({'id': id, 'pCode':pCode, 'unit': unit, 'country': $rootScope.geoLocation.country});
      return rentalService.api.checkCreditItemPricePub({'id': id, 'pCode':pCode, 'unit': unit, 'country': $rootScope.geoLocation.country});
    };

    rentalService.checkSubscriptionItemPrice= function(id, pCode, isAuth) {
      if (isAuth) return rentalService.api.checkSubscriptionItemPriceAuth({'id': id, 'pCode':pCode, 'country': $rootScope.geoLocation.country});
      return rentalService.api.checkSubscriptionItemPricePub({'id': id, 'pCode':pCode, 'country': $rootScope.geoLocation.country});
    };

    rentalService.buySubscriptionOrCreditItem = function(id, pCode, unit, isBuyCredit) {
      if (AuthService.isAuthenticated()){
        if (isBuyCredit){
              return rentalService.api.buyCreditItem({'id': id, 'pCode':pCode, 'unit':unit});
        } else return rentalService.api.buySubscriptionItemAuth({'id': id, 'pCode':pCode});
      } else {
        if (!isBuyCredit) return rentalService.api.buySubscriptionItemPub({'id': id, 'pCode':pCode, 'tempToken':$rootScope.tempToken});
      }
    };

    rentalService.buyCreditPackage = function(id, country) {
      if (AuthService.isAuthenticated()){
        return rentalService.api.buyCreditPackageAuth({'id': id, 'country':country});
      } else {
        return rentalService.api.buyCreditPackagePub({'id': id, 'country':country, 'tempToken':$rootScope.tempToken});
      }
    };

    rentalService.checkTopUpSubscriptionOrCreditPrice= function(subscribeId, pCode, topupAfterSub, isAuth, discountableCredits, merchantPromo) {
      if (isAuth){
             return rentalService.api.checkTopUpSubscriptionOrCreditPriceAuth({
               'subscribeId': subscribeId, 
               'pCode':pCode, 
               'topupAfterSub':topupAfterSub, 
               'destinationCountry': $rootScope.geoLocation.country,
               'currency': $rootScope.geoLocation.currency,
               'exchangeRate': $rootScope.geoLocation.rate,
               'discountableCredits': discountableCredits,
               'merchantPromo': merchantPromo
              });
      } else return rentalService.api.checkTopUpSubscriptionOrCreditPricePub({
        'subscribeId': subscribeId, 
        'pCode':pCode, 
        'topupAfterSub':topupAfterSub, 
        'destinationCountry': $rootScope.geoLocation.country,
        'currency': $rootScope.geoLocation.currency,
        'exchangeRate': $rootScope.geoLocation.rate,
        'discountableCredits': discountableCredits,
        'merchantPromo': merchantPromo
      });
    };
    rentalService.buyTopUpSubscriptionOrCredit= function(subscribeId, pCode, topupAfterSub, discountableCredits, merchantPromo) {
        return rentalService.api.buyTopUpSubscriptionOrCredit({
        'subscribeId': subscribeId, 
        'pCode':pCode, 
        'topupAfterSub':topupAfterSub, 
        'country': $rootScope.geoLocation.country, 
        'discountableCredits': discountableCredits,
        'merchantPromo': merchantPromo
      });
    };
    rentalService.getOrderDetails = function(orderID) {
      return rentalService.api.getOrderDetails({'orderID' : orderID});
    };

    rentalService.getRentalPeriod = function(listingID) {
      return rentalService.api.getRentalPeriod({'id' : listingID});
    };

    rentalService.getAllowedDates= function(listingID) {
      return rentalService.api.getAllowedDates();
    };

    rentalService.getAllowedDatesV3= function(destinationCountry) {
      return rentalService.api.getAllowedDatesV3({'destinationCountry': destinationCountry});
    };

    rentalService.getAllowedDatesV4= function(destinationCountry, merchantId, productId) {
      return rentalService.api.getAllowedDatesV4(
        {
          'destinationCountry': destinationCountry,
          'merchantId': merchantId,
          'productId': productId
        });
    };

    rentalService.pendingCount = function() {
      return rentalService.api.pendingCount();
    };

    rentalService.history = function(country) {
      return rentalService.api.history({'country': country});
    };

    rentalService.approvalPending = function(refID,rentalDate) {
      return rentalService.api.approvalPending({'id' : refID},{'startDate':rentalDate.START_DATE,'endDate':rentalDate.RETURN_DATE});
    };

    rentalService.approvalRentalRequestV2 = function(refID,rentalDate) {
      return rentalService.api.approvalRentalRequestV2({'id' : refID},{'startDate':rentalDate.START_DATE,'endDate':rentalDate.RETURN_DATE});
    };

    rentalService.declinePending = function(refID) {
      return rentalService.api.declinePending({'id' : refID});
    };

    rentalService.pendingApproval = function() {
      return rentalService.api.pendingApproval(updateImageURL);
    };

    rentalService.pendingApprovalV2 = function() {
      return rentalService.api.pendingApprovalV2(updateImageURLV2);
    };

    rentalService.allRentalOrders = function() {
      return rentalService.api.allRentalOrders(updateImageURLV2);
    };

    rentalService.getAwaitingDispatchRentals = function() {
      return rentalService.api.getAwaitingDispatchRentals(updateImageURLV2);
    };

    rentalService.getCreditCardInfo = function() {
      return rentalService.api.getCreditCardInfo({'country': $rootScope.geoLocation.country});
    };

    rentalService.preCheck = function() {
      return rentalService.api.preCheck({'country': $rootScope.geoLocation.country});
    };

    rentalService.saveStripeToken = function(stripeToken, addressObj) {
      var ctry = addressObj.country ? addressObj.country : "HK";
      if (AuthService.isAuthenticated()){
        return rentalService.api.saveStripeTokenAuth({
          'token' : stripeToken, 
          'country': ctry, 
          'district': addressObj.district, 
          'postalCode': addressObj.postalCode
        });
      } else {
        return rentalService.api.saveStripeTokenPub({
          'token' : stripeToken, 
          'tempToken': $rootScope.tempToken, 
          'country': ctry, 
          'district': addressObj.district, 
          'postalCode': addressObj.postalCode});
      }
    };

    rentalService.requestRental = function(id, pCode, startDate) {
      return rentalService.api.requestRental({'id' : id,'promo': pCode, 'startDate':startDate});
    };

    rentalService.acceptRentalRequest = function(req) {
      return rentalService.api.acceptRentalRequest(req);
    };

    rentalService.declineRentalRequest = function(req) {
      return rentalService.api.declineRentalRequest(req);
    };

    rentalService.buyNow = function(rentalID, country, currency, exchangeRate) {
      return rentalService.api.buyNow(
        {
          'id' : rentalID,
          'country': country,
          'currency': currency,
          'exchangeRate': exchangeRate
        });
    };

    rentalService.retrieveMerchantToCustomerAddress = function(rentalID) {
      return rentalService.api.retrieveMerchantToCustomerAddress({'id' : rentalID});
    };

    rentalService.captureCheckout = function(checkedOutProducts, fee){
      checkedOutProducts.products.forEach(function(part, index, theArray) {
      if (theArray[index].productId ==null) return;

      ListingService.getListing(theArray[index].productId).$promise.then(
        function(resp) {
          let prodObj = resp;
          let currentUser = localStorageService.get('user');
          let geoLocation = $rootScope.geoLocation;//localStorageService.get('geoLocation');
          let sessionCurrency = geoLocation ? geoLocation.currency : "HKD";
          let sessionCountry = geoLocation ? geoLocation.country : "HK";
          let discounterItemPrice = prodObj.discountRate > 0 ? prodObj.price*(1-prodObj.discountRate) : prodObj.price;
          
          var purchasedObj = theArray[index];
          var cartID = purchasedObj ? (purchasedObj.cartID ? purchasedObj.cartID : prodObj.id) : prodObj.id;
          dataLayer.push({ ecommerce: null });  
          dataLayer.push({
            "environment" : envService.environment === "production" ? "prod" : "dev",
            "currentUserID" : currentUser ? currentUser.userid : "guest",
            "currentUserName" : currentUser ? currentUser.firstName + " " + currentUser.lastName : "guest",
            "currentUserEmail" : currentUser ? currentUser.email : "guest",
            "masterID": cartID,
            "size": purchasedObj ? purchasedObj.size : "no-size-defined",
            "country": sessionCountry ? sessionCountry : "HK",
            "color": prodObj ? prodObj.color : "Multicolor",
            "subCategory": prodObj ? (prodObj.subCategory ? prodObj.subCategory.name : prodObj.category)  : prodObj.category,
            
            'checkoutReference': fee.checkoutReference,
            'orderSubTotal': fee.orderSubTotal,
            'subscriptionFee': fee.subscriptionFee,
            'shippingFee': fee.shippingFee,
            'promoDiscount': fee.promoDiscount,
            'rentalCredit': fee.rentalCredit,
            'rentalCreditValue': fee.rentalCreditValue,
            'stylePassDiscount': fee.stylePassDiscount,
            'totalDue': fee.totalDue,

            event: "purchase",
            ecommerce: {
              currency: sessionCurrency ? sessionCurrency : "HKD",
              value: discounterItemPrice,
              transaction_id: currentUser.userid + "-" + prodObj.id,
              items: [{
                item_name: prodObj.productLine,       
                item_id: prodObj.id,
                price: prodObj.price,
                item_brand: prodObj.brand,
                item_category: prodObj.category.name
              }]}
          });

          fbq('track', 'Purchase', 
          {
            content_ids: [
              prodObj.id,
            ], 
            content_name: prodObj.productLine,
            content_type: "product",
            contents: [{'id': prodObj.id, 'quantity': 1}],
            currency: sessionCurrency ? sessionCurrency : "HKD",
            value: prodObj.price
          });

      });


      });
    };

    rentalService.getCreditPackage = function(country) {
      return rentalService.api.getCreditPackage({'country': country});
    };

    rentalService.getOverduePayments = function() {
      return rentalService.api.getOverduePayments();
    };

    rentalService.preauthOverduePayment = function(invoiceId) {
      return rentalService.api.preauthOverduePayment({'invoiceId': invoiceId});
    };

    rentalService.chargeOverduePayment = function(invoiceId) {
      return rentalService.api.chargeOverduePayment({'invoiceId': invoiceId});
    };

    return rentalService;
  }]);

'use strict';

/**
 * @ngdoc service
 * @name coutureApp.TransactionService
 * @description
 * # TransactionService
 * Factory in the coutureApp.
 */
angular.module('coutureApp')
  .factory('TransactionService', ["$resource", "envService", "CONFIG", "moment", "AuthService", "$rootScope", function ($resource, envService,CONFIG,moment,AuthService,$rootScope) {

    var transactionService = {};
    function base64toBlob(base64Data, contentType) {
      contentType = contentType || '';
      var sliceSize = 1024;
      var byteCharacters = atob(base64Data);
      var bytesLength = byteCharacters.length;
      var slicesCount = Math.ceil(bytesLength / sliceSize);
      var byteArrays = new Array(slicesCount);
  
      for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
          var begin = sliceIndex * sliceSize;
          var end = Math.min(begin + sliceSize, bytesLength);
  
          var bytes = new Array(end - begin);
          for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
              bytes[i] = byteCharacters[offset].charCodeAt(0);
          }
          byteArrays[sliceIndex] = new Uint8Array(bytes);
      }
      return new Blob(byteArrays, { type: contentType });
  }
    var transformFileDownload = function(data, headers) {
      var filename = headers('X-filename');
      var contentType = headers('content-type');
      var linkElement = document.createElement('a');
      try {
          var blob = base64toBlob(data, contentType);
          var url = window.URL.createObjectURL(blob);

          linkElement.setAttribute('href', url);
          linkElement.setAttribute("download", filename);

          var clickEvent = new MouseEvent("click", {
              "view": window,
              "bubbles": true,
              "cancelable": false
          });
          linkElement.dispatchEvent(clickEvent);
      } catch (err) {
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":transformFileDownload - Failed") :'';
      }
  }

    //This is a wrapper endpoint that will process both purchase and rent backend
    // Interact with the RESTful API of the server.
    transactionService.api = $resource(
      envService.read('SERVICE_DOMAIN') + "/api/transaction/auth/request/precheck",
      {}, // param defaults
      {
        'requestMultiItems' : { 
          method: "POST", 
          url: envService.read('SERVICE_DOMAIN') + "/api/transaction/auth/request/multi"
        },
        'requestsCount' : { 
          method: "GET", 
          url: envService.read('SERVICE_DOMAIN') + "/api/transaction/auth/count-requests"
        },
        'viewInvoice' : { 
          method: "GET", 
          url: envService.read('SERVICE_DOMAIN')+ "/api/transaction/auth/invoice/:checkoutReferenceNumber/view",
          params: {
            checkoutReferenceNumber : '@checkoutReferenceNumber'
          }
        },
        'downloadInvoice' : { 
          method: "GET", 
          url: envService.read('SERVICE_DOMAIN') + "/api/transaction/auth/invoice/:checkoutReferenceNumber/download",
          params: {
            checkoutReferenceNumber : '@checkoutReferenceNumber'
          }
        },
        'createSelfDispatch': {
          method: "POST",
          url: envService.read('SERVICE_DOMAIN')+ "/api/transaction/auth/shipping/create-self-dispatch"
        },
        'downloadTransactionList':{
          method:"GET",
          url: envService.read('SERVICE_DOMAIN')+ "/api/v2/transaction/auth/admin/download", 
          timeout: 300000,
          transformResponse: transformFileDownload
        },
      });

    
      transactionService.requestMultiItems = function(checkoutProducts) {
        checkoutProducts.products.forEach(function(part, index, theArray) {
          theArray[index].startDate = moment(Number(theArray[index].startDate)).format("YYYYMMDD");
          theArray[index].endDate = moment(Number(theArray[index].endDate)).format("YYYYMMDD");
        }); 
        return transactionService.api.requestMultiItems(checkoutProducts);
      }

      transactionService.requestsCount = function() {
        return transactionService.api.requestsCount();
      };

      transactionService.viewInvoice = function(checkoutReferenceNumber) {
        return transactionService.api.viewInvoice({'checkoutReferenceNumber' : checkoutReferenceNumber});
      };

      transactionService.createSelfDispatch = function(shipmentDetails) {
        return transactionService.api.createSelfDispatch({}, shipmentDetails);
      };

      transactionService.downloadTransactionList = function() {
        return transactionService.api.downloadTransactionList();
      }

    return transactionService;
  }]);

'use strict';

/**
 * @ngdoc service
 * @name coutureApp.BuyService
 * @description
 * # BuyService
 * Factory in the coutureApp.
 */
angular.module('coutureApp')
  .factory('BuyService', ["$resource", "envService", "CONFIG", "moment", "AuthService", "$rootScope", "ListingService", "localStorageService", function ($resource, envService,CONFIG,moment,AuthService,$rootScope,ListingService, localStorageService) {

    var buyService = {};
    
    var updateImageURL = function(resp){
      for (var i = 0; i < resp.length; i++) {
        resp[i].product.pictures.forEach(function(item) {
            item._url = item.pathSrc === 'shopify' ? item.path : envService.read('IMG_DOMAIN') + "/" + item.path;
        });
      }
    };

    var isAuth = function() {
      if (AuthService.isAuthenticated()) {
          return "auth";
      } else {
          return "pub";
      }
    };

    // Interact with the RESTful API of the server.
    buyService.api = $resource(
      envService.read('SERVICE_DOMAIN') + "/api/buy/auth/precheck",
      {}, // param defaults
      {
        'getPendingBuyRequests' : { 
          method: "GET", 
          url: envService.read('SERVICE_DOMAIN') + "/api/buy/auth/list/pending-requests",
          isArray : true
        },
        'getAllBuyOrders' : { 
          method: "GET", 
          url: envService.read('SERVICE_DOMAIN')+ "/api/buy/auth/list/buy-requests",
          isArray : true
        },
        'getAllBuyOrdersByCustomer' : { 
          method: "GET", 
          url: envService.read('SERVICE_DOMAIN') + "/api/buy/auth/list/customer-buy-requests",
          isArray : true
        },
        'approveRequest' : { 
          method: "PUT", url: envService.read('SERVICE_DOMAIN') + "/api/buy/auth/request/:purchaseId/acceptance",
          params: {purchaseId : '@purchaseId'} 
        },
        'approveRequestV2' : { 
          method: "PUT", 
          url: envService.read('SERVICE_DOMAIN') + "/api/v2/buy/auth/request/:purchaseId/acceptance",
          params: {
            purchaseId : '@purchaseId'
          } 
        },
        'declineRequest' : { 
          method: "PUT", url: envService.read('SERVICE_DOMAIN') + "/api/buy/auth/request/:purchaseId/decline",
          params: {purchaseId : '@purchaseId'} 
        },
        'getOrderDetails' : {
          method:"GET" , 
          url : envService.read('SERVICE_DOMAIN')  + "/api/buy/auth/admin/get/:purchaseId",
          params: {
            purchaseId : '@purchaseId'
          } 
        },
        'getOtherFees' : {
          method:"POST" , 
          url : envService.read('SERVICE_DOMAIN') + "/api/:isAuth/fees/buy/calculate-fee",
          params: {
            isAuth: '@isAuth'
        }
        },
        'retrieveMerchantToCustomerAddress' : { 
          method: "GET", 
          url: envService.read('SERVICE_DOMAIN') + "/api/buy/auth/address/:id/get"
        },
        'getAwaitingDispatchPurchases' : { 
          method: "GET", 
          url: envService.read('SERVICE_DOMAIN')+ "/api/buy/auth/list/awaiting-dispatch",
          isArray : true
        },
      });

      buyService.getPendingBuyRequests = function() {
        return buyService.api.getPendingBuyRequests(updateImageURL);
      };

      buyService.getAwaitingDispatchPurchases = function() {
        return buyService.api.getAwaitingDispatchPurchases(updateImageURL);
      };

      buyService.getOrderDetails = function(purchaseId) {
        return buyService.api.getOrderDetails({'purchaseId' : purchaseId});
      };

      buyService.getAllBuyOrders = function() {
        return buyService.api.getAllBuyOrders(updateImageURL);
      };

      buyService.getAllBuyOrdersByCustomer = function() {
        return buyService.api.getAllBuyOrdersByCustomer(updateImageURL);
      };

      buyService.approveRequest = function(purchaseId) {
        return buyService.api.approveRequest({'purchaseId' : purchaseId});
      };

      buyService.approveRequestV2 = function(purchaseId) {
        return buyService.api.approveRequestV2({'purchaseId' : purchaseId});
      };

      buyService.declineRequest = function(purchaseId) {
        return buyService.api.declineRequest({'purchaseId' : purchaseId});
      };

      buyService.getOtherFees = function(products) {
        return buyService.api.getOtherFees({'isAuth': isAuth()}, products);
      };

      buyService.retrieveMerchantToCustomerAddress = function(purchaseId) {
        return buyService.api.retrieveMerchantToCustomerAddress({'id' : purchaseId});
      };

    return buyService;
  }]);

'use strict';

/**
 * @ngdoc service
 * @name coutureApp.PromoCodeService
 * @description
 * # Promote Code Service
 * Factory in the coutureApp.
 */
angular.module('coutureApp')
  .factory('PromoCodeService', ["$resource", "envService", "$rootScope", function ($resource, envService,$rootScope) {
    var promoCodeService = {};

    // Interact with the RESTful API of the server.
    promoCodeService.api = $resource(
        envService.read('SERVICE_DOMAIN') + "/api/",
        {}, // param defaults
        {
          'create' : { method: "POST",
          url: envService.read('SERVICE_DOMAIN') + "/api/auth/admin/promo"
        },
          'listActive' : { method: "GET",
          url: envService.read('SERVICE_DOMAIN') + "/api/auth/admin/promo",
          isArray: true
        },
          'listConsumed' : { method: "GET",
          url: envService.read('SERVICE_DOMAIN') + "/api/auth/admin/promo/consumed",
          isArray: true
        },
        'delete': {
            method: "DELETE",
            url: envService.read('SERVICE_DOMAIN') + "/api/auth/admin/promo/:id",
            params: {
                id: '@id'
            },
            transformResponse: function (data) {
              //RETURN VALUE AS STRING. SUCCESS/FAIL
              //CONVERT IT TO JSON.
              return {'status':data}
            }
        },
        'getPromo' : { method: "GET",
          url: envService.read('SERVICE_DOMAIN') + "/api/auth/promo/get",
          params: {
            code: '@code',
            country: '@country'
          }
        }
    });

    promoCodeService.create = function(promoCodeRequest) {
      //ARG1: PARAMS
      //ARG2: POST DATA
      return promoCodeService.api.create({},promoCodeRequest);
    };

    promoCodeService.listActive = function() {
      //ARG1: PARAMS
      //ARG2: POST DATA
      return promoCodeService.api.listActive({},{});
    };

    promoCodeService.listConsumed = function() {
      //ARG1: PARAMS
      //ARG2: POST DATA
      return promoCodeService.api.listConsumed({},{});
    };

    promoCodeService.delete = function(id) {
      //ARG1: PARAMS
      //ARG2: POST DATA
      return promoCodeService.api.delete(  {'id': id},{});
    };

    promoCodeService.getPromo = function(code) {
      //ARG1: PARAMS
      //ARG2: POST DATA
      return promoCodeService.api.getPromo({'code': code,'country':$rootScope.geoLocation.country});
    };
    // Public API here
    return promoCodeService;
  }]);

/**
 * A directive to embed a Disqus comments widget on your AngularJS page.
 *
 * Created by Michael on 22/01/14.
 * Modified by Serkan "coni2k" Holat on 24/02/16.
 * Copyright Michael Bromley 2014
 * Available under the MIT license.
 * https://github.com/michaelbromley/angularUtils/tree/master/src/directives/disqus
 */
'use strict';
(function () {

    /**
     * Config
     */
    var moduleName = 'angularUtils.directives.dirDisqus';

    /**
     * Module
     */
    var module;
    try {
        module = angular.module(moduleName);
    } catch (err) {
        // named module does not exist, so create one
        module = angular.module(moduleName, []);
    }

    module.directive('dirDisqus', ['$window', function ($window) {
        return {
            restrict: 'E',
            scope: {
                config: '='
            },
            template: '<div id="disqus_thread"></div>',
            link: function (scope) {

                scope.$watch('config', configChanged, true);

                function configChanged() {

                    // Ensure that the disqus_identifier and disqus_url are both set, otherwise we will run in to identifier conflicts when using URLs with "#" in them
                    // see http://help.disqus.com/customer/portal/articles/662547-why-are-the-same-comments-showing-up-on-multiple-pages-
                    if (!scope.config.disqus_shortname ||
                        !scope.config.disqus_identifier ||
                        !scope.config.disqus_url) {
                        return;
                    }

                    $window.disqus_shortname = scope.config.disqus_shortname;
                    $window.disqus_identifier = scope.config.disqus_identifier;
                    $window.disqus_url = scope.config.disqus_url;
                    $window.disqus_title = scope.config.disqus_title;
                    $window.disqus_category_id = scope.config.disqus_category_id;
                    $window.disqus_disable_mobile = scope.config.disqus_disable_mobile;
                    $window.disqus_config = function () {
                        this.language = scope.config.disqus_config_language;
                        this.page.remote_auth_s3 = scope.config.disqus_remote_auth_s3;
                        this.page.api_key = scope.config.disqus_public_api_key;
                        this.page.secret_api_key = scope.config.disqus_public_secret_key;

                        // This adds the custom login/logout functionality
                        this.sso = {
                              name:   scope.config.disqus_sso_name,
                              button:  scope.config.disqus_sso_button,
                              icon:    scope.config.disqus_sso_icon,
                              url:     scope.config.disqus_sso_url,
                              logout:  scope.config.disqus_sso_logout,
                              width:   scope.config.disqus_sso_width,
                              height:  scope.config.disqus_sso_height
                        };

                        if (scope.config.disqus_on_ready) {
                            this.callbacks.onReady = [function () {
                                scope.config.disqus_on_ready();
                            }];
                        }
                    };

                    // Get the remote Disqus script and insert it into the DOM, but only if it not already loaded (as that will cause warnings)
                    if (!$window.DISQUS) {
                        var d = document, s = d.createElement('script');
                        s.src = '//' + scope.config.disqus_shortname + '.disqus.com/embed.js';
                        s.setAttribute('data-timestamp', +new Date());
                        (d.head || d.body).appendChild(s);

                    } else {
                        $window.DISQUS.reset({
                            reload: true,
                            config: function () {
                                this.page.identifier = scope.config.disqus_identifier;
                                this.page.url = scope.config.disqus_url;
                                this.page.title = scope.config.disqus_title;
                                this.language = scope.config.disqus_config_language;
                                this.page.remote_auth_s3 = scope.config.disqus_remote_auth_s3;
                                this.page.api_key = scope.config.disqus_public_api_key;
                                this.page.secret_api_key = scope.config.disqus_public_secret_key;
                            }
                        });
                    }
                }
            }
        };
    }]);
})();

/*
CryptoJS v3.1.2
code.google.com/p/crypto-js
(c) 2009-2013 by Jeff Mott. All rights reserved.
code.google.com/p/crypto-js/wiki/License
*/
'use strict';
var CryptoJS=CryptoJS||function(g,l){var e={},d=e.lib={},m=function(){},k=d.Base={extend:function(a){m.prototype=this;var c=new m;a&&c.mixIn(a);c.hasOwnProperty("init")||(c.init=function(){c.$super.init.apply(this,arguments)});c.init.prototype=c;c.$super=this;return c},create:function(){var a=this.extend();a.init.apply(a,arguments);return a},init:function(){},mixIn:function(a){for(var c in a)a.hasOwnProperty(c)&&(this[c]=a[c]);a.hasOwnProperty("toString")&&(this.toString=a.toString)},clone:function(){return this.init.prototype.extend(this)}},
p=d.WordArray=k.extend({init:function(a,c){a=this.words=a||[];this.sigBytes=c!=l?c:4*a.length},toString:function(a){return(a||n).stringify(this)},concat:function(a){var c=this.words,q=a.words,f=this.sigBytes;a=a.sigBytes;this.clamp();if(f%4)for(var b=0;b<a;b++)c[f+b>>>2]|=(q[b>>>2]>>>24-8*(b%4)&255)<<24-8*((f+b)%4);else if(65535<q.length)for(b=0;b<a;b+=4)c[f+b>>>2]=q[b>>>2];else c.push.apply(c,q);this.sigBytes+=a;return this},clamp:function(){var a=this.words,c=this.sigBytes;a[c>>>2]&=4294967295<<
32-8*(c%4);a.length=g.ceil(c/4)},clone:function(){var a=k.clone.call(this);a.words=this.words.slice(0);return a},random:function(a){for(var c=[],b=0;b<a;b+=4)c.push(4294967296*g.random()|0);return new p.init(c,a)}}),b=e.enc={},n=b.Hex={stringify:function(a){var c=a.words;a=a.sigBytes;for(var b=[],f=0;f<a;f++){var d=c[f>>>2]>>>24-8*(f%4)&255;b.push((d>>>4).toString(16));b.push((d&15).toString(16))}return b.join("")},parse:function(a){for(var c=a.length,b=[],f=0;f<c;f+=2)b[f>>>3]|=parseInt(a.substr(f,
2),16)<<24-4*(f%8);return new p.init(b,c/2)}},j=b.Latin1={stringify:function(a){var c=a.words;a=a.sigBytes;for(var b=[],f=0;f<a;f++)b.push(String.fromCharCode(c[f>>>2]>>>24-8*(f%4)&255));return b.join("")},parse:function(a){for(var c=a.length,b=[],f=0;f<c;f++)b[f>>>2]|=(a.charCodeAt(f)&255)<<24-8*(f%4);return new p.init(b,c)}},h=b.Utf8={stringify:function(a){try{return decodeURIComponent(escape(j.stringify(a)))}catch(c){throw Error("Malformed UTF-8 data");}},parse:function(a){return j.parse(unescape(encodeURIComponent(a)))}},
r=d.BufferedBlockAlgorithm=k.extend({reset:function(){this._data=new p.init;this._nDataBytes=0},_append:function(a){"string"==typeof a&&(a=h.parse(a));this._data.concat(a);this._nDataBytes+=a.sigBytes},_process:function(a){var c=this._data,b=c.words,f=c.sigBytes,d=this.blockSize,e=f/(4*d),e=a?g.ceil(e):g.max((e|0)-this._minBufferSize,0);a=e*d;f=g.min(4*a,f);if(a){for(var k=0;k<a;k+=d)this._doProcessBlock(b,k);k=b.splice(0,a);c.sigBytes-=f}return new p.init(k,f)},clone:function(){var a=k.clone.call(this);
a._data=this._data.clone();return a},_minBufferSize:0});d.Hasher=r.extend({cfg:k.extend(),init:function(a){this.cfg=this.cfg.extend(a);this.reset()},reset:function(){r.reset.call(this);this._doReset()},update:function(a){this._append(a);this._process();return this},finalize:function(a){a&&this._append(a);return this._doFinalize()},blockSize:16,_createHelper:function(a){return function(b,d){return(new a.init(d)).finalize(b)}},_createHmacHelper:function(a){return function(b,d){return(new s.HMAC.init(a,
d)).finalize(b)}}});var s=e.algo={};return e}(Math);
(function(){var g=CryptoJS,l=g.lib,e=l.WordArray,d=l.Hasher,m=[],l=g.algo.SHA1=d.extend({_doReset:function(){this._hash=new e.init([1732584193,4023233417,2562383102,271733878,3285377520])},_doProcessBlock:function(d,e){for(var b=this._hash.words,n=b[0],j=b[1],h=b[2],g=b[3],l=b[4],a=0;80>a;a++){if(16>a)m[a]=d[e+a]|0;else{var c=m[a-3]^m[a-8]^m[a-14]^m[a-16];m[a]=c<<1|c>>>31}c=(n<<5|n>>>27)+l+m[a];c=20>a?c+((j&h|~j&g)+1518500249):40>a?c+((j^h^g)+1859775393):60>a?c+((j&h|j&g|h&g)-1894007588):c+((j^h^
g)-899497514);l=g;g=h;h=j<<30|j>>>2;j=n;n=c}b[0]=b[0]+n|0;b[1]=b[1]+j|0;b[2]=b[2]+h|0;b[3]=b[3]+g|0;b[4]=b[4]+l|0},_doFinalize:function(){var d=this._data,e=d.words,b=8*this._nDataBytes,g=8*d.sigBytes;e[g>>>5]|=128<<24-g%32;e[(g+64>>>9<<4)+14]=Math.floor(b/4294967296);e[(g+64>>>9<<4)+15]=b;d.sigBytes=4*e.length;this._process();return this._hash},clone:function(){var e=d.clone.call(this);e._hash=this._hash.clone();return e}});g.SHA1=d._createHelper(l);g.HmacSHA1=d._createHmacHelper(l)})();
(function(){var g=CryptoJS,l=g.enc.Utf8;g.algo.HMAC=g.lib.Base.extend({init:function(e,d){e=this._hasher=new e.init;"string"==typeof d&&(d=l.parse(d));var g=e.blockSize,k=4*g;d.sigBytes>k&&(d=e.finalize(d));d.clamp();for(var p=this._oKey=d.clone(),b=this._iKey=d.clone(),n=p.words,j=b.words,h=0;h<g;h++)n[h]^=1549556828,j[h]^=909522486;p.sigBytes=b.sigBytes=k;this.reset()},reset:function(){var e=this._hasher;e.reset();e.update(this._iKey)},update:function(e){this._hasher.update(e);return this},finalize:function(e){var d=
this._hasher;e=d.finalize(e);d.reset();return d.finalize(this._oKey.clone().concat(e))}})})();

/**
 * @license
 * Lodash lodash.com/license | Underscore.js 1.8.3 underscorejs.org/LICENSE
 */
;(function(){function n(n,t){return n.set(t[0],t[1]),n}function t(n,t){return n.add(t),n}function r(n,t,r){switch(r.length){case 0:return n.call(t);case 1:return n.call(t,r[0]);case 2:return n.call(t,r[0],r[1]);case 3:return n.call(t,r[0],r[1],r[2])}return n.apply(t,r)}function e(n,t,r,e){for(var u=-1,i=null==n?0:n.length;++u<i;){var o=n[u];t(e,o,r(o),n)}return e}function u(n,t){for(var r=-1,e=null==n?0:n.length;++r<e&&false!==t(n[r],r,n););return n}function i(n,t){for(var r=null==n?0:n.length;r--&&false!==t(n[r],r,n););
return n}function o(n,t){for(var r=-1,e=null==n?0:n.length;++r<e;)if(!t(n[r],r,n))return false;return true}function f(n,t){for(var r=-1,e=null==n?0:n.length,u=0,i=[];++r<e;){var o=n[r];t(o,r,n)&&(i[u++]=o)}return i}function c(n,t){return!(null==n||!n.length)&&-1<d(n,t,0)}function a(n,t,r){for(var e=-1,u=null==n?0:n.length;++e<u;)if(r(t,n[e]))return true;return false}function l(n,t){for(var r=-1,e=null==n?0:n.length,u=Array(e);++r<e;)u[r]=t(n[r],r,n);return u}function s(n,t){for(var r=-1,e=t.length,u=n.length;++r<e;)n[u+r]=t[r];
return n}function h(n,t,r,e){var u=-1,i=null==n?0:n.length;for(e&&i&&(r=n[++u]);++u<i;)r=t(r,n[u],u,n);return r}function p(n,t,r,e){var u=null==n?0:n.length;for(e&&u&&(r=n[--u]);u--;)r=t(r,n[u],u,n);return r}function _(n,t){for(var r=-1,e=null==n?0:n.length;++r<e;)if(t(n[r],r,n))return true;return false}function v(n,t,r){var e;return r(n,function(n,r,u){if(t(n,r,u))return e=r,false}),e}function g(n,t,r,e){var u=n.length;for(r+=e?1:-1;e?r--:++r<u;)if(t(n[r],r,n))return r;return-1}function d(n,t,r){if(t===t)n:{
--r;for(var e=n.length;++r<e;)if(n[r]===t){n=r;break n}n=-1}else n=g(n,b,r);return n}function y(n,t,r,e){--r;for(var u=n.length;++r<u;)if(e(n[r],t))return r;return-1}function b(n){return n!==n}function x(n,t){var r=null==n?0:n.length;return r?k(n,t)/r:P}function j(n){return function(t){return null==t?F:t[n]}}function w(n){return function(t){return null==n?F:n[t]}}function m(n,t,r,e,u){return u(n,function(n,u,i){r=e?(e=false,n):t(r,n,u,i)}),r}function A(n,t){var r=n.length;for(n.sort(t);r--;)n[r]=n[r].c;
return n}function k(n,t){for(var r,e=-1,u=n.length;++e<u;){var i=t(n[e]);i!==F&&(r=r===F?i:r+i)}return r}function E(n,t){for(var r=-1,e=Array(n);++r<n;)e[r]=t(r);return e}function O(n,t){return l(t,function(t){return[t,n[t]]})}function S(n){return function(t){return n(t)}}function I(n,t){return l(t,function(t){return n[t]})}function R(n,t){return n.has(t)}function z(n,t){for(var r=-1,e=n.length;++r<e&&-1<d(t,n[r],0););return r}function W(n,t){for(var r=n.length;r--&&-1<d(t,n[r],0););return r}function B(n){
return"\\"+Tn[n]}function L(n){var t=-1,r=Array(n.size);return n.forEach(function(n,e){r[++t]=[e,n]}),r}function U(n,t){return function(r){return n(t(r))}}function C(n,t){for(var r=-1,e=n.length,u=0,i=[];++r<e;){var o=n[r];o!==t&&"__lodash_placeholder__"!==o||(n[r]="__lodash_placeholder__",i[u++]=r)}return i}function D(n){var t=-1,r=Array(n.size);return n.forEach(function(n){r[++t]=n}),r}function M(n){var t=-1,r=Array(n.size);return n.forEach(function(n){r[++t]=[n,n]}),r}function T(n){if(Bn.test(n)){
for(var t=zn.lastIndex=0;zn.test(n);)++t;n=t}else n=tt(n);return n}function $(n){return Bn.test(n)?n.match(zn)||[]:n.split("")}var F,N=1/0,P=NaN,Z=[["ary",128],["bind",1],["bindKey",2],["curry",8],["curryRight",16],["flip",512],["partial",32],["partialRight",64],["rearg",256]],q=/\b__p\+='';/g,V=/\b(__p\+=)''\+/g,K=/(__e\(.*?\)|\b__t\))\+'';/g,G=/&(?:amp|lt|gt|quot|#39);/g,H=/[&<>"']/g,J=RegExp(G.source),Y=RegExp(H.source),Q=/<%-([\s\S]+?)%>/g,X=/<%([\s\S]+?)%>/g,nn=/<%=([\s\S]+?)%>/g,tn=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,rn=/^\w*$/,en=/^\./,un=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,on=/[\\^$.*+?()[\]{}|]/g,fn=RegExp(on.source),cn=/^\s+|\s+$/g,an=/^\s+/,ln=/\s+$/,sn=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,hn=/\{\n\/\* \[wrapped with (.+)\] \*/,pn=/,? & /,_n=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,vn=/\\(\\)?/g,gn=/\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,dn=/\w*$/,yn=/^[-+]0x[0-9a-f]+$/i,bn=/^0b[01]+$/i,xn=/^\[object .+?Constructor\]$/,jn=/^0o[0-7]+$/i,wn=/^(?:0|[1-9]\d*)$/,mn=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,An=/($^)/,kn=/['\n\r\u2028\u2029\\]/g,En="[\\ufe0e\\ufe0f]?(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?(?:\\u200d(?:[^\\ud800-\\udfff]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff])[\\ufe0e\\ufe0f]?(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?)*",On="(?:[\\u2700-\\u27bf]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff])"+En,Sn="(?:[^\\ud800-\\udfff][\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]?|[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff]|[\\ud800-\\udfff])",In=RegExp("['\u2019]","g"),Rn=RegExp("[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]","g"),zn=RegExp("\\ud83c[\\udffb-\\udfff](?=\\ud83c[\\udffb-\\udfff])|"+Sn+En,"g"),Wn=RegExp(["[A-Z\\xc0-\\xd6\\xd8-\\xde]?[a-z\\xdf-\\xf6\\xf8-\\xff]+(?:['\u2019](?:d|ll|m|re|s|t|ve))?(?=[\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000]|[A-Z\\xc0-\\xd6\\xd8-\\xde]|$)|(?:[A-Z\\xc0-\\xd6\\xd8-\\xde]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])+(?:['\u2019](?:D|LL|M|RE|S|T|VE))?(?=[\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000]|[A-Z\\xc0-\\xd6\\xd8-\\xde](?:[a-z\\xdf-\\xf6\\xf8-\\xff]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])|$)|[A-Z\\xc0-\\xd6\\xd8-\\xde]?(?:[a-z\\xdf-\\xf6\\xf8-\\xff]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])+(?:['\u2019](?:d|ll|m|re|s|t|ve))?|[A-Z\\xc0-\\xd6\\xd8-\\xde]+(?:['\u2019](?:D|LL|M|RE|S|T|VE))?|\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)|\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)|\\d+",On].join("|"),"g"),Bn=RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]"),Ln=/[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,Un="Array Buffer DataView Date Error Float32Array Float64Array Function Int8Array Int16Array Int32Array Map Math Object Promise RegExp Set String Symbol TypeError Uint8Array Uint8ClampedArray Uint16Array Uint32Array WeakMap _ clearTimeout isFinite parseInt setTimeout".split(" "),Cn={};
Cn["[object Float32Array]"]=Cn["[object Float64Array]"]=Cn["[object Int8Array]"]=Cn["[object Int16Array]"]=Cn["[object Int32Array]"]=Cn["[object Uint8Array]"]=Cn["[object Uint8ClampedArray]"]=Cn["[object Uint16Array]"]=Cn["[object Uint32Array]"]=true,Cn["[object Arguments]"]=Cn["[object Array]"]=Cn["[object ArrayBuffer]"]=Cn["[object Boolean]"]=Cn["[object DataView]"]=Cn["[object Date]"]=Cn["[object Error]"]=Cn["[object Function]"]=Cn["[object Map]"]=Cn["[object Number]"]=Cn["[object Object]"]=Cn["[object RegExp]"]=Cn["[object Set]"]=Cn["[object String]"]=Cn["[object WeakMap]"]=false;
var Dn={};Dn["[object Arguments]"]=Dn["[object Array]"]=Dn["[object ArrayBuffer]"]=Dn["[object DataView]"]=Dn["[object Boolean]"]=Dn["[object Date]"]=Dn["[object Float32Array]"]=Dn["[object Float64Array]"]=Dn["[object Int8Array]"]=Dn["[object Int16Array]"]=Dn["[object Int32Array]"]=Dn["[object Map]"]=Dn["[object Number]"]=Dn["[object Object]"]=Dn["[object RegExp]"]=Dn["[object Set]"]=Dn["[object String]"]=Dn["[object Symbol]"]=Dn["[object Uint8Array]"]=Dn["[object Uint8ClampedArray]"]=Dn["[object Uint16Array]"]=Dn["[object Uint32Array]"]=true,
Dn["[object Error]"]=Dn["[object Function]"]=Dn["[object WeakMap]"]=false;var Mn,Tn={"\\":"\\","'":"'","\n":"n","\r":"r","\u2028":"u2028","\u2029":"u2029"},$n=parseFloat,Fn=parseInt,Nn=typeof global=="object"&&global&&global.Object===Object&&global,Pn=typeof self=="object"&&self&&self.Object===Object&&self,Zn=Nn||Pn||Function("return this")(),qn=typeof exports=="object"&&exports&&!exports.nodeType&&exports,Vn=qn&&typeof module=="object"&&module&&!module.nodeType&&module,Kn=Vn&&Vn.exports===qn,Gn=Kn&&Nn.process;
n:{try{Mn=Gn&&Gn.binding&&Gn.binding("util");break n}catch(n){}Mn=void 0}var Hn=Mn&&Mn.isArrayBuffer,Jn=Mn&&Mn.isDate,Yn=Mn&&Mn.isMap,Qn=Mn&&Mn.isRegExp,Xn=Mn&&Mn.isSet,nt=Mn&&Mn.isTypedArray,tt=j("length"),rt=w({"\xc0":"A","\xc1":"A","\xc2":"A","\xc3":"A","\xc4":"A","\xc5":"A","\xe0":"a","\xe1":"a","\xe2":"a","\xe3":"a","\xe4":"a","\xe5":"a","\xc7":"C","\xe7":"c","\xd0":"D","\xf0":"d","\xc8":"E","\xc9":"E","\xca":"E","\xcb":"E","\xe8":"e","\xe9":"e","\xea":"e","\xeb":"e","\xcc":"I","\xcd":"I","\xce":"I",
"\xcf":"I","\xec":"i","\xed":"i","\xee":"i","\xef":"i","\xd1":"N","\xf1":"n","\xd2":"O","\xd3":"O","\xd4":"O","\xd5":"O","\xd6":"O","\xd8":"O","\xf2":"o","\xf3":"o","\xf4":"o","\xf5":"o","\xf6":"o","\xf8":"o","\xd9":"U","\xda":"U","\xdb":"U","\xdc":"U","\xf9":"u","\xfa":"u","\xfb":"u","\xfc":"u","\xdd":"Y","\xfd":"y","\xff":"y","\xc6":"Ae","\xe6":"ae","\xde":"Th","\xfe":"th","\xdf":"ss","\u0100":"A","\u0102":"A","\u0104":"A","\u0101":"a","\u0103":"a","\u0105":"a","\u0106":"C","\u0108":"C","\u010a":"C",
"\u010c":"C","\u0107":"c","\u0109":"c","\u010b":"c","\u010d":"c","\u010e":"D","\u0110":"D","\u010f":"d","\u0111":"d","\u0112":"E","\u0114":"E","\u0116":"E","\u0118":"E","\u011a":"E","\u0113":"e","\u0115":"e","\u0117":"e","\u0119":"e","\u011b":"e","\u011c":"G","\u011e":"G","\u0120":"G","\u0122":"G","\u011d":"g","\u011f":"g","\u0121":"g","\u0123":"g","\u0124":"H","\u0126":"H","\u0125":"h","\u0127":"h","\u0128":"I","\u012a":"I","\u012c":"I","\u012e":"I","\u0130":"I","\u0129":"i","\u012b":"i","\u012d":"i",
"\u012f":"i","\u0131":"i","\u0134":"J","\u0135":"j","\u0136":"K","\u0137":"k","\u0138":"k","\u0139":"L","\u013b":"L","\u013d":"L","\u013f":"L","\u0141":"L","\u013a":"l","\u013c":"l","\u013e":"l","\u0140":"l","\u0142":"l","\u0143":"N","\u0145":"N","\u0147":"N","\u014a":"N","\u0144":"n","\u0146":"n","\u0148":"n","\u014b":"n","\u014c":"O","\u014e":"O","\u0150":"O","\u014d":"o","\u014f":"o","\u0151":"o","\u0154":"R","\u0156":"R","\u0158":"R","\u0155":"r","\u0157":"r","\u0159":"r","\u015a":"S","\u015c":"S",
"\u015e":"S","\u0160":"S","\u015b":"s","\u015d":"s","\u015f":"s","\u0161":"s","\u0162":"T","\u0164":"T","\u0166":"T","\u0163":"t","\u0165":"t","\u0167":"t","\u0168":"U","\u016a":"U","\u016c":"U","\u016e":"U","\u0170":"U","\u0172":"U","\u0169":"u","\u016b":"u","\u016d":"u","\u016f":"u","\u0171":"u","\u0173":"u","\u0174":"W","\u0175":"w","\u0176":"Y","\u0177":"y","\u0178":"Y","\u0179":"Z","\u017b":"Z","\u017d":"Z","\u017a":"z","\u017c":"z","\u017e":"z","\u0132":"IJ","\u0133":"ij","\u0152":"Oe","\u0153":"oe",
"\u0149":"'n","\u017f":"s"}),et=w({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}),ut=w({"&amp;":"&","&lt;":"<","&gt;":">","&quot;":'"',"&#39;":"'"}),it=function w(En){function On(n){if(xu(n)&&!af(n)&&!(n instanceof Mn)){if(n instanceof zn)return n;if(ci.call(n,"__wrapped__"))return Pe(n)}return new zn(n)}function Sn(){}function zn(n,t){this.__wrapped__=n,this.__actions__=[],this.__chain__=!!t,this.__index__=0,this.__values__=F}function Mn(n){this.__wrapped__=n,this.__actions__=[],this.__dir__=1,
this.__filtered__=false,this.__iteratees__=[],this.__takeCount__=4294967295,this.__views__=[]}function Tn(n){var t=-1,r=null==n?0:n.length;for(this.clear();++t<r;){var e=n[t];this.set(e[0],e[1])}}function Nn(n){var t=-1,r=null==n?0:n.length;for(this.clear();++t<r;){var e=n[t];this.set(e[0],e[1])}}function Pn(n){var t=-1,r=null==n?0:n.length;for(this.clear();++t<r;){var e=n[t];this.set(e[0],e[1])}}function qn(n){var t=-1,r=null==n?0:n.length;for(this.__data__=new Pn;++t<r;)this.add(n[t])}function Vn(n){
this.size=(this.__data__=new Nn(n)).size}function Gn(n,t){var r,e=af(n),u=!e&&cf(n),i=!e&&!u&&sf(n),o=!e&&!u&&!i&&gf(n),u=(e=e||u||i||o)?E(n.length,ri):[],f=u.length;for(r in n)!t&&!ci.call(n,r)||e&&("length"==r||i&&("offset"==r||"parent"==r)||o&&("buffer"==r||"byteLength"==r||"byteOffset"==r)||Re(r,f))||u.push(r);return u}function tt(n){var t=n.length;return t?n[cr(0,t-1)]:F}function ot(n,t){return Te(Mr(n),gt(t,0,n.length))}function ft(n){return Te(Mr(n))}function ct(n,t,r){(r===F||hu(n[t],r))&&(r!==F||t in n)||_t(n,t,r);
}function at(n,t,r){var e=n[t];ci.call(n,t)&&hu(e,r)&&(r!==F||t in n)||_t(n,t,r)}function lt(n,t){for(var r=n.length;r--;)if(hu(n[r][0],t))return r;return-1}function st(n,t,r,e){return oo(n,function(n,u,i){t(e,n,r(n),i)}),e}function ht(n,t){return n&&Tr(t,Lu(t),n)}function pt(n,t){return n&&Tr(t,Uu(t),n)}function _t(n,t,r){"__proto__"==t&&Ei?Ei(n,t,{configurable:true,enumerable:true,value:r,writable:true}):n[t]=r}function vt(n,t){for(var r=-1,e=t.length,u=Hu(e),i=null==n;++r<e;)u[r]=i?F:Wu(n,t[r]);return u;
}function gt(n,t,r){return n===n&&(r!==F&&(n=n<=r?n:r),t!==F&&(n=n>=t?n:t)),n}function dt(n,t,r,e,i,o){var f,c=1&t,a=2&t,l=4&t;if(r&&(f=i?r(n,e,i,o):r(n)),f!==F)return f;if(!bu(n))return n;if(e=af(n)){if(f=Ee(n),!c)return Mr(n,f)}else{var s=yo(n),h="[object Function]"==s||"[object GeneratorFunction]"==s;if(sf(n))return Wr(n,c);if("[object Object]"==s||"[object Arguments]"==s||h&&!i){if(f=a||h?{}:Oe(n),!c)return a?Fr(n,pt(f,n)):$r(n,ht(f,n))}else{if(!Dn[s])return i?n:{};f=Se(n,s,dt,c)}}if(o||(o=new Vn),
i=o.get(n))return i;o.set(n,f);var a=l?a?ye:de:a?Uu:Lu,p=e?F:a(n);return u(p||n,function(e,u){p&&(u=e,e=n[u]),at(f,u,dt(e,t,r,u,n,o))}),f}function yt(n){var t=Lu(n);return function(r){return bt(r,n,t)}}function bt(n,t,r){var e=r.length;if(null==n)return!e;for(n=ni(n);e--;){var u=r[e],i=t[u],o=n[u];if(o===F&&!(u in n)||!i(o))return false}return true}function xt(n,t,r){if(typeof n!="function")throw new ei("Expected a function");return jo(function(){n.apply(F,r)},t)}function jt(n,t,r,e){var u=-1,i=c,o=true,f=n.length,s=[],h=t.length;
if(!f)return s;r&&(t=l(t,S(r))),e?(i=a,o=false):200<=t.length&&(i=R,o=false,t=new qn(t));n:for(;++u<f;){var p=n[u],_=null==r?p:r(p),p=e||0!==p?p:0;if(o&&_===_){for(var v=h;v--;)if(t[v]===_)continue n;s.push(p)}else i(t,_,e)||s.push(p)}return s}function wt(n,t){var r=true;return oo(n,function(n,e,u){return r=!!t(n,e,u)}),r}function mt(n,t,r){for(var e=-1,u=n.length;++e<u;){var i=n[e],o=t(i);if(null!=o&&(f===F?o===o&&!Au(o):r(o,f)))var f=o,c=i}return c}function At(n,t){var r=[];return oo(n,function(n,e,u){
t(n,e,u)&&r.push(n)}),r}function kt(n,t,r,e,u){var i=-1,o=n.length;for(r||(r=Ie),u||(u=[]);++i<o;){var f=n[i];0<t&&r(f)?1<t?kt(f,t-1,r,e,u):s(u,f):e||(u[u.length]=f)}return u}function Et(n,t){return n&&co(n,t,Lu)}function Ot(n,t){return n&&ao(n,t,Lu)}function St(n,t){return f(t,function(t){return gu(n[t])})}function It(n,t){t=Rr(t,n);for(var r=0,e=t.length;null!=n&&r<e;)n=n[$e(t[r++])];return r&&r==e?n:F}function Rt(n,t,r){return t=t(n),af(n)?t:s(t,r(n))}function zt(n){if(null==n)n=n===F?"[object Undefined]":"[object Null]";else if(ki&&ki in ni(n)){
var t=ci.call(n,ki),r=n[ki];try{n[ki]=F;var e=true}catch(n){}var u=si.call(n);e&&(t?n[ki]=r:delete n[ki]),n=u}else n=si.call(n);return n}function Wt(n,t){return n>t}function Bt(n,t){return null!=n&&ci.call(n,t)}function Lt(n,t){return null!=n&&t in ni(n)}function Ut(n,t,r){for(var e=r?a:c,u=n[0].length,i=n.length,o=i,f=Hu(i),s=1/0,h=[];o--;){var p=n[o];o&&t&&(p=l(p,S(t))),s=Mi(p.length,s),f[o]=!r&&(t||120<=u&&120<=p.length)?new qn(o&&p):F}var p=n[0],_=-1,v=f[0];n:for(;++_<u&&h.length<s;){var g=p[_],d=t?t(g):g,g=r||0!==g?g:0;
if(v?!R(v,d):!e(h,d,r)){for(o=i;--o;){var y=f[o];if(y?!R(y,d):!e(n[o],d,r))continue n}v&&v.push(d),h.push(g)}}return h}function Ct(n,t,r){var e={};return Et(n,function(n,u,i){t(e,r(n),u,i)}),e}function Dt(n,t,e){return t=Rr(t,n),n=2>t.length?n:It(n,vr(t,0,-1)),t=null==n?n:n[$e(Ge(t))],null==t?F:r(t,n,e)}function Mt(n){return xu(n)&&"[object Arguments]"==zt(n)}function Tt(n){return xu(n)&&"[object ArrayBuffer]"==zt(n)}function $t(n){return xu(n)&&"[object Date]"==zt(n)}function Ft(n,t,r,e,u){if(n===t)t=true;else if(null==n||null==t||!xu(n)&&!xu(t))t=n!==n&&t!==t;else n:{
var i=af(n),o=af(t),f=i?"[object Array]":yo(n),c=o?"[object Array]":yo(t),f="[object Arguments]"==f?"[object Object]":f,c="[object Arguments]"==c?"[object Object]":c,a="[object Object]"==f,o="[object Object]"==c;if((c=f==c)&&sf(n)){if(!sf(t)){t=false;break n}i=true,a=false}if(c&&!a)u||(u=new Vn),t=i||gf(n)?_e(n,t,r,e,Ft,u):ve(n,t,f,r,e,Ft,u);else{if(!(1&r)&&(i=a&&ci.call(n,"__wrapped__"),f=o&&ci.call(t,"__wrapped__"),i||f)){n=i?n.value():n,t=f?t.value():t,u||(u=new Vn),t=Ft(n,t,r,e,u);break n}if(c)t:if(u||(u=new Vn),
i=1&r,f=de(n),o=f.length,c=de(t).length,o==c||i){for(a=o;a--;){var l=f[a];if(!(i?l in t:ci.call(t,l))){t=false;break t}}if((c=u.get(n))&&u.get(t))t=c==t;else{c=true,u.set(n,t),u.set(t,n);for(var s=i;++a<o;){var l=f[a],h=n[l],p=t[l];if(e)var _=i?e(p,h,l,t,n,u):e(h,p,l,n,t,u);if(_===F?h!==p&&!Ft(h,p,r,e,u):!_){c=false;break}s||(s="constructor"==l)}c&&!s&&(r=n.constructor,e=t.constructor,r!=e&&"constructor"in n&&"constructor"in t&&!(typeof r=="function"&&r instanceof r&&typeof e=="function"&&e instanceof e)&&(c=false)),
u.delete(n),u.delete(t),t=c}}else t=false;else t=false}}return t}function Nt(n){return xu(n)&&"[object Map]"==yo(n)}function Pt(n,t,r,e){var u=r.length,i=u,o=!e;if(null==n)return!i;for(n=ni(n);u--;){var f=r[u];if(o&&f[2]?f[1]!==n[f[0]]:!(f[0]in n))return false}for(;++u<i;){var f=r[u],c=f[0],a=n[c],l=f[1];if(o&&f[2]){if(a===F&&!(c in n))return false}else{if(f=new Vn,e)var s=e(a,l,c,n,t,f);if(s===F?!Ft(l,a,3,e,f):!s)return false}}return true}function Zt(n){return!(!bu(n)||li&&li in n)&&(gu(n)?_i:xn).test(Fe(n))}function qt(n){
return xu(n)&&"[object RegExp]"==zt(n)}function Vt(n){return xu(n)&&"[object Set]"==yo(n)}function Kt(n){return xu(n)&&yu(n.length)&&!!Cn[zt(n)]}function Gt(n){return typeof n=="function"?n:null==n?Nu:typeof n=="object"?af(n)?Xt(n[0],n[1]):Qt(n):Vu(n)}function Ht(n){if(!Le(n))return Ci(n);var t,r=[];for(t in ni(n))ci.call(n,t)&&"constructor"!=t&&r.push(t);return r}function Jt(n,t){return n<t}function Yt(n,t){var r=-1,e=pu(n)?Hu(n.length):[];return oo(n,function(n,u,i){e[++r]=t(n,u,i)}),e}function Qt(n){
var t=me(n);return 1==t.length&&t[0][2]?Ue(t[0][0],t[0][1]):function(r){return r===n||Pt(r,n,t)}}function Xt(n,t){return We(n)&&t===t&&!bu(t)?Ue($e(n),t):function(r){var e=Wu(r,n);return e===F&&e===t?Bu(r,n):Ft(t,e,3)}}function nr(n,t,r,e,u){n!==t&&co(t,function(i,o){if(bu(i)){u||(u=new Vn);var f=u,c=n[o],a=t[o],l=f.get(a);if(l)ct(n,o,l);else{var l=e?e(c,a,o+"",n,t,f):F,s=l===F;if(s){var h=af(a),p=!h&&sf(a),_=!h&&!p&&gf(a),l=a;h||p||_?af(c)?l=c:_u(c)?l=Mr(c):p?(s=false,l=Wr(a,true)):_?(s=false,l=Lr(a,true)):l=[]:wu(a)||cf(a)?(l=c,
cf(c)?l=Ru(c):(!bu(c)||r&&gu(c))&&(l=Oe(a))):s=false}s&&(f.set(a,l),nr(l,a,r,e,f),f.delete(a)),ct(n,o,l)}}else f=e?e(n[o],i,o+"",n,t,u):F,f===F&&(f=i),ct(n,o,f)},Uu)}function tr(n,t){var r=n.length;if(r)return t+=0>t?r:0,Re(t,r)?n[t]:F}function rr(n,t,r){var e=-1;return t=l(t.length?t:[Nu],S(je())),n=Yt(n,function(n){return{a:l(t,function(t){return t(n)}),b:++e,c:n}}),A(n,function(n,t){var e;n:{e=-1;for(var u=n.a,i=t.a,o=u.length,f=r.length;++e<o;){var c=Ur(u[e],i[e]);if(c){e=e>=f?c:c*("desc"==r[e]?-1:1);
break n}}e=n.b-t.b}return e})}function er(n,t){return ur(n,t,function(t,r){return Bu(n,r)})}function ur(n,t,r){for(var e=-1,u=t.length,i={};++e<u;){var o=t[e],f=It(n,o);r(f,o)&&pr(i,Rr(o,n),f)}return i}function ir(n){return function(t){return It(t,n)}}function or(n,t,r,e){var u=e?y:d,i=-1,o=t.length,f=n;for(n===t&&(t=Mr(t)),r&&(f=l(n,S(r)));++i<o;)for(var c=0,a=t[i],a=r?r(a):a;-1<(c=u(f,a,c,e));)f!==n&&wi.call(f,c,1),wi.call(n,c,1);return n}function fr(n,t){for(var r=n?t.length:0,e=r-1;r--;){var u=t[r];
if(r==e||u!==i){var i=u;Re(u)?wi.call(n,u,1):mr(n,u)}}}function cr(n,t){return n+zi(Fi()*(t-n+1))}function ar(n,t){var r="";if(!n||1>t||9007199254740991<t)return r;do t%2&&(r+=n),(t=zi(t/2))&&(n+=n);while(t);return r}function lr(n,t){return wo(Ce(n,t,Nu),n+"")}function sr(n){return tt(Du(n))}function hr(n,t){var r=Du(n);return Te(r,gt(t,0,r.length))}function pr(n,t,r,e){if(!bu(n))return n;t=Rr(t,n);for(var u=-1,i=t.length,o=i-1,f=n;null!=f&&++u<i;){var c=$e(t[u]),a=r;if(u!=o){var l=f[c],a=e?e(l,c,f):F;
a===F&&(a=bu(l)?l:Re(t[u+1])?[]:{})}at(f,c,a),f=f[c]}return n}function _r(n){return Te(Du(n))}function vr(n,t,r){var e=-1,u=n.length;for(0>t&&(t=-t>u?0:u+t),r=r>u?u:r,0>r&&(r+=u),u=t>r?0:r-t>>>0,t>>>=0,r=Hu(u);++e<u;)r[e]=n[e+t];return r}function gr(n,t){var r;return oo(n,function(n,e,u){return r=t(n,e,u),!r}),!!r}function dr(n,t,r){var e=0,u=null==n?e:n.length;if(typeof t=="number"&&t===t&&2147483647>=u){for(;e<u;){var i=e+u>>>1,o=n[i];null!==o&&!Au(o)&&(r?o<=t:o<t)?e=i+1:u=i}return u}return yr(n,t,Nu,r);
}function yr(n,t,r,e){t=r(t);for(var u=0,i=null==n?0:n.length,o=t!==t,f=null===t,c=Au(t),a=t===F;u<i;){var l=zi((u+i)/2),s=r(n[l]),h=s!==F,p=null===s,_=s===s,v=Au(s);(o?e||_:a?_&&(e||h):f?_&&h&&(e||!p):c?_&&h&&!p&&(e||!v):p||v?0:e?s<=t:s<t)?u=l+1:i=l}return Mi(i,4294967294)}function br(n,t){for(var r=-1,e=n.length,u=0,i=[];++r<e;){var o=n[r],f=t?t(o):o;if(!r||!hu(f,c)){var c=f;i[u++]=0===o?0:o}}return i}function xr(n){return typeof n=="number"?n:Au(n)?P:+n}function jr(n){if(typeof n=="string")return n;
if(af(n))return l(n,jr)+"";if(Au(n))return uo?uo.call(n):"";var t=n+"";return"0"==t&&1/n==-N?"-0":t}function wr(n,t,r){var e=-1,u=c,i=n.length,o=true,f=[],l=f;if(r)o=false,u=a;else if(200<=i){if(u=t?null:po(n))return D(u);o=false,u=R,l=new qn}else l=t?[]:f;n:for(;++e<i;){var s=n[e],h=t?t(s):s,s=r||0!==s?s:0;if(o&&h===h){for(var p=l.length;p--;)if(l[p]===h)continue n;t&&l.push(h),f.push(s)}else u(l,h,r)||(l!==f&&l.push(h),f.push(s))}return f}function mr(n,t){return t=Rr(t,n),n=2>t.length?n:It(n,vr(t,0,-1)),
null==n||delete n[$e(Ge(t))]}function Ar(n,t,r,e){for(var u=n.length,i=e?u:-1;(e?i--:++i<u)&&t(n[i],i,n););return r?vr(n,e?0:i,e?i+1:u):vr(n,e?i+1:0,e?u:i)}function kr(n,t){var r=n;return r instanceof Mn&&(r=r.value()),h(t,function(n,t){return t.func.apply(t.thisArg,s([n],t.args))},r)}function Er(n,t,r){var e=n.length;if(2>e)return e?wr(n[0]):[];for(var u=-1,i=Hu(e);++u<e;)for(var o=n[u],f=-1;++f<e;)f!=u&&(i[u]=jt(i[u]||o,n[f],t,r));return wr(kt(i,1),t,r)}function Or(n,t,r){for(var e=-1,u=n.length,i=t.length,o={};++e<u;)r(o,n[e],e<i?t[e]:F);
return o}function Sr(n){return _u(n)?n:[]}function Ir(n){return typeof n=="function"?n:Nu}function Rr(n,t){return af(n)?n:We(n,t)?[n]:mo(zu(n))}function zr(n,t,r){var e=n.length;return r=r===F?e:r,!t&&r>=e?n:vr(n,t,r)}function Wr(n,t){if(t)return n.slice();var r=n.length,r=yi?yi(r):new n.constructor(r);return n.copy(r),r}function Br(n){var t=new n.constructor(n.byteLength);return new di(t).set(new di(n)),t}function Lr(n,t){return new n.constructor(t?Br(n.buffer):n.buffer,n.byteOffset,n.length)}function Ur(n,t){
if(n!==t){var r=n!==F,e=null===n,u=n===n,i=Au(n),o=t!==F,f=null===t,c=t===t,a=Au(t);if(!f&&!a&&!i&&n>t||i&&o&&c&&!f&&!a||e&&o&&c||!r&&c||!u)return 1;if(!e&&!i&&!a&&n<t||a&&r&&u&&!e&&!i||f&&r&&u||!o&&u||!c)return-1}return 0}function Cr(n,t,r,e){var u=-1,i=n.length,o=r.length,f=-1,c=t.length,a=Di(i-o,0),l=Hu(c+a);for(e=!e;++f<c;)l[f]=t[f];for(;++u<o;)(e||u<i)&&(l[r[u]]=n[u]);for(;a--;)l[f++]=n[u++];return l}function Dr(n,t,r,e){var u=-1,i=n.length,o=-1,f=r.length,c=-1,a=t.length,l=Di(i-f,0),s=Hu(l+a);
for(e=!e;++u<l;)s[u]=n[u];for(l=u;++c<a;)s[l+c]=t[c];for(;++o<f;)(e||u<i)&&(s[l+r[o]]=n[u++]);return s}function Mr(n,t){var r=-1,e=n.length;for(t||(t=Hu(e));++r<e;)t[r]=n[r];return t}function Tr(n,t,r,e){var u=!r;r||(r={});for(var i=-1,o=t.length;++i<o;){var f=t[i],c=e?e(r[f],n[f],f,r,n):F;c===F&&(c=n[f]),u?_t(r,f,c):at(r,f,c)}return r}function $r(n,t){return Tr(n,vo(n),t)}function Fr(n,t){return Tr(n,go(n),t)}function Nr(n,t){return function(r,u){var i=af(r)?e:st,o=t?t():{};return i(r,n,je(u,2),o);
}}function Pr(n){return lr(function(t,r){var e=-1,u=r.length,i=1<u?r[u-1]:F,o=2<u?r[2]:F,i=3<n.length&&typeof i=="function"?(u--,i):F;for(o&&ze(r[0],r[1],o)&&(i=3>u?F:i,u=1),t=ni(t);++e<u;)(o=r[e])&&n(t,o,e,i);return t})}function Zr(n,t){return function(r,e){if(null==r)return r;if(!pu(r))return n(r,e);for(var u=r.length,i=t?u:-1,o=ni(r);(t?i--:++i<u)&&false!==e(o[i],i,o););return r}}function qr(n){return function(t,r,e){var u=-1,i=ni(t);e=e(t);for(var o=e.length;o--;){var f=e[n?o:++u];if(false===r(i[f],f,i))break;
}return t}}function Vr(n,t,r){function e(){return(this&&this!==Zn&&this instanceof e?i:n).apply(u?r:this,arguments)}var u=1&t,i=Hr(n);return e}function Kr(n){return function(t){t=zu(t);var r=Bn.test(t)?$(t):F,e=r?r[0]:t.charAt(0);return t=r?zr(r,1).join(""):t.slice(1),e[n]()+t}}function Gr(n){return function(t){return h($u(Tu(t).replace(In,"")),n,"")}}function Hr(n){return function(){var t=arguments;switch(t.length){case 0:return new n;case 1:return new n(t[0]);case 2:return new n(t[0],t[1]);case 3:
return new n(t[0],t[1],t[2]);case 4:return new n(t[0],t[1],t[2],t[3]);case 5:return new n(t[0],t[1],t[2],t[3],t[4]);case 6:return new n(t[0],t[1],t[2],t[3],t[4],t[5]);case 7:return new n(t[0],t[1],t[2],t[3],t[4],t[5],t[6])}var r=io(n.prototype),t=n.apply(r,t);return bu(t)?t:r}}function Jr(n,t,e){function u(){for(var o=arguments.length,f=Hu(o),c=o,a=xe(u);c--;)f[c]=arguments[c];return c=3>o&&f[0]!==a&&f[o-1]!==a?[]:C(f,a),o-=c.length,o<e?fe(n,t,Xr,u.placeholder,F,f,c,F,F,e-o):r(this&&this!==Zn&&this instanceof u?i:n,this,f);
}var i=Hr(n);return u}function Yr(n){return function(t,r,e){var u=ni(t);if(!pu(t)){var i=je(r,3);t=Lu(t),r=function(n){return i(u[n],n,u)}}return r=n(t,r,e),-1<r?u[i?t[r]:r]:F}}function Qr(n){return ge(function(t){var r=t.length,e=r,u=zn.prototype.thru;for(n&&t.reverse();e--;){var i=t[e];if(typeof i!="function")throw new ei("Expected a function");if(u&&!o&&"wrapper"==be(i))var o=new zn([],true)}for(e=o?e:r;++e<r;)var i=t[e],u=be(i),f="wrapper"==u?_o(i):F,o=f&&Be(f[0])&&424==f[1]&&!f[4].length&&1==f[9]?o[be(f[0])].apply(o,f[3]):1==i.length&&Be(i)?o[u]():o.thru(i);
return function(){var n=arguments,e=n[0];if(o&&1==n.length&&af(e))return o.plant(e).value();for(var u=0,n=r?t[u].apply(this,n):e;++u<r;)n=t[u].call(this,n);return n}})}function Xr(n,t,r,e,u,i,o,f,c,a){function l(){for(var d=arguments.length,y=Hu(d),b=d;b--;)y[b]=arguments[b];if(_){var x,j=xe(l),b=y.length;for(x=0;b--;)y[b]===j&&++x}if(e&&(y=Cr(y,e,u,_)),i&&(y=Dr(y,i,o,_)),d-=x,_&&d<a)return j=C(y,j),fe(n,t,Xr,l.placeholder,r,y,j,f,c,a-d);if(j=h?r:this,b=p?j[n]:n,d=y.length,f){x=y.length;for(var w=Mi(f.length,x),m=Mr(y);w--;){
var A=f[w];y[w]=Re(A,x)?m[A]:F}}else v&&1<d&&y.reverse();return s&&c<d&&(y.length=c),this&&this!==Zn&&this instanceof l&&(b=g||Hr(b)),b.apply(j,y)}var s=128&t,h=1&t,p=2&t,_=24&t,v=512&t,g=p?F:Hr(n);return l}function ne(n,t){return function(r,e){return Ct(r,n,t(e))}}function te(n,t){return function(r,e){var u;if(r===F&&e===F)return t;if(r!==F&&(u=r),e!==F){if(u===F)return e;typeof r=="string"||typeof e=="string"?(r=jr(r),e=jr(e)):(r=xr(r),e=xr(e)),u=n(r,e)}return u}}function re(n){return ge(function(t){
return t=l(t,S(je())),lr(function(e){var u=this;return n(t,function(n){return r(n,u,e)})})})}function ee(n,t){t=t===F?" ":jr(t);var r=t.length;return 2>r?r?ar(t,n):t:(r=ar(t,Ri(n/T(t))),Bn.test(t)?zr($(r),0,n).join(""):r.slice(0,n))}function ue(n,t,e,u){function i(){for(var t=-1,c=arguments.length,a=-1,l=u.length,s=Hu(l+c),h=this&&this!==Zn&&this instanceof i?f:n;++a<l;)s[a]=u[a];for(;c--;)s[a++]=arguments[++t];return r(h,o?e:this,s)}var o=1&t,f=Hr(n);return i}function ie(n){return function(t,r,e){
e&&typeof e!="number"&&ze(t,r,e)&&(r=e=F),t=Eu(t),r===F?(r=t,t=0):r=Eu(r),e=e===F?t<r?1:-1:Eu(e);var u=-1;r=Di(Ri((r-t)/(e||1)),0);for(var i=Hu(r);r--;)i[n?r:++u]=t,t+=e;return i}}function oe(n){return function(t,r){return typeof t=="string"&&typeof r=="string"||(t=Iu(t),r=Iu(r)),n(t,r)}}function fe(n,t,r,e,u,i,o,f,c,a){var l=8&t,s=l?o:F;o=l?F:o;var h=l?i:F;return i=l?F:i,t=(t|(l?32:64))&~(l?64:32),4&t||(t&=-4),u=[n,t,u,h,s,i,o,f,c,a],r=r.apply(F,u),Be(n)&&xo(r,u),r.placeholder=e,De(r,n,t)}function ce(n){
var t=Xu[n];return function(n,r){if(n=Iu(n),r=null==r?0:Mi(Ou(r),292)){var e=(zu(n)+"e").split("e"),e=t(e[0]+"e"+(+e[1]+r)),e=(zu(e)+"e").split("e");return+(e[0]+"e"+(+e[1]-r))}return t(n)}}function ae(n){return function(t){var r=yo(t);return"[object Map]"==r?L(t):"[object Set]"==r?M(t):O(t,n(t))}}function le(n,t,r,e,u,i,o,f){var c=2&t;if(!c&&typeof n!="function")throw new ei("Expected a function");var a=e?e.length:0;if(a||(t&=-97,e=u=F),o=o===F?o:Di(Ou(o),0),f=f===F?f:Ou(f),a-=u?u.length:0,64&t){
var l=e,s=u;e=u=F}var h=c?F:_o(n);return i=[n,t,r,e,u,l,s,i,o,f],h&&(r=i[1],n=h[1],t=r|n,e=128==n&&8==r||128==n&&256==r&&i[7].length<=h[8]||384==n&&h[7].length<=h[8]&&8==r,131>t||e)&&(1&n&&(i[2]=h[2],t|=1&r?0:4),(r=h[3])&&(e=i[3],i[3]=e?Cr(e,r,h[4]):r,i[4]=e?C(i[3],"__lodash_placeholder__"):h[4]),(r=h[5])&&(e=i[5],i[5]=e?Dr(e,r,h[6]):r,i[6]=e?C(i[5],"__lodash_placeholder__"):h[6]),(r=h[7])&&(i[7]=r),128&n&&(i[8]=null==i[8]?h[8]:Mi(i[8],h[8])),null==i[9]&&(i[9]=h[9]),i[0]=h[0],i[1]=t),n=i[0],t=i[1],
r=i[2],e=i[3],u=i[4],f=i[9]=i[9]===F?c?0:n.length:Di(i[9]-a,0),!f&&24&t&&(t&=-25),De((h?lo:xo)(t&&1!=t?8==t||16==t?Jr(n,t,f):32!=t&&33!=t||u.length?Xr.apply(F,i):ue(n,t,r,e):Vr(n,t,r),i),n,t)}function se(n,t,r,e){return n===F||hu(n,ii[r])&&!ci.call(e,r)?t:n}function he(n,t,r,e,u,i){return bu(n)&&bu(t)&&(i.set(t,n),nr(n,t,F,he,i),i.delete(t)),n}function pe(n){return wu(n)?F:n}function _e(n,t,r,e,u,i){var o=1&r,f=n.length,c=t.length;if(f!=c&&!(o&&c>f))return false;if((c=i.get(n))&&i.get(t))return c==t;var c=-1,a=true,l=2&r?new qn:F;
for(i.set(n,t),i.set(t,n);++c<f;){var s=n[c],h=t[c];if(e)var p=o?e(h,s,c,t,n,i):e(s,h,c,n,t,i);if(p!==F){if(p)continue;a=false;break}if(l){if(!_(t,function(n,t){if(!R(l,t)&&(s===n||u(s,n,r,e,i)))return l.push(t)})){a=false;break}}else if(s!==h&&!u(s,h,r,e,i)){a=false;break}}return i.delete(n),i.delete(t),a}function ve(n,t,r,e,u,i,o){switch(r){case"[object DataView]":if(n.byteLength!=t.byteLength||n.byteOffset!=t.byteOffset)break;n=n.buffer,t=t.buffer;case"[object ArrayBuffer]":if(n.byteLength!=t.byteLength||!i(new di(n),new di(t)))break;
return true;case"[object Boolean]":case"[object Date]":case"[object Number]":return hu(+n,+t);case"[object Error]":return n.name==t.name&&n.message==t.message;case"[object RegExp]":case"[object String]":return n==t+"";case"[object Map]":var f=L;case"[object Set]":if(f||(f=D),n.size!=t.size&&!(1&e))break;return(r=o.get(n))?r==t:(e|=2,o.set(n,t),t=_e(f(n),f(t),e,u,i,o),o.delete(n),t);case"[object Symbol]":if(eo)return eo.call(n)==eo.call(t)}return false}function ge(n){return wo(Ce(n,F,Ve),n+"")}function de(n){
return Rt(n,Lu,vo)}function ye(n){return Rt(n,Uu,go)}function be(n){for(var t=n.name+"",r=Ji[t],e=ci.call(Ji,t)?r.length:0;e--;){var u=r[e],i=u.func;if(null==i||i==n)return u.name}return t}function xe(n){return(ci.call(On,"placeholder")?On:n).placeholder}function je(){var n=On.iteratee||Pu,n=n===Pu?Gt:n;return arguments.length?n(arguments[0],arguments[1]):n}function we(n,t){var r=n.__data__,e=typeof t;return("string"==e||"number"==e||"symbol"==e||"boolean"==e?"__proto__"!==t:null===t)?r[typeof t=="string"?"string":"hash"]:r.map;
}function me(n){for(var t=Lu(n),r=t.length;r--;){var e=t[r],u=n[e];t[r]=[e,u,u===u&&!bu(u)]}return t}function Ae(n,t){var r=null==n?F:n[t];return Zt(r)?r:F}function ke(n,t,r){t=Rr(t,n);for(var e=-1,u=t.length,i=false;++e<u;){var o=$e(t[e]);if(!(i=null!=n&&r(n,o)))break;n=n[o]}return i||++e!=u?i:(u=null==n?0:n.length,!!u&&yu(u)&&Re(o,u)&&(af(n)||cf(n)))}function Ee(n){var t=n.length,r=n.constructor(t);return t&&"string"==typeof n[0]&&ci.call(n,"index")&&(r.index=n.index,r.input=n.input),r}function Oe(n){
return typeof n.constructor!="function"||Le(n)?{}:io(bi(n))}function Se(r,e,u,i){var o=r.constructor;switch(e){case"[object ArrayBuffer]":return Br(r);case"[object Boolean]":case"[object Date]":return new o(+r);case"[object DataView]":return e=i?Br(r.buffer):r.buffer,new r.constructor(e,r.byteOffset,r.byteLength);case"[object Float32Array]":case"[object Float64Array]":case"[object Int8Array]":case"[object Int16Array]":case"[object Int32Array]":case"[object Uint8Array]":case"[object Uint8ClampedArray]":
case"[object Uint16Array]":case"[object Uint32Array]":return Lr(r,i);case"[object Map]":return e=i?u(L(r),1):L(r),h(e,n,new r.constructor);case"[object Number]":case"[object String]":return new o(r);case"[object RegExp]":return e=new r.constructor(r.source,dn.exec(r)),e.lastIndex=r.lastIndex,e;case"[object Set]":return e=i?u(D(r),1):D(r),h(e,t,new r.constructor);case"[object Symbol]":return eo?ni(eo.call(r)):{}}}function Ie(n){return af(n)||cf(n)||!!(mi&&n&&n[mi])}function Re(n,t){return t=null==t?9007199254740991:t,
!!t&&(typeof n=="number"||wn.test(n))&&-1<n&&0==n%1&&n<t}function ze(n,t,r){if(!bu(r))return false;var e=typeof t;return!!("number"==e?pu(r)&&Re(t,r.length):"string"==e&&t in r)&&hu(r[t],n)}function We(n,t){if(af(n))return false;var r=typeof n;return!("number"!=r&&"symbol"!=r&&"boolean"!=r&&null!=n&&!Au(n))||(rn.test(n)||!tn.test(n)||null!=t&&n in ni(t))}function Be(n){var t=be(n),r=On[t];return typeof r=="function"&&t in Mn.prototype&&(n===r||(t=_o(r),!!t&&n===t[0]))}function Le(n){var t=n&&n.constructor;
return n===(typeof t=="function"&&t.prototype||ii)}function Ue(n,t){return function(r){return null!=r&&(r[n]===t&&(t!==F||n in ni(r)))}}function Ce(n,t,e){return t=Di(t===F?n.length-1:t,0),function(){for(var u=arguments,i=-1,o=Di(u.length-t,0),f=Hu(o);++i<o;)f[i]=u[t+i];for(i=-1,o=Hu(t+1);++i<t;)o[i]=u[i];return o[t]=e(f),r(n,this,o)}}function De(n,t,r){var e=t+"";t=wo;var u,i=Ne;return u=(u=e.match(hn))?u[1].split(pn):[],r=i(u,r),(i=r.length)&&(u=i-1,r[u]=(1<i?"& ":"")+r[u],r=r.join(2<i?", ":" "),
e=e.replace(sn,"{\n/* [wrapped with "+r+"] */\n")),t(n,e)}function Me(n){var t=0,r=0;return function(){var e=Ti(),u=16-(e-r);if(r=e,0<u){if(800<=++t)return arguments[0]}else t=0;return n.apply(F,arguments)}}function Te(n,t){var r=-1,e=n.length,u=e-1;for(t=t===F?e:t;++r<t;){var e=cr(r,u),i=n[e];n[e]=n[r],n[r]=i}return n.length=t,n}function $e(n){if(typeof n=="string"||Au(n))return n;var t=n+"";return"0"==t&&1/n==-N?"-0":t}function Fe(n){if(null!=n){try{return fi.call(n)}catch(n){}return n+""}return"";
}function Ne(n,t){return u(Z,function(r){var e="_."+r[0];t&r[1]&&!c(n,e)&&n.push(e)}),n.sort()}function Pe(n){if(n instanceof Mn)return n.clone();var t=new zn(n.__wrapped__,n.__chain__);return t.__actions__=Mr(n.__actions__),t.__index__=n.__index__,t.__values__=n.__values__,t}function Ze(n,t,r){var e=null==n?0:n.length;return e?(r=null==r?0:Ou(r),0>r&&(r=Di(e+r,0)),g(n,je(t,3),r)):-1}function qe(n,t,r){var e=null==n?0:n.length;if(!e)return-1;var u=e-1;return r!==F&&(u=Ou(r),u=0>r?Di(e+u,0):Mi(u,e-1)),
g(n,je(t,3),u,true)}function Ve(n){return(null==n?0:n.length)?kt(n,1):[]}function Ke(n){return n&&n.length?n[0]:F}function Ge(n){var t=null==n?0:n.length;return t?n[t-1]:F}function He(n,t){return n&&n.length&&t&&t.length?or(n,t):n}function Je(n){return null==n?n:Ni.call(n)}function Ye(n){if(!n||!n.length)return[];var t=0;return n=f(n,function(n){if(_u(n))return t=Di(n.length,t),true}),E(t,function(t){return l(n,j(t))})}function Qe(n,t){if(!n||!n.length)return[];var e=Ye(n);return null==t?e:l(e,function(n){
return r(t,F,n)})}function Xe(n){return n=On(n),n.__chain__=true,n}function nu(n,t){return t(n)}function tu(){return this}function ru(n,t){return(af(n)?u:oo)(n,je(t,3))}function eu(n,t){return(af(n)?i:fo)(n,je(t,3))}function uu(n,t){return(af(n)?l:Yt)(n,je(t,3))}function iu(n,t,r){return t=r?F:t,t=n&&null==t?n.length:t,le(n,128,F,F,F,F,t)}function ou(n,t){var r;if(typeof t!="function")throw new ei("Expected a function");return n=Ou(n),function(){return 0<--n&&(r=t.apply(this,arguments)),1>=n&&(t=F),
r}}function fu(n,t,r){return t=r?F:t,n=le(n,8,F,F,F,F,F,t),n.placeholder=fu.placeholder,n}function cu(n,t,r){return t=r?F:t,n=le(n,16,F,F,F,F,F,t),n.placeholder=cu.placeholder,n}function au(n,t,r){function e(t){var r=c,e=a;return c=a=F,_=t,s=n.apply(e,r)}function u(n){var r=n-p;return n-=_,p===F||r>=t||0>r||g&&n>=l}function i(){var n=Jo();if(u(n))return o(n);var r,e=jo;r=n-_,n=t-(n-p),r=g?Mi(n,l-r):n,h=e(i,r)}function o(n){return h=F,d&&c?e(n):(c=a=F,s)}function f(){var n=Jo(),r=u(n);if(c=arguments,
a=this,p=n,r){if(h===F)return _=n=p,h=jo(i,t),v?e(n):s;if(g)return h=jo(i,t),e(p)}return h===F&&(h=jo(i,t)),s}var c,a,l,s,h,p,_=0,v=false,g=false,d=true;if(typeof n!="function")throw new ei("Expected a function");return t=Iu(t)||0,bu(r)&&(v=!!r.leading,l=(g="maxWait"in r)?Di(Iu(r.maxWait)||0,t):l,d="trailing"in r?!!r.trailing:d),f.cancel=function(){h!==F&&ho(h),_=0,c=p=a=h=F},f.flush=function(){return h===F?s:o(Jo())},f}function lu(n,t){function r(){var e=arguments,u=t?t.apply(this,e):e[0],i=r.cache;return i.has(u)?i.get(u):(e=n.apply(this,e),
r.cache=i.set(u,e)||i,e)}if(typeof n!="function"||null!=t&&typeof t!="function")throw new ei("Expected a function");return r.cache=new(lu.Cache||Pn),r}function su(n){if(typeof n!="function")throw new ei("Expected a function");return function(){var t=arguments;switch(t.length){case 0:return!n.call(this);case 1:return!n.call(this,t[0]);case 2:return!n.call(this,t[0],t[1]);case 3:return!n.call(this,t[0],t[1],t[2])}return!n.apply(this,t)}}function hu(n,t){return n===t||n!==n&&t!==t}function pu(n){return null!=n&&yu(n.length)&&!gu(n);
}function _u(n){return xu(n)&&pu(n)}function vu(n){if(!xu(n))return false;var t=zt(n);return"[object Error]"==t||"[object DOMException]"==t||typeof n.message=="string"&&typeof n.name=="string"&&!wu(n)}function gu(n){return!!bu(n)&&(n=zt(n),"[object Function]"==n||"[object GeneratorFunction]"==n||"[object AsyncFunction]"==n||"[object Proxy]"==n)}function du(n){return typeof n=="number"&&n==Ou(n)}function yu(n){return typeof n=="number"&&-1<n&&0==n%1&&9007199254740991>=n}function bu(n){var t=typeof n;return null!=n&&("object"==t||"function"==t);
}function xu(n){return null!=n&&typeof n=="object"}function ju(n){return typeof n=="number"||xu(n)&&"[object Number]"==zt(n)}function wu(n){return!(!xu(n)||"[object Object]"!=zt(n))&&(n=bi(n),null===n||(n=ci.call(n,"constructor")&&n.constructor,typeof n=="function"&&n instanceof n&&fi.call(n)==hi))}function mu(n){return typeof n=="string"||!af(n)&&xu(n)&&"[object String]"==zt(n)}function Au(n){return typeof n=="symbol"||xu(n)&&"[object Symbol]"==zt(n)}function ku(n){if(!n)return[];if(pu(n))return mu(n)?$(n):Mr(n);
if(Ai&&n[Ai]){n=n[Ai]();for(var t,r=[];!(t=n.next()).done;)r.push(t.value);return r}return t=yo(n),("[object Map]"==t?L:"[object Set]"==t?D:Du)(n)}function Eu(n){return n?(n=Iu(n),n===N||n===-N?1.7976931348623157e308*(0>n?-1:1):n===n?n:0):0===n?n:0}function Ou(n){n=Eu(n);var t=n%1;return n===n?t?n-t:n:0}function Su(n){return n?gt(Ou(n),0,4294967295):0}function Iu(n){if(typeof n=="number")return n;if(Au(n))return P;if(bu(n)&&(n=typeof n.valueOf=="function"?n.valueOf():n,n=bu(n)?n+"":n),typeof n!="string")return 0===n?n:+n;
n=n.replace(cn,"");var t=bn.test(n);return t||jn.test(n)?Fn(n.slice(2),t?2:8):yn.test(n)?P:+n}function Ru(n){return Tr(n,Uu(n))}function zu(n){return null==n?"":jr(n)}function Wu(n,t,r){return n=null==n?F:It(n,t),n===F?r:n}function Bu(n,t){return null!=n&&ke(n,t,Lt)}function Lu(n){return pu(n)?Gn(n):Ht(n)}function Uu(n){if(pu(n))n=Gn(n,true);else if(bu(n)){var t,r=Le(n),e=[];for(t in n)("constructor"!=t||!r&&ci.call(n,t))&&e.push(t);n=e}else{if(t=[],null!=n)for(r in ni(n))t.push(r);n=t}return n}function Cu(n,t){
if(null==n)return{};var r=l(ye(n),function(n){return[n]});return t=je(t),ur(n,r,function(n,r){return t(n,r[0])})}function Du(n){return null==n?[]:I(n,Lu(n))}function Mu(n){return Nf(zu(n).toLowerCase())}function Tu(n){return(n=zu(n))&&n.replace(mn,rt).replace(Rn,"")}function $u(n,t,r){return n=zu(n),t=r?F:t,t===F?Ln.test(n)?n.match(Wn)||[]:n.match(_n)||[]:n.match(t)||[]}function Fu(n){return function(){return n}}function Nu(n){return n}function Pu(n){return Gt(typeof n=="function"?n:dt(n,1))}function Zu(n,t,r){
var e=Lu(t),i=St(t,e);null!=r||bu(t)&&(i.length||!e.length)||(r=t,t=n,n=this,i=St(t,Lu(t)));var o=!(bu(r)&&"chain"in r&&!r.chain),f=gu(n);return u(i,function(r){var e=t[r];n[r]=e,f&&(n.prototype[r]=function(){var t=this.__chain__;if(o||t){var r=n(this.__wrapped__);return(r.__actions__=Mr(this.__actions__)).push({func:e,args:arguments,thisArg:n}),r.__chain__=t,r}return e.apply(n,s([this.value()],arguments))})}),n}function qu(){}function Vu(n){return We(n)?j($e(n)):ir(n)}function Ku(){return[]}function Gu(){
return false}En=null==En?Zn:it.defaults(Zn.Object(),En,it.pick(Zn,Un));var Hu=En.Array,Ju=En.Date,Yu=En.Error,Qu=En.Function,Xu=En.Math,ni=En.Object,ti=En.RegExp,ri=En.String,ei=En.TypeError,ui=Hu.prototype,ii=ni.prototype,oi=En["__core-js_shared__"],fi=Qu.prototype.toString,ci=ii.hasOwnProperty,ai=0,li=function(){var n=/[^.]+$/.exec(oi&&oi.keys&&oi.keys.IE_PROTO||"");return n?"Symbol(src)_1."+n:""}(),si=ii.toString,hi=fi.call(ni),pi=Zn._,_i=ti("^"+fi.call(ci).replace(on,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),vi=Kn?En.Buffer:F,gi=En.Symbol,di=En.Uint8Array,yi=vi?vi.f:F,bi=U(ni.getPrototypeOf,ni),xi=ni.create,ji=ii.propertyIsEnumerable,wi=ui.splice,mi=gi?gi.isConcatSpreadable:F,Ai=gi?gi.iterator:F,ki=gi?gi.toStringTag:F,Ei=function(){
try{var n=Ae(ni,"defineProperty");return n({},"",{}),n}catch(n){}}(),Oi=En.clearTimeout!==Zn.clearTimeout&&En.clearTimeout,Si=Ju&&Ju.now!==Zn.Date.now&&Ju.now,Ii=En.setTimeout!==Zn.setTimeout&&En.setTimeout,Ri=Xu.ceil,zi=Xu.floor,Wi=ni.getOwnPropertySymbols,Bi=vi?vi.isBuffer:F,Li=En.isFinite,Ui=ui.join,Ci=U(ni.keys,ni),Di=Xu.max,Mi=Xu.min,Ti=Ju.now,$i=En.parseInt,Fi=Xu.random,Ni=ui.reverse,Pi=Ae(En,"DataView"),Zi=Ae(En,"Map"),qi=Ae(En,"Promise"),Vi=Ae(En,"Set"),Ki=Ae(En,"WeakMap"),Gi=Ae(ni,"create"),Hi=Ki&&new Ki,Ji={},Yi=Fe(Pi),Qi=Fe(Zi),Xi=Fe(qi),no=Fe(Vi),to=Fe(Ki),ro=gi?gi.prototype:F,eo=ro?ro.valueOf:F,uo=ro?ro.toString:F,io=function(){
function n(){}return function(t){return bu(t)?xi?xi(t):(n.prototype=t,t=new n,n.prototype=F,t):{}}}();On.templateSettings={escape:Q,evaluate:X,interpolate:nn,variable:"",imports:{_:On}},On.prototype=Sn.prototype,On.prototype.constructor=On,zn.prototype=io(Sn.prototype),zn.prototype.constructor=zn,Mn.prototype=io(Sn.prototype),Mn.prototype.constructor=Mn,Tn.prototype.clear=function(){this.__data__=Gi?Gi(null):{},this.size=0},Tn.prototype.delete=function(n){return n=this.has(n)&&delete this.__data__[n],
this.size-=n?1:0,n},Tn.prototype.get=function(n){var t=this.__data__;return Gi?(n=t[n],"__lodash_hash_undefined__"===n?F:n):ci.call(t,n)?t[n]:F},Tn.prototype.has=function(n){var t=this.__data__;return Gi?t[n]!==F:ci.call(t,n)},Tn.prototype.set=function(n,t){var r=this.__data__;return this.size+=this.has(n)?0:1,r[n]=Gi&&t===F?"__lodash_hash_undefined__":t,this},Nn.prototype.clear=function(){this.__data__=[],this.size=0},Nn.prototype.delete=function(n){var t=this.__data__;return n=lt(t,n),!(0>n)&&(n==t.length-1?t.pop():wi.call(t,n,1),
--this.size,true)},Nn.prototype.get=function(n){var t=this.__data__;return n=lt(t,n),0>n?F:t[n][1]},Nn.prototype.has=function(n){return-1<lt(this.__data__,n)},Nn.prototype.set=function(n,t){var r=this.__data__,e=lt(r,n);return 0>e?(++this.size,r.push([n,t])):r[e][1]=t,this},Pn.prototype.clear=function(){this.size=0,this.__data__={hash:new Tn,map:new(Zi||Nn),string:new Tn}},Pn.prototype.delete=function(n){return n=we(this,n).delete(n),this.size-=n?1:0,n},Pn.prototype.get=function(n){return we(this,n).get(n);
},Pn.prototype.has=function(n){return we(this,n).has(n)},Pn.prototype.set=function(n,t){var r=we(this,n),e=r.size;return r.set(n,t),this.size+=r.size==e?0:1,this},qn.prototype.add=qn.prototype.push=function(n){return this.__data__.set(n,"__lodash_hash_undefined__"),this},qn.prototype.has=function(n){return this.__data__.has(n)},Vn.prototype.clear=function(){this.__data__=new Nn,this.size=0},Vn.prototype.delete=function(n){var t=this.__data__;return n=t.delete(n),this.size=t.size,n},Vn.prototype.get=function(n){
return this.__data__.get(n)},Vn.prototype.has=function(n){return this.__data__.has(n)},Vn.prototype.set=function(n,t){var r=this.__data__;if(r instanceof Nn){var e=r.__data__;if(!Zi||199>e.length)return e.push([n,t]),this.size=++r.size,this;r=this.__data__=new Pn(e)}return r.set(n,t),this.size=r.size,this};var oo=Zr(Et),fo=Zr(Ot,true),co=qr(),ao=qr(true),lo=Hi?function(n,t){return Hi.set(n,t),n}:Nu,so=Ei?function(n,t){return Ei(n,"toString",{configurable:true,enumerable:false,value:Fu(t),writable:true})}:Nu,ho=Oi||function(n){
return Zn.clearTimeout(n)},po=Vi&&1/D(new Vi([,-0]))[1]==N?function(n){return new Vi(n)}:qu,_o=Hi?function(n){return Hi.get(n)}:qu,vo=Wi?function(n){return null==n?[]:(n=ni(n),f(Wi(n),function(t){return ji.call(n,t)}))}:Ku,go=Wi?function(n){for(var t=[];n;)s(t,vo(n)),n=bi(n);return t}:Ku,yo=zt;(Pi&&"[object DataView]"!=yo(new Pi(new ArrayBuffer(1)))||Zi&&"[object Map]"!=yo(new Zi)||qi&&"[object Promise]"!=yo(qi.resolve())||Vi&&"[object Set]"!=yo(new Vi)||Ki&&"[object WeakMap]"!=yo(new Ki))&&(yo=function(n){
var t=zt(n);if(n=(n="[object Object]"==t?n.constructor:F)?Fe(n):"")switch(n){case Yi:return"[object DataView]";case Qi:return"[object Map]";case Xi:return"[object Promise]";case no:return"[object Set]";case to:return"[object WeakMap]"}return t});var bo=oi?gu:Gu,xo=Me(lo),jo=Ii||function(n,t){return Zn.setTimeout(n,t)},wo=Me(so),mo=function(n){n=lu(n,function(n){return 500===t.size&&t.clear(),n});var t=n.cache;return n}(function(n){var t=[];return en.test(n)&&t.push(""),n.replace(un,function(n,r,e,u){
t.push(e?u.replace(vn,"$1"):r||n)}),t}),Ao=lr(function(n,t){return _u(n)?jt(n,kt(t,1,_u,true)):[]}),ko=lr(function(n,t){var r=Ge(t);return _u(r)&&(r=F),_u(n)?jt(n,kt(t,1,_u,true),je(r,2)):[]}),Eo=lr(function(n,t){var r=Ge(t);return _u(r)&&(r=F),_u(n)?jt(n,kt(t,1,_u,true),F,r):[]}),Oo=lr(function(n){var t=l(n,Sr);return t.length&&t[0]===n[0]?Ut(t):[]}),So=lr(function(n){var t=Ge(n),r=l(n,Sr);return t===Ge(r)?t=F:r.pop(),r.length&&r[0]===n[0]?Ut(r,je(t,2)):[]}),Io=lr(function(n){var t=Ge(n),r=l(n,Sr);return(t=typeof t=="function"?t:F)&&r.pop(),
r.length&&r[0]===n[0]?Ut(r,F,t):[]}),Ro=lr(He),zo=ge(function(n,t){var r=null==n?0:n.length,e=vt(n,t);return fr(n,l(t,function(n){return Re(n,r)?+n:n}).sort(Ur)),e}),Wo=lr(function(n){return wr(kt(n,1,_u,true))}),Bo=lr(function(n){var t=Ge(n);return _u(t)&&(t=F),wr(kt(n,1,_u,true),je(t,2))}),Lo=lr(function(n){var t=Ge(n),t=typeof t=="function"?t:F;return wr(kt(n,1,_u,true),F,t)}),Uo=lr(function(n,t){return _u(n)?jt(n,t):[]}),Co=lr(function(n){return Er(f(n,_u))}),Do=lr(function(n){var t=Ge(n);return _u(t)&&(t=F),
Er(f(n,_u),je(t,2))}),Mo=lr(function(n){var t=Ge(n),t=typeof t=="function"?t:F;return Er(f(n,_u),F,t)}),To=lr(Ye),$o=lr(function(n){var t=n.length,t=1<t?n[t-1]:F,t=typeof t=="function"?(n.pop(),t):F;return Qe(n,t)}),Fo=ge(function(n){function t(t){return vt(t,n)}var r=n.length,e=r?n[0]:0,u=this.__wrapped__;return!(1<r||this.__actions__.length)&&u instanceof Mn&&Re(e)?(u=u.slice(e,+e+(r?1:0)),u.__actions__.push({func:nu,args:[t],thisArg:F}),new zn(u,this.__chain__).thru(function(n){return r&&!n.length&&n.push(F),
n})):this.thru(t)}),No=Nr(function(n,t,r){ci.call(n,r)?++n[r]:_t(n,r,1)}),Po=Yr(Ze),Zo=Yr(qe),qo=Nr(function(n,t,r){ci.call(n,r)?n[r].push(t):_t(n,r,[t])}),Vo=lr(function(n,t,e){var u=-1,i=typeof t=="function",o=pu(n)?Hu(n.length):[];return oo(n,function(n){o[++u]=i?r(t,n,e):Dt(n,t,e)}),o}),Ko=Nr(function(n,t,r){_t(n,r,t)}),Go=Nr(function(n,t,r){n[r?0:1].push(t)},function(){return[[],[]]}),Ho=lr(function(n,t){if(null==n)return[];var r=t.length;return 1<r&&ze(n,t[0],t[1])?t=[]:2<r&&ze(t[0],t[1],t[2])&&(t=[t[0]]),
rr(n,kt(t,1),[])}),Jo=Si||function(){return Zn.Date.now()},Yo=lr(function(n,t,r){var e=1;if(r.length)var u=C(r,xe(Yo)),e=32|e;return le(n,e,t,r,u)}),Qo=lr(function(n,t,r){var e=3;if(r.length)var u=C(r,xe(Qo)),e=32|e;return le(t,e,n,r,u)}),Xo=lr(function(n,t){return xt(n,1,t)}),nf=lr(function(n,t,r){return xt(n,Iu(t)||0,r)});lu.Cache=Pn;var tf=lr(function(n,t){t=1==t.length&&af(t[0])?l(t[0],S(je())):l(kt(t,1),S(je()));var e=t.length;return lr(function(u){for(var i=-1,o=Mi(u.length,e);++i<o;)u[i]=t[i].call(this,u[i]);
return r(n,this,u)})}),rf=lr(function(n,t){return le(n,32,F,t,C(t,xe(rf)))}),ef=lr(function(n,t){return le(n,64,F,t,C(t,xe(ef)))}),uf=ge(function(n,t){return le(n,256,F,F,F,t)}),of=oe(Wt),ff=oe(function(n,t){return n>=t}),cf=Mt(function(){return arguments}())?Mt:function(n){return xu(n)&&ci.call(n,"callee")&&!ji.call(n,"callee")},af=Hu.isArray,lf=Hn?S(Hn):Tt,sf=Bi||Gu,hf=Jn?S(Jn):$t,pf=Yn?S(Yn):Nt,_f=Qn?S(Qn):qt,vf=Xn?S(Xn):Vt,gf=nt?S(nt):Kt,df=oe(Jt),yf=oe(function(n,t){return n<=t}),bf=Pr(function(n,t){
if(Le(t)||pu(t))Tr(t,Lu(t),n);else for(var r in t)ci.call(t,r)&&at(n,r,t[r])}),xf=Pr(function(n,t){Tr(t,Uu(t),n)}),jf=Pr(function(n,t,r,e){Tr(t,Uu(t),n,e)}),wf=Pr(function(n,t,r,e){Tr(t,Lu(t),n,e)}),mf=ge(vt),Af=lr(function(n){return n.push(F,se),r(jf,F,n)}),kf=lr(function(n){return n.push(F,he),r(Rf,F,n)}),Ef=ne(function(n,t,r){n[t]=r},Fu(Nu)),Of=ne(function(n,t,r){ci.call(n,t)?n[t].push(r):n[t]=[r]},je),Sf=lr(Dt),If=Pr(function(n,t,r){nr(n,t,r)}),Rf=Pr(function(n,t,r,e){nr(n,t,r,e)}),zf=ge(function(n,t){
var r={};if(null==n)return r;var e=false;t=l(t,function(t){return t=Rr(t,n),e||(e=1<t.length),t}),Tr(n,ye(n),r),e&&(r=dt(r,7,pe));for(var u=t.length;u--;)mr(r,t[u]);return r}),Wf=ge(function(n,t){return null==n?{}:er(n,t)}),Bf=ae(Lu),Lf=ae(Uu),Uf=Gr(function(n,t,r){return t=t.toLowerCase(),n+(r?Mu(t):t)}),Cf=Gr(function(n,t,r){return n+(r?"-":"")+t.toLowerCase()}),Df=Gr(function(n,t,r){return n+(r?" ":"")+t.toLowerCase()}),Mf=Kr("toLowerCase"),Tf=Gr(function(n,t,r){return n+(r?"_":"")+t.toLowerCase();
}),$f=Gr(function(n,t,r){return n+(r?" ":"")+Nf(t)}),Ff=Gr(function(n,t,r){return n+(r?" ":"")+t.toUpperCase()}),Nf=Kr("toUpperCase"),Pf=lr(function(n,t){try{return r(n,F,t)}catch(n){return vu(n)?n:new Yu(n)}}),Zf=ge(function(n,t){return u(t,function(t){t=$e(t),_t(n,t,Yo(n[t],n))}),n}),qf=Qr(),Vf=Qr(true),Kf=lr(function(n,t){return function(r){return Dt(r,n,t)}}),Gf=lr(function(n,t){return function(r){return Dt(n,r,t)}}),Hf=re(l),Jf=re(o),Yf=re(_),Qf=ie(),Xf=ie(true),nc=te(function(n,t){return n+t},0),tc=ce("ceil"),rc=te(function(n,t){
return n/t},1),ec=ce("floor"),uc=te(function(n,t){return n*t},1),ic=ce("round"),oc=te(function(n,t){return n-t},0);return On.after=function(n,t){if(typeof t!="function")throw new ei("Expected a function");return n=Ou(n),function(){if(1>--n)return t.apply(this,arguments)}},On.ary=iu,On.assign=bf,On.assignIn=xf,On.assignInWith=jf,On.assignWith=wf,On.at=mf,On.before=ou,On.bind=Yo,On.bindAll=Zf,On.bindKey=Qo,On.castArray=function(){if(!arguments.length)return[];var n=arguments[0];return af(n)?n:[n]},
On.chain=Xe,On.chunk=function(n,t,r){if(t=(r?ze(n,t,r):t===F)?1:Di(Ou(t),0),r=null==n?0:n.length,!r||1>t)return[];for(var e=0,u=0,i=Hu(Ri(r/t));e<r;)i[u++]=vr(n,e,e+=t);return i},On.compact=function(n){for(var t=-1,r=null==n?0:n.length,e=0,u=[];++t<r;){var i=n[t];i&&(u[e++]=i)}return u},On.concat=function(){var n=arguments.length;if(!n)return[];for(var t=Hu(n-1),r=arguments[0];n--;)t[n-1]=arguments[n];return s(af(r)?Mr(r):[r],kt(t,1))},On.cond=function(n){var t=null==n?0:n.length,e=je();return n=t?l(n,function(n){
if("function"!=typeof n[1])throw new ei("Expected a function");return[e(n[0]),n[1]]}):[],lr(function(e){for(var u=-1;++u<t;){var i=n[u];if(r(i[0],this,e))return r(i[1],this,e)}})},On.conforms=function(n){return yt(dt(n,1))},On.constant=Fu,On.countBy=No,On.create=function(n,t){var r=io(n);return null==t?r:ht(r,t)},On.curry=fu,On.curryRight=cu,On.debounce=au,On.defaults=Af,On.defaultsDeep=kf,On.defer=Xo,On.delay=nf,On.difference=Ao,On.differenceBy=ko,On.differenceWith=Eo,On.drop=function(n,t,r){var e=null==n?0:n.length;
return e?(t=r||t===F?1:Ou(t),vr(n,0>t?0:t,e)):[]},On.dropRight=function(n,t,r){var e=null==n?0:n.length;return e?(t=r||t===F?1:Ou(t),t=e-t,vr(n,0,0>t?0:t)):[]},On.dropRightWhile=function(n,t){return n&&n.length?Ar(n,je(t,3),true,true):[]},On.dropWhile=function(n,t){return n&&n.length?Ar(n,je(t,3),true):[]},On.fill=function(n,t,r,e){var u=null==n?0:n.length;if(!u)return[];for(r&&typeof r!="number"&&ze(n,t,r)&&(r=0,e=u),u=n.length,r=Ou(r),0>r&&(r=-r>u?0:u+r),e=e===F||e>u?u:Ou(e),0>e&&(e+=u),e=r>e?0:Su(e);r<e;)n[r++]=t;
return n},On.filter=function(n,t){return(af(n)?f:At)(n,je(t,3))},On.flatMap=function(n,t){return kt(uu(n,t),1)},On.flatMapDeep=function(n,t){return kt(uu(n,t),N)},On.flatMapDepth=function(n,t,r){return r=r===F?1:Ou(r),kt(uu(n,t),r)},On.flatten=Ve,On.flattenDeep=function(n){return(null==n?0:n.length)?kt(n,N):[]},On.flattenDepth=function(n,t){return null!=n&&n.length?(t=t===F?1:Ou(t),kt(n,t)):[]},On.flip=function(n){return le(n,512)},On.flow=qf,On.flowRight=Vf,On.fromPairs=function(n){for(var t=-1,r=null==n?0:n.length,e={};++t<r;){
var u=n[t];e[u[0]]=u[1]}return e},On.functions=function(n){return null==n?[]:St(n,Lu(n))},On.functionsIn=function(n){return null==n?[]:St(n,Uu(n))},On.groupBy=qo,On.initial=function(n){return(null==n?0:n.length)?vr(n,0,-1):[]},On.intersection=Oo,On.intersectionBy=So,On.intersectionWith=Io,On.invert=Ef,On.invertBy=Of,On.invokeMap=Vo,On.iteratee=Pu,On.keyBy=Ko,On.keys=Lu,On.keysIn=Uu,On.map=uu,On.mapKeys=function(n,t){var r={};return t=je(t,3),Et(n,function(n,e,u){_t(r,t(n,e,u),n)}),r},On.mapValues=function(n,t){
var r={};return t=je(t,3),Et(n,function(n,e,u){_t(r,e,t(n,e,u))}),r},On.matches=function(n){return Qt(dt(n,1))},On.matchesProperty=function(n,t){return Xt(n,dt(t,1))},On.memoize=lu,On.merge=If,On.mergeWith=Rf,On.method=Kf,On.methodOf=Gf,On.mixin=Zu,On.negate=su,On.nthArg=function(n){return n=Ou(n),lr(function(t){return tr(t,n)})},On.omit=zf,On.omitBy=function(n,t){return Cu(n,su(je(t)))},On.once=function(n){return ou(2,n)},On.orderBy=function(n,t,r,e){return null==n?[]:(af(t)||(t=null==t?[]:[t]),
r=e?F:r,af(r)||(r=null==r?[]:[r]),rr(n,t,r))},On.over=Hf,On.overArgs=tf,On.overEvery=Jf,On.overSome=Yf,On.partial=rf,On.partialRight=ef,On.partition=Go,On.pick=Wf,On.pickBy=Cu,On.property=Vu,On.propertyOf=function(n){return function(t){return null==n?F:It(n,t)}},On.pull=Ro,On.pullAll=He,On.pullAllBy=function(n,t,r){return n&&n.length&&t&&t.length?or(n,t,je(r,2)):n},On.pullAllWith=function(n,t,r){return n&&n.length&&t&&t.length?or(n,t,F,r):n},On.pullAt=zo,On.range=Qf,On.rangeRight=Xf,On.rearg=uf,On.reject=function(n,t){
return(af(n)?f:At)(n,su(je(t,3)))},On.remove=function(n,t){var r=[];if(!n||!n.length)return r;var e=-1,u=[],i=n.length;for(t=je(t,3);++e<i;){var o=n[e];t(o,e,n)&&(r.push(o),u.push(e))}return fr(n,u),r},On.rest=function(n,t){if(typeof n!="function")throw new ei("Expected a function");return t=t===F?t:Ou(t),lr(n,t)},On.reverse=Je,On.sampleSize=function(n,t,r){return t=(r?ze(n,t,r):t===F)?1:Ou(t),(af(n)?ot:hr)(n,t)},On.set=function(n,t,r){return null==n?n:pr(n,t,r)},On.setWith=function(n,t,r,e){return e=typeof e=="function"?e:F,
null==n?n:pr(n,t,r,e)},On.shuffle=function(n){return(af(n)?ft:_r)(n)},On.slice=function(n,t,r){var e=null==n?0:n.length;return e?(r&&typeof r!="number"&&ze(n,t,r)?(t=0,r=e):(t=null==t?0:Ou(t),r=r===F?e:Ou(r)),vr(n,t,r)):[]},On.sortBy=Ho,On.sortedUniq=function(n){return n&&n.length?br(n):[]},On.sortedUniqBy=function(n,t){return n&&n.length?br(n,je(t,2)):[]},On.split=function(n,t,r){return r&&typeof r!="number"&&ze(n,t,r)&&(t=r=F),r=r===F?4294967295:r>>>0,r?(n=zu(n))&&(typeof t=="string"||null!=t&&!_f(t))&&(t=jr(t),
!t&&Bn.test(n))?zr($(n),0,r):n.split(t,r):[]},On.spread=function(n,t){if(typeof n!="function")throw new ei("Expected a function");return t=null==t?0:Di(Ou(t),0),lr(function(e){var u=e[t];return e=zr(e,0,t),u&&s(e,u),r(n,this,e)})},On.tail=function(n){var t=null==n?0:n.length;return t?vr(n,1,t):[]},On.take=function(n,t,r){return n&&n.length?(t=r||t===F?1:Ou(t),vr(n,0,0>t?0:t)):[]},On.takeRight=function(n,t,r){var e=null==n?0:n.length;return e?(t=r||t===F?1:Ou(t),t=e-t,vr(n,0>t?0:t,e)):[]},On.takeRightWhile=function(n,t){
return n&&n.length?Ar(n,je(t,3),false,true):[]},On.takeWhile=function(n,t){return n&&n.length?Ar(n,je(t,3)):[]},On.tap=function(n,t){return t(n),n},On.throttle=function(n,t,r){var e=true,u=true;if(typeof n!="function")throw new ei("Expected a function");return bu(r)&&(e="leading"in r?!!r.leading:e,u="trailing"in r?!!r.trailing:u),au(n,t,{leading:e,maxWait:t,trailing:u})},On.thru=nu,On.toArray=ku,On.toPairs=Bf,On.toPairsIn=Lf,On.toPath=function(n){return af(n)?l(n,$e):Au(n)?[n]:Mr(mo(zu(n)))},On.toPlainObject=Ru,
On.transform=function(n,t,r){var e=af(n),i=e||sf(n)||gf(n);if(t=je(t,4),null==r){var o=n&&n.constructor;r=i?e?new o:[]:bu(n)&&gu(o)?io(bi(n)):{}}return(i?u:Et)(n,function(n,e,u){return t(r,n,e,u)}),r},On.unary=function(n){return iu(n,1)},On.union=Wo,On.unionBy=Bo,On.unionWith=Lo,On.uniq=function(n){return n&&n.length?wr(n):[]},On.uniqBy=function(n,t){return n&&n.length?wr(n,je(t,2)):[]},On.uniqWith=function(n,t){return t=typeof t=="function"?t:F,n&&n.length?wr(n,F,t):[]},On.unset=function(n,t){return null==n||mr(n,t);
},On.unzip=Ye,On.unzipWith=Qe,On.update=function(n,t,r){return null==n?n:pr(n,t,Ir(r)(It(n,t)),void 0)},On.updateWith=function(n,t,r,e){return e=typeof e=="function"?e:F,null!=n&&(n=pr(n,t,Ir(r)(It(n,t)),e)),n},On.values=Du,On.valuesIn=function(n){return null==n?[]:I(n,Uu(n))},On.without=Uo,On.words=$u,On.wrap=function(n,t){return rf(Ir(t),n)},On.xor=Co,On.xorBy=Do,On.xorWith=Mo,On.zip=To,On.zipObject=function(n,t){return Or(n||[],t||[],at)},On.zipObjectDeep=function(n,t){return Or(n||[],t||[],pr);
},On.zipWith=$o,On.entries=Bf,On.entriesIn=Lf,On.extend=xf,On.extendWith=jf,Zu(On,On),On.add=nc,On.attempt=Pf,On.camelCase=Uf,On.capitalize=Mu,On.ceil=tc,On.clamp=function(n,t,r){return r===F&&(r=t,t=F),r!==F&&(r=Iu(r),r=r===r?r:0),t!==F&&(t=Iu(t),t=t===t?t:0),gt(Iu(n),t,r)},On.clone=function(n){return dt(n,4)},On.cloneDeep=function(n){return dt(n,5)},On.cloneDeepWith=function(n,t){return t=typeof t=="function"?t:F,dt(n,5,t)},On.cloneWith=function(n,t){return t=typeof t=="function"?t:F,dt(n,4,t)},
On.conformsTo=function(n,t){return null==t||bt(n,t,Lu(t))},On.deburr=Tu,On.defaultTo=function(n,t){return null==n||n!==n?t:n},On.divide=rc,On.endsWith=function(n,t,r){n=zu(n),t=jr(t);var e=n.length,e=r=r===F?e:gt(Ou(r),0,e);return r-=t.length,0<=r&&n.slice(r,e)==t},On.eq=hu,On.escape=function(n){return(n=zu(n))&&Y.test(n)?n.replace(H,et):n},On.escapeRegExp=function(n){return(n=zu(n))&&fn.test(n)?n.replace(on,"\\$&"):n},On.every=function(n,t,r){var e=af(n)?o:wt;return r&&ze(n,t,r)&&(t=F),e(n,je(t,3));
},On.find=Po,On.findIndex=Ze,On.findKey=function(n,t){return v(n,je(t,3),Et)},On.findLast=Zo,On.findLastIndex=qe,On.findLastKey=function(n,t){return v(n,je(t,3),Ot)},On.floor=ec,On.forEach=ru,On.forEachRight=eu,On.forIn=function(n,t){return null==n?n:co(n,je(t,3),Uu)},On.forInRight=function(n,t){return null==n?n:ao(n,je(t,3),Uu)},On.forOwn=function(n,t){return n&&Et(n,je(t,3))},On.forOwnRight=function(n,t){return n&&Ot(n,je(t,3))},On.get=Wu,On.gt=of,On.gte=ff,On.has=function(n,t){return null!=n&&ke(n,t,Bt);
},On.hasIn=Bu,On.head=Ke,On.identity=Nu,On.includes=function(n,t,r,e){return n=pu(n)?n:Du(n),r=r&&!e?Ou(r):0,e=n.length,0>r&&(r=Di(e+r,0)),mu(n)?r<=e&&-1<n.indexOf(t,r):!!e&&-1<d(n,t,r)},On.indexOf=function(n,t,r){var e=null==n?0:n.length;return e?(r=null==r?0:Ou(r),0>r&&(r=Di(e+r,0)),d(n,t,r)):-1},On.inRange=function(n,t,r){return t=Eu(t),r===F?(r=t,t=0):r=Eu(r),n=Iu(n),n>=Mi(t,r)&&n<Di(t,r)},On.invoke=Sf,On.isArguments=cf,On.isArray=af,On.isArrayBuffer=lf,On.isArrayLike=pu,On.isArrayLikeObject=_u,
On.isBoolean=function(n){return true===n||false===n||xu(n)&&"[object Boolean]"==zt(n)},On.isBuffer=sf,On.isDate=hf,On.isElement=function(n){return xu(n)&&1===n.nodeType&&!wu(n)},On.isEmpty=function(n){if(null==n)return true;if(pu(n)&&(af(n)||typeof n=="string"||typeof n.splice=="function"||sf(n)||gf(n)||cf(n)))return!n.length;var t=yo(n);if("[object Map]"==t||"[object Set]"==t)return!n.size;if(Le(n))return!Ht(n).length;for(var r in n)if(ci.call(n,r))return false;return true},On.isEqual=function(n,t){return Ft(n,t);
},On.isEqualWith=function(n,t,r){var e=(r=typeof r=="function"?r:F)?r(n,t):F;return e===F?Ft(n,t,F,r):!!e},On.isError=vu,On.isFinite=function(n){return typeof n=="number"&&Li(n)},On.isFunction=gu,On.isInteger=du,On.isLength=yu,On.isMap=pf,On.isMatch=function(n,t){return n===t||Pt(n,t,me(t))},On.isMatchWith=function(n,t,r){return r=typeof r=="function"?r:F,Pt(n,t,me(t),r)},On.isNaN=function(n){return ju(n)&&n!=+n},On.isNative=function(n){if(bo(n))throw new Yu("Unsupported core-js use. Try https://npms.io/search?q=ponyfill.");
return Zt(n)},On.isNil=function(n){return null==n},On.isNull=function(n){return null===n},On.isNumber=ju,On.isObject=bu,On.isObjectLike=xu,On.isPlainObject=wu,On.isRegExp=_f,On.isSafeInteger=function(n){return du(n)&&-9007199254740991<=n&&9007199254740991>=n},On.isSet=vf,On.isString=mu,On.isSymbol=Au,On.isTypedArray=gf,On.isUndefined=function(n){return n===F},On.isWeakMap=function(n){return xu(n)&&"[object WeakMap]"==yo(n)},On.isWeakSet=function(n){return xu(n)&&"[object WeakSet]"==zt(n)},On.join=function(n,t){
return null==n?"":Ui.call(n,t)},On.kebabCase=Cf,On.last=Ge,On.lastIndexOf=function(n,t,r){var e=null==n?0:n.length;if(!e)return-1;var u=e;if(r!==F&&(u=Ou(r),u=0>u?Di(e+u,0):Mi(u,e-1)),t===t){for(r=u+1;r--&&n[r]!==t;);n=r}else n=g(n,b,u,true);return n},On.lowerCase=Df,On.lowerFirst=Mf,On.lt=df,On.lte=yf,On.max=function(n){return n&&n.length?mt(n,Nu,Wt):F},On.maxBy=function(n,t){return n&&n.length?mt(n,je(t,2),Wt):F},On.mean=function(n){return x(n,Nu)},On.meanBy=function(n,t){return x(n,je(t,2))},On.min=function(n){
return n&&n.length?mt(n,Nu,Jt):F},On.minBy=function(n,t){return n&&n.length?mt(n,je(t,2),Jt):F},On.stubArray=Ku,On.stubFalse=Gu,On.stubObject=function(){return{}},On.stubString=function(){return""},On.stubTrue=function(){return true},On.multiply=uc,On.nth=function(n,t){return n&&n.length?tr(n,Ou(t)):F},On.noConflict=function(){return Zn._===this&&(Zn._=pi),this},On.noop=qu,On.now=Jo,On.pad=function(n,t,r){n=zu(n);var e=(t=Ou(t))?T(n):0;return!t||e>=t?n:(t=(t-e)/2,ee(zi(t),r)+n+ee(Ri(t),r))},On.padEnd=function(n,t,r){
n=zu(n);var e=(t=Ou(t))?T(n):0;return t&&e<t?n+ee(t-e,r):n},On.padStart=function(n,t,r){n=zu(n);var e=(t=Ou(t))?T(n):0;return t&&e<t?ee(t-e,r)+n:n},On.parseInt=function(n,t,r){return r||null==t?t=0:t&&(t=+t),$i(zu(n).replace(an,""),t||0)},On.random=function(n,t,r){if(r&&typeof r!="boolean"&&ze(n,t,r)&&(t=r=F),r===F&&(typeof t=="boolean"?(r=t,t=F):typeof n=="boolean"&&(r=n,n=F)),n===F&&t===F?(n=0,t=1):(n=Eu(n),t===F?(t=n,n=0):t=Eu(t)),n>t){var e=n;n=t,t=e}return r||n%1||t%1?(r=Fi(),Mi(n+r*(t-n+$n("1e-"+((r+"").length-1))),t)):cr(n,t);
},On.reduce=function(n,t,r){var e=af(n)?h:m,u=3>arguments.length;return e(n,je(t,4),r,u,oo)},On.reduceRight=function(n,t,r){var e=af(n)?p:m,u=3>arguments.length;return e(n,je(t,4),r,u,fo)},On.repeat=function(n,t,r){return t=(r?ze(n,t,r):t===F)?1:Ou(t),ar(zu(n),t)},On.replace=function(){var n=arguments,t=zu(n[0]);return 3>n.length?t:t.replace(n[1],n[2])},On.result=function(n,t,r){t=Rr(t,n);var e=-1,u=t.length;for(u||(u=1,n=F);++e<u;){var i=null==n?F:n[$e(t[e])];i===F&&(e=u,i=r),n=gu(i)?i.call(n):i;
}return n},On.round=ic,On.runInContext=w,On.sample=function(n){return(af(n)?tt:sr)(n)},On.size=function(n){if(null==n)return 0;if(pu(n))return mu(n)?T(n):n.length;var t=yo(n);return"[object Map]"==t||"[object Set]"==t?n.size:Ht(n).length},On.snakeCase=Tf,On.some=function(n,t,r){var e=af(n)?_:gr;return r&&ze(n,t,r)&&(t=F),e(n,je(t,3))},On.sortedIndex=function(n,t){return dr(n,t)},On.sortedIndexBy=function(n,t,r){return yr(n,t,je(r,2))},On.sortedIndexOf=function(n,t){var r=null==n?0:n.length;if(r){
var e=dr(n,t);if(e<r&&hu(n[e],t))return e}return-1},On.sortedLastIndex=function(n,t){return dr(n,t,true)},On.sortedLastIndexBy=function(n,t,r){return yr(n,t,je(r,2),true)},On.sortedLastIndexOf=function(n,t){if(null==n?0:n.length){var r=dr(n,t,true)-1;if(hu(n[r],t))return r}return-1},On.startCase=$f,On.startsWith=function(n,t,r){return n=zu(n),r=null==r?0:gt(Ou(r),0,n.length),t=jr(t),n.slice(r,r+t.length)==t},On.subtract=oc,On.sum=function(n){return n&&n.length?k(n,Nu):0},On.sumBy=function(n,t){return n&&n.length?k(n,je(t,2)):0;
},On.template=function(n,t,r){var e=On.templateSettings;r&&ze(n,t,r)&&(t=F),n=zu(n),t=jf({},t,e,se),r=jf({},t.imports,e.imports,se);var u,i,o=Lu(r),f=I(r,o),c=0;r=t.interpolate||An;var a="__p+='";r=ti((t.escape||An).source+"|"+r.source+"|"+(r===nn?gn:An).source+"|"+(t.evaluate||An).source+"|$","g");var l="sourceURL"in t?"//# sourceURL="+t.sourceURL+"\n":"";if(n.replace(r,function(t,r,e,o,f,l){return e||(e=o),a+=n.slice(c,l).replace(kn,B),r&&(u=true,a+="'+__e("+r+")+'"),f&&(i=true,a+="';"+f+";\n__p+='"),
e&&(a+="'+((__t=("+e+"))==null?'':__t)+'"),c=l+t.length,t}),a+="';",(t=t.variable)||(a="with(obj){"+a+"}"),a=(i?a.replace(q,""):a).replace(V,"$1").replace(K,"$1;"),a="function("+(t||"obj")+"){"+(t?"":"obj||(obj={});")+"var __t,__p=''"+(u?",__e=_.escape":"")+(i?",__j=Array.prototype.join;function print(){__p+=__j.call(arguments,'')}":";")+a+"return __p}",t=Pf(function(){return Qu(o,l+"return "+a).apply(F,f)}),t.source=a,vu(t))throw t;return t},On.times=function(n,t){if(n=Ou(n),1>n||9007199254740991<n)return[];
var r=4294967295,e=Mi(n,4294967295);for(t=je(t),n-=4294967295,e=E(e,t);++r<n;)t(r);return e},On.toFinite=Eu,On.toInteger=Ou,On.toLength=Su,On.toLower=function(n){return zu(n).toLowerCase()},On.toNumber=Iu,On.toSafeInteger=function(n){return n?gt(Ou(n),-9007199254740991,9007199254740991):0===n?n:0},On.toString=zu,On.toUpper=function(n){return zu(n).toUpperCase()},On.trim=function(n,t,r){return(n=zu(n))&&(r||t===F)?n.replace(cn,""):n&&(t=jr(t))?(n=$(n),r=$(t),t=z(n,r),r=W(n,r)+1,zr(n,t,r).join("")):n;
},On.trimEnd=function(n,t,r){return(n=zu(n))&&(r||t===F)?n.replace(ln,""):n&&(t=jr(t))?(n=$(n),t=W(n,$(t))+1,zr(n,0,t).join("")):n},On.trimStart=function(n,t,r){return(n=zu(n))&&(r||t===F)?n.replace(an,""):n&&(t=jr(t))?(n=$(n),t=z(n,$(t)),zr(n,t).join("")):n},On.truncate=function(n,t){var r=30,e="...";if(bu(t))var u="separator"in t?t.separator:u,r="length"in t?Ou(t.length):r,e="omission"in t?jr(t.omission):e;n=zu(n);var i=n.length;if(Bn.test(n))var o=$(n),i=o.length;if(r>=i)return n;if(i=r-T(e),1>i)return e;
if(r=o?zr(o,0,i).join(""):n.slice(0,i),u===F)return r+e;if(o&&(i+=r.length-i),_f(u)){if(n.slice(i).search(u)){var f=r;for(u.global||(u=ti(u.source,zu(dn.exec(u))+"g")),u.lastIndex=0;o=u.exec(f);)var c=o.index;r=r.slice(0,c===F?i:c)}}else n.indexOf(jr(u),i)!=i&&(u=r.lastIndexOf(u),-1<u&&(r=r.slice(0,u)));return r+e},On.unescape=function(n){return(n=zu(n))&&J.test(n)?n.replace(G,ut):n},On.uniqueId=function(n){var t=++ai;return zu(n)+t},On.upperCase=Ff,On.upperFirst=Nf,On.each=ru,On.eachRight=eu,On.first=Ke,
Zu(On,function(){var n={};return Et(On,function(t,r){ci.call(On.prototype,r)||(n[r]=t)}),n}(),{chain:false}),On.VERSION="4.17.4",u("bind bindKey curry curryRight partial partialRight".split(" "),function(n){On[n].placeholder=On}),u(["drop","take"],function(n,t){Mn.prototype[n]=function(r){r=r===F?1:Di(Ou(r),0);var e=this.__filtered__&&!t?new Mn(this):this.clone();return e.__filtered__?e.__takeCount__=Mi(r,e.__takeCount__):e.__views__.push({size:Mi(r,4294967295),type:n+(0>e.__dir__?"Right":"")}),e},Mn.prototype[n+"Right"]=function(t){
return this.reverse()[n](t).reverse()}}),u(["filter","map","takeWhile"],function(n,t){var r=t+1,e=1==r||3==r;Mn.prototype[n]=function(n){var t=this.clone();return t.__iteratees__.push({iteratee:je(n,3),type:r}),t.__filtered__=t.__filtered__||e,t}}),u(["head","last"],function(n,t){var r="take"+(t?"Right":"");Mn.prototype[n]=function(){return this[r](1).value()[0]}}),u(["initial","tail"],function(n,t){var r="drop"+(t?"":"Right");Mn.prototype[n]=function(){return this.__filtered__?new Mn(this):this[r](1);
}}),Mn.prototype.compact=function(){return this.filter(Nu)},Mn.prototype.find=function(n){return this.filter(n).head()},Mn.prototype.findLast=function(n){return this.reverse().find(n)},Mn.prototype.invokeMap=lr(function(n,t){return typeof n=="function"?new Mn(this):this.map(function(r){return Dt(r,n,t)})}),Mn.prototype.reject=function(n){return this.filter(su(je(n)))},Mn.prototype.slice=function(n,t){n=Ou(n);var r=this;return r.__filtered__&&(0<n||0>t)?new Mn(r):(0>n?r=r.takeRight(-n):n&&(r=r.drop(n)),
t!==F&&(t=Ou(t),r=0>t?r.dropRight(-t):r.take(t-n)),r)},Mn.prototype.takeRightWhile=function(n){return this.reverse().takeWhile(n).reverse()},Mn.prototype.toArray=function(){return this.take(4294967295)},Et(Mn.prototype,function(n,t){var r=/^(?:filter|find|map|reject)|While$/.test(t),e=/^(?:head|last)$/.test(t),u=On[e?"take"+("last"==t?"Right":""):t],i=e||/^find/.test(t);u&&(On.prototype[t]=function(){function t(n){return n=u.apply(On,s([n],f)),e&&h?n[0]:n}var o=this.__wrapped__,f=e?[1]:arguments,c=o instanceof Mn,a=f[0],l=c||af(o);
l&&r&&typeof a=="function"&&1!=a.length&&(c=l=false);var h=this.__chain__,p=!!this.__actions__.length,a=i&&!h,c=c&&!p;return!i&&l?(o=c?o:new Mn(this),o=n.apply(o,f),o.__actions__.push({func:nu,args:[t],thisArg:F}),new zn(o,h)):a&&c?n.apply(this,f):(o=this.thru(t),a?e?o.value()[0]:o.value():o)})}),u("pop push shift sort splice unshift".split(" "),function(n){var t=ui[n],r=/^(?:push|sort|unshift)$/.test(n)?"tap":"thru",e=/^(?:pop|shift)$/.test(n);On.prototype[n]=function(){var n=arguments;if(e&&!this.__chain__){
var u=this.value();return t.apply(af(u)?u:[],n)}return this[r](function(r){return t.apply(af(r)?r:[],n)})}}),Et(Mn.prototype,function(n,t){var r=On[t];if(r){var e=r.name+"";(Ji[e]||(Ji[e]=[])).push({name:t,func:r})}}),Ji[Xr(F,2).name]=[{name:"wrapper",func:F}],Mn.prototype.clone=function(){var n=new Mn(this.__wrapped__);return n.__actions__=Mr(this.__actions__),n.__dir__=this.__dir__,n.__filtered__=this.__filtered__,n.__iteratees__=Mr(this.__iteratees__),n.__takeCount__=this.__takeCount__,n.__views__=Mr(this.__views__),
n},Mn.prototype.reverse=function(){if(this.__filtered__){var n=new Mn(this);n.__dir__=-1,n.__filtered__=true}else n=this.clone(),n.__dir__*=-1;return n},Mn.prototype.value=function(){var n,t=this.__wrapped__.value(),r=this.__dir__,e=af(t),u=0>r,i=e?t.length:0;n=i;for(var o=this.__views__,f=0,c=-1,a=o.length;++c<a;){var l=o[c],s=l.size;switch(l.type){case"drop":f+=s;break;case"dropRight":n-=s;break;case"take":n=Mi(n,f+s);break;case"takeRight":f=Di(f,n-s)}}if(n={start:f,end:n},o=n.start,f=n.end,n=f-o,
o=u?f:o-1,f=this.__iteratees__,c=f.length,a=0,l=Mi(n,this.__takeCount__),!e||!u&&i==n&&l==n)return kr(t,this.__actions__);e=[];n:for(;n--&&a<l;){for(o+=r,u=-1,i=t[o];++u<c;){var h=f[u],s=h.type,h=(0,h.iteratee)(i);if(2==s)i=h;else if(!h){if(1==s)continue n;break n}}e[a++]=i}return e},On.prototype.at=Fo,On.prototype.chain=function(){return Xe(this)},On.prototype.commit=function(){return new zn(this.value(),this.__chain__)},On.prototype.next=function(){this.__values__===F&&(this.__values__=ku(this.value()));
var n=this.__index__>=this.__values__.length;return{done:n,value:n?F:this.__values__[this.__index__++]}},On.prototype.plant=function(n){for(var t,r=this;r instanceof Sn;){var e=Pe(r);e.__index__=0,e.__values__=F,t?u.__wrapped__=e:t=e;var u=e,r=r.__wrapped__}return u.__wrapped__=n,t},On.prototype.reverse=function(){var n=this.__wrapped__;return n instanceof Mn?(this.__actions__.length&&(n=new Mn(this)),n=n.reverse(),n.__actions__.push({func:nu,args:[Je],thisArg:F}),new zn(n,this.__chain__)):this.thru(Je);
},On.prototype.toJSON=On.prototype.valueOf=On.prototype.value=function(){return kr(this.__wrapped__,this.__actions__)},On.prototype.first=On.prototype.head,Ai&&(On.prototype[Ai]=tu),On}();typeof define=="function"&&typeof define.amd=="object"&&define.amd?(Zn._=it, define(function(){return it})):Vn?((Vn.exports=it)._=it,qn._=it):Zn._=it}).call(this);

'use strict';

(function() {
  angular.module("coutureApp").directive("productTrackedTable", productTrackedTable);

  productTrackedTable.$inject = [];

  function productTrackedTable() {
    return {
      restrict: "A",
      priority: -1,
      require: "ngForm",
      controller: productTrackedTableController
    };
  }

  productTrackedTableController.$inject = ["$scope", "$parse", "$attrs", "$element"];

  function productTrackedTableController($scope, $parse, $attrs, $element) {
    var self = this;
    var tableForm = $element.controller("form");
    var dirtyCellsByRow = [];
    var invalidCellsByRow = [];

    init();

    ////////

    function init() {
      var setter = $parse($attrs.productTrackedTable).assign;
      setter($scope, self);
      $scope.$on("$destroy", function() {
        setter(null);
      });

      self.reset = reset;
      self.isCellDirty = isCellDirty;
      self.setCellDirty = setCellDirty;
      self.setCellInvalid = setCellInvalid;
      self.untrack = untrack;
    }

    function getCellsForRow(row, cellsByRow) {
      return _.find(cellsByRow, function(entry) {
        return entry.row === row;
      })
    }

    function isCellDirty(row, cell) {
      var rowCells = getCellsForRow(row, dirtyCellsByRow);
      return rowCells && rowCells.cells.indexOf(cell) !== -1;
    }

    function reset() {
      dirtyCellsByRow = [];
      invalidCellsByRow = [];
      setInvalid(false);
    }

    function setCellDirty(row, cell, isDirty) {
      setCellStatus(row, cell, isDirty, dirtyCellsByRow);
    }

    function setCellInvalid(row, cell, isInvalid) {
      setCellStatus(row, cell, isInvalid, invalidCellsByRow);
      setInvalid(invalidCellsByRow.length > 0);
    }

    function setCellStatus(row, cell, value, cellsByRow) {
      var rowCells = getCellsForRow(row, cellsByRow);
      if (!rowCells && !value) {
        return;
      }

      if (value) {
        if (!rowCells) {
          rowCells = {
            row: row,
            cells: []
          };
          cellsByRow.push(rowCells);
        }
        if (rowCells.cells.indexOf(cell) === -1) {
          rowCells.cells.push(cell);
        }
      } else {
        _.remove(rowCells.cells, function(item) {
          return cell === item;
        });
        if (rowCells.cells.length === 0) {
          _.remove(cellsByRow, function(item) {
            return rowCells === item;
          });
        }
      }
    }

    function setInvalid(isInvalid) {
      self.$invalid = isInvalid;
      self.$valid = !isInvalid;
    }

    function untrack(row) {
      _.remove(invalidCellsByRow, function(item) {
        return item.row === row;
      });
      _.remove(dirtyCellsByRow, function(item) {
        return item.row === row;
      });
      setInvalid(invalidCellsByRow.length > 0);
    }
  }
})();

(function() {
  angular.module("coutureApp").directive("productTrackedTableRow", productTrackedTableRow);

  productTrackedTableRow.$inject = [];

  function productTrackedTableRow() {
    return {
      restrict: "A",
      priority: -1,
      require: ["^productTrackedTable", "ngForm"],
      controller: productTrackedTableRowController
    };
  }

  productTrackedTableRowController.$inject = ["$attrs", "$element", "$parse", "$scope"];

  function productTrackedTableRowController($attrs, $element, $parse, $scope) {
    var self = this;
    var row = $parse($attrs.productTrackedTableRow)($scope);
    var rowFormCtrl = $element.controller("form");
    var trackedTableCtrl = $element.controller("productTrackedTable");

    self.isCellDirty = isCellDirty;
    self.setCellDirty = setCellDirty;
    self.setCellInvalid = setCellInvalid;

    function isCellDirty(cell) {
      return trackedTableCtrl.isCellDirty(row, cell);
    }

    function setCellDirty(cell, isDirty) {
      trackedTableCtrl.setCellDirty(row, cell, isDirty)
    }

    function setCellInvalid(cell, isInvalid) {
      trackedTableCtrl.setCellInvalid(row, cell, isInvalid)
    }
  }
})();

(function() {
  angular.module("coutureApp").directive("productTrackedTableCell", productTrackedTableCell);

  productTrackedTableCell.$inject = [];

  function productTrackedTableCell() {
    return {
      restrict: "A",
      priority: -1,
      scope: true,
      require: ["^productTrackedTableRow", "ngForm"],
      controller: productTrackedTableCellController
    };
  }

  productTrackedTableCellController.$inject = ["$attrs", "$element", "$scope"];

  function productTrackedTableCellController($attrs, $element, $scope) {
    var self = this;
    var cellFormCtrl = $element.controller("form");
    var cellName = cellFormCtrl.$name;
    var trackedTableRowCtrl = $element.controller("productTrackedTableRow");

    if (trackedTableRowCtrl.isCellDirty(cellName)) {
      cellFormCtrl.$setDirty();
    } else {
      cellFormCtrl.$setPristine();
    }
    // note: we don't have to force setting validaty as angular will run validations
    // when we page back to a row that contains invalid data

    $scope.$watch(function() {
      return cellFormCtrl.$dirty;
    }, function(newValue, oldValue) {
      if (newValue === oldValue) return;

      trackedTableRowCtrl.setCellDirty(cellName, newValue);
    });

    $scope.$watch(function() {
      return cellFormCtrl.$invalid;
    }, function(newValue, oldValue) {
      if (newValue === oldValue) return;

      trackedTableRowCtrl.setCellInvalid(cellName, newValue);
    });
  }
})();

//CONFIG THE TABLE
(function() {
  "use strict";

  angular.module("coutureApp").run(configureDefaults);
  configureDefaults.$inject = ["ngTableDefaults"];

  function configureDefaults(ngTableDefaults) {
    // ngTableDefaults.params.count = 5;
    // ngTableDefaults.settings.counts = [];
    ngTableDefaults.settings.groupOptions = { isExpanded: false };
  }
})();

'use strict';

/**
 * @ngdoc service
 * @name coutureApp.metadataservice
 * @description
 * # metadataservice
 * 
 */
 angular.module('coutureApp')
 .service('SeoService', ["$state", function ($state) {

    this.setMetaDataTags = function (metadata) {

        var metaDesc = metadata.description;
        var metaDescriptionAttr = document.querySelector('meta[name=description]');
        if (metaDescriptionAttr !== null&& metaDesc !== null) {
            metaDescriptionAttr.setAttribute('content', metaDesc);
        }
        var metaOGDescriptionAttr = document.querySelector('meta[property="og:description"]');
        if (metaOGDescriptionAttr !== null&& metaDesc !== null) {
            metaOGDescriptionAttr.setAttribute('content', metaDesc);
        }

        var metaKeyword = metadata.keywords;
        var metaKeywordAttr = document.querySelector('meta[name=keywords]');
        if (metaKeywordAttr !== null && metaKeyword !== null) {
            metaKeywordAttr.setAttribute('content', metaKeyword);
        } 

        var metaTitle = metadata.title;
        var metaTitleAttr = document.querySelector('title[id=title]');
        if (metaTitleAttr !== null && metaTitle !== null) {
            metaTitleAttr.text = metaTitle;
        } 

        var metaOGTitleAttr = document.querySelector('[property="og:title"]');
        if (metaOGTitleAttr !== null && metaTitle !== null) {
            metaOGTitleAttr.setAttribute('content', metaTitle);
        } 

        var metaImageUrl = metadata.imageUrl;
        var metaOGTImagettr = document.querySelector('[property="og:image"]');
        if (metaOGTImagettr !== null && (metaImageUrl !== null || metaImageUrl !== undefined)) {
            metaOGTImagettr.setAttribute('content', metaImageUrl);
        } 

    };
}]);
'use strict';

/**
 * @ngdoc service
 * @name coutureApp.NotificationService
 * @description
 * # NotificationService
 * Factory in the coutureApp.
 */
angular.module('coutureApp')
.factory('NotificationService', 
["$resource", "envService", "$http", "$rootScope", "$log", "CONFIG", "Session", "utilities", function ($resource, envService,$http,$rootScope,$log, CONFIG,Session, utilities) {

    var notificationService = {};

    notificationService.api = $resource(
    envService.read('SERVICE_DOMAIN') + "/api/auth/profile/notification/token", {}, // param defaults
    {
        'getNotificationToken' : {
            method: "GET", 
            url: envService.read('SERVICE_DOMAIN') + "/api/auth/profile/notification/token",
            cache: true, 
            isArray : true
        }
    });

    notificationService.getNotificationToken = function() {
        return notificationService.api.getNotificationToken();
    };

    notificationService.subscribeDevice = function() {
    let browserName = utilities.getBrowser();
    if(browserName == "chrome"){ //only works for chrome
        const beamsClient = new PusherPushNotifications.Client({
            instanceId: envService.read('MESSAGEBIRD_PUSHER_INSTANCE_ID'),
        });
        if($rootScope.isLogon) {
            $rootScope.enableLog ? $log.info($rootScope.UUID + " : Loading - NotificationService for Member"):'';

            const tokenProvider = new PusherPushNotifications.TokenProvider({
                url: envService.read('SERVICE_DOMAIN') + "/api/auth/profile/notification/token",
                headers: {
                    'X-Authorization':  Session.token
                },
            })

            beamsClient
            .start()
            .then(() => beamsClient.setUserId($rootScope.user.userid, tokenProvider))
            .then(() => beamsClient.addDeviceInterest(CONFIG.MESSAGEBIRD_PUSHER_DEVICE_INTEREST_ABANDONED_CART_GENERAL_REGISTERED))
            .then(() => beamsClient.addDeviceInterest(CONFIG.MESSAGEBIRD_PUSHER_DEVICE_INTEREST_ABANDONED_CART_PRODUCT_REGISTERED))
            .then(() => beamsClient.removeDeviceInterest(CONFIG.MESSAGEBIRD_PUSHER_DEVICE_INTEREST_ABANDONED_CART_GENERAL_GUEST))
            .then(() => beamsClient.removeDeviceInterest(CONFIG.MESSAGEBIRD_PUSHER_DEVICE_INTEREST_ABANDONED_CART_PRODUCT_GUEST))
            .then(() => beamsClient.removeDeviceInterest(CONFIG.MESSAGEBIRD_PUSHER_DEVICE_INTEREST_ACCOUNT_ACTIVATION))
            .then(() => beamsClient.getDeviceInterests())
            //.then((interests) => console.log("Current interests:", interests))
            .catch(err => $rootScope.enableLog ? $log.error($rootScope.UUID + " : Loading - NotificationService for Member - Err:" + err):'');
        } else {
            $rootScope.enableLog ? $log.info($rootScope.UUID + " : Loading - NotificationService for Guest"):'';

            var cart = Session.getCart();
            if(cart != null && cart.length > 0){
                beamsClient
                .start()
                .then((beamsClient) => beamsClient.getDeviceId())
                .then((deviceId) => setDeviceID(deviceId))
                .then(() => beamsClient.addDeviceInterest(CONFIG.MESSAGEBIRD_PUSHER_DEVICE_INTEREST_ABANDONED_CART_GENERAL_GUEST))
                .then(() => beamsClient.addDeviceInterest(CONFIG.MESSAGEBIRD_PUSHER_DEVICE_INTEREST_ABANDONED_CART_PRODUCT_GUEST))
                .then(() => beamsClient.removeDeviceInterest(CONFIG.MESSAGEBIRD_PUSHER_DEVICE_INTEREST_ABANDONED_CART_GENERAL_REGISTERED))
                .then(() => beamsClient.removeDeviceInterest(CONFIG.MESSAGEBIRD_PUSHER_DEVICE_INTEREST_ABANDONED_CART_PRODUCT_REGISTERED))
                .then(() => beamsClient.getDeviceInterests())
                //.then((interests) => console.log("Current interests:", interests))
                .catch(err => $rootScope.enableLog ? $log.error($rootScope.UUID + " : Loading - NotificationService for Guest - Err:" + err):'');

            } else {
                beamsClient
                .start()
                .then(() => beamsClient.removeDeviceInterest(CONFIG.MESSAGEBIRD_PUSHER_DEVICE_INTEREST_ABANDONED_CART_GENERAL_GUEST))
                .then(() => beamsClient.removeDeviceInterest(CONFIG.MESSAGEBIRD_PUSHER_DEVICE_INTEREST_ABANDONED_CART_PRODUCT_GUEST))
                .then(() => beamsClient.removeDeviceInterest(CONFIG.MESSAGEBIRD_PUSHER_DEVICE_INTEREST_ABANDONED_CART_GENERAL_REGISTERED))
                .then(() => beamsClient.removeDeviceInterest(CONFIG.MESSAGEBIRD_PUSHER_DEVICE_INTEREST_ABANDONED_CART_PRODUCT_REGISTERED))
                .then(() => beamsClient.getDeviceInterests())
                //.then((interests) => console.log("Current interests:", interests))
                .catch(err => $rootScope.enableLog ? $log.error($rootScope.UUID + " : Loading - NotificationService for Guest - Err:" + err):'');
            }

        }
    }
    }

    notificationService.subscribeDeviceForAccountActivation = function() {
    let browserName = utilities.getBrowser();
    if(browserName == "chrome"){ //only works for chrome

        const beamsClient = new PusherPushNotifications.Client({
            instanceId: envService.read('MESSAGEBIRD_PUSHER_INSTANCE_ID'),
        });
        
        beamsClient
        .start()
        .then(() => beamsClient.addDeviceInterest(CONFIG.MESSAGEBIRD_PUSHER_DEVICE_INTEREST_ACCOUNT_ACTIVATION))
        .then(() => beamsClient.getDeviceInterests())
        //.then((interests) => console.log("Current interests:", interests))
        .catch(err => $rootScope.enableLog ? $log.error($rootScope.UUID + " : Loading - NotificationService for Guest - Err:" + err):'');
    }
    }
    
    notificationService.unsubscribeDeviceForAccountActivation = function() {
    let browserName = utilities.getBrowser();
    if(browserName == "chrome"){ //only works for chrome

        const beamsClient = new PusherPushNotifications.Client({
            instanceId: envService.read('MESSAGEBIRD_PUSHER_INSTANCE_ID'),
        });
        
        beamsClient
        .start()
        .then(() => beamsClient.removeDeviceInterest(CONFIG.MESSAGEBIRD_PUSHER_DEVICE_INTEREST_ACCOUNT_ACTIVATION))
        .then(() => beamsClient.getDeviceInterests())
        //.then((interests) => console.log("Current interests:", interests))
        .catch(err => $rootScope.enableLog ? $log.error($rootScope.UUID + " : Loading - NotificationService for Guest - Err:" + err):'');
    }
    }

    function setDeviceID(deviceId) {
        $rootScope.deviceId = deviceId;
    }

    return notificationService;
}]);

'use strict';

/**
 * @ngdoc service
 * @name coutureApp.ReferralService
 * @description
 * # ReferralService
 * Factory in the coutureApp.
 */
angular.module('coutureApp')
    .factory('ReferralService', ["$resource", "envService", "AuthService", "$q", "$filter", "$translate", "$translatePartialLoader", "productStatus", "localStorageService", "$rootScope", "$log", function($resource, envService, AuthService, $q,$filter,$translate,$translatePartialLoader,productStatus, localStorageService, $rootScope, $log) {
        var referralService = {};

        
        // Interact with the RESTful API of the server.
        referralService.api = $resource(
            envService.read('SERVICE_DOMAIN') + "/api/auth/referrals/admin/list",
            {}, // param defaults
            {
              'getReferralList' : { 
                  method: "GET"
              },
            });
          referralService.getReferralList = function(filters) {
            return referralService.api.getReferralList(filters);
          };
        return referralService;
    }]);

'use strict';

/**
 * @ngdoc filter
 * @name coutureApp.filter:TitleCase
 * @function
 * @description
 * # TitleCase
 * Filter in the coutureApp.
 */
angular.module('coutureApp')
  .filter('titleCase', function () {
    return function(input) {
      input = input || '';
      return input.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
    };
  })
  .filter('creditOrSubPromo', function () {
    return function(isSubscriptionPromo) {
      var output = (isSubscriptionPromo)? "Subs" : "Credits"
      return output;
    };
  })

'use strict';


angular.module('coutureApp')
.directive('stringToNumber', function() {
  return {
    require: 'ngModel',
    link: function(scope, element, attrs, modelCtrl) {

      modelCtrl.$parsers.push(function (inputValue) {
        if (inputValue!=null){
          var newValue = modelCtrl.$modelValue != null ? inputValue.substr(modelCtrl.$modelValue.length,inputValue.length):inputValue;
          var finalValue = (isNaN(newValue) && newValue != ' ' && newValue != '+') ? modelCtrl.$modelValue : inputValue;
          element.val(finalValue);
          return finalValue;
        }
      });

    }
  }
});

	'use strict';

	/**
	 * @ngdoc function
	 * @name coutureApp.controller:ListingCreateCtrl
	 * @description
	 * # ListingCreateCtrl
	 * Controller of the coutureApp
	 */
	angular.module('coutureApp')
	  .controller('ListingCreateCtrl', ["$scope", "$state", "$rootScope", "ListingService", "UploadService", "RefDataService", "envService", "usSpinnerService", "$translate", "$log", "$sce", "DialogAlertService", "$anchorScroll", "utilities", "priceUtilities", "Upload", "AuthService", "$filter", "CONFIG", "AdminService", "$q", "USER_ROLES", "ProductService", function($scope, $state, $rootScope, ListingService, UploadService, RefDataService, envService, usSpinnerService,$translate,
			$log, $sce, DialogAlertService,$anchorScroll,utilities,priceUtilities,Upload,AuthService, $filter,CONFIG,AdminService,$q,USER_ROLES,ProductService) {

	    var self = this;
			self.selectedCredit= '';

			// DISABLE FEATURE WHERE SAME PRODUCT HAD MORE THEN 1 SIZE OR SUB-ITEMS.
      self.isMultiSizeFeatureEnable = CONFIG.LISTING_SUPPORT_MULTISIZE;
      $scope.tempSizeList = [
        {
          'size': null,
          'qty': 1,
          'desc': '',
          'conditionKey': 'NEW',
          'conditionValue': 'New'
        }
      ];

			//THE SPECIFIC FIELDS USED FOR CUSTOMER ENTER BRAND NOT ON THE PRODUCT LIST
			self.isSelectedOtherBrand = false;
			self.otherBrandName = '';
			self.UPLOAD_PHOTO_LIMIT = CONFIG.UPLOAD_PHOTO_LIMIT;
			self.PHOTO_LIMIT_MIN = CONFIG.PHOTO_SIZE_LIMIT_MIN;
			self.PHOTO_LIMIT_MAX = CONFIG.PHOTO_SIZE_LIMIT_MAX;
			self.PHOTO_RESIZE_QTY = CONFIG.PHOTO_RESIZE_RATIO;
			self.PHOTO_RESIZE_WIDTH = CONFIG.PHOTO_RESIZE_WIDTH;
			self.PHOTO_RESIZE_HEIGHT = CONFIG.PHOTO_RESIZE_HEIGHT;
			self.PRODUCT_MIN_PRICE = CONFIG.PRICE_MIN;
			self.EARNING_FROM = CONFIG.EARNING_FROM;
			self.EARNING_TO = CONFIG.EARNING_TO;
			self.proudct_currency = priceUtilities.getCurrency();
			$scope.earning_toolTip_html = $sce.trustAsHtml($filter('translate')('LISTING.LABEL.EARNING_TOOLTIP_HTML'));
			$scope.leftArrow = '/assets/images/ArrowLeft.png';
			$scope.rightArrow = '/assets/images/ArrowRight.png';
	    	$scope.colors = utilities.getColorList();
			$scope.selectedDisplayPhotoIndex = 0;
			$scope.photos = [];
			$scope.isAdmin = false;
			self.availableForRegion = utilities.isShowMainRegion();
			self.lowestPlan = priceUtilities.getSubscriptionPlanDetails(CONFIG.PLAN_SUBSCRIPTION_4)
			self.lowestPlanPrice = priceUtilities.getDiscountedCreditPrice($rootScope.geoLocation.country);
			$scope.hkdOriginalPrice = 0;
			
			this.$onInit = function() {

				if (AuthService.isAuthenticated()) {

					$rootScope.enableLog ? $log.info($rootScope.UUID + ':Loading - ListingCreateCtrl with type ' + $state.params.type):'';

					//TYPE 1: RENTAL LISTING, TYPE 2: STYLE POST
					if ($state.params.type === '2'){
						$scope.isRentalListing = false;
					}else{
						$scope.isRentalListing = true;
					}

					if (AuthService.isAuthorized(USER_ROLES.admin)){
						this.getAllUserListing();
						$scope.isAdmin = true;
					}

		      // Double submit locks
		      self.lk_listing = false;

		      // Load reference data
		      RefDataService.getCategories().$promise.then(function(resp) {

		        for (var i = 0; i < resp.length; i++) {

		          switch (resp[i].name.toLowerCase()) {
		            case 'accessories':
		              resp[i]['icon'] = 'icon-accessories';
		              break;

		            case 'clothing':
		              resp[i]['icon'] = 'icon-clothings';
		              break;

		            case 'bags & luggage':
		              resp[i]['icon'] = 'icon-bags';
		              break;

		            case 'shoes':
		              resp[i]['icon'] = 'icon-shoes';
		              break;
		            default:

		          }
		        }
		        self.categoryList = resp;
		      });

		      RefDataService.getBrands().$promise.then(function(resp) {
		        self.brandList = resp;
		        self.brandList.unshift({
		          'id': 'OTHER',
		          'name': '-- Other Brand --'
		        });
		      });



			  self.itemConditions = RefDataService.getItemConditions();
		

		      self.sizesOfTitle = [];
			  self.sizeForAllCategory = RefDataService.getSizeList();
		      self.discountOptions = RefDataService.getDiscountOptions();
		      this.req_tmp = {};

		      // Models
			  self.testHtml = '';
		      self.req_listing = {
		        'category': {},
				'subCategory': {},
				'brand': '',
				'productLine': '',
				'description': '',
				'price': '',
				'discountRate': 0,
				'size': '',
				'credit':1,
				'color': '',
				'tags': [],
				'type': 1,
				'instantRental':false,
				'lookBook': []
		      };

			  if($rootScope.geoLocation.country === CONFIG.COUNTRY_CURRENCY_CODE.SG.country_code){
				RefDataService.getForexList().$promise.then(function(resp) {
				  self.forex = resp;
				  var f = self.forex.filter(f=>f.currency == CONFIG.COUNTRY_CURRENCY_CODE.SG.currency_code);
				  
				  $scope.sgdForex = f.length > 0 ? f[0].amount : 1;
				});
			  }

			}
			self.calculateEarnings();
	    };

			//Prevent any propagation of the same event
			$('.dropdown-menu').find('input').click(function (e) {
			    e.stopPropagation();
			});

			this.isAdmin = function(){
        return AuthService.isAuthorized(USER_ROLES.admin);
      }

			$scope.selectUser = function(selectedUserProfile){
				$scope.ListingCreatedByUser = selectedUserProfile;
			}

			$scope.setDiscountAndCredit = function() {
				$scope.setDiscount();
				self.req_listing.credit=priceUtilities.returnEquivalentCreditValue(self.req_listing.price);
				self.calculateEarnings();
			}

	    $scope.setDiscount = function() {
			self.error_original_price = null;
			self.req_listing.discountRate = priceUtilities.setDiscount($scope.originalPrice , self.req_listing.price)
	    };

			this.getAllUserListing = function(){
				$scope.items = [];

				AdminService.userListing().$promise.then(function(resp) {

					resp.forEach(function(item){
						item._displayName = item.lastName + ', ' + item.firstName + ' ('+ item.username + ' )';
						$scope.items.push({'name':item._displayName,'profile':item});
						//BY DEFAULT THE OBF USER IS THE LOGON ADMIN
						if ($rootScope.user.userid == item.userid){
							$scope.ListingCreatedByUser = item;
						}
					})
				},function(err){
					$rootScope.enableLog ? $log.info($rootScope.UUID + ':ListingCreateCtrl:getAllUserListing - Error retrieve user list. '):'';
				})
			}


	    // item condition section
	    $scope.conditionTooltip = $sce.trustAsHtml('<p>NEW<br/>Preowned Never Worn<br/>(with / without tags and no alterations)</p>');
	    $scope.conditionTooltip += $sce.trustAsHtml('<p>PRISTINE<br/>Preowned Worn Once or Twice<br/>(with no obvious flaws)</p>');
	    $scope.conditionTooltip += $sce.trustAsHtml('<p>EXCELLENT<br/>Preowned (with slight or small imperfections)</p>');

      ////////////////////////////////////////////////
      //ADD NEW SIZE AND QTY TO THE PRODUCT.
      ////////////////////////////////////////////////
      $scope.addSize = function() {

        getFilteredSizeList();
        //CREATE A DEFAULT BLANK VALUE
        $scope.tempSizeList.push({
          value: '',
          'qty': 1,
          'conditionKey': 'NEW',
          'conditionValue': 'New'
        });
    }

      ////////////////////////////////////////////////
      //REMOVE THE SELECTED SIZE
      ////////////////////////////////////////////////
      $scope.removedSize = function(removeSize) {

        for (var i = 0; i < $scope.tempSizeList.length; i++) {
          if ($scope.tempSizeList[i] === removeSize) {
            $scope.tempSizeList.splice(i, 1);
            break;
          }
        }
        getFilteredSizeList();
      }



			//////////////////////////////////////////
			//GET ESTIMATE EARNING FOR RENTAL ITEM
			//////////////////////////////////////////
			this.getEarningAmount = function(periodFee){
					return priceUtilities.getEarning(periodFee);
			}

			//////////////////////////////////////////
			//GET RENTAL PRICE
			//////////////////////////////////////////
			function getRentalPrice(discountRate){
				if ($scope.originalPrice){
					return priceUtilities.getRentalPrice($scope.originalPrice,discountRate);
				}else{
					return self.req_listing ? priceUtilities.getRentalPrice(self.req_listing.price,discountRate):0;
				}
			}

			//////////////////////////////////////////
			//GET RENTAL PRICE RANGE FOR DISPLAY PURPOSE
			//////////////////////////////////////////
			this.getRentalPriceRange = function(discountRate){
				var rentalPrice = getRentalPrice(discountRate);
				if (self.req_listing.price && (self.req_listing.price <= $scope.originalPrice || !$scope.originalPrice)){
					return self.proudct_currency + '$' + Math.round(getRentalPrice(discountRate)*0.7) + ' - $' + Math.round(getRentalPrice(discountRate));
				}else{
					return '---'
				}
			}

			//////////////////////////////////////////
      //SET THE SELECTED PRODUCT SIZE
      //////////////////////////////////////////
      self.setSize = function(list, sizeObj) {
		self.error_size = null;
        list.size = sizeObj.key
        list.desc = sizeObj.value;
      }
      self.setCondition = function(list, conditionObj) {
		self.error_condition = null;
        list.conditionKey = conditionObj.key
        list.conditionValue = conditionObj.value;
      }


			/////////////////////////////////////
	    // CREATE LISTIGN WITH SAME VALUE, EXCEPT SIZE
	    /////////////////////////////////////
	this.createAnotherItem = function(){
		$scope.tempSizeList = [
          {
            'size': null,
            'qty': 1,
            'desc': '',
			'conditionKey': 'NEW',
			'conditionValue': 'New'
          }
        ];
	}


			/////////////////////////////////////
	    // DISCARD CREATE LISTING
	    /////////////////////////////////////
	    $scope.discardClose = function() {
				window.history.back();
	    };

	    /////////////////////////////////////
	    // CREATE NEW LISTING
	    /////////////////////////////////////
	    $scope.listItem = function() {
	      if (self.validate() && !self.lk_listing) {

	       	self.create();
					$anchorScroll('top');
					$rootScope.enableLog ? $log.info($rootScope.UUID + ':ListingCreateCtrl:listItem - Created listing. ' + JSON.stringify(self.req_listing)):'';
	      }
	    };

	    this.goHome = function() {
          if(utilities.isShowMainRegion()){
			$state.go('main', {});
          } else {
            $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
          }
	    }


	    $scope.invalidPhotos = [];
			$scope.selectedDisplayPhoto = null;
			$scope.selectedDisplayPhotoIndex = null;

	    ///////////////////////////////////////////////
	    // SET THE USER ENTERED DATA IN TO THE REQ_LISTING PARAMETERS AND CLEAR THE ERROR MSG
	    ///////////////////////////////////////////////
	    $scope.$watch('invalidPhotos', function(invalidPhotos) {
	      if (invalidPhotos != null && invalidPhotos.length > 0) {
					self.error_photo = $filter('translate')('GENERAL.ERROR.INVALID_PRODUCT_PHOTO1') + self.PHOTO_LIMIT_MIN + $filter('translate')('GENERAL.ERROR.INVALID_PRODUCT_PHOTO2') + self.PHOTO_LIMIT_MAX;
	      }
	    });

	    $scope.$watch('photos', function(data) {
				data ? $scope.selectedDisplayPhoto = data[0]:$scope.selectedDisplayPhoto = null;
	    });

	    ///////////////////////////////////////////////
	    // VALIDATION METHOD BEFORE CREATE LISTING.
	    // THE VALIDATION METHOD WILL ALSO TRIGGER THE ERROR MSG FOR EACH FIELD
	    ///////////////////////////////////////////////
	    self.validate = function() {
	      var isValid = true;

	      if ($scope.photos.length === 0) {
	        isValid = false;
					self.error_photo = 'GENERAL.ERROR.MISSING_PRODUCT_PHOTO';
	      }

	      if (!self.req_listing.category.id) {
	        isValid = false;
			self.error_category = 'GENERAL.ERROR.MISSING_PRODUCT_CATEGORY';
	      }

	      if (!self.req_listing.subCategory.id && self.req_listing.category.code === 'CLOTHING') {
	        isValid = false;
			self.error_subcategory = 'GENERAL.ERROR.MISSING_PRODUCT_SUBCATEGORY';
	      }

	      if (!self.req_listing.brand) {
	        isValid = false;
					self.error_brand = 'GENERAL.ERROR.MISSING_PRODUCT_BRAND';
	      }

		if (self.isSelectedOtherBrand && self.otherBrandName.length == 0){
			isValid = false;
			self.error_brand = 'GENERAL.ERROR.MISSING_PRODUCT_BRAND';
		}

		if ($scope.tempSizeList.map(m=> m.size).findIndex(i=> i === undefined || i === null) != -1 ){
			self.error_size = 'GENERAL.ERROR.MISSING_PRODUCT_SIZE'
			isValid = false;
		}

		if ($scope.tempSizeList.map(m=> m.conditionKey).findIndex(i=> i === undefined || i === null) != -1 ){
			self.error_condition = 'GENERAL.ERROR.MISSING_PRODUCT_CONDITION'
			isValid = false;
		}

		if (!self.req_listing.color) {
	        self.error_color = 'GENERAL.ERROR.MISSING_PRODUCT_COLOR'
	        isValid = false;
    	}

		if (!self.req_listing.productLine){
			self.error_productLine = 'GENERAL.ERROR.MISSING_PRODUCTLINE'
			isValid = false;
		}

	    if (!self.req_listing.credit) {
	        self.error_credit= 'GENERAL.ERROR.MISSING_CREDIT_VALUE'
	        isValid = false;
		}

	    // //   PRICING IS ONLY REQUIRED FOR LISTING, NOT STYLE POST.
	    //   if ($scope.isRentalListing) {
		// 			if ($scope.originalPrice > 0 && $scope.originalPrice < self.req_listing.price){
		// 				isValid = false;
		// 				self.error_price = 'GENERAL.ERROR.INVALID_PRODUCT_PRICE'
		// 			}else if (!self.req_listing.price) {
	    //       isValid = false;
		// 				self.error_price = 'GENERAL.ERROR.MISSING_PRODUCT_PRICE';
	    //     } else if (self.req_listing.price < self.PRODUCT_MIN_PRICE) {
	    //       isValid = false;
		// 				self.error_price = 'GENERAL.ERROR.MISSING_PRODUCT_PRICE';
	    //     }
		//   }

	    //   ORIGINAL PRICING IS ONLY REQUIRED FOR LISTING, NOT STYLE POST.
			if ($scope.isRentalListing) {
				if (!$scope.originalPrice) {
					isValid = false;
					self.error_original_price = 'GENERAL.ERROR.MISSING_PRODUCT_ORIGINAL_PRICE';
				} else if ($scope.originalPrice < self.PRODUCT_MIN_PRICE){
					isValid = false;
					self.error_original_price = 'GENERAL.ERROR.INVALID_PRODUCT_ORIGINAL_PRICE'
				} else if ($scope.originalPrice < self.req_listing.price){
					isValid = false;
					self.error_original_price = 'GENERAL.ERROR.INVALID_PRODUCT_ORIGINAL_PRICE_2'
				}
			}

			if(self.req_listing.description){
				self.error_productStyleNotes = null;
				if(utilities.containsEmoji(self.req_listing.description)){
				  isValid = false;
				  self.error_productStyleNotes = "GENERAL.ERROR.INVALID_ADDITIONAL_DESCRIPTION"
				}
			}
			

	      return isValid;
	    }

			////////////////////////////////////////////////////////////////
	    //  DISPLAY THE SELECTED THUMBNAIL IN THE BIG VIEW
	    ////////////////////////////////////////////////////////////////
	    self.displayPhoto = function(selectedPhotoIndex){
	        $scope.selectedDisplayPhotoIndex = selectedPhotoIndex;
	    }

			$scope.movePhotoEnabled = function(){
				return ($scope.photos && $scope.photos.length > 1) ? true: false;
			}

			$scope.leftClick = function(photoIndex){
				if (photoIndex > 0){
					var tempPhoto = $scope.photos[photoIndex];
					$scope.photos.splice(photoIndex,1);
					$scope.photos.splice(photoIndex-1,0,tempPhoto);
					$scope.selectedDisplayPhotoIndex = photoIndex-1;
				}
			}

			$scope.rightClick = function(photoIndex){
				if (photoIndex != $scope.photos.length-1 && $scope.photos.length > 1){
					var tempPhoto = $scope.photos[photoIndex];
					$scope.photos.splice(photoIndex,1);
					$scope.photos.splice(photoIndex+1,0,tempPhoto);
					$scope.selectedDisplayPhotoIndex = photoIndex+1;
				}
			}

	    ////////////////////////////////////////////////////////////////
	    //  CHECK IF IT IS SELECTED THE UPLOAD PHOTO BUTTON
	    ////////////////////////////////////////////////////////////////
	    self.isUploadPhotoButton = function(){
	      return $scope.photos.length < self.UPLOAD_PHOTO_LIMIT ? true : false;
	    }

			////////////////////////////////////////////////////////////////
	    //  REMOVE THE SELECTED PHOTO
	    ////////////////////////////////////////////////////////////////
	    self.markPhotoToDeleteWithIndex = function(index) {
	      self.markDelete($scope.photos[index].id);
	      $scope.invalidPhotos = null;
	      $scope.photos.splice(index,1);
	      $scope.selectedDisplayPhotoIndex = index != 0 ? index - 1 : 0;
	    }

			////////////////////////////////////////////////////////////////
	    //  UPLOAD PHOTO
	    ////////////////////////////////////////////////////////////////
	    $scope.uploadFiles = function(files, isProductImage) {
	      if (files.length > 0 && $scope.photos){
					//ONLY ADD THE ALLOWED PHOTOS TO THE MODEL, BASED ON THE MAX PHOTO ALLOWED SIZE
					var allowPhotos = self.UPLOAD_PHOTO_LIMIT - $scope.photos.length > 0 ? self.UPLOAD_PHOTO_LIMIT - $scope.photos.length : self.UPLOAD_PHOTO_LIMIT;
					$scope.photos = files.splice(0,allowPhotos).concat($scope.photos);
	        $scope.selectedDisplayPhotoIndex = 0;

	      }
	    };

			this.markDelete = function(id) {
	      if (id){
	        var index = self.toBeDeleted.indexOf(id);
	        if(index >= 0) {
	          self.toBeDeleted.splice(index, 1);
	        } else {
	          self.toBeDeleted.push(id);
	        }
	      }
	    }


	    ///////////////////////////////////////////////
	    // LIMITED TO ONLY ALLOW UPLOAD_PHOTO_LIMIT PHOTOS TO BE ADDED
	    ///////////////////////////////////////////////
	    self.checkPhotoLimit = function(files) {
				self.error_photo = null;
	      if ($scope.photos.length + files.length > self.UPLOAD_PHOTO_LIMIT){
	        $scope.selectedDisplayPhotoIndex = 0;
					// self.error_photo = 'GENERAL.ERROR.MAX_PRODUCT_PHOTO';
	      }
	    }

	    ///////////////////////////////////////////////
	    // SET THE USER ENTERED DATA IN TO THE REQ_LISTING PARAMETERS AND CLEAR THE ERROR MSG
	    ///////////////////////////////////////////////
	    self.setSelected = function(type, selectedValue) {
	      switch (type) {
	        case 'category':
				self.error_category = null;
	          	self.req_listing.category = selectedValue;
				self.subcategoryList = self.req_listing.category.subCategory;
	          	getFilteredSizeList();
	          	break;
			case 'subcategory':
				self.error_subcategory = null;
				self.req_listing.subCategory = selectedValue;
				break;
	        case 'brand':
						self.error_brand = null;
						if (selectedValue){
							self.req_listing.brand = selectedValue.name;

							//ADD SPECIAL LOGIC WHEN USER ENTER OTHER BRAND, THE req_listing WILL REMAINS '-- OTHER BRAND --'
							//BUT THE ACTUAL BRAND WILL BE STORED IN TAG. HOWEVER IT WILL NOT GOING TO DISPLAY ON SCREEN.
							if (selectedValue.name == '-- Other Brand --') {
								self.isSelectedOtherBrand = true;
							}else{
								self.isSelectedOtherBrand = false;
							}
						}
	          break;
	        case 'color':
						self.error_color = null;
	          self.req_listing.color = selectedValue.name;
	          break;
	        case 'condition':
	          $scope.selectedCondition = selectedValue;
	          break;
	        case 'credit':
						self.error_credit= null;
	          self.req_listing.credit= selectedValue.KEY;
						self.selectedCredit= selectedValue.VALUE;
	          break;
	        case 'alter':
	          $scope.selectedAlter = selectedValue;
	          break;
	      }
	    };


	    // RELOAD SIZE BASED ON CATEGORY
	    function getFilteredSizeList() {

	      self.req_listing.size = '';
				self.displaySizeTitle = [];
        //CREATE FILTER SIZE BASED ON CATEGORY eg.Clothing , Accessories, Bags & Luggage, Shoes
        for (var item in self.sizeForAllCategory) {

          //EXTRACT ONLY THE SIZE FOR THE MATCHING CATEGORY
          if (self.sizeForAllCategory[item].category !== undefined && self.sizeForAllCategory[item].category.toUpperCase() === self.req_listing.category.name.toUpperCase()) {
            //SIZE FOR THE MATCHED ONE CATEGORY
            for (var size in self.sizeForAllCategory[item].options) {

              //ONLY ADD THE SIZE TO THE DISPLAY SIZE LIST IF IT IS NOT ALREADY IN THE PRODUCT LISTING
			  //logic removed to cater for setting different conditions per item size
              //if ($scope.tempSizeList.find(p => p.size === self.sizeForAllCategory[item].options[size].key) === undefined) {
                //VALUE OF THE SPECIFIC SIZE OF THE TITLE
                self.displaySizeTitle.push(self.sizeForAllCategory[item].options[size]);
              //}
            }
          }
        }
	    }

	    // Private helper function used by create() to tokenize tags input string and format into an array of object
	    function parseTags(str) {
	      var arr = str.trim().replace(/\s+/g, ' ').split(' ');
	      var tags = [];
	      for (var i = 0; i < arr.length; i++) {
	        tags.push({
	          'name': arr[i]
	        });
	      }
	      return tags;
	    }

	    function resolveTags(tags) {

				var newTags = [];
				if (!!tags){
					// Remove duplicates
		      var tmp = [];
		      for (var i = 0; i < tags.length; i++) {
		        if (!tmp.includes(tags[i].text.toUpperCase())) {
		          tmp.push(tags[i].text.toUpperCase());
		        }
		      }

		      // Build tag list
		      for (var i = 0; i < tmp.length; i++) {
		        newTags.push({'name': tmp[i]});
		      }
				}

				//SPECIAL LOGIC FOR OTHER BRAND, IT WILL STORED AS A TAG WITH */new brand*/ IN IT.
				if (self.isSelectedOtherBrand){
					//GLOBALLY REPLACE ' ' WITH '-'
					var regEx = / /gi
					newTags.push({'name': '*^/'+self.otherBrandName.replace(regEx,'-').toUpperCase()});
				}

	      return newTags;
	    };

		function resolveCompleteTheLook(productIds) {

			var newProductIds = [];
			if (!!productIds){
				// Remove duplicates
				var tmp = [];
				for (var i = 0; i < productIds.length; i++) {
					if (!tmp.includes(productIds[i].text)) {
						tmp.push(productIds[i].text);
					}
				}

				// Build list
				for (var i = 0; i < tmp.length; i++) {
					newProductIds.push({'productId': tmp[i]});
				}
			}

	  		return newProductIds;
		};

	    // Create Listing service
	    this.create = function() {

	      self.lk_listing = true;
				self.tempProductID = null;
	      usSpinnerService.spin('spinner');

	      // Tokenize tags
	      // if(self.req_tmp.tags && self.req_tmp.tags.length > 0) {
	      // 	self.req_listing.tags = parseTags(self.req_tmp.tags);
	      // }

		  //Set subcategory to null for shoes, bags, accessories
		  if(self.req_listing.category.code !== "CLOTHING"){
			self.req_listing.subCategory = null;
		  }

	      // Resolved tags
	      if (!!self.req_tmp.tags || self.isSelectedOtherBrand) {
	        self.req_listing['tags'] = resolveTags(self.req_tmp.tags);
	      }
	      if (!!self.req_tmp.lookBook) {
	        self.req_listing['lookBook'] = resolveCompleteTheLook(self.req_tmp.lookBook);
	      }

	      // To take care of price being undefined when type 2 and 3 listing is created
	      if (!self.req_listing.price) {
	        self.req_listing.price = 0;
	      }


	      if ($scope.isRentalListing) {
	        //RENTAL LISTING
	        self.req_listing.type = 1;
	      } else {
	        //STYLE POST
	        self.req_listing.type = 2;
	      }

		  if (self.req_listing.discountRate > 0){
			self.req_listing.price = $scope.originalPrice;
		  }

		  if (self.req_listing.price > 0 && $rootScope.geoLocation.country == CONFIG.COUNTRY_CURRENCY_CODE.SG.country_code){
			var amt = self.req_listing.price / $scope.sgdForex;
			self.req_listing.price = Math.round(amt);
		  }

		    //CREATE NEW FILENAME FOR PHOTO
	      $scope.photos.forEach(function (file,index) {
	         file.newName = utilities.getNewPhotoFilename(file);
	      });

		  self.req_listing.description = btoa(self.req_listing.description);

				var promises = [];
        var deferred = $q.defer();
				promises.push(deferred.promise);

				///ADD NEW LOGIC TO CREATE LISTING ON BEHALF OF CUSTOMER
				if ($scope.ListingCreatedByUser != null && ($scope.ListingCreatedByUser.userid != $rootScope.user.userid)){
					self.req_listing.owner = {username:$scope.ListingCreatedByUser.username};

					AdminService.createListingWithUsername(this.req_listing).$promise.then(
					function(resp) {
						self.tempProductID = resp.id;
						$scope.tempSizeList.forEach(function (item){
							AdminService.adminAddProductWithSize(self.tempProductID, item.size, item.qty, self.req_listing.instantRental, item.conditionKey).$promise.then(
							function(resp){
								deferred.resolve(self.tempProductID);
							},
							function(err){
								if (err.data) {
									$rootScope.enableLog ? $log.error($rootScope.UUID + ':ListingCreateCtrl:create - Save size error: ' + err.data.reasons[0].message + ' (' + self.tempProductID + '-' + item.size + ')') : '';
								} else {
									$rootScope.enableLog ? $log.error($rootScope.UUID + ':ListingCreateCtrl:create - Save size error: ' + err + ' (' + self.tempProductID + ')') : '';
								}
								deferred.reject(err);
							});
						});
						if (self.req_listing.discountRate == 1){self.req_listing.price = 0;}
					},
					function(err) {
						deferred.reject(err);
					});
				} else {
					delete self.req_listing.owner;
					delete self.req_listing.instantRental;

					ListingService.create(self.req_listing).$promise.then(
		        	function(resp) {
						self.tempProductID = resp.id;
						$scope.tempSizeList.forEach(function (item){
							ProductService.addProductWithSize(self.tempProductID, item.size, item.qty, item.conditionKey).$promise.then(
							function(resp){
								deferred.resolve(self.tempProductID);
							},
							function(err){
								if (err.data) {
									$rootScope.enableLog ? $log.error($rootScope.UUID + ':ListingCreateCtrl:create - Save size error: ' + err.data.reasons[0].message + ' (' + self.tempProductID + '-' + item.size + ')') : '';
								} else {
									$rootScope.enableLog ? $log.error($rootScope.UUID + ':ListingCreateCtrl:create - Save size error: ' + err + ' (' + self.tempProductID + ')') : '';
								}
								deferred.reject(err);
							});
						});
						if (self.req_listing.discountRate == 1){self.req_listing.price = 0;}
					},
					function(err) {
						deferred.reject(err);
		        	});
				}

				// Upload photos using UploadService
				$q.all(promises).then(function(resp) {

					UploadService.uploadPhotosWithPaths($scope.photos, resp[0]).then(
						function(finalResp) {
							// Upload photos using UploadService
							$rootScope.enableLog ? $log.info($rootScope.UUID + ':ListingCreateCtrl:create - ' + $scope.photos.length + ' Photo(s) uploaded.'):'';
							self.lk_listing = false;
							usSpinnerService.stop('spinner');
							DialogAlertService.promptDialog('Listing created successfully. Ref#' + resp[0], '', true, 'LISTING.BUTTON.BACK_TO_MAIN', 'LISTING.BUTTON.CREATE_ANOTHER', function(){self.createAnotherItem()}, function(){self.goHome()}, true);
						},
						function(err) {
							self.lk_listing = false;
							usSpinnerService.stop('spinner');
							DialogAlertService.promptDialog('Listing created failed. Please try again later.', '', '', '', '', '', '', true, '', 'RED');
							$rootScope.enableLog ? $log.info($rootScope.UUID + ':ListingCreateCtrl:create - Listing creation failed. ' + JSON.stringify(err)):'';
						}
					);
				},function(err){
					self.lk_listing = false;
					usSpinnerService.stop('spinner');
					DialogAlertService.promptDialog('Listing created failed. Please try again later.', '', '', '', '', '', '', true, '', 'RED');
					$rootScope.enableLog ? $log.info($rootScope.UUID + ':ListingCreateCtrl:create - Listing creation error. '):'';
				})

	    };

		$scope.selectSubcategory = function(selectedSubcategory){
			$scope.ListingSubcategory = selectedSubcategory;
		}

		self.calculateEarnings = function() {
			self._earnings = priceUtilities.calculateEarningsByCurrency(self.req_listing.credit, $rootScope.geoLocation.country);
			self._dollarAmount = self.proudct_currency + "" + priceUtilities.currencyFormat(self.lowestPlanPrice * self.req_listing.credit);
		}

	  }]);

(function(angular) {
  var ngContextMenu = angular.module('directive.contextMenu', []);

  ngContextMenu.directive('cellHighlight', function() {
    return {
      restrict: 'C',
      link: function postLink(scope, iElement, iAttrs) {
        iElement.find('td')
          .mouseover(function() {
            $(this).parent('tr').css('opacity', '0.7');
          }).mouseout(function() {
            $(this).parent('tr').css('opacity', '1.0');
          });
      }
    };
  });

  ngContextMenu.directive('context', [

    function() {
      return {
        restrict: 'A',
        scope: '@&',
        compile: function compile(tElement, tAttrs, transclude) {
          return {
            post: function postLink(scope, iElement, iAttrs, controller) {
              var ul = $('#' + iAttrs.context),
                last = null;

              ul.css({
                'display': 'none'
              });
              $(iElement).bind('contextmenu', function(event) {
                event.preventDefault();
                 ul.css({
                  position: "fixed",
                  display: "block",
                  left: event.clientX + 'px',
                  top: event.clientY + 'px'
                });
                last = event.timeStamp;
              });
              //$(iElement).click(function(event) {
              //  ul.css({
              //    position: "fixed",
              //    display: "block",
              //    left: event.clientX + 'px',
              //    top: event.clientY + 'px'
              //  });
              //  last = event.timeStamp;
              //});

              $(document).click(function(event) {
                var target = $(event.target);
                if (!target.is(".popover") && !target.parents().is(".popover")) {
                  if (last === event.timeStamp)
                    return;
                  ul.css({
                    'display': 'none'
                  });
                }
              });
            }
          };
        }
      };
    }
  ]);
})(window.angular);

'use strict';

(function() {
  angular.module('coutureApp')
    .component('userListing', {
      templateUrl: 'scripts/components/user-listing/user-listing.html',
      controllerAs: 'ctrl',
      bindings: {
        loadOrNot: '<'
      },
      controller: ["$scope", "$rootScope", "$filter", "NgTableParams", "AdminService", "AuthService", "$state", "$translate", "$translatePartialLoader", "USER_ROLES", "DialogAlertService", "usSpinnerService", "$log", "CONFIG", "RentalService", "RefDataService", "priceUtilities", function($scope,$rootScope, $filter,NgTableParams, AdminService,AuthService,
        $state,$translate,$translatePartialLoader,USER_ROLES,DialogAlertService,usSpinnerService,$log,CONFIG,RentalService,RefDataService,priceUtilities) {

        var self = this;

        this.$onInit = function() {
          self.allSubscriptionPlan = [];
          if (!$rootScope.isLogon || !AuthService.isAuthorized(USER_ROLES.admin)){
            if($rootScope.geoLocation.country == null){
              $state.go('main');
            } else {
              $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
            }
          }else{
            $scope.PLAN_SUBSCRIPTION_4= CONFIG.PLAN_SUBSCRIPTION_4;
            $scope.PLAN_SUBSCRIPTION_5= CONFIG.PLAN_SUBSCRIPTION_5;
            $scope.PLAN_SUBSCRIPTION_3= CONFIG.PLAN_SUBSCRIPTION_3;
            $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - userListing"):'';
          }
          // DAY 2 LOGIC ALLOW ADMIN TO CHANGE ROLE. EG UPGRADE MEMBERSHIP
          // $scope.AllUserAuth = [];
          // $scope.AllUserAuthLabel = [{name:"Opera Software"},{name:"Opera Software"},{name:"Opera Software"},{name:"Opera Software"},{name:"Opera Software"}];
          // $scope.selectedUserAuth = [
          //  	{	name: "Opera",	maker: "Opera Software",	ticked: true	},
          //  	{	name: "Internet Explorer",	maker: "Microsoft",	ticked: false	},
          //  	{	name: "Firefox",	maker: "Mozilla Foundation",	ticked: true	},
          //  	{	name: "Safari",	maker: "Apple",	ticked: false	},
          //  	{	name: "Chrome",	maker: "Google",	ticked: true	}
          // ];
          //
        };

        ///////////////////////////////////////////////
  	    // ONLY LOAD THE LISTING IF IT IS SELECTED/VISIBLE
  	    ///////////////////////////////////////////////
        $scope.$watch('ctrl.loadOrNot', function(selectedToDisplay) {
          if (selectedToDisplay){
            $translatePartialLoader.addPart('userListing');
            self.originalData = [];
            self.loadReference();
          }
        });


        self.showProduct = showProduct;
        this.originalData = [];
        this.statusList = [{title:$filter('translate')("GENERAL.LABEL.YES"),id:true},{title:$filter('translate')("GENERAL.LABEL.NO"),id:false}];
        self.recordEditMode = false;


        //LOAD ALL THE PRODUCTS
        this.loadReference = function() {
          usSpinnerService.spin('spinner');
          AdminService.userListing().$promise.then(function(resp) {

            //ADD CREATION DATE TO THE DATA
            for (var i = 0; i < resp.length; i++) {
              resp[i]._createTime = new Date(resp[i].createTime).toLocaleDateString();
              resp[i]._userRoles = self.getRoles(resp[i]);
              resp[i]._dispatchType = resp[i].dispatchType;
            }

            self.tableParams = new NgTableParams({}, {
              filterOptions: {
                filterLayout: "horizontal"
              },
              dataset: resp
            });

            self.usernameFilterDef = {
              'userid': {
                id: "text",
                placeholder: $filter('translate')("USER_LISTING.LABEL.PLACEHOLDER_USERID")
              },
              'username': {
                id: "text",
                placeholder: $filter('translate')("USER_LISTING.LABEL.PLACEHOLDER_USERNAME")
              }
            };

            self.nameFilterDef = {
              'lastName': {
                id: "text",
                placeholder: $filter('translate')("USER_LISTING.LABEL.PLACEHOLDER_LAST_NAME")
              },
              'firstName': {
                id: "text",
                placeholder: $filter('translate')("USER_LISTING.LABEL.PLACEHOLDER_FIRST_NAME")
              }
            };

            self.dispatchTypeList = [];
            RefDataService.getDispatchType().forEach(function(item, index) {
              self.dispatchTypeList.push({
                title: item.name,
                id: item.name,
                value: item.value
              });
            });
            self.originalData = angular.copy(resp);
            self.loadSubscriptionPricing();
            usSpinnerService.stop('spinner');
          },
          function(err) {
            usSpinnerService.stop('spinner');
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":userListing:loadReference - Error: " + JSON.stringify(err.data.reasons)):'';
          });
        };

        self.getRoles = function(userRecord){
          var result = [];
          angular.forEach(userRecord.authorities,function(value,key){
            switch (value.authority) {
              case 'ROLE_MEMBER':
                this.push("M");
                break;
              case 'ROLE_ADMIN':
                this.push("A");
                break;
              case 'ROLE_PREMIUM_MEMBER':
                this.push("P");
                break;
              default:

            }
          },result);
          return result.toString();
        }


        self.cancel = function(row, rowForm) {
          var originalRow = resetRow(row, rowForm);
          angular.extend(row, originalRow);
          self.recordEditMode = false;
        }

        self.subscribe= function(planId){
            self.showStatusMsg =true;
            self.selected.statusMsg= "Trying...";
          RentalService.buySubscriptionAdmin(planId,self.selected.userId).$promise.then(function(resp){
            $rootScope.enableLog ? $log.info($rootScope.UUID + ":ctrl:subscribe user to plan - Successfully"):'';
            self.showPlanButtons=false;
            self.selected.statusMsg="Success";
            usSpinnerService.stop('spinner');
          },
          function(err){
            self.selected.showTryingStatus=false;
            usSpinnerService.stop('spinner');
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":ctrl:subscribe user to plan - - failed: " + JSON.stringify(err)):'';
            self.selected.statusMsg= "Failed: "+ err.data.reasons[0].message;
            self.recordEditMode = false;
          });
        }
        self.selectRow= function(row){
          self.showPlanButtons=true;
          self.selected={};
          self.selected.userId=row.userid;
          self.selected.email=row.email;
          self.selected.name=row.firstName+ " " + row.lastName;
          self.selected.row=row;
        }

        // RETRIEVE PRODUCT BASED ON PRODUCT ID
        function showProduct(id) {
          if($rootScope.geoLocation.country == null){
            $state.go('listing', {id: id});
          } else {
            $state.go('listing-multi-region', {id: id, country: $rootScope.geoLocation.country});
          }
        };

        self.del = function(row) {
          _.remove(self.tableParams.settings().dataset, function(item) {
            return row === item;
          });
          self.tableParams.reload().then(function(data) {
            if (data.length === 0 && self.tableParams.total() > 0) {
              self.tableParams.page(self.tableParams.page() - 1);
              self.tableParams.reload();
            }
          });
          deleteServerRecord(row);
        }

        function resetRow(row, rowForm) {
          row.isEditing = false;
          rowForm.$setPristine();
          self.tableTracker.untrack(row);
          return _.find(self.originalData, function(r) {
            return r.userid === row.userid;
          });
        }

        self.save = function(row, rowForm) {
          var tempUserProfile = {id:row.id,username:row.username,isEnabled:row.isEnabled,isActivated:row.isActivated,
            email:row.email,firstName:row.firstName,lastName:row.lastName,phone1:row.phone1,aboutMe:row.aboutMe,businessName:row.businessName,dispatchType:row.dispatchType.title};
          
          AdminService.updateUserProfile(tempUserProfile).$promise.then(function(resp) {
            $rootScope.enableLog ? $log.info($rootScope.UUID + ":userListing:save - Successfully update personal info."):'';
            row._dispatchType = row.dispatchType.value;
            var originalRow = resetRow(row, rowForm);
            angular.extend(originalRow, row);
            self.recordEditMode = false;
          }, function(err) {
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":userListing:save - Error: " + JSON.stringify(err)):'';
            var error_txn = err.data && err.data.reasons && err.data.reasons[0] ? $filter('translate')("GENERAL.ERROR."+ err.data.reasons[0].code) : "We are unable to update user (ID: "+row.username+")for the moment. Please try again later.";

            DialogAlertService.promptDialog(error_txn, '', '', '', 'Ok', '', '', false,'',"RED");
          });
        }

        //THIS FUNCTION DELETE THE SERVER USER RECORD - THERE IS NO SUCH THING FOR DELETE A USER. ONLY DISABLED.
        function deleteServerRecord(userRecord) {
          self.recordEditMode = false;
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":userListing:deleteServerRecord - Deleted User."):'';
        }

        this.loadSubscriptionPricing = function(){
          RentalService.getAllSubscriptionPricingAdmin().$promise.then(function(resp){
            resp.forEach((item) => {
              var subscription = {};
              subscription.id = item.id;
              subscription.name = item.itemName;
              subscription.country = item.country;
              subscription.price = item.country + "" + priceUtilities.currencyFormat(item.price);
              subscription.numContractMonths = item.numContractMonths;
              self.allSubscriptionPlan.push(subscription);
            });
          },
          function(err) {
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":userListing:loadSubscriptionPricing - Error: " + JSON.stringify(err.data.reasons)):'';
          });

        };

        self.openAdminUserSubscription = function(row) {
          var userDetails={};
          userDetails.userid=row.userid;
          userDetails.username=row.username;
          userDetails.email=row.email;
          userDetails.name=row.firstName+ " " + row.lastName;
          DialogAlertService.openAdminUserSubscription(userDetails, self.allSubscriptionPlan);
        }



      }]
    })
})();

'use strict';

(function(){
  angular.module('coutureApp')
    .component('productListing', {
      templateUrl: 'scripts/components/product-listing/product-listing.html',
      controllerAs : 'ctrl',
      bindings: {
        loadOrNot: '<'
      },
      controller: ["$scope", "$rootScope", "USER_ROLES", "AuthService", "NgTableParams", "ProductService", "ListingService", "priceUtilities", "RefDataService", "$state", "DialogAlertService", "$log", "$filter", "$translate", "$translatePartialLoader", "usSpinnerService", "productStatus", "AdminService", "$q", "utilities", "WishlistService", "CONFIG", function($scope,$rootScope,USER_ROLES,AuthService,NgTableParams,ProductService,ListingService,priceUtilities
        ,RefDataService,$state,DialogAlertService, $log, $filter,$translate,$translatePartialLoader,usSpinnerService,productStatus
        ,AdminService,$q,utilities,WishlistService,CONFIG) {

        this.$onInit = function(){
          $scope.params = {
            limit: 20,
            query: {},
            currentPage: 1,
            totalItems: 0
          };

          if (!$rootScope.isLogon || !AuthService.isAuthorized(USER_ROLES.admin)){
            if(utilities.isShowMainRegion()){
              $state.go('main');
            } else {
              $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
            }
          }else{
            $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - productListing"):'';
            this.originalData = [];
            this.categoryList = null;
            this.categoryFilterList = [];
            self.recordEditMode = false;
            self.isInstantRentalChanged = false;
            self.isItemConditionChanged = false;
            self.isHubChanged = false;

            self.listingStatusFilter = getListingStatusFilter();

            // Load reference data
            RefDataService.getCategories().$promise.then(function(resp) {
              self.categoryList = [];
              for (var item in resp) {
                !isNaN(resp[item].id) ? self.categoryList.push({id:resp[item].id,title:resp[item].name,name:resp[item].name}):'';
                !isNaN(resp[item].id) ? self.categoryFilterList.push({id:resp[item].id,title:resp[item].name,name:resp[item].name}):'';
              }
            });
            self.downloadResult = {
              message : null,
              type : null,
              disable: false
            };

            self.ownerFilterDef = {
              '_createdByID': {
                id: "text",
                placeholder: "USER ID"
              },
              '_createdByUsername': {
                id: "text",
                placeholder: "USERNAME"
              }
            };

			      self.itemConditions = RefDataService.getItemConditions();
            self.itemConditionsFilterList = [];
            self.itemConditions.forEach(function(item) {
              self.itemConditionsFilterList.push({id:item.key,title:item.value,name:item.value});
            });
          }
        };

        ///////////////////////////////////////////////
  	    // ONLY LOAD THE LISTING IF IT IS SELECTED/VISIBLE
  	    ///////////////////////////////////////////////
        $scope.$watch('ctrl.loadOrNot', function(selectedToDisplay) {
          if (selectedToDisplay){
            $translatePartialLoader.addPart('productListing');
            self.originalData = [];
            self.loadReference();
          }
        });

        var self = this;

        //LOAD ALL THE PRODUCTS
        this.loadReference = function(){

          self.tableParams = new NgTableParams({ 
            page: 1,
            count: 15,
            sorting: { 
              productID: "DESC"
            },
          }, {
            counts:[15],
            getData: function(params) {
              usSpinnerService.spin('spinner');

              var tableFilters = params._params.filter;
              var filterParams = {};
              var tableParams = params._params;
              var sort = params._params.sorting;
              var sortType = null;
              var sortDir = null;
              if(sort._brandName){
                sortType = "brand";
                sortDir = sort.brand;
              } else if(sort.color){
                sortType = "color";
                sortDir = sort.color;
              } else if(sort._createdByID){
                sortType = "owner.id";
                sortDir = sort._createdByID;
              }  else if(sort._createdByUsername){
                sortType = "owner.username";
                sortDir = sort._createdByUsername;
              } else if(sort.creationDate){
                sortType = "creationDate";
                sortDir = sort.creationDate;
              } else if(sort.category){
                sortType = "category.name";
                sortDir = sort.category;
              } else if(sort.price){
                sortType = "price";
                sortDir = sort.price;
              } else {
                sortType = "id";
                sortDir = "DESC";
              }

              var masterID = tableFilters._masterID ? tableFilters._masterID.split("-") : null;
              var productID = masterID ? masterID[0] : null;
              var itemID = masterID ? masterID[1] : null;


              filterParams.page = tableParams.page;
              filterParams.productID = productID ? productID : null;
              filterParams.itemID = itemID ? itemID : null;
              filterParams.sku = tableFilters.sku ? tableFilters.sku : null;
              filterParams.brand = tableFilters.brand ? tableFilters.brand : null;
              filterParams.size = tableFilters.size ? tableFilters.size : null;
              filterParams.itemCondition = tableFilters._conditionValue ? tableFilters._conditionValue : null;
              filterParams.hub = tableFilters.hub ? tableFilters.hub : null;
              filterParams.color = tableFilters.color ? tableFilters.color : null;
              filterParams.rentalCredit = tableFilters.rentalCredit ? tableFilters.rentalCredit : null;
              filterParams.price = tableFilters.price ? tableFilters.price : null;
              filterParams.rentStatus = tableFilters.status ? tableFilters.status : null;
              filterParams.curated = tableFilters.curated ? tableFilters.curated : null;
              filterParams.category = tableFilters.category ? tableFilters.category : null;
              filterParams.instantRental = tableFilters.instantRental ? tableFilters.instantRental : null;

              filterParams.ownerID = tableFilters._createdByID ? tableFilters._createdByID : null;
              filterParams.username = tableFilters._createdByUsername ? tableFilters._createdByUsername : null;
              filterParams.creationDate = null;

              filterParams.sortType = sortType;
              filterParams.sortDirection = sortDir;

              var newProductsData = [];
              return ProductService.getAllProductListingV2(filterParams).$promise.then(function(resp) {
                $scope.data = resp;
                var totalRecordCount, totalPageCount;

                $scope.data.forEach(function(item, index, arr) {
                  if (!item['searchResult']) {
                    item._modifyDate = item.modifyDate == null ? item.creationDate : item.modifyDate;
                    item._page = self.currentPageCount;
                  } else {
                    totalRecordCount = item['searchResult']['totalRecordCount'];
                    totalPageCount = item['searchResult']['totalPageCount'];
                    arr.pop();
                  }
                });


                //ADD STATUS NAME AND DATE TO THE DATA
                for (var i = 0; i < $scope.data.length; i++) {
                  var tempProduct = $scope.data[i];
                  var priceTemp = tempProduct.discountRate > 0 ? (tempProduct.price*(1-tempProduct.discountRate)) : tempProduct.price;

                  tempProduct._statusName = productStatus.getListingStatusDisplay(tempProduct.status);
                  tempProduct._creationDate = new Date(tempProduct.createdDate).toLocaleDateString();
                  tempProduct._createdBy = tempProduct.product.ownerDTO.id + " " + tempProduct.product.ownerDTO.lastName + ", " + tempProduct.product.ownerDTO.firstName;
                  tempProduct._createdByID = tempProduct.product.ownerDTO.id;
                  tempProduct._createdByUsername = tempProduct.product.ownerDTO.username;
                  tempProduct._tagPrice = priceUtilities.getFormattedAmountByRate(priceTemp);
                  tempProduct._rentalPrice = priceUtilities.getRentalPrice(tempProduct.price,tempProduct.discountRate);
                  tempProduct._brandName = tempProduct.brand;
                  tempProduct._curated = tempProduct.curated;
                  tempProduct._masterID = tempProduct.masterID;
                  tempProduct._conditionValue = tempProduct.itemCondition;
                  tempProduct._sizeValue = tempProduct.size;
                  tempProduct.status = tempProduct.status;

                  newProductsData.push(tempProduct);
                }
                usSpinnerService.stop('spinner');
                params.total(totalRecordCount);
                return newProductsData;
              },
              function(err) {
                usSpinnerService.stop('spinner');
                $rootScope.enableLog ? $log.error($rootScope.UUID + ":productListing:loadReference - Error: " + JSON.stringify(err.data.reasons)):'';
              });
            }
          });
        };

        ///////////////////////////////////////////////
        // UPDATE CURATED
  	    ///////////////////////////////////////////////
        this.curatedChange = function(row, rowForm){
          rowForm.$setDirty();
          row.curated = !row.curated;
          self.isCuratedChanged = !self.isCuratedChanged;
          
          angular.element(document.getElementById(row.id)).addClass('btn-danger');
        }

        ///////////////////////////////////////////////
        // UPDATE INSTANT RENTAL STATUS
  	    ///////////////////////////////////////////////
        this.instantRentalChange = function(row, rowForm){
          rowForm.$setDirty();
          row.instantRental = !row.instantRental;
          self.isInstantRentalChanged = !self.isInstantRentalChanged;
          if(row.instantRental){
            if(!row.hub){
              row.hub = "SG";
            }
          } else {
            row.hub = null;
          }
          angular.element(document.getElementById(row.id)).addClass('btn-danger');
        }

        ///////////////////////////////////////////////
        // UPDATE ITEM CONDITION
  	    ///////////////////////////////////////////////
        this.itemConditionChange = function(row, rowForm){
          rowForm.$setDirty();

          if(row._conditionValue == 'NEW') {
            row._conditionValue  = 'PRISTINE';
          } else if(row._conditionValue == 'PRISTINE') {
            row._conditionValue  = 'EXCELLENT';
          } else if(row._conditionValue == 'EXCELLENT') {
            row._conditionValue  = 'GOOD';
          } else if(row._conditionValue == 'GOOD') {
            row._conditionValue  = 'FAIR';
          } else {
            row._conditionValue  = 'NEW';
          }

          self.isItemConditionChanged = !self.isItemConditionChanged;
          angular.element(document.getElementById(row.id)).addClass('btn-danger');
        }

        ///////////////////////////////////////////////
        // UPDATE ITEM HUB
  	    ///////////////////////////////////////////////
        this.itemHubChanged = function(row, rowForm){
          rowForm.$setDirty();

          if(row.hub == 'SG') {
            row.hub = 'HK';
          } else if(row.hub == 'HK') {
            row.hub = 'SG';
          } else {
            row.hub = 'SG';
          }

          self.isHubChanged = !self.isHubChanged;
          angular.element(document.getElementById(row.id)).addClass('btn-danger');
        }
        /////////////////////////////////////
  	    // CREATE INSTANT RENTAL STATUS FILTER
  	    /////////////////////////////////////
        this.getInstantRentalFilter = function(){
          return [{id: 'true', title: 'Yes'},{id: 'false', title: 'No'}];
        }

        /////////////////////////////////////
  	    // CREATE HUB FILTER
  	    /////////////////////////////////////
        this.getHubFilter = function(){
          return [{id: 'SG', title: 'SG'},{id: 'HK', title: 'HK'}];
        }


        /////////////////////////////////////
  	    // CREATE AND RETURN AN ARRAY LIST OF LISTING STATUS
  	    /////////////////////////////////////
        function getListingStatusFilter(){
          var resultList = [];
          for (var item in productStatus.listingStatusMapping) {
            resultList.push({id:item,title:productStatus.getListingStatusDisplay(item),value:item});
          }
          return resultList;
        }

        self.cancel = function(row, rowForm) {
          var originalRow = resetRow(row, rowForm);
          angular.extend(row, originalRow);
        }

        // RETRIEVE PRODUCT BASED ON PRODUCT ID
        self.showProduct = function(id, product) {
          var url;
          var productBrand = utilities.getCustomBrandName(product);
          var urlSlug = utilities.getPrettyUrl(product.category.code, product.subCategory.code, productBrand, product.productLine);
          if(utilities.isShowMainRegion()){
            url = $state.href('listing', {id: id, urlSlug: urlSlug});
          } else {
            url = $state.href('listing-multi-region', {id: id, urlSlug: urlSlug, country: $rootScope.geoLocation.country});
          }
          window.open(url,'_blank');
        };

        self.del = function(row, rowForm) {
          ListingService.delete(row.id).$promise.then(function(resp){
            if (resp.deleted){
              $rootScope.enableLog ? $log.info($rootScope.UUID + ":productListing:del - Successful"):'';
              self.recordEditMode = false;

              //change this row table status to delete for display purpose.
              row.status =  32;
              row._statusName = productStatus.getListingStatusDisplay(row.status);
              var originalRow = resetRow(row, rowForm);
              angular.extend(originalRow, row);

              //REMOVE THE ITEM FROM THE TABLE
              // _.remove(self.tableParams.settings().dataset, function(item) {
              //   return record === item;
              // });
              // self.tableParams.reload().then(function(data) {
              //   if (data.length === 0 && self.tableParams.total() > 0) {
              //     self.tableParams.page(self.tableParams.page() - 1);
              //     self.tableParams.reload();
              //   }
              // });
            }else{
              DialogAlertService.promptDialog('Error delete product (ID: '+row.id+'). Please try again later. ', '', '', '', 'Ok', '', '', false,'',"RED");
              $rootScope.enableLog ? $log.error($rootScope.UUID + ":productListing:del - Error1: " + JSON.stringify(resp)):'';
            }
          },
          function(err){
            DialogAlertService.promptDialog('Error delete product (ID: '+row.id+'). Please try again later. ', '', '', '', 'Ok', '', '', false,'',"RED");
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":productListing:del - Error2: " + JSON.stringify(err)):'';
          });

        }

        function resetRow(row, rowForm){
          row.isEditing = false;
          rowForm.$setPristine();
          self.tableTracker.untrack(row);
          return _.find(self.originalData, function(r){
            return r.id === row.id;
          });
        }


        /////////////////////////////////////////////////////
        // UPDATE THE TAG/PRICE AND DISCOUNT RATE
        /////////////////////////////////////////////////////
        self.updatePrice = function(row,rowForm){

          //THE PRODUCT HAD ORIGINAL PRICE AND THE CHANGED TAG PRICE IS > ORIGINAL PRICE
          //RESTORE THE TAG PRICE
          var originalProduct = _.find(self.originalData, function(r){
            return r.id === row.id;
          });
          if (row._tagPrice > originalProduct.price && row.discountRate > 0 || row._tagPrice < CONFIG.PRICE_MIN_INT){
            row._tagPrice = originalProduct._tagPrice;
            rowForm.price.$setPristine();
            DialogAlertService.promptDialog('Tag price must larger than $10 but less then original price: $' + originalProduct.price, '', '', '', '', '', '', true, '', 'RED');
          }

          //UPDATE THE DISCOUNT RATE IF THE PRODUCT HAD DISCOUNT RATE EXISTED (EG. HAVE TAG PRICE AND ORIGINAL PRICE)
          if (row.discountRate){
            row.discountRate = priceUtilities.setDiscount(originalProduct.price , row._tagPrice);
            row.price = row._tagPrice / (1-row.discountRate);
          }else{
            row.price = row._tagPrice;
          }
          row._rentalPrice = priceUtilities.getRentalPrice(row.price,row.discountRate);
        }


        self.save = function(row, rowForm) {
          usSpinnerService.spin('spinner');

         // var promises = [];
        //  var deferred = $q.defer();
          if(row.status == 6 || row.status == 8) {
            if (self.isInstantRentalChanged || self.isItemConditionChanged || self.isHubChanged){
            // promises.push(deferred.promise);
              row.status = row.instantRental ? 6:8;
              AdminService.changeProductItemStatus({
                itemID:row.productItemID,
                statusID: row.status, 
                itemCondition:row._conditionValue, 
                hub:row.hub}).$promise.then(
                function(resp){
                var originalRow = resetRow(row, rowForm);
                angular.extend(row, originalRow);
                self.isInstantRentalChanged = false;
                self.isItemConditionChanged = false;
                self.isHubChanged = false;
                self.recordEditMode = false;
                row._statusName = productStatus.getListingStatusDisplay(row.status);
                usSpinnerService.stop('spinner');
                //deferred.resolve();
              },function(err){
              // deferred.reject("Error: Changing instant rental indicator.");
                usSpinnerService.stop('spinner');
                DialogAlertService.promptDialog('Error updating sub product (ID: '+row.productItemID+'). Please try again later. ', '', '', '', 'Ok', '', '', false,'',"RED");
                $rootScope.enableLog ? $log.error($rootScope.UUID + ":changeProductItemStatus:save - Error: " + JSON.stringify(err)):'';
                self.recordEditMode = false;
              })
            }
          }

          if(self.isCuratedChanged){
            AdminService.changeProductItemCurated(row.productID, row.curated).$promise.then(
							function(resp){
                var originalRow = resetRow(row, rowForm);
                angular.extend(row, originalRow);
                self.isInstantRentalChanged = false;
                self.isItemConditionChanged = false;
                self.isHubChanged = false;
                self.recordEditMode = false;
                self.isCuratedChanged = false;
                row._statusName = productStatus.getListingStatusDisplay(row.status);
                usSpinnerService.stop('spinner');
							},
							function(err){
                usSpinnerService.stop('spinner');
								if (err.data) {
									$rootScope.enableLog ? $log.error($rootScope.UUID + ':ListingCreateCtrl:changeProductItemCurated error: ' + err.data.reasons[0].message + ' (' + self.tempProductID + '-' + item.size + ')') : '';
								} else {
									$rootScope.enableLog ? $log.error($rootScope.UUID + ':ListingCreateCtrl:changeProductItemCurated error: ' + err + ' (' + self.tempProductID + ')') : '';
								}
							});
          }
        }
        
        self.downloadProductCatalogue = function(){
          self.downloadResult.message = $translate.instant('PRODUCT_LISTING.MESSAGE.DOWNLOAD_CATALOGUE_INPROGRESS');
          self.downloadResult.type = "alert-info";
          self.downloadResult.disable = true;
          var params = {
            'country': $rootScope.geoLocation.country,
            'currency': $rootScope.geoLocation.currency,
            'exchangeRate': $rootScope.geoLocation.rate
          };
          ListingService.downloadProductCatalogue(params).$promise.then(
            function(resp){
              self.downloadResult.message = $translate.instant('PRODUCT_LISTING.MESSAGE.DOWNLOAD_CATALOGUE_COMPLETE');
              self.downloadResult.type = "alert-success";
              self.downloadResult.disable = false;
            },function(err){
              self.downloadResult.message = $translate.instant('PRODUCT_LISTING.MESSAGE.DOWNLOAD_CATALOGUE_ERROR');
              self.downloadResult.type = "alert-danger";
              self.downloadResult.disable = false;
            }
          );
        }
        
        self.downloadWishlist = function(){
          self.downloadResult.message = $translate.instant('PRODUCT_LISTING.MESSAGE.DOWNLOAD_CATALOGUE_INPROGRESS');
          self.downloadResult.type = "alert-info";
          self.downloadResult.disable = true;
          WishlistService.downloadWishlist().$promise.then(
            function(resp){
              self.downloadResult.message = $translate.instant('PRODUCT_LISTING.MESSAGE.DOWNLOAD_CATALOGUE_COMPLETE');
              self.downloadResult.type = "alert-success";
              self.downloadResult.disable = false;
            },function(err){
              self.downloadResult.message = $translate.instant('PRODUCT_LISTING.MESSAGE.DOWNLOAD_CATALOGUE_ERROR');
              self.downloadResult.type = "alert-danger";
              self.downloadResult.disable = false;
            }
          );
        }
      }]
    })
})();

'use strict';

(function(){
  angular.module('coutureApp')
    .component('productRentalListing', {
      templateUrl: 'scripts/components/product-rental-listing/product-rental-listing.html',
      controllerAs : 'ctrl',
      bindings: {
        loadOrNot: '<'
      },
      controller: ["$rootScope", "$scope", "NgTableParams", "$state", "USER_ROLES", "ProductService", "AuthService", "DialogAlertService", "RefDataService", "$filter", "$log", "$translate", "$translatePartialLoader", "ListingService", "usSpinnerService", "RentalService", "envService", "utilities", "productStatus", "CONFIG", "BuyService", "TransactionService", "PayoutService", "$uibModal", "priceUtilities", function($rootScope,$scope,NgTableParams,$state,USER_ROLES,ProductService,AuthService,DialogAlertService,
        RefDataService,$filter,$log,$translate,$translatePartialLoader,ListingService,usSpinnerService,RentalService,envService,utilities,productStatus,CONFIG,BuyService,TransactionService,PayoutService,$uibModal,priceUtilities) {

        this.$onInit = function(){
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - productRentalListing"):'';
          if (!$rootScope.isLogon || !AuthService.isAuthorized(USER_ROLES.admin)){
            if(utilities.isShowMainRegion()){
              $state.go('main');
            } else {
              $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
            }
          }else{
            this.scope = $scope;
            this.originalData = [];
            this.tempStatusFlow = [];
            this.categoryList = [];

            //ONLY ALLOW ONE RECORD TO BE EDIT AT ONE TIME
            this.formIsEditing = false;

            // Load reference data
            RefDataService.getCategories().$promise.then(function(resp) {
              for (var i = 0; i < resp.length; i++) {
                self.categoryList.push({title:resp[i].name,id:resp[i].name, value:resp[i].name});
              }
            });
          }
            self.downloadResult = {
              message : null,
              type : null,
              disable: false
            };
        };

        var self = this;

        ///////////////////////////////////////////////
  	    // ONLY LOAD THE LISTING IF IT IS SELECTED/VISIBLE
  	    ///////////////////////////////////////////////
        $scope.$watch('ctrl.loadOrNot', function(selectedToDisplay) {
          if (selectedToDisplay){
            $translatePartialLoader.addPart('productRentalListing');
            $translatePartialLoader.addPart('checkout');
            self.originalData = [];
            self.loadProductRentalList();
          }
        });

        //LOAD ALL THE RENTAL PRODUCTS
        this.loadProductRentalList = function(){
          self.transactionReferenceNumberFilterDef = {
            'transactionReferenceNumber': {
              id: "text",
              placeholder: "Transaction Reference Number"
            }
          };
          self.currencyFilterDef = {
            'country': {
              id: "text",
              placeholder: "Currency"
            }
          };
          self.checkoutReferenceNumberFilterDef = {
            'checkoutReferenceNumber': {
              id: "text",
              placeholder: "Checkout Reference Number"
            }
          };
          self.bundleIdFilterDef = {
            'bundleID': {
              id: "text",
              placeholder: "Bundle ID"
            }
          };
          self.masterIdFilterDef = {
            '_masterID': {
              id: "text",
              placeholder: "Master ID"
            }
          };
          self.brandNameFilterDef = {
            'brandName': {
              id: "text",
              placeholder: "Brand"
            }
          };
          self.sizeFilterDef = {
            'size': {
              id: "text",
              placeholder: "Size"
            }
          };
          self.colorFilterDef = {
            'color': {
              id: "text",
              placeholder: "Color"
            }
          };
          self.payoutRefFilterDef = {
            'payoutReferenceNumber': {
              id: "text",
              placeholder: "Payout Reference Number"
            }
          };


          self.ownerFilterDef = {
            'ownerID': {
              id: "text",
              placeholder: "User ID"
            },
            'ownerUsername': {
              id: "text",
              placeholder: "Username"
            }
          };

          self.customerFilterDef = {
            'customerID': {
              id: "text",
              placeholder: "User ID"
            },
            'customerUsername': {
              id: "text",
              placeholder: "Username"
            }
          };

          self.tableParams = new NgTableParams({ 
            page: 1,
            count: 15,
            sorting: { 
              creationDate: "DESC"
            },
          }, {
            counts:[15],
            getData: function(params) {
              usSpinnerService.spin('spinner');

              var tableFilters = params._params.filter;
              var filterParams = {};
              var tableParams = params._params;
              var sort = params._params.sorting;
              var sortType = null;
              var sortDir = null;
              
              if(sort.brandName){
                sortType = "brand";
                sortDir = sort.brand;
              } else if(sort.color){
                sortType = "color";
                sortDir = sort.color;
              } else if(sort.creationDate){
                sortType = "creationDate";
                sortDir = sort.creationDate;
              } else if(sort.category){
                sortType = "category";
                sortDir = sort.category;
              } else if(sort.checkoutReferenceNumber){
                sortType = "checkoutReferenceNumber";
                sortDir = sort.checkoutReferenceNumber;
              } else if(sort.payoutReferenceNumber){
                sortType = "payoutReferenceNumber";
                sortDir = sort.payoutReferenceNumber;
              } else if(sort._masterID){
                sortType = "product";
                sortDir = sort._masterID;
              }  else {
                sortType = "creationDate";
                sortDir = "DESC";
              }

              var masterID = tableFilters._masterID ? tableFilters._masterID.split("-") : null;
              var productID = masterID ? masterID[0] : null;
              var itemID = masterID ? masterID[1] : null;

              filterParams.page = tableParams.page;
              filterParams.productID = productID ? productID : null;
              filterParams.itemID = itemID ? itemID : null;
              filterParams.orderID = tableFilters.transactionReferenceNumber ? tableFilters.transactionReferenceNumber : null;
              filterParams.checkoutRef = tableFilters.checkoutReferenceNumber ? tableFilters.checkoutReferenceNumber : null;
              filterParams.brand = tableFilters.brandName ? tableFilters.brandName : null;
              filterParams.category = tableFilters.category ? tableFilters.category : null;
              filterParams.size = tableFilters.size ? tableFilters.size : null;
              filterParams.color = tableFilters.color ? tableFilters.color : null;
              filterParams.itemCondition = tableFilters.itemCondition ? tableFilters.itemCondition : null;
              filterParams.ownerID = tableFilters.ownerID ? tableFilters.ownerID : null;
              filterParams.username = tableFilters.ownerUsername ? tableFilters.ownerUsername : null;
              filterParams.customerID = tableFilters.customerID ? tableFilters.customerID : null;
              filterParams.customerUsername = tableFilters.customerUsername ? tableFilters.customerUsername : null;
              filterParams.creationDate = null;
              filterParams.rentStatus = tableFilters.status ? tableFilters.status : null;
              filterParams.transactionType = tableFilters.transactionType ? tableFilters.transactionType : null;
              filterParams.country = tableFilters.country ? tableFilters.country : null;
              filterParams.bundleID = tableFilters.bundleID ? tableFilters.bundleID : null;
              filterParams.sortType = sortType;
              filterParams.sortDirection = sortDir;

              var newProductsData = [];
              return ProductService.getAllRentalListingV2(filterParams).$promise.then(function(resp) {
                $scope.data = resp;
                var totalRecordCount, totalPageCount;

                $scope.data.forEach(function(item, index, arr) {
                  if (!item['searchResult']) {
                    item._modifyDate = item.modifyDate == null ? item.creationDate : item.modifyDate;
                    item._page = self.currentPageCount;
                  } else {
                    totalRecordCount = item['searchResult']['totalRecordCount'];
                    totalPageCount = item['searchResult']['totalPageCount'];
                    arr.pop();
                  }
                });


                //ADD STATUS NAME AND DATE TO THE DATA
                for (var i = 0; i < $scope.data.length; i++) {
                  var tempResponse = $scope.data[i];
                  tempResponse._orderID = tempResponse.transactionReferenceNumber;
                  tempResponse._creationDate = moment(new Date(tempResponse.creationDate)).format('D/M/YYYY');
                  tempResponse._merchantFullName = tempResponse.merchantUserId + " " + tempResponse.merchantUsername; //tempResponse.merchantFullname
                  tempResponse._customerFullName = tempResponse.customerUserId + " " + tempResponse.customerUsername; //tempResponse.customerFullname
                  tempResponse._masterID = tempResponse.product + "-" + (tempResponse.item ? tempResponse.item : "");
                  tempResponse._earnings = priceUtilities.formatWithCountryCode(tempResponse.earnings, tempResponse.country);
                  newProductsData.push(tempResponse);
                }
                
                newProductsData.sort(function(a, b){return b.creationDate-a.creationDate;});

                usSpinnerService.stop('spinner');
                params.total(totalRecordCount);
                return newProductsData;
              },
              function(err) {
                usSpinnerService.stop('spinner');
                $rootScope.enableLog ? $log.error($rootScope.UUID + ":productRentalListing:loadProductRentalList - Error: " + JSON.stringify(err.data.reasons)):'';
              });
            }
          });
        };

        //DEFINE THE RENTAL STATUS LABEL, KEYS, NAME AND IT'S FLOW
        self.rentalStatus = {};
        Object.keys(productStatus.rentalStatusMapping).forEach((key) => {
          self.rentalStatus[key] =  {shortLabel:key,fullLabel:productStatus.rentalStatusMapping[key]};
        })
        //CREATE SHORT LABEL AND FULL LABEL FOR DISPLAY
        //CREATE WORKFLOW TO ONLY ALLOW CHANGE OF STATUS AS DEFINED IN flow
        self.rentalStatus[1] =  {shortLabel:'R',fullLabel:productStatus.rentalStatusMapping[1]};
        self.rentalStatus[2] =  {shortLabel:'A',fullLabel:productStatus.rentalStatusMapping[2],flow:['8','32','64']};
        self.rentalStatus[4] =  {shortLabel:'D',fullLabel:productStatus.rentalStatusMapping[4]};
        self.rentalStatus[8] =  {shortLabel:'R',fullLabel:productStatus.rentalStatusMapping[8]};
        self.rentalStatus[16] =  {shortLabel:'E',fullLabel:productStatus.rentalStatusMapping[16]};
        self.rentalStatus[32] =  {shortLabel:'FD',fullLabel:productStatus.rentalStatusMapping[32]};
        self.rentalStatus[64] =  {shortLabel:'FI',fullLabel:productStatus.rentalStatusMapping[64]};

        self.allStatus = {};
        Object.keys(productStatus.allStatusMapping).forEach((key) => {
          self.allStatus[key] =  {shortLabel:key,fullLabel:productStatus.allStatusMapping[key]};
        })
        self.allStatus[8] =  {shortLabel:'R',fullLabel:productStatus.rentalStatusMapping[8]};

        //THE PRE-DEFINED STATUS LIST. NEED TO MATCH WITH DB
        self.statusFilter = [];
        Object.keys(productStatus.allStatusMapping).forEach((key) => {
          self.statusFilter.push({id:$filter('translate')(self.allStatus[key].fullLabel),title:$filter('translate')(self.allStatus[key].fullLabel),value:key});
        });


        self.itemConditions = RefDataService.getItemConditions();
        self.itemConditionsFilterList = [];
        self.itemConditions.forEach(function(item) {
          self.itemConditionsFilterList.push({id:item.key,title:item.value,name:item.value});
        });

        self.transactionTypeFilterList = [];
        self.transactionTypeFilterList.push({id:"RENT",title:"RENT",name:"RENT"});
        self.transactionTypeFilterList.push({id:"BUY",title:"BUY",name:"BUY"});



        //PUBLISH THE FUNCTION SO IT CAN BE CALLED FROM CONTROLLER
        self.cancel = cancel;
        self.del = del;
        self.save = save;
        self.statusChange = statusChange;
        self.showStatusFlow = showStatusFlow;

        ///////////////////////////////////////////////////////////
        // RETRIEVE THE RENTAL ORDER DETAILS
        ///////////////////////////////////////////////////////////
        self.getOrderDetails = function(orderID, transactionType){
          if(transactionType == CONFIG.TRANSACTION_TYPE_RENT) {
            RentalService.getOrderDetails(orderID).$promise.then(function(resp){
              if (resp.product.pictures.length > 0) {
                resp.product.pictures[0]._url = resp.product.pictures[0].pathSrc === 'shopify' ? resp.product.pictures[0].path : (envService.read('IMG_DOMAIN') + "/" + resp.product.pictures[0].path);
              }else{
                resp.product.pictures[0] = {};
                resp.product.pictures[0]._url = "";
              }
              DialogAlertService.displayOrderDetails(orderID,resp);
            },function(err){
              $rootScope.enableLog ? $log.error($rootScope.UUID + ":productRentalListing:getOrderDetails - Error: " + JSON.stringify(err.data)):'';
            })
          } else {
            BuyService.getOrderDetails(orderID).$promise.then(function(resp){
              if (resp.product.pictures.length > 0) {
                resp.product.pictures[0]._url = resp.product.pictures[0].pathSrc === 'shopify' ? resp.product.pictures[0].path : (envService.read('IMG_DOMAIN') + "/" + resp.product.pictures[0].path);
              }else{
                resp.product.pictures[0] = {};
                resp.product.pictures[0]._url = "";
              }
              DialogAlertService.displayBuyOrderDetails(orderID,resp);
            },function(err){
              $rootScope.enableLog ? $log.error($rootScope.UUID + ":productRentalListing:displayBuyOrderDetails - Error: " + JSON.stringify(err.data)):'';
            })
          }
        }

        self.viewInvoice = function(checkoutReferenceNumber){
          TransactionService.viewInvoice(checkoutReferenceNumber).$promise.then(function(resp){
            DialogAlertService.viewInvoice(checkoutReferenceNumber,resp);
          },function(err){
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":productRentalListing:viewInvoice - Error: " + JSON.stringify(err.data)):'';
          })
        }


        function showStatusFlow(status){
          return self.tempStatusFlow.length==0 ? self.rentalStatus[status].flow : self.tempStatusFlow;
        }


        //THE FUNCTION WILL UPDATE AND RENTAL STATUS
        function statusChange(row, rowForm,statusID){
          //DEFINE THE TEMPSTATUSFLOW WHERE IT WILL BE USED TO CONTINUE DISPLAY THE STATUS AVAILABLE WHEN THE CUSTOMER SELECTED A NEW STATUS.
          self.tempStatusFlow.length == 0 ? self.tempStatusFlow = self.rentalStatus[row.status].flow:'';
          //RESET ALL BUTTON COLOR IN THE STATUS
          for (var i = 0; i < self.tempStatusFlow.length; i++) {
            angular.element(document.getElementById(row.id+'-'+self.tempStatusFlow[i])).removeClass('btn-danger');
          }
          rowForm.$setDirty();
          row.status = statusID;
          //SET THE SELECTION BUTTON COLOR
          angular.element(document.getElementById(row.id+'-'+row.status)).addClass('btn-danger');

          // save(row,rowForm);
        }

        function cancel(row, rowForm) {
          var originalRow = resetRow(row, rowForm);
          angular.extend(row, originalRow);
        }

        function del(row) {
          self.tempStatusFlow = [];
          self.formIsEditing = false;

          _.remove(self.tableParams.settings().dataset, function(item) {
            return row === item;
          });
          self.tableParams.reload().then(function(data) {
            if (data.length === 0 && self.tableParams.total() > 0) {
              self.tableParams.page(self.tableParams.page() - 1);
              self.tableParams.reload();
            }
          });
        }

        function resetRow(row, rowForm){
          self.tempStatusFlow = [];
          self.formIsEditing = false;

          row.isEditing = false;
          rowForm.$setPristine();
          self.tableTracker.untrack(row);
          return _.find(self.originalData, function(r){
            return r.id === row.id;
          });
        }

        function save(row, rowForm) {

          updateRentalStatus(row);

          var originalRow = resetRow(row, rowForm);
          angular.extend(originalRow, row);
        }

        function updateRentalStatus(record){
          switch (record.status) {
            case '8':
              ProductService.updateProductStatus_ApproveRental(record.id).$promise.then(function(resp){
                //DO NOTHING
              },function(err){
                $rootScope.enableLog ? $log.info($rootScope.UUID + ":productRentalListing:updateRentalStatus - Error: " + JSON.stringify(err)):'';
              });
              break;
            case '32':
              ProductService.updateProductStatus_FailedDeliver(record.id).$promise.then(function(resp){
                //DO NOTHING
              },function(err){
                $rootScope.enableLog ? $log.info($rootScope.UUID + ":productRentalListing:updateRentalStatus - Error: " + JSON.stringify(err)):'';
              });
              break;
            case '64':
              ProductService.updateProductStatus_FailedInspection(record.id).$promise.then(function(resp){
                //DO NOTHING
              },function(err){
                $rootScope.enableLog ? $log.info($rootScope.UUID + ":productRentalListing:updateRentalStatus - Error: " + JSON.stringify(err)):'';
              });
              break;
            default:

          }

        }

        self.getPayoutRequest = function(payoutReferenceNumber){
          var modalInstance = $uibModal.open({
            templateUrl: 'views/modals/payout-request-confirmation.html',
            controller: ["$scope", "priceUtilities", function($scope, priceUtilities) {
              $scope.submitted = false;
              $scope.listingView = true;
              PayoutService.getPayoutDetails(payoutReferenceNumber).$promise.then(function(resp) {
                $scope.payoutdetails = resp;
                $scope.requestedAmount = priceUtilities.currencyFormat(resp.selectedAmount);
              });
            }]
          });
    
          
        }


        self.downloadTransactionList = function(){
          self.downloadResult.message = $translate.instant('PRODUCT_LISTING.MESSAGE.DOWNLOAD_CATALOGUE_INPROGRESS');
          self.downloadResult.type = "alert-info";
          self.downloadResult.disable = true;
          TransactionService.downloadTransactionList().$promise.then(
            function(resp){
              self.downloadResult.message = $translate.instant('PRODUCT_LISTING.MESSAGE.DOWNLOAD_CATALOGUE_COMPLETE');
              self.downloadResult.type = "alert-success";
              self.downloadResult.disable = false;
            },function(err){
              self.downloadResult.message = $translate.instant('PRODUCT_LISTING.MESSAGE.DOWNLOAD_CATALOGUE_ERROR');
              self.downloadResult.type = "alert-danger";
              self.downloadResult.disable = false;
            }
          );
        }
        
      }]
    })
})();

'use strict';

angular.module('coutureApp')
  .controller('ProductDashboardCtrl', ["$scope", "AuthService", "Session", "USER_ROLES", function($scope, AuthService, Session, USER_ROLES) {


    this.showProduct = function(){
      return AuthService.isAuthorized(USER_ROLES.admin);
    }
  }]);

'use strict';

/**
 * @ngdoc function
 * @name coutureApp.controller:ListingCtrl
 * @description
 * # ListingCtrl
 * Controller of the coutureApp
 */
angular.module('coutureApp')
  .controller('ListingCtrl', ["$scope", "$rootScope", "$state", "utilities", "priceUtilities", "CartService", "PageCtx", "usSpinnerService", "ListingService", "DialogAlertService", "Session", "$uibModal", "$log", "$location", "$sce", "AuthService", "RentalService", "ErrorHandler", "CONFIG", "CalendarService", "$translate", "$anchorScroll", "$timeout", "ProductService", "envService", "RefDataService", "SeoService", "WishlistService", "$window", "USER_ROLES", function($scope, $rootScope,$state, utilities,priceUtilities,CartService,PageCtx, usSpinnerService, ListingService,
    DialogAlertService, Session, $uibModal, $log, $location,$sce,AuthService, RentalService,ErrorHandler,CONFIG,CalendarService,$translate,$anchorScroll,$timeout,
    ProductService,envService,RefDataService,SeoService,WishlistService,$window,USER_ROLES) {

    var self = this;

    this.$onInit = function() {
      $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - ListingCtrl"):'';

      $scope.isAdmin = false;
      if (AuthService.isAuthorized(USER_ROLES.admin)){
        $scope.isAdmin = true;
      } 

      $rootScope.showLgLogo=true;
      this.params = Session.prev_searchParams;
      $rootScope.isCheckoutSidebarActive = false;
      self.proudct_currency = priceUtilities.getCurrency();
      self.availableForRegion = utilities.isFunctionEnabled();
      $scope.verifyImg = '/assets/images/non_verified.png';
      $scope.linkedProducts;
      self.isRentalTransaction = $rootScope.transactionType == CONFIG.TRANSACTION_TYPE_RENT;
      self.isPurchaseTransaction = $rootScope.transactionType == CONFIG.TRANSACTION_TYPE_BUY;
      self.selectedWeek = 1;
      self.selectedWeekCode = 'one';

      //WORKAROUND TO LOAD THE TRANSLATION.

      $translate(['LISTING.LABEL.CLEAN_CONDITION_HTML']).then(function(trans){
        $scope.CLEAN_CONDITION_HTML = $sce.trustAsHtml(trans['LISTING.LABEL.CLEAN_CONDITION_HTML']);
      });

      $translate(['LISTING.LABEL.DELIVERY_RETURNS_NOTE1_HTML']).then(function(trans){
        $scope.DELIVERY_RETURNS_NOTE1_HTML = $sce.trustAsHtml(trans['LISTING.LABEL.DELIVERY_RETURNS_NOTE1_HTML']);
      });

      $translate(['LISTING.LABEL.DELIVERY_RETURNS_NOTE2_HTML']).then(function(trans){
        $scope.DELIVERY_RETURNS_NOTE2_HTML = $sce.trustAsHtml(trans['LISTING.LABEL.DELIVERY_RETURNS_NOTE2_HTML']);
      });

      $translate(['LISTING.LABEL.DELIVERY_RETURNS_NOTE3_HTML']).then(function(trans){
        $scope.DELIVERY_RETURNS_NOTE3_HTML = $sce.trustAsHtml(trans['LISTING.LABEL.DELIVERY_RETURNS_NOTE3_HTML']);
      });

      $translate(['LISTING.LABEL.ITEM_CONDITION_FAQ']).then(function(trans){
        $scope.ITEM_CONDITION_FAQ = $sce.trustAsHtml(trans['LISTING.LABEL.ITEM_CONDITION_FAQ']);
      });

      $translate(['LISTING.LABEL.DELIVERY_FAQ']).then(function(trans){
        $scope.DELIVERY_FAQ = $sce.trustAsHtml(trans['LISTING.LABEL.DELIVERY_FAQ']);
      });

      setProductDetails();
      setConditionAvailability(self.lowestCondition);

      $scope.productData = {
        id: null,
        size: null,
        rental: null
      };

      // product options dropdown section
      $scope.productOptions = [
        'Reset to Available',
        'Option 2',
        'Option 3'
      ];

      self.sizeList = null;
      self.sizeForAllCategory = RefDataService.getSizeList();

      // product slider section
  	  $scope.myInterval = 5000;
  	  $scope.noWrapSlides = false;
  	  $scope.active = 0;
      $scope.showRentalPrice = false;

      this.selectedSize = null;
      this.selectedSizeValue = null;
      $scope.dateSelectionButton = {
        status: false,
        text: self.isRentalTransaction ? 'LISTING.LABEL.SELECT_DATE' : 'LISTING.LABEL.ADD_TO_BAG'
      };

      self.listing = {"isOwner":true};

      //FOR NOW THERE IS ONLY A LA CARTE, NO MEMBERSHIP
      $scope.isRental = "carte";
      $scope.conditionTooltip = $sce.trustAsHtml('Original Value');

      $scope.slider = {
        minValue: CONFIG.ITEM_CONDITION[0],
        maxValue: self.isRentalTransaction ? CONFIG.ITEM_CONDITION[2] : CONFIG.ITEM_CONDITION[4],
        options: {
          showTicksValues: true,
          stepsArray: CONFIG.ITEM_CONDITION
        }
      };
      
      self.get($state.params.id);
      self.scrollUp();
    }

    ////////////////////////////
    // SCROLL TO TOP
    ////////////////////////////
    this.scrollUp = function(){
      $timeout(() => {
        $anchorScroll('top');
      },500);
    }

    /////////////////////////////////
    //GET THE LIST OF PRODUCT BASED ON THE DEFINED PARAS
    /////////////////////////////////
    this.getProductWith = function(query, inputPriceMin,	inputPriceMax){
      if(utilities.isShowMainRegion()){
        $state.go('search', {q:query,mm:true,brand: null,category: null,min: inputPriceMin | CONFIG.PRICE_MIN,max: inputPriceMax | CONFIG.PRICE_MAX,fdmin: null,fdmax: null,feeMin:null,feeMax:null,fp: null,type:CONFIG.DEFAULT_SEARCH_TYPE,page:null,status:null,sort:CONFIG.DEFAULT_SEARCH_SORT_ORDER,color:null,size:null});
      } else {
        $state.go('search-multi-region', {q:query,mm:true,brand: null,category: null,min: inputPriceMin | CONFIG.PRICE_MIN,max: inputPriceMax | CONFIG.PRICE_MAX,fdmin: null,fdmax: null,feeMin:null,feeMax:null,fp: null,type:CONFIG.DEFAULT_SEARCH_TYPE,page:null,status:null,sort:CONFIG.DEFAULT_SEARCH_SORT_ORDER,color:null,size:null,country: $rootScope.geoLocation.country});
      }
    }

    this.goToCircularShop = function(username){
      var shopFront = $rootScope.shopfrontList;//.size > 0 ? $rootScope.shopfrontList : CONFIG.SHOP_FRONT;
      if (shopFront.indexOf(username.toLowerCase()) == -1){
        this.getProductWith(self.listing.brand);
      } else {
        if(utilities.isShowMainRegion()){
          $state.go('viewOtherUserRentalListings',{otherUsername:username});
        } else {
          $state.go('viewOtherUserRentalListings-multi-region',{otherUsername:username,country: $rootScope.geoLocation.country});
        }
      }
    }


    /////////////////////////////////
    // SET THE CURRENT PRESENTING THUMBNAIL AND PRODUCT IMAGE.
    /////////////////////////////////
    $scope.slideTo = function(index) {
      if(index >= 0 && index < self.listing.pictures.length) {
			  $scope.active = index;
		  }
	  };

    //////////////////////////////////////////
    //CALCULATE ALL THE PRICING
    //////////////////////////////////////////
    this.calculatePricing = function(){

      var productSummaryMap = priceUtilities.sumOfProductsInCart();
      self.subTotalRentalPrice = productSummaryMap.get('subTotalRentalPrice');
      self.subTotalProtectionFee = productSummaryMap.get('subTotalProtectionFee');
      self.subTotalShippingFee = productSummaryMap.get('subTotalShippingFee');
      self.discountApplied = productSummaryMap.get('discountApplied');
      self.totalPrice = productSummaryMap.get('totalPrice');
      self.subTotalRentalCredit= productSummaryMap.get('subTotalRentalCredit');
      self.totalMiscFee= self.subTotalProtectionFee+self.subTotalShippingFee;
    }

    /////////////////////////////////////////////
    //CHECK IF THE PRODUCTID-SUBID IS IN CART ALREADY
    ////////////////////////////////////////////
    this.isEveryAvailableSizeInCart = function(sizeKeys){
      let cartKeys = $rootScope.cc.cart.map(cartItem => cartItem.cartID);
      return !sizeKeys.every(key => cartKeys.includes(key));
    }


    //////////////////////////////////////////
    //DETERMINE THE STYLEPASS OPTION TO DISPLAY OR NOT
    //////////////////////////////////////////
    $scope.isShowStylePassOptions = function(){
      
      if (self.listing.isOwner){
        return false;
      }

      if ($rootScope.credit == null || $rootScope.credit.balance == null){
        return true;
      }else if ($rootScope.credit.balance.activeSubscriptionId == null){
        return true;
      }else{
        return false;
      }
    }


    //////////////////////////////////////////
    //ADD THE SELECTED ITEM TO CART
    //////////////////////////////////////////
    this.addToCart = function(){
      const rental = {
        cartID: null, 
        productID: self.listing.id, 
        product: self.listing, 
        size: self.selectedSize, 
        selectedDate: null,
        transactionType: $rootScope.transactionType,
      };

      if(self.isRentalTransaction){
        this.addToCartRent();
      } else {
        this.addToCartBuy();
      }

    }

    this.addToCartRent = function(){

      const rental = {
        cartID: null, 
        productID: self.listing.id, 
        product: self.listing, 
        size: self.selectedSize, 
        selectedDate: null,
        transactionType: CONFIG.TRANSACTION_TYPE_RENT,
        itemCondition: self.lowestCondition,
        bundleID: null
      };

       //GET THE UNIQUE KEY FOR THE SELECTED PRODUCT SIZE.
	    const keysInCartForSelectedSize = $rootScope.cc.cart
      .filter(
        cartItem => 
          cartItem.size === self.selectedSize && 
          cartItem.itemCondition === self.lowestCondition && 
          cartItem.productID === rental.productID
      )
      .map(cartItem => cartItem.cartID);


      // GET THE PRODUCT KEYS ARRAY FOR EACH DIFFERENT PRODUCT SIZE (EG. 'PRODUCTID-SUBITEMID')
      const allKeysForSelectedSizeOnly = self.listing._availableSize
        .filter(sizeObj => sizeObj.size === self.selectedSize);

      const allKeysForSelectedSizeAndCondition = allKeysForSelectedSizeOnly[0].subItems
          .filter(sizeObj => sizeObj.itemCondition === self.lowestCondition);

      const allKeysForSelectedSize = allKeysForSelectedSizeAndCondition
        .map(selectedSizeObj => selectedSizeObj.keys)
        .flat();

      if (keysInCartForSelectedSize.length > 0 && 
          keysInCartForSelectedSize.length < allKeysForSelectedSize.length) {

        //ALREADY HAVE PRODUCT IN CART, ADD ANOTHER PRODUCT OF THE SAME SIZE TO CART
        let availableKeysForSelectedSize = [...allKeysForSelectedSize];

        keysInCartForSelectedSize.forEach(cartKey => {
          availableKeysForSelectedSize = availableKeysForSelectedSize.filter(
            availableKey => availableKey != cartKey
          );
        });

        rental.cartID = availableKeysForSelectedSize[0];
        $scope.dateSelectionButton.status = false;

      } else if (keysInCartForSelectedSize.length === 0) {

        //FIRST PRODUCT OF SELECTED SIZE ADDED TO THE CART
        rental.cartID = allKeysForSelectedSize[0];
        $scope.dateSelectionButton.status = false;
        
      } else {
        //MAX AVAILABLE ITEM REACHED
        return;
      }

        CalendarService.openCalendar(function() {
          
          utilities.loadAllowedDatesByMerchant(rental.product.owner.id, rental.product.id);
          //CHECKOUT DIRECTLY
          if (rental.product != null && rental.selectedDate != null){
              utilities.replaceItemInArray(rental,$rootScope.cc.cart);
              rental.bundleID = utilities.generateBundleID(self.listing, rental.selectedDate.START_DATE, rental.selectedDate.RETURN_DATE, rental.cartID);
              //STORE PRODUCT ID IN LOCAL SERVICE
                  var sessionCartDetails = {
                    cartID:rental.cartID, 
                    productID:self.listing.id, 
                    size:self.selectedSize, 
                    startDate: rental.selectedDate.START_DATE,
                    returnDate: rental.selectedDate.RETURN_DATE,
                    transactionType: CONFIG.TRANSACTION_TYPE_RENT, 
                    price: {
                      purchasePrice: self.listing.purchasePrice,
                      originalPrice: self.listing.price,
                      salePrice: self.listing.salePrice
                    },
                    itemCondition: self.lowestCondition,
                    bundleID: rental.bundleID,
                    country: $rootScope.geoLocation.country
                  };
              Session.updateCartV2(sessionCartDetails);

            if(!$rootScope.isLogon){
              DialogAlertService.openLogon(function(){
                //[START] CC-1082 for analytics
                CartService.captureAddToCart(self.listing);
                //[END] CC-1082 for analytics
                var cartDetails = {
                  'cartID' : rental.cartID, 
                  'productID' : self.listing.id, 
                  'size' : self.selectedSize, 
                  'startDate' : rental.selectedDate.START_DATE, 
                  'returnDate' : rental.selectedDate.RETURN_DATE, 
                  'transactionType' : CONFIG.TRANSACTION_TYPE_RENT, 
                  'itemCondition' : self.lowestCondition,
                  'bundleID': rental.bundleID,
                  'country': $rootScope.geoLocation.country
                };
                CartService.addCart(cartDetails);
                priceUtilities.applyPromo($scope.temp_promoCode,$rootScope.cc.cart)
                self.calculatePricing();
                usSpinnerService.spin('spinner');
                    $timeout(() => {
                      usSpinnerService.stop('spinner');
                      if(utilities.isShowMainRegion()){
                        $state.go('checkout');
                      } else {
                        $state.go('checkout-multi-region', {country: $rootScope.geoLocation.country});
                      }
                    },1500);
              });
            } else {
              //[START] CC-1082 for analytics
              CartService.captureAddToCart(self.listing, rental);
              //[END] CC-1082 for analytics
              var cartDetails = {
                'cartID' : rental.cartID, 
                'productID' : self.listing.id, 
                'size' : self.selectedSize, 
                'startDate' : rental.selectedDate.START_DATE, 
                'returnDate' : rental.selectedDate.RETURN_DATE, 
                'transactionType' : CONFIG.TRANSACTION_TYPE_RENT, 
                'itemCondition' : self.lowestCondition,
                'bundleID': rental.bundleID,
                'country': $rootScope.geoLocation.country
              };
              CartService.addCart(cartDetails);
              priceUtilities.applyPromo($scope.temp_promoCode,$rootScope.cc.cart)
              self.calculatePricing();
              usSpinnerService.spin('spinner');
              $timeout(() => {
                usSpinnerService.stop('spinner');
                if(utilities.isShowMainRegion()){
                  $state.go('checkout');
                } else {
                  $state.go('checkout-multi-region', {country: $rootScope.geoLocation.country});
                }
              },1500);
            }
          }

        }, function() {

          //SAVED TO CART
          if (rental.product != null && rental.selectedDate != null){
            rental.bundleID = utilities.generateBundleID(self.listing, rental.selectedDate.START_DATE, rental.selectedDate.RETURN_DATE, rental.cartID);
              utilities.replaceItemInArray(rental,$rootScope.cc.cart);
              //STORE PRODUCT ID IN LOCAL SERVICE
              var sessionCartDetails = {
                    cartID:rental.cartID, 
                    productID:self.listing.id, 
                    size:self.selectedSize, 
                    startDate: rental.selectedDate.START_DATE,
                    returnDate: rental.selectedDate.RETURN_DATE,
                    transactionType: CONFIG.TRANSACTION_TYPE_RENT, 
                    price: {
                      purchasePrice: self.listing.purchasePrice,
                      originalPrice: self.listing.price,
                      salePrice: self.listing.salePrice
                    },
                    itemCondition: self.lowestCondition,
                    bundleID: rental.bundleID,
                    country: $rootScope.geoLocation.country
              };
              Session.updateCartV2(sessionCartDetails);

              var cartDetails = {
                'cartID' : rental.cartID, 
                'productID' : self.listing.id, 
                'size' : self.selectedSize, 
                'startDate' : rental.selectedDate.START_DATE, 
                'returnDate' : rental.selectedDate.RETURN_DATE, 
                'transactionType' : CONFIG.TRANSACTION_TYPE_RENT, 
                'itemCondition' : self.lowestCondition,
                'bundleID': rental.bundleID,
                'country': $rootScope.geoLocation.country
              };
              CartService.addCart(cartDetails);
          
              //[START] CC-1082 for analytics
              CartService.captureAddToCart(self.listing, rental);
              //[END] CC-1082 for analytics
            }

        }, function(date, endDate) {
            rental.selectedDate={'START_DATE':null, 'RETURN_DATE':null};
            rental.selectedDate.START_DATE = moment(date).format('x');
            rental.selectedDate.RETURN_DATE = moment(endDate).format('x');//moment(Number(rental.selectedDate.START_DATE)).add(CONFIG.DEFAULT_RENTAL_DURATION,'d').format('x');
        }, utilities.getAvailableDatesWithSizeByMerchant(self.selectedSize,self.listing,self.lowestCondition),
        self.listing.credit, self.selectedWeek);
      $rootScope.credit.selectedOneTimeAtCheckout=false;
    }

    this.addToCartBuy = function(){
      const rental = {
        cartID: null, 
        productID: self.listing.id, 
        product: self.listing, 
        size: self.selectedSize, 
        selectedDate: null,
        transactionType: CONFIG.TRANSACTION_TYPE_BUY,
        itemCondition: self.lowestCondition,
        price: {
          purchasePrice: self.listing.purchasePrice,
          originalPrice: self.listing.price,
          salePrice: self.listing.salePrice
        }
      };

       //GET THE UNIQUE KEY FOR THE SELECTED PRODUCT SIZE.
	    const keysInCartForSelectedSize = $rootScope.cc.cart
      .filter(
        cartItem => 
          cartItem.size === self.selectedSize && 
          cartItem.itemCondition === self.lowestCondition && 
          cartItem.productID === rental.productID
      )
      .map(cartItem => cartItem.cartID);


      // GET THE PRODUCT KEYS ARRAY FOR EACH DIFFERENT PRODUCT SIZE (EG. 'PRODUCTID-SUBITEMID')
      const allKeysForSelectedSizeOnly = self.listing._availableSize
        .filter(sizeObj => sizeObj.size === self.selectedSize);

      const allKeysForSelectedSizeAndCondition = allKeysForSelectedSizeOnly[0].subItems
          .filter(sizeObj => sizeObj.itemCondition === self.lowestCondition);

      const allKeysForSelectedSize = allKeysForSelectedSizeAndCondition
        .map(selectedSizeObj => selectedSizeObj.keys)
        .flat();

      if (keysInCartForSelectedSize.length > 0 && 
          keysInCartForSelectedSize.length < allKeysForSelectedSize.length) {

        //ALREADY HAVE PRODUCT IN CART, ADD ANOTHER PRODUCT OF THE SAME SIZE TO CART
        let availableKeysForSelectedSize = [...allKeysForSelectedSize];

        keysInCartForSelectedSize.forEach(cartKey => {
          availableKeysForSelectedSize = availableKeysForSelectedSize.filter(
            availableKey => availableKey != cartKey
          );
        });

        rental.cartID = availableKeysForSelectedSize[0];
        $scope.dateSelectionButton.status = false;

      } else if (keysInCartForSelectedSize.length === 0) {

        //FIRST PRODUCT OF SELECTED SIZE ADDED TO THE CART
        rental.cartID = allKeysForSelectedSize[0];
        $scope.dateSelectionButton.status = false;
        
      } else {
        //MAX AVAILABLE ITEM REACHED
        return;
      }
      var sessionCartDetails = {
        cartID:rental.cartID, 
        productID:self.listing.id, 
        size:self.selectedSize, 
        startDate: null,
        returnDate: null,
        transactionType: CONFIG.TRANSACTION_TYPE_BUY, 
        price: {
          purchasePrice: self.listing.purchasePrice,
          originalPrice: self.listing.price,
          salePrice: self.listing.salePrice
        },
        itemCondition : self.lowestCondition,
        bundleID : rental.bundleID,
        country: $rootScope.geoLocation.country
      };
      utilities.replaceItemInArray(rental,$rootScope.cc.cart);
      Session.updateCartV2(sessionCartDetails);

      var cartDetails = {
        'cartID' : rental.cartID, 
        'productID' : self.listing.id, 
        'size' : self.selectedSize, 
        'startDate' : null, 
        'returnDate' : null, 
        'transactionType' : CONFIG.TRANSACTION_TYPE_BUY, 
        'itemCondition' : self.lowestCondition,
        'bundleID': null,
        'country': $rootScope.geoLocation.country
      };
      CartService.addCart(cartDetails);
      CartService.captureAddToCart(self.listing, rental);
      $rootScope.credit.selectedOneTimeAtCheckout=false;


      DialogAlertService.displayAddToCartBuyConfirmation(sessionCartDetails, self.listing);
    }

    this.addToWishlist = function(item, productId, subscribed, itemCondition){
      if ($rootScope.isLogon){
        this.saveToWishlist(item, productId, subscribed, itemCondition);
      } else {
        this.saveWishlistSession(item, productId, itemCondition);
        DialogAlertService.openLogon('','',true,false,true,true);
      }
    }

    this.saveWishlistSession = function(item, productId, itemCondition){
          
      var productID = productId
      var country = $rootScope.geoLocation.country;

      self.allWishlists = {
        'productId' : productId,
        'wishlists': []
      };
      var wishlist_info = {
        "userID": null,
        "email": null,
        "productId": productID,
        "size": item.size,
        "country": country,
        "itemCondition": itemCondition,
        "subscribed": true
      };
      self.allWishlists.wishlists.push(wishlist_info);
      Session.saveWishlistSession(self.allWishlists);
  }

    this.saveToWishlist = function(item, productId, subscribed, itemCondition){
      var modalInstance = $uibModal.open({
        templateUrl: 'views/modals/notify-me.html',
        controller: ["$scope", "$rootScope", function($scope, $rootScope) {
          var self = this;
          $scope.showForm = $rootScope.isLogon ? false : true;
          $scope.emailAddress = null;
          self.wishlist = {
            "userID": null,
            "email": null,
            "productId": productId,
            "size": item.size,
            "country": $rootScope.geoLocation.country,
            "itemCondition": itemCondition,
            "subscribed": subscribed
          };

          if(!$scope.showForm){
            WishlistService.addToWishlist(self.wishlist).$promise.then(
		        	function(resp) {
                $scope.showForm = false;
              },
		        	function(err) {
                $rootScope.enableLog ? $log.error($rootScope.UUID + ':ListingCreateCtrl:addToWishlist - addToWishlist error: ' + err ) : '';
              }
            );
          }

          $scope.sendNotifyMeEmail = function() {
            if ($scope.validate()){
            $scope.showForm = false;
            self.wishlist.email = $scope.emailAddress;
            WishlistService.addToWishlist(self.wishlist).$promise.then(
		        	function(resp) {
                $scope.showForm = false;
              },
		        	function(err) {
                $rootScope.enableLog ? $log.error($rootScope.UUID + ':ListingCreateCtrl:addToWishlist - addToWishlist error: ' + err ) : '';
              }
            );
            }
          };

          $scope.validate = function() {
            var isValid = true;
            if (!$scope.emailAddress) {
              isValid = false;
              $scope.error_emailAddress = 'GENERAL.ERROR.MISSING_EMAIL_ADDRESS';
            }
            return isValid;
          }

        }]
      });
    }

    this.setProductSize = function(availebleSizeObj){
      self.wishlistSize = availebleSizeObj;
      self.selectedSize = availebleSizeObj.size;
      self.selectedSizeValue = availebleSizeObj.sizeValue;
      self.selectedSizeValueWithRange = (availebleSizeObj.alternativeSize ? availebleSizeObj.alternativeSize : "") + (availebleSizeObj.alternativeSize ? " | " : "") + availebleSizeObj._rangeSize;
      self.selectedSizeAvailableItemConditions = availebleSizeObj.subItems;
      self.lowestCondition = self.isRentalTransaction ? availebleSizeObj.rentalLowestAvailableCondition : availebleSizeObj.itemCondition;
      $scope.slider.minValue = availebleSizeObj.highestAvailableCondition;

      self.lowestCondition = self.lowestCondition ? self.lowestCondition : CONFIG.ITEM_CONDITION[4];

      var itemConditionsMinIdx = CONFIG.ITEM_CONDITION_OPT.findIndex(p=> p.code === self.lowestCondition);
      var itemConditionsMaxIdx = CONFIG.ITEM_CONDITION_OPT.findIndex(p=> p.code === self.lowestCondition);
      if(itemConditionsMinIdx > itemConditionsMaxIdx){
        $scope.slider.maxValue = availebleSizeObj.highestAvailableCondition;
      } else {
        $scope.slider.maxValue = self.lowestCondition;
      }
      
      const allKeysForSelectedSizeOnly = self.listing._availableSize
        .filter(sizeObj => sizeObj.size === self.selectedSize);

      const selectedSizeKeysTemp = allKeysForSelectedSizeOnly[0].subItems
        .filter(sizeObj => sizeObj.itemCondition === self.lowestCondition);

      const selectedSizeKeys = selectedSizeKeysTemp.length > 0 ? selectedSizeKeysTemp[0].keys : [];

        $scope.dateSelectionButton.status =
        this.isEveryAvailableSizeInCart(selectedSizeKeys);
        $scope.dateSelectionButton.text = $scope.dateSelectionButton.status
        ? (self.isRentalTransaction ? 'LISTING.LABEL.SELECT_DATE' : 'LISTING.LABEL.ADD_TO_BAG')
        : 'LISTING.LABEL.ALL_SIZES_IN_CART';
      

      setConditionAvailability(self.lowestCondition);
      enableDisableDateSelectionButton(self.selectedSize, self.lowestCondition);
      
      ListingService.captureViewItem(self.listing, self.selectedSizeValue);
    }

    //////////////////////////////////////////
    //GET THE PRODUCT DETAILS BASED ON ID
    //////////////////////////////////////////
    this.get = function(id) {
      self.lk_get = true;
      var startTime = new Date();

      if (id ==null) return;

      RefDataService.getSizeList().$promise.then(function(resp) {
      self.sizeForAllCategory = resp;
      
      ListingService.getListingV2(id).$promise.then(
        function(resp) {
          var endTime = new Date();
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":ListingCtrl:get: Listing retrieved in " + (endTime - startTime) + 'ms.'):'';
          self.lk_get = false;
          self.listing = resp;

          if(!$scope.isAdmin && !utilities.isProductOwner(self.listing)){
            if($state.params.id == null){
              $window.location.href = envService.read('APP_URL');
            } else {
              $window.location.href = envService.read('APP_URL') + "/listings/" + $state.params.id;
            }
          }
          utilities.loadAllowedDatesByMerchant(self.listing.owner.id, self.listing.id);
          self.listing.productLine = resp.productLine ? resp.productLine.toLowerCase() : resp.productLine;
          self.listing._color = resp.designerColor == 'Multicolor' ? resp.color : resp.designerColor;
          //REORDER THE PHOTO AS PER THE PICORDER
          var newReOrderedPictures = [];
          resp.pictures.forEach(function(pic,index){
            newReOrderedPictures.push(resp.pictures.filter(function(p){return p.picOrder == index})[0]);
          })

          self.listing.hasSocialMedia = false;
          if(resp.facebookLink !== null || resp.instagramLink !== null){
            self.listing.hasSocialMedia = true;
          }
          self.listing.facebookLink = resp.facebookLink ? resp.facebookLink : null;
          self.listing.instagramLink = resp.instagramLink ? resp.instagramLink : null;
          self.listing.pictures = newReOrderedPictures;
          self.listing._isInstant = false;
          self.listing._origIrItems = angular.copy(self.listing.ir_items);
          self.listing._origRrItems = angular.copy(self.listing.rr_items);
          self.tempIRHub = angular.copy(self.listing.ir_itemsHub);
          self.listing._availableSize = self.listing.itemSizes;
          self.listing._availableSize.forEach((availableSize, i) => {
            if(self.listing.category.code == 'CLOTHING'){
                var previousSize = self.listing._availableSize[i-1];
                if(i <= 1) {
                  availableSize._rangeSize = availableSize.sizeValue;
                } else if(previousSize && i > 0){
                  availableSize._rangeSize = previousSize.sizeValue + "-" + availableSize.sizeValue;
                } else {
                  availableSize._rangeSize = availableSize.sizeValue;
                }
            } else {
              availableSize._rangeSize = availableSize.sizeValue;
            }
          });
          self.listing._availableSize.sort(function(a, b){return a.sizePosition-b.sizePosition;});
         
          
          //PRE-SELECT THE SIZE IF THERE IS ONLY 1 AVAILABLE
          if (self.listing._availableSize.length == 1){
            self.setProductSize(self.listing._availableSize[0]);
            self.selectedSizeValue = self.listing._availableSize[0].sizeValue;
          }

          self.listing._hasDiscount = resp.discountRate > 0;
          self.listing._tagPrice = resp.discountRate > 0 ? resp.price*(1-resp.discountRate) : resp.price;
          self.listing._rentalPrice = priceUtilities.getRentalPrice(resp.price,resp.discountRate);
          self.listing.brand = self.listing.brand;

          $scope.translationData = {brand: self.listing.brand};

          //LISTING TYPE 1 = RENTAL, TYPE 2 = STYLE POST
          $scope.showRentalPrice = self.listing.type === 2 ? false:true;
          self.listing.isOwner = utilities.isProductOwner(self.listing);
          self.isEdit = utilities.isProductEditable(self.listing);

          self.isSalePriceSameWithOrigPrice = priceUtilities.isSalePriceSameWithOrigPrice(self.listing.price, self.listing.discountRate);

          $rootScope.credit.currentProductCredit=resp.credit;

          self.rentalNonMemberPrice = priceUtilities.getListingNonMemberRentalPrice(self.listing, self.selectedWeek);
          self.rentalMemberPrice = priceUtilities.getListingRentalPrice(self.listing, self.selectedWeek);
          self.rentalCreditByWeek = self.listing.credit * self.selectedWeek;
          ListingService.captureViewItem(resp, "no-size-defined");
          getPurchaseDetails();
          setMetadata();

        },
        function(err) {
          self.lk_get = false;
          DialogAlertService.promptDialog(ErrorHandler.resolveError(err).toString(), '', '', '', '', '', '', true, '', 'RED');
          if (err.data) {
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":ListingCtrl:get: Search error: " + err.data.reasons[0].message):'';
          } else {
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":ListingCtrl:get: Search error: " + err):'';
          }
          if(utilities.isShowMainRegion()){
            $state.go('main');
          } else {
            $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
          }
        });
      });

      ListingService.getListingCompleteTheLook(id).$promise.then(
        function(resp) {
          $scope.completeTheLook = resp;
      });

      ListingService.getListingRecommendedLook(id).$promise.then(
        function(resp) {
          $scope.recommendedLook = resp;
      });


    };

    this.listingsCreate = function() {
      $scope.$emit("header:listings-create");
    };


    this.search = function(tags, page) {
      Session.prev_filterParams = null;
      if (!!tags) {
        // var tags = parseTagObjToString(tags);
        Session.prev_searchParams = angular.copy(tags);
        Session.megaMenuSearchParams = null;
        tags = tags.trim().replace(/\s+/g, "+");
        $location.path('/main/search').search({
          'q': tags,
          'page': page
        });
      }else{
        //SEARCH WITH NO VALUE = ALL LISTING.
          if(utilities.isShowMainRegion()){
            $state.go('search', {q:undefined}, {reload:true});
          } else {
            $state.go('search-multi-region', {q:undefined, country: $rootScope.geoLocation.country}, {reload:true});
          }
      }
    }


    //CONSOLIDATE BOTH IR AND RR SIZE IN TO A NEW ARRAY
    function combineSizes(instantRental,requestRental,fullList){
      var tempSize = [];
      var tempSizeIndex;
      if (instantRental){
        instantRental.forEach((item, i) => {
          tempSizeIndex = tempSize.findIndex(p=> p.size === item.size);
          if (tempSizeIndex !== -1){
            var tempSubItems = {};
            tempSubItems.itemCondition = item.itemCondition;
            tempSubItems.itemConditionPosition = item.itemConditionPosition;
            tempSubItems.availableQuantityForRental = item.availableQuantityForRental;
            var subItems = tempSize[tempSizeIndex].subItems;
            subItems.push(tempSubItems);
            tempSize[tempSizeIndex].subItems = subItems;
            tempSize[tempSizeIndex].availableQuantityForRental += item.availableQuantityForRental;
           
          }else{
            var subItems = {};
            subItems.itemCondition = item.itemCondition;
            subItems.itemConditionPosition = item.itemConditionPosition;
            subItems.availableQuantityForRental = item.availableQuantityForRental;
            item.subItems = [subItems];
            tempSize.push(item);
          }
        });
      }
      if (tempSize && requestRental){
        requestRental.forEach((item, i) => {
          tempSizeIndex = tempSize.findIndex(p=> p.size === item.size);
          if (tempSizeIndex !== -1){
            var subItems = tempSize[tempSizeIndex].subItems;
            var subIndex = subItems.findIndex(p=> p.itemCondition === item.itemCondition);
            if (subIndex !== -1){
              subItems[subIndex].availableQuantityForRental += item.availableQuantityForRental;
            } else {
              var tempSubItems = {};
              tempSubItems.itemCondition = item.itemCondition;
              tempSubItems.itemConditionPosition = item.itemConditionPosition;
              tempSubItems.availableQuantityForRental = item.availableQuantityForRental;
              subItems.push(tempSubItems);
              tempSize[tempSizeIndex].subItems = subItems;
            }

            
            tempSize[tempSizeIndex].availableQuantityForRental += item.availableQuantityForRental;
          }else{
            var subItems = {};
            subItems.itemCondition = item.itemCondition;
            subItems.itemConditionPosition = item.itemConditionPosition;
            subItems.availableQuantityForRental = item.availableQuantityForRental;
            item.subItems = [subItems];
            tempSize.push(item);
          }
        });
      }

      //ADD THE KEY (MASTERID + SUBITEM) TO THE ASSOCIATED COMBINED SIZE AS AN ARRAY.
      //THE PURPOSE OF THE KEY IS TO UNIQUELY ID THE PRODUCT IN THE CART, SO REMOVAL/CHANGE DATE FOR THE SPECIFIC ITEM CAN BE DONE.
      if (tempSize && tempSize.length > 0){
        //MORE THEN ONE SIZE PER PRODUCT
        tempSize.forEach((item) => {
          //PRODUCT WITH STATUS AVAILABLE_INSTANT OR AVAILABLE (REFER TO PRODUCTSTATUS.JS)
          item.keys = fullList.filter(p=> p.size ==item.size && (p.status == 6 || p.status == 8)).map(m=> fullList[0].productId + "-" + m.id); 
          item.subItems.forEach((si) => {
            si.keys = fullList.filter(p=> p.size ==item.size && p.condition == si.itemCondition && (p.status == 6 || p.status == 8)).map(m=> fullList[0].productId + "-" + m.id);  
          });
          item.subItems.sort(function(a, b){return a.itemConditionPosition-b.itemConditionPosition;});
          var lowestAvailableCondition = item.subItems[0];
          item.itemCondition = lowestAvailableCondition.itemCondition;
          item.itemConditionPosition = lowestAvailableCondition.itemConditionPosition;

          var rentalOptions = item.subItems.filter(i => i.itemConditionPosition >= 2);
          if(rentalOptions.length > 0){
            var rentalLowestAvailableCondition = rentalOptions[0];
            item.rentalLowestAvailableCondition = rentalLowestAvailableCondition.itemCondition;
            item.rentalLowestAvailableConditionPosition = rentalLowestAvailableCondition.itemConditionPosition;
          }

          item.subItems.sort(function(a, b){return b.itemConditionPosition-a.itemConditionPosition;});
          var highestAvailableCondition = item.subItems[0];
          item.highestAvailableCondition = highestAvailableCondition.itemCondition;
          item.highestAvailableConditionPosition = highestAvailableCondition.itemConditionPosition;

        });
      }else{
        //ONE SIZE PER PRODUCT
        var productDetails = fullList.filter(p=> (p.status == 6 || p.status == 8));
        if (productDetails && productDetails.length > 0){
          var item = {
            size:productDetails.size ,
            availableQuantityForRental:1, 
            keys:[productDetails['productId'] + "-" + productDetails['id']],
            sizeValue:productDetails.sizeValue
          };
          tempSize.push(item);
        }
      }

      var unavailableSizes = {};
      var sizesByCategory = self.sizeForAllCategory.filter(s => s.category === self.listing.category.name);
      if(sizesByCategory && sizesByCategory.length > 0){
        sizesByCategory[0].options.forEach(size => {
          var checkExist = tempSize.filter(temp => {
            return size.key == temp.size;
          });
          if(!checkExist || checkExist.length === 0){
            var item = {
              size:size.key,
              availableQuantityForRental:0, 
              keys: "",
              sizeValue:size.value,
              sizePosition: size.position
            };
            // check if item is returning soon, status not in 6,8,4,32,108,109,120
            var filterReturningSoon = fullList.filter(p=> p.size === size.key && (p.status != 6 && p.status != 8 && p.status != 4 && p.status != 32 && p.status != 108 && p.status != 109 && p.status != 120));
            item.isReturningSoon = filterReturningSoon.length > 0;
            tempSize.push(item);
          }
        });
      }
      
      return tempSize;
    }

    function parseTagObjToString(tagsObj) {
      var str = "";
      for (var i = 0; i < tagsObj.length; i++) {
        if (!str.includes(tagsObj[i].text)) {
          str = str + " " + tagsObj[i].text;
        }
      }
      return str;
    };

    $rootScope.$on("CallUpdateDateSelectButton", function(){
      //$scope.updateDateSelectButton();
      $scope.dateSelectionButton = {
        status: true,
        text: self.isRentalTransaction ? 'LISTING.LABEL.SELECT_DATE' : 'LISTING.LABEL.ADD_TO_BAG'
      };
    });
    this.getDisplayPhoto = function(product, position){
      return utilities.getDisplayPhoto(product, position);
    }
  function getMainPhoto(product){
    return product.pictures.length > 0 ? (product.pictures.filter(function(p){return p.picOrder == 0})[0])._url : '';
  }

  function setMetadata() {
      var metaKeywords = ["Rent", "Buy", "Style Carousel", "StyleCarousel"];
      if(self.listing){
        //Category
        if(self.listing.category){
          metaKeywords.push(self.listing.category.name);
        }

        //Sub-Category
        if(self.listing.category && self.listing.category.name === 'Clothing' && self.listing.subCategory){
          metaKeywords.push(self.listing.subCategory.name);
        }

        //Brand
        if(self.listing.brand){
          metaKeywords.push(self.listing.brand);
        }
      }

      var metaBrand = self.listing.brand ? self.listing.brand : "";
      var metaProductLine = self.listing.productLine ? self.listing.productLine : "";

      var noStyleNotes = $translate.instant('LISTING.LABEL.NO_STYLE_NOTES', {brand: metaBrand});
      var metadata = {
        description : self.listing.cleanProductDescription ? self.listing.cleanProductDescription : noStyleNotes,
        keywords : metaKeywords.join(","),
        title : "Rent | " + utilities.capitalizeFirstLetter(metaBrand) + " " + metaProductLine + " at Style Carousel",
        imageUrl : getMainPhoto(self.listing)
      };
      SeoService.setMetaDataTags(metadata);
    };

    function getPurchaseDetails() {
      var tagPrice = priceUtilities.getAmountByRate(Math.round(self.listing._tagPrice.toFixed(2)));
      var originalAmount = priceUtilities.getAmountByRate(Math.round(self.listing.price.toFixed(2)));
      $scope.productMemberPrice = $rootScope.geoLocation.country + priceUtilities.currencyFormat(tagPrice);
      $scope.productNonMemberPrice = $rootScope.geoLocation.country + priceUtilities.currencyFormat(originalAmount);
      self.isRentalTransaction = $rootScope.transactionType == CONFIG.TRANSACTION_TYPE_RENT;
      self.isPurchaseTransaction = $rootScope.transactionType == CONFIG.TRANSACTION_TYPE_BUY;
      
      self.selectedSize = null;
      self.selectedSizeValue = null;
      $scope.dateSelectionButton = {
        status : false,
        text: self.isRentalTransaction ? 'LISTING.LABEL.SELECT_DATE' : 'LISTING.LABEL.ADD_TO_BAG'
      };
    }
    
    $scope.setTransactionType = function(transactionType) {
      $rootScope.transactionType = transactionType;
      $scope.isRentalTransaction = $rootScope.transactionType == CONFIG.TRANSACTION_TYPE_RENT;
      $scope.isPurchaseTransaction = $rootScope.transactionType == CONFIG.TRANSACTION_TYPE_BUY;
      getPurchaseDetails();
      setProductDetails();
    }
    
    this.getDisplayPrice = function(price){
      return priceUtilities.getFormattedAmountByRateNoCurrency(price);
    }

    $scope.$watch('slider.minValue', function() {
      //NOTE: minValue is the highest condition, maxValue is the lowest condition
      setItemConditions();
    });
    $scope.$watch('slider.maxValue', function() {
      //NOTE: maxValue is the lowest condition, minValue is the highest condition
      setItemConditions();
    });

    function setItemConditions() {
      var itemConditionsMinIdx = CONFIG.ITEM_CONDITION_OPT.findIndex(p=> p.code === $scope.slider.minValue);
      var itemConditionsMaxIdx = CONFIG.ITEM_CONDITION_OPT.findIndex(p=> p.code === $scope.slider.maxValue);
      var minPosition = CONFIG.ITEM_CONDITION_OPT[itemConditionsMinIdx].id;
      var maxPosition = CONFIG.ITEM_CONDITION_OPT[itemConditionsMaxIdx].id;
      self.lowestCondition = $scope.slider.maxValue;
      var availableConditions = self.selectedSizeAvailableItemConditions;
      if(availableConditions) {
        if(self.isRentalTransaction) {
          availableConditions = availableConditions.filter(i => i.itemConditionPosition >= 2);
        }
        var index = availableConditions.findIndex(p=> p.itemCondition === $scope.slider.maxValue);
        if(index == -1){
          var filteredOptions = availableConditions.filter(i => i.itemConditionPosition >= maxPosition && i.itemConditionPosition <= minPosition);
          if(filteredOptions.length > 0) {
            let nextLowest = filteredOptions.reduce((prev, curr) => prev.itemConditionPosition < curr.itemConditionPosition ? prev : curr);
            self.lowestCondition = nextLowest.itemCondition;
            $scope.dateSelectionButton.status = true;
          } else {
            self.lowestCondition = null;
            $scope.dateSelectionButton.status = false;
          }
        } else {
          self.lowestCondition = availableConditions[index].itemCondition;
          $scope.dateSelectionButton.status = true;
        }
      } 
      setConditionAvailability(self.lowestCondition);
      enableDisableDateSelectionButton(self.selectedSize, self.lowestCondition);
    }

    $scope.openRentalListingToNewTab = function() {

      $rootScope.transactionType = CONFIG.TRANSACTION_TYPE_RENT;
      var id = self.listing.id;
      var product = self.listing;
      var productBrand = self.listing.brand;
      var urlSlug = utilities.getPrettyUrl(product.category.code, product.subCategory.code, productBrand, product.productLine);
      
      var url;
      if(utilities.isShowMainRegion()){
        url = $state.href('listing',  {id: id, urlSlug: urlSlug});
      } else {
        url = $state.href('listing-multi-region', {id: id, country: $rootScope.geoLocation.country, urlSlug: urlSlug});
      }
      window.open(url,'_blank');
    };

    function setConditionAvailability(itemCondition) {
      $translate(['LISTING.LABEL.ITEM_CONDITION_AVAILABILITY'], {itemCondition: itemCondition}).then(function(trans){
        $scope.ITEM_CONDITION_AVAILABILITY = $sce.trustAsHtml(trans['LISTING.LABEL.ITEM_CONDITION_AVAILABILITY']);
      });
    }

    this.isMobileView = function(){
      return utilities.isMobileView();
    }
    
    this.getListingTagPrice = function(product) {
      if(self.isRentalTransaction){
        return priceUtilities.getListingTagPrice(product);
      } else {
        var purchasePrice = product.discountRate > 0 ? product.price*(1-product.discountRate) : product.price;
        return priceUtilities.getFormattedAmountByRate(purchasePrice);
      }
    }
    this.getSalePrice = function(product) {
      if(self.isRentalTransaction){
        return priceUtilities.getListingTagPrice(product);
      } else {
        var purchasePrice = product.discountRate > 0 ? product.price*(1-product.discountRate) : product.price;
        return priceUtilities.getFormattedAmountByRateNoCurrency(purchasePrice);
      }
    }

    function enableDisableDateSelectionButton(selectedSize, selectedCondition) {
      var check = false;
      var conditionAvailable = true;
      if(!self.listing._availableSize) {
        return false;
      }
      const allKeysForSelectedSizeOnly = self.listing._availableSize
      .filter(sizeObj => sizeObj.size === selectedSize);

      if(allKeysForSelectedSizeOnly.length > 0) {
        const selectedObj = allKeysForSelectedSizeOnly[0].subItems
        .filter(sizeObj => sizeObj.itemCondition === selectedCondition);

        if(selectedObj.length > 0){
          const selectedSizeKeys = selectedObj[0].keys;

          check = self.isEveryAvailableSizeInCart(selectedSizeKeys);
        } else {
          conditionAvailable = false;
        }
      }

      var rentOrbuyBtn = self.isRentalTransaction ? 'LISTING.LABEL.SELECT_DATE' : 'LISTING.LABEL.ADD_TO_BAG';
      $scope.dateSelectionButton.status = check;
      $scope.dateSelectionButton.text = $scope.dateSelectionButton.status
        ? rentOrbuyBtn : (conditionAvailable ? 'LISTING.LABEL.ALL_SIZES_IN_CART' : rentOrbuyBtn ) ;
    }

    this.openCreditPackage = function() {
      DialogAlertService.openCreditPackage();
    }

    function setProductDetails(){
      if($rootScope.transactionType == CONFIG.TRANSACTION_TYPE_RENT){
        $translate(['LISTING.LABEL.PRODUCT_INFO_NOTE3_HTML']).then(function(trans){
          $scope.PRODUCT_INFO_NOTE2_HTML = $sce.trustAsHtml(trans['LISTING.LABEL.PRODUCT_INFO_NOTE3_HTML']);
        });
        $translate(['LISTING.LABEL.DELIVERY_RETURN_FAQ_BOOK']).then(function(trans){
          $scope.DELIVERY_RETURN_FAQ = $sce.trustAsHtml(trans['LISTING.LABEL.DELIVERY_RETURN_FAQ_BOOK']);
        });
        $translate(['LISTING.LABEL.PRODUCT_INFO_NOTE3_HTML']).then(function(trans){
          $scope.PRODUCT_INFO_NOTE2_HTML = $sce.trustAsHtml(trans['LISTING.LABEL.PRODUCT_INFO_NOTE3_HTML']);
        });
        $translate(['LISTING.LABEL.DELIVERY_RETURN_FAQ_BOOK']).then(function(trans){
          $scope.DELIVERY_RETURN_FAQ = $sce.trustAsHtml(trans['LISTING.LABEL.DELIVERY_RETURN_FAQ_BOOK']);
        });

      } else {
        $translate(['LISTING.LABEL.PRODUCT_INFO_NOTE2_HTML']).then(function(trans){
          $scope.PRODUCT_INFO_NOTE2_HTML = $sce.trustAsHtml(trans['LISTING.LABEL.PRODUCT_INFO_NOTE2_HTML']);
        });
        $translate(['LISTING.LABEL.DELIVERY_RETURN_FAQ']).then(function(trans){
          $scope.DELIVERY_RETURN_FAQ = $sce.trustAsHtml(trans['LISTING.LABEL.DELIVERY_RETURN_FAQ']);
        });
        $translate(['LISTING.LABEL.PRODUCT_INFO_NOTE2_HTML']).then(function(trans){
          $scope.PRODUCT_INFO_NOTE2_HTML = $sce.trustAsHtml(trans['LISTING.LABEL.PRODUCT_INFO_NOTE2_HTML']);
        });
        $translate(['LISTING.LABEL.DELIVERY_RETURN_FAQ']).then(function(trans){
          $scope.DELIVERY_RETURN_FAQ = $sce.trustAsHtml(trans['LISTING.LABEL.DELIVERY_RETURN_FAQ']);
        });
      }
    }

    this.showListing = function(id, product) {
      utilities.showListing(id, product);
    };

    this.getDisplayBrand = function(product){
      return utilities.getCustomBrandName(product);
    }

    this.viewMoreCompleteTheLook = function() {
      var search = {
        creditMin: CONFIG.CREDIT_MIN,
        creditMax: CONFIG.CREDIT_MAX,
        status: "bundles",
        sort: CONFIG.DEFAULT_SEARCH_SORT_ORDER,
        page: "1",
        type: CONFIG.DEFAULT_SEARCH_TYPE,
        country: $rootScope.geoLocation.country
      }
      if(utilities.isShowMainRegion()){
        $state.go('search', search);
      } else {
        $state.go('search-multi-region', search);
      }
    }

    this.viewMoreRecommendedLook = function() {
      var search = {
        creditMin: CONFIG.CREDIT_MIN,
        creditMax: CONFIG.CREDIT_MAX,
        sort: CONFIG.DEFAULT_SEARCH_SORT_ORDER,
        page: "1",
        type: CONFIG.DEFAULT_SEARCH_TYPE,
        country: $rootScope.geoLocation.country,
        category: self.listing.category.name,
        q: self.listing.subCategory ? self.listing.subCategory.name : null
      }
      if(utilities.isShowMainRegion()){
        $state.go('search', search);
      } else {
        $state.go('search-multi-region', search);
      }
    }

    this.isPriceDisplay = function() {
      return  priceUtilities.isPriceDisplay();
    }

    this.toggleRentalWeeks = function(wks, wkCode) {
      self.selectedWeek = wks;
      self.selectedWeekCode = wkCode;
      self.rentalCreditByWeek = self.listing.credit * self.selectedWeek;
      self.rentalNonMemberPrice = priceUtilities.getListingNonMemberRentalPrice(self.listing, self.selectedWeek);
      self.rentalMemberPrice = priceUtilities.getListingRentalPrice(self.listing, self.selectedWeek);
    }


  }]);

'use strict';

/**
 * @ngdoc function
 * @name coutureApp.controller:SearchCtrl
 * @description
 * # SearchCtrl
 * Controller of the coutureApp
 */
angular.module('coutureApp')
  .controller('SearchCtrl', ["$rootScope", "$scope", "$state", "CartService", "AuthService", "utilities", "$filter", "ListingService", "FavoriteService", "$http", "DialogAlertService", "$anchorScroll", "Session", "usSpinnerService", "$location", "$log", "$injector", "USER_ROLES", "$translatePartialLoader", "RefDataService", "menuBarsService", "RentalService", "CONFIG", "$timeout", "authCheck", "$translate", "SeoService", "CalendarService", "priceUtilities", "$window", "envService", function($rootScope, $scope, $state, CartService, AuthService, utilities, $filter, ListingService, FavoriteService,
    $http, DialogAlertService, $anchorScroll, Session, usSpinnerService, $location, $log,$injector,USER_ROLES,
    $translatePartialLoader, RefDataService, menuBarsService, RentalService,CONFIG,$timeout,authCheck,$translate,SeoService,CalendarService,priceUtilities, $window, envService) {

    var self = this;

    // Double submit locks
    self.lk_search = false;
    self.lk_get = false;
    self.lk_fav = false;
    self.lk_del = false;
    self.lk_loadMore = true; // Prevent loading of more results initially
    self.scrollLastItemID = null;
    self.isLoading = true;

    // Search result
    self.result = [];
    self.originalResult = [];
    self.resultTotalPageCount = 0;

    // Controller level trigger to allow/prevent repeated search, e.g. view change
    self.prev_searchParams_local = null;

    // Configurations
    self.noWrap = false; // Repeat image loop?
    self.accordionDetailsOpen = true;
    self.ratingMax = 5;
    self.ratingReadOnly = false;
    $scope.isSideFilterActive = !utilities.isMobileView();
    $scope.selectedFilterCategory = null;
    $scope.selectedCategoryItem = [];
    $scope.pageSelector_maxSize = 3;
    $scope.pageSelector_itemPerPage = CONFIG.ITEM_PER_PAGE;
    $scope.topFilter = {
      earliestFilter: false,
      date: false,
      size: false
    };
    self.unavailableDates = {};
    $scope.isDateSelected = false;
    $scope.events = [];
    $scope.calendarView = 'month';
    $scope.viewDate = new Date(moment().startOf('month').format('LLLL'));
    $scope.currentMonth = moment($scope.viewDate).format('MMMM');

    var expectedDeliveryDateInDays = 0;
    var EndDateInDays = CONFIG.DEFAULT_RENTAL_DURATION;

    //Filter Brand, Filter Category, Filter Price Min, etc
    //Can be "latest", "priceAsc", "priceDesc", "brandAsc", "brandDesc".  Default is "latest", which sort descendingly by modified and creation date.
    getSliderFilter();

    self.filtersParams = {
      brand: undefined,
      category: undefined,
      subCategory: undefined,
      min: self._sliderMinValue,
      max: self._sliderMaxValue,
      creditMin: CONFIG.CREDIT_MIN,
      creditMax: CONFIG.CREDIT_MAX,
      feeMin: undefined,
      feeMax: undefined,
      color: undefined,
      status: undefined,
      sort: CONFIG.DEFAULT_SEARCH_SORT_ORDER,
      size: undefined,
      fdmin: undefined,
      fdmax: undefined,
      page: "1",
      q: undefined,
      type: utilities.getDefaultTypeFilterParams(),
      startDate: null,
      endDate: null,
      country: $rootScope.geoLocation.country,
      itemCondition: null
    };
    $translatePartialLoader.addPart('search');
    $scope.isStylePostSelected = false;
    $scope.isUnrecommendedSelected = false;
    $scope.isAllSelected = false;
    $scope.isDeletedSelected = false;
    $scope.isAvailableSelected = false;

    //////////////////////////////////////////
    // PAGE INITIALIZE METHOD
    //////////////////////////////////////////
    this.$onInit = function() {


      getSliderFilter();
      $scope.pageSelector_pgNum = 1;
      $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - SearchCtrl") : '';

      $scope.params = {
        limit: 20,
        query: $state.params.q,
        filters: [],
        sortBy: null,
        currentPage: 1,
        totalItems: 0,
        priceFilter: {
          min: self._sliderMinValue,
          max: self._sliderMaxValue
        },
        creditFilter: {
          min: CONFIG.CREDIT_MIN,
          max: CONFIG.CREDIT_MAX
        }
      };
      
      //SET THE FILTER DEFAULT VALUE
      $scope.slider = {
        minValue: self._sliderMinValue,
        maxValue: self._sliderMaxValue,
        options: {
          floor: parseInt(self._sliderMinValue),
          ceil: parseInt(self._sliderMaxValue),
          step: self._sliderStep,
          logScale: true,
          translate: function(value, sliderId, label) {
            switch (label) {
              case 'model':
                $scope.params.priceFilter.min = Math.round(value / self._sliderExchangeRate) < CONFIG.PRICE_MIN_INT ? CONFIG.PRICE_MIN_INT : Math.round(value / self._sliderExchangeRate);
                break;

              case 'high':
                $scope.params.priceFilter.max = Math.round(value / self._sliderExchangeRate) > 300000 ? 300000 : Math.round(value / self._sliderExchangeRate);
                break;
            }
            return $filter('currency')(value, '$', 0);
          }
        }
      };
      refreshPriceFilter();


      //SET THE FILTER DEFAULT VALUE
      $scope.creditSlider = {
        minValue: CONFIG.CREDIT_MIN,
        maxValue: CONFIG.CREDIT_MAX,
        options: {
          floor: parseInt(CONFIG.CREDIT_MIN),
          ceil: parseInt(CONFIG.CREDIT_MAX),
          step: 1,
          logScale: true,
          translate: function(value, sliderId, label) {
            switch (label) {
              case 'model':
                $scope.params.creditFilter.min = value;
                break;

              case 'high':
                $scope.params.creditFilter.max = value;
                break;
            }
            return value;
          }
        }
      };


      self.sortByList = RefDataService.getSortByList_Listings();
      $scope.params.sortBy = self.sortByList.filter(p => p.KEY == CONFIG.DEFAULT_SEARCH_SORT_ORDER)[0];

      loadFilter();

      self.sizeList = RefDataService.getSizeFlatList();
      self.allCategorySizes = RefDataService.getSizeList();
      self.itemConditionFilterList = RefDataService.getItemConditionsFilter();
      self.collectionList = RefDataService.getCollections();

      if ($state.params) {
        var temp_previousSessionSearchParams = angular.toJson(Session.prev_searchParams);

        //SETUP DEFAULT PARAMS IF NOT ALREADY EXISTED (EG.SORT,PAGE,MIN PRICE,MAX PRICE)
        $state.params.min = $state.params.min ? $state.params.min : self._sliderMinValue;
        $state.params.max = $state.params.max ? $state.params.max : self._sliderMaxValue;
        $state.params.creditMin = $state.params.creditMin ? $state.params.creditMin : CONFIG.CREDIT_MIN;
        $state.params.creditMax = $state.params.creditMax ? $state.params.creditMax : CONFIG.CREDIT_MAX;
        $state.params.sort = $state.params.sort ? $state.params.sort : CONFIG.DEFAULT_SEARCH_SORT_ORDER;
        $state.params.type = $state.params.type ? $state.params.type : CONFIG.DEFAULT_SEARCH_TYPE;
        $state.params.page = $state.params.page ? $state.params.page : "1";
        $state.params.startDate = $state.params.startDate ? $state.params.startDate : null;
        $state.params.endDate = $state.params.endDate ? $state.params.endDate : null;
        $state.params.itemCondition = $state.params.itemCondition ? $state.params.itemCondition : null;

        self.display_searchTags = $state.params.q ? $state.params.q.trim().replace(/\++/g, " ") : "";
        self.displayFilterTags();
        //THIS IS TO HANDLE BACK BUTTON REPEATING SEARCH FOR THE SAME RESULT.
        self.filtersParams = angular.copy($state.params);

        if (angular.toJson($state.params) === angular.toJson(Session.prev_searchParams)) {
          self.result = Session.prev_searchResult;
          $scope.params.totalItems = Session.prev_searchResultCount;
          self.resultTotalPageCount = Session.prev_searchResultCount;
          self.restoreSelectedFilterOptions();
          RefDataService.getSizeFlatList().$promise.then(function(resp) {
            self.sizeList = resp;
            self.displayFilterTags();
          });
          //RESTORE THE PREVIOUS PAGE
          $scope.params.currentPage = angular.copy(Session.prev_searchParams.page);
          self.currentPageCount = $scope.params.currentPage;

          //SCROLL TO THE PREVIOUSLY CLICKED PRODUCT.
          if ($state.params.id){
            $timeout(function() {
              $anchorScroll($state.params.id);
              self.lk_loadMore = false;
            }, 900);
          }
        } else {

          $scope.params.sortBy = self.sortByList.filter(p => p.KEY == $state.params.sort)[0];

          //INITIAL SEARCH OR NEW SEARCH BASED ON FILTERS OR CLEAR FILTER SEARCH
          if ($state.params.sort){
            self.selectedSortByType = $state.params.sort;
          }
          self.search($state.params);
        }
      }else{
        self.selectedSortByType = CONFIG.DEFAULT_SEARCH_SORT_ORDER;
      }

      self.filtersParams.country = $rootScope.geoLocation.country;

    };

    this.isAdmin = function(){
      return AuthService.isAuthorized(USER_ROLES.admin);
    }

    //CC-1041: Sizes are now loaded from backend DB. Refer to RefDataService.getSizeFlatList()
    ////////////////////////////
    //  COMBINE DIFFERENT CATEGORY SIZE TO A MASTER SIZE LIST
    ////////////////////////////
    /*function flatternSize(inputList) {
      //FLATTERN THE SIZE DICTIONARY FROM DIFFERENT CATEGORY INTO A SINGLE ARRAY
      var flattern = inputList.map(m=>m.options).flat();
      var singleDic = {};

      //RE-CONVERT THE DICTIONARIES FROM DIFFERENT CATEGORY INTO A SINGLE DICTIONARY OBJECT
      //THIS WILL REMOVE THE DUPLICATE KEY
      flattern.map(p=> singleDic[p.KEY] = p.VALUE);

      //RE-MAP THE SINGLE DICTIONARY OF SIZE TO [{KEY:VALUE},{KEY:VALUE}]
      var k = Object.keys(singleDic);
      var output = [];
      k.map(index=> {output.push({'key':index,'value':singleDic[index]})})
      return output;
    }*/

    ////////////////////////////
    //  LOAD UP ALL FILTER OPTIONS
    ////////////////////////////
    function loadFilter() {
      // GET SEARCH FITLER AND SORTING DATA AS A JSON
      $http.get('scripts/config/search-filters.json').then(function successCallback(response) {
        self.filterList = response.data.filterList;

        if(AuthService.isAuthorized(USER_ROLES.admin)){
          var type = self.filterList.filter(p => p.key == 5);
          if(type){
            if(type.length > 0){
              var key = type[0].key;
              type[0].keywords.forEach(function(item, index) {
                var filterSelected = self.filtersParams.type ? self.filtersParams.type.contains(item.key) : false;
                if(item.key == 1) {
                  $scope.isAvailableSelected = filterSelected;
                } else if(item.key == 2) {
                  $scope.isStylePostSelected = filterSelected;
                } else if(item.key == 3) {
                  $scope.isUnrecommendedSelected = filterSelected;
                } else if(item.key == 4) {
                  $scope.isAllSelected = filterSelected;
                } else if(item.key == 5) {
                  $scope.isDeletedSelected = filterSelected;
                }
                if(filterSelected){
                  $scope.params.filters.push({
                    key: key,
                    value: item,
                    selected: filterSelected
                  });
                }
              });
            }
          }
        }
  

        //REPLACE THE FILTER CATEGORY LIST
        RefDataService.getCategories().$promise.then(function(resp) {
          var tempCat = [];
          resp.forEach(function(item, index) {
            var tempSubCat = [];
            var subCategories = item.subCategory;

            if(subCategories.length > 0){
              subCategories.forEach(function(subItem, subIndex) {
                tempSubCat.push({
                  key: subItem.id,
                  value: subItem.name,
                  position : subItem.position,
                  level : subItem.level
                });
              });
            }

            tempCat.push({
              key: item.id,
              value: item.name,
              position : item.position,
              subCategories : tempSubCat,
              level : item.level
            });

          });
          (self.filterList && self.filterList[0].title.toUpperCase() === "category".toUpperCase()) ? self.filterList[0].keywords = tempCat: '';
        });

        //REPLACE THE FILTER DESIGNER LIST
        RefDataService.getSelectedBrands().$promise.then(function(resp) {
          self.brandList = resp;
          var brandArray = [];
          resp.forEach(function(item, index) {
            brandArray.push({
              key: item,
              value: item,
              plainTextValue: item.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
            });
          });
          (self.filterList && self.filterList[3].title.toUpperCase() === "designer".toUpperCase()) ? self.filterList[3].keywords = brandArray: '';
        });

        //REPLACE THE FILTER COLOR LIST
        var colorArray = [];
        utilities.getColorList().forEach(function(item, index) {
          colorArray.push({
            key: item.id,
            value: item.name
          });
        });
        (self.filterList && self.filterList[2].title.toUpperCase() === "Color".toUpperCase()) ? self.filterList[2].keywords = colorArray: '';

        //REPLACE THE FILTER SIZE LIST
        var sizeArray = [];
        RefDataService.getSizeList().$promise.then(function(resp){
          resp.forEach(function(item, index) {
            sizeArray.push({
              key: item.category,
              value: item.options
            });
          });
        });
        (self.filterList && self.filterList[1].title.toUpperCase() === "Size".toUpperCase()) ? self.filterList[1].keywords = sizeArray: '';

        var itemConditionArray = []
        RefDataService.getItemConditionsFilter().forEach(function(item, index) {
          itemConditionArray.push({
            key: item.key,
            value: item.value
          });
        });
        (self.filterList && self.filterList[7].title.toUpperCase() === "Item Condition".toUpperCase()) ? self.filterList[7].keywords = itemConditionArray: '';

      }, function errorCallback(response) {
        $rootScope.enableLog ? $log.error($rootScope.UUID + ":SearchCtrl:onInit - Error loading filter: " + response.statusText) : '';
      });
    }



    // GET SEARCH FITLER AND SORTING DATA AS A JSON
    $scope.setWishlist = function(data) {
      $rootScope.enableLog ? $log.info($rootScope.UUID + ":SearchCtrl:setWishlist - " + JSON.stringify(data)) : '';
      menuBarsService.toggleSidebar(true);
      return new Array();
      // return cart.toggleWishlist(data);
    };

    ////////////////////////////
    //SHOW / HIDE THE SIDE BAR
    ////////////////////////////
    $scope.toggleCheckoutSidebar = function() {
      $anchorScroll();
      menuBarsService.toggleSidebar(false);
    };

    ////////////////////////////
    //THIS APPLIED FOR DROP AND DROP TO CART
    ////////////////////////////
    $scope.dragToCart = function(data) {
      var rental = {
        product: data.dragProduct,
        selectedDate: null
      };

      //ALLOW THE PRODUCT ADDED TO CART IF, 1-NOT OWNER OF PRODUCT, 2-PRODUCT CANRENT, 3-PRODUCT IS NOT ALREADY IN THE CART.
      if (!utilities.isItemInArray(rental.product, $rootScope.cc.cart) && utilities.isProductAvailableForRental(rental.product) && !utilities.isProductOwner(rental.product)) {
        // RentalService.getRentalPeriod(rental.product.id).$promise.then(function(resp) {
        //   rental.selectedDate = {
        //     'START_DATE': resp.startDate,
        //     'RETURN_DATE': resp.endDate
        //   };
          utilities.replaceItemInArray(rental, $rootScope.cc.cart);
          //STORE PRODUCT ID IN LOCAL SERVICE
          Session.updateCart(rental.product.id);
          CartService.addCart(rental.product.id);
          CartService.captureAddToCart(rental.product, rental);
        // }, function(err) {
        //   DialogAlertService.promptDialog('Add to Cart failed. Please try again later', '', '', '', '', '', '', true, '', 'RED');
        //   $rootScope.enableLog ? $log.error($rootScope.UUID + ":SearchCtrl:dragToCart - Error get rental period date: " + JSON.stringify(err)) : '';
        // });
      }
    };

    ////////////////////////////
    // listens to drag and drop event broadcast
    ////////////////////////////
    $scope.$on('ANGULAR_HOVER', function(event, data) {
      menuBarsService.toggleWishlistSidebarOnHover();
    });

    ////////////////////////////
    // watch for any changes on params
    // then execute get products request
    ////////////////////////////
    // $scope.$watch('params', function() {
    //   $rootScope.enableLog ? $log.info($rootScope.UUID + ":SearchCtrl:$watch(params) - " + JSON.stringify($scope.params)) : '';
    //   // getProducts();
    //   // listingService.getListingsWithFilters
    // }, true);

    $scope.toggleDropdown = function($event) {
      $event.preventDefault();
      $event.stopPropagation();
      $scope.status.isopen = !$scope.status.isopen;
    };

    ////////////////////////////
    // sort by section
    ////////////////////////////
    $scope.sortProduct = function(sortBy) {
      $scope.params.sortBy = sortBy;

      //CLEAR THE PREVIOUS SEARCH RESULT AND CHANGE THE SORT ORDER.
      self.result = [];
      self.currentPageCount = 1;
      self.filtersParams.sort = sortBy.KEY;
      self.search(self.filtersParams);
    };

    ////////////////////////////
    //SHOW & HIDE FILTER MANUAL
    ////////////////////////////
    $scope.toggleSideFilter = function() {
      $scope.isSideFilterActive = !$scope.isSideFilterActive;
      utilities.goToTop();
    };


    ////////////////////////////
    //RESTORE THE FILTER FROM PREVIOUS SESSION
    //EG. SELECT THE OPTION IN THE FILTER
    ////////////////////////////
    self.restoreSelectedFilterOptions = function(){
      if (Session.prev_filterParams){
        $scope.params.filters = angular.copy(Session.prev_filterParams.filters);
        $scope.params.priceFilter = angular.copy(Session.prev_filterParams.priceFilter);
        $scope.params.creditFilter = angular.copy(Session.prev_filterParams.creditFilter);
        $scope.params.query = angular.copy(Session.prev_filterParams.query);
        $scope.params.sortBy = angular.copy(Session.prev_filterParams.sortBy);
      }
    }

    ////////////////////////////
    //  TOOGLE TO SHOW AND HIDE THE  FILTER BAR
    ////////////////////////////
    $scope.toggleFilter = function(params) {

      if (params.selected) {
        let index = $scope.params.filters.map(function(o) {
          return String(o.key) === String(params.key)? o.value.key : '';
        }).indexOf(params.value.key);
        if (index !== -1) {
          $scope.params.filters.splice(index, 1);
        }

      } else if (params.value) {

        $scope.params.filters.push({
          key: params.key,
          value: params.value
        });
      }
      $rootScope.enableLog ? $log.info($rootScope.UUID + ":SearchCtrl:$toggleFilter(scope.params) - " + JSON.stringify($scope.params.filters)) : '';
      return params.selected = !params.selected;
    };

    $scope.toggleFilterCategory = function(params, hasSubCategory) {
      if(hasSubCategory){
        var selectedSubCategories = $scope.params.filters.filter(p => p.value.level > 1);
        if(selectedSubCategories.length > 0 && !params.selected){
          return $scope.toggleFilter(params);
        } else {
          return $scope.toggleFilter(params);
        }
      } else {
        return $scope.toggleFilter(params);
      }
    }

    $scope.toggleFilterSubCategory = function(paramsSubCategory, paramsRootCategory) {
      var isSubCategorySelected = $scope.toggleFilter(paramsSubCategory);
      var selectedSubCategories = $scope.params.filters.filter(p => p.value.level > 1);

      if(isSubCategorySelected && paramsRootCategory.selected){
        return true;
      }

      if(selectedSubCategories.length == 0){
        return $scope.toggleFilter(paramsRootCategory);
      }

      return isSubCategorySelected;
    }


    ////////////////////////////
    //  CHECK IF THE FILTER IS BEING SELECTED.
    ////////////////////////////

    self.isFilterSelected = function(filterOptionKey,selectedOptionKey){

      var isSelected = false;
      $scope.params.filters.forEach(function(current,index,array){
        if (current.key === String(filterOptionKey) && selectedOptionKey.key === current.value.key){
          isSelected = true;
        }
      })
      return isSelected;
    }

    self.isFilterSelectedCategory = function(filterOptionKey, selectedOptionKey, hasSubCategory) {
      if(hasSubCategory){
        var selectedSubCategories = $scope.params.filters.filter(p => p.value.level > 1);
        var selected = selectedSubCategories.length > 0;
        return selected;
      } else {
        return self.isFilterSelected(filterOptionKey, selectedOptionKey);
      }
    }

    ////////////////////////////
    //  APPLY SEARCH FILTERS
    ////////////////////////////
    self.applyFilters = function() {
      $scope.isSideFilterActive = false;

      setFilterParams();
      //CLEAR THE PREVIOUS SEARCH RESULT AND CHANGE THE SORT ORDER.
      self.result = [];
      self.currentPageCount = 1;
      self.search(self.filtersParams);
      self.displayFilterTags();
    }

    ////////////////////////////
    //  APPLY SEARCH FILTERS
    ////////////////////////////
    function setFilterParams(){
      $rootScope.enableLog ? $log.info($rootScope.UUID + ":SearchCtrl:setFilterParams") : '';

      self.filtersParams.min = String($scope.params.priceFilter.min);
      self.filtersParams.max = String($scope.params.priceFilter.max);
      self.filtersParams.creditMin = String($scope.params.creditFilter.min);
      self.filtersParams.creditMax = String($scope.params.creditFilter.max);

      // THE FILTER PARAMETERS, AS THESE ARE MULTI-SELECT VALUE
      self.filtersParams.category = undefined;
      self.filtersParams.subCategory = undefined;
      self.filtersParams.sort = undefined;
      self.filtersParams.color = undefined;
      self.filtersParams.brand = undefined;
      self.filtersParams.size = undefined;
      self.filtersParams.status = undefined;
      self.filtersParams.type = undefined;//CONFIG.DEFAULT_SEARCH_TYPE;
      self.filtersParams.startDate = null;
      self.filtersParams.endDate = null;
      self.filtersParams.country = $rootScope.geoLocation.country;
      self.filtersParams.itemCondition = null;

      if($rootScope.isLogon){
        var isAdmin = AuthService.isAuthorized(USER_ROLES.admin);
        if(isAdmin){
          var adminFilterType = $scope.params.filters.filter(f => f.key === "5");
          for (var item in adminFilterType) {
            var i = adminFilterType[item];
            if(i.value.key === "3"){
              $scope.isUnrecommendedSelected = true;
            } else if(i.value.key === "2"){
              $scope.isStylePostSelected = true;
            } else if(i.value.key === "4"){
              $scope.isAllSelected = true;
            } else if(i.value.key === "5"){
              $scope.isDeletedSelected = true;
            }  else if(i.value.key === "1"){
              $scope.isAvailableSelected = true;
            } 
          }

          /*if($scope.stylePostSelected && !$scope.recommendedSelected ) {
            self.filtersParams.type = "2";
          }*/
        } else {
          self.filtersParams.type = CONFIG.DEFAULT_SEARCH_TYPE;
        }
      } else {
        self.filtersParams.type = CONFIG.DEFAULT_SEARCH_TYPE;
      }

      //LOOP THRU ALL FILTER PARAMETERS
      for (var item in $scope.params.filters) {

        //THE SELECTED FILTER OPTIONS. EG. CATEGORY, COLOR, DESIGNER, RENTAL
        var selectedItem = $scope.params.filters[item].value;

        switch ($scope.params.filters[item].key) {

          //CATEGORY
          case "0":
            if(selectedItem.level == 1){
              self.filtersParams.category = self.filtersParams.category ? self.filtersParams.category + "|" + $scope.params.filters[item].value.value : $scope.params.filters[item].value.value;
            } else {
              self.filtersParams.subCategory = self.filtersParams.subCategory ? self.filtersParams.subCategory + "|" + $scope.params.filters[item].value.value : $scope.params.filters[item].value.value;
            }
            break;

            //SIZE
          case "1":
            self.filtersParams.size = self.filtersParams.size ? self.filtersParams.size + "|" + $scope.params.filters[item].value.key : $scope.params.filters[item].value.key;
            break;

            //COLOR
          case "2":
            self.filtersParams.color = self.filtersParams.color ? self.filtersParams.color + "|" + $scope.params.filters[item].value.value : $scope.params.filters[item].value.value;
            break;

            //DESIGNER/BRAND
          case "3":
            self.filtersParams.brand = self.filtersParams.brand ? self.filtersParams.brand + "|" + $scope.params.filters[item].value.value : $scope.params.filters[item].value.value;
            break;

            //RENTAL
          case "4":
            //"instant" (Instant Rental), "rental" (Rental Request), "rented" (Checked Out)
            switch ($scope.params.filters[item].value.key) {
              case "IR":
                self.filtersParams.status = self.filtersParams.status ? self.filtersParams.status + "|" + "instant" : self.filtersParams.status = "instant";
                break;

              case "RR":
                self.filtersParams.status = self.filtersParams.status ? self.filtersParams.status + "|" + "rental" : self.filtersParams.status = "rental";
                break;

              case "BUNDLES":
                self.filtersParams.status = self.filtersParams.status ? self.filtersParams.status + "|" + "bundles" : self.filtersParams.status = "bundles";
                break;

              case "CO":
                self.filtersParams.status = self.filtersParams.status ? self.filtersParams.status + "|" + "rented" : self.filtersParams.status = "rented";
                break;
            };
            break;

          //VIEW
          case "5":
            //self.filtersParams.type = self.filtersParams.type = '1' ? self.filtersParams.type = "1|2" : self.filtersParams.type = '1';
            self.filtersParams.type = self.filtersParams.type ? self.filtersParams.type + "|" + $scope.params.filters[item].value.key : $scope.params.filters[item].value.key;
            break;

          case "6":
            switch ($scope.params.filters[item].value.key) {
              case "StartDate":
                self.filtersParams.startDate  = $scope.params.filters[item].value.value;
                break;
              case "EndDate":
                self.filtersParams.endDate  =$scope.params.filters[item].value.value;
                break;
            }
            break;

          //ITEM CONDITION
          case "7":
            self.filtersParams.itemCondition = self.filtersParams.itemCondition ? self.filtersParams.itemCondition + "|" + $scope.params.filters[item].value.value : $scope.params.filters[item].value.value;
          break;

        };
      }

      self.filtersParams.sort = $scope.params.sortBy.KEY;
    }


    ////////////////////////////
    //  CLEAR FILTERS
    ////////////////////////////
    $scope.clearFilters = function() {
      $rootScope.enableLog ? $log.info($rootScope.UUID + ":SearchCtrl:clearFilters") : '';
      var tempSortOrder = angular.copy($scope.params.sortBy);
      $scope.isSideFilterActive = false;
      $scope.params.filters = [];
      setFilterParams();
      self.filtersParams.min = CONFIG.PRICE_MIN;
      self.filtersParams.max = CONFIG.PRICE_MAX;
      self.filtersParams.creditMin = CONFIG.CREDIT_MIN;
      self.filtersParams.creditMax = CONFIG.CREDIT_MAX;
      self.filtersParams.page = "1";
      self.filtersParams.size = undefined;
      self.filtersParams.sort = $scope.params.sortBy.KEY;
      self.filtersParams.type = utilities.getDefaultTypeFilterParams();

      self.filterTags = {
        isFiltered: false
      };

      if(utilities.isShowMainRegion()){
        $state.go('search', self.filtersParams, {reload:true});
      } else {
        $state.go('search-multi-region', self.filtersParams, {reload:true});
      }
    };


    function parseSearchParams(params) {
      if (!!params) {
        if (params.mm) {
          //MEGA MENU SEARCH, PREDEFINED SEARCH
          Session.prev_searchParams = params.brand;
        } else {
          //PASER THE USER INPUT STRING FOR THE SEARCH
          Session.prev_searchParams = params.q.trim().replace(/\++/g, " ");
        }
      }
    };

    // Retrieve listing based on listing id
    this.showListing = function(id) {
      // $location.path('/listing/' + id).search({});

      if(utilities.isShowMainRegion()){
        $state.go('listing', {
          id: id
        });
      } else {
        $state.go('listing-multi-region', {
          id: id,
          country: $rootScope.geoLocation.country
        });
      }

    };


    /////////////////////////////////////////////////////////////////
    // Split param string into array and call ListingService.search()
    // params variables
    //brand: filter brand, category: filter category, min: filter price min, max: filter price max, fdmin: filter discount main
    //fdmax: filter discount max, page: filter page, q:tags ,
    /////////////////////////////////////////////////////////////////
    this.search = function(params) {
      //usSpinnerService.spin('spinner');
      self.isLoading = true;
      self.lk_search = true;
      self.prev_searchParams_local = params;

      //DEFINE SEARCH PAGE, IF NO PREVIOUS SEARCH DEFAULT PAGE IS 1
      if (self.currentPageCount) {
        params.page = self.currentPageCount;
      } else {
        self.currentPageCount = params.page ? params.page : 1;
        params.page = String(self.currentPageCount);
      }

      self.filtersParams.page = String(params.page);
      self.filtersParams.q = params.q;
      self.filtersParams.country = $rootScope.geoLocation.country;

      

      var q_params = null;
      var q_brand = null;
      var q_category = null;
      var q_status = null;
      var q_item_condition = null;
      var q_color = null;
      var q_size = null;
      var _params = null;
      if(self.filtersParams.q){
        q_params = "q="+self.filtersParams.q;
        _params = q_params;
      }
      if(self.filtersParams.brand){
        q_brand = "brand="+self.filtersParams.brand;
        _params = _params != null ? "&" + q_brand : q_brand;
      }
      if(self.filtersParams.category){
        q_category = "category="+self.filtersParams.category;
        _params = _params != null ? "&" + q_category : q_category;
      }
      if(self.filtersParams.status){
        q_status = "status="+self.filtersParams.status;
        _params = _params != null ? "&" + q_status : q_status;
      }
      if(self.filtersParams.itemCondition){
        q_item_condition = "itemCondition="+self.filtersParams.itemCondition;
        _params = _params != null ? "&" + q_item_condition : q_item_condition;
      }
      if(self.filtersParams.color){
        q_color = "color="+self.filtersParams.color;
        _params = _params != null ? "&" + q_color : q_color;
      }
      if(self.filtersParams.size){
        q_size = "size="+self.filtersParams.size;
        _params = _params != null ? "&" + q_size : q_size;
      }
      
      if(!this.isAdmin()){

        DialogAlertService.appInfo(_params);
        if(_params){
          //DialogAlertService.promptDialog('GENERAL.MESSAGE.APP_POPUP_MESSAGE', '', '', '', 'SHOP NOW', function(){$window.location.href = envService.read('APP_URL') + "/listings?"+_params;}, '', false);
        } else {
          //DialogAlertService.promptDialog('GENERAL.MESSAGE.APP_POPUP_MESSAGE', '', '', '', 'SHOP NOW', function(){$window.location.href = envService.read('APP_URL');}, '', false);
        }
      }

      
      if(utilities.isShowMainRegion()){
        $state.go('search', self.filtersParams, {notify: false}); //UPDATE THE URL PARAMETERS WITHOUT RELOADING THE PAGE.
      } else {
        $state.go('search-multi-region', self.filtersParams, {notify: false, reload: true});
      }

      Session.prev_searchParams = angular.copy(self.filtersParams);
      Session.prev_filterParams = angular.copy($scope.params);
      setMetadata();
      ListingService.getListingsWithFilters(prepareParam(self.filtersParams)).$promise.then(
        function(resp) {
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":SearchCtrl:search - Listing Search: " + JSON.stringify(resp.length)) : '';
          handleSearchResult(resp);
        },
        function(err) {
          //usSpinnerService.stop('spinner');
          self.lk_search = false;
          self.isLoading = false;
          self.lk_loadMore = false;
          if (err.data) {
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":SearchCtrl:search - Listing error: " + err.data.reasons[0].message) : '';
          } else {
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":SearchCtrl:search - Listing error: " + JSON.stringify(err)) : '';
          }
        });
    };


    /////////////////////////////////////
    // HANDLE SUCCESSFUL SEARCH RESULT
    /////////////////////////////////////
    function handleSearchResult(resp){
      //ADD LISTING MODIFYDATE = CREATIONDATE, IF MODIFDATE DATE IS EMPTY
      //THIS IS USED TO DO SORTING OF THE LISTING PRODUCT BY LATEST
      var totalRecordCount, totalPageCount;

      resp.forEach(function(item, index, arr) {
        if (!item['searchResult']) {
          item._modifyDate = item.modifyDate == null ? item.creationDate : item.modifyDate;
          item._page = self.currentPageCount;
        } else {
          totalRecordCount = item['searchResult']['totalRecordCount'];
          totalPageCount = item['searchResult']['totalPageCount'];
          arr.pop();
        }
      });
      self.resultTotalPageCount = totalPageCount;

      //SAVED THE SEARCH RESULT IN THE SESSION
      var tmpResult = angular.copy(self.result);
      self.result = tmpResult.concat(resp);

      //SHOW DIFFERENT SIZES IN THE LISTING PAGE
      self.result.forEach(product => {
        product.hasSize = product.sizes ? product.sizes.filter(s => s.available).length > 0 : 0;
        product._itemCurated = product.existInCollection;
        var allCollections = [];
        self.collectionList.forEach(c => {
          var collection = {};
          collection.key = c.key;
          collection.value = c.value;
          collection.order = c.order;
          if(c.key === "two-for-one"){
            collection.selected = product.bundle;
          } else if(c.key === "main-collection"){
            collection.selected = product.recommended;
          }
          allCollections.push(collection);
        });
        product.allCollections = allCollections;
        product.allCollections.sort(function(a, b){return a.position-b.position;});

      });
      $scope.params.totalItems = totalRecordCount;

      (self.currentPageCount >= totalPageCount || $scope.params.totalItems === 0) ? self.lk_loadMore = true: self.lk_loadMore = false;

      Session.prev_searchResultCount = totalRecordCount;
      Session.prev_searchResult = angular.copy(self.result);

      self.lk_search = false;
      self.isLoading = false;
      usSpinnerService.stop('spinner');

      //SAVE THE LAST PRODUCT ID WHERE THE USER HAS SCROLLED TO, BEFORE THE NEW ITEMS LOADED
      //MOVE THE LIST BACK TO THE LAST POSITION.
      self.scrollLastItemID = tmpResult.length > 0 ? tmpResult[tmpResult.length-1].id : null;
      
      $timeout(function() {
        $anchorScroll(self.scrollLastItemID );
        self.lk_loadMore = false;
      }, 400);

    }

    ////////////////////////////
    // REFRESH THE SERACH RESULT
    // BASED ON THE PAGE CLICK
    ////////////////////////////
    self.pageSelectorClick = function(){
      Session.prev_searchResult = [];
      self.result = [];
      $scope.params.currentPage = $scope.pageSelector_pgNum;
      self.currentPageCount = $scope.params.currentPage;
      var searchParams = self.prev_searchParams_local ? self.prev_searchParams_local : Session.prev_searchParams;
      self.search(searchParams);
    }

    ////////////////////////////
    //  WATCH FOR CALLBACK ON THE UPDATED PAGENUM
    ////////////////////////////
    self.PageNumCallback = function(newVal){
      $scope.pageSelector_pgNum = parseInt(newVal);
    }

    ////////////////////////////
    // DETECT MOBILE VIEW
    ////////////////////////////
    self.isMobileView = function(){
      return utilities.isMobileView();
    }

    ////////////////////////////
    //  SCROLL DOWN TO LOAD MORE
    ////////////////////////////
    this.loadMoreListings = function() {
      if (!self.lk_loadMore && !self.lk_search && Number(self.currentPageCount) <= Number(self.resultTotalPageCount)) {
        authCheck.authorityCheck().then(function(returnValue){
          if (returnValue != 'SHOW_CONFIRM'){
            self.lk_loadMore = true;
            self.currentPageCount++;
            $scope.pageSelector_pgNum = self.currentPageCount;
            $scope.params.currentPage = self.currentPageCount;
            $rootScope.enableLog ? $log.info($rootScope.UUID + ":SearchCtrl:loadMoreListings - Loading more results from page " + self.currentPageCount) : '';
            if (self.prev_searchParams_local == null){
              self.prev_searchParams_local = Session.prev_searchParams;
            }else{
              Session.prev_searchParams = angular.copy(self.prev_searchParams_local);
            }

            self.search(self.prev_searchParams_local);
          }
        },function(){
          self.lk_loadMore = false;
          self.lk_search = false;

          if(utilities.isShowMainRegion()){
            $state.go('main');
          } else {
            $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
          }

          $rootScope.enableLog ? $log.info($rootScope.UUID + ":SearchCtrl:loadMoreListings - Loading more failed.") : '';
        })
      }
    };

    // Update Fav
    this.updateFav = function() {
      self.lk_fav = true;
      if (self.listing.myFavorite) {
        // Current product is favorited, now unfavorite it
        FavoriteService.delFav(self.listing.id).$promise.then(function(resp) {
          self.listing.numberOfFavorite--;
          self.listing.myFavorite = false;
          self.lk_fav = false;
        });

      } else {
        self.listing.myFavorite = FavoriteService.addFav(self.listing.id).$promise.then(function(resp) {
          self.listing.numberOfFavorite++;
          self.listing.myFavorite = true;
          self.lk_fav = false;
        });

      }
    };

    this.goBack = function() {
      window.history.back();
    };

    ////////////////////////////
    //  CONVERT THE URL PARAMETERS TO SERVICE API PARAMETERS
    ////////////////////////////
    function prepareParam(params) {
      return {
        brand: params.brand,
        category: params.category,
        subCategory: params.subCategory,
        creditMin: params.creditMin,
        creditMax: params.creditMax,
        priceMin: params.min,
        priceMax: params.max,
        rentalFeeMin: params.feeMin,
        rentalFeeMax: params.feeMax,
        color: params.color,
        rentStatus: params.status,
        sort: params.sort,
        size: params.size,
        discountRateMin: params.fdmin,
        discountRateMax: params.fdmax,
        page: params.page,
        tags: params.q,
        types: params.type,
        startDate: params.startDate,
        endDate: params.endDate,
        itemCondition: params.itemCondition,
        country: $rootScope.geoLocation.country
      };
    }


    self.displayFilterTags = function () {

      var filterTags = {
        tagParameters: []
      };


      var brandsArr = self.filtersParams.brand ? self.filtersParams.brand.split("|") : [];
      brandsArr.forEach((v) => {
        filterTags.tagParameters.push({ type: "brand", value : v });
      });

      var categoryArr = self.filtersParams.category ? self.filtersParams.category.split("|") : [];
      var subCategoryArr = self.filtersParams.subCategory ? self.filtersParams.subCategory.split("|") : [];
      categoryArr.forEach((v) => {
        //Exclude clothing category in displaying in tags to not allow the user to clear the root category.
        //For now it is only for Clothing since there is no subcategory yet for other root categories.
        if(v !== "Clothing" || subCategoryArr.length == 0){
          filterTags.tagParameters.push({ type: "category", value : v });
        }
      });

      subCategoryArr.forEach((v) => {
        filterTags.tagParameters.push({ type: "category", value : v });
      });

      var sizeArr = self.filtersParams.size ? self.filtersParams.size.split("|") : [];
      sizeArr.forEach((v) => {
        var selectedSize = getSizeValue(v);
        filterTags.tagParameters.push({ type: "size", value : selectedSize });
      });

      var colorArr = self.filtersParams.color ? self.filtersParams.color.split("|") : [];
      colorArr.forEach((v) => {
        filterTags.tagParameters.push({ type: "color", value : v });
      });

      var statusArr = self.filtersParams.status ? self.filtersParams.status.split("|") : [];
      statusArr.forEach((v) => {
        filterTags.tagParameters.push({ type: "status", value : v });
      });

      var searchTag = self.display_searchTags ? self.display_searchTags.split("|") :  self.display_searchTags;
      if(searchTag) {
        searchTag.forEach((v) => {
          filterTags.tagParameters.push({ type: "tag", value : v });
        });
      };

      var startDate = self.filtersParams.startDate;
      var endDate = self.filtersParams.endDate;

      if(startDate && endDate) {
        var dateFilter = moment(startDate, "x").format("DD MMM YYYY") + " - " + moment(endDate, "x").format("DD MMM YYYY");
        filterTags.tagParameters.push({ type: "date", value :  dateFilter});
      };

      var conditionArr = self.filtersParams.itemCondition ? self.filtersParams.itemCondition.split("|") : [];
      conditionArr.forEach((v) => {
        filterTags.tagParameters.push({ type: "itemCondition", value : v });
      });

      filterTags.isFiltered = filterTags.tagParameters.length > 0;
      self.filterTags = filterTags;

      $rootScope.enableLog ? $log.info($rootScope.UUID + ":SearchCtrl:$displayFilterTags - " + JSON.stringify(self.filterTags)) : '';

    }

    self.refreshFilters = function(removedParam) {

      var paramObj = {};
        if (removedParam.type === "category") {
          paramObj = $scope.params.filters.filter(p => {
            return p.key === "0" && String(p.value.value).toUpperCase() === String(removedParam.value).toUpperCase();
          })[0];
          self.refreshFilterParams(paramObj);

          //CC-945: Handling only for CLOTHING for now. Other categories does not have sub-categories
          var subCategories = $scope.params.filters.filter(p => {
            return p.key === "0" && p.value.level > 1;
          });

          //Clear root category
          if(subCategories.length == 0){
            var parentClothingCategory = $scope.params.filters.filter(p => {
              return p.key === "0" && String(p.value.value).toUpperCase() === "CLOTHING";
            })[0];
            self.refreshFilterParams(parentClothingCategory);
          }
        }
        else if (removedParam.type === "size") {
          paramObj = $scope.params.filters.filter(p => {
            return p.key === "1" && String(p.value.value).toUpperCase() === String(removedParam.value).toUpperCase();
          })[0];
          self.refreshFilterParams(paramObj);
        }
        else if (removedParam.type === "color") {
          paramObj = $scope.params.filters.filter(p => {
           return p.key === "2" && String(p.value.value).toUpperCase() === String(removedParam.value).toUpperCase();
          })[0];
          self.refreshFilterParams(paramObj);
        }
        else if (removedParam.type === "brand") {
          paramObj = $scope.params.filters.filter(p => {
            return p.key === "3" && String(p.value.value).toUpperCase() === String(removedParam.value).toUpperCase();
          })[0];
          self.refreshFilterParams(paramObj);
        }
        else if (removedParam.type === "status") {
          paramObj = $scope.params.filters.filter(p => {
            var statusCode = removedParam.value === "instant" ? "IR" : "RR";
            return p.key === "4" && String(p.value.key).toUpperCase() === String(statusCode).toUpperCase();
          })[0];
          self.refreshFilterParams(paramObj);
        }
        else if (removedParam.type === "date") {
          //clear both start and end dates since both dates are required for search.
          let startDtIdx = $scope.params.filters.map(function(o) {
            return String(o.key) === "6" ? o.value.value : '';
          }).indexOf(self.filtersParams.startDate);
          if (startDtIdx !== -1) {
            $scope.params.filters.splice(startDtIdx, 1);
          }

          let endDtIdx = $scope.params.filters.map(function(o) {
            return String(o.key) === "6" ? o.value.value : '';
          }).indexOf(self.filtersParams.endDate);
          if (endDtIdx !== -1) {
            $scope.params.filters.splice(endDtIdx, 1);
          }
          self.applyFilters();
        }
        else if (removedParam.type === "itemCondition") {
          paramObj = $scope.params.filters.filter(p => {
            return p.key === "7" && String(p.value.value).toUpperCase() === String(removedParam.value).toUpperCase();
          })[0];
          self.refreshFilterParams(paramObj);
        }
        else if (removedParam.type === "tag") {
          var searchTag = self.display_searchTags ? self.display_searchTags.split("|") :  self.display_searchTags;
          let index = searchTag.indexOf(removedParam.value);

          if (index !== -1) {
            searchTag.splice(index, 1);
          }

          var searchTagStr = "";
          for (var item in searchTag) {
            searchTagStr = searchTagStr ? searchTagStr + "|" + searchTag[item]: searchTag[item];
          }
          self.filtersParams.q = searchTagStr;
          self.display_searchTags = searchTagStr;

          self.applyFilters();
        }
        else {
          self.filtersParams.q = null;
          self.display_searchTags = "";
          self.applyFilters();
        }


    }

    self.refreshFilterParams = function (paramObj){
      let index = $scope.params.filters.map(function(o) {
        return String(o.key) === String(paramObj.key)? o.value.key : '';
      }).indexOf(paramObj.value.key);
      if (index !== -1) {
        $scope.params.filters.splice(index, 1);
      }
      self.applyFilters();
    }

    function getSizeValue(size) {
      var sizes = self.sizeList;
      var sizeValue = sizes.filter(s => {
        return s.key === size ? s.value : null;
      });

      return sizeValue.length > 0 ? sizeValue[0].value : null;
    }


    function setMetadata() {
      var metaKeywords = ["Rent", "Buy", "Style Carousel", "StyleCarousel"];
      var metaBrand, metaCategory, metaSubCategory;
      if(self.filtersParams){
        //Category
        if(self.filtersParams.category){
          metaCategory = self.filtersParams.category;
          metaKeywords.push(metaCategory);
        }

        //Sub-Category
        if(self.filtersParams.category && self.filtersParams.category === 'Clothing' && self.filtersParams.subCategory){
          metaSubCategory = self.filtersParams.subCategory;
          metaKeywords.push(metaSubCategory);
        }

        //Brand
        if(self.filtersParams.brand){
          metaBrand = self.filtersParams.brand;
          metaKeywords.push(metaBrand);
        }
      }

      var category = metaSubCategory ? metaSubCategory : (metaCategory ? metaCategory : 'piece');
      var brandDesc = $translate.instant('GENERAL.META.DESC_BY_BRAND', {brand: metaBrand, category: category});
      var categoryDesc = $translate.instant('GENERAL.META.DESC_BY_CATEGORY', {category: category});
      var metaTitle;

      if(metaBrand && category && category !== 'piece'){
        metaTitle = "Rent | " + utilities.capitalizeFirstLetter(metaBrand) + " | " + utilities.capitalizeFirstLetter(category);
      } else if (!metaBrand && category && category !== 'piece') {
        metaTitle = "Rent | " + utilities.capitalizeFirstLetter(category);
      } else if (metaBrand && (!category || category === 'piece')) {
        metaTitle = "Rent | " + utilities.capitalizeFirstLetter(metaBrand);
      } else {
        metaTitle = "Rent Clothing, Bags & Luggage, Accessories, Shoes"
      }


      var metadata = {
        description : metaBrand ? brandDesc : categoryDesc,
        keywords : metaKeywords.join(","),
        title : metaTitle + " at Style Carousel",
      };
      SeoService.setMetaDataTags(metadata);
    };

    $scope.cellModifier = function(cell){
      if (cell.events && cell.events[0] && cell.events[0].cssClass){
        if (cell.events.length > 1 && cell.events.filter(x=>x.cssClass == '-unavailable').length > 0 && cell.events.filter(x=>x.cssClass == '-rental-period').length > 0){
          cell.events = cell.events.filter(x=>x.cssClass != '-unavailable');
        }

        switch (cell.events.map(x=>x.cssClass)[0]) {
          case '-rental-period':
            cell.cssClass = '-selectedRentalPeriod';
            break;
          case '-delivery-icon':
            cell.cssClass = '-selectedRentalPeriodStart';
            break;
          case '-delivery-returns-filter':
            cell.cssClass = '-selectedRentalPeriodEnd';
            break;

          default:
            cell.cssClass = '-unavailable';
        }
      } else {
        var cellDate = moment(cell.date).startOf('day').valueOf();
        var firstAvailableDate = moment($scope.firstAvailableDate).startOf('day').valueOf();
        var diff = utilities.getRentalDays(firstAvailableDate, cellDate);

        if(diff <= 2){
          cell.cssClass = '-styles-1';
        } else if(diff >= 3 && diff <= 5){
          cell.cssClass = '-styles-2';
        } else if(diff == 6){
          cell.cssClass = '-styles-3';
        } else if(diff == 7){
          cell.cssClass = '-styles-4';
        } else if(diff == 8){
          cell.cssClass = '-styles-5';
        } else {
          cell.cssClass = '-styles-6';
        }
      }
    }


    $scope.timespanClicked = function(date, cell) {
        date = moment(date).startOf('day').valueOf();

        if (self.availDatesWithoutTime.includes(cell.date.format('ll')) || !cell.events) {

          let rentalDates = [];
          for (var i = 0; i <= EndDateInDays; i++) {
            rentalDates.push({
              startsAt: new Date(moment(date).startOf('day').add(expectedDeliveryDateInDays + i, 'd').format('LLLL')),
              cssClass: '-rental-period',
              incrementsBadgeTotal: false });
          }

          let newEvent = [{
              startsAt: new Date(moment(date).startOf('day').add(expectedDeliveryDateInDays, 'd').format('LLLL')),
              cssClass: '-delivery-icon',
              incrementsBadgeTotal: false
            },
            {
              startsAt: new Date(moment(date).startOf('day').add(EndDateInDays, 'd').format('LLLL')),
              cssClass: '-delivery-returns-filter',
              incrementsBadgeTotal: false
            }
          ];
          $scope.events = [];
          $scope.events = $scope.events.concat(newEvent);
          $scope.events = $scope.events.concat(self.unavailableDates);
          $scope.events = $scope.events.concat(rentalDates);
          $scope.isDateSelected = true;

          //clear both start and end dates
          let startDtIdx = $scope.params.filters.map(function(o) {
            return String(o.key) === "6" ? o.value.value : '';
          }).indexOf(self.filtersParams.startDate);
          if (startDtIdx !== -1) {
            $scope.params.filters.splice(startDtIdx, 1);
          }

          let endDtIdx = $scope.params.filters.map(function(o) {
            return String(o.key) === "6" ? o.value.value : '';
          }).indexOf(self.filtersParams.endDate);
          if (endDtIdx !== -1) {
            $scope.params.filters.splice(endDtIdx, 1);
          }

          $scope.params.filters.push({
            key: "6",
            value: {
              key: "StartDate",
              value: moment(rentalDates[0].startsAt).format('x')
            }
          });
          $scope.params.filters.push({
            key: "6",
            value: {
              key: "EndDate",
              value: moment(rentalDates[rentalDates.length - 1].startsAt).format('x')
            }
          });

        }
    };

    $scope.changeMonth = function(viewDate) {
      $scope.currentMonth = moment(viewDate).format('MMMM');
    };

    this.toggleCalendarSizeFilter = function() {
      //moment.tz.setDefault($rootScope.currentTimezone);
      var datesByCountry = $rootScope.cc.allowedDates ? $rootScope.cc.allowedDates.DATES_BY_COUNTRY : null;
      var country = self.filtersParams.country ? self.filtersParams.country : "HK";
      var allowedDatesByCountry = datesByCountry.filter(d=>d.country == country);
      var availableDates = allowedDatesByCountry.length > 0 ? allowedDatesByCountry[0].INSTANT_RENTAL : $rootScope.cc.allowedDates.INSTANT_RENTAL;
      

      var unavailableDates = [{
        startsAt: new Date(moment().startOf('year').subtract(1,'y').format('LLLL')),
        endsAt: new Date(moment().endOf('day').subtract(1,'d').format('LLLL')),
        cssClass: '-unavailable',
        incrementsBadgeTotal: false }];

      if (moment().startOf('day').format('LLLL') !=moment.tz(availableDates[0],$rootScope.ServerTimezone).utc().format('LLLL')){
        unavailableDates.push({
          startsAt: new Date(moment().startOf('day').format('LLLL')),
          endsAt: new Date(moment.tz(availableDates[0],$rootScope.ServerTimezone).utc().endOf('day').subtract(1,'d').format('LLLL')),
          cssClass: '-unavailable',
          incrementsBadgeTotal: false });
      }
      unavailableDates.push( {
        startsAt: new Date(moment(availableDates[availableDates.length-1]).startOf('day').add(1,'d').format('LLLL')),
        endsAt: new Date(moment(availableDates[availableDates.length-1]).add(1,'y').startOf('day').format('LLLL')),
        cssClass: '-unavailable',
        incrementsBadgeTotal: false });

      var availDatesWithoutTime=[];
      for (var i = 1; i < availableDates.length; i++){
        //availDatesWithoutTime[i]=moment(availableDates[i]).startOf('day').format('ll');
        availDatesWithoutTime[i]=moment(new Date()).startOf('day').add(i,'d').format('ll');
      }

      $scope.events = $scope.events.concat(unavailableDates);
      self.unavailableDates = unavailableDates;
      self.availDatesWithoutTime = availDatesWithoutTime;
      $scope.firstAvailableDate = new Date(moment(availableDates[0]).startOf('day').format('LLLL'));

    }

    function getSliderFilter() {
      if($rootScope.sliderCountry == CONFIG.COUNTRY_CURRENCY_CODE.SG.country_code){
        self._sliderMinValue = CONFIG.PRICE_MIN_SG;
        self._sliderMaxValue = CONFIG.PRICE_MAX_SG;
        self._sliderStep = 100;
        self._sliderCurrency = CONFIG.COUNTRY_CURRENCY_CODE.SG.currency_code;
      } else if($rootScope.sliderCountry == CONFIG.COUNTRY_CURRENCY_CODE.AU.country_code){
        self._sliderMinValue = CONFIG.PRICE_MIN_AU;
        self._sliderMaxValue = CONFIG.PRICE_MAX_AU;
        self._sliderStep = 100;
        self._sliderCurrency = CONFIG.COUNTRY_CURRENCY_CODE.AU.currency_code;
      } else {
        self._sliderMinValue = CONFIG.PRICE_MIN;
        self._sliderMaxValue = CONFIG.PRICE_MAX;
        self._sliderStep = 1000;
        self._sliderCurrency = CONFIG.COUNTRY_CURRENCY_CODE.HK.currency_code;
      }

    }

    function refreshPriceFilter() {
      RefDataService.getForexList().$promise.then(function(resp) {
        var exchangeRate = resp ? resp.filter(fx => fx.currency == self._sliderCurrency) : {};
        self._sliderExchangeRate = exchangeRate.length > 0 ? exchangeRate[0].amount : 1;

        $scope.params.priceFilter.min = Math.round(self._sliderMinValue / self._sliderExchangeRate) < CONFIG.PRICE_MIN_INT  ? CONFIG.PRICE_MIN_INT  : Math.round(self._sliderMinValue / self._sliderExchangeRate);
        $scope.params.priceFilter.max = Math.round(self._sliderMaxValue / self._sliderExchangeRate) > 300000 ? 300000 : Math.round(self._sliderMaxValue / self._sliderExchangeRate);
        $scope.slider = {
          minValue: self._sliderMinValue,
          maxValue: self._sliderMaxValue,
          options: {
            floor: parseInt(self._sliderMinValue),
            ceil: parseInt(self._sliderMaxValue),
            step: self._sliderStep,
            logScale: true,
            translate: function(value, sliderId, label) {
              switch (label) {
                case 'model':
                  $scope.params.priceFilter.min = Math.round(value / self._sliderExchangeRate) < CONFIG.PRICE_MIN_INT  ? CONFIG.PRICE_MIN_INT  : Math.round(value / self._sliderExchangeRate);
                  break;

                case 'high':
                  $scope.params.priceFilter.max = Math.round(value / self._sliderExchangeRate) > 300000 ? 300000 : Math.round(value / self._sliderExchangeRate);
                  break;
              }
              return $filter('currency')(value, '$', 0);
            }
          }
        };
      });
    }


    this.viewMoreListings = function() {
      if (Number(self.currentPageCount) <= Number(self.resultTotalPageCount)) {
        authCheck.authorityCheck().then(function(returnValue){
          if (returnValue != 'SHOW_CONFIRM'){
            self.lk_loadMore = true;
            self.currentPageCount++;
            $scope.pageSelector_pgNum = self.currentPageCount;
            $scope.params.currentPage = self.currentPageCount;
            $rootScope.enableLog ? $log.info($rootScope.UUID + ":SearchCtrl:viewMoreListings - Loading more results from page " + self.currentPageCount) : '';
            if (self.prev_searchParams_local == null){
              self.prev_searchParams_local = Session.prev_searchParams;
            }else{
              Session.prev_searchParams = angular.copy(self.prev_searchParams_local);
            }

            self.search(self.prev_searchParams_local);
          }
        },function(){
          self.lk_loadMore = false;
          self.lk_search = false;

          if(utilities.isShowMainRegion()){
            $state.go('main');
          } else {
            $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
          }

          $rootScope.enableLog ? $log.info($rootScope.UUID + ":SearchCtrl:loadMoreListings - Loading more failed.") : '';
        })
      }
    };

  }]);

'use strict';

(function(){
  angular.module('coutureApp')
    .component('customBrandListing', {
      templateUrl: 'scripts/components/custom-brand-listing/custom-brand-listing.html',
      controllerAs : 'customBrandCtrl',
      bindings: {
        loadOrNot: '<'
      },
      controller: ["$scope", "$rootScope", "USER_ROLES", "AuthService", "NgTableParams", "ProductService", "ListingService", "$log", "RefDataService", "$state", "DialogAlertService", "$filter", "$translate", "$translatePartialLoader", "utilities", "usSpinnerService", "productStatus", function($scope,$rootScope,USER_ROLES,AuthService,NgTableParams,ProductService,ListingService,$log
        ,RefDataService,$state,DialogAlertService, $filter,$translate,$translatePartialLoader,utilities,usSpinnerService,productStatus) {

        this.$onInit = function(){
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - customBrandListing"):'';
          if (!$rootScope.isLogon || !AuthService.isAuthorized(USER_ROLES.admin)){
            if(utilities.isShowMainRegion()){
              $state.go('main');
            } else {
              $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
            }
          }else{
            this.originalData = [];
            this.categoryList = null;
            this.categoryFilterList = [];
            self.recordEditMode = false;

            self.listingStatusFilter = getListingStatusFilter();

            // Load reference data
            RefDataService.getCategories().$promise.then(function(resp) {
              self.categoryList = [];
              for (var item in resp) {
                !isNaN(resp[item].id) ? self.categoryList.push({id:resp[item].id,title:resp[item].name,name:resp[item].name}):'';
                !isNaN(resp[item].id) ? self.categoryFilterList.push({id:resp[item].id,title:resp[item].name,name:resp[item].name}):'';
              }
            });
          }
        };

        ///////////////////////////////////////////////
  	    // ONLY LOAD THE LISTING IF IT IS SELECTED/VISIBLE
  	    ///////////////////////////////////////////////
        $scope.$watch('customBrandCtrl.loadOrNot', function(selectedToDisplay) {
          if (selectedToDisplay){
            $translatePartialLoader.addPart('productListing');
            self.originalData = [];
            self.loadReference();
          }
        });

        var self = this;

        ///////////////////////////////////////////////
        //THE FUNCTION WILL UPDATE AND RENTAL STATUS
  	    ///////////////////////////////////////////////
        this.statusChange = function(row, rowForm){
          rowForm.$setDirty();
          //TOGGLE BETWEEN PENDING <> AVAILABLE STATUS
          row.status = row.status === 1 ? 8:1;
          row._statusName = productStatus.getListingStatusDisplay(row.status);
          angular.element(document.getElementById(row.id)).addClass('btn-danger');
        }

        ///////////////////////////////////////////////
  	    // LOAD THE LISTING
  	    ///////////////////////////////////////////////
        this.loadReference = function(){
          usSpinnerService.spin('spinner');
          ProductService.getAllProductListing().$promise.then(function(resp){
            //ONLY SHOW THE CUSTOM BRAND ITEM
            //ADD STATUS NAME AND DATE TO THE DATA
            for (var i = 0; i < resp.length; i++) {
              if (resp[i].brand === '-- Other Brand --'){
                resp[i]._statusName = productStatus.getListingStatusDisplay(resp[i].status);
                resp[i]._creationDate = new Date(resp[i].creationDate).toLocaleDateString();
                resp[i]._createdBy = resp[i].owner.id + " " + resp[i].owner.lastName + ", " + resp[i].owner.firstName;
                resp[i]._custBrand = utilities.getCustomBrandName(resp[i]);
                self.originalData.push(resp[i]);
              }
            }
            self.tableParams = new NgTableParams({ sorting: { creationDate: "asc",id:'asc'}}, {
               dataset: angular.copy(self.originalData)
            });
            usSpinnerService.stop('spinner');
          },
          function(err) {
            usSpinnerService.stop('spinner');
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":customBrandListing:loadReference - Server error cannot load custom brand listing!" + JSON.stringify(err.data.reasons)):'';
          });

        };

        /////////////////////////////////////
  	    // SET THE PRODUCT AS PENDING
  	    /////////////////////////////////////
        self.setPending = function(product){
          var modProduct = JSON.parse(angular.toJson(product));
          modProduct.status = 1;
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":customBrandListing:setPending - Reset Rental to Available " + product.status + " " + + JSON.stringify(modProduct)):'';
          ListingService.update(modProduct).$promise.then(function(resp) {
            $rootScope.enableLog ? $log.info($rootScope.UUID + ":customBrandListing:setPending - Status update successfully. " + JSON.stringify(resp)):'';
          }, function(err) {
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":customBrandListing:setPending - Error " + err.data.reasons[0].message):'';
          });
        }

        /////////////////////////////////////
  	    // CREATE AND RETURN AN ARRAY LIST OF LISTING STATUS
  	    /////////////////////////////////////
        function getListingStatusFilter(){
          var resultList = [];
          for (var item in productStatus.listingStatusMapping) {
            resultList.push({id:productStatus.getListingStatusDisplay(item),title:productStatus.getListingStatusDisplay(item),value:item});
          }
          return resultList;
        }

        self.cancel = function(row, rowForm) {
          var originalRow = resetRow(row, rowForm);
          angular.extend(row, originalRow);
        }

        // RETRIEVE PRODUCT BASED ON PRODUCT ID
        self.showProduct = function(id, product) {
          var productBrand = utilities.getCustomBrandName(product);
          var urlSlug = utilities.getPrettyUrl(product.category.code, product.subCategory.code, productBrand, product.productLine);
          if(utilities.isShowMainRegion()){
            $state.go('listing');
          } else {
            $state.go('listing-multi-region', {id: id, urlSlug: urlSlug, country: $rootScope.geoLocation.country});
          }
        };

        self.del = function(row, rowForm) {
          ListingService.delete(row.id).$promise.then(function(resp){
            if (resp.deleted){
              $rootScope.enableLog ? $log.log("customBrandListing:del - Successfully deleted product."):'';
              self.recordEditMode = false;

              //change this row table status to delete for display purpose.
              row.status =  32;
              row._statusName = productStatus.getListingStatusDisplay(row.status);
              var originalRow = resetRow(row, rowForm);
              angular.extend(originalRow, row);

              //REMOVE THE ITEM FROM THE TABLE
              // _.remove(self.tableParams.settings().dataset, function(item) {
              //   return record === item;
              // });
              // self.tableParams.reload().then(function(data) {
              //   if (data.length === 0 && self.tableParams.total() > 0) {
              //     self.tableParams.page(self.tableParams.page() - 1);
              //     self.tableParams.reload();
              //   }
              // });
            }else{
              DialogAlertService.promptDialog('Error delete product (ID: '+row.id+'). Please try again later. ', '', '', '', 'Ok', '', '', false,'',"RED");
              $rootScope.enableLog ? $log.error($rootScope.UUID + ":customBrandListing:del - Error deleted product " + + JSON.stringify(resp)):'';
            }
          },
          function(err){
            DialogAlertService.promptDialog('Error delete product (ID: '+row.id+'). Please try again later. ', '', '', '', 'Ok', '', '', false,'',"RED");
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":customBrandListing:del - Err deleted product " + + JSON.stringify(err)):'';
          });

        }

        function resetRow(row, rowForm){
          row.isEditing = false;
          rowForm.$setPristine();
          self.tableTracker.untrack(row);
          return _.find(self.originalData, function(r){
            return r.id === row.id;
          });
        }

        self.save = function(row, rowForm) {
          ListingService.update(row).$promise.then(function(resp){
            $rootScope.enableLog ? $log.info($rootScope.UUID + ":customBrandListing:save - Updated product successfully : " + + JSON.stringify(resp)):'';
            self.recordEditMode = false;

            var originalRow = resetRow(row, rowForm);
            angular.extend(originalRow, row);
          },
          function(err){
            DialogAlertService.promptDialog('Error updating product (ID: '+row.id+'). Please try again later. ', '', '', '', 'Ok', '', '', false,'',"RED");
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":customBrandListing:save - Error updated product : " + + JSON.stringify(err)):'';
            self.recordEditMode = false;
          });

        }

      }]
    })
})();

'use strict';

(function(){
  angular.module('coutureApp')
  .component('adminSubscriptionPricing', {
    templateUrl: 'scripts/components/admin-subscription-pricing/admin-subscription-pricing.html',
    controllerAs : 'adminSubPricingCtrl',
      bindings: {
        loadOrNot: '<'
      },
      controller: ["$scope", "$rootScope", "USER_ROLES", "AuthService", "RentalService", "NgTableParams", "ProductService", "ListingService", "priceUtilities", "RefDataService", "$state", "DialogAlertService", "$log", "$filter", "$translate", "$translatePartialLoader", "usSpinnerService", "productStatus", "AdminService", "$q", "utilities", function($scope,$rootScope,USER_ROLES,AuthService,RentalService,NgTableParams,ProductService,ListingService,priceUtilities
        ,RefDataService,$state,DialogAlertService, $log, $filter,$translate,$translatePartialLoader,usSpinnerService,productStatus
        ,AdminService,$q,utilities) {

        this.$onInit = function(){

          if (!$rootScope.isLogon || !AuthService.isAuthorized(USER_ROLES.admin)){
            if(utilities.isShowMainRegion()){
              $state.go('main');
            } else {
              $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
            }
          }else{
            $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - adminSubPricingCtrl"):'';
            this.originalData = [];
            this.categoryList = null;
            this.categoryFilterList = [];
            self.recordEditMode = false;
            self.isInstantRentalChanged = false;

            // self.listingStatusFilter = getListingStatusFilter();

            // Load reference data
            // RefDataService.getCategories().$promise.then(function(resp) {
            //   self.categoryList = [];
            //   for (var item in resp) {
            //     !isNaN(resp[item].id) ? self.categoryList.push({id:resp[item].id,title:resp[item].name,name:resp[item].name}):'';
            //     !isNaN(resp[item].id) ? self.categoryFilterList.push({id:resp[item].id,title:resp[item].name,name:resp[item].name}):'';
            //   }
            // });
          }
        };

        ///////////////////////////////////////////////
  	    // ONLY LOAD THE LISTING IF IT IS SELECTED/VISIBLE
  	    ///////////////////////////////////////////////
        $scope.$watch('adminSubPricingCtrl.loadOrNot', function(selectedToDisplay) {
          if (selectedToDisplay){
            // $translatePartialLoader.addPart('adminSubPricingCtrl');
            self.originalData = [];
            self.loadSubscriptionPricing();
          }
        });

        var self = this;

        //LOAD ALL THE PRODUCTS
        this.loadSubscriptionPricing = function(){
          usSpinnerService.spin('spinner');
          RentalService.getAllSubscriptionPricingAdmin().$promise.then(function(resp){

            // ADD STATUS NAME AND DATE TO THE DATA
            // for (var i = 0; i < resp.length; i++) {
            //   resp[i]._statusName = productStatus.getListingStatusDisplay(resp[i].status);
            //   resp[i]._creationDate = new Date(resp[i].creationDate).toLocaleDateString();
            //   resp[i]._createdBy = resp[i].owner.id + " " + resp[i].owner.lastName + ", " + resp[i].owner.firstName;
            //   resp[i]._tagPrice = resp[i].discountRate > 0 ? resp[i].price*(1-resp[i].discountRate) : resp[i].price;
            //   resp[i]._rentalPrice = priceUtilities.getRentalPrice(resp[i].price,resp[i].discountRate);
            // }

            self.tableParams = new NgTableParams({ sorting: { creationDate: "asc",id:'asc'}}, {
               dataset: resp
            });

            self.originalData = angular.copy(resp);
            usSpinnerService.stop('spinner');
          },
          function(err) {
            usSpinnerService.stop('spinner');
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":adminSubPricingCtrl:loadSubscriptionPricing - Error: " + JSON.stringify(err.data.reasons)):'';
          });

        };

        ///////////////////////////////////////////////
        // UPDATE INSTANT RENTAL STATUS
  	    ///////////////////////////////////////////////
        // this.instantRentalChange = function(row, rowForm){
        //   rowForm.$setDirty();
        //   row.instantRental = !row.instantRental;
        //   self.isInstantRentalChanged = !self.isInstantRentalChanged;
        //   angular.element(document.getElementById(row.id)).addClass('btn-danger');
        // }

        /////////////////////////////////////
  	    // CREATE INSTANT RENTAL STATUS FILTER
  	    /////////////////////////////////////
        // this.getInstantRentalFilter = function(){
        //   return [{id: 'true', title: 'Yes'},{id: 'false', title: 'No'}];
        // }


        /////////////////////////////////////
  	    // CREATE AND RETURN AN ARRAY LIST OF LISTING STATUS
  	    /////////////////////////////////////
        // function getListingStatusFilter(){
        //   var resultList = [];
        //   for (var item in productStatus.listingStatusMapping) {
        //     resultList.push({id:productStatus.getListingStatusDisplay(item),title:productStatus.getListingStatusDisplay(item),value:item});
        //   }
        //   return resultList;
        // }

        self.cancel = function(row, rowForm) {
          var originalRow = resetRow(row, rowForm);
          angular.extend(row, originalRow);
        }

        // RETRIEVE PRODUCT BASED ON PRODUCT ID
        // self.showProduct = function(id) {
        //   $state.go('listing', {id: id});
        // };

        // self.del = function(row, rowForm) {
        //   ListingService.delete(row.id).$promise.then(function(resp){
        //     if (resp.deleted){
        //       $rootScope.enableLog ? $log.info($rootScope.UUID + ":adminSubPricingCtrl:del - Successful"):'';
        //       self.recordEditMode = false;

        //       //change this row table status to delete for display purpose.
        //       row.status =  32;
        //       row._statusName = productStatus.getListingStatusDisplay(row.status);
        //       var originalRow = resetRow(row, rowForm);
        //       angular.extend(originalRow, row);

        //       //REMOVE THE ITEM FROM THE TABLE
        //       // _.remove(self.tableParams.settings().dataset, function(item) {
        //       //   return record === item;
        //       // });
        //       // self.tableParams.reload().then(function(data) {
        //       //   if (data.length === 0 && self.tableParams.total() > 0) {
        //       //     self.tableParams.page(self.tableParams.page() - 1);
        //       //     self.tableParams.reload();
        //       //   }
        //       // });
        //     }else{
        //       DialogAlertService.promptDialog('Error delete product (ID: '+row.id+'). Please try again later. ', '', '', '', 'Ok', '', '', false,'',"RED");
        //       $rootScope.enableLog ? $log.error($rootScope.UUID + ":adminSubPricingCtrl:del - Error1: " + JSON.stringify(resp)):'';
        //     }
        //   },
        //   function(err){
        //     DialogAlertService.promptDialog('Error delete product (ID: '+row.id+'). Please try again later. ', '', '', '', 'Ok', '', '', false,'',"RED");
        //     $rootScope.enableLog ? $log.error($rootScope.UUID + ":adminSubPricingCtrl:del - Error2: " + JSON.stringify(err)):'';
        //   });

        // }

        function resetRow(row, rowForm){
          row.isEditing = false;
          rowForm.$setPristine();
          self.tableTracker.untrack(row);
          return _.find(self.originalData, function(r){
            return r.id === row.id;
          });
        }


        /////////////////////////////////////////////////////
        // UPDATE THE TAG/PRICE AND DISCOUNT RATE
        /////////////////////////////////////////////////////
        // self.updatePrice = function(row,rowForm){

        //   //THE PRODUCT HAD ORIGINAL PRICE AND THE CHANGED TAG PRICE IS > ORIGINAL PRICE
        //   //RESTORE THE TAG PRICE
        //   var originalProduct = _.find(self.originalData, function(r){
        //     return r.id === row.id;
        //   });
        //   if (row._tagPrice > originalProduct.price && row.discountRate > 0 || row._tagPrice < 2000){
        //     row._tagPrice = originalProduct._tagPrice;
        //     rowForm.price.$setPristine();
        //     DialogAlertService.promptDialog('Tag price must larger then $2000 but less then original price: $' + originalProduct.price, '', '', '', '', '', '', true, '', 'RED');
        //   }

        //   //UPDATE THE DISCOUNT RATE IF THE PRODUCT HAD DISCOUNT RATE EXISTED (EG. HAVE TAG PRICE AND ORIGINAL PRICE)
        //   if (row.discountRate){
        //     row.discountRate = priceUtilities.setDiscount(originalProduct.price , row._tagPrice);
        //     row.price = row._tagPrice / (1-row.discountRate);
        //   }else{
        //     row.price = row._tagPrice;
        //   }
        //   row._rentalPrice = priceUtilities.getRentalPrice(row.price,row.discountRate);
        // }


        self.save = function(row, rowForm) {
          usSpinnerService.spin('spinner');

          // var promises = [];
          // var deferred = $q.defer();

          // if (self.isInstantRentalChanged && (row.status == 6 || row.status == 8)){
          //   promises.push(deferred.promise);
          //   row.status = row.status == 6 ? 8:6;
          //   AdminService.changeProductStatus({productID:row.id,status: row.status}).$promise.then(function(resp){
          //     self.isInstantRentalChanged = false;
          //     deferred.resolve();
          //   },function(err){
          //     deferred.reject("Error: Changing instant rental indicator.");
          //   })
          // }

          // $q.all(promises).then(function() {
            RentalService.updateSubscriptionPricingAdmin(row.id,row).$promise.then(function(resp){
              $rootScope.enableLog ? $log.info($rootScope.UUID + ":adminSubPricingCtrl:save - Successfully"):'';
              self.recordEditMode = false;

              // row._statusName = productStatus.getListingStatusDisplay(row.status);
              var originalRow = resetRow(row, rowForm);
              angular.extend(originalRow, row);
              usSpinnerService.stop('spinner');
            },
            function(err){
              usSpinnerService.stop('spinner');
              DialogAlertService.promptDialog('Error updating product (ID: '+row.id+'). Please try again later. ', '', '', '', 'Ok', '', '', false,'',"RED");
              $rootScope.enableLog ? $log.error($rootScope.UUID + ":adminSubPricingCtrl:save - Error: " + JSON.stringify(err)):'';
              self.recordEditMode = false;
            });
          // },function(err){
          //   usSpinnerService.stop('spinner');
          //   DialogAlertService.promptDialog('Error updating product (ID: '+row.id+'). Please try again later. ', '', '', '', 'Ok', '', '', false,'',"RED");
          //   $rootScope.enableLog ? $log.error($rootScope.UUID + ":adminSubPricingCtrl:save - Error: " + JSON.stringify(err)):'';
          //   self.recordEditMode = false;
          // });
        }
      }]
    })
})();

'use strict';

(function(){
  angular.module('coutureApp')
  .component('adminSubscriptionUser', {
    templateUrl: 'scripts/components/admin-subscription-user/admin-subscription-user.html',
    controllerAs : 'adminSubUserCtrl',
      bindings: {
        loadOrNot: '<'
      },
      controller: ["$scope", "$rootScope", "USER_ROLES", "AuthService", "RentalService", "NgTableParams", "ProductService", "ListingService", "priceUtilities", "RefDataService", "$state", "DialogAlertService", "$log", "$filter", "$translate", "$translatePartialLoader", "usSpinnerService", "productStatus", "AdminService", "$q", "utilities", function($scope,$rootScope,USER_ROLES,AuthService,RentalService,NgTableParams,ProductService,ListingService,priceUtilities
        ,RefDataService,$state,DialogAlertService, $log, $filter,$translate,$translatePartialLoader,usSpinnerService,productStatus
        ,AdminService,$q,utilities) {

        this.$onInit = function(){

          if (!$rootScope.isLogon || !AuthService.isAuthorized(USER_ROLES.admin)){
            if(utilities.isShowMainRegion()){
              $state.go('main');
            } else {
              $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
            }
          }else{
            self.showRecords=false;
            $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - adminSubUserCtrl"):'';
            this.originalData = [];
            // this.categoryList = null;
            // this.categoryFilterList = [];
            self.recordEditMode = false;
            // self.isInstantRentalChanged = false;

            // self.listingStatusFilter = getListingStatusFilter();

            // Load reference data
            // RefDataService.getCategories().$promise.then(function(resp) {
            //   self.categoryList = [];
            //   for (var item in resp) {
            //     !isNaN(resp[item].id) ? self.categoryList.push({id:resp[item].id,title:resp[item].name,name:resp[item].name}):'';
            //     !isNaN(resp[item].id) ? self.categoryFilterList.push({id:resp[item].id,title:resp[item].name,name:resp[item].name}):'';
            //   }
            // });
          }
        };

        ///////////////////////////////////////////////
  	    // ONLY LOAD THE LISTING IF IT IS SELECTED/VISIBLE
  	    ///////////////////////////////////////////////
        $scope.$watch('adminSubUserCtrl.loadOrNot', function(selectedToDisplay) {
          if (selectedToDisplay){
            // $translatePartialLoader.addPart('adminSubUserCtrl');
            self.originalData = [];
            self.loadSubscriptionUser();
            self.getTodayHKT();
          }
        });

        var self = this;

        //LOAD ALL SUBSCRIPTION
        this.loadSubscriptionUser = function(){
          usSpinnerService.spin('spinner');
          RentalService.getAllUserSubscriptionAdmin().$promise.then(function(resp){

            // PULL DATA OUT for filter to work
            for (var i = 0; i < resp.length; i++) {
              resp[i]._firstName= resp[i].user.firstName;
              resp[i]._lastName= resp[i].user.lastName;
              resp[i]._email= resp[i].user.email;
              if (resp[i].sub!=null) {
                resp[i]._itemName= resp[i].sub.itemName;
                resp[i]._starts= resp[i].sub.starts;
                resp[i]._nextContractRenewal= resp[i].sub.nextContractRenewal;
              }
            }

            self.tableParams = new NgTableParams({ sorting: { itemName: "desc"}}, {
               dataset: resp
            });

            self.originalData = angular.copy(resp);
            usSpinnerService.stop('spinner');
          },
          function(err) {
            usSpinnerService.stop('spinner');
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":adminSubUserCtrl:loadSubscriptionUser - Error: " + JSON.stringify(err.data.reasons)):'';
          });

        };
        this.getTodayHKT=function(){
          RentalService.getTodayHKT().$promise.then(function(resp){
            var today=resp.today;
            self.today=parseInt(today.substring(0,4)+today.substring(5, 7)+today.substring(8, 10));
          },
          function(err) {
            usSpinnerService.stop('spinner');
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":adminSubUserCtrl:getTodayHKT - Error: " + JSON.stringify(err.data.reasons)):'';
          });
        }
        //LOAD USER CREDIT RECORD
        self.listUserCredit= function(userId){
          usSpinnerService.spin('spinner');
          RentalService.listUserCreditAdmin(userId).$promise.then(function(resp){

            // Calculate status
            for (var i = 0; i < resp.length; i++) {
              if (resp[i].voided){
                resp[i]._status= "Voided";
              } else if (resp[i].expiryDate!=null && resp[i].expiryDate <= self.today ){
                resp[i]._status= "Expired";
              } else if (resp[i].redeemed){
                resp[i]._status= "Redeemed";
              } else if (resp[i].reserved){
                resp[i]._status= "Reserved";
              } else {
                resp[i]._status= "Available";
              }

              if (resp[i].fundingType==0){
                resp[i]._source= "Purchase";
              } else {
                resp[i]._source= "Subscription";
              }
            }

            self.tableParams2 = new NgTableParams({ sorting: { itemName: "desc"}}, {
               dataset: resp
            });

            usSpinnerService.stop('spinner');
          },
          function(err) {
            usSpinnerService.stop('spinner');
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":adminSubUserCtrl:listUserCredit - Error: " + JSON.stringify(err.data.reasons)):'';
          });

        };

        ///////////////////////////////////////////////
        // UPDATE INSTANT RENTAL STATUS
  	    ///////////////////////////////////////////////
        // this.instantRentalChange = function(row, rowForm){
        //   rowForm.$setDirty();
        //   row.instantRental = !row.instantRental;
        //   self.isInstantRentalChanged = !self.isInstantRentalChanged;
        //   angular.element(document.getElementById(row.id)).addClass('btn-danger');
        // }

        /////////////////////////////////////
  	    // CREATE INSTANT RENTAL STATUS FILTER
  	    /////////////////////////////////////
        // this.getInstantRentalFilter = function(){
        //   return [{id: 'true', title: 'Yes'},{id: 'false', title: 'No'}];
        // }


        /////////////////////////////////////
  	    // CREATE AND RETURN AN ARRAY LIST OF LISTING STATUS
  	    /////////////////////////////////////
        // function getListingStatusFilter(){
        //   var resultList = [];
        //   for (var item in productStatus.listingStatusMapping) {
        //     resultList.push({id:productStatus.getListingStatusDisplay(item),title:productStatus.getListingStatusDisplay(item),value:item});
        //   }
        //   return resultList;
        // }

        // self.cancel = function(row, rowForm) {
        //   var originalRow = resetRow(row, rowForm);
        //   angular.extend(row, originalRow);
        // }

        // // RETRIEVE PRODUCT BASED ON PRODUCT ID
        // self.showProduct = function(id) {
        //   $state.go('listing', {id: id});
        // };

        // self.del = function(row, rowForm) {
        //   ListingService.delete(row.id).$promise.then(function(resp){
        //     if (resp.deleted){
        //       $rootScope.enableLog ? $log.info($rootScope.UUID + ":adminSubUserCtrl:del - Successful"):'';
        //       self.recordEditMode = false;

        //       //change this row table status to delete for display purpose.
        //       row.status =  32;
        //       row._statusName = productStatus.getListingStatusDisplay(row.status);
        //       var originalRow = resetRow(row, rowForm);
        //       angular.extend(originalRow, row);

        //       //REMOVE THE ITEM FROM THE TABLE
        //       // _.remove(self.tableParams.settings().dataset, function(item) {
        //       //   return record === item;
        //       // });
        //       // self.tableParams.reload().then(function(data) {
        //       //   if (data.length === 0 && self.tableParams.total() > 0) {
        //       //     self.tableParams.page(self.tableParams.page() - 1);
        //       //     self.tableParams.reload();
        //       //   }
        //       // });
        //     }else{
        //       DialogAlertService.promptDialog('Error delete product (ID: '+row.id+'). Please try again later. ', '', '', '', 'Ok', '', '', false,'',"RED");
        //       $rootScope.enableLog ? $log.error($rootScope.UUID + ":adminSubUserCtrl:del - Error1: " + JSON.stringify(resp)):'';
        //     }
        //   },
        //   function(err){
        //     DialogAlertService.promptDialog('Error delete product (ID: '+row.id+'). Please try again later. ', '', '', '', 'Ok', '', '', false,'',"RED");
        //     $rootScope.enableLog ? $log.error($rootScope.UUID + ":adminSubUserCtrl:del - Error2: " + JSON.stringify(err)):'';
        //   });

        // }

        self.selectRow=function(row){
          self.showRecords=true;
          self.selected={};
          if (row.sub != null) self.selected.subscriptionId=row.sub.id;
          self.selected.userId=row.userId;
          self.selected.row=row;
          self.selected.email=row._email
          self.selected.firstName=row._firstName;
          self.selected.lastName=row._lastName;
          self.selected.showCancelButton=(self.today < row._nextContractRenewal)?true:false;
          self.selected.showCancelSubStatus=false;
          self.selected.numCreditVoided=0;
          self.showConfirmButton=false;
          self.showConfirmButton2=false;
          self.selected.showTryingStatus=false;
          self.selected.errMsg=null;
          self.listUserCredit(row.userId);
        }
        self.voidCredit=function(row){
          row._voidStatus='Trying...';
          RentalService.voidCreditAdmin(row.id).$promise.then(function(resp){
            row._status='Voided';
            row._voidStatus="[Done]"
            $rootScope.enableLog ? $log.info($rootScope.UUID + ":adminSubUserCtrl:voidCredit - Successfully"):'';
            usSpinnerService.stop('spinner');
          },
          function(err){
            row._voidStatus="[Err]"
            usSpinnerService.stop('spinner');
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":adminSubUserCtrl:voidCredit - failed: " + JSON.stringify(err)):'';
            self.recordEditMode = false;
          });
        }
        self.cancelSubVoidCredit=function(subscriptionId){
          self.selected.showTryingStatus=true;
          self.showConfirmButton=false;
          self.selected.errMsg=null;
          RentalService.cancelSubscriptionAndVoidCreditAdmin(subscriptionId).$promise.then(function(resp){
            $rootScope.enableLog ? $log.info($rootScope.UUID + ":adminSubUserCtrl:cancelSub- Successfully"):'';
            self.selected.numCreditVoided=resp.numCreditVoided;
            self.selected.showTryingStatus=false;
            self.selected.showCancelSubStatus=true;
            self.selected.showCancelButton=false;
            // reload both tables
            self.listUserCredit(self.selected.userId);
            self.selected.row._nextContractRenewal="Today"
            usSpinnerService.stop('spinner');
          },
          function(err){
            self.selected.showTryingStatus=false;
            usSpinnerService.stop('spinner');
            self.selected.errMsg=JSON.stringify(err);
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":adminSubUserCtrl:save - cancelSub: " + JSON.stringify(err)):'';
            self.recordEditMode = false;
          });
        }
        self.cancelSubOnly=function(subscriptionId){
          self.selected.showTryingStatus=true;
          self.showConfirmButton2=false;
          self.selected.errMsg=null;
          RentalService.cancelSubscriptionOnlyAdmin(subscriptionId).$promise.then(function(resp){
            $rootScope.enableLog ? $log.info($rootScope.UUID + ":adminSubUserCtrl:cancelSub- Successfully"):'';
            self.selected.numCreditVoided='No ';
            self.selected.showTryingStatus=false;
            self.selected.showCancelSubStatus=true;
            self.selected.showCancelButton=false;
            // reload both tables
            self.listUserCredit(self.selected.userId);
            self.selected.row._nextContractRenewal="Today"
            usSpinnerService.stop('spinner');
          },
          function(err){
            self.selected.showTryingStatus=false;
            usSpinnerService.stop('spinner');
            self.selected.errMsg=JSON.stringify(err);
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":adminSubUserCtrl:save - cancelSub: " + JSON.stringify(err)):'';
            self.recordEditMode = false;
          });
        }
        function resetRow(row, rowForm){
          row.isEditing = false;
          rowForm.$setPristine();
          self.tableTracker.untrack(row);
          return _.find(self.originalData, function(r){
            return r.id === row.id;
          });
        }


        /////////////////////////////////////////////////////
        // UPDATE THE TAG/PRICE AND DISCOUNT RATE
        /////////////////////////////////////////////////////
        // self.updatePrice = function(row,rowForm){

        //   //THE PRODUCT HAD ORIGINAL PRICE AND THE CHANGED TAG PRICE IS > ORIGINAL PRICE
        //   //RESTORE THE TAG PRICE
        //   var originalProduct = _.find(self.originalData, function(r){
        //     return r.id === row.id;
        //   });
        //   if (row._tagPrice > originalProduct.price && row.discountRate > 0 || row._tagPrice < 2000){
        //     row._tagPrice = originalProduct._tagPrice;
        //     rowForm.price.$setPristine();
        //     DialogAlertService.promptDialog('Tag price must larger then $2000 but less then original price: $' + originalProduct.price, '', '', '', '', '', '', true, '', 'RED');
        //   }

        //   //UPDATE THE DISCOUNT RATE IF THE PRODUCT HAD DISCOUNT RATE EXISTED (EG. HAVE TAG PRICE AND ORIGINAL PRICE)
        //   if (row.discountRate){
        //     row.discountRate = priceUtilities.setDiscount(originalProduct.price , row._tagPrice);
        //     row.price = row._tagPrice / (1-row.discountRate);
        //   }else{
        //     row.price = row._tagPrice;
        //   }
        //   row._rentalPrice = priceUtilities.getRentalPrice(row.price,row.discountRate);
        // }


        self.save = function(row, rowForm) {
          usSpinnerService.spin('spinner');

          // var promises = [];
          // var deferred = $q.defer();

          // if (self.isInstantRentalChanged && (row.status == 6 || row.status == 8)){
          //   promises.push(deferred.promise);
          //   row.status = row.status == 6 ? 8:6;
          //   AdminService.changeProductStatus({productID:row.id,status: row.status}).$promise.then(function(resp){
          //     self.isInstantRentalChanged = false;
          //     deferred.resolve();
          //   },function(err){
          //     deferred.reject("Error: Changing instant rental indicator.");
          //   })
          // }

          // $q.all(promises).then(function() {
            RentalService.updateSubscriptionPricingAdmin(row.id,row).$promise.then(function(resp){
              $rootScope.enableLog ? $log.info($rootScope.UUID + ":adminSubUserCtrl:save - Successfully"):'';
              self.recordEditMode = false;

              // row._statusName = productStatus.getListingStatusDisplay(row.status);
              var originalRow = resetRow(row, rowForm);
              angular.extend(originalRow, row);
              usSpinnerService.stop('spinner');
            },
            function(err){
              usSpinnerService.stop('spinner');
              DialogAlertService.promptDialog('Error updating product (ID: '+row.id+'). Please try again later. ', '', '', '', 'Ok', '', '', false,'',"RED");
              $rootScope.enableLog ? $log.error($rootScope.UUID + ":adminSubUserCtrl:save - Error: " + JSON.stringify(err)):'';
              self.recordEditMode = false;
            });
          // },function(err){
          //   usSpinnerService.stop('spinner');
          //   DialogAlertService.promptDialog('Error updating product (ID: '+row.id+'). Please try again later. ', '', '', '', 'Ok', '', '', false,'',"RED");
          //   $rootScope.enableLog ? $log.error($rootScope.UUID + ":adminSubUserCtrl:save - Error: " + JSON.stringify(err)):'';
          //   self.recordEditMode = false;
          // });
        }
      }]
    })
})();

'use strict';

(function(){
  angular.module('coutureApp')
  .component('adminSettings', {
    templateUrl: 'scripts/components/admin-settings/admin-settings.html',
    controllerAs : 'adminSettingsCtrl',
      bindings: {
        loadOrNot: '<'
      },
      controller: ["$scope", "$rootScope", "USER_ROLES", "AuthService", "RentalService", "NgTableParams", "ProductService", "ListingService", "priceUtilities", "RefDataService", "$state", "DialogAlertService", "$log", "$filter", "$translate", "$translatePartialLoader", "usSpinnerService", "productStatus", "AdminService", "$q", "utilities", "CONFIG", function($scope,$rootScope,USER_ROLES,AuthService,RentalService,NgTableParams,ProductService,ListingService,priceUtilities
        ,RefDataService,$state,DialogAlertService, $log, $filter,$translate,$translatePartialLoader,usSpinnerService,productStatus
        ,AdminService,$q,utilities, CONFIG) {

        var self = this;
        this.$onInit = function(){
          self.areaName = CONFIG.AREAS;
          self.sgShippingAddress = {};
          self.sgShippingAddress.country = CONFIG.SINGAPORE;
          self.hkShippingAddress = {};
          self.hkShippingAddress.country = CONFIG.HONG_KONG;
          self.shippingAddress = {};
          self.pickupAddress = {};

          if (!$rootScope.isLogon || !AuthService.isAuthorized(USER_ROLES.admin)){
            if(utilities.isShowMainRegion()){
              $state.go('main');
            } else {
              $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
            }
          }else{
            $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - adminSettingsCtrl"):'';
            self.retrieveHubAddress();
          }
        };

        self.setSelected = function(type,selectedValue) {
          switch (type) {
            case 'sgShippingCountry':
              self.sgShippingAddress.country = selectedValue.name;
              self.disable_sgShipping_CityDDL = selectedValue.name != CONFIG.HONG_KONG ? true:false;
              break;
            case 'hkShippingCountry':
              self.hkShippingAddress.country = selectedValue.name;
              self.disable_hkShipping_CityDDL = selectedValue.name != CONFIG.HONG_KONG ? true:false;
              break;
            case 'SG_SHIPPING_ADDRESS':
              self.sgShippingAddress.city = selectedValue.name;
              break;
            case 'HK_SHIPPING_ADDRESS':
              self.hkShippingAddress.city = selectedValue.name;
              break;
          }
        }

        self.updateAddress = function(address) {
          if(!self.validateAddress(address)) {
            self.error_address = "Invalid address information.";
          } else {
            AdminService.updateAddress(address).$promise.then(
              function(resp){
                DialogAlertService.promptDialog('Hub address updated successfully. ', '', '', '', 'GENERAL.LABEL.OK', '', '', false);
              }, function(err){
                  $rootScope.enableLog ? $log.error($rootScope.UUID + ":adminSettingsCtrl:updateAddress - Error:" + err):'';
                  DialogAlertService.promptDialog('Error updating the hub address. Please try again later. ', '', '', '', 'GENERAL.LABEL.OK', '', '', false,'',"RED");
              }
            );
          }
        }

        self.retrieveHubAddress = function() {
          AdminService.retrieveHubAddress().$promise.then(
            function(resp){
              var sgHub = resp.filter(a => a.country === CONFIG.SINGAPORE);
              var hkHub = resp.filter(a => a.country === CONFIG.HONG_KONG);
              if(sgHub.length > 0){
                self.sgShippingAddress = sgHub[0];
              } else {
                self.sgShippingAddress = {};
                self.sgShippingAddress.country = CONFIG.SINGAPORE;
              }

              if(hkHub.length > 0){
                self.hkShippingAddress = hkHub[0];
              } else {
                self.hkShippingAddress = {};
                self.hkShippingAddress.country = CONFIG.HONG_KONG;
              }
              
            }, function(err){
                $rootScope.enableLog ? $log.error($rootScope.UUID + ":adminSettingsCtrl:updateAddress - Error:" + err):'';
                DialogAlertService.promptDialog('Error retrieving the hub address. Please try again later. ', '', '', '', 'GENERAL.LABEL.OK', '', '', false,'',"RED");
            }
          );
        }

        this.validateAddress = function(address){
          var valid = true;
          if (!address){
            return false;
          }

          if (!address.address1 || !address.country || !address.city){
            return false;
          }

          return valid;
        }

      }]
  })
})();

'use strict';

(function(){
  angular.module('coutureApp')
  .component('payoutRequests', {
    templateUrl: 'scripts/components/payout-requests/payout-requests.html',
    controllerAs : 'ctrl',
      bindings: {
        loadOrNot: '<'
      },
      controller: ["$scope", "$rootScope", "NgTableParams", "priceUtilities", "$log", "usSpinnerService", "PayoutService", "$uibModal", "utilities", function($scope,$rootScope,NgTableParams,priceUtilities, $log, usSpinnerService,PayoutService, $uibModal, utilities) {

        var self = this;
        this.$onInit = function(){
          self.statusFilter = utilities.getPayoutStatusFilter();
        };

        $scope.$watch('ctrl.loadOrNot', function(selectedToDisplay) {
          if (selectedToDisplay){
            self.originalData = [];
            self.loadHistory();
          }
        });

        this.loadHistory = function() {
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - payoutRequests#loadHistory"):'';
          
          self.tableParams = new NgTableParams({ 
            page: 1,
            count: 15,
            sorting: { 
              id: "DESC"
            },
          }, {
            counts:[],
            getData: function(params) {
              usSpinnerService.spin('spinner');
              var tableFilters = params._params.filter;
              var filterParams = {};
              var tableParams = params._params;
              var sort = params._params.sorting;
              var sortType = null ;
              var sortDir = null;
              if(sort.payoutReferenceNumber){
                sortType = "referenceNumber";
                sortDir = sort.payoutReferenceNumber;
              } else if(sort.requestedCurrency){
                sortType = "requestedCurrency";
                sortDir = sort.requestedCurrency;
              } else if(sort.requestedAmount){
                sortType = "requestedAmount";
                sortDir = sort.requestedAmount;
              }  else if(sort.status){
                sortType = "status";
                sortDir = sort.status;
              } else {
                sortType = "id";
                sortDir = "DESC";
              }
  
              filterParams.page = tableParams.page;
              filterParams.sortType = sortType;
              filterParams.sortDirection = sortDir;
  
              filterParams.referenceNumber = tableFilters.payoutReferenceNumber ? tableFilters.payoutReferenceNumber : null;
              filterParams.currency = tableFilters.requestedCurrency ? tableFilters.requestedCurrency : null;
              filterParams.amount = tableFilters.requestedAmount ? tableFilters.requestedAmount : null;
              filterParams.status = tableFilters.status ? tableFilters.status : null;
              var history = [];
              return PayoutService.getAllPayoutHistory(filterParams).$promise.then(function(resp) {
                $scope.data = resp;
                var totalRecordCount, totalPageCount;
  
                $scope.data.forEach(function(item, index, arr) {
                  if (!item['searchResult']) {
                    item._page = self.currentPageCount;
                  } else {
                    totalRecordCount = item['searchResult']['totalRecordCount'];
                    totalPageCount = item['searchResult']['totalPageCount'];
                    arr.pop();
                  }
                });
  
                for (var i = 0; i < $scope.data.length; i++) {
                  var tempResponse = $scope.data[i];
                  tempResponse._requestedDate = moment(new Date(tempResponse.requestedDate)).format('D/M/YYYY');
                  tempResponse._currencyAmount = priceUtilities.formatWithCountryCode(tempResponse.requestedAmount, tempResponse.requestedCurrency);
                  tempResponse._paymentDate = tempResponse.status == "PAID" ? moment(new Date(tempResponse.paidDate)).format('D/M/YYYY') : "";
                  history.push(tempResponse);
                }
  
                history.sort(function(a, b){return b.requestedDate-a.requestedDate;});
  
                usSpinnerService.stop('spinner');
                params.total(totalRecordCount);
                return history;
              },
              function(err) {
                usSpinnerService.stop('spinner');
                $rootScope.enableLog ? $log.error($rootScope.UUID + ":payoutRequests#loadHistory - Error: " + JSON.stringify(err.data)):'';
              });
            }
          });
  
        }

        self.getPayoutRequest = function(row){
          var modalInstance = $uibModal.open({
            templateUrl: 'views/modals/payout-request-confirmation.html',
            controller: ["$scope", "$rootScope", "priceUtilities", function($scope, $rootScope, priceUtilities) {
              var self = this;
              $scope.submitted = false;
              $scope.listingView = false;
              PayoutService.getPayoutDetails(row.payoutReferenceNumber).$promise.then(function(resp) {
                $scope.payoutdetails = resp;
                $scope.requestedAmount = priceUtilities.currencyFormat(resp.selectedAmount);
              });

              $scope.approveRequest = function() {
                $scope.submitted = true;
                $scope.message = "Payout request is processing....";
                PayoutService.approvePayout(row.payoutReferenceNumber).$promise.then(function(resp) {
                  $scope.message = "Payout request has been approved.";
                  row.paidAmount = resp.paidAmount;
                  row.paidCurrency = resp.paidCurrency;
                  row.status = resp.status;
                },
                function(err) {
                  if (err.data){
                    switch (err.data.reasons[0].code) {
                      case "INSUFFICIENT_BALANCE":
                        $scope.message = err.data.reasons[0].message;
                        break;
                      default:
                        $scope.message = "Unable to approve payout.";
                    }
                  } else {
                    $scope.message = "Unable to approve payout.";
                  }
                  $rootScope.enableLog ? $log.error($rootScope.UUID + ":payoutRequests#approveRequest - Error: " + JSON.stringify(err.data)):'';
                });
              }

              $scope.declineRequest = function() {
                $scope.submitted = true;
                $scope.message = "Payout request is processing....";
                PayoutService.declinePayout(row.payoutReferenceNumber).$promise.then(function(resp) {
                  row.status = resp.status;
                  $scope.message = "Payout request has been declined.";
                },
                function(err) {
                  $scope.message = "Unable to decline payout.";
                  $rootScope.enableLog ? $log.error($rootScope.UUID + ":payoutRequests#declineRequest - Error: " + JSON.stringify(err.data)):'';
                });
              }
            }]
          });
    
          
        }

      }]
  })
})();

'use strict';

/**
 * @ngdoc function
 * @name coutureApp.controller:BuySubCtrl
 * @description
 * # BuySubCtrl
 * Controller of the coutureApp
 */
angular.module('coutureApp')
  .controller('BuySubCtrl', ["Session", "$scope", "$rootScope", "$q", "$state", "DialogAlertService", "utilities", "$log", "$location", "AuthService", "RentalService", "CONFIG", "UserService", "RefDataService", "usSpinnerService", "$translatePartialLoader", "CartService", "$anchorScroll", "dateUtilities", "priceUtilities", "$filter", "CalendarService", "$window", "envService", "$http", "localStorageService", function(Session, $scope, $rootScope, $q, $state, DialogAlertService, utilities, $log, $location, AuthService, RentalService,CONFIG,
    UserService, RefDataService, usSpinnerService, $translatePartialLoader, CartService, $anchorScroll,dateUtilities,priceUtilities,$filter,CalendarService, $window, envService,$http, localStorageService) {

    var self = this;
    self.isShipToHKOnly = CONFIG.SHIPPING_TO_HONG_KONG_ONLY;
    self.countries = RefDataService.getCountryList();

    this.$onInit = function() {
      loadCountryList();
      $rootScope.tempToken=null;
      self.subscription={
        "id": $state.params.id,
        "unit":1,
        "itemName": "",
        "numCredit": 1,
        "price": 0,
        "expiryDate": 0,
        "isBuyCredit": null,
        "type":$state.params.type,
        "subscriptionRef":null,
        "subscriptionStarts":"",
        "totalPrice": 0,
        "finalPriceReturn":{},
        "nextBillingDate":null,
        "nextBillingCharge":0,
        "numFreeMonths":0,
        "numContractMonths":0
    }
      self.subscription.isBuyCredit=false;

      this.isOrderSummaryActive = true;
      this.isShippingActive = true;
      this.isItemsActive = true;

      this.productIndex = 0;

      // Double submit locks
      self.lk_checkout = false;
      self.acceptedTnC = false;
      self.editShippingToggle = false;
      self.billingAddress = {country:CONFIG.DEFAULT_COUNTRY};
      self.stReq = {};
      self.isHideCreditCardDetails = true;
      self.isAcceptedTC = false;
      if (self.isShipToHKOnly){
        self.shippingAddress = {country:CONFIG.HONG_KONG};
      }else{
        self.shippingAddress = {country:CONFIG.DEFAULT_COUNTRY};
      }

      self.rentalPrice = 0;
      self.giftCardSaving = 0;
      self.giftCardDesc='';
      self.rentalProtectionFee = 0;
      self.shippingFee = 0;
      self.totalDue = 0;

    // DEBUG for subscription-confirmation.component.js - uncomment to test the page without going through checkout process
      //     self.subscription.itemName="StyleCarousel 1-Credit Pack";
      //     self.subscription.numCredit=3;
      //     self.subscription.totalPrice=5400;
      //     self.subscription.price=1800;
      //     self.subscription.unit=3;
      // if ( $state.params.type=='credit'){
      //     self.subscription.totalPrice=5400;
      //     self.subscription.price=1800;
      //     self.subscription.unit=3;
      //     self.subscription.finalPriceReturn={"pricingId":1, "totalPriceAfterDiscount":1700, "promoPubDesc":""};
      //     DialogAlertService.openSubscriptionConfirmation("Cred-1234","",self.subscription,function(){
      //     });
      //   } else {
      //     self.subscription.totalPrice=1800;
      //     self.subscription.price=1800;
      //     self.subscription.unit=1;
      //     self.subscription.finalPriceReturn={"pricingId":4, "listPrice":1800, "finalMonthlyPrice":[100], "promoPubDesc":"1st Month Free"};
      //     DialogAlertService.openSubscriptionConfirmation("Sub-1234","20200630",self.subscription,function(){
      //     });
      //   }
    // DEBUG
      self.error_shippingInfo = "Missing Shipping Info";
      self.error_shippingAddress = "Missing Shipping Address";
      self.error_billingAddress = "Missing Billing Address";
      self.error_paymentInfo = "Missing Payment Info";
      self.error_termsCondition = "You must accept Terms of Service";
      self.error_deliveryDate = "You must select delivery date";
      self.error_txn = null;
      self.is_recurring_error = false;
      self.recurring_error_line_1 = null;
      self.recurring_error_line_2 = null;
      self.error_ship_bill_info = null;
      self.areaName = CONFIG.AREAS;
      self.proudct_currency = priceUtilities.getCurrency();
      self.promoCode = null;

      self.selectedCheckoutProductsMissingDate = [];
      self.returnedCalculatedPrice = null;

      try {
        if ($location.path().includes('buy')) {
          var id = $state.params.id;
          var redirectId = null;
          if($rootScope.geoLocation.country === "SG"){
            switch(id) {
              case 3:
                redirectId = 22;
                break;
                case 4:
                  redirectId = 21;
                  break;
                  case 5:
                    redirectId = 16;
                    break;
                    case 15:
                      redirectId = 14;
                      break;
                        default:
                          redirectId = id;
                          break
            }
          } else {
            switch(id) {
              case 22:
                redirectId = 3;
                break;
                case 21:
                  redirectId = 4;
                  break;
                  case 16:
                    redirectId = 5;
                    break;
                    case 14:
                      redirectId = 15;
                      break;
                      default:
                        redirectId = id;
                        break;
            }
          }
          $state.go('buy-subscription-multi-region', {country: $rootScope.geoLocation.country, id: redirectId});
          self.initializeCheckoutPage(self.subscription.id);
          self.countries = RefDataService.getCountryList();

          // Used for data passing between update payment and checkout
          if ($state.params.ctx) {
            self.ctx = $state.params.ctx;
          }
        }
      }catch(err) {
        if(utilities.isShowMainRegion()){
          $state.go('main');
        } else {
          $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
        }
      }
    }

    $translatePartialLoader.addPart('checkout');

    /////////////////////////////////////////
    // SELECT THE PRE-DEFINED CITY FROM THE DROP DOWN LIST.
    /////////////////////////////////////////
    // this.setSelected = function(type,selectedValue) {
      // switch (type) {
      //   case 'BILLING_ADDRESS':
      //     self.billingAddress.city = selectedValue.name;
      //     break;
      //   case 'SHIPPING_ADDRESS':
      //     self.shippingAddress.city = selectedValue.name;
      //     break;
      // }
    // }

    //////////////////////////////////////////
    //SORT THE ITEM IN THE CART BASED ON START_DATE
    //////////////////////////////////////////
    $scope.min = function(arr) {
      return $filter('min')($filter('map')(arr, 'selectedDate.START_DATE'));
    }

    /**************************
    //CHANGE THE RENTAL DATE
    **************************/
    // this.changeDate = function(product) {

    //   self.error_txn = null;

    //   var rental = {
    //     product: null,
    //     selectedDate: null
    //   };

    //   //arg1 = (null=no CheckoutButton)
    //   CalendarService.openCalendar(null, function() {
    //     rental.product = product;
    //     if (rental.product !== null && rental.selectedDate != null) {
    //       //REMOVE THE PRODUCT ID WHICH HAVE NO DATE SELECTED IN THE ERROR DISPLAY ARRAY.
    //       if (self.selectedCheckoutProductsMissingDate.indexOf(product.id) != -1){
    //         self.selectedCheckoutProductsMissingDate.splice(self.selectedCheckoutProductsMissingDate.indexOf(product.id),1)
    //       }
    //       utilities.replaceItemInArray(rental, $rootScope.cc.cart);
    //       //STORE PRODUCT ID IN LOCAL SERVICE
    //       Session.updateCart(product.id);
    //       //STORE PRODUCT ID IN REMOTE SERVICE
    //       CartService.addCart(product.id,rental.selectedDate.START_DATE,rental.selectedDate.RETURN_DATE);
    //     }
    //   }, function(date) {

    //     rental.selectedDate={'START_DATE':null, 'RETURN_DATE':null}
    //     rental.selectedDate.START_DATE = moment(date).format('x');
    //     rental.selectedDate.RETURN_DATE=moment(rental.selectedDate.START_DATE).add(CONFIG.DEFAULT_RENTAL_DURATION,'d').format('x');
    //   }, utilities.getAvailableDates(product.status));


    // };

    /**************************
    //SET THE SHIPPING COUNTRY AS PER THE DROP DOWN LIST
    **************************/
    this.setShippingCountry = function(inputCountry) {
      self.shippingAddress.country = null;
      for (var index in self.countries) {
        if (self.countries[index].name === inputCountry) {
          self.shippingAddress.country = self.countries[index].name;
          break;
        }
      }
    }

    /////////////////////////////////////////
    //COPY BILLING ADDRESS TO ADDRESS LOGIC
    /////////////////////////////////////////
    this.isCopyShippingInfoToBillingInfo = function() {
      return false;
    }

    /**************************
    //COPY THE SHIPPING ADDRESS TO BILLING ADDRESS
    **************************/
    this.copyShippingAddressToBillingAddress = function() {
      self.billingAddress = angular.copy(self.shippingAddress);
      self.disable_Billing_CityDDL = self.billingAddress.country != CONFIG.HONG_KONG ? true:false;
    }

    /**************************
    //COPY THE BILLING ADDRESS TO SHIPPING ADDRESS 
    **************************/
   this.copyBillingAddressToShippingAddress = function() {
    self.shippingAddress = angular.copy(self.billingAddress);
    self.disable_Shipping_CityDDL = self.shippingAddress.country != CONFIG.HONG_KONG ? true:false;
  }
    /**************************
    //GET THE PICKUP DATE
    **************************/
    // this.getPickupDate = function() {
    //   return utilities.getPickupDate($rootScope.cc.cart[self.productIndex]);
    // }

    /**************************
    //GET THE RETURN DATE
    **************************/
    // this.getReturnDate = function() {
    //   return utilities.getReturnDate($rootScope.cc.cart[self.productIndex]);
    // }

    /**************************
    //ADD SPECIAL LOGIC WHEN USER ENTER OTHER BRAND, THE req_listing WILL REMAINS '-- OTHER BRAND --'
    //BUT THE ACTUAL BRAND WILL BE STORED IN TAG. HOWEVER IT WILL NOT GOING TO DISPLAY ON SCREEN.
    **************************/
    this.getDisplayBrand = function(product){
      return utilities.getCustomBrandName(product);
    }

    /**************************
    //UPDATE PROMOTION CODE TO THE PRICING
    **************************/
    this.applyPromo = function(){
      self.error_txn = null;
      self.promoCode = $scope.temp_promoCode;
      reCalculateSubscriptionPricing();
    }

    /**************************
    //GET PRODUCT DISCOUNT VALUE
    **************************/
    this.getDiscountAmount = function(product){
      if (product && self.returnedCalculatedPrice){
        return self.returnedCalculatedPrice.products.filter(p=> p.productSummary.productId == product.id).map(p=> p.rentalOrderBreakdown.originalWeeklyRentalFee - p.rentalOrderBreakdown.weeklyRentalFee)[0];
      }else{
        return 0;
      }
    }


    /**************************
    //THE CHECKOUT PAGE INITIALIZE METHOD, LOAD THE SPECIFIC ITEM IN THE CART AND PREPARE THE PAGE FOR DISPLAY
    **************************/
    this.initializeCheckoutPage = function(id) {

      // self.promoCode = $rootScope.cc.cart.filter(f=> f.product.id == id)[0].product._promoPrice.promoCode;
      // $scope.temp_promoCode = self.promoCode;

      // //PRE-SELECTED ALL PRODUCTS IN CART
      // $rootScope.cc.cart.filter(p=> p.product._selectedToCheckout == undefined || p.product._selectedToCheckout == false)
      // .map(item=> item.product._selectedToCheckout = true);

      usSpinnerService.spin('spinner');
      // Do a pre-rental check.  Make sure user has credit card and shipping address.
      if (AuthService.isAuthenticated()){
        RentalService.preCheck().$promise.then(
          function(resp) {

            var ctx = self.ctx || {};
            self.pid = id;
            ctx.last4 = resp.last4;
            self.last4=resp.last4;

            self.isHideAccountInfo=true;

            if (resp.shippingAddress){
              ctx.shippingAddress = resp.shippingAddress;
              self.shippingAddress = ctx.shippingAddress;
            }else{
              //NEWLY REGISTER CUSTOMER WITHOUT ENTER DELIVERY ADDRESS
              resp.shippingAddress = {"phone":"","address1":"","address2":"","address3":"","city":"","district":"","country":CONFIG.DEFAULT_COUNTRY,"postalCode":"","type":1};
              self.shippingAddress = resp.shippingAddress;
            }
            if (resp.billingAddress){
              ctx.billingAddress = resp.billingAddress;
              self.billingAddress = ctx.billingAddress;
            }else{
              //NEWLY REGISTER CUSTOMER WITHOUT ENTER DELIVERY ADDRESS
              resp.billingAddress = angular.copy(resp.shippingAddress);
              resp.billingAddress.type = CONFIG.ADDRESS_TYPE_BILLING;
              self.billingAddress = angular.copy(self.shippingAddress);
              self.billingAddress.type = CONFIG.ADDRESS_TYPE_BILLING;
            }
            //CC-519 SHIPPING ONLY TO HK
            if (self.isShipToHKOnly && self.shippingAddress.country != CONFIG.HONG_KONG){
              self.shippingAddress.country = CONFIG.HONG_KONG;
              self.shippingAddress.city = self.areaName[0].name;
            }

            if (resp.hasBilling) {
              self.hasBilling = true;
              self.isHideCreditCardDetails = true;
            } else {
              self.hasBilling = false;
              self.isHideCreditCardDetails = false;
            }

            self.shippingAddress.firstname = $rootScope.user.firstName;
            self.shippingAddress.lastname = $rootScope.user.lastName;

            self.disable_Shipping_CityDDL = self.shippingAddress.country != CONFIG.HONG_KONG ? true:false;
            self.disable_Billing_CityDDL = self.billingAddress.country != CONFIG.HONG_KONG ? true:false;

            usSpinnerService.stop('spinner');
          },
          function(err) {
            usSpinnerService.stop('spinner');
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":BuySubCtrl:checkout - Error: " + err):"";
          }
        );
      } else {
            var ctx = self.ctx || {};
            self.pid = id;
            ctx.last4 = null;
            self.last4= null;

            self.shippingAddress = {"phone":"","address1":"","address2":"","address3":"","city":"","district":"","country":CONFIG.DEFAULT_COUNTRY,"postalCode":"","type":1};

            //CC-519 SHIPPING ONLY TO HK
            if (self.isShipToHKOnly && self.shippingAddress.country != CONFIG.HONG_KONG){
              self.shippingAddress.country = CONFIG.HONG_KONG;
              self.shippingAddress.city = self.areaName[0].name;
            }

            self.hasBilling = false;
            self.isHideCreditCardDetails = false;
            self.disable_Shipping_CityDDL = self.shippingAddress.country != CONFIG.HONG_KONG ? true:false;
            self.disable_Billing_CityDDL = self.billingAddress.country != CONFIG.HONG_KONG ? true:false;
            self.isHideAccountInfo=false;
            self.account={"email": "","password": "", "password2": ""};

      }
      // Fill out subscription item details
      RentalService.getItemPricing(id,self.subscription.isBuyCredit).$promise.then(
        function(resp) {
          self.subscription.itemName=resp.itemName;  // StylePass 3 Month
          self.subscription.numCredit=resp.numCredit;
          self.subscription.price=resp.price; // 1,950
          self.subscription.totalPrice=resp.price * self.subscription.unit;
          self.subscription.expiryDate=resp.expiryDate;
          self.subscription.numFreeMonths=resp.numFreeMonths;
          self.subscription.numContractMonths=resp.numContractMonths;
          self.totalDue=self.subscription.totalPrice;
          self.subscription.country = resp.country;
          self.subscription.recurring = resp.recurring;

          self.getNextMonthHKT();

          //added only for buy sub. Currently only applicable for buy subscription.
          if(resp.country == 'SG') {
            $window.Stripe.setPublishableKey(envService.read('STRIP_KEY_SG'));
          }

          usSpinnerService.stop('spinner');
        },
        function(err) {
          usSpinnerService.stop('spinner');
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":BuySubCtrl:checkout - Error: " + err):"";
          //$state.go('main');  // quite on err e.g. credit/:id where id is a subscription item
          if(utilities.isShowMainRegion()){
            $state.go('main');
          } else {
            $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
          }
        }
      );
      reCalculateSubscriptionPricing();
    }

    this.getNextMonthHKT=function(){
      RentalService.getNextMonthHKT().$promise.then(function(resp){
        var nextMonth=resp.nextMonth;
        // self.subscription.nextBillingDate=parseInt(nextMonth.substring(0,4)+nextMonth.substring(5, 7)+nextMonth.substring(8, 10));
        self.subscription.nextBillingDate=nextMonth.substring(6, 8)+"/"+nextMonth.substring(4, 6); //dd-mm
      },
      function(err) {
        usSpinnerService.stop('spinner');
        $rootScope.enableLog ? $log.error($rootScope.UUID + ":BuySubCtrl:getNextMonthHKT- Error: " + JSON.stringify(err.data.reasons)):'';
      });
    }
    /**************************
    //SCROLL BACK TO TOP ONCE THE CHECKOUT HAS BEEN COMPLETED
    **************************/
    this.GotoTop = function(){
      $anchorScroll('top');
    }

    function comparer(otherArray){
      return function(current){
        return otherArray.filter(function(other){
          return other.value == current.value && other.display == current.display
        }).length == 0;
      }
    }

    /**************************
    //MAIN CHECKOUT PROCESS
    **************************/
    this.preparePurchase = function() {

      self.error_txn = null;
      self.error_ship_bill_info = null;
      self.lk_checkout = true;
      self.unitReset();
      self.GotoTop();

      usSpinnerService.spin('spinner');

      if (!self.isHideCreditCardDetails) {
        self.createTempAccount().then(function(resp){
          self.validateCard().then(function(resp){
            $rootScope.enableLog ? $log.info($rootScope.UUID + ":BuySubCtrl:preparePurchase - Saved card"):"";
            self.submitBuyRequest();
          },function(err){ // card related problem 
              try {
                if (!self.error_txn){
                  self.error_txn = err.data && err.data.reasons && err.data.reasons[0] ? $filter('translate')("GENERAL.ERROR."+ err.data.reasons[0].code) : $filter('translate')("GENERAL.ERROR.UNABLE_TO_PROCESS_PAYMENT");
                }
              } catch (err) {
                self.error_txn = $filter('translate')("GENERAL.ERROR.UNABLE_TO_PROCESS_PAYMENT");
              } finally {
                $rootScope.enableLog ? $log.error($rootScope.UUID + ":BuySubCtrl:preparePurchase - Err No card saved" + err):"";
                self.lk_checkout = false;
                usSpinnerService.stop('spinner');
              }
            });
        }, function(err){ // temp account creation problem
          try {
            if (!self.error_txn){
              self.error_txn = err.data && err.data.reasons && err.data.reasons[0] ? $filter('translate')("GENERAL.ERROR."+ err.data.reasons[0].code) : "We are unable to accept your request for the moment. Please try again later.";
            }
          } catch (err) {
            self.error_txn = "We are unable to accept your request for the moment. Please try again later.";
          } finally {
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":BuySubCtrl:preparePurchase - Err No temp account created" + err):"";
            self.lk_checkout = false;
            usSpinnerService.stop('spinner');
          }
        });
      }else{
        $rootScope.enableLog ? $log.info($rootScope.UUID + ":BuySubCtrl:preparePurchase - Other flow no card change and just submit request"):"";
        self.submitBuyRequest();
      }
    };


    /**************************
    //FINALIZE SHIPPING AND THE RENTAL PROCESS
    **************************/
    self.submitBuyRequest = function(){
      self.recurring_error_line_1 = null;
      self.recurring_error_line_2 = null;
      self.is_recurring_error = false;
      var promises = [];
      // no shipping form will be present; only save it if no shipping address found 
      var updateShippingAddress = !self.isHideCreditCardDetails && self.billingAddress.address1 
      // var updateShippingAddress = $scope.checkoutForm.shipAdd1.$dirty || $scope.checkoutForm.shipAdd2.$dirty ||
      //   $scope.checkoutForm.shipCountry.$dirty || $scope.checkoutForm.shipCity.$dirty || $scope.checkoutForm.shipDistrict.$dirty ||
      //   $scope.checkoutForm.shipPhone.$dirty || $scope.checkoutForm.shipPostalCode.$dirty;

      if(updateShippingAddress) {
        if (!AuthService.isAuthenticated()) {  
          self.copyBillingAddressToShippingAddress();
          self.shippingAddress.tempToken=$rootScope.tempToken;
        }
        promises.push(UserService.updateAddress(self.shippingAddress).$promise);
      }

      $q.all(promises).then(function() {
        // RentalService.preparePurchaseMultiItems({'products':selectedCheckoutProducts,'promo':self.promoCode}).$promise.then(function(resp){
        RentalService.buySubscriptionOrCreditItem(self.subscription.id, self.promoCode, self.subscription.unit, self.subscription.isBuyCredit).$promise.then(function(resp){
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":BuySubCtrl:submitBuyRequest - BuySubOrCredit request submitted successfully."):"";
          // self.subscription.subscriptionRef=resp.subscriptionRef;
          // self.subscription.subscriptionStarts=resp.subscriptionStarts;
          UserService.confirmTempAccount();
          $rootScope.tempToken=null;
          Session.setSubscribed();
          self.captureSubscription(resp.paymentRef);
          DialogAlertService.openSubscriptionConfirmation(resp.paymentRef,resp.starts,self.subscription,function(){
            usSpinnerService.stop('spinner');
            if(utilities.isShowMainRegion()){
              $state.go('credit-balance');
            } else {
              $state.go('credit-balance-multi-region', {country: $rootScope.geoLocation.country});
            }
          });
        },function(err){
          usSpinnerService.stop('spinner');
          self.lk_checkout = false;
          var errorLog;
          try{
            errorLog = err.error ? err.error.message : err.data.reasons[0].message;
            if (err.data){
              switch (err.data.reasons[0].code) {
                case "DUPLICATE_RENTAL_REQUEST":
                  self.error_txn = err.data.reasons[0].message;
                  self.GotoTop();
                  break;
                case "FAILED_TO_APPLY_PROMO":
                  self.error_txn = $filter('translate')('GENERAL.ERROR.FAILED_TO_APPLY_PROMO');
                  self.GotoTop();
                  break;
                case "START_DATE_NOT_ALLOWED":
                  self.error_txn = err.data.reasons[0].message;
                  self.GotoTop();
                  break;
                case "BILLING_CARD_DECLINED":
                  self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_DECLINED');
                  self.GotoTop();
                  break;
                case "NON_RECURRING_SUBSCRIPTION":
                  self.error_txn = err.data.reasons[0].message;
                  self.is_recurring_error = true;
                  self.recurring_error_line_1 = $filter('translate')('GENERAL.ERROR.RECURRING_STYLEPASS_SUBSCRIPTION_ERR_1'); 
                  self.recurring_error_line_2 = $filter('translate')('GENERAL.ERROR.RECURRING_STYLEPASS_SUBSCRIPTION_ERR_2'); 
                  self.GotoTop();
                  break;
                case "EXISTING_SUBSCRIPTION":
                  self.error_txn = err.data.reasons[0].message;
                  self.is_recurring_error = true;
                  self.recurring_error_line_1 = $filter('translate')('GENERAL.ERROR.EXISTING_STYLEPASS_SUBSCRIPTION_ERR_1'); 
                  self.GotoTop();
                  break;
                default:
                  self.error_txn = "System Error - Please try again later. (" + err.data.reasons[0].code+")";
                  break;
              }
            }else{
              self.error_txn = errorLog;
            }
          }catch(moreErr){
            self.error_txn = $filter('translate')("GENERAL.ERROR.UNABLE_TO_PROCESS_PAYMENT");
            errorLog = moreErr;
          }finally{
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":BuySubCtrl:submitBuyRequest - Checkout failed. "+ errorLog):"";
          }
        })

      },function(err){
        usSpinnerService.stop('spinner');
        self.lk_checkout = false;
        self.error_ship_bill_info= "Shipping address is too long, please try again.";
        $rootScope.enableLog ? $log.error($rootScope.UUID + ":BuySubCtrl:submitBuyRequest - Update shipping address error. "):"";
      });
    }

    /**************************
    //ONLY ALLOW NUMBERIC VALUE TO BE ENTERED
    **************************/
    this.creditCardCheck = function(inputValue) {
      if (inputValue){
        (isNaN(inputValue) || inputValue.charAt(inputValue.length - 1) === '.') ? self.stReq.cardnum = inputValue.substring(0, inputValue.length - 1): '';
      }
    }

    /**************************
    //ONLY ALLOW NUMBERIC VALUE TO BE ENTERED
    **************************/
    this.CVCCheck = function(inputValue) {
      if (inputValue){
        (isNaN(inputValue) || inputValue.charAt(inputValue.length - 1) === '.') ? self.stReq.cvc = inputValue.substring(0, inputValue.length - 1): '';
      }
    }

    /**************************
    //CHECK FOR VALID CREDIT CARD EXPIRY DATE
    **************************/
    this.expiryDateCheck = function(inputValue) {
      //ONLY ALLOW ENTER MM/YY
      if (inputValue){
        var validValue = true;
        isNaN(inputValue) ? validValue = false : '';
        (inputValue.length === 2 && (inputValue === 0 || inputValue > 12)) ? validValue = false: '';
        !validValue ? self.ccExpiry = inputValue.substring(0, inputValue.length - 1) : '';
      }
    }


    /*********************************
    //CALCULATE ALL THE CREDIT PRICING 
    **********************************/
    function reCalculateSubscriptionPricing() {

      // var selectedCheckoutProducts = $rootScope.cc.cart.filter(p=> p.product._selectedToCheckout == true).map(item=> {
      //   var obj = {};
      //   obj['productId'] = item.product.id;
      //   obj['startDate'] = item.selectedDate.START_DATE;
      //   return obj;
      // });

        // if (AuthService.isAuthenticated()) {
          var isAuth=AuthService.isAuthenticated();
          if (self.subscription.isBuyCredit){
              RentalService.checkCreditItemPrice(self.subscription.id, self.subscription.unit, self.promoCode,isAuth).$promise.then(function(resp){
                self.totalDue=resp.totalPriceAfterDiscount;
                self.giftCardSaving=resp.totalPrice-self.totalDue;
                if (resp.promoPubDesc !=null && resp.promoPubDesc!='') self.giftCardDesc="("+resp.promoPubDesc+")";
                self.subscription.finalPriceReturn=angular.copy(resp);
                // copied from priceUtilities.applyPromoToMultiProducts
                if (self.promoCode && resp.promoCode === null){
                  self.error_txn = $filter('translate')('GENERAL.ERROR.FAILED_TO_APPLY_PROMO');
                  self.GotoTop();
                  // return deferred.reject(resp);
                }
              },function(err){
                self.error_txn = $filter('translate')('GENERAL.ERROR.FAILED_TO_APPLY_PROMO');
                self.GotoTop();
              });
          } else {
              RentalService.checkSubscriptionItemPrice(self.subscription.id,self.promoCode,isAuth).$promise.then(function(resp){
                var tempMths = "";
                if(resp.promoApplicableMonths == "" || resp.promoApplicableMonths == null){
                  tempMths = " / ";
                } else {
                  var applicableMonths = resp.promoApplicableMonths.split(",");
                  var len = applicableMonths.length;
                  var i = 1;
                  applicableMonths.forEach(function(m){
                    self.savingsCost=resp.finalMonthlyPrice[m-1];
                    if(i === len && len > 1) {
                      tempMths = tempMths + " and " + utilities.ordinalSuffixOf(m);
                    } else if(i === len && len === 1) {
                      tempMths = " on " + utilities.ordinalSuffixOf(m);
                    }  else {
                      if(i == 1){
                        tempMths = " on " + utilities.ordinalSuffixOf(m);
                      } else {
                        tempMths = tempMths + ", " + utilities.ordinalSuffixOf(m);
                      }
                    }
                    i++;
                  });
                }
                self.totalDue=resp.finalMonthlyPrice[0];
                self.promoApplicableMonths = resp.promoApplicableMonths;
                self.promoMonths = tempMths + " Month";
                self.subscription.nextBillingCharge=resp.finalMonthlyPrice[self.subscription.numFreeMonths];
                // self.giftCardSaving=resp.listPrice-self.totalDue;
                self.giftCardSaving=resp.listPrice-self.savingsCost;
                if (resp.promoPubDesc !=null && resp.promoPubDesc!='') self.giftCardDesc="("+resp.promoPubDesc+")";
                self.subscription.finalPriceReturn=angular.copy(resp);
                // copied from priceUtilities.applyPromoToMultiProducts
                if (self.promoCode && resp.promoCode === null){
                  self.error_txn = $filter('translate')('GENERAL.ERROR.FAILED_TO_APPLY_PROMO');
                  self.GotoTop();
                  // return deferred.reject(resp);
                }
              },function(err){
                self.error_txn = $filter('translate')('GENERAL.ERROR.FAILED_TO_APPLY_PROMO');
                self.GotoTop();
              });
          }

        // } 
    };
    this.validateCard = function() {
      self.is_recurring_error = false;
      self.recurring_error_line_1 = null;
      self.recurring_error_line_2 = null;

      var deferred = $q.defer();

      //CONVERT FORM DATA TO STRIP REQUIRED FORMAT
      self.stReq.mm = self.ccExpiry.substring(0, 2);
      self.stReq.yy = self.ccExpiry.substring(2, 4);
      self.stReq.address1 = self.billingAddress.address1;
      self.stReq.address2 = self.billingAddress.address2;
      self.stReq.city = self.billingAddress.city;
      self.stReq.country = self.billingAddress.country;
      self.stReq.district = self.billingAddress.district;

      // Request a token from Stripe:
      Stripe.card.createToken({
        number: self.stReq.cardnum,
        cvc: self.stReq.cvc,
        exp_month: self.stReq.mm,
        exp_year: self.stReq.yy,
        name: self.stReq.name,
        address_line1: self.stReq.address1,
        address_line2: self.stReq.address2,
        address_city: self.stReq.city,
        address_country: self.stReq.country,
        metadata: {
          "email": self.account ? self.account.email : ($rootScope.user && $rootScope.isLogon ? $rootScope.user.email : ""),
          "phone": $rootScope.user && $rootScope.isLogon ? $rootScope.user.phone1 : ""
        }
      }, function(status, response) {

        if (response.error) { // Problem!
          self.error_ship_bill_info= response.error.message;
          self.error_txn = "Our payment gateway says " + response.error.message + " Please correct the details and try again.";
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":BuySubCtrl:validateCard - Card creation failed!. "+ response.error.message):"";
          deferred.reject(response);
        } else { // Token was created!
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":BuySubCtrl:validateCard - Card creation succeeded. " + response.id):"";
          self.error_ship_bill_info= null;
          // Get the token ID:
          var stripeToken = response.id;
          var addressObj = {
            country : self.subscription.country,
            district : self.billingAddress.district,
            postalCode : self.billingAddress.postalCode
          }

          // send stripeToken
          RentalService.saveStripeToken(stripeToken, addressObj).$promise.then(
            function(resp) {
              $rootScope.enableLog ? $log.info($rootScope.UUID + ":BuySubCtrl:validateCard - Token saved to server. " + resp):"";
              deferred.resolve(resp.token);
            },
            function(err) {
              var errMsg= err.data.reasons[0].message;
              $rootScope.enableLog ? $log.error($rootScope.UUID + ":BuySubCtrl:validateCard - Token failed to save to server. " + err):"";
              
              if(err.data && err.data.reasons && err.data.reasons[0]){
                switch (err.data.reasons[0].code) {
                  case "FAILED_TO_CREATE_CUSTOMER_OBJECT":
                    self.error_txn = $filter('translate')('GENERAL.ERROR.FAILED_TO_CREATE_CUSTOMER_OBJECT');
                    break;
                  case "CARD_DECLINED":
                    self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_DECLINED');
                    break;
                  case "CARD_INCORRECT_CVC":
                    self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_INCORRECT_CVC');
                    break;
                  case "CARD_INCORRECT_NUMBER":
                    self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_INCORRECT_NUMBER');
                    break;
                  case "CARD_EXPIRED":
                    self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_EXPIRED');
                    break;
                  default:
                    self.error_txn = $filter('translate')('GENERAL.ERROR.PROFILE_ERROR');
                    break;
                }
              } else {
                self.error_txn = $filter('translate')('GENERAL.ERROR.PROFILE_ERROR');
              }
              deferred.reject(err);
            }
          );
        }
      });
      return deferred.promise;
    }
    this.createTempAccount = function() {
      var deferred = $q.defer();
      if (!self.isHideAccountInfo && $rootScope.tempToken == null) {
        // check if password is valid
        if (self.account.password.length<8 || self.account.password!==self.account.password2){
            self.error_txn = "Passwords don’t match or have less than 8 characters.";
            deferred.reject(self.error_txn);
            usSpinnerService.stop('spinner');
        } else {
          // create temp account
        $http.get(CONFIG.IPINFO_URL).then(function (response){
          var registeredCountry = utilities.isShowMainRegion() ? "HK" : $rootScope.geoLocation.country;
          UserService.createTempAccount(self.account.email,self.account.password,self.stReq.name, response.data.country, registeredCountry).$promise.then(
            function(resp) {
              $rootScope.tempToken=resp.tempToken;
              $rootScope.enableLog ? $log.info($rootScope.UUID + ":BuySubCtrl:tempAccount - Account created. " + resp):"";
              deferred.resolve(resp.token);
            },
            function(err) {
              $rootScope.enableLog ? $log.error($rootScope.UUID + ":BuySubCtrl:validateCard - Account failed to be created. " + err):"";
              // self.error_txn = 'There is a system error while saving your profile.  Please contact support or try again later.';
              // self.error_txn = 'We are unable to process your request for the moment. Please try again later.';
              var errMsg= err.data.reasons[0].message;
              if (errMsg.includes("String index out of range")){
                self.error_txn = "Email address supplied is not valid.";
              } else self.error_txn = errMsg;
              deferred.reject(err);
              usSpinnerService.stop('spinner');
            }
          );
        });
        }
      } else {
        deferred.resolve("");
      }
        return deferred.promise;
    }


    self.updateSubTotal= function() {
      if (self.subscription.unit!=null){
        self.subscription.totalPrice=self.subscription.unit * self.subscription.price;
        self.totalDue=self.subscription.totalPrice;
        self.error_txn = null;
        reCalculateSubscriptionPricing();
      } 
    }

    self.unitReset=function(){
      if (self.subscription.unit==null){
        self.subscription.unit=1;
        self.subscription.totalPrice=self.subscription.unit * self.subscription.price;
        self.totalDue=self.subscription.totalPrice;
        reCalculateSubscriptionPricing();
      }
    }

    self.setSelected = function(type, selectedValue) {
      switch (type) {
        case 'shippingCountry':
          // $scope.checkoutForm ? $scope.checkoutForm.shipCountry.$setDirty() : '';
          self.shippingAddress.country = selectedValue.name;
          self.disable_Shipping_CityDDL = selectedValue.name != CONFIG.HONG_KONG ? true:false;
          self.shippingAddress.reqPostCode = selectedValue.reqPostCode;
          if (!self.disable_Shipping_CityDDL && typeof self.areaName != "undefined"){
            self.shippingAddress.city = self.areaName[0].name;
          }
          if ($scope.isSameShippingAddress) {
            self.billingAddress.country = selectedValue.name;
            self.disable_Billing_CityDDL = true;
          }
          break;

        case 'billingCountry':
          self.billingAddress.country = selectedValue.name;
          self.disable_Billing_CityDDL = selectedValue.name != CONFIG.HONG_KONG ? true:false;
          if (!self.disable_Billing_CityDDL){
            self.billingAddress.city = self.areaName[0].name;
          }
          self.billingAddress.reqPostCode = selectedValue.reqPostCode;
          break;

        case 'BILLING_ADDRESS':
          self.billingAddress.city = selectedValue.name;
          break;

        case 'SHIPPING_ADDRESS':
          self.shippingAddress.city = selectedValue.name;
          if ($scope.isSameShippingAddress) {
            self.billingAddress.city = selectedValue.name;
          }
          break;
      }
    };

    function loadCountryList(){
      $http.get('scripts/config/countries.json').then(function successCallback(response) {
          self.countries = response.data;
      }, function errorCallback(response) {
          // console.log(response.statusText);
      });
    }

    self.captureSubscription = function(checkoutReference){
      let currentUser = localStorageService.get('user');
      var currency = "HKD";
      if(self.subscription){
        if(self.subscription.country == "SG"){
          currency = "SGD";
        }
      }
      dataLayer.push({ ecommerce: null });  
      dataLayer.push({
          "environment" : envService.environment === "production" ? "prod" : "dev",
          "currentUserID" : currentUser ? currentUser.userid : "guest",
          "currentUserName" : currentUser ? currentUser.firstName + " " + currentUser.lastName : "guest",
          "currentUserEmail" : currentUser ? currentUser.email : "guest",
          "currency": currency,
          "subscription_item_name": self.subscription ? self.subscription.itemName : "NA",      
          "subscription_item_id": self.subscription ? self.subscription.id : "NA",
          "subscription_item_price": self.subscription ?  self.subscription.price : "NA",
      event: "stylepass_subscription",
      });

      dataLayer.push({
        event: "purchase",
        ecommerce: {
        currency: currency,
        value: self.subscription ?  self.subscription.price : 0,
        transaction_id: checkoutReference,
          items: [{
            item_name: self.subscription ? self.subscription.itemName : "NA", 
            item_id: self.subscription ? self.subscription.id : "NA",
            price: self.subscription ?  self.subscription.price : 0,
          }]}
      });

      fbq('track', 'StylepassSubscription', 
      {
        "environment" : envService.environment === "production" ? "prod" : "dev",
        "currentUserID" : currentUser ? currentUser.userid : "guest",
        "currentUserName" : currentUser ? currentUser.firstName + " " + currentUser.lastName : "guest",
        "currentUserEmail" : currentUser ? currentUser.email : "guest",
        "currency": currency,
        "subscription_item_name": self.subscription ? self.subscription.itemName : "NA",      
        "subscription_item_id": self.subscription ? self.subscription.id : "NA",
        "subscription_item_price": self.subscription ?  self.subscription.price : "NA",
      });

      fbq('track', 'Purchase', 
      {
        content_ids: [
          self.subscription ? self.subscription.id : "NA",
        ], 
        content_name: self.subscription ? self.subscription.itemName : "NA", 
        content_type: "product",
        contents: [{'id': (self.subscription ? self.subscription.id : "NA"), 'quantity': 1}],
        currency: currency,
        value: self.subscription ?  self.subscription.price : 0
      });

    };
      
    $('.dropdown-menu').find('input').click(function (e) {
      e.stopPropagation();
    });

    this.signIn = function() {
      DialogAlertService.openLogon(function(){
        //ON SUCESSFUL LOGON
        $state.go('buy-subscription');
      },function(){
        //ON CANCEL OR CLOSE THE LOGON
        $state.go('buy-subscription');
      });
    };

  }]);

'use strict';

/**
 * @ngdoc function
 * @name coutureApp.controller:BuyCreditCtrl
 * @description
 * # BuyCreditCtrl
 * Controller of the coutureApp
 */
angular.module('coutureApp')
  .controller('BuyCreditCtrl', ["Session", "$scope", "$rootScope", "$q", "$state", "DialogAlertService", "utilities", "$log", "$location", "AuthService", "RentalService", "CONFIG", "UserService", "RefDataService", "usSpinnerService", "$translatePartialLoader", "CartService", "$anchorScroll", "dateUtilities", "priceUtilities", "$filter", "CalendarService", function(Session, $scope, $rootScope, $q, $state, DialogAlertService, utilities, $log, $location, AuthService, RentalService,CONFIG,
    UserService, RefDataService, usSpinnerService, $translatePartialLoader, CartService, $anchorScroll,dateUtilities,priceUtilities,$filter,CalendarService) {

    var self = this;
    self.isShipToHKOnly = CONFIG.SHIPPING_TO_HONG_KONG_ONLY;

    this.$onInit = function() {
      self.subscription={
        "id": $state.params.id,
        "unit":1,
        "itemName": "",
        "numCredit": 1,
        "price": 0,
        "expiryDate": 0,
        "isBuyCredit": null,
        "type":$state.params.type,
        "subscriptionRef":null,
        "subscriptionStarts":"",
        "totalPrice": 0,
        "finalPriceReturn":{}
    }
      // if ( $state.params.type=='credit'){
      self.subscription.isBuyCredit=true;
      // } else if ($state.params.type=='subscription'){
      //     self.subscription.isBuyCredit=false;
      // } else $state.go('main');

      this.isOrderSummaryActive = true;
      this.isShippingActive = true;
      this.isItemsActive = true;

      this.productIndex = 0;

      // Double submit locks
      self.lk_checkout = false;
      self.acceptedTnC = false;
      self.editShippingToggle = false;
      self.billingAddress = {country:CONFIG.DEFAULT_COUNTRY};
      self.stReq = {};
      self.isHideCreditCardDetails = true;
      self.isAcceptedTC = false;
      if (self.isShipToHKOnly){
        self.shippingAddress = {country:CONFIG.HONG_KONG};
      }else{
        self.shippingAddress = {country:CONFIG.DEFAULT_COUNTRY};
      }

      self.rentalPrice = 0;
      self.giftCardSaving = 0;
      self.giftCardDesc="";
      self.rentalProtectionFee = 0;
      self.shippingFee = 0;
      self.totalDue = 0;

    // DEBUG for subscription-confirmation.component.js - uncomment to test the page without going through checkout process
      //     self.subscription.itemName="StyleCarousel 1-Credit Pack";
      //     self.subscription.numCredit=3;
      //     self.subscription.totalPrice=5400;
      //     self.subscription.price=1800;
      //     self.subscription.unit=3;
      // if ( $state.params.type=='credit'){
      //     self.subscription.totalPrice=5400;
      //     self.subscription.price=1800;
      //     self.subscription.unit=3;
      //     self.subscription.finalPriceReturn={"pricingId":1, "totalPriceAfterDiscount":1700, "promoPubDesc":""};
      //     DialogAlertService.openSubscriptionConfirmation("Cred-1234","",self.subscription,function(){
      //     });
      //   } else {
      //     self.subscription.totalPrice=1800;
      //     self.subscription.price=1800;
      //     self.subscription.unit=1;
      //     self.subscription.finalPriceReturn={"pricingId":4, "listPrice":1800, "finalMonthlyPrice":[100], "promoPubDesc":"1st Month Free"};
      //     DialogAlertService.openSubscriptionConfirmation("Sub-1234","20200630",self.subscription,function(){
      //     });
      //   }
    // DEBUG
      self.error_shippingInfo = "Missing Shipping Info";
      self.error_shippingAddress = "Missing Shipping Address";
      self.error_billingAddress = "Missing Billing Address";
      self.error_paymentInfo = "Missing Payment Info";
      self.error_termsCondition = "You must accept Terms of Service";
      self.error_deliveryDate = "You must select delivery date";
      self.error_txn = null;
      self.error_ship_bill_info = null;
      self.areaName = CONFIG.AREAS;
      self.proudct_currency = priceUtilities.getCurrency();
      self.promoCode = null;

      self.selectedCheckoutProductsMissingDate = [];
      self.returnedCalculatedPrice = null;

      try {
        if (!AuthService.isAuthenticated()) {
          if(utilities.isShowMainRegion()){
            $state.go('main');
          } else {
            $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
          }
        } else if ($location.path().includes('buy')) {

          // if ($rootScope.cc.cart.length !== 0){
          //   self.promoCode = $rootScope.cc.cart[0].product._promoPrice.promoCode;
          //   $scope.temp_promoCode = self.promoCode;
            self.initializeCheckoutPage(self.subscription.id);
          // }else{
          //   $rootScope.enableLog ? $log.error($rootScope.UUID + ":BuyCreditCtrl:$onInit - Err initialize" + err):"";
          //   $state.go('main');
          // }

          self.countries = RefDataService.getCountryList();

          // Used for data passing between update payment and checkout
          if ($state.params.ctx) {
            self.ctx = $state.params.ctx;
          }
        }
      }catch(err) {
        if(utilities.isShowMainRegion()){
          $state.go('main');
        } else {
          $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
        }
      }
    }

    $translatePartialLoader.addPart('checkout');

    /////////////////////////////////////////
    // SELECT THE PRE-DEFINED CITY FROM THE DROP DOWN LIST.
    /////////////////////////////////////////
    // this.setSelected = function(type,selectedValue) {
      // switch (type) {
      //   case 'BILLING_ADDRESS':
      //     self.billingAddress.city = selectedValue.name;
      //     break;
      //   case 'SHIPPING_ADDRESS':
      //     self.shippingAddress.city = selectedValue.name;
      //     break;
      // }
    // }

    //////////////////////////////////////////
    //SORT THE ITEM IN THE CART BASED ON START_DATE
    //////////////////////////////////////////
    $scope.min = function(arr) {
      return $filter('min')($filter('map')(arr, 'selectedDate.START_DATE'));
    }

    /**************************
    //CHANGE THE RENTAL DATE
    **************************/
    // this.changeDate = function(product) {

    //   self.error_txn = null;

    //   var rental = {
    //     product: null,
    //     selectedDate: null
    //   };

    //   //arg1 = (null=no CheckoutButton)
    //   CalendarService.openCalendar(null, function() {
    //     rental.product = product;
    //     if (rental.product !== null && rental.selectedDate != null) {
    //       //REMOVE THE PRODUCT ID WHICH HAVE NO DATE SELECTED IN THE ERROR DISPLAY ARRAY.
    //       if (self.selectedCheckoutProductsMissingDate.indexOf(product.id) != -1){
    //         self.selectedCheckoutProductsMissingDate.splice(self.selectedCheckoutProductsMissingDate.indexOf(product.id),1)
    //       }
    //       utilities.replaceItemInArray(rental, $rootScope.cc.cart);
    //       //STORE PRODUCT ID IN LOCAL SERVICE
    //       Session.updateCart(product.id);
    //       //STORE PRODUCT ID IN REMOTE SERVICE
    //       CartService.addCart(product.id,rental.selectedDate.START_DATE,rental.selectedDate.RETURN_DATE);
    //     }
    //   }, function(date) {

    //     rental.selectedDate={'START_DATE':null, 'RETURN_DATE':null}
    //     rental.selectedDate.START_DATE = moment(date).format('x');
    //     rental.selectedDate.RETURN_DATE=moment(rental.selectedDate.START_DATE).add(CONFIG.DEFAULT_RENTAL_DURATION,'d').format('x');
    //   }, utilities.getAvailableDates(product.status));


    // };

    /**************************
    //SET THE SHIPPING COUNTRY AS PER THE DROP DOWN LIST
    **************************/
    this.setShippingCountry = function(inputCountry) {
      self.shippingAddress.country = null;
      for (var index in self.countries) {
        if (self.countries[index].name === inputCountry) {
          self.shippingAddress.country = self.countries[index].name;
          break;
        }
      }
    }

    /////////////////////////////////////////
    //COPY BILLING ADDRESS TO ADDRESS LOGIC
    /////////////////////////////////////////
    this.isCopyShippingInfoToBillingInfo = function() {
      return false;
    }

    /**************************
    //COPY THE SHIPPING ADDRESS TO BILLING ADDRESS
    **************************/
    this.copyShippingAddressToBillingAddress = function() {
      self.billingAddress = angular.copy(self.shippingAddress);
      self.disable_Billing_CityDDL = self.billingAddress.country != CONFIG.HONG_KONG ? true:false;
    }

    /**************************
    //COPY THE BILLING ADDRESS TO SHIPPING ADDRESS 
    **************************/
   this.copyShippingAddressToBillingAddressToShippingAddress = function() {
    self.shippingAddress = angular.copy(self.billingAddress);
    self.disable_Shipping_CityDDL = self.shippingAddress.country != CONFIG.HONG_KONG ? true:false;
  }
    /**************************
    //GET THE PICKUP DATE
    **************************/
    // this.getPickupDate = function() {
    //   return utilities.getPickupDate($rootScope.cc.cart[self.productIndex]);
    // }

    /**************************
    //GET THE RETURN DATE
    **************************/
    // this.getReturnDate = function() {
    //   return utilities.getReturnDate($rootScope.cc.cart[self.productIndex]);
    // }

    /**************************
    //ADD SPECIAL LOGIC WHEN USER ENTER OTHER BRAND, THE req_listing WILL REMAINS '-- OTHER BRAND --'
    //BUT THE ACTUAL BRAND WILL BE STORED IN TAG. HOWEVER IT WILL NOT GOING TO DISPLAY ON SCREEN.
    **************************/
    this.getDisplayBrand = function(product){
      return utilities.getCustomBrandName(product);
    }

    /**************************
    //UPDATE PROMOTION CODE TO THE PRICING
    **************************/
    this.applyPromo = function(){
      self.error_txn = null;
      self.promoCode = $scope.temp_promoCode;
      reCalculateSubscriptionPricing();
    }

    /**************************
    //GET PRODUCT DISCOUNT VALUE
    **************************/
    this.getDiscountAmount = function(product){
      if (product && self.returnedCalculatedPrice){
        return self.returnedCalculatedPrice.products.filter(p=> p.productSummary.productId == product.id).map(p=> p.rentalOrderBreakdown.originalWeeklyRentalFee - p.rentalOrderBreakdown.weeklyRentalFee)[0];
      }else{
        return 0;
      }
    }


    /**************************
    //THE CHECKOUT PAGE INITIALIZE METHOD, LOAD THE SPECIFIC ITEM IN THE CART AND PREPARE THE PAGE FOR DISPLAY
    **************************/
    this.initializeCheckoutPage = function(id) {

      // self.promoCode = $rootScope.cc.cart.filter(f=> f.product.id == id)[0].product._promoPrice.promoCode;
      // $scope.temp_promoCode = self.promoCode;

      // //PRE-SELECTED ALL PRODUCTS IN CART
      // $rootScope.cc.cart.filter(p=> p.product._selectedToCheckout == undefined || p.product._selectedToCheckout == false)
      // .map(item=> item.product._selectedToCheckout = true);

      usSpinnerService.spin('spinner');
      // Do a pre-rental check.  Make sure user has credit card and shipping address.
      RentalService.preCheck().$promise.then(
        function(resp) {

          var ctx = self.ctx || {};
          self.pid = id;
          ctx.last4 = resp.last4;
          self.last4=resp.last4;

          if (resp.shippingAddress){
            ctx.shippingAddress = resp.shippingAddress;
            self.shippingAddress = ctx.shippingAddress;
          }else{
            //NEWLY REGISTER CUSTOMER WITHOUT ENTER DELIVERY ADDRESS
            resp.shippingAddress = {"phone":"","address1":"","address2":"","address3":"","city":"","district":"","country":CONFIG.DEFAULT_COUNTRY,"postalCode":"","type":CONFIG.ADDRESS_TYPE_SHIPPING};
            self.shippingAddress = resp.shippingAddress;
          }

          if (resp.billingAddress){
            ctx.billingAddress = resp.billingAddress;
            self.billingAddress = ctx.billingAddress;
          }else{
            //NEWLY REGISTER CUSTOMER WITHOUT ENTER DELIVERY ADDRESS
            resp.billingAddress = angular.copy(resp.shippingAddress);
            resp.billingAddress.type = CONFIG.ADDRESS_TYPE_BILLING;
            self.billingAddress = angular.copy(self.shippingAddress);
            self.billingAddress.type = CONFIG.ADDRESS_TYPE_BILLING;
          }

          //CC-519 SHIPPING ONLY TO HK
          if (self.isShipToHKOnly && self.shippingAddress.country != CONFIG.HONG_KONG){
            self.shippingAddress.country = CONFIG.HONG_KONG;
            self.shippingAddress.city = self.areaName[0].name;
          }

          if (resp.hasBilling) {
            self.hasBilling = true;
            self.isHideCreditCardDetails = true;
          } else {
            self.hasBilling = false;
            self.isHideCreditCardDetails = false;
          }

          self.shippingAddress.firstname = $rootScope.user.firstName;
          self.shippingAddress.lastname = $rootScope.user.lastName;

          self.disable_Shipping_CityDDL = self.shippingAddress.country != CONFIG.HONG_KONG ? true:false;
          self.disable_Billing_CityDDL = self.billingAddress.country != CONFIG.HONG_KONG ? true:false;

          usSpinnerService.stop('spinner');
        },
        function(err) {
          usSpinnerService.stop('spinner');
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":BuyCreditCtrl:checkout - Error: " + err):"";
        }
      );
      // Fill out subscription item details
      RentalService.getItemPricing(id,self.subscription.isBuyCredit).$promise.then(
        function(resp) {
          self.subscription.itemName=resp.itemName;
          self.subscription.numCredit=resp.numCredit;
          self.subscription.price=resp.price;
          self.subscription.totalPrice=resp.price * self.subscription.unit;
          self.subscription.expiryDate=resp.expiryDate;
          self.totalDue=self.subscription.totalPrice;
          usSpinnerService.stop('spinner');
        },
        function(err) {
          usSpinnerService.stop('spinner');
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":BuyCreditCtrl:checkout - Error: " + err):"";
          //$state.go('main');  // quite on err e.g. credit/:id where id is a subscription item
          if(utilities.isShowMainRegion()){
            $state.go('main');
          } else {
            $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
          }
        }
      );
      reCalculateSubscriptionPricing();
    }

    /**************************
    //SCROLL BACK TO TOP ONCE THE CHECKOUT HAS BEEN COMPLETED
    **************************/
    this.GotoTop = function(){
      $anchorScroll('top');
    }

    function comparer(otherArray){
      return function(current){
        return otherArray.filter(function(other){
          return other.value == current.value && other.display == current.display
        }).length == 0;
      }
    }

    // /**************************
    // //PRODUCT SELECTED FOR CHECKOUT
    // **************************/
    // this.selectedProduct = function(selectedItem){

    //   self.error_txn = null;

    //   if (selectedItem.selectedDate == null || selectedItem.selectedDate.START_DATE == null){
    //     if (self.selectedCheckoutProductsMissingDate.indexOf(selectedItem.product.id) == -1){
    //       self.selectedCheckoutProductsMissingDate.push(selectedItem.product.id);
    //     }
    //     selectedItem.product._selectedToCheckout = false;

    //   }else if (selectedItem.product._selectedToCheckout){
    //     self.selectedCheckoutProductsMissingDate = [];
    //     selectedItem.product._selectedToCheckout = false;
    //     // calculateCreditPricing();

    //   }else if (!selectedItem.product._selectedToCheckout){
    //     self.selectedCheckoutProductsMissingDate = [];
    //     selectedItem.product._selectedToCheckout = true;
    //     // calculateCreditPricing();
    //   }
    // }

    /**************************
    //MAIN CHECKOUT PROCESS
    **************************/
    this.preparePurchase = function() {

      self.error_txn = null;
      self.error_ship_bill_info = null;
      self.lk_checkout = true;
      self.unitReset();
      self.GotoTop();

      // var selectedCheckoutProducts = $rootScope.cc.cart.filter(p=> p.product._selectedToCheckout == true).map(item=> {
      //   var obj = {};
      //   obj['productId'] = item.product.id;
      //   obj['startDate'] = item.selectedDate.START_DATE;
      //   return obj;
      // });

      // if (selectedCheckoutProducts.length < 1){
      //   self.error_txn = "Please select at least one product for checkout.";
      //   self.lk_checkout = false;
      //   return;
      // }

      usSpinnerService.spin('spinner');

      if (!self.isHideCreditCardDetails) {
        self.validateCard().then(function(resp){
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":BuyCreditCtrl:preparePurchase - Saved card"):"";
          self.submitBuyRequest();
        },function(err){
          try {
            if (!self.error_txn){
              self.error_txn = err.data && err.data.reasons && err.data.reasons[0] ? $filter('translate')("GENERAL.ERROR."+ err.data.reasons[0].code) : $filter('translate')("GENERAL.ERROR.UNABLE_TO_PROCESS_PAYMENT");
            }
          } catch (err) {
            self.error_txn = $filter('translate')("GENERAL.ERROR.UNABLE_TO_PROCESS_PAYMENT");
          } finally {
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":BuyCreditCtrl:preparePurchase - Err No card saved" + err):"";
            self.lk_checkout = false;
            usSpinnerService.stop('spinner');
          }
        });
      }else{
        $rootScope.enableLog ? $log.info($rootScope.UUID + ":BuyCreditCtrl:preparePurchase - Other flow no card change and just submit request"):"";
        self.submitBuyRequest();
      }
    };


    /**************************
    //FINALIZE SHIPPING AND THE RENTAL PROCESS
    **************************/
    self.submitBuyRequest = function(){

      var promises = [];
      // no shipping form will be present; only save it if no shipping address found 
      var updateShippingAddress = !self.isHideCreditCardDetails && self.billingAddress.address1 
      // var updateShippingAddress = $scope.checkoutForm.shipAdd1.$dirty || $scope.checkoutForm.shipAdd2.$dirty ||
      //   $scope.checkoutForm.shipCountry.$dirty || $scope.checkoutForm.shipCity.$dirty || $scope.checkoutForm.shipDistrict.$dirty ||
      //   $scope.checkoutForm.shipPhone.$dirty || $scope.checkoutForm.shipPostalCode.$dirty;

      if(updateShippingAddress) {
        promises.push(UserService.updateAddress(self.shippingAddress).$promise);
      }

      $q.all(promises).then(function() {
        // RentalService.preparePurchaseMultiItems({'products':selectedCheckoutProducts,'promo':self.promoCode}).$promise.then(function(resp){
        RentalService.buySubscriptionOrCreditItem(self.subscription.id, self.promoCode, self.subscription.unit, self.subscription.isBuyCredit).$promise.then(function(resp){
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":BuyCreditCtrl:submitBuyRequest - BuyCredit request submitted successfully."):"";
          // self.subscription.subscriptionRef=resp.subscriptionRef;
          // self.subscription.subscriptionStarts=resp.subscriptionStarts;
          DialogAlertService.openSubscriptionConfirmation(resp.paymentRef,resp.starts,self.subscription,function(){
            usSpinnerService.stop('spinner');
            if(utilities.isShowMainRegion()){
              $state.go('credit-balance');
            } else {
              $state.go('credit-balance-multi-region', {country: $rootScope.geoLocation.country});
            }
          });
        },function(err){
          usSpinnerService.stop('spinner');
          self.lk_checkout = false;
          var errorLog;
          try{
            errorLog = err.error ? err.error.message : err.data.reasons[0].message;
            if (err.data){
              switch (err.data.reasons[0].code) {
                case "DUPLICATE_RENTAL_REQUEST":
                  self.error_txn = err.data.reasons[0].message;
                  self.GotoTop();
                  break;
                case "FAILED_TO_APPLY_PROMO":
                  self.error_txn = $filter('translate')('GENERAL.ERROR.FAILED_TO_APPLY_PROMO');
                  self.GotoTop();
                  break;
                case "START_DATE_NOT_ALLOWED":
                  self.error_txn = err.data.reasons[0].message;
                  self.GotoTop();
                  break;
                case "BILLING_CARD_DECLINED":
                  self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_DECLINED')
                  self.GotoTop();
                  break;
                default:
                  self.error_txn = "System Error - Please try again later. (" + err.data.reasons[0].code+")";
                  break;
              }
            }else{
              self.error_txn = errorLog;
            }
          }catch(moreErr){
            self.error_txn = $filter('translate')("GENERAL.ERROR.UNABLE_TO_PROCESS_PAYMENT");
            errorLog = moreErr;
          }finally{
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":BuyCreditCtrl:submitBuyRequest - Checkout failed. "+ errorLog):"";
          }
        })

      },function(err){
        usSpinnerService.stop('spinner');
        self.lk_checkout = false;
        self.error_ship_bill_info= "Shipping address is too long, please try again.";
        $rootScope.enableLog ? $log.error($rootScope.UUID + ":BuyCreditCtrl:submitBuyRequest - Update shipping address error. "):"";
      });
    }

    /**************************
    //ONLY ALLOW NUMBERIC VALUE TO BE ENTERED
    **************************/
    this.creditCardCheck = function(inputValue) {
      if (inputValue){
        (isNaN(inputValue) || inputValue.charAt(inputValue.length - 1) === '.') ? self.stReq.cardnum = inputValue.substring(0, inputValue.length - 1): '';
      }
    }

    /**************************
    //ONLY ALLOW NUMBERIC VALUE TO BE ENTERED
    **************************/
    this.CVCCheck = function(inputValue) {
      if (inputValue){
        (isNaN(inputValue) || inputValue.charAt(inputValue.length - 1) === '.') ? self.stReq.cvc = inputValue.substring(0, inputValue.length - 1): '';
      }
    }

    /**************************
    //CHECK FOR VALID CREDIT CARD EXPIRY DATE
    **************************/
    this.expiryDateCheck = function(inputValue) {
      //ONLY ALLOW ENTER MM/YY
      if (inputValue){
        var validValue = true;
        isNaN(inputValue) ? validValue = false : '';
        (inputValue.length === 2 && (inputValue === 0 || inputValue > 12)) ? validValue = false: '';
        !validValue ? self.ccExpiry = inputValue.substring(0, inputValue.length - 1) : '';
      }
    }


    /*********************************
    //CALCULATE ALL THE CREDIT PRICING 
    **********************************/
    function reCalculateSubscriptionPricing() {

      // var selectedCheckoutProducts = $rootScope.cc.cart.filter(p=> p.product._selectedToCheckout == true).map(item=> {
      //   var obj = {};
      //   obj['productId'] = item.product.id;
      //   obj['startDate'] = item.selectedDate.START_DATE;
      //   return obj;
      // });

        // if (AuthService.isAuthenticated()) {
          var isAuth=AuthService.isAuthenticated();
          if (self.subscription.isBuyCredit){
              RentalService.checkCreditItemPrice(self.subscription.id, self.subscription.unit, self.promoCode,isAuth).$promise.then(function(resp){
                self.totalDue=resp.totalPriceAfterDiscount;
                self.giftCardSaving=resp.totalPrice-self.totalDue;
                self.giftCardDesc=resp.promoPubDesc;
                self.subscription.finalPriceReturn=angular.copy(resp);
                // copied from priceUtilities.applyPromoToMultiProducts
                if (self.promoCode && resp.promoCode === null){
                  self.error_txn = $filter('translate')('GENERAL.ERROR.FAILED_TO_APPLY_PROMO');
                  self.GotoTop();
                  // return deferred.reject(resp);
                }
              },function(err){
                self.error_txn = $filter('translate')('GENERAL.ERROR.FAILED_TO_APPLY_PROMO');
                self.GotoTop();
              });
          } else {
              RentalService.checkSubscriptionItemPrice(self.subscription.id,self.promoCode,isAuth).$promise.then(function(resp){
                self.totalDue=resp.finalMonthlyPrice[0];
                self.giftCardSaving=resp.listPrice-self.totalDue;
                self.giftCardDesc=resp.promoPubDesc;
                self.subscription.finalPriceReturn=angular.copy(resp);
                // copied from priceUtilities.applyPromoToMultiProducts
                if (self.promoCode && resp.promoCode === null){
                  self.error_txn = $filter('translate')('GENERAL.ERROR.FAILED_TO_APPLY_PROMO');
                  self.GotoTop();
                  // return deferred.reject(resp);
                }
              },function(err){
                self.error_txn = $filter('translate')('GENERAL.ERROR.FAILED_TO_APPLY_PROMO');
                self.GotoTop();
              });
          }

        // } 
    };
    this.validateCard = function() {

      var deferred = $q.defer();

      //CONVERT FORM DATA TO STRIP REQUIRED FORMAT
      self.stReq.mm = self.ccExpiry.substring(0, 2);
      self.stReq.yy = self.ccExpiry.substring(2, 4);
      self.stReq.address1 = self.billingAddress.address1;
      self.stReq.address2 = self.billingAddress.address2;
      self.stReq.city = self.billingAddress.city;
      self.stReq.country = self.billingAddress.country;
      self.stReq.district = self.billingAddress.district;

      // Request a token from Stripe:
      Stripe.card.createToken({
        number: self.stReq.cardnum,
        cvc: self.stReq.cvc,
        exp_month: self.stReq.mm,
        exp_year: self.stReq.yy,
        name: self.stReq.name,
        address_line1: self.stReq.address1,
        address_line2: self.stReq.address2,
        address_city: self.stReq.city,
        address_country: self.stReq.country
      }, function(status, response) {

        if (response.error) { // Problem!
          self.error_ship_bill_info= response.error.message;
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":BuyCreditCtrl:validateCard - Card creation failed!. "+ response.error.message):"";
          deferred.reject(response);
        } else { // Token was created!
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":BuyCreditCtrl:validateCard - Card creation succeeded. " + response.id):"";
          self.error_ship_bill_info= null;
          // Get the token ID:
          var stripeToken = response.id;
          var addressObj = {
            country : null,
            district : self.billingAddress.district,
            postalCode : self.billingAddress.postalCode
          }

          // send stripeToken
          RentalService.saveStripeToken(stripeToken, addressObj).$promise.then(
            function(resp) {
              $rootScope.enableLog ? $log.info($rootScope.UUID + ":BuyCreditCtrl:validateCard - Token saved to server. " + resp):"";
              deferred.resolve(resp.token);
            },
            function(err) {
              $rootScope.enableLog ? $log.error($rootScope.UUID + ":BuyCreditCtrl:validateCard - Token failed to save to server. " + err):"";
              
              
              if(err.data && err.data.reasons && err.data.reasons[0]){
                switch (err.data.reasons[0].code) {
                  case "FAILED_TO_CREATE_CUSTOMER_OBJECT":
                    self.error_txn = $filter('translate')('GENERAL.ERROR.FAILED_TO_CREATE_CUSTOMER_OBJECT');
                    break;
                  case "CARD_DECLINED":
                    self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_DECLINED');
                    break;
                  case "CARD_INCORRECT_CVC":
                    self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_INCORRECT_CVC');
                    break;
                  case "CARD_INCORRECT_NUMBER":
                    self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_INCORRECT_NUMBER');
                    break;
                  case "CARD_EXPIRED":
                    self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_EXPIRED');
                    break;
                  default:
                    self.error_txn = $filter('translate')('GENERAL.ERROR.PROFILE_ERROR');
                    break;
                }
              } else {
                self.error_txn = $filter('translate')('GENERAL.ERROR.PROFILE_ERROR');
              }
              deferred.reject(err);
            }
          );
        }
      });
      return deferred.promise;
    }


    self.updateSubTotal= function() {
      if (self.subscription.unit!=null){
        self.subscription.totalPrice=self.subscription.unit * self.subscription.price;
        self.totalDue=self.subscription.totalPrice;
        self.error_txn = null;
        reCalculateSubscriptionPricing();
      } 
    }

    self.unitReset=function(){
      if (self.subscription.unit==null){
        self.subscription.unit=1;
        self.subscription.totalPrice=self.subscription.unit * self.subscription.price;
        self.totalDue=self.subscription.totalPrice;
        reCalculateSubscriptionPricing();
      }
    }

    self.setSelected = function(type, selectedValue) {
      switch (type) {
        case 'shippingCountry':
          // $scope.checkoutForm ? $scope.checkoutForm.shipCountry.$setDirty() : '';
          self.shippingAddress.country = selectedValue.name;
          self.disable_Shipping_CityDDL = selectedValue.name != CONFIG.HONG_KONG ? true:false;
          self.shippingAddress.reqPostCode = selectedValue.reqPostCode;
          if (!self.disable_Shipping_CityDDL && typeof self.areaName != "undefined"){
            self.shippingAddress.city = self.areaName[0].name;
          }
          if ($scope.isSameShippingAddress) {
            self.billingAddress.country = selectedValue.name;
            self.disable_Billing_CityDDL = true;
          }
          break;

        case 'billingCountry':
          self.billingAddress.country = selectedValue.name;
          self.disable_Billing_CityDDL = selectedValue.name != CONFIG.HONG_KONG ? true:false;
          if (!self.disable_Billing_CityDDL){
            self.billingAddress.city = self.areaName[0].name;
          }
          self.billingAddress.reqPostCode = selectedValue.reqPostCode;
          break;

        case 'BILLING_ADDRESS':
          self.billingAddress.city = selectedValue.name;
          break;

        case 'SHIPPING_ADDRESS':
          self.shippingAddress.city = selectedValue.name;
          if ($scope.isSameShippingAddress) {
            self.billingAddress.city = selectedValue.name;
          }
          break;
      }
    };
  }]);

'use strict';

/**
 * @ngdoc function
 * @name coutureApp.controller:SubOptionCtrl
 * @description
 * # SubOption
 * Controller of the coutureApp
 */
angular.module('coutureApp')
  .controller('SubOptionCtrl', ["Session", "$sce", "$translate", "$scope", "$rootScope", "$log", "$location", "AuthService", "CONFIG", "UserService", "$anchorScroll", "priceUtilities", "RentalService", "$filter", "$timeout", "utilities", function(Session, $sce, $translate, $scope, $rootScope, $log, $location, AuthService, CONFIG,
    UserService, $anchorScroll, priceUtilities, RentalService, $filter,$timeout, utilities) {

    var self = this;
    // self.isShipToHKOnly = CONFIG.SHIPPING_TO_HONG_KONG_ONLY;

    $rootScope.$on("CallParentUpdateCreditPricing", function() {
      this.updateTopUpCreditPrice();
    });
    this.$onInit = function() {
      if ($rootScope.credit.pricing == null) {
        RentalService.getSubscriptionTopupPricing().$promise.then(function(resp) {
          $rootScope.credit.pricing = [];
          $rootScope.credit.pricing = resp;
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":Get credit pricing") : '';
          //$rootScope.enableLog ? $log.info("Credit pricing: " + JSON.stringify($rootScope.credit.pricing)) : '';
        });
      }
      self.loadContent();
      $scope.isRentalTransaction = $rootScope.transactionType == CONFIG.TRANSACTION_TYPE_RENT;
      $scope.isPurchaseTransaction = $rootScope.transactionType == CONFIG.TRANSACTION_TYPE_BUY;
      
      $scope.showUpgradePrompt = $scope.selected12MthPlan();
      $scope.originalCreditPrice = $rootScope.geoLocation.country == CONFIG.COUNTRY_CURRENCY_CODE.SG.country_code ? CONFIG.ORIGINAL_CREDIT_PRICE_SG : CONFIG.ORIGINAL_CREDIT_PRICE;
      $scope.PLAN_ONE_TIME = CONFIG.PLAN_ONE_TIME;
      $scope.PLAN_SUBSCRIPTION_4 = CONFIG.PLAN_SUBSCRIPTION_4;
      $scope.PLAN_SUBSCRIPTION_5 = CONFIG.PLAN_SUBSCRIPTION_5;
      $scope.PLAN_SUBSCRIPTION_3 = CONFIG.PLAN_SUBSCRIPTION_3;
      $scope.PLAN_SUBSCRIPTION_15 = CONFIG.PLAN_SUBSCRIPTION_15;
      $scope.PLAN_SUBSCRIPTION_14 = CONFIG.PLAN_SUBSCRIPTION_14;
      $scope.PLAN_SUBSCRIPTION_16 = CONFIG.PLAN_SUBSCRIPTION_16;
      $scope.MONTH_1_PER_CREDIT_PRICE = CONFIG.MONTH_1_PER_CREDIT_PRICE;
      $scope.MONTH_3_PER_CREDIT_PRICE = CONFIG.MONTH_3_PER_CREDIT_PRICE;
      $scope.MONTH_12_PER_CREDIT_PRICE = CONFIG.MONTH_12_PER_CREDIT_PRICE;
      $scope.PLAN_SG_1_TIME_CREDIT_PRICE = CONFIG.PLAN_SG_1_TIME_CREDIT_PRICE;
      $scope.PLAN_HK_1_TIME_CREDIT_PRICE = CONFIG.PLAN_HK_1_TIME_CREDIT_PRICE;
      $scope.currentPlanMonth = 0;
      $scope.showSubscriptionOptionsProductListing = false;
      $scope.showSubscriptionDetails = false;
      $scope.product_currency = $rootScope.geoLocation.country;
      if ($rootScope.cc.cart.length == 0 || $scope.currentPlanMonth < 12) $scope.showSubscriptionOptionsProductListing = true;

      // SET A DELAY BEFORE CHECK AND SET DEFAULT CHOSEN PLAN, AS IT ACCOUNT FOR USER MANUALLY PRESS RELOAD
      $timeout(function () {
        if ($location.path().includes('listing') && ($rootScope.credit.selectedPlan == null || ($rootScope.credit.selectedOneTimeAtCheckout != null && $rootScope.credit.selectedOneTimeAtCheckout == true))){
          UserService.storeSelectedPlan($scope.PLAN_SUBSCRIPTION_4);
        }

        if ($location.path().includes('checkout')) {
          $scope.showSubscriptionDetails = false;
          $scope.isCheckoutPage = true;
        }
        loadPerkContent($rootScope.credit.selectedPlan);
      }, 500);
    }

    /**************************
    //SCROLL BACK TO TOP ONCE THE CHECKOUT HAS BEEN COMPLETED
    **************************/
    this.GotoTop = function() {
      $anchorScroll('top');
    }

    $scope.setToUpgrade = function() {
      if (!$scope.showSubscriptionDetails) {
        UserService.storeSelectedPlan($scope.PLAN_SUBSCRIPTION_3);
        if ($location.path().includes('checkout')) {
          $rootScope.$emit("CallCheckoutParentUpdateCreditPricing", {});
        }
      }
      $scope.showSubscriptionDetails = true;
    }

    $scope.inCheckout = function() {
      return $location.path().includes('checkout');
    }

    $scope.isDisplayPerks = function() {
      return $rootScope.geoLocation.country != CONFIG.COUNTRY_CURRENCY_CODE.AU.country_code;
    }

    $scope.isDisplaySGPass = function() {
      return $rootScope.geoLocation.country == CONFIG.COUNTRY_CURRENCY_CODE.SG.country_code;
    }

    $scope.selected12MthPlan = function() {
      return Session.getSelectedPlan() != CONFIG.PLAN_SUBSCRIPTION_3;
    }

    $scope.selectedOneTime = function() {
      return Session.getSelectedPlan() == CONFIG.PLAN_ONE_TIME;
    }

    $scope.alwaysChecked = function() {
      $scope.subCheckbox = true;
    }

    $scope.upgradePrice = function() {
      if (Session.getSelectedPlan() != null && Session.getSelectedPlan() != 0) {
        var planMonth = $rootScope.credit.pricing.filter(p => p.id == Number(Session.getSelectedPlan()))[0].numContractMonths;
        if (planMonth > $scope.currentPlanMonth) {
          if (Number(Session.getSelectedPlan()) == CONFIG.PLAN_SUBSCRIPTION_3) {
            return $scope.MONTH_12_LINE[3];
          }
          if (Number(Session.getSelectedPlan()) == CONFIG.PLAN_SUBSCRIPTION_4) {
            return $scope.MONTH_1_LINE[3];
          }
          if (Number(Session.getSelectedPlan()) == CONFIG.PLAN_SUBSCRIPTION_5) {
            return $scope.MONTH_3_LINE[3];
          }
        }
      }
      return "";
    }

    $scope.getPlanDetails = function(subId){
      if (subId != null && $rootScope.credit != null && $rootScope.credit.pricing != null){
        return $rootScope.credit.pricing.find(p => p.id == Number(subId));
      }else{
        return null;
      }
    }

    $scope.getPlanPricingByRate = function (price) {
      return priceUtilities.getAmountByRate(price);
    }

    $scope.setSelectedPlan = function(subId) {
      $rootScope.subscriptionSelected = Number(subId) != 0;
      // self.error_txn = null;
      if (Number(subId) != Number(Session.getSelectedPlan())) {
        var plan = $rootScope.credit.pricing.find(p => p.id == Number(subId));
        var planMonth = plan.numContractMonths;
        $scope.selectedNumCredit = plan.numCredit;
        if (Number(subId) == 0 || planMonth > $scope.currentPlanMonth) {
          UserService.storeSelectedPlan(subId);
          if (Number(subId) == 0) {
            $scope.showUpgradePrompt = true;
            $scope.showSubscriptionDetails = false;
            // hack to stuff in 5 credits for the default chosen 12 month plan
            $scope.selectedNumCredit = 5;
            // if setting one-time at checkout screen
            if ($location.path().includes('checkout')) $rootScope.credit.selectedOneTimeAtCheckout = true;
          }
          loadPerkContent(subId);
          if ($scope.inCheckout()) {
            $rootScope.$emit("CallCheckoutParentUpdateCreditPricing", {});
            $rootScope.enableLog ? $log.info($rootScope.UUID + ":selectedPlan Changed") : '';
          } else { // in product listing
            $scope.showUpgradePrompt = $scope.selected12MthPlan();
          }
        }
      }
    }

    function loadPerkContent(subId){
      if (Number(subId) == 3) {
        $scope.perk = $scope.MONTH_12_PERK;
        $scope.perk[0] = $scope.MONTH_12_PER_CREDIT_PRICE;
        $scope.line = $scope.MONTH_12_LINE;
        $scope.perk_subtitle = $scope.PERK_HK_SUBTITLE;
      }
      if (Number(subId) == 4) {
        $scope.perk = $scope.MONTH_1_PERK;
        $scope.perk[0] = $scope.MONTH_1_PER_CREDIT_PRICE;
        $scope.line = $scope.MONTH_1_LINE;
        $scope.perk_subtitle = $scope.PERK_HK_SUBTITLE;
      }
      if (Number(subId) == 5) {
        $scope.perk = $scope.MONTH_3_PERK;
        $scope.perk[0] = $scope.MONTH_3_PER_CREDIT_PRICE;
        $scope.line = $scope.MONTH_3_LINE;
        $scope.perk_subtitle = $scope.PERK_HK_SUBTITLE;
      }
      if (Number(subId) == 14) {
        $scope.perk = $scope.SG_ONE_TIME_PERK;
        $scope.perk_subtitle = $scope.PERK_SG_SUBTITLE;
        $scope.perk_country = CONFIG.COUNTRY_CURRENCY_CODE.SG.country_code
      }
      if (Number(subId) == 15) {
        $scope.perk = $scope.HK_ONE_TIME_PERK;
        $scope.perk_subtitle = $scope.PERK_HK_SUBTITLE_ONE_TIME;
        $scope.perk_country = CONFIG.COUNTRY_CURRENCY_CODE.HK.country_code
      }
      if (Number(subId) == 16) {
        $scope.perk = $scope.SG_MONTH_3_PERK;
        $scope.perk_subtitle = $scope.PERK_SG_SUBTITLE_MONTH_3;
        $scope.perk_country = CONFIG.COUNTRY_CURRENCY_CODE.SG.country_code
      }
    }


    $scope.isPricingActive = function(subId) {
      var isActive = true;
      if (subId != null && AuthService.isAuthenticated() && $rootScope.credit.balance && $rootScope.credit.pricing) {
        $scope.currentPlan = 0;
        if ($rootScope.credit.balance.activeSubscriptionId != null) {
          $scope.currentPlan = $rootScope.credit.balance.activeSubscriptionId;
        }
        $scope.currentPlanMonth = $rootScope.credit.balance.numContractMonths;
        var subMonth = $rootScope.credit.pricing.filter(p => p.id == Number(subId))[0].numContractMonths;
        isActive = subMonth > $scope.currentPlanMonth;
      }
      return isActive;
    }

    const sleep = (milliseconds) => {
      return new Promise(resolve => setTimeout(resolve, milliseconds))
    }

    $scope.eligibleOneCreditPrice = function() {
      var e = CONFIG.ORIGINAL_CREDIT_PRICE;
      if ($rootScope.credit.balance && $rootScope.credit.balance.eligibleOneCreditPrice) {
        e = $rootScope.credit.balance.eligibleOneCreditPrice;
      }
      return e;
    }

    $scope.getSelectedPlanName = function() {
      if ($rootScope.credit != null && $rootScope.credit.pricing != null){
        var name = $rootScope.credit.pricing.filter(p => p.id == Number(Session.getSelectedPlan()))[0].itemName;
        if (Session.getSelectedPlan() == 0) {
          return $scope.ONE_TIME_LINE_1;
        } else {
          return name;
        }
      }else{
        return "";
      }
    }

    this.getPlanPrice = function(planId) {
      if ($rootScope.credit.pricing != null) {
        return $rootScope.credit.pricing.filter(p => p.id == Number(planId))[0].price;
      }
    }

    this.getPlanAvgPrice = function(planId) {
      if ($rootScope.credit.pricing != null) {
        // return Math.ceil($rootScope.credit.pricing.filter(p => p.id == Number(planId))[0].price/$rootScope.credit.pricing.filter(p => p.id == Number(planId))[0].numCredit);
        return $rootScope.credit.pricing.filter(p => p.id == Number(planId))[0].price / $rootScope.credit.pricing.filter(p => p.id == Number(planId))[0].numCredit;
      }
    }

    self.loadContent = function() {
      $translate(['SUBSCRIPTION_OPTION.CONTENT.STYLEPASS_BENEFIT_SUBTITLE_HK']).then(function(trans) {
        $scope.PERK_HK_SUBTITLE = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.STYLEPASS_BENEFIT_SUBTITLE_HK']);
      });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.STYLEPASS_BENEFIT_SUBTITLE_SG']).then(function(trans) {
        $scope.PERK_SG_SUBTITLE = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.STYLEPASS_BENEFIT_SUBTITLE_SG']);
      });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.STYLEPASS_BENEFIT_SUBTITLE_HK_ONE_TIME']).then(function(trans) {
        $scope.PERK_HK_SUBTITLE_ONE_TIME = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.STYLEPASS_BENEFIT_SUBTITLE_HK_ONE_TIME']);
      });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.STYLEPASS_LINE_1']).then(function(trans) {
        $scope.STYLEPASS_LINE_1 = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.STYLEPASS_LINE_1']);
      });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.ONE_TIME_LINE_1']).then(function(trans) {
        $scope.ONE_TIME_LINE_1 = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.ONE_TIME_LINE_1']);
      });
      $scope.MONTH_12_LINE = [];
      $translate(['SUBSCRIPTION_OPTION.CONTENT.MONTH_12_SAVING']).then(function(trans) {
        $scope.MONTH_12_LINE[0] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.MONTH_12_SAVING']);
      });
      // $translate(['SUBSCRIPTION_OPTION.CONTENT.MONTH_12_LINE_2']).then(function(trans){
      //   $scope.MONTH_12_LINE[2] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.MONTH_12_LINE_2']);
      // });
      // $translate(['SUBSCRIPTION_OPTION.CONTENT.MONTH_12_LINE_3']).then(function(trans){
      //   $scope.MONTH_12_LINE[3] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.MONTH_12_LINE_3']);
      // });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.MONTH_12_LINE_1']).then(function(trans) {
        $scope.MONTH_12_LINE[1] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.MONTH_12_LINE_1']);
      });
      $scope.MONTH_12_LINE[2] = this.getPlanAvgPrice(CONFIG.PLAN_SUBSCRIPTION_3);
      $scope.MONTH_12_LINE[3] = this.getPlanPrice(CONFIG.PLAN_SUBSCRIPTION_3);
      $rootScope.enableLog ? $log.info("12 Month Plan Price: " + $scope.MONTH_12_LINE[3]) : '';
      $scope.MONTH_12_PERK = [];
      $scope.MONTH_12_PERK[0] = Number($filter('translate')('SUBSCRIPTION_OPTION.CONTENT.MONTH_12_PER_CREDIT_PRICE'));
      $translate(['SUBSCRIPTION_OPTION.CONTENT.MONTH_12_PERK_1']).then(function(trans) {
        $scope.MONTH_12_PERK[1] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.MONTH_12_PERK_1']);
      });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.MONTH_12_PERK_2']).then(function(trans) {
        $scope.MONTH_12_PERK[2] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.MONTH_12_PERK_2']);
      });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.MONTH_12_PERK_3']).then(function(trans) {
        $scope.MONTH_12_PERK[3] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.MONTH_12_PERK_3']);
      });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.MONTH_12_PERK_4']).then(function(trans) {
        $scope.MONTH_12_PERK[4] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.MONTH_12_PERK_4']);
      });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.MONTH_12_PERK_5']).then(function(trans) {
        $scope.MONTH_12_PERK[5] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.MONTH_12_PERK_5']);
      });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.MONTH_12_PERK_6']).then(function(trans) {
        $scope.MONTH_12_PERK[6] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.MONTH_12_PERK_6']);
      });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.MONTH_12_PERK_7']).then(function(trans) {
        $scope.MONTH_12_PERK[7] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.MONTH_12_PERK_7']);
      });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.MONTH_12_PERK_8']).then(function(trans) {
        $scope.MONTH_12_PERK[8] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.MONTH_12_PERK_8']);
      });
      $scope.MONTH_3_LINE = [];
      $translate(['SUBSCRIPTION_OPTION.CONTENT.MONTH_3_SAVING']).then(function(trans) {
        $scope.MONTH_3_LINE[0] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.MONTH_3_SAVING']);
      });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.MONTH_3_LINE_1']).then(function(trans) {
        $scope.MONTH_3_LINE[1] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.MONTH_3_LINE_1']);
      });
      // $translate(['SUBSCRIPTION_OPTION.CONTENT.MONTH_3_LINE_2']).then(function(trans){
      //   $scope.MONTH_3_LINE[2]= $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.MONTH_3_LINE_2']);
      // });
      // $translate(['SUBSCRIPTION_OPTION.CONTENT.MONTH_3_LINE_3']).then(function(trans){
      //   $scope.MONTH_3_LINE[3]= $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.MONTH_3_LINE_3']);
      // });
      $scope.MONTH_3_LINE[2] = this.getPlanAvgPrice(CONFIG.PLAN_SUBSCRIPTION_5);
      $scope.MONTH_3_LINE[3] = this.getPlanPrice(CONFIG.PLAN_SUBSCRIPTION_5);
      $scope.MONTH_3_PERK = [];
      $scope.MONTH_3_PERK[0] = Number($filter('translate')('SUBSCRIPTION_OPTION.CONTENT.MONTH_3_PER_CREDIT_PRICE'));
      $translate(['SUBSCRIPTION_OPTION.CONTENT.MONTH_3_PERK_1']).then(function(trans) {
        $scope.MONTH_3_PERK[1] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.MONTH_3_PERK_1']);
      });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.MONTH_3_PERK_2']).then(function(trans) {
        $scope.MONTH_3_PERK[2] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.MONTH_3_PERK_2']);
      });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.MONTH_3_PERK_3']).then(function(trans) {
        $scope.MONTH_3_PERK[3] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.MONTH_3_PERK_3']);
      });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.MONTH_3_PERK_4']).then(function(trans) {
        $scope.MONTH_3_PERK[4] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.MONTH_3_PERK_4']);
      });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.MONTH_3_PERK_5']).then(function(trans) {
        $scope.MONTH_3_PERK[5] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.MONTH_3_PERK_5']);
      });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.MONTH_3_PERK_6']).then(function(trans) {
        $scope.MONTH_3_PERK[6] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.MONTH_3_PERK_6']);
      });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.MONTH_3_PERK_7']).then(function(trans) {
        $scope.MONTH_3_PERK[7] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.MONTH_3_PERK_7']);
      });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.MONTH_3_PERK_8']).then(function(trans) {
        $scope.MONTH_3_PERK[8] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.MONTH_3_PERK_8']);
      });
      $scope.MONTH_1_LINE = [];
      $scope.MONTH_1_LINE[0] = "";
      $translate(['SUBSCRIPTION_OPTION.CONTENT.MONTH_1_LINE_1']).then(function(trans) {
        $scope.MONTH_1_LINE[1] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.MONTH_1_LINE_1']);
      });
      // $translate(['SUBSCRIPTION_OPTION.CONTENT.MONTH_1_LINE_2']).then(function(trans){
      //   $scope.MONTH_1_LINE[2] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.MONTH_1_LINE_2']);
      // });
      // $translate(['SUBSCRIPTION_OPTION.CONTENT.MONTH_1_LINE_3']).then(function(trans){
      //   $scope.MONTH_1_LINE[3] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.MONTH_1_LINE_3']);
      // });
      $scope.MONTH_1_LINE[2] = this.getPlanAvgPrice(CONFIG.PLAN_SUBSCRIPTION_4);
      $scope.MONTH_1_LINE[3] = this.getPlanPrice(CONFIG.PLAN_SUBSCRIPTION_4);
      $scope.MONTH_1_PERK = [];
      $scope.MONTH_1_PERK[0] = Number($filter('translate')('SUBSCRIPTION_OPTION.CONTENT.MONTH_1_PER_CREDIT_PRICE'));
      $translate(['SUBSCRIPTION_OPTION.CONTENT.MONTH_1_PERK_1']).then(function(trans) {
        $scope.MONTH_1_PERK[1] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.MONTH_1_PERK_1']);
      });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.MONTH_1_PERK_2']).then(function(trans) {
        $scope.MONTH_1_PERK[2] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.MONTH_1_PERK_2']);
      });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.MONTH_1_PERK_3']).then(function(trans) {
        $scope.MONTH_1_PERK[3] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.MONTH_1_PERK_3']);
      });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.MONTH_1_PERK_4']).then(function(trans) {
        $scope.MONTH_1_PERK[4] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.MONTH_1_PERK_4']);
      });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.MONTH_1_PERK_5']).then(function(trans) {
        $scope.MONTH_1_PERK[5] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.MONTH_1_PERK_5']);
      });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.MONTH_1_PERK_6']).then(function(trans) {
        $scope.MONTH_1_PERK[6] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.MONTH_1_PERK_6']);
      });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.MONTH_1_PERK_7']).then(function(trans) {
        $scope.MONTH_1_PERK[7] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.MONTH_1_PERK_7']);
      });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.MONTH_1_PERK_8']).then(function(trans) {
        $scope.MONTH_1_PERK[8] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.MONTH_1_PERK_8']);
      });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.UPGRADE_PROMPT']).then(function(trans) {
        $scope.UPGRADE_PROMPT = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.UPGRADE_PROMPT']);
      });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.CHANGE_PLAN_PROMPT']).then(function(trans) {
        $scope.CHANGE_PLAN_PROMPT = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.CHANGE_PLAN_PROMPT']);
      });

      $scope.SG_ONE_TIME_PERK = [];
      $translate(['SUBSCRIPTION_OPTION.CONTENT.SG_ONE_TIME_PERK_1']).then(function(trans) {
        $scope.SG_ONE_TIME_PERK[1] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.SG_ONE_TIME_PERK_1']);
      });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.SG_ONE_TIME_PERK_2']).then(function(trans) {
        $scope.SG_ONE_TIME_PERK[2] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.SG_ONE_TIME_PERK_2']);
      });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.SG_ONE_TIME_PERK_3']).then(function(trans) {
        $scope.SG_ONE_TIME_PERK[3] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.SG_ONE_TIME_PERK_3']);
      });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.SG_ONE_TIME_PERK_4']).then(function(trans) {
        $scope.SG_ONE_TIME_PERK[4] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.SG_ONE_TIME_PERK_4']);
      });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.SG_ONE_TIME_PERK_5']).then(function(trans) {
        $scope.SG_ONE_TIME_PERK[5] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.SG_ONE_TIME_PERK_5']);
      });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.SG_ONE_TIME_PERK_6']).then(function(trans) {
        $scope.SG_ONE_TIME_PERK[6] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.SG_ONE_TIME_PERK_6']);
      });


      $scope.HK_ONE_TIME_PERK = [];
      $translate(['SUBSCRIPTION_OPTION.CONTENT.HK_ONE_TIME_PERK_1']).then(function(trans) {
        $scope.HK_ONE_TIME_PERK[1] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.HK_ONE_TIME_PERK_1']);
      });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.HK_ONE_TIME_PERK_2']).then(function(trans) {
        $scope.HK_ONE_TIME_PERK[2] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.HK_ONE_TIME_PERK_2']);
      });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.HK_ONE_TIME_PERK_3']).then(function(trans) {
        $scope.HK_ONE_TIME_PERK[3] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.HK_ONE_TIME_PERK_3']);
      });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.HK_ONE_TIME_PERK_4']).then(function(trans) {
        $scope.HK_ONE_TIME_PERK[4] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.HK_ONE_TIME_PERK_4']);
      });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.HK_ONE_TIME_PERK_5']).then(function(trans) {
        $scope.HK_ONE_TIME_PERK[5] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.HK_ONE_TIME_PERK_5']);
      });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.HK_ONE_TIME_PERK_6']).then(function(trans) {
        $scope.HK_ONE_TIME_PERK[6] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.HK_ONE_TIME_PERK_6']);
      });

      $scope.SG_MONTH_3_PERK = [];
      $translate(['SUBSCRIPTION_OPTION.CONTENT.SG_MONTH_3_PERK_1']).then(function(trans) {
        $scope.SG_MONTH_3_PERK[1] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.SG_MONTH_3_PERK_1']);
      });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.SG_MONTH_3_PERK_2']).then(function(trans) {
        $scope.SG_MONTH_3_PERK[2] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.SG_MONTH_3_PERK_2']);
      });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.SG_MONTH_3_PERK_3']).then(function(trans) {
        $scope.SG_MONTH_3_PERK[3] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.SG_MONTH_3_PERK_3']);
      });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.SG_MONTH_3_PERK_4']).then(function(trans) {
        $scope.SG_MONTH_3_PERK[4] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.SG_MONTH_3_PERK_4']);
      });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.SG_MONTH_3_PERK_5']).then(function(trans) {
        $scope.SG_MONTH_3_PERK[5] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.SG_MONTH_3_PERK_5']);
      });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.SG_MONTH_3_PERK_6']).then(function(trans) {
        $scope.SG_MONTH_3_PERK[6] = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.SG_MONTH_3_PERK_6']);
      });
      $translate(['SUBSCRIPTION_OPTION.CONTENT.STYLEPASS_BENEFIT_SUBTITLE_SG_MONTH_3']).then(function(trans) {
        $scope.PERK_SG_SUBTITLE_MONTH_3 = $sce.trustAsHtml(trans['SUBSCRIPTION_OPTION.CONTENT.STYLEPASS_BENEFIT_SUBTITLE_SG_MONTH_3']);
      });

      if ($rootScope.credit.selectedPlan == Number(CONFIG.PLAN_SUBSCRIPTION_3)) {
        var plan = $rootScope.credit.pricing.filter(p => p.id == Number(CONFIG.PLAN_SUBSCRIPTION_3))[0];
        $scope.selectedNumCredit = plan.numCredit;
        loadPerkContent(CONFIG.PLAN_SUBSCRIPTION_3);
      }
    }

  }])
  .directive('subscriptionOption', function() {
    return {
      restrict: 'E',
      templateUrl: 'scripts/components/subscription-option/subscription-option.html',
      controller: 'SubOptionCtrl'
    };
  })
  .directive('subscriptionOptionCheckout', function() {
    return {
      restrict: 'E',
      templateUrl: 'scripts/components/subscription-option/subscription-option-checkout.html',
      controller: 'SubOptionCtrl'
    };
  })
  .directive('subscriptionOptionProductListing', function() {
    return {
      restrict: 'E',
      templateUrl: 'scripts/components/subscription-option/subscription-option-product-listing.html',
      controller: 'SubOptionCtrl'
    };
  })
  .directive('subscriptionOptionPerk', function() {
    return {
      restrict: 'E',
      templateUrl: 'scripts/components/subscription-option/subscription-option-perk.html',
      controller: 'SubOptionCtrl'
    };
  });

'use strict';

/**
 * @ngdoc function
 * @name coutureApp.controller:CheckoutCtrl
 * @description
 * # CheckoutCtrl
 * Controller of the coutureApp
 */
angular.module('coutureApp')
  .controller('CheckoutCtrl', ["Session", "$sce", "$scope", "$rootScope", "$q", "$state", "DialogAlertService", "utilities", "$log", "$location", "AuthService", "RentalService", "CONFIG", "UserService", "RefDataService", "usSpinnerService", "$translatePartialLoader", "CartService", "$anchorScroll", "dateUtilities", "priceUtilities", "$filter", "CalendarService", "TransactionService", "BuyService", "$window", "envService", "WishlistService", "PromoCodeService", function(Session, $sce, $scope, $rootScope, $q, $state, DialogAlertService, utilities, $log, $location, AuthService, RentalService,CONFIG,
    UserService, RefDataService, usSpinnerService, $translatePartialLoader, CartService, $anchorScroll,dateUtilities,priceUtilities,$filter,CalendarService,TransactionService,BuyService, $window, envService, WishlistService, PromoCodeService) {

    var self = this;
    self.isShipToHKOnly = CONFIG.SHIPPING_TO_HONG_KONG_ONLY;

    this.$onInit = function() {
      if($rootScope.geoLocation.country == 'SG') {
        $window.Stripe.setPublishableKey(envService.read('STRIP_KEY_SG'));
      }
      $rootScope.showLgLogo = false;
      this.isOrderSummaryActive = true;
      this.isShippingActive = true;
      this.isItemsActive = true;

      this.productIndex = 0;
      self.FREE_SHIPPING_SIDE_BAR_0 = CONFIG.FREE_SHIPPING_SIDE_BAR_0;
      self.FREE_SHIPPING_SIDE_BAR_1 = CONFIG.FREE_SHIPPING_SIDE_BAR_1;
      self.FREE_SHIPPING_SIDE_BAR_2 = CONFIG.FREE_SHIPPING_SIDE_BAR_2;
      self.FREE_SHIPPING_SIDE_BAR_3 = CONFIG.FREE_SHIPPING_SIDE_BAR_3;

      // Double submit locks
      self.lk_checkout = false;
      self.acceptedTnC = false;
      self.editShippingToggle = false;
      self.billingAddress = {country:CONFIG.DEFAULT_COUNTRY};
      self.stReq = {};
      self.isHideCreditCardDetails = true;
      self.isAcceptedTC = false;
      if (self.isShipToHKOnly){
        self.shippingAddress = {country:CONFIG.HONG_KONG};
      }else{
        self.shippingAddress = {country:CONFIG.DEFAULT_COUNTRY};
      }

      self.rentalPrice = 0;
      self.rentalProtectionFee = 0;
      self.shippingFee = 0;
      self.buyShippingFee = 0;
      self.totalDue = 0;
      self.originalValue= 0;
      self.usualPricePerCredit = priceUtilities.getOriginalCreditPrice();

      self.error_shippingInfo = "Missing Shipping Info";
      self.error_shippingAddress = "Missing Shipping Address";
      self.error_billingAddress = "Missing Billing Address";
      self.error_paymentInfo = "Missing Payment Info";
      self.error_termsCondition = "You must accept Terms of Service";
      self.error_deliveryDate = "You must select delivery date";
      self.error_txn = null;
      self.error_ship_bill_info = null;
      self.areaName = CONFIG.AREAS;
      self.product_currency = priceUtilities.getCurrency();
      self.promoCode = null;

      self.purchaseOrderDate = new Date(moment().startOf('day').format('LLLL'));//moment(Number().format("YYYYMMDD");

      self.selectedCheckoutProductsMissingDate = [];
      self.returnedCalculatedPrice = null;
      self.topUp={};
      self.topUp.eligibleOneCreditPrice= 0;
      self.applyCredits = true;
      //old Sub
      $scope.showSubscriptionOptionsCheckout= false;

      $scope.protectionTooltip=$sce.trustAsHtml('Wear without worry!</br></br>Rental Protection covers most normal wear and tear in the case of minor stains or other repairable damage up to HK$ 200. For serious damage or other loss you may be charged the sale price. StylePass members receive exclusive sale pricing depending on status level.<br/><br/>Please read our <a href="https://stylecarousel.com/landing/terms-and-conditions/" style="display:contents">Terms of Service</a> to learn more. ');
      if($rootScope.geoLocation.country == CONFIG.COUNTRY_CURRENCY_CODE.SG.country_code){
        $scope.protectionTooltip=$sce.trustAsHtml('Wear without worry!</br></br>Rental Protection covers most normal wear and tear in the case of minor stains or other repairable damage up to SG$ 35. For serious damage or other loss you may be charged the sale price. StylePass members receive exclusive sale pricing depending on status level.<br/><br/>Please read our <a href="https://stylecarousel.com/landing/terms-and-conditions/" style="display:contents">Terms of Service</a> to learn more. ');
      }
      var rentals = $rootScope.cc.cart.filter(p=> p.transactionType == CONFIG.TRANSACTION_TYPE_RENT);
      var purchases = $rootScope.cc.cart.filter(p=> p.transactionType == CONFIG.TRANSACTION_TYPE_BUY);
      self.isShowRentalOrders = rentals ? rentals.length > 0 : false;
      self.isShowPurchaseOrders = purchases ? purchases.length > 0 : false;
      self.memberPrice = priceUtilities.getMemberPrice();
      showMemberPrice();
      try {
        if (!AuthService.isAuthenticated()) {
          if(utilities.isShowMainRegion()){
            $state.go('main');
          } else {
            $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
          }
        } else if ($location.path().includes('checkout')) {
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - CheckoutCtrl") : '';
          if ($rootScope.credit.balance){
            self.topUp.currentPlanMonth = $rootScope.credit.balance.numContractMonths;
          }
          if ($rootScope.cc.cart.length !== 0){
            self.promoCode = null; // promo code is not supported in rental checkout under credit system  (yet)
            $scope.temp_promoCode = self.promoCode;
            var productID = $rootScope.cc.cart[0].product != null ? $rootScope.cc.cart[0].product.id : $rootScope.cc.cart[0].productID;
            self.validateItemsInCart();
            self.initializeCheckoutPage(productID);
          }else{
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":CheckoutCtrl:$onInit - Err initialize no item in cart"):"";
            if(utilities.isShowMainRegion()){
              $state.go('main');
            } else {
              $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
            }
          }

          self.countries = RefDataService.getCountryList();
          self.availableShippingCountries = RefDataService.getAvailableShippingCountries();

          // Used for data passing between update payment and checkout
          if ($state.params.ctx) {
            self.ctx = $state.params.ctx;
          }
        }
      }catch(err) {
        $rootScope.enableLog ? $log.error($rootScope.UUID + ":CheckoutCtrl:$onInit - Err initialize " + err):"";
        if(utilities.isShowMainRegion()){
          $state.go('main');
        } else {
          $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
        }
      }
    }

    $translatePartialLoader.addPart('checkout');

    /////////////////////////////////////////
    // SELECT THE PRE-DEFINED CITY FROM THE DROP DOWN LIST.
    /////////////////////////////////////////
    // this.setSelected = function(type,selectedValue) {
      // switch (type) {
      //   case 'BILLING_ADDRESS':
      //     self.billingAddress.city = selectedValue.name;
      //     break;
      //   case 'SHIPPING_ADDRESS':
      //     self.shippingAddress.city = selectedValue.name;
      //     break;
      // }
    // }

    //////////////////////////////////////////
    //SORT THE ITEM IN THE CART BASED ON START_DATE
    //////////////////////////////////////////
    $scope.min = function(arr) {
      return $filter('min')($filter('map')(arr, 'selectedDate.START_DATE'));
    }

    /**************************
    //CHANGE THE RENTAL DATE
    **************************/
    this.changeDate = function(SelectedItem) {

      self.error_txn = null;

      var rental = {
        cartID:SelectedItem.cartID, 
        product:SelectedItem.product, 
        size:SelectedItem.size , 
        selectedDate:null, 
        transactionType: SelectedItem.transactionType, 
        itemCondition: SelectedItem.itemCondition,
        bundleID: SelectedItem.bundleID
      };

      //utilities.loadAllowedDatesByMerchant(rental.product.owner.id, rental.product.id);
      $rootScope.cc.allowedDates.DATES_BY_MERCHANT = {};
      RentalService.getAllowedDatesV4($rootScope.geoLocation.country, SelectedItem.product.owner.id, SelectedItem.product.id).$promise.then(
        function(resp){
          var tempDate = {'INSTANT_RENTAL':null, 'RENTAL_REQUEST':null}
          var irDates =resp.ir.map(function(value) {
            return value;
          });
          var rrDates =resp.rr.map(function(value) {
            return value;
          });

          tempDate.INSTANT_RENTAL = irDates;
          tempDate.RENTAL_REQUEST = rrDates;
          $rootScope.cc.allowedDates.DATES_BY_MERCHANT = tempDate;
      //arg1 = (null=no CheckoutButton)
      CalendarService.openCalendar(null, function() {
        if (rental.cartID && rental.selectedDate) {
          rental.bundleID = utilities.generateBundleID(rental.product, rental.selectedDate.START_DATE, rental.selectedDate.RETURN_DATE, rental.cartID);
          //REMOVE THE PRODUCT ID WHICH HAVE NO DATE SELECTED IN THE ERROR DISPLAY ARRAY.
          if (self.selectedCheckoutProductsMissingDate.indexOf(rental.cartID) != -1){
            self.selectedCheckoutProductsMissingDate.splice(self.selectedCheckoutProductsMissingDate.indexOf(rental.cartID),1)
          }
          rental._selectedToCheckout = true;
          utilities.replaceItemInArray(rental, $rootScope.cc.cart);
          //STORE PRODUCT ID IN LOCAL SERVICE
          var sessionCartDetails = {
            cartID:rental.cartID, 
            productID:rental.product.id, 
            size:rental.size, 
            startDate: rental.selectedDate.START_DATE,
            returnDate: rental.selectedDate.RETURN_DATE,
            transactionType: rental.transactionType, 
            price: {
              purchasePrice: rental.product.purchasePrice,
              originalPrice: rental.product.price,
              salePrice: rental.product.salePrice
            },
            itemCondition: rental.lowestCondition,
            bundleID: rental.bundleID,
            country: $rootScope.geoLocation.country
          };
          Session.updateCartV2(sessionCartDetails);

          //STORE PRODUCT ID IN REMOTE SERVICE
          var cartDetails = {
                  'cartID' : rental.cartID, 
                  'productID' : rental.product.id, 
                  'size' : rental.size, 
                  'startDate' : rental.selectedDate.START_DATE, 
                  'returnDate' : rental.selectedDate.RETURN_DATE, 
                  'transactionType' : rental.transactionType, 
                  'itemCondition' : rental.itemCondition,
                  'bundleID': rental.bundleID,
                  'country': $rootScope.geoLocation.country
          };
          CartService.addCart(cartDetails);

          calculateRentalCredit();
          CartService.captureAddToCart(rental.product, rental);
        }
      }, function(date, endDate) {

        rental.selectedDate={'START_DATE':null, 'RETURN_DATE':null}
        rental.selectedDate.START_DATE = moment(date).format('x');
        rental.selectedDate.RETURN_DATE= moment(endDate).format('x');
      }, utilities.getAvailableDatesWithSizeByMerchant(rental.size,rental.product,rental.itemCondition),
      rental.product.credit, CONFIG.DEFAULT_RENTAL_WEEK
      );
    });


    };

    /**************************
    //SET THE SHIPPING COUNTRY AS PER THE DROP DOWN LIST
    **************************/
    this.setShippingCountry = function(inputCountry) {
      self.shippingAddress.country = null;
      for (var index in self.countries) {
        if (self.countries[index].name === inputCountry) {
          self.shippingAddress.country = self.countries[index].name;
          break;
        }
      }
    }

    /////////////////////////////////////////
    //COPY BILLING ADDRESS TO ADDRESS LOGIC
    /////////////////////////////////////////
    this.isCopyShippingInfoToBillingInfo = function() {
      if ($scope.isSameShippingAddress && ((self.isShipToHKOnly && self.shippingAddress.country == CONFIG.HONG_KONG) || !self.isShipToHKOnly)){
        return true;
      }else{
        return false;
      }
    }

    /**************************
    //COPY THE SHIPPING ADDRESS TO BILLING ADDRESS
    **************************/
    this.copyShippingAddressToBillingAddress = function() {
      self.billingAddress = angular.copy(self.shippingAddress);
      self.disable_Billing_CityDDL = self.billingAddress.country != CONFIG.HONG_KONG ? true:false;
    }

    /**************************
    //GET THE PICKUP DATE
    **************************/
    // this.getPickupDate = function() {
    //   return utilities.getPickupDate($rootScope.cc.cart[self.productIndex]);
    // }

    /**************************
    //GET THE RETURN DATE
    **************************/
    // this.getReturnDate = function() {
    //   return utilities.getReturnDate($rootScope.cc.cart[self.productIndex]);
    // }

    /**************************
    //ADD SPECIAL LOGIC WHEN USER ENTER OTHER BRAND, THE req_listing WILL REMAINS '-- OTHER BRAND --'
    //BUT THE ACTUAL BRAND WILL BE STORED IN TAG. HOWEVER IT WILL NOT GOING TO DISPLAY ON SCREEN.
    **************************/
    this.getDisplayBrand = function(product){
      return titleCase(utilities.getCustomBrandName(product));
    }
    function titleCase(str) {
      var splitStr = str.toLowerCase().split(' ');
      for (var i = 0; i < splitStr.length; i++) {
          splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      return splitStr.join(' ');
   }
    /**************************
    //UPDATE PROMOTION CODE TO THE PRICING
    **************************/
    this.applyPromo = function(){
      self.error_txn = null;
      self.promoCode = $scope.temp_promoCode;
      self.updateTopUpCreditPrice();
      usSpinnerService.spin('spinner');
    }

    /**************************
    //GET PRODUCT DISCOUNT VALUE
    **************************/
    this.getDiscountAmount = function(product){
      if (product && self.returnedCalculatedPrice){
        return self.returnedCalculatedPrice.products.filter(p=> p.productSummary.productId == product.id).map(p=> p.rentalOrderBreakdown.originalWeeklyRentalFee - p.rentalOrderBreakdown.weeklyRentalFee)[0];
      }else{
        return 0;
      }
    }


    /**************************
    //THE CHECKOUT PAGE INITIALIZE METHOD, LOAD THE SPECIFIC ITEM IN THE CART AND PREPARE THE PAGE FOR DISPLAY
    **************************/
    this.initializeCheckoutPage = function(id) {

      if (Session.getSelectedPlan()==null){
        UserService.storeSelectedPlan(CONFIG.PLAN_ONE_TIME);
      } else{
        UserService.storeSelectedPlan(Session.getSelectedPlan());
      }
      RentalService.getSubscriptionTopupPricing().$promise.then(function (resp) {
        $rootScope.credit.pricing = [];
        $rootScope.credit.pricing = resp;
      });

      self.promoCode = null;
      $scope.temp_promoCode = self.promoCode;

      //PRE-SELECTED ALL PRODUCTS IN CART
      $rootScope.cc.cart.filter(p=> p._selectedToCheckout == undefined || p._selectedToCheckout == false)
      .map(item=> item._selectedToCheckout = true);

      usSpinnerService.spin('spinner');
      // Do a pre-rental check.  Make sure user has credit card and shipping address.
      RentalService.preCheck().$promise.then(
        function(resp) {

          var ctx = self.ctx || {};
          self.pid = id;
          ctx.last4 = resp.last4;
          self.last4=resp.last4;

          if (resp.shippingAddress){
            ctx.shippingAddress = resp.shippingAddress;
            self.shippingAddress = ctx.shippingAddress;
          }else{
            //NEWLY REGISTER CUSTOMER WITHOUT ENTER DELIVERY ADDRESS
            resp.shippingAddress = {"phone":"","address1":"","address2":"","address3":"","city":"","district":"","country":CONFIG.DEFAULT_COUNTRY,"postalCode":"","type":1};
            self.shippingAddress = resp.shippingAddress;
          }

          if (resp.billingAddress){
            ctx.billingAddress = resp.billingAddress;
            self.billingAddress = ctx.billingAddress;
          }else{
            //NEWLY REGISTER CUSTOMER WITHOUT ENTER DELIVERY ADDRESS
            resp.billingAddress = angular.copy(resp.shippingAddress);
            resp.billingAddress.type = CONFIG.ADDRESS_TYPE_BILLING;
            self.billingAddress = angular.copy(self.shippingAddress);
            self.billingAddress.type = CONFIG.ADDRESS_TYPE_BILLING;
          }

          //CC-519 SHIPPING ONLY TO HK
          if (self.isShipToHKOnly && self.shippingAddress.country != CONFIG.HONG_KONG){
            self.shippingAddress.country = CONFIG.HONG_KONG;
            self.shippingAddress.city = self.areaName[0].name;
          }

          if (resp.hasBilling) {
            self.hasBilling = true;
            self.isHideCreditCardDetails = true;
          } else {
            self.hasBilling = false;
            self.isHideCreditCardDetails = false;
          }

          self.shippingAddress.firstname = $rootScope.user.firstName;
          self.shippingAddress.lastname = $rootScope.user.lastName;

          self.disable_Shipping_CityDDL = self.shippingAddress.country != CONFIG.HONG_KONG ? true:false;
          self.disable_Billing_CityDDL = self.billingAddress.country != CONFIG.HONG_KONG ? true:false;

          usSpinnerService.stop('spinner');
        },
        function(err) {
          usSpinnerService.stop('spinner');
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":CheckoutCtrl:checkout - Error: " + err):"";
        }
      );
      calculateTransactionAmount();
    }

    /**************************
    //SCROLL BACK TO TOP ONCE THE CHECKOUT HAS BEEN COMPLETED
    **************************/
    this.GotoTop = function(){
      $anchorScroll('top');
    }

    function comparer(otherArray){
      return function(current){
        return otherArray.filter(function(other){
          return other.value == current.value && other.display == current.display
        }).length == 0;
      }
    }

    /**************************
    //PRODUCT SELECT/UNSELECT FOR CHECKOUT
    **************************/
    this.selectedProduct = function(selectedItem){

      self.error_txn = null;

      if ((!selectedItem.selectedDate || !selectedItem.selectedDate.START_DATE) && selectedItem.transactionType == CONFIG.TRANSACTION_TYPE_RENT){
        if (self.selectedCheckoutProductsMissingDate.indexOf(selectedItem.cartID) == -1){
          self.selectedCheckoutProductsMissingDate.push(selectedItem.cartID);
        }
        selectedItem._selectedToCheckout = false;

      }else if (selectedItem._selectedToCheckout){
        self.selectedCheckoutProductsMissingDate = [];
        selectedItem._selectedToCheckout = false;
        calculateTransactionAmount();

      }else{
        self.selectedCheckoutProductsMissingDate = [];
        selectedItem._selectedToCheckout = true;
        calculateTransactionAmount();
     }
     var rentals = $rootScope.cc.cart.filter(p=> p.transactionType == CONFIG.TRANSACTION_TYPE_RENT && p._selectedToCheckout);
     var purchases = $rootScope.cc.cart.filter(p=> p.transactionType == CONFIG.TRANSACTION_TYPE_BUY && p._selectedToCheckout);
     self.isShowRentalOrders = rentals ? rentals.length > 0 : false;
     self.isShowPurchaseOrders = purchases ? purchases.length > 0 : false;
    }

    /**************************
    //REMOVE ITEM FROM CART
    **************************/
    this.removeCart = function(removedItem) {
      self.error_txn = null;

      this.moveToWishlist(removedItem);
      CartService.deleteCart(removedItem.cartID).$promise.then(
        function(resp) {
          Session.removeCart(removedItem.cartID);
          var itemIndexInCart;
          itemIndexInCart = $rootScope.cc.cart.findIndex(p=> (p.cartID == removedItem.cartID));
          if (itemIndexInCart != -1){
            $rootScope.cc.cart.splice(itemIndexInCart,1);
          }
          $state.reload();
        },
        function(err) {
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":CheckoutCtrl:removeCart - Error: " + err):"";
        }
      );
    }

    this.moveToWishlist = function(cart){
      var wishlistInfo = {
        "userID": null,
        "email": null,
        "productId": cart.productID,
        "size": cart.size,
        "country": $rootScope.geoLocation.country,
        "itemCondition": cart.itemCondition,
        "subscribed": true
      };
      
      WishlistService.addToWishlist(wishlistInfo).$promise.then(
        function(resp) {
          $rootScope.enableLog ? $log.info($rootScope.UUID + ':checkout:moveToWishlist - moveToWishlist success') : '';
        },
        function(err) {
          $rootScope.enableLog ? $log.error($rootScope.UUID + ':checkout:moveToWishlist - moveToWishlist error: ' + err ) : '';
        }
      );

    }

    /**************************
    //MAIN CHECKOUT PROCESS
    **************************/
    this.requestRental = function() {

      self.error_txn = null;
      self.error_ship_bill_info = null;
      self.lk_checkout = true;
      self.GotoTop();

      // select all cart items
      $rootScope.cc.cart.forEach(function(item) {
        if(!item._selectedToCheckout) {
          item._selectedToCheckout = true;
        }
      });
      var selectedCheckoutProducts = $rootScope.cc.cart.filter(p=> p._selectedToCheckout == true).map(item=> {
        var obj = {};
        obj['cartID'] = item.cartID;
        obj['productId'] = item.product.id;
        obj['size'] = item.size;
        obj['startDate'] = item.transactionType == CONFIG.TRANSACTION_TYPE_RENT ? item.selectedDate.START_DATE : self.purchaseOrderDate;
        obj['endDate'] = item.transactionType == CONFIG.TRANSACTION_TYPE_RENT ? item.selectedDate.RETURN_DATE : self.purchaseOrderDate;
        obj['transactionType'] = item.transactionType;
        obj['itemCondition'] = item.itemCondition;
        obj['bundleID'] = item.bundleID;
        obj['deliverBoth'] = item.deliverBoth;
        return obj;
      });

      if (selectedCheckoutProducts.length < 1){
        self.error_txn = "Please select at least one product for checkout.";
        self.lk_checkout = false;
        return;
      }

      usSpinnerService.spin('spinner');

      if (!self.isHideCreditCardDetails) {
        self.validateCard().then(function(resp){
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":CheckoutCtrl:requestRental - Saved card"):"";
          self.topUpAndSubmitRequests(selectedCheckoutProducts);
          /*var hasBundles = $rootScope.cc.cart.filter(p=> p.bundleID !== null);
          if(hasBundles && hasBundles.length > 1){
            usSpinnerService.stop('spinner');
            self.isSubmitted = false;
            self.lk_checkout = false;
            $rootScope.enableLog ? $log.info($rootScope.UUID + ":CheckoutCtrl:hasBundles"):"";
            DialogAlertService.checkoutPreference(self.usualPricePerCredit, self.rentalFeePerDay);
          } else {
            $rootScope.enableLog ? $log.info($rootScope.UUID + ":CheckoutCtrl:requestRental - Saved card"):"";
            self.topUpAndSubmitRequests(selectedCheckoutProducts);
          }*/
        },function(err){
          try {
            if (!self.error_txn){
              self.error_txn = err.data && err.data.reasons && err.data.reasons[0] ? $filter('translate')("GENERAL.ERROR."+ err.data.reasons[0].code) : $filter('translate')("GENERAL.ERROR.UNABLE_TO_PROCESS_PAYMENT");
            }
          } catch (err) {
            self.error_txn = $filter('translate')("GENERAL.ERROR.UNABLE_TO_PROCESS_PAYMENT");
            if(err.data && err.data.reasons && err.data.reasons[0]){
              switch (err.data.reasons[0].code) {
                case "FAILED_TO_CREATE_CUSTOMER_OBJECT":
                  self.error_txn = $filter('translate')('GENERAL.ERROR.FAILED_TO_CREATE_CUSTOMER_OBJECT');
                  break;
                case "CARD_DECLINED":
                  self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_DECLINED');
                  break;
                case "CARD_INCORRECT_CVC":
                  self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_INCORRECT_CVC');
                  break;
                case "CARD_INCORRECT_NUMBER":
                  self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_INCORRECT_NUMBER');
                  break;
                case "CARD_EXPIRED":
                  self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_EXPIRED');
                  break;
                default:
                  self.error_txn = $filter('translate')('GENERAL.ERROR.UNABLE_TO_PROCESS_PAYMENT');
                  break;
              }
            } else {
              self.error_txn = $filter('translate')('GENERAL.ERROR.UNABLE_TO_PROCESS_PAYMENT');
            }
          } finally {
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":CheckoutCtrl:requestRental - Err No card saved" + err):"";
            self.lk_checkout = false;
            usSpinnerService.stop('spinner');
          }
        });
      }else{

        $rootScope.enableLog ? $log.info($rootScope.UUID + ":CheckoutCtrl:requestRental - Other flow no card change and just submit request"):"";
        self.topUpAndSubmitRequests(selectedCheckoutProducts);
        
        /*var hasBundles = $rootScope.cc.cart.filter(p=> p.bundleID !== null);
        if(hasBundles && hasBundles.length > 1){
          usSpinnerService.stop('spinner');
          self.isSubmitted = false;
          self.lk_checkout = false;
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":CheckoutCtrl:hasBundles"):"";
          DialogAlertService.checkoutPreference(self.usualPricePerCredit, self.rentalFeePerDay);
        } else {
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":CheckoutCtrl:requestRental - Other flow no card change and just submit request"):"";
          self.topUpAndSubmitRequests(selectedCheckoutProducts);
        }*/
      }
    };


    /**************************
    //FINALIZE SHIPPING AND THE RENTAL PROCESS
    **************************/
    self.submitTransactionRequest = function(selectedCheckoutProducts){

      var promises = [];
      var updateShippingAddress = $scope.checkoutForm ? ($scope.checkoutForm.shipAdd1.$dirty || $scope.checkoutForm.shipAdd2.$dirty ||
        $scope.checkoutForm.shipCountry.$dirty || $scope.checkoutForm.shipCity.$dirty || $scope.checkoutForm.shipDistrict.$dirty ||
        $scope.checkoutForm.shipPhone.$dirty || $scope.checkoutForm.shipPostalCode.$dirty) : false;

      if(updateShippingAddress) {
        promises.push(UserService.updateAddress(self.shippingAddress).$promise);
      }

      $q.all(promises).then(function() {
        TransactionService.requestMultiItems({
          'products':selectedCheckoutProducts,
          'promo':self.promoCode, 
          'currency': $rootScope.geoLocation.currency, 
          'exchangeRate': $rootScope.geoLocation.rate,
          'destinationCountry': $rootScope.geoLocation.country,
          'topUpInvoiceReferenceNumber':$scope.topUpInvoiceReferenceNumber, 
          'subscriptionInvoiceReferenceNumber': $scope.subscriptionInvoiceReferenceNumber
        }).$promise.then(
          function(resp){
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":CheckoutCtrl:submitTransactionRequest#requestMultiItems - Checkout request submitted successfully. ${resp.checkoutRef}"):"";
          
          //[START] CC-1082 for analytics
          var fee = {
            'checkoutReference': resp.checkoutRef,
            'orderSubTotal': self.rentalCreditTotalAmount + self.purchasePriceSubTotal,
            'subscriptionFee': self.topUp.subCreditPrice,
            'shippingFee': self.shippingFee + self.buyShippingFee,
            'promoDiscount': self.topUp.subOrCreditDiscount,
            'rentalCredit': (self.rentalCredit-self.topUp.extraCredit),
            'rentalCreditValue': (self.rentalCredit-self.topUp.extraCredit) * self.usualPricePerCredit,
            'stylePassDiscount': (self.topUp.extraCredit * self.usualPricePerCredit - self.topUp.extraCreditPrice),
            'totalDue': self.totalDue + self.purchasePriceSubTotalWithShipping
          };
          RentalService.captureCheckout({'products':selectedCheckoutProducts}, fee);
          //[END] CC-1082 for analytics
          self.removeCartItemsAfterCheckedout(resp.checkoutRef,resp.rentalId,true );
        },function(err){
          usSpinnerService.stop('spinner');
          calculateTransactionAmount();
          self.lk_checkout = false;
          var errorLog;
          try{
            errorLog = err.error ? err.error.message : err.data.reasons[0].message;
            if (err.data){
              switch (err.data.reasons[0].code) {
                case "DUPLICATE_RENTAL_REQUEST":
                  self.error_txn = err.data.reasons[0].message;
                  self.GotoTop();
                  break;
                case "FAILED_TO_APPLY_PROMO":
                  self.error_txn = $filter('translate')('GENERAL.ERROR.FAILED_TO_APPLY_PROMO');
                  self.GotoTop();
                  break;
                case "START_DATE_NOT_ALLOWED":
                  self.error_txn = err.data.reasons[0].message;
                  self.GotoTop();
                  break;
                case "CREDIT_BALANCE_NOT_ENOUGH_ONLY":
                  // self.error_txn = 'Your balance has only ' + err.data.reasons[0].message + ' credit(s) but this checkout requires ' + self.rentalCredit + '. Please top up and try again.'
                  self.error_txn = 'Your balance has been topped up successfully. Please submit the order again to use the credits';
                  self.GotoTop();
                  break;
                case "FAILED_TO_CREATE_CUSTOMER_OBJECT":
                  self.error_txn = $filter('translate')('GENERAL.ERROR.FAILED_TO_CREATE_CUSTOMER_OBJECT');
                  self.GotoTop();
                  break;
                case "CARD_DECLINED":
                  self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_DECLINED');
                  self.GotoTop();
                  break;
                case "CARD_INCORRECT_CVC":
                  self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_INCORRECT_CVC');
                  self.GotoTop();
                  break;
                case "CARD_INCORRECT_NUMBER":
                  self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_INCORRECT_NUMBER');
                  self.GotoTop();
                  break;
                case "CARD_EXPIRED":
                  self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_EXPIRED');
                  self.GotoTop();
                  break;
                default:
                  self.error_txn = "System Error - Please try again later. (" + err.data.reasons[0].code+")";
                  self.GotoTop();
                  break;
              }
            }else{
              self.error_txn = errorLog;
            }
          }catch(moreErr){
            self.error_txn = $filter('translate')("GENERAL.ERROR.UNABLE_TO_PROCESS_PAYMENT");
            errorLog = moreErr;
          }finally{
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":CheckoutCtrl:submitTransactionRequest - Checkout failed. "+ errorLog):"";
          }
        });

      },function(err){
        usSpinnerService.stop('spinner');
        self.lk_checkout = false;
        self.error_ship_bill_info= "Shipping address is too long, please try again.";
        $rootScope.enableLog ? $log.error($rootScope.UUID + ":CheckoutCtrl:submitTransactionRequest - Update shipping address error. "):"";
      });
    }


    /**************************
    //REMOVE ITEM FROM CART SERVICE WHERE STORE SHOPPING CART IN DB
    //pid : Product ID
    //orderRefID: Order reference ID
    //cartItemIndex : Product Index within the shopping cart
    //isShowDialogBox: DISPLAY CONFIRMATION DIALOG
    **************************/
    self.removeCartItemsAfterCheckedout = function(checkoutRefID, orderIDs, isShowDialogBox){
      var checkedoutProducts = $rootScope.cc.cart.filter(p=> p._selectedToCheckout == true).map(item=> {
        var obj = {};
        obj['cartID'] = item.cartID;
        obj['productId'] = item.product.id;
        obj['size'] = item.size;
        obj['startDate'] = item.transactionType == CONFIG.TRANSACTION_TYPE_RENT ? item.selectedDate.START_DATE : self.purchaseOrderDate;
        obj['endDate'] = item.transactionType == CONFIG.TRANSACTION_TYPE_RENT ? item.selectedDate.RETURN_DATE : self.purchaseOrderDate;
        obj['transactionType'] = item.transactionType;
        obj['itemCondition'] = item.itemCondition;
        return obj;
      });

      //STORE THE SELECTED CHECKOUT PRODUCTS IN AN ARRAY ALONG WITH THE START AND END RENTAL DATE FOR CONFIRMATION DISPLAY.
      var checkoutProductsDetails = $rootScope.cc.cart.filter(p=> p._selectedToCheckout == true).map(item=> {
        var obj = {};
        obj['cartID'] = item.cartID;
        obj[item.product.id] = item.product;
        obj['size'] = item.size;
        obj['START_DATE'] = item.transactionType == CONFIG.TRANSACTION_TYPE_RENT ? item.selectedDate.START_DATE : self.purchaseOrderDate;
        obj['END_DATE'] = item.transactionType == CONFIG.TRANSACTION_TYPE_RENT ? item.selectedDate.END_DATE : self.purchaseOrderDate;
        obj['transactionType'] = item.transactionType;
        obj['itemCondition'] = item.itemCondition;
        return obj;
      });

      //ADD THE PRODUCT DETAILS AND RENTAL START AND END DATE IN THE OBJECT FOR CONFIRMATION PAGE TO DISPLAY.
      //var checkoutConfirmationDetails = [];
      var itemIndex;
      self.returnedCalculatedPrice.products.forEach((item, i) => {
        itemIndex = $rootScope.cc.cart.findIndex(p=> p.product.id === item.productSummary.productId 
          && p.size === item.productSummary.size 
          && p.itemCondition === item.productSummary.condition);
        item._details = $rootScope.cc.cart[itemIndex].product;
        item._details.size = $rootScope.cc.cart[itemIndex].size;
        item._selectedDate = $rootScope.cc.cart[itemIndex].selectedDate;
        item._additionalRentalFee = $rootScope.cc.cart[itemIndex].product.credit * self.rentalFeePerDay

        var cart = $rootScope.cc.cart[itemIndex];

        item.rentalWeeks = this.getRentalWeeks(cart.selectedDate.START_DATE, cart.selectedDate.RETURN_DATE);
        item.additionalDays = this.getRentalAdditionalDays(cart.selectedDate.START_DATE, cart.selectedDate.RETURN_DATE);
        item.rentalDays = this.getRentalDays(cart.selectedDate.START_DATE, cart.selectedDate.RETURN_DATE);

        var checkoutConfirmationDetails = {
          '_cartID' : cart.cartID,
          '_size' : cart.size,
          '_selectedDate' : cart.selectedDate,
          '_brandName' : utilities.getCustomBrandName(cart.product),
          '_productDescription' : cart.product.cleanProductDescription,
          '_purchasePrice' : priceUtilities.getAmountByRate(cart.product.purchasePrice),
          '_transactionType' : cart.transactionType,
          '_itemCondition' : cart.itemCondition,
          '_bundleID' : cart.bundleID,
          '_deliverBoth' : cart.deliverBoth
        };
        item._checkoutConfirmationDetails = checkoutConfirmationDetails;
      });

      var promises = [];

      //REMOVE THE CHECKED OUT PRODUCTS.
      checkedoutProducts.forEach(function(checkoutPd){
        promises.push(CartService.deleteCart(checkoutPd.cartID).$promise);
        Session.removeCart(checkoutPd.cartID);
      });
      $rootScope.cc.cart = $rootScope.cc.cart.filter(pd=> checkedoutProducts.map(m=>m.cartID).findIndex(i=> i == pd.cartID) == -1);

      $q.all(promises).then(function(resp){
        self.lk_checkout = false;
        usSpinnerService.stop('spinner');
        var deleteStatus = resp.filter(result=> result.delete == false);
        if (deleteStatus.length < 1){
          if (isShowDialogBox){

            //UPDATE THE DISPLAY ONLY FIELD FOR CONFIRMATION PAGE
            self.returnedCalculatedPrice.order._applyCredits = self.applyCredits;
            self.returnedCalculatedPrice.order._totalDue = self.totalDue;
            self.returnedCalculatedPrice.order._isShowRentalCredits = (self.currentCreditBalance.available + self.topUp.subCredit) > 0;
            self.returnedCalculatedPrice.order._promoDiscount = self.topUp.subOrCreditDiscount;
            self.returnedCalculatedPrice.order._rentalCreditExclTopUp = self.rentalCredit - self.topUp.extraCredit;
            self.returnedCalculatedPrice.order._rentalCreditExclTopUpAmt = (self.rentalCredit - self.topUp.extraCredit) * self.usualPricePerCredit;
            DialogAlertService.openConfirmation(checkoutRefID, orderIDs, self.returnedCalculatedPrice, self.topUp, self.selectedPurchaseOrders, function() {
              $rootScope.enableLog ? $log.error($rootScope.UUID + ":CheckoutCtrl:removeCartItemsAfterCheckedout - Successfully remove cart after checkout. "):"";

              if ($rootScope.cc.cart.length > 0){
                $state.reload();
              }else{
                if(utilities.isShowMainRegion()){
                  $state.go('main');
                } else {
                  $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
                }
              }
            });
          }else{
            $state.reload();
          }
        }else{
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":CheckoutCtrl:removeCartItemsAfterCheckedout - Delete cart failed. "+ err):"";
          $state.reload();
        }

      },function(err) {
        usSpinnerService.stop('spinner');
        $rootScope.enableLog ? $log.error($rootScope.UUID + ":CheckoutCtrl:removeCartItemsAfterCheckedout - Delete cart failed. "+ err):"";
        self.lk_checkout = false;
        $state.reload();
      });
    }


    /**************************
    //ONLY ALLOW NUMBERIC VALUE TO BE ENTERED
    **************************/
    this.creditCardCheck = function(inputValue) {
      if (inputValue){
        (isNaN(inputValue) || inputValue.charAt(inputValue.length - 1) === '.') ? self.stReq.cardnum = inputValue.substring(0, inputValue.length - 1): '';
      }
    }

    /**************************
    //ONLY ALLOW NUMBERIC VALUE TO BE ENTERED
    **************************/
    this.CVCCheck = function(inputValue) {
      if (inputValue){
        (isNaN(inputValue) || inputValue.charAt(inputValue.length - 1) === '.') ? self.stReq.cvc = inputValue.substring(0, inputValue.length - 1): '';
      }
    }

    /**************************
    //CHECK FOR VALID CREDIT CARD EXPIRY DATE
    **************************/
    this.expiryDateCheck = function(inputValue) {
      //ONLY ALLOW ENTER MM/YY
      if (inputValue){
        var validValue = true;
        isNaN(inputValue) ? validValue = false : '';
        (inputValue.length === 2 && (inputValue === 0 || inputValue > 12)) ? validValue = false: '';
        !validValue ? self.ccExpiry = inputValue.substring(0, inputValue.length - 1) : '';
      }
    }

    

    /*********************************
    //CALCULATE ALL THE CREDIT PRICING
    **********************************/
    function calculateRentalCredit() {

      var selectedCheckoutProducts = $rootScope.cc.cart
        .filter(p => p._selectedToCheckout === true && p.transactionType == CONFIG.TRANSACTION_TYPE_RENT)
        .map(item => {
          var obj = {};
          obj['cartID'] = item.cartID;
          obj['productId'] = item.product ? item.product.id : item.productID;
          obj['size'] = item.size;
          obj['startDate'] = item.transactionType == CONFIG.TRANSACTION_TYPE_RENT ? item.selectedDate.START_DATE : self.purchaseOrderDate;
          obj['endDate'] = item.transactionType == CONFIG.TRANSACTION_TYPE_RENT ? item.selectedDate.RETURN_DATE : self.purchaseOrderDate;
          obj['transactionType'] = item.transactionType;
          obj['itemCondition'] = item.itemCondition;
          obj['bundleID'] = item.bundleID;
          return obj;
        });

      var multiItemReq = { 
        products: selectedCheckoutProducts, 
        destinationCountry: $rootScope.geoLocation.country, 
        currency: $rootScope.geoLocation.currency,
        exchangeRate: $rootScope.geoLocation.rate,
        applyCredits: self.applyCredits
      };

      RentalService.getCreditAndOtherFeesOnMultiProducts(
        multiItemReq,
        AuthService.isAuthenticated()
      ).$promise.then(
        function(resp) {
          self.returnedCalculatedPrice = resp;
          self.rentalCredit = resp.order.rentalCredit;
          self.currentCreditBalance = resp.currentBalance;
          self.topUp.credit = resp.topUpCredit;
          self.rentalProtectionFee = resp.order.protectionFee;
          self.shippingFee = resp.order.shippingFee;
          self.rentalMiscFee = resp.order.rentalMiscFee;
          self.totalDue = resp.order.rentalMiscFee;
          self.topUp.eligibleOneCreditPrice = resp.topUpCreditUnitPrice;
          self.usualPricePerCredit = resp.usualPricePerCredit || priceUtilities.getOriginalCreditPrice();
          self.rentalCreditTotalAmount = (resp.order.rentalCredit * self.usualPricePerCredit) + resp.order.additionalRentalPrice;
          self.rentalFeePerDay = resp.rentalFeePerDay;

          for (var i = 0; i < resp.products.length; i++) {
            self.originalValue += resp.products[i].productSummary.tagPrice;
            self.saleValue += resp.products[i].productSummary.salePrice;
          }

          self.updateTopUpCreditPrice();

        }, function(err){
          self.error_txn = $filter('translate')('GENERAL.ERROR.FAILED_TO_APPLY_PROMO');
          self.GotoTop();
      });
    };

    function calculatePurchasePrice() {
      self.selectedPurchaseOrders = [];
      self.selectedPurchaseOrders.orders = [];
      self.selectedPurchaseOrders.subTotal = 0;
      self.selectedPurchaseOrders.buyShippingFee = 0;
      var buyOrders = $rootScope.cc.cart.filter(p => p.transactionType == CONFIG.TRANSACTION_TYPE_BUY && p._selectedToCheckout);
      var subTotal = 0;
      var item = [];
      buyOrders.forEach(function(purchase){
        var purchasePrice = $rootScope.subscriptionSelected ? purchase.product.salePrice : purchase.product.purchasePrice;
        subTotal = subTotal + purchasePrice;
        var p = {};
        p._brandName = utilities.getCustomBrandName(purchase.product);
        p._size = purchase.size;
        p._color = purchase.product.color;
        p._cartID = purchase.cartID;
        p._purchasePrice = Math.round(purchasePrice.toFixed(2));
        p._mainPhotoUrl = purchase.product.pictures[0]._url;
        p._itemCondition = purchase.itemCondition;
        item.push(p);
      });
      var tempSubTotal = priceUtilities.getAmountByRate(subTotal);
      self.selectedPurchaseOrders = {
        orders : item,
        subTotal : Math.round(tempSubTotal.toFixed(2))
      }
      self.purchasePriceSubTotal = Math.round(tempSubTotal.toFixed(2));
      self.buyShippingFee = 0;
      var cartItems = $rootScope.cc.cart
          .filter(p => p.transactionType == CONFIG.TRANSACTION_TYPE_BUY)
          .map(item => {
            var obj = {};
            obj['cartID'] = item.cartID;
            obj['productId'] = item.productID;
            obj['size'] = item.size;
            obj['transactionType'] = item.transactionType;
            return obj;
          });
  
      var multiItemReq = { 
        products: cartItems, 
        destinationCountry: $rootScope.geoLocation.country,
        currency: $rootScope.geoLocation.currency,
        exchangeRate: $rootScope.geoLocation.rate  
      };
  
      BuyService.getOtherFees(multiItemReq).$promise.then(
          function(resp) {
            self.buyShippingFee = resp.order.shippingFee;
            self.selectedPurchaseOrders.buyShippingFee = self.buyShippingFee;
            self.purchasePriceSubTotalWithShipping = self.purchasePriceSubTotal + self.buyShippingFee;
          }, function(err){
            self.error_txn = $filter('translate')('GENERAL.ERROR.FAILED_TO_APPLY_PROMO');
            self.GotoTop();
      });

    }

    function calculateTransactionAmount() {
      calculateRentalCredit();
      calculatePurchasePrice();
    }
    
    function showMemberPrice(){
      self.isMemberPrice = false;
      if ($rootScope.credit.balance) {
          if ($rootScope.credit.balance.activeSubscriptionId != null) {
            self.isMemberPrice = true;
          } 
      }
    }

    self.setSelectedPlan = function(subId){
      self.error_txn = null;
      if (Number(subId) != Number(Session.getSelectedPlan())){
        Session.setSelectedPlan(Number(subId));
        $rootScope.credit.selectedPlan=Session.getSelectedPlan();
        var planMonth = $rootScope.credit.pricing.filter(p => p.id == Number(subId))[0].numContractMonths;
        if (Number(subId)==0 || planMonth > self.topUp.currentPlanMonth){
          usSpinnerService.spin('spinner');
          self.updateTopUpCreditPrice();
        }
      }
    }
    self.isPricingActive=function(subId){
      if (AuthService.isAuthenticated() && $rootScope.credit.balance) {
          if ($rootScope.credit.balance.activeSubscriptionId != null) {
            self.topUp.currentPlan = $rootScope.credit.balance.activeSubscriptionId;
          } else {
            self.topUp.currentPlan = 0;
          }
          var planMonth = $rootScope.credit.pricing.filter(p => p.id == Number(subId))[0].numContractMonths;
          var isActive = planMonth > self.topUp.currentPlanMonth;
          return isActive;
      } else return false;
    }

    /*
    THIS FUNCTION DETERMINE IF THE SUBSCRIPTION OPTION IS VISIBLE OR NOT.
    THE OPTIONS SHOULD ONLY BE VISIBLE IF TOP UP IS REQUIRED.
    */
    self.isShowSubscriptionPlanOptions = function(){
      if ($rootScope.credit.balance) {
        if ($rootScope.credit.balance.available != null && self.rentalCredit < $rootScope.credit.balance.available) {
          return false;
        }
      }
      return true;
    }

    self.updateTopUpCreditPrice = function () {
      self.topUp.currentPlan = 0;
      self.topUp.needSub = false;
      self.topUp.subCredit = 0;
      self.topUp.subCreditPrice = 0;
      self.topUp.needExtraCredit = false;
      self.topUp.extraCredit = 0;
      self.topUp.extraCreditPrice=0;
      self.topUp.subOrCreditDiscount = 0;
      self.topUp.creditPricingDiscountRate = 0;
      self.totalDue = self.rentalMiscFee;
      self.subscribe = CONFIG.PLAN_ONE_TIME;
      showMemberPrice();

      //removing this logic since it is possible for customer to checkout buy without rent + subscribe
      //if (self.topUp.credit > 0) {
        // Disabled the Subscription Upgrade section regardless - uncomment to enable
        if (
          $rootScope.credit.selectedPlan == null ||
          Session.getSelectedPlan() == null ||
          self.topUp.currentPlanMonth >= CONFIG.LONGEST_PLAN_MONTH
        ) {
          UserService.storeSelectedPlan(CONFIG.PLAN_ONE_TIME);
        }

        //DEFINE THE TOPUP CREDIT PRICE BASED ON CURRENT SUBSCRIBED PLAN
        if ($rootScope.credit.balance.activeSubscriptionId != null) {
          self.topUp.currentPlan = $rootScope.credit.balance.activeSubscriptionId;
        } else {
          //THIS IS FAIL-SAFE. IF YOU ARRIVED HERE YOU MUST HAVE A PLAN ALREADY.
          self.topUp.currentPlan = CONFIG.PLAN_ONE_TIME;
        }

        var selectedPlanMonth = $rootScope.credit.pricing.find(
            p => p.id == Number(Session.getSelectedPlan())
          ).numContractMonths;

        if (selectedPlanMonth > self.topUp.currentPlanMonth) {
          self.topUp.needSub = true;
          self.subscribe = Number(Session.getSelectedPlan());
          self.topUp.subCredit = $rootScope.credit.pricing.find(p => p.id == self.subscribe).numCredit;
        }

        var extraCredit = self.topUp.credit - self.topUp.subCredit;

        if (extraCredit > 0) {
          self.topUp.needExtraCredit = true;
          self.topUp.extraCredit = extraCredit;
        }
        $rootScope.subscriptionSelected = self.topUp.needSub;
        // how much those topup sub and credit
        usSpinnerService.spin('spinner');

        if(self.promoCode == null){
          self.checkTopUpSubscriptionOrCreditPrice(0, false);
        } else {
          PromoCodeService.getPromo(self.promoCode).$promise.then(
          function (resp) {
              var creditByMerchant = 0;
              var topUpByMerchant = 0;
              var cartByMerchant = $rootScope.cc.cart.filter((c) => c.product != null && c.product.owner.id == resp.merchantId && c.bundleID == null);
              cartByMerchant.forEach(function (c) {
                var additionalWeeks = utilities.getRentalWeeks(c.selectedDate.START_DATE, c.selectedDate.RETURN_DATE);
                creditByMerchant = (c.product.credit * additionalWeeks) + creditByMerchant;
                if(creditByMerchant > 0){
                  if(self.topUp.extraCredit >= creditByMerchant){
                    topUpByMerchant = creditByMerchant;
                  } else {
                    topUpByMerchant = self.topUp.extraCredit;
                  }
                }
              });
              self.checkTopUpSubscriptionOrCreditPrice(topUpByMerchant, resp.merchantId != null);
          },
          function (err) {
            usSpinnerService.stop('spinner');
            $rootScope.enableLog ?
              $log.error($rootScope.UUID + ":CheckoutCtrl:getPromo Promo Check- server response failed. " + err)
              :
              "";
          });
        }

        
      //} 

      //HIDE THE SUBSCRIPTION OPTION IF CLIENT ALREADY SUBSCRIBED.
      if ($rootScope.credit.balance.activeSubscriptionId != null) {
        $scope.showSubscriptionOptionsCheckout = false;
      } else {
        $scope.showSubscriptionOptionsCheckout = true;
      }
    }

    self.checkTopUpSubscriptionOrCreditPrice = function(discountableCredits, isMerchantPromo) {

      RentalService.checkTopUpSubscriptionOrCreditPrice(self.subscribe, self.promoCode, self.topUp.extraCredit, AuthService.isAuthenticated(), discountableCredits, isMerchantPromo).$promise.then(
        function (resp) {
          // check and update sub price and discount
          // update total due
          usSpinnerService.stop('spinner');
          if (self.topUp.needSub && resp.subscription.pricingId != null) {
            self.topUp.subCreditPrice = resp.subscription.listPrice;
            if (resp.subscription.listPrice > resp.subscription.finalMonthlyPrice[0]){
              self.topUp.subOrCreditDiscount = resp.subscription.listPrice - resp.subscription.finalMonthlyPrice[0];
            }
            self.totalDue = self.totalDue + self.topUp.subCreditPrice - self.topUp.subOrCreditDiscount;
          }
          // check and update extra credit price and discount
          // update total due
          if (resp.unit != 0) {
            self.topUp.extraCreditPrice = resp.totalPrice;
            if (self.topUp.subOrCreditDiscount==0){ // if sub above doesn't have any discount (either sub or credit can have discount, not both)
              self.topUp.subOrCreditDiscount = resp.totalPrice - resp.totalPriceAfterDiscount;
            }
            self.totalDue = self.totalDue + resp.totalPriceAfterDiscount;
            self.topUp.creditPricingDiscountRate=(priceUtilities.getOriginalCreditPrice() - resp.unitPrice)/priceUtilities.getOriginalCreditPrice()*100;
          }
          // check for invalid promo and err
          if (self.promoCode != null && self.promoCode !='' && resp.promoCode == null && resp.subscription.promoCode == null) {
            self.error_txn = $filter('translate')('GENERAL.ERROR.FAILED_TO_APPLY_PROMO');
            self.GotoTop();
          }
        },
        function (err) {
          usSpinnerService.stop('spinner');
          $rootScope.enableLog ?
            $log.error($rootScope.UUID + ":CheckoutCtrl:topUpCredit Price Check- server response failed. " + err)
            :
            "";
        }
      );
    }

    /*********************************
    //CREDITS SUBSCRIPTION FLOW. ALL TXN BASED ON CREDITS.
    //THE FUNCTION WILL PURCHASE SUBSCRIPTION PLAN AND/OR EXTRA CREDITS NEEDED FOR USER ACCOUNT
    //BASED ON THE RENTAL. ONCE THE CREDIT HAS BEEN PURCHASED. IT WILL GO TO RENTAL SUBMISSION REQUEST
    **********************************/
    self.topUpAndSubmitRequests = function (selectedCheckoutProducts) {
      if (self.topUp.needSub || self.topUp.needExtraCredit) {
        if(self.promoCode != null){
          PromoCodeService.getPromo(self.promoCode).$promise.then(
            function (resp) {
              var creditByMerchant = 0;
              var topUpByMerchant = 0;
              var cartByMerchant = $rootScope.cc.cart.filter((c) => c.product != null && c.product.owner.id == resp.merchantId && c.bundleID == null);
              cartByMerchant.forEach(function (c) {
                var additionalWeeks = utilities.getRentalWeeks(c.selectedDate.START_DATE, c.selectedDate.RETURN_DATE);
                creditByMerchant = (c.product.credit * additionalWeeks) + creditByMerchant;
                if(creditByMerchant > 0){
                  if(self.topUp.extraCredit >= creditByMerchant){
                    topUpByMerchant = creditByMerchant;
                  } else {
                    topUpByMerchant = self.topUp.extraCredit;
                  }
                }
              });
              
              
              var promises = [];
              promises.push(RentalService.buyTopUpSubscriptionOrCredit(self.subscribe, self.promoCode, self.topUp.extraCredit, topUpByMerchant, resp.merchantId != null).$promise);
  
              $q.all(promises).then(function (resp) {
                sleep(1500).then(() => {
                  $scope.topUpInvoiceReferenceNumber = resp ? resp[0].topUpInvoiceReferenceNumber : null;
                  $scope.subscriptionInvoiceReferenceNumber = resp ? resp[0].subscriptionInvoiceReferenceNumber : null;
                  self.submitTransactionRequest(selectedCheckoutProducts);
                });
              }, function (err) {
                usSpinnerService.stop('spinner');
                self.lk_checkout = false;
                var errorLog;
                try {
                  errorLog = err.error ? err.error.message : err.data.reasons[0].message;
                  if (err.data) {
                    switch (err.data.reasons[0].code) {
                      case "FAILED_TO_APPLY_PROMO":
                        self.error_txn = $filter('translate')('GENERAL.ERROR.FAILED_TO_APPLY_PROMO');
                        self.GotoTop();
                        break;
                      case "BILLING_CARD_DECLINED":
                        self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_DECLINED')
                        self.GotoTop();
                        break;
                      default:
                        self.error_txn = "System Error - Please try again later. (" + err.data.reasons[0].code + ")";
                        break;
                    }
                  } else {
                    self.error_txn = errorLog;
                  }
                } catch (moreErr) {
                  self.error_txn = $filter('translate')("GENERAL.ERROR.UNABLE_TO_PROCESS_PAYMENT");
                  errorLog = moreErr;
                } finally {
                  $rootScope.enableLog ? $log.error($rootScope.UUID + ":CheckoutCtrl:submitBuyCredit - Checkout failed. " + errorLog) : "";
                }
              })
  
            },
            function (err) {
              usSpinnerService.stop('spinner');
              $rootScope.enableLog ?
                $log.error($rootScope.UUID + ":CheckoutCtrl:getPromo Promo Check- server response failed. " + err)
                :
                "";
            });
        } else {
          var promises = [];
          promises.push(RentalService.buyTopUpSubscriptionOrCredit(self.subscribe, self.promoCode, self.topUp.extraCredit, 0, false).$promise);

          $q.all(promises).then(function (resp) {
            sleep(1500).then(() => {
              $scope.topUpInvoiceReferenceNumber = resp ? resp[0].topUpInvoiceReferenceNumber : null;
              $scope.subscriptionInvoiceReferenceNumber = resp ? resp[0].subscriptionInvoiceReferenceNumber : null;
              self.submitTransactionRequest(selectedCheckoutProducts);
            });
          }, function (err) {
            usSpinnerService.stop('spinner');
            self.lk_checkout = false;
            var errorLog;
            try {
              errorLog = err.error ? err.error.message : err.data.reasons[0].message;
              if (err.data) {
                switch (err.data.reasons[0].code) {
                  case "FAILED_TO_APPLY_PROMO":
                    self.error_txn = $filter('translate')('GENERAL.ERROR.FAILED_TO_APPLY_PROMO');
                    self.GotoTop();
                    break;
                  case "BILLING_CARD_DECLINED":
                    self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_DECLINED')
                    self.GotoTop();
                    break;
                  default:
                    self.error_txn = "System Error - Please try again later. (" + err.data.reasons[0].code + ")";
                    break;
                }
              } else {
                self.error_txn = errorLog;
              }
            } catch (moreErr) {
              self.error_txn = $filter('translate')("GENERAL.ERROR.UNABLE_TO_PROCESS_PAYMENT");
              errorLog = moreErr;
            } finally {
              $rootScope.enableLog ? $log.error($rootScope.UUID + ":CheckoutCtrl:submitBuyCredit - Checkout failed. " + errorLog) : "";
            }
          })
          
        }
        

        /*
        */

      } else {
        self.submitTransactionRequest(selectedCheckoutProducts)
      };
    }

    const sleep = (milliseconds) => {
      return new Promise(resolve => setTimeout(resolve, milliseconds))
    }

    this.validateCard = function() {

      var deferred = $q.defer();

      //CONVERT FORM DATA TO STRIP REQUIRED FORMAT
      self.stReq.mm = self.ccExpiry.substring(0, 2);
      self.stReq.yy = self.ccExpiry.substring(2, 4);
      self.stReq.address1 = self.billingAddress.address1;
      self.stReq.address2 = self.billingAddress.address2;
      self.stReq.city = self.billingAddress.city;
      self.stReq.country = self.billingAddress.country;
      self.stReq.district = self.billingAddress.district;

      // Request a token from Stripe:
      Stripe.card.createToken({
        number: self.stReq.cardnum,
        cvc: self.stReq.cvc,
        exp_month: self.stReq.mm,
        exp_year: self.stReq.yy,
        name: self.stReq.name,
        address_line1: self.stReq.address1,
        address_line2: self.stReq.address2,
        address_city: self.stReq.city,
        address_country: self.stReq.country,
        metadata: {
          "email": $rootScope.user && $rootScope.isLogon ? $rootScope.user.email : "",
          "phone": $rootScope.user && $rootScope.isLogon ? $rootScope.user.phone1 : ""
        }
      }, function(status, response) {

        if (response.error) { // Problem!
          self.error_ship_bill_info= response.error.message;
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":CheckoutCtrl:validateCard - Card creation failed!. "+ response.error.message):"";
          deferred.reject(response);
        } else { // Token was created!
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":CheckoutCtrl:validateCard - Card creation succeeded. " + response.id):"";
          self.error_ship_bill_info= null;
          // Get the token ID:
          var stripeToken = response.id;
          var addressObj = {
            country : $rootScope.geoLocation.country,
            district : self.billingAddress.district,
            postalCode : self.billingAddress.postalCode
          }

          // send stripeToken
          RentalService.saveStripeToken(stripeToken, addressObj).$promise.then(
            function(resp) {
              $rootScope.enableLog ? $log.info($rootScope.UUID + ":CheckoutCtrl:validateCard - Token saved to server. " + resp):"";
              deferred.resolve(resp.token);
            },
            function(err) {
              $rootScope.enableLog ? $log.error($rootScope.UUID + ":CheckoutCtrl:validateCard - Token failed to save to server. " + err):"";
              
              if(err.data && err.data.reasons && err.data.reasons[0]){
                switch (err.data.reasons[0].code) {
                  case "FAILED_TO_CREATE_CUSTOMER_OBJECT":
                    self.error_txn = $filter('translate')('GENERAL.ERROR.FAILED_TO_CREATE_CUSTOMER_OBJECT');
                    self.GotoTop();
                    break;
                  case "CARD_DECLINED":
                    self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_DECLINED');
                    self.GotoTop();
                    break;
                  case "CARD_INCORRECT_CVC":
                    self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_INCORRECT_CVC');
                    self.GotoTop();
                    break;
                  case "CARD_INCORRECT_NUMBER":
                    self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_INCORRECT_NUMBER');
                    self.GotoTop();
                    break;
                  case "CARD_EXPIRED":
                    self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_EXPIRED');
                    self.GotoTop();
                    break;
                  default:
                    self.error_txn = $filter('translate')('GENERAL.ERROR.PROFILE_ERROR');
                    self.GotoTop();
                    break;
                }
              } else {
                self.error_txn = $filter('translate')('GENERAL.ERROR.PROFILE_ERROR');
                self.GotoTop();
              }
              deferred.reject(err);
            }
          );
        }
      });
      return deferred.promise;
    }


    self.setSelected = function(type, selectedValue) {
      switch (type) {
        case 'shippingCountry':
          $scope.checkoutForm ? $scope.checkoutForm.shipCountry.$setDirty() : '';
          self.shippingAddress.country = selectedValue.name;
          self.disable_Shipping_CityDDL = selectedValue.name != CONFIG.HONG_KONG ? true:false;
          self.shippingAddress.reqPostCode = selectedValue.reqPostCode;
          if (!self.disable_Shipping_CityDDL && typeof self.areaName != "undefined"){
            self.shippingAddress.city = self.areaName[0].name;
          }
          if ($scope.isSameShippingAddress) {
            self.billingAddress.country = selectedValue.name;
            self.disable_Billing_CityDDL = true;
          }
          break;

        case 'billingCountry':
          self.billingAddress.country = selectedValue.name;
          self.disable_Billing_CityDDL = selectedValue.name != CONFIG.HONG_KONG ? true:false;
          if (!self.disable_Billing_CityDDL){
            self.billingAddress.city = self.areaName[0].name;
          }
          self.billingAddress.reqPostCode = selectedValue.reqPostCode;
          break;

        case 'BILLING_ADDRESS':
          self.billingAddress.city = selectedValue.name;
          break;

        case 'SHIPPING_ADDRESS':
          self.shippingAddress.city = selectedValue.name;
          if ($scope.isSameShippingAddress) {
            self.billingAddress.city = selectedValue.name;
          }
          break;
      }
    };


    this.getFormattedPrice = function(price){
      return priceUtilities.getFormattedAmountByRate(price);
    }

    $rootScope.$on("CallCheckoutParentUpdateCreditPricing", function(){
      self.updateTopUpCreditPrice();
      calculateTransactionAmount();
    });
    
    this.showListing = function(product) {
      var url;
      var productBrand = utilities.getCustomBrandName(product);
      var urlSlug = utilities.getPrettyUrl(product.category.code, product.subCategory.code, productBrand, product.productLine);
      
      if(utilities.isShowMainRegion()){
        url = $state.href('listing', {id: product.id, urlSlug: urlSlug});
      } else {
        url = $state.href('listing-multi-region', {id: product.id, urlSlug: urlSlug, country: $rootScope.geoLocation.country});
      }
      window.open(url,'_blank');
    };

    $scope.getVolumeSum = function(items, startDate, endDate) {
        var credits = 0;
        var rentalWeeks = utilities.getRentalWeeks(startDate, endDate);
        var noBundle = items.filter(i => i.bundleID == null);
        var noBundleCredits = 0;
        if(noBundle.length > 0){
          noBundleCredits = items
          .map(function(x) { return x.product ? (x.product.credit * rentalWeeks) : 0; })
          .reduce(function(a, b) { return a + b; });
          noBundleCredits = Number(noBundleCredits);
        }
        var withBundle = items.filter(i => i.bundleID != null);
        var withBundleCredits = 0;
        if(withBundle.length > 0){
          var holdBundles = [];
          withBundle.forEach(function(item) {
            var bundleID = item.bundleID;
            var exist = holdBundles.filter(b => b === bundleID);
            if(exist.length === 0){
              holdBundles.push(bundleID);
              withBundleCredits = withBundleCredits + (item.product ? item.product.credit : 0);
            } 
          });
          withBundleCredits = Number(withBundleCredits) * rentalWeeks;
        }
        var subCredits = noBundleCredits + withBundleCredits;
        credits = 3 - Number(subCredits);
      return credits ;
    };

    $scope.goToBundles = function(bundleID) {
      Session.setBundleID(bundleID);
      utilities.goToSearch();
      $rootScope.isCheckoutSidebarActive = false;
      $rootScope.showLgLogo = false;
    }

    this.getRentalDays = function(startDate, endDate){
        return utilities.getRentalDays(startDate, endDate);
    }

    this.getRentalWeeks = function(startDate, endDate){
      return utilities.getRentalWeeks(startDate, endDate);
    }

    this.getRentalAdditionalDays = function(startDate, endDate){
      var rentalDays = utilities.getRentalDays(startDate, endDate);
      return rentalDays % CONFIG.DEFAULT_WEEKLY_RENTAL;
    }

    this.validateItemsInCart = function(){
      var valid = true;
      self.error_txn = null;

      if ($rootScope.cc.cart == null || $rootScope.cc.cart == undefined || $rootScope.cc.cart.length == 0){
        return true
      }

      for (var itemIndexInCart in $rootScope.cc.cart) {
        if($rootScope.cc.cart[itemIndexInCart].transactionType === CONFIG.TRANSACTION_TYPE_RENT){

          if ($rootScope.cc.cart[itemIndexInCart].selectedDate === null 
            || $rootScope.cc.cart[itemIndexInCart].selectedDate.START_DATE === null
            || $rootScope.cc.cart[itemIndexInCart].selectedDate.START_DATE === undefined){
            valid = false;
            $rootScope.cc.cart[itemIndexInCart].selectedDate = {'START_DATE': null, 'RETURN_DATE':null};
            break;
          }

        }
      }

      //VALIDATE IF THE DATE SELECTED IS ALLOWED
      $rootScope.cc.cart.some((item, i) => {
        if(item.transactionType == CONFIG.TRANSACTION_TYPE_RENT ){
          if(item.product != null){
            utilities.loadAllowedDatesByMerchant(item.product.owner.id, item.product.id);
            var items = utilities.getAvailableDatesWithSizeByMerchant(item.size, item.product, item.itemCondition);
            if(items){
              valid = items.map(p=> moment(parseInt(item.selectedDate.START_DATE)).add(8,'hours').isSame(p,'day')).filter(f=> f==true).length > 0 ? true:false;
              if (!valid){
                item.selectedDate = {'START_DATE': null, 'RETURN_DATE':null};
                return true;
              }
            }
          }
        }
      });
      if (!valid){
        self.error_txn = "Some of the item(s) are missing rental period. Please select a rental period."
      }

      return valid;
    }

    $rootScope.$on("CallCheckoutProcess", function(){
      $rootScope.$emit("CallCloseCheckoutPreference", {});
      var selectedCheckoutProducts = $rootScope.cc.cart.filter(p=> p._selectedToCheckout == true).map(item=> {
        var obj = {};
        obj['cartID'] = item.cartID;
        obj['productId'] = item.product.id;
        obj['size'] = item.size;
        obj['startDate'] = item.transactionType == CONFIG.TRANSACTION_TYPE_RENT ? item.selectedDate.START_DATE : self.purchaseOrderDate;
        obj['endDate'] = item.transactionType == CONFIG.TRANSACTION_TYPE_RENT ? item.selectedDate.RETURN_DATE : self.purchaseOrderDate;
        obj['transactionType'] = item.transactionType;
        obj['itemCondition'] = item.itemCondition;
        obj['bundleID'] = item.bundleID;
        obj['deliverBoth'] = item.deliverBoth;
        return obj;
      });
      usSpinnerService.spin('spinner');

      if (!self.isHideCreditCardDetails) {
        self.validateCard().then(function(resp){
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":CheckoutCtrl:requestRental - Saved card"):"";
          self.topUpAndSubmitRequests(selectedCheckoutProducts);
        },function(err){
          try {
            if (!self.error_txn){
              self.error_txn = err.data && err.data.reasons && err.data.reasons[0] ? $filter('translate')("GENERAL.ERROR."+ err.data.reasons[0].code) : $filter('translate')("GENERAL.ERROR.UNABLE_TO_PROCESS_PAYMENT");
            }
          } catch (err) {
            self.error_txn = $filter('translate')("GENERAL.ERROR.UNABLE_TO_PROCESS_PAYMENT");
          } finally {
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":CheckoutCtrl:requestRental - Err No card saved" + err):"";
            self.lk_checkout = false;
            usSpinnerService.stop('spinner');
          }
        });
      }else{
        $rootScope.enableLog ? $log.info($rootScope.UUID + ":CheckoutCtrl:requestRental - Other flow no card change and just submit request"):"";
        self.topUpAndSubmitRequests(selectedCheckoutProducts);
      }
    });
      
    $('.dropdown-menu').find('input').click(function (e) {
      e.stopPropagation();
    });

    self.toggleApplyCredits = function(){
      self.applyCredits = !self.applyCredits;
      calculateTransactionAmount();
      self.updateTopUpCreditPrice();
    }

  }]);

'use strict';

/**
 * @ngdoc function
 * @name coutureApp.controller:DirectCheckoutCtrl
 * @description
 * # DirectCheckoutCtrl
 * Controller of the coutureApp
 */
angular.module('coutureApp')
  .controller('DirectCheckoutCtrl', ["$rootScope", "$state", "utilities", "$log", "DialogAlertService", "$timeout", "usSpinnerService", "$anchorScroll", "ListingService", "CartService", "Session", "CONFIG", "$q", function($rootScope,$state, utilities, $log, DialogAlertService,$timeout, usSpinnerService, $anchorScroll, ListingService, CartService, Session, CONFIG, $q) {

    var self = this;

    this.$onInit = function() {
      $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - DirectCheckoutCtrl") : '';
      
      const sleep = (milliseconds) => {
        return new Promise(resolve => setTimeout(resolve, milliseconds))
      }

      if($rootScope.isLogon){
        usSpinnerService.spin('spinner');
          //WAIT FOR 3SEC FOR THE CART ITEM TO MERGE AND UPDATE
        sleep(3000).then(() => {
          usSpinnerService.stop('spinner');
          if(utilities.isShowMainRegion()){
            $state.go('checkout');
          } else {
            $state.go('checkout-multi-region', {country: $rootScope.geoLocation.country});
          }
          $anchorScroll('top');
        });

      } else {
        DialogAlertService.openLogon(function(){
          usSpinnerService.spin('spinner');
          //WAIT FOR 1.5SEC FOR THE CART ITEM TO MERGE AND UPDATE
          sleep(1500).then(() => {
              usSpinnerService.stop('spinner');
              if(utilities.isShowMainRegion()){
                $state.go('checkout');
              } else {
                $state.go('checkout-multi-region', {country: $rootScope.geoLocation.country});
              }
              $anchorScroll('top');
          });
          
        },function(){
          if(utilities.isShowMainRegion()){
            $state.go('checkout');
          } else {
            $state.go('checkout-multi-region', {country: $rootScope.geoLocation.country});
          }
        });
      }
      
    }
    

  }]);

'use strict';

// (function() {
  angular.module('coutureApp')
    .component('sidebarCart', {
      templateUrl: 'scripts/components/sidebar-cart/sidebar-cart.html',
      controllerAs: 'sidebarCtrl',
      controller: ["$scope", "$state", "CartService", "Session", "$rootScope", "ListingService", "CalendarService", "utilities", "priceUtilities", "$anchorScroll", "RefDataService", "menuBarsService", "dateUtilities", "$log", "RentalService", "$filter", "CONFIG", "DialogAlertService", "usSpinnerService", "$sce", "AuthService", "BuyService", "UserService", "WishlistService", function($scope, $state,CartService,Session,$rootScope,ListingService,CalendarService,utilities,priceUtilities
        ,$anchorScroll, RefDataService,menuBarsService,dateUtilities,$log,RentalService,$filter,CONFIG,DialogAlertService,usSpinnerService,$sce,AuthService,BuyService,UserService, WishlistService) {

        var self = this;

        this.$onInit = function(){
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - sidebarCart"):'';
          self.error_date = null;
          self.subTotalRentalPrice = 0;
          self.subTotalRentalCredit= 0;
          self.totalMiscFee= 0;
          self.subTotalProtectionFee = 0;
          self.subTotalShippingFee = 0;
          self.discountApplied = 0;
          self.product_currency = priceUtilities.getCurrency();
          self.promoCode = null;
          self.usualPricePerCredit = priceUtilities.getOriginalCreditPrice();
          self.memberPrice = priceUtilities.getMemberPrice();
          self.rentalCredit = 0;
          self.topUp={};
          self.FREE_SHIPPING_SIDE_BAR_0 = CONFIG.FREE_SHIPPING_SIDE_BAR_0;
          self.FREE_SHIPPING_SIDE_BAR_1 = CONFIG.FREE_SHIPPING_SIDE_BAR_1;
          self.FREE_SHIPPING_SIDE_BAR_2 = CONFIG.FREE_SHIPPING_SIDE_BAR_2;
          self.FREE_SHIPPING_SIDE_BAR_3 = CONFIG.FREE_SHIPPING_SIDE_BAR_3;
          this.getProtectionTooltip();
        };

        this.getProtectionTooltip = function(){
          $scope.protectionTooltip=$sce.trustAsHtml('Wear without worry!</br></br>Rental Protection covers most normal wear and tear in the case of minor stains or other repairable damage up to HK$ 200. For serious damage or other loss you may be charged the sale price. StylePass members receive exclusive sale pricing depending on status level.<br/><br/>Please read our <a href="https://stylecarousel.com/landing/terms-and-conditions/" style="display:contents">Terms of Service</a> to learn more. ');
          if($rootScope.geoLocation.country == CONFIG.COUNTRY_CURRENCY_CODE.SG.country_code){
            $scope.protectionTooltip=$sce.trustAsHtml('Wear without worry!</br></br>Rental Protection covers most normal wear and tear in the case of minor stains or other repairable damage up to SG$ 35. For serious damage or other loss you may be charged the sale price. StylePass members receive exclusive sale pricing depending on status level.<br/><br/>Please read our <a href="https://stylecarousel.com/landing/terms-and-conditions/" style="display:contents">Terms of Service</a> to learn more. ');
          }
        }

        //////////////////////////////////////////
        //SORT THE ITEM IN THE CART BASED ON START_DATE
        //////////////////////////////////////////
        $scope.min = function(arr) {
          if ($rootScope.isCheckoutSidebarActive){
            return $filter('min')($filter('map')(arr, 'selectedDate.START_DATE'));
          }
        }

        //////////////////////////////////////////
        //REMOVE ITEM FROM CART
        //////////////////////////////////////////
        this.removeItem = function(selectedObject){
          Session.removeCart(selectedObject.cartID);
          CartService.deleteCart(selectedObject.cartID);

          var itemIndexInCart;
          itemIndexInCart = $rootScope.cc.cart.findIndex(p=> p.cartID == selectedObject.cartID);
          if (itemIndexInCart != -1){
            $rootScope.cc.cart.splice(itemIndexInCart,1);
          }
          self.validateItemsInCart();
          $scope.calculateTotal();
          //self.calculateOrderFees();
        };

        //////////////////////////////////////////
        // TRIGGER THE CALCULATION OF THE SUBTOTAL
        //////////////////////////////////////////
        $rootScope.$watch('isCheckoutSidebarActive',(newValue,oldValue)=>{
          if(newValue == true && self.validateItemsInCart()){
            self.moveToWishlist();
            $scope.calculateTotal();
            showMemberPrice();
            this.getProtectionTooltip();

          }
        })

        //////////////////////////////////////////
        //CALCULATE ALL THE PRICING
        //////////////////////////////////////////
        this.calculatePricing = function(){
          if ($scope.hasOwnProperty('temp_promoCode') && $rootScope.hasOwnProperty('cc') && $rootScope.cc.hasOwnProperty('cart') && $rootScope.cc.cart.length > 0){
            self.promoCode = $scope.temp_promoCode;

            priceUtilities.applyPromo(self.promoCode,$rootScope.cc.cart).then(function(resp){
              self.subTotalRentalCredit= resp.rentalCredit;
              self.subTotalProtectionFee = resp.protectionFee;
              self.subTotalShippingFee = resp.shippingFee;
              self.totalMiscFee = resp.rentalMiscFee;
              self.totalPrice = resp.rentalMiscFee;
            })
          }else{
            self.subTotalRentalPrice = 0;
            self.discountApplied = 0;
            self.subTotalProtectionFee = 0;
            self.subTotalShippingFee = 0;
            self.totalPrice = 0;
            self.subTotalRentalCredit= 0;
            self.totalMiscFee = 0;
          }
          $scope.isShowRentalOrders();
          $scope.isShowPurchaseOrders();
        }

        //////////////////////////////////////////
        //CHECKOUT BUTTON
        //////////////////////////////////////////
        this.checkout = function() {
          //CHECK IF THE ITEM DATE HAD BEEN SELECTED
          if (self.validateItemsInCart()){
            if ($rootScope.isLogon){
              $rootScope.isCheckoutSidebarActive = false;
              $rootScope.showLgLogo = false;
              if(utilities.isShowMainRegion()){
                $state.go('checkout');
              } else {
                $state.go('checkout-multi-region', {country: $rootScope.geoLocation.country});
              }
              $anchorScroll('top');
            }else{
              $rootScope.isCheckoutSidebarActive = false;
              $rootScope.showLgLogo = false;

              DialogAlertService.openLogon(function(){
                usSpinnerService.spin('spinner');

                const sleep = (milliseconds) => {
                  return new Promise(resolve => setTimeout(resolve, milliseconds))
                }

                //WAIT FOR 1.5SEC FOR THE CART ITEM TO MERGE AND UPDATE
                sleep(1500).then(() => {
                  priceUtilities.applyPromo(null,$rootScope.cc.cart).then(function(resp){
                    usSpinnerService.stop('spinner');
                    if(utilities.isShowMainRegion()){
                      $state.go('checkout');
                    } else {
                      $state.go('checkout-multi-region', {country: $rootScope.geoLocation.country});
                    }
                    $anchorScroll('top');
                  })
                });
              });

            }
          }
        };

        //////////////////////////////////////////
        //VALIDATE THE ITEM IN THE CART BEFORE SUBMIT CAN PROCEED
        //////////////////////////////////////////
        this.validateItemsInCart = function(){
          var valid = true;
          self.error_date = null;

          if ($rootScope.cc.cart == null || $rootScope.cc.cart == undefined || $rootScope.cc.cart.length == 0){
            return true
          }

          for (var itemIndexInCart in $rootScope.cc.cart) {
            if($rootScope.cc.cart[itemIndexInCart].transactionType === CONFIG.TRANSACTION_TYPE_RENT){

              if ($rootScope.cc.cart[itemIndexInCart].selectedDate === null 
                || $rootScope.cc.cart[itemIndexInCart].selectedDate.START_DATE === null
                || $rootScope.cc.cart[itemIndexInCart].selectedDate.START_DATE === undefined){
                valid = false;
                $rootScope.cc.cart[itemIndexInCart].selectedDate = {'START_DATE': null, 'RETURN_DATE':null};
                break;
              }

            }
          }

          //VALIDATE IF THE DATE SELECTED IS ALLOWED
          $rootScope.cc.cart.some((item, i) => {
            if(item.transactionType == CONFIG.TRANSACTION_TYPE_RENT ){
              utilities.loadAllowedDatesByMerchant(item.product.owner.id, item.product.id);
              var items = utilities.getAvailableDatesWithSizeByMerchant(item.size, item.product, item.itemCondition);
              if(items){
                valid = items.map(p=> moment(parseInt(item.selectedDate.START_DATE)).add(8,'hours').isSame(p,'day')).filter(f=> f==true).length > 0 ? true:false;
                if (!valid){
                  item.selectedDate = {'START_DATE': null, 'RETURN_DATE':null};
                  return true;
                }
              }
            }
          });
          if (!valid){
            self.error_date = "Some of the item(s) are missing rental period. Please select a rental period."
          }

          return valid;
        }

        //////////////////////////////////////////////////////////////////
        //ADD SPECIAL LOGIC WHEN USER ENTER OTHER BRAND, THE req_listing WILL REMAINS '-- OTHER BRAND --'
        //BUT THE ACTUAL BRAND WILL BE STORED IN TAG. HOWEVER IT WILL NOT GOING TO DISPLAY ON SCREEN.
        //////////////////////////////////////////////////////////////////
        this.getDisplayBrand = function(product){
          return utilities.getCustomBrandName(product);
        }

        //////////////////////////////////////////
        //CHANGE RENTAL DATE FOR THE SELECTED ITEM
        //////////////////////////////////////////
        this.changeDate = function(selectedObject) {
          var rental = { productID:null, product: null, size:null, selectedDate: null ,cartID: null, transactionType: null, itemCondition : null, bundleID: null};

          //utilities.loadAllowedDatesByMerchant(selectedObject.product.owner.id, selectedObject.product.id);
          $rootScope.cc.allowedDates.DATES_BY_MERCHANT = {};
          RentalService.getAllowedDatesV4($rootScope.geoLocation.country, selectedObject.product.owner.id, selectedObject.product.id).$promise.then(
            function(resp){
              var tempDate = {'INSTANT_RENTAL':null, 'RENTAL_REQUEST':null}
              var irDates =resp.ir.map(function(value) {
                return value;
              });
              var rrDates =resp.rr.map(function(value) {
                return value;
              });
    
              tempDate.INSTANT_RENTAL = irDates;
              tempDate.RENTAL_REQUEST = rrDates;
              $rootScope.cc.allowedDates.DATES_BY_MERCHANT = tempDate;


          CalendarService.openCalendar(null, function() {
            rental.productID = selectedObject.product.id;
            rental.product = selectedObject.product;
            rental.size = selectedObject.size;
            rental.cartID = selectedObject.cartID;
            rental.transactionType = selectedObject.transactionType;
            rental.itemCondition = selectedObject.itemCondition;
            rental.bundleID = selectedObject.bundleID;

            if (rental.product != null && rental.selectedDate != null && rental.cartID != null){

                rental.bundleID = utilities.generateBundleID(rental.product, rental.selectedDate.START_DATE, rental.selectedDate.RETURN_DATE, rental.cartID);
                utilities.replaceItemInArray(rental,$rootScope.cc.cart);
                self.validateItemsInCart();
                $scope.calculateTotal();
                var sessionCartDetails = {
                  cartID:selectedObject.cartID, 
                  productID:selectedObject.product.id, 
                  size:selectedObject.size, 
                  startDate: rental.selectedDate.START_DATE,
                  returnDate: rental.selectedDate.RETURN_DATE,
                  transactionType: rental.transactionType, 
                  price: {
                    purchasePrice: selectedObject.product.purchasePrice,
                    originalPrice: selectedObject.product.price,
                    salePrice: selectedObject.product.salePrice
                  },
                  itemCondition: rental.itemCondition,
                  bundleID: rental.bundleID,
                  country: $rootScope.geoLocation.country
                };
                Session.updateCartV2(sessionCartDetails);

                var cartDetails = {
                  'cartID' : selectedObject.cartID, 
                  'productID' : selectedObject.product.id, 
                  'size' : selectedObject.size, 
                  'startDate' : rental.selectedDate.START_DATE, 
                  'returnDate' : rental.selectedDate.RETURN_DATE, 
                  'transactionType' : rental.transactionType, 
                  'itemCondition' : rental.itemCondition,
                  'bundleID': rental.bundleID,
                  'country': $rootScope.geoLocation.country
                };
                CartService.addCart(cartDetails);
              
                //[START] CC-1082 for analytics
                CartService.captureAddToCart(selectedObject.product, rental);
                //[END] CC-1082 for analytics
            }
        }, function(date, endDate) {
            rental.selectedDate={'START_DATE':null, 'RETURN_DATE':null};
            rental.selectedDate.START_DATE = moment(date).format('x');
            rental.selectedDate.RETURN_DATE= moment(endDate).format('x');//moment(Number(rental.selectedDate.START_DATE)).add(CONFIG.DEFAULT_RENTAL_DURATION,'d').format('x');
        }, utilities.getAvailableDatesWithSizeByMerchant(selectedObject.size,selectedObject.product,selectedObject.itemCondition),selectedObject.product.credit, CONFIG.DEFAULT_RENTAL_WEEK);

    
            },
            function(err){
              $rootScope.enableLog ? $log.error($rootScope.UUID + ":utilities:getAvailableDatesWithSizeByMerchant - Error : " + JSON.stringify(err)):'';
          });

        };

        //////////////////////////////////////////
        //ADD ITEM TO WISHLIST
        //////////////////////////////////////////
        $scope.addToWishlist = function(type, data) {
            menuBarsService.closeSidebar();
            // return cart.toggleWishlist(data);
        };

        //////////////////////////////////////////
        //CREATE A NEW WISHLIST
        //////////////////////////////////////////
        $scope.createNewWishlist = function() {

        };

        this.getPrettyUrl = function(product){
          if(product === null || !product){
            return;
          }
          var productBrand = utilities.getCustomBrandName(product);
          var urlSlug = utilities.getPrettyUrl(product.category.code, product.subCategory.code, productBrand, product.productLine);
          return urlSlug;
        }

        this.getFormattedPrice = function(price){
          return priceUtilities.getFormattedAmountByRate(price);
        }

        this.getCurrency = function(price){
          return priceUtilities.getCurrency();
        }

        $scope.isShowRentalOrders = function(){
            var rentals = $rootScope.cc.cart.filter(p=> p.transactionType == CONFIG.TRANSACTION_TYPE_RENT);
            self.displayRentals = rentals.length > 0;
        }
        $scope.isShowPurchaseOrders = function(){
          var purchases = $rootScope.cc.cart.filter(p=> p.transactionType == CONFIG.TRANSACTION_TYPE_BUY);
          self.displayPurchases = purchases.length > 0;
        }

        $scope.calculateTotal = function() {
          if($rootScope.cc.cart.length > 0) {
            calculatePurchaseAmount();
            calculateRentalCredit();
          }
          $scope.isShowRentalOrders();
          $scope.isShowPurchaseOrders();
        }

        function calculatePurchaseAmount() {
          var buyOrders = $rootScope.cc.cart.filter(p => p.transactionType == CONFIG.TRANSACTION_TYPE_BUY);
          
          var buySubTotal = 0;
          self.buyShippingFee = 0;
          buyOrders.forEach(function(purchase){
            var p = $rootScope.subscriptionSelected ? purchase.price.salePrice : purchase.price.purchasePrice;
            buySubTotal = buySubTotal + p;
          });
          self.buySubTotal = priceUtilities.getAmountByRate(buySubTotal);


            var cartItems = $rootScope.cc.cart
            .filter(p => p.transactionType == CONFIG.TRANSACTION_TYPE_BUY)
            .map(item => {
              var obj = {};
              obj['cartID'] = item.cartID;
              obj['productId'] = item.product.id;
              obj['size'] = item.size;
              obj['transactionType'] = item.transactionType;
              obj['itemCondition'] = item.itemCondition;
              return obj;
            });
      
            var multiItemReq = { 
              products: cartItems, 
              destinationCountry: $rootScope.geoLocation.country,
              currency: $rootScope.geoLocation.currency,
              exchangeRate: $rootScope.geoLocation.rate  
            };
      
            BuyService.getOtherFees(
              multiItemReq
            ).$promise.then(
              function(resp) {
                self.buyShippingFee = resp.order.shippingFee;
                self.buySubTotalWithShipping = self.buySubTotal + resp.order.shippingFee;
              }, function(err){
                self.error_txn = $filter('translate')('GENERAL.ERROR.FAILED_TO_APPLY_PROMO');
              });
  

        }

        function calculateRentalCredit() {
          if(!AuthService.isAuthenticated()){
            var rentOrders = $rootScope.cc.cart.filter(p => p.transactionType == CONFIG.TRANSACTION_TYPE_RENT);
            
            var rentSubTotalCredit = 0;
            rentOrders.forEach(function(item){
              rentSubTotalCredit = rentSubTotalCredit + item.product.credit;
            });
            self.rentalCredit = rentSubTotalCredit;
            self.rentalCreditTotalAmount = rentSubTotalCredit * priceUtilities.getOriginalCreditPrice();

          }


          var cartItems = $rootScope.cc.cart
          .filter(p => p.transactionType == CONFIG.TRANSACTION_TYPE_RENT)
          .map(item => {
            var obj = {};
            obj['cartID'] = item.cartID;
            obj['productId'] = item.product.id;
            obj['size'] = item.size;
            obj['startDate'] = item.transactionType == CONFIG.TRANSACTION_TYPE_RENT ? item.selectedDate.START_DATE : self.purchaseOrderDate;
            obj['endDate'] = item.transactionType == CONFIG.TRANSACTION_TYPE_RENT ? item.selectedDate.RETURN_DATE : self.purchaseOrderDate;
            obj['transactionType'] = item.transactionType;
            obj['itemCondition'] = item.itemCondition;
            obj['bundleID'] = item.bundleID;
            return obj;
          });

          var multiItemReq = { 
            products: cartItems, 
            destinationCountry: $rootScope.geoLocation.country, 
            currency: $rootScope.geoLocation.currency,
            exchangeRate: $rootScope.geoLocation.rate
          };

          RentalService.getCreditAndOtherFeesOnMultiProducts(
            multiItemReq,
            AuthService.isAuthenticated()
          ).$promise.then(
            function(resp) {
              self.returnedCalculatedPrice = resp;
              self.rentalCredit = resp.order.rentalCredit;
              self.currentCreditBalance = resp.currentBalance;
              self.topUpCredit = resp.topUpCredit;
              self.rentalProtectionFee = resp.order.protectionFee;
              self.shippingFee = resp.order.shippingFee;
              self.rentalMiscFee = resp.order.rentalMiscFee;
              self.totalDue = resp.order.rentalMiscFee;
              self.topUpEligibleOneCreditPrice = resp.topUpCreditUnitPrice;
              self.usualPricePerCredit = resp.usualPricePerCredit || priceUtilities.getOriginalCreditPrice();
              self.rentalCreditTotalAmount = (resp.order.rentalCredit * self.usualPricePerCredit) + resp.order.additionalRentalPrice;
              self.rentalFeePerDay = resp.rentalFeePerDay;
              self.updateTopUpCreditPrice();
              
            }, function(err){
              self.error_txn = $filter('translate')('GENERAL.ERROR.FAILED_TO_APPLY_PROMO');
          });


        };

        function showMemberPrice(){
          self.isMemberPrice = false;
          if ($rootScope.credit.balance) {
              if ($rootScope.credit.balance.activeSubscriptionId != null) {
                self.isMemberPrice = true;
              } 
          }
        }

        this.showListing = function(product) {
          var url;
          var productBrand = utilities.getCustomBrandName(product);
          var urlSlug = utilities.getPrettyUrl(product.category.code, product.subCategory.code, productBrand, product.productLine);
          
          if(utilities.isShowMainRegion()){
            url = $state.href('listing', {id: product.id, urlSlug: urlSlug});
          } else {
            url = $state.href('listing-multi-region', {id: product.id, urlSlug: urlSlug, country: $rootScope.geoLocation.country});
          }
          window.open(url,'_blank');
        };

        self.updateTopUpCreditPrice = function () {
            self.topUp.currentPlan = 0;
            self.topUp.needSub = false;
            self.topUp.subCredit = 0;
            self.topUp.subCreditPrice = 0;
            self.topUp.needExtraCredit = false;
            self.topUp.extraCredit = 0;
            self.topUp.extraCreditPrice=0;
            self.topUp.subOrCreditDiscount = 0;
            self.topUp.creditPricingDiscountRate = 0;
            self.totalDue = self.rentalMiscFee;
            self.subscribe = CONFIG.PLAN_ONE_TIME;

            if ($rootScope.credit.balance && $rootScope.isLogon){
              self.topUp.currentPlanMonth = $rootScope.credit.balance.numContractMonths;
            }
            if (
                $rootScope.credit.selectedPlan == null ||
                Session.getSelectedPlan() == null ||
                self.topUp.currentPlanMonth >= CONFIG.LONGEST_PLAN_MONTH
            ) {
                UserService.storeSelectedPlan(CONFIG.PLAN_ONE_TIME);
            }
      
            //DEFINE THE TOPUP CREDIT PRICE BASED ON CURRENT SUBSCRIBED PLAN
            if ($rootScope.credit.balance) {
                if ($rootScope.credit.balance.activeSubscriptionId != null) {
                  self.topUp.currentPlan = $rootScope.credit.balance.activeSubscriptionId;
                } else {
                  self.topUp.currentPlan = CONFIG.PLAN_ONE_TIME;
                }
            } else {
                self.topUp.currentPlan = CONFIG.PLAN_ONE_TIME;
            }
    
            var selectedPlanMonth = $rootScope.credit.pricing.find(
                p => p.id == Number(Session.getSelectedPlan())
              ).numContractMonths;
    
            if (selectedPlanMonth > self.topUp.currentPlanMonth) {
              self.topUp.needSub = true;
              self.subscribe = Number(Session.getSelectedPlan());
              self.topUp.subCredit = $rootScope.credit.pricing.find(p => p.id == self.subscribe).numCredit;
            }
    
            var extraCredit = self.topUpCredit - self.topUp.subCredit;
    
            if (extraCredit > 0) {
              self.topUp.needExtraCredit = true;
              self.topUp.extraCredit = extraCredit;
            }
            $rootScope.subscriptionSelected = self.topUp.needSub;
            // how much those topup sub and credit
            usSpinnerService.spin('spinner');
    
            RentalService.checkTopUpSubscriptionOrCreditPrice(self.subscribe, self.promoCode, self.topUp.extraCredit, AuthService.isAuthenticated(), 0, false).$promise.then(
              function (resp) {
                // check and update sub price and discount
                // update total due
                usSpinnerService.stop('spinner');
                if (self.topUp.needSub && resp.subscription.pricingId != null) {
                  self.topUp.subCreditPrice = resp.subscription.listPrice;
                  if (resp.subscription.listPrice > resp.subscription.finalMonthlyPrice[0]){
                    self.topUp.subOrCreditDiscount = resp.subscription.listPrice - resp.subscription.finalMonthlyPrice[0];
                  }
                  self.totalDue = self.totalDue + self.topUp.subCreditPrice - self.topUp.subOrCreditDiscount;
                }
                // check and update extra credit price and discount
                // update total due
                if (resp.unit != 0) {
                  self.topUp.extraCreditPrice = resp.totalPrice;
                  if (self.topUp.subOrCreditDiscount==0){ // if sub above doesn't have any discount (either sub or credit can have discount, not both)
                    self.topUp.subOrCreditDiscount = resp.totalPrice - resp.totalPriceAfterDiscount;
                  }
                  self.totalDue = self.totalDue + resp.totalPriceAfterDiscount;
                  self.topUp.creditPricingDiscountRate=(priceUtilities.getOriginalCreditPrice() - resp.unitPrice)/priceUtilities.getOriginalCreditPrice()*100;
                }
                // check for invalid promo and err
                if (self.promoCode != null && self.promoCode !='' && resp.promoCode == null && resp.subscription.promoCode == null) {
                  self.error_txn = $filter('translate')('GENERAL.ERROR.FAILED_TO_APPLY_PROMO');
                  self.GotoTop();
                }
              },
              function (err) {
                usSpinnerService.stop('spinner');
                $rootScope.enableLog ?
                  $log.error($rootScope.UUID + ":sidebarCart:topUpCredit Price Check- server response failed. " + err)
                  :
                  "";
              }
            );
          }


        //////////////////////////////////////////
        //MOVE TO WISHLIST
        //////////////////////////////////////////
        this.moveToWishlist = function(){
          var cartDetails = [];
          var moveToWishlist = [];
          if ($rootScope.cc.cart == null || $rootScope.cc.cart == undefined || $rootScope.cc.cart.length == 0){
            return true
          }

          for (var cartIndex in $rootScope.cc.cart) {
            var wishlistInfo = {};
            var cart = $rootScope.cc.cart[cartIndex];
            var cartID = cart.cartID.split("-");
            var itemID = cartID ? cartID[1] : null;
            var cartItems = cart.product.items;
            if(itemID && cartItems) {
              var cartItem = cartItems.filter(c=> c.id==itemID);
              if(cartItem.length > 0){
                var status = cartItem[0] ? cartItem[0].status : null;
                if(!(status == 8 || status == 6)) {
                  wishlistInfo = {
                    "userID": null,
                    "email": null,
                    "productId": cart.productID,
                    "size": cartItem[0].size,
                    "country": $rootScope.geoLocation.country,
                    "itemCondition": cartItem[0].itemCondition,
                    "subscribed": true
                  };

                  cart._brandName = utilities.getCustomBrandName(cart.product);
                  cart._purchasePrice = this.getFormattedPrice(cart.product.purchasePrice);
                  cartDetails.push(cart);

                  var wl = moveToWishlist.filter(w=> w.productId == wishlistInfo.productId && w.itemCondition == wishlistInfo.itemCondition && w.size == wishlistInfo.size);
                  
                  if(moveToWishlist.length == 0){
                    moveToWishlist.push(wishlistInfo);
                  } else {
                    if(!wl){
                      moveToWishlist.push(wishlistInfo);
                    } 
                  }
                 
                }
              } else {
                wishlistInfo = {
                  "userID": null,
                  "email": null,
                  "productId": cart.productID,
                  "size": cart.size,
                  "country": $rootScope.geoLocation.country,
                  "itemCondition": cart.itemCondition,
                  "subscribed": true
                };

                cart._brandName = utilities.getCustomBrandName(cart.product);
                cart._purchasePrice = this.getFormattedPrice(cart.product.purchasePrice);
                cartDetails.push(cart);

                var wl = moveToWishlist.filter(w=> w.productId == wishlistInfo.productId && w.itemCondition == wishlistInfo.itemCondition && w.size == wishlistInfo.size);
                
                if(moveToWishlist.length == 0){
                  moveToWishlist.push(wishlistInfo);
                } else {
                  if(!wl){
                    moveToWishlist.push(wishlistInfo);
                  } 
                }
              }

            }
          }

          if(moveToWishlist){
            for (var wishlistIndex in moveToWishlist) {
              var wishlist = moveToWishlist[wishlistIndex];
              WishlistService.addToWishlist(wishlist).$promise.then(
                function(resp) {},
                function(err) {
                  $rootScope.enableLog ? $log.error($rootScope.UUID + ':sidebarCart:addToWishlist - addToWishlist error: ' + err ) : '';
                }
              );
            }
          }

          if(cartDetails){
            for (var cartDetailsIndex in cartDetails) {
              var cart = cartDetails[cartDetailsIndex];
              self.removeItem(cart);
            }
            $rootScope.isCheckoutSidebarActive = true;
          }

          if(moveToWishlist.length > 0 && cartDetails.length > 0){
            DialogAlertService.moveToWishlist(cartDetails);
          }
        }

        $scope.getVolumeSum = function(items, startDate, endDate) {
          var credits = 0;
          if($rootScope.isCheckoutSidebarActive ) {
            var rentalWeeks = utilities.getRentalWeeks(startDate, endDate);
            var noBundle = items.filter(i => i.bundleID == null);
            var noBundleCredits = 0;
            if(noBundle.length > 0){
              noBundleCredits = items
              .map(function(x) { return x.product ? (x.product.credit * rentalWeeks) : 0; })
              .reduce(function(a, b) { return a + b; });
              noBundleCredits = Number(noBundleCredits);
            }
            var withBundle = items.filter(i => i.bundleID != null);
            var withBundleCredits = 0;
            if(withBundle.length > 0){
              var holdBundles = [];
              withBundle.forEach(function(item) {
                var bundleID = item.bundleID;
                var exist = holdBundles.filter(b => b === bundleID);
                if(exist.length === 0){
                  holdBundles.push(bundleID);
                  withBundleCredits = withBundleCredits + item.product.credit;
                } 
              });
              withBundleCredits = Number(withBundleCredits) * rentalWeeks;
            }
            var subCredits = noBundleCredits + withBundleCredits;
            credits = 3 - Number(subCredits);
          } return credits ;
        };

        $scope.goToBundles = function(bundleID) {
          Session.setBundleID(bundleID);
          utilities.goToSearch();
          $rootScope.isCheckoutSidebarActive = false;
        }

        this.getRentalDays = function(startDate, endDate){
          if($rootScope.isCheckoutSidebarActive ) {
            return utilities.getRentalDays(startDate, endDate);
          }
          return 0;
        }

        this.getRentalWeeks = function(startDate, endDate){
          if($rootScope.isCheckoutSidebarActive ) {
            return utilities.getRentalWeeks(startDate, endDate);
          }
          return 0;
        }

        this.getRentalAdditionalDays = function(startDate, endDate){
          if($rootScope.isCheckoutSidebarActive ) {
            var rentalDays = utilities.getRentalDays(startDate, endDate);
            return rentalDays % CONFIG.DEFAULT_WEEKLY_RENTAL;
          }
          return 0;
        }

      }]
    });
// })()

'use strict';

(function() {
  angular.module("coutureApp")
    .component("aboutUs", {
      controllerAs: "aboutUsCtrl",
      templateUrl: "scripts/components/about-us/about-us.html",
      controller: ["$state", "AuthService", "DialogAlertService", "utilities", function($state,AuthService,DialogAlertService,utilities) {

        var self = this;

        this.$onInit = function() {

        }

        this.goToProfile = function(userid){
          $state.go('wardrobe',{otherUsername:userid})
        }


        this.beLender = function(){
          if(utilities.isShowMainRegion()){
            $state.go('listings-create',{type:1});
          } else {
            $state.go('listings-create-multi-region',{type:1, country: $rootScope.geoLocation.country});
          }
        }

        this.beBorrower = function(){
          if(utilities.isShowMainRegion()){
            $state.go('search', {mm:true,fp: null});
          } else {
            $state.go('search-multi-region', {mm:true,fp: null, country: $rootScope.geoLocation.country});
          }
        }

      }]
    })
})()

'use strict';

(function() {
  angular.module("coutureApp")
    .component("privacyPolicy", {
      controllerAs: "$privCtrl",
      templateUrl: "scripts/components/privacy-policy/privacy-policy.html",
      controller: function() {

        var self = this;

        this.$onInit = function() {

        }
      }
    })
})()

'use strict';

  angular.module('coutureApp')
    .component('navbar', {
      templateUrl: 'scripts/components/navbar/navbar.html',
      controllerAs : 'navbarCtrl',
      controller: ["$rootScope", "$location", "$scope", "$timeout", "DialogAlertService", "AuthService", "utilities", "$state", "UserService", "RentalService", "menuBarsService", "$translatePartialLoader", "$log", "CONFIG", "Session", "$sce", "$translate", "$anchorScroll", "ListingService", "RefDataService", function($rootScope,$location, $scope, $timeout, DialogAlertService,AuthService,utilities,$state,
        UserService,RentalService,menuBarsService, $translatePartialLoader,$log,CONFIG,Session, $sce, $translate,$anchorScroll, ListingService, RefDataService) {

        var self = this;
        var timer;

        this.$onInit = function(){
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - NavBar"):'';

          $rootScope.showLgLogo=true;
          self.isCollapsed = true;
          self.toggleNavbar = function () {
            self.isCollapsed = !self.isCollapsed;
          }
          $scope.isSearchBarActive = null;
          $scope.isMegaMenuActive = null;
          $rootScope.cc ? '' : $rootScope.cc = {cart:[]};

          //WORKAROUND TO LOAD THE TRANSLATION. THE LABEL CANNOT LOAD DIRECTLY AS IT IS NOT YET LOADED TO MEMORY
          $translate(['HOMEPAGE.LABEL.PROMOTION_HTML']).then(function(trans){
            $scope.promotionalLabel = $sce.trustAsHtml(trans['HOMEPAGE.LABEL.PROMOTION_HTML']);
          });
          $translate(['HOMEPAGE.LABEL.PROMOTION_MOBILE_HTML']).then(function(trans){
            $scope.promotionalLabel_mobile = $sce.trustAsHtml(trans['HOMEPAGE.LABEL.PROMOTION_MOBILE_HTML']);
          });
          $translate(['HOMEPAGE.LABEL.PROMOTION_HTML_2']).then(function(trans){
            $scope.promotionalLabel2 = $sce.trustAsHtml(trans['HOMEPAGE.LABEL.PROMOTION_HTML_2']);
          });
          
          $translate(['HOMEPAGE.LABEL.BANNER_HEADING_1']).then(function(trans){
            $scope.bannerHeader1 = $sce.trustAsHtml(trans['HOMEPAGE.LABEL.BANNER_HEADING_1']);
          });
          $translate(['HOMEPAGE.LABEL.BANNER_HEADING_2']).then(function(trans){
            $scope.bannerHeader2 = $sce.trustAsHtml(trans['HOMEPAGE.LABEL.BANNER_HEADING_2']);
          });
          $translate(['HOMEPAGE.LABEL.BANNER_HEADING_3']).then(function(trans){
            $scope.bannerHeader3 = $sce.trustAsHtml(trans['HOMEPAGE.LABEL.BANNER_HEADING_3']);
          });


          if ($rootScope.isLogon){
            getUserProfile();
          }else{
            $rootScope.user = null;
            utilities.loadLocalCartWithProductInfo();
          }

          self.availableForRegion = utilities.isShowMainRegion();
        }

        $scope.$watch('navbarCtrl.isCollapsed', () => {
          self.isCollapsed ?
            window.removeEventListener('scroll', handleScroll) :
            window.addEventListener('scroll', handleScroll)
        })

        function handleScroll() {
          $scope.$apply(self.toggleNavbar());
        }

        /////////////////////////////////
        //LOAD THE USER PROFILE TO ROOTSCOPE
        /////////////////////////////////
        function getUserProfile(){
          UserService.retrieveUserProfile().$promise.then(function(resp) {
            utilities.updateLocalUserProfile(resp);

            $rootScope.isLogon = true;

            //RELOAD THE CART IF USER CLICK RELOAD BUTTON
            utilities.loadCartFromServer();
          }, function(err) {
            delete ($rootScope.user);
            $rootScope.isLogon = false;
            if(utilities.isShowMainRegion()){
              $state.go('main');
            } else {
              $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
            }
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":navbar:getUserProfile - Error: " +  err.status):'';
          });
        }

        /////////////////////////////////
        //TRIGGER THE MEGA MENU ITEM WITH DELAY DEFINED BELOW '5ms'
        /////////////////////////////////
        self.showIt = function (menu) {

          $scope.isMegaMenuActive = null;
          //DASHBOARD
          if (menu === "db"){
            $scope.isSearchBarActive = false;
            timer = $timeout(function () {
              $scope.isDashboardMenuActive = true
            }, 500);
          }else{

            $scope.isDashboardMenuActive = null;
            timer = $timeout(function () {
                $scope.isMegaMenuActive = menu;
            }, 500);
          }
        };

        /////////////////////////////////
        //MOUSE LEFT EVENT. HIDE THE MEGA MENU AS THE MOUSE LEFT THE MENU
        /////////////////////////////////
        self.hideIt = function () {
          $timeout.cancel(timer);
        };

        /////////////////////////////////
        //SHOW/HIDE THE MEGA MENU
        /////////////////////////////////
        $scope.toggleCheckoutSidebar = function() {
          $scope.isSearchBarActive = false;
          $anchorScroll();
          menuBarsService.toggleSidebar(false);
          $rootScope.showLgLogo = false;
        }

        /////////////////////////////////
        //GET THE LIST OF PRODUCT BASED ON THE DEFINED PARAS IN THE HTML (MEGA MENU ITEM)
        /////////////////////////////////
        this.getProductWith = function(query,inputBrand, inputCategory, status){
          $scope.isMegaMenuActive = null;
          $scope.isSearchBarActive = false;
          this.isCollapsed=true;
          Session.prev_filterParams = null;
          if(utilities.isShowMainRegion()){
            $state.go('search', {
              q:query, 
              brand: inputBrand,
              category: inputCategory,
              type:CONFIG.DEFAULT_SEARCH_TYPE, 
              page:null,
              status:status ? status : null,
              sort:CONFIG.DEFAULT_SEARCH_SORT_ORDER,
              color:null,
              size:null,
              id:null
            });
          } else {
            $state.go('search-multi-region', {
              q:query, 
              brand: inputBrand,
              category: inputCategory,
              min: CONFIG.PRICE_MIN,
              max: CONFIG.PRICE_MAX,
              type:CONFIG.DEFAULT_SEARCH_TYPE, 
              page:null,
              status:status ? status : null,
              sort:CONFIG.DEFAULT_SEARCH_SORT_ORDER,
              color:null,
              size:null,
              id:null,
              country: $rootScope.geoLocation.country
            });
          }
        }

        this.getMultiOccassions = function(){
          $scope.isMegaMenuActive = null;
          $scope.isSearchBarActive = false;
          this.isCollapsed=true;
          Session.prev_filterParams = null;
          if(utilities.isShowMainRegion()){
            $state.go('search', {
              q:'vacation|casual|office|summerstatement|formal|party|cocktail|bridal', 
              brand: null,
              category: null,
              type:CONFIG.DEFAULT_SEARCH_TYPE, 
              page:null,
              status:null,
              sort:CONFIG.DEFAULT_SEARCH_SORT_ORDER,
              color:null,
              size:null,
              id:null
            });
          } else {
            $state.go('search-multi-region', {
              q:'vacation|casual|office|summerstatement|formal|party|cocktail|bridal', 
              brand: null,
              category: null,
              type:CONFIG.DEFAULT_SEARCH_TYPE, 
              page:null,
              status:null,
              sort:CONFIG.DEFAULT_SEARCH_SORT_ORDER,
              color:null,
              size:null,
              id:null,
              country: $rootScope.geoLocation.country});
          }
        }

        /////////////////////////////////
        //TOOGLE TO SHOW THE SEARCH BAR
        /////////////////////////////////
        $scope.toggleSearchBar = function() {
          $scope.isMegaMenuActive = null;
          $scope.isSearchBarActive = !$scope.isSearchBarActive;
          //HAVE THE SERACH BAR FOCUS WHEN SEARCH BAR APPEARS
          $timeout(function() {
                  document.querySelector('#searchBar').focus();
          });
        };

        /////////////////////////////////
        //SIGN OUT
        /////////////////////////////////
        this.signOut = function(){
          $scope.$emit('header:logout', null);
          $scope.isDashboardMenuActive = null;
          if(utilities.isShowMainRegion()){
            $state.go("main")
          } else {
            $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
          }
        }

        /////////////////////////////////
        //SIGN IN
        /////////////////////////////////
        this.signIn = function() {
          DialogAlertService.openLogon();
        };

        this.goToMyAccount = function() {
          if(utilities.isShowMainRegion()){
            $state.go("my-account")
          } else {
            $state.go('my-account-multi-region', {country: $rootScope.geoLocation.country});
          }
        };

        this.isActive = function(route) {
          return route === this.$location.path();
        }


        /////////////////////////////////
        //OPEN THE WISHLIST
        /////////////////////////////////
        $scope.openWishlist = function() {
            $scope.isSearchBarActive = false;
            if($rootScope.isLogon) {
              if(utilities.isShowMainRegion()){
                $state.go('wishlists');
              } else {
                $state.go('wishlists-multi-region', {country: $rootScope.geoLocation.country});
              }
            } else {
                DialogAlertService.openSignIn();
            }
        };


        function handleSearchOnTypeResult(params){
          const searchFilters = utilities.prepareSearchFilters(params);
          ListingService.getListingSuggestions(searchFilters).$promise.then(
            function(resp) {
              $rootScope.enableLog ? $log.info($rootScope.UUID + ":NavbarCtrl:search - Listing Suggestions: " + JSON.stringify(resp.length)) : '';
              $scope.searchResultSet = resp;
            },
            function(err) {
              $scope.searchResultSet = {};
            });
        }

        this.searchOnType = function(query, inputBrand, inputCategory){
          
          if(query && query.length >= 3){
            var searchParams = {
              q:query,
              brand: inputBrand,
              category: inputCategory,
              min: CONFIG.PRICE_MIN,
              max: CONFIG.PRICE_MAX,
              type: CONFIG.DEFAULT_SEARCH_TYPE,
              sort: CONFIG.DEFAULT_SEARCH_SORT_ORDER,
            };
            handleSearchOnTypeResult(searchParams);
          } else {
            $scope.searchResultSet = {};
          }
        }

        this.setTransactionType = function(type) {
          $rootScope.transactionType = type;
        }

        $scope.setSelectedCountry= function(countryCode) {
          var currentState = $state.current ? $state.current.name : "main";
          
          if(countryCode == "SG"){
            $state.params.country = "SG";
            $rootScope.geoLocation.countryFlag = CONFIG.SG_FLAG_SRC;
          } else {
            $state.params.country = "HK";
            $rootScope.geoLocation.countryFlag = CONFIG.HK_FLAG_SRC;
          }

          if(currentState.indexOf("-multi-region") == -1){
            currentState = currentState + "-multi-region";
          } 
          utilities.loadAllowedDatesFromServer(countryCode);
          $state.go(currentState, $state.params, {reload:true});
        }

        this.goToPage = function(page){
          if(utilities.isShowMainRegion()){
            $state.go(page);
          } else {
            $state.go(page + '-multi-region',{country: $rootScope.geoLocation.country});
          }
        }

        this.openCreditPackage = function() {
          DialogAlertService.openCreditPackage();
        }

        function showLargeLogo(){
          
          if(window.scrollY>80){
            $rootScope.showLgLogo=false;
          }
          else{
            $rootScope.showLgLogo=true;
          }
          if (!$scope.$$phase) {
            $scope.$apply();
          }
        }
  
        window.addEventListener('scroll', showLargeLogo);
      }]
      

    });

'use strict';

angular.module('coutureApp')
  .component('footer', {
    templateUrl: 'scripts/components/footer/footer.html',
    controllerAs : 'ftCtrl',
    controller: ["$http", function($http) {

      var self = this;
      self.version = "";

      $http.get('/version.txt').then(function(resp) {
        self.version = resp.data;
      });

      this.year = function(){
        return (new Date()).getFullYear()
      }
    }]
  });

'use strict';

/**
 * @ngdoc function
 * @name coutureApp.controller:LandingCtrl
 * @description
 * # LandingCtrl
 * Controller of the coutureApp
 */
 angular.module('coutureApp')
 .controller('LandingCtrl', ["$scope", "$state", "$log", "PageCtx", "$http", "DialogAlertService", "$rootScope", "CONFIG", "Session", "$sce", "$translate", "$timeout", "$filter", "utilities", function($scope, $state,$log, PageCtx, $http,DialogAlertService,$rootScope,CONFIG,Session, $sce, $translate,$timeout,$filter,utilities) {

  	var self = this;
    self.mainListing = [];
    self.wardrobeList = [];
    self.wardrobeList2 = [];
    self.carousel2 = [];

    //CAROUSEL CONFIG VALUES
    $scope.myInterval = 3000;
    $scope.wardrobeList_Interval = 3000;
    $scope.wardrobeList2_Interval = 3000;

    $scope.noWrapSlides = false;
    $scope.active = 0;

  	// Init the relevant logic on page refresh
  	this.$onInit = function() {
      var filtersParams = {
        min: CONFIG.PRICE_MIN,
        max: CONFIG.PRICE_MAX,
        creditMin: CONFIG.CREDIT_MIN,
        creditMax: CONFIG.CREDIT_MAX,
        sort: CONFIG.DEFAULT_SEARCH_SORT_ORDER,
        page: "1",
        type: utilities.getDefaultTypeFilterParams(),
        country: $rootScope.geoLocation.country
      };
      if(utilities.isShowMainRegion()){
        $state.go('search');
      } else {
        $state.go('search-multi-region', filtersParams);
      }

      //WORKAROUND TO LOAD THE TRANSLATION. THE LABEL CANNOT LOAD DIRECTLY AS IT IS NOT YET LOADED TO MEMORY
      $translate(['HOMEPAGE.LABEL.SECTION_1_HEADING_1_HTML']).then(function(trans){
        $scope.SECTION_1_HEADING_1_HTML = $sce.trustAsHtml(trans['HOMEPAGE.LABEL.SECTION_1_HEADING_1_HTML']);
      });
      $translate(['HOMEPAGE.LABEL.SECTION_1_SUB_HEADING_1_HTML']).then(function(trans){
        $scope.SECTION_1_SUB_HEADING_1_HTML = $sce.trustAsHtml(trans['HOMEPAGE.LABEL.SECTION_1_SUB_HEADING_1_HTML']);
      });
      $translate(['HOMEPAGE.LABEL.SECTION_1_SUB_HEADING_1_MOBILE_HTML']).then(function(trans){
        $scope.SECTION_1_SUB_HEADING_1_MOBILE_HTML = $sce.trustAsHtml(trans['HOMEPAGE.LABEL.SECTION_1_SUB_HEADING_1_MOBILE_HTML']);
      });

      //LOAD THE META DESCRIPTION
      $timeout(function () {
        var meta = document.querySelector('meta[name=description]');
        var content = $filter('translate')('HOMEPAGE.META.DESCRIPTION');
        if (meta !== null && content !== null) {
          meta.setAttribute('content', content);
        }

        var titleMeta = document.querySelector('title[id=title]');
        var titleContent = $filter('translate')('HOMEPAGE.TITLE');
        if (titleMeta !== null && titleContent !== null) {
          titleMeta.text = titleContent;
        }

      }, 1000);
    };

    this.signup = function(){
      DialogAlertService.openLogon('','',true,true);
    }

    this.signin = function(){
      DialogAlertService.openLogon('','',true,false);
    }


    this.isArray = function(text){
      return angular.isArray(text) ? true : false;
    }


    // Retrieve listing based on listing id
    this.showListing = function(id) {
      if(utilities.isShowMainRegion()){
        $state.go("listing", {id: id})
      } else {
        $state.go('listing-multi-region', {id: id, country: $rootScope.geoLocation.country});
      }
    };

    /////////////////////////////////
    //GET THE LIST OF PRODUCT BASED ON THE DEFINED PARAS IN THE HTML (MEGA MENU ITEM)
    // query: params.q,
    // brand: params.brand,
    // category: params.category,
    // priceMin: params.min,
    // priceMax: params.max,
    // discountRateMin: params.fdmin,
    // discountRateMax: params.fdmax,
    // page: params.page
    // type: params.type
    // rental fee min: params.feeMin
    // rental fee max: params.feeMax
    /////////////////////////////////
    this.getProductWith = function(query, inputBrand, inputCategory, inputPriceMin,	inputPriceMax,altTextSearch){
      Session.prev_filterParams = null;
      var searchWord_Array = altTextSearch ? altTextSearch : query;
      var searchQuery = Array.isArray(searchWord_Array) ? searchWord_Array.join(" ") : searchWord_Array;
      
      if(utilities.isShowMainRegion()){
        $state.go('search', {q:searchQuery,mm:true,brand: inputBrand,category: inputCategory,min: inputPriceMin | CONFIG.PRICE_MIN,max: inputPriceMax | CONFIG.PRICE_MAX,fdmin: null,fdmax: null,feeMin:null,feeMax:null,type:utilities.getDefaultTypeFilterParams(),page:null,status:null,sort:CONFIG.DEFAULT_SEARCH_SORT_ORDER,color:null,size:null});
      } else {
        $state.go('search-multi-region', {q:searchQuery,mm:true,brand: inputBrand,category: inputCategory,min: inputPriceMin | CONFIG.PRICE_MIN,max: inputPriceMax | CONFIG.PRICE_MAX,fdmin: null,fdmax: null,feeMin:null,feeMax:null,type:utilities.getDefaultTypeFilterParams(),page:null,status:null,sort:CONFIG.DEFAULT_SEARCH_SORT_ORDER,color:null,size:null,country: $rootScope.geoLocation.country});
      }
    }

    //////////////////////////////////////////////////////////////////
    //GET PAGE NAME/IMAGE/URL/DESCRIPTION FROM THE JSON
    //
    //////////////////////////////////////////////////////////////////
    // $http.get('/scripts/config/mainListing.json').then(function successCallback(response) {
    //     response.data.forEach(function(item, key) {
    //         self.mainListing.push({
    //             id: key,
    //             image: item.image,
    //             text: item.text,
    //             secondText : item.text2,
    //             link: item.link,
    //             imageStyle: item.imageStyle
    //         });
    //     });
    // }, function errorCallback(response) {
    //   $rootScope.enableLog ? $log.error($rootScope.UUID + ":LandingCtrl:init - Error loading mainlisting."):'';
    // });


    //////////////////////////////////////////////////////////////////
    //GET PAGE NAME/IMAGE/URL/DESCRIPTION FROM THE JSON
    //////////////////////////////////////////////////////////////////
    $http.get('/scripts/config/wardrobeList.json').then(function successCallback(response) {
        response.data.forEach(function(item, key) {
          if (item.list == 1){
            self.wardrobeList.push({
                id: self.wardrobeList.length,
                image: item.image,
                productID: item.productID
            });
          }else{
            self.wardrobeList2.push({
                id: self.wardrobeList2.length,
                image: item.image,
                productID: item.productID
            });
          }
        });
    }, function errorCallback(response) {
      $rootScope.enableLog ? $log.error($rootScope.UUID + ":LandingCtrl:init - Error loading wardrobeList."):'';
    });

    //////////////////////////////////////////////////////////////////
    //GET PAGE NAME/IMAGE/URL/DESCRIPTION FROM THE JSON
    //////////////////////////////////////////////////////////////////
    $http.get('/scripts/config/carousel2.json').then(function successCallback(response) {
        response.data.forEach(function(item, key) {
            self.carousel2.push({
                id: key,
                image: item.image,
                text: item.text,
                searchKeywords: item.searchKeywords
            });
        });
    }, function errorCallback(response) {
      $rootScope.enableLog ? $log.error($rootScope.UUID + ":LandingCtrl:init - Error loading carousel2."):'';
    });


}]);

'use strict';
(function() {
  angular.module('coutureApp')
    .component('carousel', {
      templateUrl: 'scripts/components/carousel/carousel.html',
      controllerAs: 'ctrl',
      controller: ["$scope", "$http", "$rootScope", "$log", function($scope, $http,$rootScope,$log) {

        //DEFINE SCOPE OF this
        var $ctrl = this;

        $scope.myInterval = 5000;
        $scope.noWrapSlides = false;
        $scope.active = 0;
        $scope.slides = [];
        $scope.mslides = [];

        // gets carousel list on init
        $http.get('/scripts/config/carousel.json').then(function successCallback(response) {
            //SEPARATE THE MOBILE AND DESKTOP SPECIFIC IMAGE TO KEEP KEY UNIQUE
            response.data.filter((x)=> {return x.mobile}).forEach(function(item, key) {
                $scope.mslides.push({
                    id: key,
                    mobile:item.mobile,
                    image: item.image,
                    show_divider: item.show_divider,
                    text: item.text,
                    link: item.link,
                    linkText: item.linkText
                });
            });
            response.data.filter((x)=> {return x.mobile == undefined || x.mobile == false}).forEach(function(item, key) {
                $scope.slides.push({
                    id: key,
                    image: item.image,
                    show_divider: item.show_divider,
                    text: item.text,
                    link: item.link,
                    linkText: item.linkText
                });
            });
        }, function errorCallback(response) {
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":carousel:errorCallback - response.statusText"):'';
        });

        $scope.slideTo = function(index) {
            if(index >= 0 && index <= slides.length) {
                $scope.active = index;
            }
        };
      }]
    });
})()

'use strict';

angular.module('carouselDirective', [])
.controller('cdCtrl', ['$scope', '$state',function($scope,$state,utilities) {

  // Retrieve listing based on listing id
  $scope.showListing = function(id) {
    if(utilities.isShowMainRegion()){
      $state.go('listing', {id: id});
    } else {
      $state.go('listing-multi-region', {id: id, country: $rootScope.geoLocation.country});
    }
  };
}])
.directive('carouselDir', ['$timeout',function($timeout) {
   return {
      restrict: 'E',
      scope: {
        links: '=',
        widget: '@',
        interval: '='
      },
      templateUrl: 'scripts/components/carousel/carouselTemplate.html',
      link: function(scope, element) {
        $timeout(function(){
          $('.carousel-indicators li',element).first().addClass('active');
          $('.carousel-inner .item',element).first().addClass('active');
          $('#'+scope.widget+'.carousel').carousel({interval: scope.interval});
        },2000);
      }
   };
}]);

'use strict';

(function() {
  angular.module('coutureApp')
    .component('faq', {
      templateUrl: 'scripts/components/faq/faq.html',
      controllerAs: 'faqCtrl',
      bindings:{
        isOwner : '<'
      },
      controller: ["$rootScope", "$scope", "CommentService", "$state", "$translatePartialLoader", function($rootScope, $scope,CommentService,$state,$translatePartialLoader) {


        this.$onInit = function(){

          this.question_data = {};
          this.selectedCategoryKey = "";
          this.tab = 2;
          this.showAnswerQuestionForm = false;
          this.textarea_maxlength = 2048;
          this.answerForm = {text:"",openItemIndex:-1};
          this.questionForm = {text:""};

          //LABLE & DESCRIPTION & PLACEHOLDER
          self.categoryLabel = {'1':'COMMENT_COMPONENT.LABEL.GENERAL','2':'COMMENT_COMPONENT.LABEL.SIZE_FIT','3':'COMMENT_COMPONENT.LABEL.DESIGNER'};

          //GET THE LIST TO FILL THE DDL
          this.getCommentList();
        };

        //DEFINE SCOPE OF this
        var self = this;

        this.resetShowHideQuestionForm = function() {
          this.showAnswerQuestionForm = false;
        };


        this.isFAQOpened = function(index){
          if (self.answerForm.openItemIndex == index) {
            return true;
          }else{
            return false;
          }
        }

        this.openFAQ = function(needAnswer,isAnswerSectionShown,isItemOwner,index){

          self.answerForm.openItemIndex == index ? self.answerForm.openItemIndex = -1 : self.answerForm.openItemIndex = index;
          //RESET FAQ CONTENTS
          self.answerForm.text = "";
          self.resetAnswerForm();


          // this.answerForm = {text:"",openItemIndex:-1};
          // if ($scope.answerForm) {
          //   $scope.answerForm.$setPristine();
          // }

          if ((angular.isUndefined(needAnswer) || needAnswer === null) && isItemOwner && self.isFAQOpened(index)){
            this.showAnswerQuestionForm = true;
          }else{
            this.showAnswerQuestionForm = false;
          }
        };


        this.resetAnswerForm = function () {
            for(var cs = $scope.$$childHead; cs != null; cs = cs.$$nextSibling) {
                if (cs.answerForm) {
                  cs.answerForm.$setPristine();
                }
            }
        };

        /*
        cat = 1 : general, 2:Size & fit, 3:designer
        type = 1 : Question, 2: Comment  (2 is not needed for now), 3: Answer (owner only)
        id =  Unique id for each question. Used to provide answer to question.  For now, only 1 response per question.
        */
        this.submitRequest = function(index){
          var requestMsg = {};
          requestMsg.cat = this.selectedCategoryKey;
          requestMsg.type = this.showAnswerQuestionForm ? 3 : 1;
          requestMsg.msg = this.showAnswerQuestionForm ? this.answerForm.text : this.questionForm.text;
          if (index != undefined){
            requestMsg.id = this.question_data[this.selectedCategoryKey][index].id;
          }
          $scope.questionForm.$setPristine();

          CommentService.create($state.params.id,requestMsg).$promise.then(
            function(resp){

              //REFRESH LIST
              self.getCommentList();
              self.showAnswerQuestionForm = false;
              self.answerForm.text = "";
              self.answerForm.openItemIndex = -1;
              self.questionForm.text = "";
              $scope.questionForm.$setPristine();
              self.resetAnswerForm();
            }
          )

        };


        this.getAnswer = function(catKey){
          self.selectedCategoryKey = catKey;
        }



        //LOAD ALL THE COMMENTS FOR THIS ITEM
        this.getCommentList = function(){
          CommentService.getList($state.params.id).$promise.then(function(resp){
                self.question_data = resp;
            }
          );
        };

      }]
    })
})()

'use strict';
angular.module('coutureApp')
  .component('resetPassword', {
    controllerAs : 'resetPasswordCtrl',
    templateUrl: 'scripts/components/resetPassword/reset-password.html',
    controller: ["$rootScope", "$scope", "UserService", "DialogAlertService", "AuthService", "$state", "utilities", "$filter", "$translate", "$translatePartialLoader", "usSpinnerService", "$log", function($rootScope, $scope, UserService, DialogAlertService,AuthService,
        $state ,utilities,$filter,$translate,$translatePartialLoader,usSpinnerService,$log) {

      var self = this;
      this.$onInit = function(){
        if($state.params.token) {
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - resetPassword"):'';
          self.isUnlinkSocial = false;
          self.newPass = null;
          self.verifyPass = null;
          self.token = null;
          self.lk_btn = false;
          self.showPassError = false;
          self.token=$state.params.token;
          self.validateToken(self.token);
        }else if($state.params.p && $rootScope.isLogon){
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - resetPassword"):'';
          self.isUnlinkSocial = true;
        }else{
          if(utilities.isShowMainRegion()){
			      $state.go('main');
          } else {
            $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
          }
        }
      }


      ////////////////////////////
      //VALIDATE TOKEN
      ////////////////////////////
      this.validateToken = function(token){
        usSpinnerService.spin('spinner');
        UserService.validResetPasswordToken(token).$promise.then(
          function(resp){
            usSpinnerService.stop('spinner');
          },
          function(err){
            usSpinnerService.stop('spinner');
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":resetPassword:validateToken - Error: " + JSON.stringify(err)):'';
            if(utilities.isShowMainRegion()){
              $state.go('main');
            } else {
              $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
            }
        });
      }


      ////////////////////////////
      //CHANGE PASSWORD
      ////////////////////////////
      this.changePassword = function(){
        self.lk_btn = true;
        usSpinnerService.spin('spinner');
        if (self.isUnlinkSocial){
          usSpinnerService.stop('spinner');

          AuthService.socialDelete({"network":$state.params.p,"password":self.verifyPass}).$promise.then(
            function(resp){
              DialogAlertService.promptDialog('Password updated successfully. ', '', '', '', $filter('translate')("GENERAL.LABEL.OK"), 
              function(){
                if(utilities.isShowMainRegion()){
                  $state.go('my-account')
                } else {
                  $state.go('my-account-multi-region', {country: $rootScope.geoLocation.country})
                }
              }, function(){
                if(utilities.isShowMainRegion()){
                  $state.go('main');
                } else {
                  $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
                }
              }, false);
            },function(err){
              $rootScope.enableLog ? $log.error($rootScope.UUID + ":AuthCtrl:socialDelete - Logon error: " + err):'';
          });

        }else{
          UserService.resetPassword(self.token,self.verifyPass).$promise.then(
      			function(resp){
              usSpinnerService.stop('spinner');
              self.lk_btn = false;
              $rootScope.enableLog ? $log.info($rootScope.UUID + ":resetPassword:changePassword - Succeeded"):'';
              DialogAlertService.promptDialog('Password updated successfully. ', '', '', '', $filter('translate')("GENERAL.LABEL.OK"), 
              function(){
                if(utilities.isShowMainRegion()){
                  $state.go('main');
                } else {
                  $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
                }
              }, 
              function(){
                if(utilities.isShowMainRegion()){
                  $state.go('main');
                } else {
                  $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
                }
              }, false);
      			},
      			function(err){
      				usSpinnerService.stop('spinner');
              self.lk_btn = false;
              $rootScope.enableLog ? $log.error($rootScope.UUID + ":resetPassword:changePassword - Error: " + JSON.stringify(err)):'';
              DialogAlertService.promptDialog('Error updating the Password. Please try again later. ', '', '', '', $filter('translate')("GENERAL.LABEL.OK"), '', '', false,'',"RED");
    			});
        }
      }


      ////////////////////////////
      //PASSWORD VALIDATION
      ////////////////////////////
      this.validatePasswordChange = function(){
        self.showPassError = utilities.validatePassword(self.newPass , self.verifyPass);
      }
    }]
  })

'use strict';

(function() {
  angular.module("coutureApp")
    .component("faqGeneral", {
      controllerAs: "faqGeneralCtrl",
      templateUrl: "scripts/components/faq-general/faq-general.html",
      controller: ["$scope", "$anchorScroll", "$stateParams", "$timeout", function($scope,$anchorScroll,$stateParams,$timeout) {

        var self = this;
        this.$onInit = function() {
          if ($stateParams.section !=null && $stateParams.section != ""){
            $timeout(function() {
              //EXPANDS THE FAQ SECTION AND SCROLL TO THE SECTION
              $scope['tg_'+$stateParams.section] = true;
              $anchorScroll($stateParams.section);
            }, 100);
          }
        }
      }]
    })
})()

'use strict';

angular.module('coutureApp')
  .component('membership', {
    templateUrl: 'scripts/components/membership/membership.html',
    controllerAs : 'membershipCtrl',
    controller: ["$rootScope", "DialogAlertService", "$state", "$log", function($rootScope,DialogAlertService,$state,$log) {
      var self = this;
      self.redirectToProfile = false;

      this.$onInit = function(){
        $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - membershipCtrl"):'';
      }

      this.promptLogon = function(){
        if ($rootScope.isLogon){
          if(utilities.isShowMainRegion()){
            $state.go('profile');
          } else {
            $state.go('profile-multi-region', {country: $rootScope.geoLocation.country});
          }
        }else{
          DialogAlertService.openLogon();
          self.redirectToProfile = true;
        }
      }

      //////////////////////////////////////////////////////////////////////////
      // WORKAROUND, AS PROFILE IS BECOME PUBLIC, THE REQUIREMENT IS IF NOT   //
      // ALREADY LOGON, FIRST PROMOT FOR LOGON. IF LOGON SUCCESSFUL AND IS    //
      // FROM THIS PAGE THEN DIRECT TO PROFILE PAGE.                          //
      //////////////////////////////////////////////////////////////////////////
      $rootScope.$watch('isLogon', function() {
        if (self.redirectToProfile && $rootScope.isLogon){
          if(utilities.isShowMainRegion()){
            $state.go('profile');
          } else {
            $state.go('profile-multi-region', {country: $rootScope.geoLocation.country});
          }
        }else{
          self.redirectToProfile = false;
        }
      }, true);

    }]
});

'use strict';
(function(){
  angular.module('coutureApp')
    .component('membershipUpgrade', {
      templateUrl: 'scripts/components/membership-upgrade/membership-upgrade.html',
      controllerAs : 'membershipUpgradeCtrl',
      controller: function() {

        this.$onInit = function(){
          
        }
      }
    });
})()

'use strict';

angular.module('coutureApp')
  .component('productCardList', {
    templateUrl: 'scripts/components/product-card-list/product-card-list.html',
    controllerAs: '$cardCtrl',
    bindings: {
      loadListings: '<',
      products: '<',
      sortOrder: '<',
      callback:'<'
    },
    controller: ["$scope", "Session", "$rootScope", "$log", "$state", "usSpinnerService", "CartService", "utilities", "priceUtilities", "AuthService", "ListingService", "RentalService", "$window", "CalendarService", "CONFIG", "USER_ROLES", "DialogAlertService", "WishlistService", "$uibModal", "$sce", "$translate", "RefDataService", function($scope, Session,$rootScope, $log,$state, usSpinnerService,CartService,utilities,
      priceUtilities,AuthService,ListingService,RentalService,$window,CalendarService,CONFIG,USER_ROLES,DialogAlertService,WishlistService,$uibModal,$sce, $translate, RefDataService) {

      var self = this;
      this.$onInit = function(){
        // product options dropdown section
        $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - productCardList"):'';
        $scope.productOptions = [
          'Reset to Available',
          'Option 2',
          'Option 3'
        ];
        self.product_currency = priceUtilities.getCurrency();

        $scope.status = {
          isopen: false
        };
        $scope.isAdmin = false;
        if (AuthService.isAuthorized(USER_ROLES.admin)){
          $scope.isAdmin = true;
        } 
        self.isMobileView = utilities.isMobileView();

      }


      this.isPriceDisplay = function(){
        return priceUtilities.isPriceDisplay();
      }
      //////////////////////////////////////////////////////////////////
      // UPDATE PAGINGATION IN THE SEARCH.COMPONENT WITH THE CURRENT PRODUCT
      // PAGE NUMBER AS IT DISPLAY ON SCREEN.
      //////////////////////////////////////////////////////////////////
      angular.element(window).bind('scroll', function (scope, element, attrs) {
        if(!self.products){
          if(utilities.isShowMainRegion()){
            $state.go('search', {q:null,mm:true,brand: null,category: null,min: CONFIG.PRICE_MIN,max: CONFIG.PRICE_MAX,fdmin: null,fdmax: null,feeMin:null,feeMax:null,type:utilities.getDefaultTypeFilterParams(),page:null,status:null,sort:CONFIG.DEFAULT_SEARCH_SORT_ORDER,color:null,size:null});
          } else {
            $state.go('search-multi-region', {q:null,mm:true,brand: null,category: null,min: CONFIG.PRICE_MIN,max: CONFIG.PRICE_MAX,fdmin: null,fdmax: null,feeMin:null,feeMax:null,type:utilities.getDefaultTypeFilterParams(),page:null,status:null,sort:CONFIG.DEFAULT_SEARCH_SORT_ORDER,color:null,size:null,country: $rootScope.geoLocation.country});
          }
        }

        var domID;
        var pageNUM;
        var foundStartOfView = false;   //LOCATE THE START OF THE SCREEN WHERE USER INVIEW.

        //LOOP THRU ALL THE PRODUCTS RETURNED
        for (var i = 0; i < self.products.length; i++) {

          if ($window.document.getElementsByClassName('pageNum')[i] != undefined){

            //FOUND THE LOCATION ID OF EACH PRODUCT WHICH DEFINE IT IS STILL ON SCREEN.
            domID = self.products[i].id + "_INVIEW";

            if (!utilities.inViewPort(domID) && foundStartOfView){
              //THIS PRODUCT IS NO LONGER IN USER'S VIEW. EXIT THE SEARCH
              break;
            }else if(utilities.inViewPort(domID)){
              //THE CURRENT PRODUCT IS IN USER'S VIEW
              foundStartOfView = true;
              pageNUM = $window.document.getElementsByClassName('pageNum')[i].getAttribute('page');
            }
          }
        }

        //UPDATE THE SEARCH COMPONENT PAGINGATION PAGE NUM
        if (pageNUM && !isNaN(pageNUM)){
          $scope.$apply(self.callback(pageNUM));
        }
      });

      //REMOVE THE BINDING OF THE SCROLL
      this.$onDestroy = function () {
        angular.element(window).unbind('scroll');
      };


      //////////////////////////////////////////////////////////////////
      //RETURN THE MAIN PICTURE TO DISPLAY
      //////////////////////////////////////////////////////////////////
      this.getMainPhoto = function(product){
        return utilities.getMainPhoto(product);
      }
      this.getDisplayPhoto = function(product, position){
        return utilities.getDisplayPhoto(product, position);
      }

      //////////////////////////////////////////////////////////////////
      //ADD SPECIAL LOGIC WHEN USER ENTER OTHER BRAND, THE req_listing WILL REMAINS '-- OTHER BRAND --'
      //BUT THE ACTUAL BRAND WILL BE STORED IN TAG. HOWEVER IT WILL NOT GOING TO DISPLAY ON SCREEN.
      //////////////////////////////////////////////////////////////////
      this.getDisplayBrand = function(product){
        return utilities.getCustomBrandName(product);
      }

      this.getSizeObject = function(product){

          //RETURN THE SIZE OBJECT {KEY:'IT36', VALUE:'EU35 / IT35 / FR36 / US5 / UK2'} BASED ON THE SIZEKEY
          var foundSizeObject = utilities.returnMatchedSizeObject(product.category,product.size);
          return foundSizeObject ? foundSizeObject: null;
      }

      this.isOwner = function(product){
        return utilities.isProductOwner(product);
      }

      this.isInCart = function(product) {
        if ($rootScope.cc){
          return utilities.isItemInArray(product,$rootScope.cc.cart);
        }else{
          return false;
        }
      };

      $scope.toggleDropdown = function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        $scope.status.isopen = !$scope.status.isopen;
      };

      // Retrieve listing based on listing id
      this.showListing = function(id, product) {
        utilities.showListing(id, product);
      };

      this.showListingByTransaction = function(id, product, transactionType) {
        $rootScope.transactionType = transactionType;
        utilities.showListing(id, product);
      };

      // product cards action buttons
      $scope.toggleProductOption = function(data) {

        //DEBUG FRANCO
        switch (data.option) {
          case 0:
            console.log('Reset Rental to Available', data.id.status );
            var modProduct = JSON.parse(angular.toJson(data.id));
            modProduct.status = 8;
            ListingService.update(modProduct).$promise.then(function(resp) {
              $rootScope.enableLog ? $log.info($rootScope.UUID + ":productCardList:toggleProductOption - Successfully reset rental to available." + JSON.stringify(resp)):'';
            }, function(err) {
              $rootScope.enableLog ? $log.error($rootScope.UUID + ":productCardList:toggleProductOption - Error:" + err.data.reasons[0].message):'';
            });

            break;
          default:

        }

        // console.log(data);
      };



      this.isAvailable = function(product){
       return utilities.isProductAvailableForRental(product);
      }

      //////////////////////////////////////////
      //  GET RENTAL PRICE
      //////////////////////////////////////////
      this.getRentalPrice = function(price, discountRate) {
        return priceUtilities.getRentalPrice(price,discountRate);
      };


      this.getDisplayTagOrigPrice = function(product){
        var price = priceUtilities.getAmountByRate(product.price);
        
        return priceUtilities.currencyFormat(Math.round(price));
      }

      this.isSalePriceSameWithOrigPrice = function(product){
        return priceUtilities.isSalePriceSameWithOrigPrice(product.price, product.discountRate)
      }

      //////////////////////////////////////////
      //CALCULATE ALL THE PRICING
      //////////////////////////////////////////
      this.calculatePricing = function(){
        var productSummaryMap = priceUtilities.sumOfProductsInCart();
        self.subTotalRentalPrice = productSummaryMap.get('subTotalRentalPrice');
        self.subTotalProtectionFee = productSummaryMap.get('subTotalProtectionFee');
        self.subTotalShippingFee = productSummaryMap.get('subTotalShippingFee');
        self.discountApplied = productSummaryMap.get('discountApplied');
        self.totalPrice = productSummaryMap.get('totalPrice');
        self.subTotalRentalCredit= productSummaryMap.get('subTotalRentalCredit');
        self.totalMiscFee= self.subTotalProtectionFee+self.subTotalShippingFee;
      }

      const sleep = (milliseconds) => {
        return new Promise(resolve => setTimeout(resolve, milliseconds))
      }

      /**************************************************
      THIS FUNCTION HAS BEEN DISABLED FOR NOW AS WE ALLOW MULTIPLE SIZE
      IN THE SAME PRODUCT. NEED TO ENHANCE TO HAVE SIZE AND DATE SELECTED
      IN THE SUMMARY SCREEN.
      **************************************************/
      //FEATURE CURRENTLY DISABLED AS CURRENT UX DESIGN IS NOT OPTIMIZE FOR ADDING PRODUCT WITH MULTIPLE SIZE TO CART DIRECTLY.
      // $scope.addToCart = function(product) {
      //
      //   var rental = { product: product, selectedDate: null };
      //   if (!utilities.isItemInArray(rental.product,$rootScope.cc.cart)){
      //
      //     utilities.replaceItemInArray(rental,$rootScope.cc.cart);
      //
      //     //STORE PRODUCT ID IN LOCAL SERVICE
      //     Session.updateCart(product.id);
      //     CartService.addCart(product.id);
      //   }
      //
      //   // CC-60 FUTURE DATE RENTAL  */
      //   CalendarService.openCalendar(function() {
      //
      //     //CHECKOUT DIRECTLY
      //     if (rental.product != null && rental.selectedDate != null){
      //         utilities.replaceItemInArray(rental,$rootScope.cc.cart);
      //         //STORE PRODUCT ID IN LOCAL SERVICE
      //         Session.updateCart(product.id,rental.selectedDate.START_DATE,rental.selectedDate.RETURN_DATE);
      //         CartService.addCart(product.id,rental.selectedDate.START_DATE,rental.selectedDate.RETURN_DATE);
      //         //inject _promoPrice into cart item
      //         priceUtilities.applyPromo($scope.temp_promoCode,$rootScope.cc.cart)
      //         self.calculatePricing();
      //         usSpinnerService.spin('spinner');
      //         sleep(1500).then(() => { // temp dirty hack
      //           usSpinnerService.stop('spinner');
      //           $state.go('checkout');
      //         });
      //     }
      //
      //   }, function() {
      //
      //     //SAVED TO CART
      //     if (rental.product != null && rental.selectedDate != null){
      //         utilities.replaceItemInArray(rental,$rootScope.cc.cart);
      //         //STORE PRODUCT ID IN LOCAL SERVICE
      //         Session.updateCart(product.id,rental.selectedDate.START_DATE,rental.selectedDate.RETURN_DATE);
      //         CartService.addCart(product.id,rental.selectedDate.START_DATE,rental.selectedDate.RETURN_DATE);
      //     }
      //
      //   }, function(date) {
      //       rental.selectedDate={'START_DATE':null, 'RETURN_DATE':null};
      //       rental.selectedDate.START_DATE = moment(date).format('x');
      //       rental.selectedDate.RETURN_DATE = moment(Number(rental.selectedDate.START_DATE)).add(CONFIG.DEFAULT_RENTAL_DURATION,'d').format('x');
      //   }, utilities.getAvailableDates(rental.product.status));
      // }

      this.getColorDetails = function(color){
        var colorList = utilities.getColorDetails(color);
        if(colorList.length > 0){
          return colorList[0];
        }
        return null;
      }

      this.getDisplayPriceNoLabel = function(product) {
        return priceUtilities.getListingTagPrice(product);;
      }

      this.getDisplayPrice = function(product) {
        return priceUtilities.getDisplayPriceV2(product);
      }

      this.getDisplayPurchasePrice = function(product) {
        return priceUtilities.getDisplayPurchasePriceV2(product);
      }

      this.getDisplayRentalPrice = function(product) {
        return priceUtilities.getListingRentalPrice(product, 1);
      }

      this.getDisplayPriceNoCurrency = function(product) {
        return priceUtilities.getDisplayPriceV3(product);
      }

      this.getDisplayPriceNoLabelNoCurrency = function(product) {
        return priceUtilities.getListingTagPriceNoCurrency(product);
      }

      this.getDisplayPurchasePriceNoCurrency  = function(product) {
        return priceUtilities.getDisplayPurchasePriceV3(product);
      }
      
      this.toggleWishlist = function(product) {
        self.displayedProductCollection = false;
        self.displayedProductWishlist = product.id;
        self.isWishlistDisabled = false;
        var allSizes = product.sizes;
        for (var index in allSizes) {
          var sizeWishlist = allSizes[index].wishlist;
          if(sizeWishlist){
            self.isWishlistDisabled = false;
            break;
          }
        }
      }


      this.saveWishlist = function(product){
        if ($rootScope.isLogon){
          DialogAlertService.saveWishlist(product);
        } else {
          this.saveWishlistSession(product);
          DialogAlertService.openLogon('','',true,false,true,true);
        }
      }

      this.saveWishlistSession = function(product){
          
          var productID = product.id;
          var country = $rootScope.geoLocation.country;
  
          self.allWishlists = {
            'productId' : product.id,
            'wishlists': []
          };
          var allSizes = product.sizes;
          allSizes.forEach(function(size){
            var sizeWishlist = size.wishlist;
            if(sizeWishlist){
              var wishlist_info = {
                "userID": null,
                "email": null,
                "productId": productID,
                "size": size.key,
                "country": country,
                "itemCondition": null,
                "subscribed": true
              };
              self.allWishlists.wishlists.push(wishlist_info);
            } 
          });
          Session.saveWishlistSession(self.allWishlists);
      }

      //////////////////////////////////////////
      //  ADD / REMOVE COLLECTION
      //////////////////////////////////////////
      this.toggleCollection = function(product){
        self.displayedProductWishlist = false;
        if(self.displayedProductCollection == product.id && self.displayedProductCollection){
          self.displayedProductCollection = false;
        } else {
          self.displayedProductCollection = product.id;
        }
      }

      this.saveCollection = function(product, order, collection) {
        usSpinnerService.spin('spinner');
        var productCollection = {};
        if(collection.key == 'two-for-one'){
          productCollection.selected = !collection.selected;
        } else {
          productCollection.selected = order.feature;
        }
        productCollection.code = collection.key;
        productCollection.name = collection.key;
        productCollection.order = order.key;

        product.allCollections.forEach(function(c){
          if(c.key == collection.key){
            c.selected = productCollection.selected;
          }
        });

        var update_listing = {
          id: product.id,
          collection: productCollection
        };
        
        ListingService.updateCollection(update_listing).$promise.then(function(resp) {
          usSpinnerService.stop('spinner');
          product._itemCurated = resp.recommended;
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":toggleCollection - Listing updated successfully (" + update_listing.id + ")") : '';
          //CC-1444 : do not auto reload $state.reload();
        }, function(err) {
          usSpinnerService.stop('spinner');
          self.lk_listing = false;
          DialogAlertService.promptDialog('Add to collection failed. Please try again later.', '', '', '', '', '', '', true, '', 'RED');
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":toggleCollection - Listing edit error.") : '';
        })
      }


      $scope.dropSuccess = function(e, item, collection) {
        var obj = {
          "sourceProduct": item,
          "targetProduct": e,
          "products": collection
        }

        ListingService.reorder(obj).$promise.then(function(resp) {
          usSpinnerService.stop('spinner');
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":reorder - Listing reordered successfully ") : '';
        }, function(err) {
          usSpinnerService.stop('spinner');
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":reorder - Listing reorder error.") : '';
        })
    };
    }]
  });

'use strict';

angular.module('coutureApp')
.component("checkoutConfirmation", {
  templateUrl: "scripts/components/checkout-confirmation/checkout-confirmation.html",
  controllerAs: "coConfirmCtrl",
  bindings: {
    resolve:"<",
    close: '&'
  },
  controller: ["$rootScope", "$scope", "utilities", "$filter", "priceUtilities", "RefDataService", "$state", "CONFIG", "$translate", "RentalService", "usSpinnerService", function($rootScope,$scope, utilities,$filter,priceUtilities, RefDataService,$state, CONFIG, $translate, RentalService, usSpinnerService) {

    var self = this;

    this.$onInit = function() {
      self.checkoutRefID = self.resolve.checkoutRefID;
      self.orderIDs = self.resolve.orderIDs;
      self.checkoutProductsInfo = self.resolve.checkoutProductsInfo.products;

      
      var groupByBundle = self.checkoutProductsInfo.reduce(function(obj,item){
        var bundle = item._checkoutConfirmationDetails._bundleID;
        obj[bundle] = obj[bundle] || [];
        obj[bundle].push(item);
        return obj;
      }, {});
    
      var cartByBundle = Object.keys(groupByBundle).map(function(key){
        return {
          bundle: key, 
          items: groupByBundle[key],
          bundleCnt: groupByBundle[key].length
        };
      });
      var nonBundleProducts = [];
      var bundleProducts = [];

      self.checkoutProductsInfo.forEach(function(c) {
        var bundleID = c._checkoutConfirmationDetails._bundleID;
        if(bundleID != null){
          var cnt = cartByBundle.filter(b => b.bundle == bundleID && b.bundleCnt > 1);
          if(cnt.length > 0){
            bundleProducts.push(c);
          } else {
            nonBundleProducts.push(c);
          }
        } else {
          nonBundleProducts.push(c);
        }
      });

      self.checkoutProductsInfoBundle = bundleProducts;
      self.hasBundles = bundleProducts.length > 0;
      self.checkoutProductsInfoNonBundle = nonBundleProducts;

      self.checkoutProductsPriceSummary = self.resolve.checkoutProductsInfo.order;
      self.topUp=self.resolve.topUp;
      self.purchaseOrders = self.resolve.checkoutPurchaseProductsInfo.orders;
      self.purchaseOrderSubTotal = self.resolve.checkoutPurchaseProductsInfo.subTotal;
      self.purchaseOrderSubTotalWithShipping = self.resolve.checkoutPurchaseProductsInfo.subTotal + self.resolve.checkoutPurchaseProductsInfo.buyShippingFee;
      self.isShowRentalOrders = self.checkoutProductsInfo ? self.checkoutProductsInfo.length > 0 : false;
      self.isShowPurchaseOrders = self.purchaseOrders ? self.purchaseOrders.length > 0 : false;
      //TOTAL CREDIT PRICING DETAILS
      self.proudct_currency = priceUtilities.getCurrency();
      self.rentalCredit = self.checkoutProductsPriceSummary.rentalCredit;
      self.rentalCreditExclTopUp = self.checkoutProductsPriceSummary._rentalCreditExclTopUp;
      self.rentalCreditExclTopUpAmt = self.checkoutProductsPriceSummary._rentalCreditExclTopUpAmt;
      self.rentalProtectionFee = self.checkoutProductsPriceSummary.protectionFee;
      self.shippingFee = self.checkoutProductsPriceSummary.shippingFee + self.resolve.checkoutPurchaseProductsInfo.buyShippingFee;
      self.totalDue = self.checkoutProductsPriceSummary._totalDue;

      self.isFreeShipping = self.shippingFee == 0;
      self.isFreeProtection = self.rentalProtectionFee == 0;
      self.isShowStylePassSubscription = self.topUp.needSub;
      self.isShowStylePassDiscount = self.topUp.needExtraCredit && self.topUp.creditPricingDiscountRate > 0;
      self.stylePassDiscount = self.topUp.extraCredit * self.resolve.checkoutProductsInfo.usualPricePerCredit - self.topUp.extraCreditPrice
      self.orderSubtotal = (self.checkoutProductsPriceSummary.rentalCredit * self.resolve.checkoutProductsInfo.usualPricePerCredit) + self.checkoutProductsPriceSummary.additionalRentalPrice;
      self.isShowRentalCredits = self.checkoutProductsPriceSummary._isShowRentalCredits;
      self.promoDiscount = self.checkoutProductsPriceSummary._promoDiscount
      self.isShowPromoDiscount = self.checkoutProductsPriceSummary._promoDiscount > 0;
      self.usualPricePerCredit = self.resolve.checkoutProductsInfo.usualPricePerCredit;
      self.applyCredits = self.checkoutProductsPriceSummary._applyCredits;
      
      var checkoutDate = moment(new Date()).startOf('day').format('ddd DD MMM YY');
      $scope.INVOICE_INFO = $translate.instant('GENERAL.LABEL.INVOICE_INFO', {checkoutDate: checkoutDate, checkoutReferenceNumber: self.checkoutRefID});
      

      var gtCheckoutEvent={
        'event':'ecomm_event',
        'transactionId': self.checkoutRefID, // Transaction ID - this is normally generated by your system.
        'transactionAffiliation': 'N/A',
        'transactionTotal': self.checkoutProductsPriceSummary.rentalCredit.toString(), // Grand Total - credits
        'transactionTax': self.checkoutProductsPriceSummary.rentalMiscFee.toString() , // Rental protection
        'transactionShipping': self.checkoutProductsPriceSummary.shippingFee.toString(), // Shipping cost
        'transactionProducts': []
      };
      for (var index in self.checkoutProductsInfo) {
        var product = {'sku':self.checkoutProductsInfo[index].productSummary.productId.toString(),
            'name':self.checkoutProductsInfo[index]._details.brand,
            'category':self.checkoutProductsInfo[index]._details.category.name,
            'price':self.checkoutProductsInfo[index]._details.credit.toString(),
            'quantity':'1'};
        gtCheckoutEvent.transactionProducts.push(product);
      }
      var dataLayer = window.dataLayer = window.dataLayer || [];
      dataLayer.push(gtCheckoutEvent);
    }

    this.getBrandName = function(product){
      return utilities.getCustomBrandName(product);
    }

    /**************************
    //GET PRODUCT DISCOUNT VALUE
    **************************/
    this.getDiscountAmount = function(product){
      return product.rentalOrderBreakdown.originalWeeklyRentalFee - product.rentalOrderBreakdown.weeklyRentalFee;
    }

    //////////////////////////////////////////
    //SORT THE ITEM IN THE CART BASED ON START_DATE
    //////////////////////////////////////////
    $scope.min = function(arr) {
      return $filter('min')($filter('map')(arr, '_selectedDate.START_DATE'));
    }

    this.ok = function () {
      self.close({$value: "CLOSE"});
    };

    this.displayButtonLabel = function(){
      return $rootScope.cc.cart.length > 0 ? 'Return to checkout' : 'Return to homepage';
    }
    
    this.getFormattedPrice = function(price){
      return priceUtilities.getFormattedAmountByRate(price);
    }

    $scope.onprint = function () { 
      window.print();
    } 

    this.getRentalDays = function(startDate, endDate){
      return utilities.getRentalDays(startDate, endDate);
    }

    this.getRentalWeeks = function(startDate, endDate){
      return utilities.getRentalWeeks(startDate, endDate);
    }

    this.getRentalAdditionalDays = function(startDate, endDate){
      var rentalDays = utilities.getRentalDays(startDate, endDate);
      return rentalDays % CONFIG.DEFAULT_WEEKLY_RENTAL;
    }

    this.setOfferPreference = function(bundleID, deliverBoth){
      var sameBundle = self.checkoutProductsInfo.filter(p=> p.bundleID == bundleID && p.bundleID !== null);
      if(sameBundle.length > 0){
        sameBundle.forEach(function (item) {
          item._checkoutConfirmationDetails._deliverBoth = deliverBoth;
        });
      }

      var request = {
        "bundleID": bundleID,
        "checkoutReferenceNumber": self.checkoutRefID,
        "deliverBoth": deliverBoth
      }
      //usSpinnerService.spin('spinner');
      RentalService.updateOfferPreference(request).$promise.then(
        function(resp) {
          //usSpinnerService.stop('spinner');
        },
      function(err) {
        //usSpinnerService.stop('spinner');
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":CheckoutConfirmationCtrl:updateOfferPreference - Error: " + err):"";
        }
      );
    }


  }]
})

'use strict';

angular.module('coutureApp')
.component("checkoutPreference", {
  templateUrl: "scripts/components/checkout-confirmation/checkout-preference.html",
  controllerAs: "coConfirmPreferenceCtrl",
  bindings: {
    resolve:"<",
    close: '&'
  },
  controller: ["$rootScope", "$scope", "utilities", "$filter", "priceUtilities", "RefDataService", "$state", "CONFIG", "$translate", function($rootScope,$scope, utilities,$filter,priceUtilities, RefDataService,$state, CONFIG, $translate) {

    var self = this;

    this.$onInit = function() {
      self.usualPricePerCredit = self.resolve.usualPricePerCredit;
      self.rentalFeePerDay = self.resolve.rentalFeePerDay;
    }

    this.getBrandName = function(product){
      return utilities.getCustomBrandName(product);
    }

    /**************************
    //GET PRODUCT DISCOUNT VALUE
    **************************/
    this.getDiscountAmount = function(product){
      return product.rentalOrderBreakdown.originalWeeklyRentalFee - product.rentalOrderBreakdown.weeklyRentalFee;
    }

    //////////////////////////////////////////
    //SORT THE ITEM IN THE CART BASED ON START_DATE
    //////////////////////////////////////////
    $scope.min = function(arr) {
      return $filter('min')($filter('map')(arr, '_selectedDate.START_DATE'));
    }

    this.checkout = function () {
      $rootScope.$emit("CallCheckoutProcess", {});
    };

    this.close = function () {
      self.close({$value: "CLOSE"});
    };

    $rootScope.$on("CallCloseCheckoutPreference", function(){
      self.close({$value: "CLOSE"});
    });

    this.displayButtonLabel = function(){
      return $rootScope.cc.cart.length > 0 ? 'Return to checkout' : 'Return to homepage';
    }
    
    this.getFormattedPrice = function(price){
      return priceUtilities.getFormattedAmountByRate(price);
    }

    this.getRentalDays = function(startDate, endDate){
      return utilities.getRentalDays(startDate, endDate);
    }

    this.getRentalWeeks = function(startDate, endDate){
      return utilities.getRentalWeeks(startDate, endDate);
    }

    this.getRentalAdditionalDays = function(startDate, endDate){
      var rentalDays = utilities.getRentalDays(startDate, endDate);
      return rentalDays % CONFIG.DEFAULT_WEEKLY_RENTAL;
    }
    this.getDisplayBrand = function(product){
      return utilities.getCustomBrandName(product);
    }
    this.setOfferPreference = function(bundleID){
      var sameBundle = $rootScope.cc.cart.filter(p=> p.bundleID == bundleID && p.bundleID !== null);
      if(sameBundle.length > 0){
        sameBundle.forEach(function (item) {
          item.deliverBoth = !item.deliverBoth
        });
      }
    }

  }]
})

'use strict';

angular.module('coutureApp')
.component("creditPackage", {
  templateUrl: "scripts/components/credit-package/credit-package.html",
  controllerAs: "creditPackageCtrl",
  bindings: {
    resolve:"<",
    close: '&'
  },
  controller: ["$rootScope", "$scope", "$log", "$filter", "priceUtilities", "$q", "CONFIG", "RentalService", "AuthService", "utilities", "$state", "DialogAlertService", "UserService", "$window", "envService", "$http", "Session", "localStorageService", function($rootScope,$scope,$log,$filter,priceUtilities, $q, CONFIG, RentalService, AuthService, utilities, $state, DialogAlertService, UserService, $window, envService, $http, Session, localStorageService) {

    var self = this;
    self.selected_credit = {};
    self.selected_credit.id = null;
    self.selected_credit._price = null;
    self.selected_credit._credit = null;
    self.billingAddress = {};
    self.stReq = {};
    self.account={"email": "","password": "", "password2": ""};
    self.areaName = CONFIG.AREAS;

    this.$onInit = function() {
      $rootScope.tempToken = null;
      self.isHideAccountInfo= $rootScope.isLogon;
      $scope.isShowCreditSection= true;
      $scope.isShowPaymentSection = true;
      $scope.isShowPaymentInactiveSection = false;
      $scope.isShowPaymentActiveSection = false;
      $scope.isShowBillingSection= false;
      $scope.isShowCreateAccount = !$rootScope.isLogon;
      $scope.isShowCreatePassword = false;

      $scope.isBillingSubmitted = false;
      $scope.isPaymentSubmitted = false;
      $scope.isCreateAccountFlow = false;
      $scope.isCompleted = false;

      self.error_password = null;
      self.error_billing = null;

      var country = $rootScope.geoLocation.country;
      var originalCredit = country == 'SG' ? CONFIG.ORIGINAL_CREDIT_PRICE_SG : CONFIG.ORIGINAL_CREDIT_PRICE;
      self.creditPackage = [];
      RentalService.getCreditPackage(country).$promise.then(function(resp){
        resp.forEach(item => {
          item._price = item.country + "" + priceUtilities.currencyFormat(item.price);
          var discount = (item.numCredit * originalCredit) - item.price;
          item._discountPrice = discount;
          item._discountDisplay = "Save " + priceUtilities.currencyFormat(discount);
        });
        self.selected_credit.id = resp[0].id;
        self.selected_credit._price = resp[0]._price;
        self.selected_credit._credit = resp[0].numCredit;
        self.creditPackage = resp;
      });

      this.initializeCheckoutPage();
    }

    this.closeBuyCredits = function () {
      self.close({$value: "CLOSE"});
      /*if(utilities.isShowMainRegion()){
        $state.go('main');
      } else {
        $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
      }*/
    };

    this.validateBillingAddress = function(){

      $scope.isBillingSubmitted = true;
      self.error_billing = null;
      self.stReq.address1 = self.billingAddress.address1;
      self.stReq.address2 = self.billingAddress.address2;
      self.stReq.city = self.billingAddress.city;
      self.stReq.country = self.billingAddress.country;
      self.stReq.district = self.billingAddress.district;
      if(!self.billingAddress){
        self.error_billing = $filter('translate')("GENERAL.ERROR.MISSING_BILLING_INFO");
        $scope.isBillingSubmitted = false;
      } else {
        if(!self.billingAddress.address1 || !self.billingAddress.country){
          self.error_billing = $filter('translate')("GENERAL.ERROR.MISSING_BILLING_INFO");
          $scope.isBillingSubmitted = false;
        }
      }
    }

    this.initializeCheckoutPage = function() {
      if($rootScope.geoLocation.country == 'SG') {
        $window.Stripe.setPublishableKey(envService.read('STRIP_KEY_SG'));
      }

      // Do a pre-rental check.  Make sure user has credit card and billing address.
      if (AuthService.isAuthenticated()){
        RentalService.preCheck().$promise.then(
          function(resp) {
            self.isHideAccountInfo=true;
            self.last4 = resp.last4;
            if(resp.billingAddress){
              self.billingAddress = angular.copy(resp.billingAddress);
            } else {
              self.billingAddress = angular.copy(resp.shippingAddress); 
            }
            if(self.billingAddress){
              self.disable_Billing_CityDDL = self.billingAddress.country != CONFIG.HONG_KONG ? true:false;
            }
            if (resp.hasBilling) {
              self.hasBilling = true;
              self.isHideCreditCardDetails = true;
              $scope.isShowPaymentInactiveSection = true;
              $scope.isShowPaymentActiveSection = false;
            } else {
              self.hasBilling = false;
              self.isHideCreditCardDetails = false;
              $scope.isShowPaymentInactiveSection = false;
              $scope.isShowPaymentActiveSection = false;
            }
          }, function(err) {
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":creditPackageCtrl:getCreditCardInfo - Error:" + err):'';
          });
      } 
    }


    this.continueFromCreditsToPaymentSection = function() {
      self.isHideCreditCardDetails = false;
      $scope.isShowCreditSection= false;
      $scope.isShowBillingSection= false;
      $scope.isShowPaymentActiveSection = true;
      $scope.isShowPaymentInactiveSection = false;
      $scope.isShowPaySection = false;
      self.error_txn = null;
    }


    this.backFromPaymentToCredits = function() {
      $scope.isShowCreditSection= true;
      $scope.isShowBillingSection= false;
      $scope.isShowPaymentActiveSection = false;
      $scope.isShowPaymentInactiveSection = false;
      $scope.isShowCreateAccount = !$rootScope.isLogon;
      $scope.isShowCreatePassword = false;
      self.error_txn = null;
      this.initializeCheckoutPage();
    }

    this.continueFromPaymentToBilling = function() {
      this.validatePaymentInfo();
      if(self.error_paymentInfo == null){
        $scope.isShowCreditSection= false;
        $scope.isShowBillingSection= true;
        $scope.isShowPaymentActiveSection = false;
        $scope.isShowPaymentInactiveSection = false;
      }
    }

    this.continueToCreateAccount = function() {
      if(self.account.email){
        $scope.isShowCreateAccount = false;
        $scope.isShowCreditSection = false;
        $scope.isCreateAccountFlow = true;
        $scope.isShowCreatePassword = true;

        self.uiConfig = {
          callbacks: {
              signInSuccess: function(currentUser, credential, redirectUrl) {
  
                try {
                  var country = utilities.isShowMainRegion() ? "HK" : $rootScope.geoLocation.country;
                  var userObj = JSON.parse(JSON.stringify(currentUser));
                  self.disableLogonForm = true;
  
                  $http.get(CONFIG.IPINFO_URL).then(function (response){
                  var userLocation = response.data.country;
                  // //LOGON FOR EXISTING USER AND REGISTER NEW USER.
                  AuthService.socialLogin({"firebaseToken":userObj.stsTokenManager.accessToken, "country": country, "userLocation": userLocation}).$promise.then(
                    function(resp){
                      $scope.$emit('header:setUser', resp.User);
  
                      // Remember username
                      if(self.rememberMe) {
                        localStorageService.set('username', self.req_logon.username);
                      }
  
                      self.loggedIn = true;
                      $scope.isLogon = true;
                      utilities.loadCartFromServer(Session.getCart());
                      $scope.isCreateAccountFlow = false;
                      $scope.isShowCreatePassword = false;
                      if(resp.newSignUp){
                        $scope.isShowCreditSection= true;
                        $scope.isShowPaymentInactiveSection = false;
                        $scope.isShowPaymentActiveSection = false;
                        $scope.isShowBillingSection= false;
                      } else {
                        $scope.isShowCreditSection= true;
                        $scope.isShowPaymentInactiveSection = false;
                        $scope.isShowPaymentActiveSection = false;
                        $scope.isShowBillingSection= false;
                        self.initializeCheckoutPage();
                      }
  
                    },function(err){
                      self.lk_submit = false;
                      delete($scope.isLogon);
                      var err = ErrorHandler.resolveErrorToString(err);
                      self.errors = err;
                      $rootScope.enableLog ? $log.error($rootScope.UUID + ":AuthCtrl:socialLogin - Logon error: " + err):'';
                      ui.start('#firebaseui-auth-container', self.uiConfig);
                  });
                  });
                } catch (e) {
                  self.lk_submit = false;
                  delete($scope.isLogon);
                  var err = ErrorHandler.resolveErrorToString(e);
                  self.errors = err;
                  $rootScope.enableLog ? $log.error($rootScope.UUID + ":AuthCtrl:signInSuccess - Logon error: Not able to parse accessToken."):'';
                  $scope.$apply();  
                  ui.start('#firebaseui-auth-container', self.uiConfig);
                }
                return false;
              },
              uiShown: function() {
                // The widget is rendered. Hide the loader.
                self.lk_reg = false;
                self.lk_submit = false;
                self.disableLogonForm = false;
                document.getElementById('loader').style.display = 'none';
              }
            },
          signInFlow: 'popup',
          signInOptions: [
            // Leave the lines as is for the providers you want to offer your users.
            firebase.auth.GoogleAuthProvider.PROVIDER_ID,
            firebase.auth.FacebookAuthProvider.PROVIDER_ID
          ]
  
        };

      let ui = $rootScope.firebaseuiAuthObj;
      if (!ui) {
        ui = new firebaseui.auth.AuthUI(firebase.auth());
        $rootScope.firebaseuiAuthObj = ui;
      }
      ui.start('#firebaseui-auth-container', self.uiConfig);

      }
    }
    this.backToCreditsFromCreateAccount = function() {
      $scope.isShowCreateAccount = false;
    }
    this.backFromBillingToPayment= function() {
      $scope.isShowCreditSection = false;
      $scope.isShowBillingSection= false;
      $scope.isShowPaySection = false;
      self.error_billing = null;
      $scope.isShowPaymentActiveSection = true;
      $scope.isShowPaymentInactiveSection = false;
      self.isHideCreditCardDetails = false;
    }
    

    this.continueFromBillingToPay = function() {
      $scope.isShowCreditSection= false;
      $scope.isShowPaymentSection = false;
      $scope.isShowPaymentActiveSection = false;
      $scope.isShowPaymentInactiveSection = false;
      self.validateBillingAddress();
      self.error_txn = null;
      if(self.error_billing == null){
        if($scope.isCreateAccountFlow) {
          self.createTempAccount().then(function(resp){
            self.validateCard().then(function(resp){
              $rootScope.enableLog ? $log.info($rootScope.UUID + ":creditPackageCtrl:validateCard - Saved card"):"";
              $scope.isShowBillingSection= false;
              $scope.isBillingSubmitted = false;
              $scope.isShowPaySection= true;
            },function(err){ // card related problem 
              $rootScope.enableLog ? $log.error($rootScope.UUID + ":creditPackageCtrl:continueFromBillingToPay - validateCard - Err No card saved" + err):"";
              self.error_billing = $filter('translate')("GENERAL.ERROR.UNABLE_TO_PROCESS_PAYMENT");
                  if (err.data){
                    switch (err.data.reasons[0].code) {
                      case "FAILED_TO_APPLY_PROMO":
                        self.error_billing = $filter('translate')('GENERAL.ERROR.FAILED_TO_APPLY_PROMO');
                        break;
                      case "BILLING_CARD_DECLINED":
                        self.error_billing = $filter('translate')('GENERAL.ERROR.CARD_DECLINED');
                        break;
                      case "FAILED_TO_CREATE_CUSTOMER_OBJECT":
                        self.error_billing = $filter('translate')('GENERAL.ERROR.FAILED_TO_CREATE_CUSTOMER_OBJECT');
                        break;
                      case "CARD_DECLINED":
                        self.error_billing = $filter('translate')('GENERAL.ERROR.CARD_DECLINED_CREDIT_PKG');
                        break;
                      case "CARD_INCORRECT_CVC":
                        self.error_billing = $filter('translate')('GENERAL.ERROR.CARD_INCORRECT_CVC');
                        break;
                      case "CARD_INCORRECT_NUMBER":
                        self.error_billing = $filter('translate')('GENERAL.ERROR.CARD_INCORRECT_NUMBER');
                        break;
                      case "CARD_EXPIRED":
                        self.error_billing = $filter('translate')('GENERAL.ERROR.CARD_EXPIRED');
                        break;
                      default:
                        self.error_billing = "System Error - Please try again later. (" + err.data.reasons[0].code+")";
                        break;
                    }
                  }
            });
          });
        } else {
          self.validateCard().then(function(resp){
            $rootScope.enableLog ? $log.info($rootScope.UUID + ":creditPackageCtrl:validateCard - Saved card"):"";
            $scope.isShowBillingSection= false;
            $scope.isBillingSubmitted = false;
            $scope.isShowPaySection= true;
          },function(err){ // card related problem 
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":creditPackageCtrl:continueFromBillingToPay - validateCard - Err No card saved" + err):"";
            self.error_billing = $filter('translate')("GENERAL.ERROR.UNABLE_TO_PROCESS_PAYMENT");
                if (err.data){
                  switch (err.data.reasons[0].code) {
                    case "FAILED_TO_APPLY_PROMO":
                      self.error_billing = $filter('translate')('GENERAL.ERROR.FAILED_TO_APPLY_PROMO');
                      break;
                    case "BILLING_CARD_DECLINED":
                      self.error_billing = $filter('translate')('GENERAL.ERROR.CARD_DECLINED');
                      break;
                    case "FAILED_TO_CREATE_CUSTOMER_OBJECT":
                      self.error_billing = $filter('translate')('GENERAL.ERROR.FAILED_TO_CREATE_CUSTOMER_OBJECT');
                      break;
                    case "CARD_DECLINED":
                      self.error_billing = $filter('translate')('GENERAL.ERROR.CARD_DECLINED_CREDIT_PKG');
                      break;
                    case "CARD_INCORRECT_CVC":
                      self.error_billing = $filter('translate')('GENERAL.ERROR.CARD_INCORRECT_CVC');
                      break;
                    case "CARD_INCORRECT_NUMBER":
                      self.error_billing = $filter('translate')('GENERAL.ERROR.CARD_INCORRECT_NUMBER');
                      break;
                    case "CARD_EXPIRED":
                      self.error_billing = $filter('translate')('GENERAL.ERROR.CARD_EXPIRED');
                      break;
                    default:
                      self.error_billing = "System Error - Please try again later. (" + err.data.reasons[0].code+")";
                      break;
                  }
                }
          });
        }
      } else {
        $scope.isBillingSubmitted = false;
      }
    }

    this.backFromPayToBilling = function() {
      $scope.isShowBillingSection= true;
      $scope.isBillingSubmitted = false;
      $scope.isShowCreditSection= false;
      $scope.isShowPaymentActiveSection = false;
      $scope.isShowPaymentInactiveSection = false;
      $scope.isShowPaySection= false;
    }

    this.buyPackage = function() {
      $scope.isPaymentSubmitted = true;
      var country = $rootScope.geoLocation.country;
      RentalService.buyCreditPackage(self.selected_credit.id, country).$promise.then(function(resp){
        if($scope.isCreateAccountFlow){
          UserService.confirmTempAccount();
          $rootScope.tempToken=null;
        }
        self.captureBuyPackage(resp.subscriptionRef);
        $rootScope.enableLog ? $log.info($rootScope.UUID + ":creditPackageCtrl:buyPackage - request submitted successfully."):"";
        if($scope.isCreateAccountFlow){
          self.close({$value: "CLOSE"});
          if(utilities.isShowMainRegion()){
            $state.go('account-verified');
          } else {
            $state.go('account-verified-multi-region', {country: $rootScope.geoLocation.country});
          }
        } else {
          UserService.retrieveCreditBalance(country).$promise.then(function(resp){
            $scope.isCompleted = true;
          });
        }
      },function(err){
        $scope.isPaymentSubmitted = false;
        self.lk_checkout = false;
        var errorLog;
        try{
          errorLog = err.error ? err.error.message : err.data.reasons[0].message;
          if (err.data){
            switch (err.data.reasons[0].code) {
              case "FAILED_TO_APPLY_PROMO":
                self.error_txn = $filter('translate')('GENERAL.ERROR.FAILED_TO_APPLY_PROMO');
                break;
              case "BILLING_CARD_DECLINED":
                self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_DECLINED');
                break;
              case "FAILED_TO_CREATE_CUSTOMER_OBJECT":
                self.error_txn = $filter('translate')('GENERAL.ERROR.FAILED_TO_CREATE_CUSTOMER_OBJECT');
                break;
              case "CARD_DECLINED":
                self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_DECLINED');
                break;
              case "CARD_INCORRECT_CVC":
                self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_INCORRECT_CVC');
                break;
              case "CARD_INCORRECT_NUMBER":
                self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_INCORRECT_NUMBER');
                break;
              case "CARD_EXPIRED":
                self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_EXPIRED');
                break;
              default:
                self.error_txn = "System Error - Please try again later. (" + err.data.reasons[0].code+")";
                break;
            }
          }else{
            self.error_txn = errorLog;
          }
        }catch(moreErr){
          self.error_txn = $filter('translate')("GENERAL.ERROR.UNABLE_TO_PROCESS_PAYMENT");
          errorLog = moreErr;
        }finally{
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":creditPackageCtrl:submitBuyRequest - Checkout failed. "+ errorLog):"";
        }
      })
    }

    self.setSelected = function(type, selectedValue) {
      switch (type) {
        case 'shippingCountry':
          self.shippingAddress.country = selectedValue.name;
          self.disable_Shipping_CityDDL = selectedValue.name != CONFIG.HONG_KONG ? true:false;
          self.shippingAddress.reqPostCode = selectedValue.reqPostCode;
          if (!self.disable_Shipping_CityDDL && typeof self.areaName != "undefined"){
            self.shippingAddress.city = self.areaName[0].name;
          }
          if ($scope.isSameShippingAddress) {
            self.billingAddress.country = selectedValue.name;
            self.disable_Billing_CityDDL = true;
          }
          break;

        case 'billingCountry':
          self.billingAddress.country = selectedValue.name;
          self.disable_Billing_CityDDL = selectedValue.name != CONFIG.HONG_KONG ? true:false;
          if (!self.disable_Billing_CityDDL){
            self.billingAddress.city = self.areaName[0].name;
          }
          self.billingAddress.reqPostCode = selectedValue.reqPostCode;
          break;

        case 'BILLING_ADDRESS':
          self.billingAddress.city = selectedValue.name;
          break;

        case 'SHIPPING_ADDRESS':
          self.shippingAddress.city = selectedValue.name;
          if ($scope.isSameShippingAddress) {
            self.billingAddress.city = selectedValue.name;
          }
          break;
      }
    };

    this.validateCard = function() {
      var deferred = $q.defer();

      //CONVERT FORM DATA TO STRIP REQUIRED FORMAT
      self.stReq.mm = self.ccExpiry.substring(0, 2);
      self.stReq.yy = self.ccExpiry.substring(2, 4);
      self.stReq.address1 = self.billingAddress.address1;
      self.stReq.address2 = self.billingAddress.address2;
      self.stReq.city = self.billingAddress.city;
      self.stReq.country = self.billingAddress.country;
      self.stReq.district = self.billingAddress.district;

      // Request a token from Stripe:
      Stripe.card.createToken({
        number: self.stReq.cardnum,
        cvc: self.stReq.cvc,
        exp_month: self.stReq.mm,
        exp_year: self.stReq.yy,
        name: self.stReq.name,
        address_line1: self.stReq.address1,
        address_line2: self.stReq.address2,
        address_city: self.stReq.city,
        address_country: self.stReq.country,
        metadata: {
          "email": self.account ? self.account.email : ($rootScope.user && $rootScope.isLogon ? $rootScope.user.email : ""),
          "phone": $rootScope.user && $rootScope.isLogon ? $rootScope.user.phone1 : ""
        }
      }, function(status, response) {

        if (response.error) { // Problem!
          self.error_ship_bill_info= response.error.message;
          self.error_billing = "Our payment gateway says " + response.error.message + " Please correct the details and try again.";
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":creditPackageCtrl:validateCard - Card creation failed!. "+ response.error.message):"";
          deferred.reject(response);
        } else { // Token was created!
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":creditPackageCtrl:validateCard - Card creation succeeded. " + response.id):"";
          self.error_ship_bill_info= null;
          // Get the token ID:
          var stripeToken = response.id;
          var addressObj = {
            country : $rootScope.geoLocation.country,
            district : self.billingAddress.district,
            postalCode : self.billingAddress.postalCode
          }

          // send stripeToken
          RentalService.saveStripeToken(stripeToken, addressObj).$promise.then(
            function(resp) {
              $rootScope.enableLog ? $log.info($rootScope.UUID + ":creditPackageCtrl:validateCard - Token saved to server. " + resp):"";
              
              self.hasBilling = true;
              self.isHideCreditCardDetails = true;

              deferred.resolve(resp.token);
            },
            function(err) {
              $scope.isBillingSubmitted = false;
              $rootScope.enableLog ? $log.error($rootScope.UUID + ":creditPackageCtrl:validateCard - Token failed to save to server. " + err):"";
              
              if(err.data && err.data.reasons && err.data.reasons[0]){
                switch (err.data.reasons[0].code) {
                  case "FAILED_TO_CREATE_CUSTOMER_OBJECT":
                    self.error_txn = $filter('translate')('GENERAL.ERROR.FAILED_TO_CREATE_CUSTOMER_OBJECT');
                    break;
                  case "CARD_DECLINED":
                    self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_DECLINED_PAYMENT_INFO');
                    break;
                  case "CARD_INCORRECT_CVC":
                    self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_INCORRECT_CVC');
                    break;
                  case "CARD_INCORRECT_NUMBER":
                    self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_INCORRECT_NUMBER');
                    break;
                  case "CARD_EXPIRED":
                    self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_EXPIRED');
                    break;
                  default:
                    self.error_txn = $filter('translate')('GENERAL.ERROR.PROFILE_ERROR');
                    break;
                }
              } else {
                self.error_txn = $filter('translate')('GENERAL.ERROR.PROFILE_ERROR');
              }
              deferred.reject(err);
            }
          );
        }
      });
      return deferred.promise;
    }

    this.validatePaymentInfo = function() {
      self.error_paymentInfo = null;
      if(!self.stReq.cardnum || !self.stReq.cvc || !self.stReq.name || !self.stReq.cvc || !self.ccExpiry){
        self.error_paymentInfo =$filter('translate')('GENERAL.ERROR.MISSING_PAYMENT_INFO');
      }
    }

    this.creditCardCheck = function(inputValue) {
      if (inputValue){
        (isNaN(inputValue) || inputValue.charAt(inputValue.length - 1) === '.') ? self.stReq.cardnum = inputValue.substring(0, inputValue.length - 1): '';
      }
    }

    /**************************
    //ONLY ALLOW NUMBERIC VALUE TO BE ENTERED
    **************************/
    this.CVCCheck = function(inputValue) {
      if (inputValue){
        (isNaN(inputValue) || inputValue.charAt(inputValue.length - 1) === '.') ? self.stReq.cvc = inputValue.substring(0, inputValue.length - 1): '';
      }
    }

    /**************************
    //CHECK FOR VALID CREDIT CARD EXPIRY DATE
    **************************/
    this.expiryDateCheck = function(inputValue) {
      //ONLY ALLOW ENTER MM/YY
      if (inputValue){
        var validValue = true;
        isNaN(inputValue) ? validValue = false : '';
        (inputValue.length === 2 && (inputValue === 0 || inputValue > 12)) ? validValue = false: '';
        !validValue ? self.ccExpiry = inputValue.substring(0, inputValue.length - 1) : '';
      }
    }

    $('.dropdown-menu').find('input').click(function (e) {
      e.stopPropagation();
    });

    this.signIn = function() {
      self.close();
      DialogAlertService.openLogon(function(){
        //ON SUCESSFUL LOGON
        $state.go('buy-credit-package');
      },function(){
        //ON CANCEL OR CLOSE THE LOGON
        $state.go('buy-credit-package');
      });
    };
    
    this.continueFromAccountToPaymentSection = function() {
      if (self.account.password.length<8 || self.account.password!==self.account.password2){
        self.error_create_account = "Passwords don’t match or have less than 8 characters.";
      } else {
        self.isHideCreditCardDetails = false;
        $scope.isShowCreditSection= false;
        $scope.isShowBillingSection= false;
        $scope.isShowPaymentActiveSection = true;
        $scope.isShowPaymentInactiveSection = false;
        $scope.isShowPaySection = false;
        $scope.isShowCreateAccount = false;
        $scope.isShowCreatePassword = false;
      }
    }

    this.createTempAccount = function() {
      var deferred = $q.defer();
      if (!self.isHideAccountInfo && $rootScope.tempToken == null) {
        // check if password is valid
        if (self.account.password.length<8 || self.account.password!==self.account.password2){
            self.error_create_account = "Passwords don’t match or have less than 8 characters.";
            deferred.reject(self.error_password);
        } else {
          // create temp account
        $http.get(CONFIG.IPINFO_URL).then(function (response){
          var registeredCountry = utilities.isShowMainRegion() ? "HK" : $rootScope.geoLocation.country;
          UserService.createTempAccount(self.account.email,self.account.password,self.stReq.name, response.data.country, registeredCountry).$promise.then(
            function(resp) {
              $rootScope.tempToken=resp.tempToken;
              $rootScope.enableLog ? $log.info($rootScope.UUID + ":creditPackageCtrl:tempAccount - Account created. " + resp):"";
              deferred.resolve(resp.token);
            },
            function(err) {
              $scope.isBillingSubmitted = false;
              $rootScope.enableLog ? $log.error($rootScope.UUID + ":creditPackageCtrl:validateCard - Account failed to be created. " + err):"";
              var errMsg= err.data.reasons[0].message;
              if(err.data && err.data.reasons && err.data.reasons[0]){
                switch (err.data.reasons[0].code) {
                  case "CREATE_TEMP_SUB_USER_FAILED":
                    self.error_billing = errMsg;
                    break;
                  default:
                    self.error_billing = $filter('translate')('GENERAL.ERROR.UNABLE_TO_CREATE_ACCOUNT');
                    break;
                }
              } else {
                self.error_billing = $filter('translate')('GENERAL.ERROR.PROFILE_ERROR');
              }

              if (errMsg.includes("String index out of range")){
                self.error_billing = "Email address supplied is not valid.";
              }

              deferred.reject(err);
            }
          );
        });
        }
      } else {
        deferred.resolve("");
      }
        return deferred.promise;
    }

    self.captureBuyPackage = function(checkoutReference){
      let currentUser = localStorageService.get('user');
      var currency = "HKD";
      if(self.subscription){
        if(self.subscription.country == "SG"){
          currency = "SGD";
        }
      }
      dataLayer.push({ ecommerce: null });  
      dataLayer.push({
          "environment" : envService.environment === "production" ? "prod" : "dev",
          "currentUserID" : currentUser ? currentUser.userid : "guest",
          "currentUserName" : currentUser ? currentUser.firstName + " " + currentUser.lastName : "guest",
          "currentUserEmail" : currentUser ? currentUser.email : "guest",
          "currency": currency,
          "creditPackageID": self.selected_credit ? self.selected_credit.id : "NA",      
          "creditPackagePrice": self.selected_credit ? self.selected_credit._price : 0,
          "creditPackageCredit": self.selected_credit ? self.selected_credit._credit : 0,
      event: "buy_credit_package",
      });

      dataLayer.push({
        event: "purchase",
        ecommerce: {
        currency: currency,
        value: self.subscription ?  self.subscription.price : 0,
        transaction_id: checkoutReference,
          items: [{
            item_name: (self.selected_credit ? self.selected_credit._credit : 0) + " credit(s)",
            item_id: self.selected_credit ? self.selected_credit.id : "NA",
            price: self.selected_credit ? self.selected_credit._price : 0,
          }]}
      });

    };
    

  }]
})

'use strict';

angular.module('coutureApp')
.component("buySubscriptionConfirmation", {
  templateUrl: "scripts/components/subscription-confirmation/subscription-confirmation.html",
  controllerAs: "subConfirmCtrl",
  bindings: {
    resolve:"<",
    close: '&'
  },
  controller: ["$rootScope", "$scope", "utilities", "$filter", "priceUtilities", "AuthService", "RefDataService", "$state", function($rootScope,$scope, utilities,$filter,priceUtilities, AuthService, RefDataService,$state) {

    var self = this;

    this.$onInit = function() {
      self.subscriptionRef= self.resolve.paymentRef;
      self.subscription= self.resolve.subscriptionProductInfo;

      //TOTAL CREDIT PRICING DETAILS
      self.proudct_currency = priceUtilities.getCurrency();
      self.price=self.subscription.totalPrice;
      //self.subscription.isBuyCredit is distorted for some reason?
      self.isBuyCredit=(self.subscription.type=="credit");
      self.unit=self.subscription.unit
      if (self.isBuyCredit){
        self.totalDue=self.subscription.finalPriceReturn.totalPriceAfterDiscount;
      } else {
        var d = self.resolve.starts;
        self.subscriptionStarts = new Date(d.substring(0,4),d.substring(4,6)-1,d.substring(6));
        self.totalDue=self.subscription.finalPriceReturn.finalMonthlyPrice[0];
      }
      self.giftCardSaving=self.price-self.totalDue;
      self.giftCardDesc=self.subscription.finalPriceReturn.promoPubDesc;

      self.isAuthenticated = AuthService.isAuthenticated()? true: false;
    }

    // this.getBrandName = function(product){
    //   return utilities.getCustomBrandName(product);
    // }

    /**************************
    //GET PRODUCT DISCOUNT VALUE
    **************************/
    this.getDiscountAmount = function(product){
      return self.giftCardSaving;
    }

    //////////////////////////////////////////
    //SORT THE ITEM IN THE CART BASED ON START_DATE
    //////////////////////////////////////////
    // $scope.min = function(arr) {
    //   return $filter('min')($filter('map')(arr, '_selectedDate.START_DATE'));
    // }

    this.ok = function () {
      self.close({$value: "CLOSE"});
    };

    this.displayButtonLabel = function(){
      // return $rootScope.cc.cart.length > 1 ? "Return to checkout" : "Return to homepage";
      var label= (AuthService.isAuthenticated())? "Check Credit Balance":"Return to homepage";
      return label;
    }

  }]
})

'use strict';
angular.module('coutureApp')
  .component('dashboardMenu', {
    templateUrl: 'scripts/components/dashboard-menu/dashboard-menu.html',
    controllerAs : 'dashMenuCtrl',
    controller: ["$scope", "$rootScope", "$log", "$state", "AuthService", "USER_ROLES", "$translatePartialLoader", "utilities", "DialogAlertService", function($scope, $rootScope, $log,$state,AuthService,USER_ROLES, $translatePartialLoader,utilities, DialogAlertService) {

      var self = this;

      this.$onInit = function(){
        $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - dashboardMenu"):'';
      }

      this.signOut = function(){
        $scope.$emit('header:logout', null);
        if(utilities.isShowMainRegion()){
          $state.go('main');
        } else {
          $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
        }
      }

      this.availableForRegion = function(){
        return utilities.isFunctionEnabled();
      }

      this.isAdmin = function(){
        return AuthService.isAuthorized(USER_ROLES.admin);
      }

      this.goToPage = function(page){
        if(utilities.isShowMainRegion()){
          $state.go(page);
        } else {
          $state.go(page + '-multi-region',{country: $rootScope.geoLocation.country});
        }
      }

      this.createShop = function(){

        if(utilities.isShowMainRegion()){
          $state.go("profile");
        } else {
          $state.go('profile-multi-region',{country: $rootScope.geoLocation.country});
        }

        DialogAlertService.createShop();
      }

      self.isMyAccountSelected = function(){
        return $state.includes('my-account') || $state.includes('my-account-multi-region');
      }
      self.isWishlistSelected = function(){
        return $state.includes('wishlists') || $state.includes('wishlists-multi-region');
      }
      self.isPaymentOptionsSelected = function(){
        return $state.includes('payment-options') || $state.includes('payment-options-multi-region');
      }
      self.isOrderHistorySelected = function(){
        return $state.includes('order-history') || $state.includes('order-history-multi-region') || $state.includes('customer-buy-orders') || $state.includes('customer-buy-orders-multi-region');
      }
      self.isCreditBalanceSelected = function(){
        return $state.includes('credit-balance') || $state.includes('credit-balance-multi-region');
      }
      self.isProfileSelected = function(){
        return $state.includes('profile') || $state.includes('profile-multi-region');
      }
      self.isGetPaidSelected = function(){
        return $state.includes('get-paid') || $state.includes('get-paid-multi-region');
      }
      self.isMyRentalsSelected = function(){
        return $state.includes('my-rentals') || $state.includes('merchant-dispatching-orders') || $state.includes('merchant-rental-orders') || $state.includes('merchant-buy-orders') || $state.includes('merchant-all-orders');
      }
      self.isAdminDashboardSelected = function(){
        return $state.includes('my-listings') || $state.includes('my-listings-multi-region');
      }
      self.isStoreApproved = function() {
        return $rootScope.isLogon ? $rootScope.user.storeApproved : false;
      }
      self.isReturnRentalSelected = function(){
        return $state.includes('order-history') || $state.includes('order-history-multi-region') || $state.includes('customer-buy-orders') || $state.includes('customer-buy-orders-multi-region');
      }
      self.hasPendingReturn = function() {
        return $rootScope.isLogon ? $rootScope.user.hasPendingReturn : false;
      }


    }]
  })

'use strict';
angular.module('coutureApp')
  .component('myAccount', {
    controllerAs : 'myAccountCtrl',
    templateUrl: 'scripts/components/my-account/my-account.html',
    controller: ["$rootScope", "$log", "$scope", "UserService", "DialogAlertService", "AuthService", "$state", "utilities", "$filter", "$translate", "$translatePartialLoader", "Session", "CONFIG", "UploadService", "$q", "usSpinnerService", "envService", "$firebaseAuth", "RefDataService", function($rootScope,$log, $scope, UserService, DialogAlertService,AuthService, $state ,
      utilities,$filter,$translate,$translatePartialLoader,Session,CONFIG,UploadService,$q,usSpinnerService,envService,$firebaseAuth,RefDataService) {

      var self = this;
      self.FACEBOOK_PROVIDER = 'facebook';
      self.GOOGLE_PROVIDER = 'google';
      if (!$rootScope.isLogon){
        $scope.photos = null;
      } else {
        $scope.photos = $rootScope.user.profileImg ? [$rootScope.user.profileImg]:null;
      }
      $scope.invalidPhotos = [];
      self.UPLOAD_PHOTO_LIMIT = CONFIG.UPLOAD_PHOTO_LIMIT;
			self.PHOTO_LIMIT_MIN = CONFIG.PHOTO_SIZE_LIMIT_MIN;
			self.PHOTO_LIMIT_MAX = CONFIG.PHOTO_SIZE_LIMIT_MAX;
			self.PHOTO_RESIZE_QTY = CONFIG.PHOTO_RESIZE_RATIO;
			self.PHOTO_RESIZE_WIDTH = CONFIG.PHOTO_RESIZE_WIDTH;
			self.PHOTO_RESIZE_HEIGHT = CONFIG.PHOTO_RESIZE_HEIGHT;
			self.PRODUCT_MIN_PRICE = CONFIG.PRICE_MIN;

      $scope.phoneCodeList = RefDataService.getCountryList();
      self.countries = RefDataService.getCountryList();
      self.availableCountries = RefDataService.getAvailableShippingCountries();
      self.areaName = CONFIG.AREAS; 

      this.$onInit = function(){
        $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - myAccount "):'';
        if (!$rootScope.isLogon){
          DialogAlertService.openLogon('',function(){
          if(utilities.isShowMainRegion()){
			      $state.go('main');
          } else {
            $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
          }
          });
        }else{

          self.shippingAddress = {};
          self.pickupAddress = {};
          self.lk_btn = false;
          self.profileLoaded = false;
          self.firstName = null;
          self.lastName = null;
          self.email = null;
          self.phone = null;
          self.oldPass = null;
          self.newPass = null;
          self.verifyPass = null;
          self.aboutMe = null;
          self.businessName = null;
          self.phoneCode = null;

          self.error_userProfile = null;
          self.error_updateProfile = null;
          self.error_updatePassword = null;
          self.error_shippingAddress = null;
          self.error_pickupAddress = null;
          self.showPassError = false;
          self.socialProfile = {facebookEmail:"",facebookLinked:false,googleEmail:"",googleLinked:false};
          getUserProfile();
          this.getReferralDetails();
          this.getUserPromos();
        }

      }

      ////////////////////////////
      //NEED TO HANDLE UNLINK OF SOCIAL ACCOUNT
      ////////////////////////////
      this.socialAccountLinkage = function(provider,isLinkedSocialAccount){
        self.lk_btn = true;

        var providerID
        switch (provider) {
          case self.FACEBOOK_PROVIDER:
            providerID = new firebase.auth.FacebookAuthProvider();
            break;
          case self.GOOGLE_PROVIDER:
            providerID = new firebase.auth.GoogleAuthProvider();
            break;
        }

        try {

          var auth = $firebaseAuth();

          if (!isLinkedSocialAccount){
            if(utilities.isShowMainRegion()){
              $state.go('reset-password',{p:provider});
            } else {
              $state.go('reset-password-multi-region', {p:provider, country: $rootScope.geoLocation.country});
            }
          }else{
            if (provider == self.FACEBOOK_PROVIDER){
              self.socialProfile.facebookLinked = false;
            }else{
              self.socialProfile.googleLinked = false;
            }

            auth.$signInWithPopup(providerID).then(function(firebaseUser) {
              var authObj = JSON.parse(JSON.stringify(firebaseUser));

              // //LOGON FOR EXISTING USER AND REGISTER NEW USER.
              AuthService.socialAdd({"firebaseToken":authObj.user.stsTokenManager.accessToken}).$promise.then(
                function(resp){
                  if (provider == self.FACEBOOK_PROVIDER){
                    self.socialProfile.facebookEmail = authObj.user.email;
                    self.socialProfile.facebookLinked = true;
                  }else{
                    self.socialProfile.googleEmail = authObj.user.email;
                    self.socialProfile.googleLinked = true;
                  }
                  self.lk_btn = false;
                  if(utilities.isShowMainRegion()){
                    $state.go('my-account',{},{reload:true});
                  } else {
                    $state.go('my-account-multi-region',{country: $rootScope.geoLocation.country},{reload:true});
                  }
                },function(err){
                  self.lk_btn = false;
                  var errMsg = err.data && err.data.reasons && err.data.reasons[0] ? $filter('translate')("GENERAL.ERROR."+ err.data.reasons[0].code) : $filter('translate')("GENERAL.ERROR.UPDATE_PERSONAL_INFO");
                  DialogAlertService.promptDialog(errMsg, '', '', '', 'GENERAL.LABEL.OK', '', '', false,'',"RED");
                  $rootScope.enableLog ? $log.error($rootScope.UUID + ":AuthCtrl:socialLogin - Logon error: " + err):'';
              });
            }).catch(function(err) {
              self.lk_btn = false;
              if (err.code && err.code != 'auth/popup-closed-by-user'){
                var errMsg = err.data && err.data.reasons && err.data.reasons[0] ? $filter('translate')("GENERAL.ERROR."+ err.data.reasons[0].code) : $filter('translate')("GENERAL.ERROR.UPDATE_PERSONAL_INFO");
                DialogAlertService.promptDialog(errMsg, '', '', '', 'GENERAL.LABEL.OK', '', '', false,'',"RED");
              }
              $rootScope.enableLog ? $log.error($rootScope.UUID + ":AuthCtrl:socialLogin - Logon error: " + err):'';
            });
          }

        } catch (e) {
          self.lk_btn = false;
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":AuthCtrl:signInSuccess - Logon error: Not able to parse accessToken."):'';
        }
      }

      ////////////////////////////
      //CHANGE PASSWORD
      ////////////////////////////
      this.changePassword = function(){
        var passStruct = {oldPassword:self.oldPass,newPassword:self.verifyPass};

        if (AuthService.isAuthenticated()){
          self.lk_btn = true;
          UserService.changePassword(passStruct).$promise.then(function(resp) {
            DialogAlertService.promptDialog('Password updated successfully. ', '', '', '', 'GENERAL.LABEL.OK', '', '', false);
            self.oldPass = null;
            self.newPass = null;
            self.verifyPass = null;
            self.lk_btn = false;
          }, function(err) {
            self.lk_btn= false;
            DialogAlertService.promptDialog('Error updating the Password. Please try again later. ', '', '', '', 'GENERAL.LABEL.OK', '', '', false,'',"RED");
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":myAccount:changePassword - Reset password error: "+err.status):'';
            self.error_updatePassword = err.status;
          });
        }else{
          $rootScope.user = null;
        }
      }


      ////////////////////////////
      //PASSWORD VALIDATION
      ////////////////////////////
      this.validatePasswordChange = function(){
        self.showPassError = utilities.validatePassword(self.newPass , self.verifyPass);
      }

      ////////////////////////////
      //GET USER PROFILE
      ////////////////////////////
      function getUserProfile(){
        UserService.retrieveUserProfile().$promise.then(function(resp) {
          utilities.updateLocalUserProfile(resp);
          self.username = resp.username;
          self.firstName = resp.firstName;
          self.lastName = resp.lastName;
          self.email = resp.email;
          self.phone = resp.phone1;
          self.profileLoaded = true;
          self.aboutMe = resp.aboutMe;
          self.profileImg = resp.profileImg;
          self.businessName = resp.businessName;
          self.phoneCode = resp.phoneCode;
          self.socialProfile.facebookEmail = resp.socialFacebookEmail;
          self.socialProfile.facebookLinked = resp.linkedFacebook;
          self.socialProfile.googleEmail = resp.socialGoogleEmail;
          self.socialProfile.googleLinked = resp.linkedGoogle;
          self.australiaStoreEnabled = resp.australiaStoreEnabled;
          self.storeApproved = resp.storeApproved;
          self.hasPendingReturn = resp.withPendingReturnItems;
          $scope.photos = self.profileImg != null ? [self.profileImg]: [];
          self.retrieveAddress();
          self.phoneCodeFlag = utilities.getPhoneCountryFlag(resp.phoneCode);
          self.merchantCountry = resp.merchantCountry;
          self.referralLinkCode = resp.referralLinkCode;
          self.referralLink = utilities.generateSignUpReferralLink(resp.referralLinkCode);
        }, function(err) {
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":myAccount:getUserProfile - Retrieve User Profile error: " + err.status):'';
          self.error_userProfile = err;
        });
      }

      ////////////////////////////
      //UPDATE USER PROFILE
      ////////////////////////////
      this.updateProfile = function (){

        var tempUserProfile = {
          id:$rootScope.user.userid,
          enabled:$rootScope.user.enabled,
          username:self.username,
          email:self.email,
          firstName:self.firstName,
          lastName:self.lastName,
          phone1:self.phone,
          aboutMe:self.aboutMe,
          profileImg: self.profileImg,
          businessName: self.businessName,
          phoneCode: self.phoneCode
        };

        self.lk_btn = true;

        var promises = [];
        var deferred = $q.defer();

        usSpinnerService.spin('spinner');

        if ($scope.photos != null && ($scope.photos.length > 0 && $scope.photos[0] != self.profileImg)){
          //ADD OR UDPATE PROFILE IMAGE
          promises.push(deferred.promise);
          UploadService.uploadProfileImg($scope.photos[0]).then(
            function(resp) {
              tempUserProfile.profileImg = resp[0].PATH;

              UserService.updateProfileImg(resp[0].PATH).$promise.then(function(resp){
                deferred.resolve();
              },function(err){
                deferred.reject($filter('translate')("GENERAL.ERROR.UPDATE_PERSONAL_INFO"));
              })
            },function(){
              deferred.reject($filter('translate')("GENERAL.ERROR.UPDATE_PERSONAL_INFO"));
            }
          );
        }else if($scope.photos == null && (self.profileImg != null)){
          //REMOVE PROFILE IMAGE
          promises.push(deferred.promise);
          UserService.deleteProfileImg().$promise.then(function(resp){
            tempUserProfile.profileImg = null;
            deferred.resolve();
          },function(err){
            deferred.reject($filter('translate')("GENERAL.ERROR.UPDATE_PERSONAL_INFO"));
          })
        }

        $q.all(promises).then(function() {
          UserService.updateUserProfile(tempUserProfile).$promise.then(function(resp) {
            self.lk_btn = false;
            tempUserProfile.profileImg = tempUserProfile.profileImg != null ? envService.read('IMG_DOMAIN') + "/" + tempUserProfile.profileImg:null;
            $scope.photos = tempUserProfile.profileImg != null ? [tempUserProfile.profileImg]: [];
            utilities.updateLocalUserProfile(tempUserProfile);
            usSpinnerService.stop('spinner');
            $scope.fmPInfo.$pristine=false;

            //UPDATE THE TOKEN AS USER INFO CHANGED
            if(resp["X-Authorization"]) {
              Session.updateToken(resp["X-Authorization"]);
            }

            DialogAlertService.promptDialog('GENERAL.DIALOG_TITLE.PERSONAL_INFO', '', '', '', 'GENERAL.LABEL.OK', '', '', false);
          }, function(err) {
            self.lk_btn = false;
            usSpinnerService.stop('spinner');
            var errMsg = err.data && err.data.reasons && err.data.reasons[0] ? $filter('translate')("GENERAL.ERROR."+ err.data.reasons[0].code) : $filter('translate')("GENERAL.ERROR.UPDATE_PERSONAL_INFO");
            DialogAlertService.promptDialog(errMsg, '', '', '', 'GENERAL.LABEL.OK', '', '', false,'',"RED");
          });
        },function(err){
          self.lk_btn = false;
          usSpinnerService.stop('spinner');
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":myAccount:updateProfile - Update user profile error"):'';
          DialogAlertService.promptDialog(err, '', '', '', 'GENERAL.LABEL.OK', '', '', false,'',"RED");
        })
      }

      this.updateAustrliaOnlineStore = function (australiaOnlineStore){
        UserService.updateSalesChannel(australiaOnlineStore).$promise.then(
          function(resp) {
            self.australiaStoreEnabled = australiaOnlineStore;
        },function(err){
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":myAccount:updateAustrliaOnlineStore - Update user profile error"):'';
        })
      }


      ////////////////////////////////////////////////////////////////
	    //  UPLOAD PHOTO
	    ////////////////////////////////////////////////////////////////
	    $scope.uploadFiles = function(files) {
	      if (files != null && files.length > 0){
					$scope.photos = files;
	      }
        return ($scope.photos != null && $scope.photos.length > 0) ? true : false;
	    };


      ///////////////////////////////////////////////
	    // SET THE USER ENTERED DATA IN TO THE REQ_LISTING PARAMETERS AND CLEAR THE ERROR MSG
	    ///////////////////////////////////////////////
	    $scope.$watch('invalidPhotos', function(invalidPhotos) {
	      if (invalidPhotos != null && invalidPhotos.length > 0) {
					self.error_photo = $filter('translate')("GENERAL.ERROR.INVALID_PRODUCT_PHOTO1") + self.PHOTO_LIMIT_MIN + $filter('translate')("GENERAL.ERROR.INVALID_PRODUCT_PHOTO2") + self.PHOTO_LIMIT_MAX;
	      }
	    });


      ///////////////////////////////////////////////
	    // REMOVE PROFILE IMAGE
	    ///////////////////////////////////////////////
      $scope.removeProfileImg = function(){
        $scope.photos = null;
        $scope.fmPInfo.$pristine = false;
      }

      this.copyToClipboard = function(){
        var websiteLink = ("www.stylecarousel.com/"+self.username).toLowerCase();
        navigator.clipboard.writeText(websiteLink).then(function () {
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":myAccount:copyToClipboard - link copied"):'';
        }, function () {
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":myAccount:copyToClipboard - copy failed"):'';
        });
      }

      $scope.setSelectedPhoneCode = function(countryCode, phoneCode, phoneCodeFlag) {
        self.phoneCode = countryCode + " " + phoneCode;
        self.phoneCodeFlag = phoneCodeFlag;
        $scope.fmPInfo.$pristine=false;
      }

      this.isUsernameValid = function() {
        return utilities.isUsernameValid(self.username);
      }

      self.setSelected = function(type,selectedValue) {
	      switch (type) {
          case 'shippingCountry':
            self.shippingAddress.country = selectedValue.name;
            self.disable_shipping_CityDDL = selectedValue.name != CONFIG.HONG_KONG ? true:false;
            break;

          case 'pickupCountry':
            self.pickupAddress.country = selectedValue.name;
            self.disable_pickup_CityDDL = selectedValue.name != CONFIG.HONG_KONG ? true:false;
            break;
          case 'SHIPPING_ADDRESS':
              self.shippingAddress.city = selectedValue.name;
            break;
          case 'PICKUP_ADDRESS':
              self.pickupAddress.city = selectedValue.name;
            break;
        }
      }

      self.updatePickupAddress = function() {
        self.pickupAddress.type = CONFIG.ADDRESS_TYPE_PICKUP;
        var isValid = this.validateAddress(self.pickupAddress);
        if(isValid){
          UserService.updateAddress(self.pickupAddress).$promise.then(
            function(resp) {
              DialogAlertService.promptDialog('Pickup Address updated successfully. ', '', '', '', 'GENERAL.LABEL.OK', '', '', false);
          }), function(err){
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":myAcct:updateAddress - Error:" + err):'';
            DialogAlertService.promptDialog('Error updating the address. Please try again later. ', '', '', '', 'GENERAL.LABEL.OK', '', '', false,'',"RED");
          };
        }
      }

      self.updateShippingAddress = function() {
        self.shippingAddress.type = CONFIG.ADDRESS_TYPE_SHIPPING;
        var isValid = this.validateAddress(self.shippingAddress);
        if(isValid){
          UserService.updateAddress(self.shippingAddress).$promise.then(
            function(resp) {
              DialogAlertService.promptDialog('Shipping Address updated successfully. ', '', '', '', 'GENERAL.LABEL.OK', '', '', false);
          }), function(err){
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":myAcct:updateAddress - Error:" + err):'';
            DialogAlertService.promptDialog('Error updating the address. Please try again later. ', '', '', '', 'GENERAL.LABEL.OK', '', '', false,'',"RED");
          };
        }
      }

      this.validateAddress = function(address){
          var valid = true;
          if (!address){
            return false;
          }

          if (!address.address1 || !address.country || !address.city){
            return false;
          }

          return valid;
      }

      this.retrieveAddress = function() {
        UserService.retrievePickupAddressV2().$promise.then(function(resp) {
          self.pickupAddress = resp.address;
          self.disable_pickup_CityDDL = self.pickupAddress.country != CONFIG.HONG_KONG ? true:false;
        });

        UserService.retrieveShippingAddressV2().$promise.then(function(resp) {
          self.shippingAddress = resp.address;
          self.disable_shipping_CityDDL = self.shippingAddress.country != CONFIG.HONG_KONG ? true:false;
        });
      }
      
      $('.dropdown-menu').find('input').click(function (e) {
        e.stopPropagation();
      });

      this.getReferralDetails = function() {
        $scope.referralRewards = null;
        RefDataService.getReferralRewards($rootScope.geoLocation.country).$promise.then(function(resp) {
          $scope.referralRewards = resp;
        });
      }
      this.getUserPromos = function() {
        $scope.userPromos = null;
        UserService.getUserPromos().$promise.then(function(resp) {
          $scope.userPromos = resp;
        });
      }

      this.copyReferralToClipboard = function(){
        var websiteLink = self.referralLink;
        navigator.clipboard.writeText(websiteLink).then(function () {
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":myAccount:copyToClipboard - link copied"):'';
        }, function () {
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":myAccount:copyToClipboard - copy failed"):'';
        });

        UserService.updateShareReferralLinkCount().$promise.then(
          function(resp) {
            $rootScope.enableLog ? $log.info($rootScope.UUID + ":myAccount:updateShareReferralLinkCount - Success"):'';
          }), function(err){
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":myAcct:updateShareReferralLinkCount - Error:" + err):'';
          };
      }

    }]
  })

'use strict';

angular.module('coutureApp')
  .component('paymentOptions', {
    controllerAs : 'paymentOptionsCtrl',
    templateUrl: 'scripts/components/payment-options/payment-options.html',
    controller: ["$scope", "$rootScope", "$log", "RentalService", "UserService", "usSpinnerService", "$state", "DialogAlertService", "CONFIG", "RefDataService", "$anchorScroll", "utilities", "$window", "envService", "$filter", function($scope, $rootScope, $log, RentalService, UserService, usSpinnerService, $state, DialogAlertService,CONFIG,RefDataService,$anchorScroll,utilities,$window,envService,$filter) {

      //DEFINE SCOPE OF this
      var self = this;
      self.isShipToHKOnly = CONFIG.SHIPPING_TO_HONG_KONG_ONLY;
      self.availableForRegion = utilities.isFunctionEnabled();

      this.$onInit = function(){
        $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - paymentOptions"):'';

        if ($rootScope.isLogon){
          self.last4 = null;
          self.billingAddress = {};
          self.firstName = null;
          self.lastName = null;
          self.stReq = {};
          self.shippingAddress = {};
          self.pickupAddress = {};
          self.addressType = 1;
          self.isHideCreditCardDetails = true;
          self.error_txn = null;
          $scope.payment = {};
          $scope.payments = [];
          self.areaName = CONFIG.AREAS;
          $scope.isPaymentFormActive = false;

          $scope.addressTypes = [
              { id: 1, name: 'Delivery Address' },
              { id: 2, name: 'Pickup Address' }
          ];

          self.countries = RefDataService.getCountryList();
          self.availableShippingCountries = RefDataService.getAvailableShippingCountries();

          getCreditCardInfo();
          // retrievePickupAddress();  CC-368 NO NEED FOR PICKUP ADDRESS

          $scope.error_shippingAddress = "Invalid shipping information."
          $scope.error_pickupAddress = "Invalid pickup information."
          $scope.error_billingAddress = "Invalid billing information."
          $scope.error_paymentInfo = "Invalid payment information."
        }else{
          DialogAlertService.openLogon('',function(){
          if(utilities.isShowMainRegion()){
			      $state.go('main');
          } else {
            $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
          }
          });
        }

      }

      /////////////////////////////////////////
      // SCROLL TO SHOW THE ERROR
      /////////////////////////////////////////
      $scope.scrollToError = function(showError){
          //OFFSET BECAUSE OF STICKY HEADER
          $anchorScroll.yOffset = 300;
          $anchorScroll(showError);
      }

      /////////////////////////////////////////
      //UPDATE USER PROFILE
      /////////////////////////////////////////
      // this.updateProfile = function (){
      //
      //   var tempUserProfile = {id:$rootScope.user.id,enabled:$rootScope.user.enabled,
      //     email:self.email,
      //     firstName:self.firstName,
      //     lastName:self.lastName,
      //     phone1:self.phone
      //     };
      //
      //   UserService.updateUserProfile(tempUserProfile).$promise.then(function(resp) {
      //     $rootScope.user = resp;
      //     DialogAlertService.promptDialog('Personal Information Successfully Updated. ', '', '', '', 'Ok', '', '', false);
      //   }, function(resp) {
      //     console.log("Update user profile error : ", resp.status);
      //     DialogAlertService.promptDialog('Error updating the personal information. Please try again later. ', '', '', '', 'Ok', '', '', false,'',"RED");
      //   });
      // }


      /////////////////////////////////////////
      // SELECT THE PRE-DEFINED CITY FROM THE DROP DOWN LIST.
      /////////////////////////////////////////
      self.setSelected = function(type,selectedValue) {
	      switch (type) {
          case 'shippingCountry':
            $scope.fmShippingInfo ? $scope.fmShippingInfo.shipCountry.$setDirty() : '';
            self.shippingAddress.country = selectedValue.name;
            self.disable_Shipping_CityDDL = selectedValue.name != CONFIG.HONG_KONG ? true:false;
            $scope.shipping_reqPostCode = selectedValue.reqPostCode;
            break;

          case 'billingCountry':
            self.billingAddress.country = selectedValue.name;
            self.disable_Billing_CityDDL = selectedValue.name != CONFIG.HONG_KONG ? true:false;
            if (!self.disable_Billing_CityDDL){
              self.billingAddress.city = self.areaName[0].name;
            }
            if ($scope.isSameShippingAddress && !self.disable_Billing_CityDDL) {
              self.shippingAddress.country = selectedValue.name;
              $scope.billing_reqPostCode = selectedValue.reqPostCode;
            }
            break;

	        case 'CREDIT_CARD_ADDRESS':
	          self.billingAddress.city = selectedValue.name;
            if ($scope.isSameShippingAddress) {
              self.shippingAddress.city = selectedValue.name;
            }
	          break;

          case 'SHIPPING_ADDRESS':
	          self.shippingAddress.city = selectedValue.name;
	          break;
        }
      }

      /////////////////////////////////////////
      //ONLY ALLOW NUMBERIC VALUE TO BE ENTERED
      /////////////////////////////////////////
      this.creditCardCheck = function(inputValue) {
        if (inputValue){
          (isNaN(inputValue) || inputValue.charAt(inputValue.length - 1) === '.') ? self.stReq.cardnum = inputValue.substring(0, inputValue.length - 1): '';
        }
      }

      /////////////////////////////////////////
      //ONLY ALLOW NUMBERIC VALUE TO BE ENTERED
      /////////////////////////////////////////
      this.CVCCheck = function(inputValue) {
        if (inputValue){
          (isNaN(inputValue) || inputValue.charAt(inputValue.length - 1) === '.') ? self.stReq.cvc = inputValue.substring(0, inputValue.length - 1): '';
        }
      }

      /////////////////////////////////////////
      //CHECK FOR VALID CREDIT CARD EXPIRY DATE
      /////////////////////////////////////////
      this.expiryDateCheck = function(inputValue) {
        //ONLY ALLOW ENTER MM/YY
        if (inputValue){
          var validValue = true;
          isNaN(inputValue) ? validValue = false : '';
          (inputValue.length == 2 && (inputValue == 0 || inputValue > 12)) ? validValue = false: '';
          !validValue ? self.ccExpiry = inputValue.substring(0, inputValue.length - 1) : '';
        }
      }

      /////////////////////////////////////////
      //SELECT THE ADDRESS TYPE
      /////////////////////////////////////////
      $scope.setSelectedAddressType = function(type, selectedValue) {
        switch (type) {

          case 'SHIPPING_ADDRESS':
            self.addressType = selectedValue.id;
            break;
        }
      };


      /////////////////////////////////////////
      //COPY BILLING ADDRESS TO ADDRESS LOGIC
      /////////////////////////////////////////
      this.isCopyShippingInfoFromBillingInfo = function() {
        if ($scope.isSameShippingAddress && ((self.isShipToHKOnly && self.billingAddress.country == CONFIG.HONG_KONG) || !self.isShipToHKOnly)){
          return true;
        }else{
          return false;
        }
      }

      /////////////////////////////////////////
      //COPY BILLING ADDRESS TO ADDRESS TYP
      /////////////////////////////////////////
      this.copyBillingAddressToAddressType = function(type) {
        if ($scope.isSameShippingAddress){
          switch (type) {
            case 1:

              if (self.isCopyShippingInfoFromBillingInfo()){
                self.shippingAddress = angular.copy(self.billingAddress);
              }
              break;
            case 2:
              self.pickupAddress = angular.copy(self.billingAddress);
              break;
            default:
          }
        }
      }


      /////////////////////////////////////////
      // SAVE PICKUP ADDRESS
      /////////////////////////////////////////
      this.savePickupAddress = function(){

        self.pickupAddress.type = self.addressType;
        $scope.isSubmitted_fmPickupInfo = false;

        UserService.updateAddress(self.pickupAddress).$promise.then(
          function(resp){
              $scope.fmPickupInfo.$setPristine();
              $scope.fmPickupInfo.$setUntouched();
              DialogAlertService.promptDialog('Pickup address updated Successfully. ', '', '', '', 'GENERAL.LABEL.OK', '', '', false);
          }, function(err){
              $rootScope.enableLog ? $log.error($rootScope.UUID + ":paymentOptions:savePickupAddress - Error:" + err):'';
              DialogAlertService.promptDialog('Error updating the pickup address. Please try again later. ', '', '', '', 'GENERAL.LABEL.OK', '', '', false,'',"RED");
          }
        );
      }

      /////////////////////////////////////////
      // SAVE SHIPPING ADDRESS
      /////////////////////////////////////////
      this.saveShippingAddress = function(){

        $scope.isSubmitted_fmShippingInfo = false;
        self.shippingAddress.type = self.addressType;

        UserService.updateAddress(self.shippingAddress).$promise.then(
          function(resp){
              $scope.fmShippingInfo.$setPristine();
              $scope.fmShippingInfo.$setUntouched();
              DialogAlertService.promptDialog('Shipping address updated Successfully. ', '', '', '', 'GENERAL.LABEL.OK', '', '', false);
          }, function(err){
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":paymentOptions:saveShippingAddress - Error:" + err):'';
              DialogAlertService.promptDialog('Error updating the shipping address. Please try again later. ', '', '', '', 'GENERAL.LABEL.OK', '', '', false,'',"RED");
          }
        );
      }

      /////////////////////////////////////////
      //GET CREDIT CARD INFORMATION
      /////////////////////////////////////////
      function getCreditCardInfo(){
        if($rootScope.geoLocation.country == 'SG') {
          $window.Stripe.setPublishableKey(envService.read('STRIP_KEY_SG'));
        }
        RentalService.preCheck().$promise.then(
          function(resp) {

            self.last4 = resp.last4;
            
            if(resp.billingAddress){
              self.billingAddress = angular.copy(resp.billingAddress);
            } else {
              /**
               * Copy to handle existing data with shippingAddress only
               */
              self.billingAddress = angular.copy(resp.shippingAddress); 
            }

            if(self.billingAddress){
              self.disable_Billing_CityDDL = self.billingAddress.country != CONFIG.HONG_KONG ? true:false;
            }

            if (resp.hasBilling) {
              self.hasBilling = true;
              self.isHideCreditCardDetails = true;
            } else {
              self.hasBilling = false;
              self.isHideCreditCardDetails = false;
            }

          }, function(err) {
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":paymentOptions:getCreditCardInfo - Error:" + err):'';
          });
      }


      /////////////////////////////////////////
      //RETRIEVE PICK UP ADDRESS CC-368 NO NEED FOR PICKUP ADDRESS
      /////////////////////////////////////////
      // function retrievePickupAddress(){
      //   UserService.retrievePickupAddressNoToken().$promise.then(function(resp) {
      //     self.pickupAddress = resp.address;
      //     if (resp.address.address1){
      //       $scope.hasPickupAddress = true;
      //     }
      //     $rootScope.enableLog ? $log.info($rootScope.UUID + ":paymentOptions:retrievePickupAddress - " + JSON.stringify(resp)):'';
      //   }, function(err) {
      //     $rootScope.enableLog ? $log.error($rootScope.UUID + ":paymentOptions:retrievePickupAddress - Error:" + err.status):'';
      //   });
      // }

      /////////////////////////////////////////
      //REPLACE OR ADD NEW CREDIT CARD INFORMATION
      /////////////////////////////////////////
      this.saveCreditCardinfo = function() {

        // usSpinnerService.spin('spinner');

        //CONVERT FORM DATA TO STRIP REQUIRED FORMAT
        self.stReq.mm = self.ccExpiry.substring(0, 2);
        self.stReq.yy = self.ccExpiry.substring(2, 4);
        self.stReq.address1 = self.billingAddress.address1;
        self.stReq.address2 = self.billingAddress.address2;
        self.stReq.city = self.billingAddress.city;
        self.stReq.country = self.billingAddress.country;
        self.stReq.district = self.billingAddress.district;
        $scope.isSubmitted_fmCreditCard = false;

        // Request a token from Stripe:
        Stripe.card.createToken({
          number: self.stReq.cardnum,
          cvc: self.stReq.cvc,
          exp_month: self.stReq.mm,
          exp_year: self.stReq.yy,
          name: self.stReq.name,
          address_line1: self.stReq.address1,
          address_line2: self.stReq.address2,
          address_city: self.stReq.city,
          address_country: self.stReq.country,
          metadata: {
            "email": $rootScope.user && $rootScope.isLogon ? $rootScope.user.email : "",
            "phone": $rootScope.user && $rootScope.isLogon ? $rootScope.user.phone1 : ""
          }
        }, function(status, response) {

          if (response.error) { // Problem!
            self.error_txn = response.error.message;
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":paymentOptions:saveCreditCardinfo - Card creation failed:" + self.error_txn):'';
            $scope.$apply();
            usSpinnerService.stop('spinner');
            $scope.scrollToError('billingError');
          } else { // Token was created!
            $rootScope.enableLog ? $log.info($rootScope.UUID + ":paymentOptions:saveCreditCardinfo - Card creation successed: " + response.id):'';
            self.error_txn = null;
            // Get the token ID:
            var stripeToken = response.id;
            var addressObj = {
              country : $rootScope.geoLocation.country,
              district : self.billingAddress.district,
              postalCode : self.billingAddress.postalCode
            }
            // send stripeToken
            RentalService.saveStripeToken(stripeToken, addressObj).$promise.then(
              function(resp) {
                $rootScope.enableLog ? $log.info($rootScope.UUID + ":paymentOptions:saveCreditCardinfo - Token saved to server: " + resp):'';
                getCreditCardInfo();
                self.stReq = {};
                self.ccExpiry = null;
                $scope.fmCreditCard.$setPristine();
                $scope.fmCreditCard.$setUntouched();
                usSpinnerService.stop('spinner');
              },
              function(err) {
                $rootScope.enableLog ? $log.error($rootScope.UUID + ":paymentOptions:saveCreditCardinfo - Token failed to save to server:" + err):'';
                usSpinnerService.stop('spinner');
                $scope.scrollToError('billingError');
                
                if(err.data && err.data.reasons && err.data.reasons[0]){
                  switch (err.data.reasons[0].code) {
                    case "FAILED_TO_CREATE_CUSTOMER_OBJECT":
                      self.error_txn = $filter('translate')('GENERAL.ERROR.FAILED_TO_CREATE_CUSTOMER_OBJECT');
                      break;
                    case "CARD_DECLINED":
                      self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_DECLINED_PAYMENT_INFO');
                      break;
                    case "CARD_INCORRECT_CVC":
                      self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_INCORRECT_CVC');
                      break;
                    case "CARD_INCORRECT_NUMBER":
                      self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_INCORRECT_NUMBER');
                      break;
                    case "CARD_EXPIRED":
                      self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_EXPIRED');
                      break;
                    default:
                      self.error_txn = $filter('translate')('GENERAL.ERROR.PROFILE_ERROR');
                      break;
                  }
                } else {
                  self.error_txn = $filter('translate')('GENERAL.ERROR.PROFILE_ERROR');
                }
              }
            );
          }
        });

      }
      
      $('.dropdown-menu').find('input').click(function (e) {
        e.stopPropagation();
      });

    }]

  });

'use strict';

// angular.module('coutureApp')
//   .component('creditBalance', {
//     controllerAs : 'creditBalanceCtrl',
//     templateUrl: 'scripts/components/credit-balance/credit-balance.html',
//     controller: function($scope, $rootScope,$state,DialogAlertService,$log) {

//       //DEFINE SCOPE OF this
//       var self = this;

//       this.$onInit = function(){
//         $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - creditBalance"):'';
//         if (!$rootScope.isLogon){
//           $state.go('main');
//         }
//       }

//       this.requestUpdate = function(){
//         DialogAlertService.promptDialog('Your request has been submitted successfully. We will contact you shortly.', '', '', '', 'Ok', '', '', false);
//       }

//     }
//   });


  angular.module('coutureApp')
  .component('creditBalance', {
    controllerAs : 'creditBalanceCtrl',
    templateUrl: 'scripts/components/credit-balance/credit-balance.html',
    controller: ["$rootScope", "$log", "$scope", "UserService", "DialogAlertService", "AuthService", "$state", "utilities", "$filter", "$translate", "$translatePartialLoader", "Session", "CONFIG", "$q", "usSpinnerService", "envService", "$firebaseAuth", "priceUtilities", function($rootScope,$log, $scope, UserService, DialogAlertService,AuthService, $state ,
      utilities,$filter,$translate,$translatePartialLoader,Session,CONFIG,$q,usSpinnerService,envService,$firebaseAuth,priceUtilities) {

      var self = this;

      this.$onInit = function(){
        $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - creditBalance"):'';
        if (!$rootScope.isLogon){
          if(utilities.isShowMainRegion()){
            $state.go('main');
          } else {
            $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
          }
        }else{

          self.current= null;
          self.available= null;
          self.getCreditBalance();
        }
      }

      ////////////////////////////
      //GET CREDIT BALANCE
      ////////////////////////////
      self.getCreditBalance = function(){
        var country = $rootScope.geoLocation.country;
        UserService.retrieveCreditBalance(country).$promise.then(function(resp) {
          self.reserved = resp.reserved;
          self.available= resp.available;
          self.redeemed= resp.redeemed;
          self.activeSubscription= resp.activeSubscription;
          self.recurring = resp.recurring;
          self.upgradeable = resp.upgradeable;
          // new local date format yyyymmdd
          if (resp.expire!=null){
            self.expire= new Date(resp.expire.substring(0,4),resp.expire.substring(4,6)-1,resp.expire.substring(6));
          }
          if (resp.subscriptionStart!=null){
            self.subscriptionStart= new Date(resp.subscriptionStart.substring(0,4),resp.subscriptionStart.substring(4,6)-1,resp.subscriptionStart.substring(6));
          }
          self.creditValue = "("+ country + priceUtilities.currencyFormat(self.available * priceUtilities.getOriginalCreditPrice()) + " value)";
        }, function(err) {
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":creditBalance:getCreditBalance- Retrieve Credit Balance error: " + err.status):'';
          self.error_creditBalance = err;
        });
      }

      self.upgradeStylePass = function() {
        if($rootScope.geoLocation.country == CONFIG.COUNTRY_CURRENCY_CODE.SG.country_code){
          window.open("https://stylecarousel.com/landing/sg-upgrade-stylepass/", '_blank');
        } else {
          window.open("https://stylecarousel.com/landing/hk-upgrade-stylepass/", '_blank');
        }
      }

      self.cancelStylePass = function() {
        window.open("https://stylecarousel.com/landing/stylepass-status/", '_blank');
      }


    }]
  })

'use strict';

angular.module('coutureApp')
  .component('getPaid', {
    controllerAs : 'getPaidCtrl',
    templateUrl: 'scripts/components/get-paid/get-paid.html',
    controller: ["$scope", "$rootScope", "$state", "DialogAlertService", "$log", "utilities", "PayoutService", "priceUtilities", "usSpinnerService", "NgTableParams", "$uibModal", function($scope, $rootScope,$state,DialogAlertService,$log,utilities,PayoutService,priceUtilities, usSpinnerService, NgTableParams,$uibModal) {

      //DEFINE SCOPE OF this
      var self = this;
      self.payoutdetails = {
        selectedCurrency : null,
        selectedAmount : 0,
        beneficiaryDetails : {
          beneficiary: {
            address: {},
            bank_details: {},
            company_name: null,
            entity_type: 'COMPANY'
          }
        }
      };
      self.submitted = false;

      this.$onInit = function(){
        
        self.availableForRegion = utilities.isFunctionEnabled();
        $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - getPaid"):'';
        if (!$rootScope.isLogon){
            self.isPayoutAvailable = false;
            /*if(utilities.isShowMainRegion()){
              $state.go('main');
            } else {
              $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
            }*/
              DialogAlertService.openLogon('',function(){
              if(utilities.isShowMainRegion()){
                $state.go('main');
              } else {
                $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
              }
              });
        } else {
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - GetPaid#getBeneficiaryDetails"):'';
          
          usSpinnerService.spin('spinner');
          self.statusFilter = utilities.getPayoutStatusFilter();
          self.loadHistory();

          PayoutService.getBeneficiaryDetails().$promise.then(
            function(resp) {
              self.payout = resp.payout;
              self.payoutdetails.cancellationDetails = [];
              self.payout.cancellationDetails.forEach(r => {
                self.payoutdetails.cancellationDetails.push(r);
              });
              self.payoutdetails.rentalIds = [];
              self.payout.rentalDetails.forEach(r => {
                self.payoutdetails.rentalIds.push(r.id);
              });
              self.payoutdetails.purchaseIds = [];
              self.payout.purchaseDetails.forEach(r => {
                self.payoutdetails.purchaseIds.push(r.id);
              });
              self.totalPayouts = resp.payout.totalPayouts;
              self.totalPayouts.forEach(p => {
                p._amount = priceUtilities.formatWithCountryCode(p.amount, p.currency);
              });

              self.isPayoutAvailable = resp.selectedAmount > 0;
              $scope.setCurrencyAmount(resp.selectedCurrency, resp.selectedAmount);
              $scope.getCountryName(resp.selectedCountry);
              usSpinnerService.stop('spinner');
            },
            function(err) {
              usSpinnerService.stop('spinner');
              $rootScope.enableLog ? $log.error($rootScope.UUID + ':PayoutService.getBeneficiaryDetails - getBeneficiaryDetails error: ' + err ) : '';
            }
          );

        }
      }

      this.requestUpdate = function(){
        DialogAlertService.promptDialog('Your request has been submitted successfully. We will contact you shortly.', '', '', '', 'Ok', '', '', false);
      }

      this.setEntityType = function(entityType) {
        self.payoutdetails.beneficiaryDetails.beneficiary.entity_type = entityType;
      }
      $scope.setCurrencyAmount = function(currency, amount) {
        self.payoutdetails.beneficiaryDetails.beneficiary.bank_details.bank_country_code = null;
        self.payoutdetails.beneficiaryDetails.beneficiary.address.country_code = null;
        self.defaultBankCountry = null;
        self.addressBankCountry = null;

        self.payoutdetails.selectedAmount = amount;
        self.payoutdetails.selectedCurrency = currency;
        self.payoutdetails.selectedCurrencyAmount = priceUtilities.formatWithCountryCode(amount, currency);
        if(currency == 'USD'){
          self.payoutdetails.beneficiaryDetails.beneficiary.bank_details.account_routing_type1 = 'aba';
          self.payoutdetails.beneficiaryDetails.beneficiary.bank_details.bank_country_code = 'US';
          self.payoutdetails.beneficiaryDetails.beneficiary.bank_details.local_clearing_system = 'ACH';
          self.payoutdetails.beneficiaryDetails.beneficiary.bank_details.account_currency = 'USD';
          self.payoutdetails.beneficiaryDetails.beneficiary.address.country_code = 'US';
        }
        if(currency == 'GBP'){
          self.payoutdetails.beneficiaryDetails.beneficiary.bank_details.account_routing_type1 = 'sort_code';
          self.payoutdetails.beneficiaryDetails.beneficiary.bank_details.bank_country_code = 'GB';
          self.payoutdetails.beneficiaryDetails.beneficiary.bank_details.local_clearing_system = 'faster_payments';
          self.payoutdetails.beneficiaryDetails.beneficiary.bank_details.account_currency = 'GBP';
          self.payoutdetails.beneficiaryDetails.beneficiary.address.country_code = 'GB';
        }
        if(currency == 'AUD'){
          self.payoutdetails.beneficiaryDetails.beneficiary.bank_details.account_routing_type1 = 'bsb';
          self.payoutdetails.beneficiaryDetails.beneficiary.bank_details.bank_country_code = 'AU';
          self.payoutdetails.beneficiaryDetails.beneficiary.bank_details.local_clearing_system = 'bank_transfer';
          self.payoutdetails.beneficiaryDetails.beneficiary.bank_details.account_currency = 'AUD';
          self.payoutdetails.beneficiaryDetails.beneficiary.address.country_code = 'AU';
        }
        if(currency == 'HKD'){
          self.payoutdetails.beneficiaryDetails.beneficiary.bank_details.account_routing_type1 = 'bank_code';
          self.payoutdetails.beneficiaryDetails.beneficiary.bank_details.bank_country_code = 'HK';
          self.payoutdetails.beneficiaryDetails.beneficiary.bank_details.local_clearing_system = 'ACH';
          self.payoutdetails.beneficiaryDetails.beneficiary.bank_details.account_currency = 'HKD';
          self.payoutdetails.beneficiaryDetails.beneficiary.address.country_code = 'HK';
        }
        if(currency == 'SGD'){
          self.payoutdetails.beneficiaryDetails.beneficiary.bank_details.account_routing_type1 = null;
          self.payoutdetails.beneficiaryDetails.beneficiary.bank_details.bank_country_code = 'SG';
          self.payoutdetails.beneficiaryDetails.beneficiary.bank_details.local_clearing_system = 'fast';
          self.payoutdetails.beneficiaryDetails.beneficiary.bank_details.account_currency = 'SGD';
          self.payoutdetails.beneficiaryDetails.beneficiary.address.country_code = 'SG';
        }
        if(currency == 'CAD'){
          self.payoutdetails.beneficiaryDetails.beneficiary.bank_details.account_routing_type1 = 'routing_number';
          self.payoutdetails.beneficiaryDetails.beneficiary.bank_details.bank_country_code = 'CA';
          self.payoutdetails.beneficiaryDetails.beneficiary.bank_details.account_currency = 'CAD';
          self.payoutdetails.beneficiaryDetails.beneficiary.address.country_code = 'CA';
        }
        if(currency == 'EUR'){
          self.payoutdetails.beneficiaryDetails.beneficiary.bank_details.account_routing_type1 = 'routing_number';
          self.payoutdetails.beneficiaryDetails.beneficiary.bank_details.account_currency = 'EUR';
        }
        $scope.getCountryName(self.payoutdetails.beneficiaryDetails.beneficiary.bank_details.bank_country_code);
      }

      $scope.setCountry = function(country) {
        self.payoutdetails.beneficiaryDetails.beneficiary.bank_details.bank_country_code = country.countryCode;
        self.payoutdetails.beneficiaryDetails.beneficiary.address.country_code = country.countryCode;
        self.defaultBankCountry = country.name;
        self.addressBankCountry = country.name;
      }

      $scope.setCountryAddress = function(country) {
        self.payoutdetails.beneficiaryDetails.beneficiary.address.country_code = country.countryCode;
        self.addressBankCountry = country.name;
      }

      $scope.getCountryName = function(countryCode){
        var defaultCountry = $rootScope.countryList.filter(c => c.countryCode == countryCode);
        self.defaultBankCountry = defaultCountry.length > 0 ? defaultCountry[0].name : null;
        self.payoutdetails.beneficiaryDetails.beneficiary.bank_details.bank_country_code = defaultCountry.length > 0 ? defaultCountry[0].countryCode : null;
        self.payoutdetails.beneficiaryDetails.beneficiary.address.country_code = defaultCountry.length > 0 ? defaultCountry[0].countryCode : null;
        self.addressBankCountry = defaultCountry.length > 0 ? defaultCountry[0].name : null;
      }

      this.submitRequest = function(){
        self.err_payoutdetails_beneficiaryDetails_beneficiary_address_city = null;
        self.err_payoutdetails_beneficiaryDetails_beneficiary_address_postcode = null;
        self.err_payoutdetails_beneficiaryDetails_beneficiary_address_state = null;
        self.err_payoutdetails_beneficiaryDetails_beneficiary_address_street_address = null;
        self.err_payoutdetails_beneficiaryDetails_beneficiary_bank_details_account_name = null;
        self.err_payoutdetails_beneficiaryDetails_beneficiary_bank_details_account_number = null;
        self.err_payoutdetails_beneficiaryDetails_beneficiary_bank_details_account_routing_value1 = null;
        self.err_payoutdetails_beneficiaryDetails_beneficiary_bank_details_account_bank_name = null;
        self.err_payoutdetails_beneficiaryDetails_beneficiary_bank_details_swift_code = null;
        self.err_payoutdetails_beneficiaryDetails_beneficiary_company_name = null;
        self.err_payoutdetails_beneficiaryDetails_beneficiary_first_name = null;
        self.err_payoutdetails_beneficiaryDetails_beneficiary_last_name = null;
        usSpinnerService.spin('spinner');
          PayoutService.validateBeneficiaryDetails(self.payoutdetails).$promise.then(
            function(resp) {
              var validationResult = resp;
              self.isValid = true;
              if(validationResult != undefined || validationResult != null){
                for (var key in validationResult) {
                  if (validationResult.hasOwnProperty(key)) {
                    var errObj = validationResult[key];
                      if(errObj){
                          switch (key) {
                            case 'beneficiary.address.city':
                              self.err_payoutdetails_beneficiaryDetails_beneficiary_address_city = getErrorMessage(errObj.code, errObj.description, errObj.validation_functions);//"City is required.";
                              break;
                              case 'beneficiary.address.postcode':
                                self.err_payoutdetails_beneficiaryDetails_beneficiary_address_postcode = getErrorMessage(errObj.code, errObj.description, errObj.validation_functions);//"Postal Code is required.";
                                break;
                                case 'beneficiary.address.state':
                                  self.err_payoutdetails_beneficiaryDetails_beneficiary_address_state = getErrorMessage(errObj.code, errObj.description, errObj.validation_functions);//"State is required.";
                                  break;
                                  case 'beneficiary.address.street_address':
                                    self.err_payoutdetails_beneficiaryDetails_beneficiary_address_street_address = getErrorMessage(errObj.code, errObj.description, errObj.validation_functions);//"Street Address is required.";
                                    break;
                                    case 'beneficiary.bank_details.account_name':
                                      self.err_payoutdetails_beneficiaryDetails_beneficiary_bank_details_account_name = getErrorMessage(errObj.code, errObj.description, errObj.validation_functions);//"Account Name is required.";
                                      break;
                                      case 'beneficiary.bank_details.account_number':
                                        self.err_payoutdetails_beneficiaryDetails_beneficiary_bank_details_account_number = getErrorMessage(errObj.code, errObj.description, errObj.validation_functions);//"Account Number is required.";
                                        break;
                                        case 'beneficiary.bank_details.account_routing_value1':
                                          self.err_payoutdetails_beneficiaryDetails_beneficiary_bank_details_account_routing_value1 = getErrorMessage(errObj.code, errObj.description, errObj.validation_functions);//"Account Routing Value is required.";
                                          break;
                                          case 'beneficiary.bank_details.bank_name':
                                            self.err_payoutdetails_beneficiaryDetails_beneficiary_bank_details_bank_name = getErrorMessage(errObj.code, errObj.description, errObj.validation_functions);//"Bank Name is required.";
                                            break;
                                            case 'beneficiary.bank_details.swift_code':
                                              self.err_payoutdetails_beneficiaryDetails_beneficiary_bank_details_swift_code = getErrorMessage(errObj.code, errObj.description, errObj.validation_functions);//"Bank Name is required.";
                                              break;
                                            case 'beneficiary.company_name':
                                              self.err_payoutdetails_beneficiaryDetails_beneficiary_company_name = getErrorMessage(errObj.code, errObj.description, errObj.validation_functions);//"Company Name is required.";
                                              break;
                                              case 'beneficiary.first_name':
                                                self.err_payoutdetails_beneficiaryDetails_beneficiary_first_name = getErrorMessage(errObj.code, errObj.description, errObj.validation_functions);//"First Name is required.";
                                                break;
                                                case 'beneficiary.last_name':
                                                  self.err_payoutdetails_beneficiaryDetails_beneficiary_last_name = getErrorMessage(errObj.code, errObj.description, errObj.validation_functions);//"Last Name is required.";
                                                  break;
                            default:

                          }
                      }
                  }
                }
              } 
              if(self.isValid){
                PayoutService.updateBeneficiaryDetails(self.payoutdetails).$promise.then(
                  function(resp) {
                    self.submitted = resp ? true : false;
                  },
                  function(err) {
                    $rootScope.enableLog ? $log.error($rootScope.UUID + ':PayoutService.getBeneficiaryDetails - getBeneficiaryDetails error: ' + err ) : '';
                });
              } 
              usSpinnerService.stop('spinner');
            },
            function(err) {
              usSpinnerService.stop('spinner');
              $rootScope.enableLog ? $log.error($rootScope.UUID + ':PayoutService.getBeneficiaryDetails - getBeneficiaryDetails error: ' + err ) : '';
            }
          );
      }

      function getErrorMessage (errorCode, errorMessage, validationFunctionsErr) {
        self.isValid = false;
        if(errorCode == 'MISSING_REQUIRED_VALUE') {
          return errorMessage;
        } 
        if(errorCode == 'FAILED_VALIDATION_FUNCTIONS') {
          if (validationFunctionsErr.length > 0){
           return validationFunctionsErr[0].description; 
          }
        } 
      }

      this.loadHistory = function() {
        $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - GetPaid#loadHistory"):'';
        
        self.tableParams = new NgTableParams({ 
          page: 1,
          count: 5,
          sorting: { 
            requestedDate: "DESC"
          },
        }, {
          counts:[],
          getData: function(params) {
            usSpinnerService.spin('spinner');
            var tableFilters = params._params.filter;
            var filterParams = {};
            var tableParams = params._params;
            var sort = params._params.sorting;
            var sortType = null ;
            var sortDir = null;
            if(sort.payoutReferenceNumber){
              sortType = "referenceNumber";
              sortDir = sort.payoutReferenceNumber;
            } else if(sort.requestedCurrency){
              sortType = "requestedCurrency";
              sortDir = sort.requestedCurrency;
            } else if(sort.requestedAmount){
              sortType = "requestedAmount";
              sortDir = sort.requestedAmount;
            }  else if(sort.status){
              sortType = "status";
              sortDir = sort.status;
            }  else if(sort.requestedDate){
              sortType = "id";
              sortDir = sort.status;
            } else {
              sortType = "id";
              sortDir = "DESC";
            }

            filterParams.page = tableParams.page;
            filterParams.sortType = sortType;
            filterParams.sortDirection = sortDir;

            filterParams.referenceNumber = tableFilters.payoutReferenceNumber ? tableFilters.payoutReferenceNumber : null;
            filterParams.currency = tableFilters.requestedCurrency ? tableFilters.requestedCurrency : null;
            filterParams.amount = tableFilters.requestedAmount ? tableFilters.requestedAmount : null;
            filterParams.status = tableFilters.status ? tableFilters.status : null;
            var history = [];
            return PayoutService.getUserPayoutHistory(filterParams).$promise.then(function(resp) {
              $scope.data = resp;
              var totalRecordCount, totalPageCount;

              $scope.data.forEach(function(item, index, arr) {
                if (!item['searchResult']) {
                  item._page = self.currentPageCount;
                } else {
                  totalRecordCount = item['searchResult']['totalRecordCount'];
                  totalPageCount = item['searchResult']['totalPageCount'];
                  arr.pop();
                }
              });

              for (var i = 0; i < $scope.data.length; i++) {
                var tempResponse = $scope.data[i];
                tempResponse._requestedDate = moment(new Date(tempResponse.requestedDate)).format('D/M/YYYY');
                tempResponse._currencyAmount = priceUtilities.formatWithCountryCode(tempResponse.requestedAmount, tempResponse.requestedCurrency);
                tempResponse._paymentDate = tempResponse.status == "PAID" ? moment(new Date(tempResponse.paidDate)).format('D/M/YYYY') : "";
                history.push(tempResponse);
              }

              history.sort(function(a, b){return b.requestedDate-a.requestedDate;});

              usSpinnerService.stop('spinner');
              params.total(totalRecordCount);
              return history;
            },
            function(err) {
              usSpinnerService.stop('spinner');
              $rootScope.enableLog ? $log.error($rootScope.UUID + ":productRentalListing:loadProductRentalList - Error: " + JSON.stringify(err.data.reasons)):'';
            });
          }
        });

      }

      self.getPayoutTransactions = function(row){
        DialogAlertService.getPayoutTransactions(row);
      }

    }]
  });

'use strict';
angular.module('coutureApp')
  .component('myMembership', {
    controllerAs : 'myMembershipCtrl',
    templateUrl: 'scripts/components/my-membership/my-membership.html',
    controller: ["$rootScope", "$state", "utilities", function($rootScope,$state,utilities) {

      var self = this;
      this.$onInit = function(){
        if (!$rootScope.isLogon){
          if(utilities.isShowMainRegion()){
			      $state.go('main');
          } else {
            $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
          }
        }
      }


    }]
  })

'use strict';
angular.module('coutureApp')
  .component('myListings', {
    controllerAs : 'myListingsCtrl',
    templateUrl: 'scripts/components/my-listings/my-listings.html',
    controller: ["$scope", "$http", "$rootScope", "$log", "$state", "USER_ROLES", "AuthService", "utilities", function($scope, $http, $rootScope, $log,$state, USER_ROLES,AuthService,utilities) {

      var self = this;
      this.$onInit = function(){
        if (!$rootScope.isLogon || !AuthService.isAuthorized(USER_ROLES.admin)){
          if(utilities.isShowMainRegion()){
            $state.go('main');
          } else {
            $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
          }
        }else{
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - myListings"):'';
        }
      }

    $scope.isListing = null;

    $scope.setListing = function(type) {
      $scope.users = false;
      $scope.posts = false;
      $scope.rentals = false;
      $scope.custom = false;
      $scope.promo = false;
      $scope.subPricing= false;
      $scope.subUser= false;
      $scope.admin_settings= false;
      $scope.payout_requests= false;
      $scope.referrals= false;
      $scope.overdue_payments=false;
      switch (type) {
          case 'users':
              $scope.isListing = type;
              $scope.users = true;
              break;
          case 'posts':
              $scope.isListing = type;
              $scope.posts = true;
              break;
          case 'rentals':
              $scope.isListing = type;
              $scope.rentals = true;
              break;
          case 'custom':
              $scope.isListing = type;
              $scope.custom = true;
              break;
          case 'promo':
              $scope.isListing = type;
              $scope.promo = true;
              break;
          case 'subPricing':
              $scope.isListing = type;
              $scope.subPricing= true;
              break;
          case 'subUser':
              $scope.isListing = type;
              $scope.subUser= true;
              break;
          case 'admin_settings':
              $scope.isListing = type;
              $scope.admin_settings= true;
              break;
          case 'payout_requests':
              $scope.isListing = type;
              $scope.payout_requests= true;
             break;
          case 'referrals':
              $scope.isListing = type;
              $scope.referrals= true;
              break;
          case 'overdue_payments':
              $scope.isListing = type;
              $scope.overdue_payments= true;
              break;
      }
    };


    }]
  })

'use strict';

(function(){
  angular.module('coutureApp')
    .component('promoCodePage', {
      templateUrl: 'scripts/components/promo-code/promo-code.html',
      controllerAs : 'promoCodeCtrl',
      bindings: {
        loadOrNot: '<'
      },
      controller: ["$scope", "$rootScope", "USER_ROLES", "AuthService", "NgTableParams", "ProductService", "ListingService", "$log", "PromoCodeService", "RefDataService", "$state", "DialogAlertService", "$filter", "$translate", "$translatePartialLoader", "utilities", "usSpinnerService", "priceUtilities", "CONFIG", function($scope,$rootScope,USER_ROLES,AuthService,NgTableParams,ProductService,ListingService,$log,PromoCodeService
        ,RefDataService,$state,DialogAlertService, $filter,$translate,$translatePartialLoader,utilities,usSpinnerService,priceUtilities,CONFIG) {

        var self = this;

        this.$onInit = function(){
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - promoCodePage"):'';
          if (!$rootScope.isLogon || !AuthService.isAuthorized(USER_ROLES.admin)){
            if(utilities.isShowMainRegion()){
              $state.go('main');
            } else {
              $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
            }
          }else{
            this.sorting_promoteCodeList = { id:'desc'};
            this.sorting_comsumedCodeList = { id:'desc'};
            this.product_currency = priceUtilities.getCurrency();
            this.DATE_FORMAT = "MMM DD YYYY";
            this.code = null;
            this.isDiscountRate = 'true';
            this.isForCreditPurchase= 'true';
            this.subPromoAppMonths=null;
            this.discountValue = null;
            //"M" = Multi-use promo code.  Can be used many times.
            //"O" = One-time use promo code.  Can be used once by user.
            //"U" = Unique one-time use promo code.  Can be used only once by anyone. (Default)
            this.type = 'U';
            this.promo_country = CONFIG.COUNTRY_CURRENCY_CODE.HK.country_code;
            this.promo_currency = CONFIG.COUNTRY_CURRENCY_CODE.HK.currency_code;
            this.codeForUser = null;
            this.codeForMerchantProduct = null;
            this.description = null;
            this.codeStartDate = null;
            this.codeExpireDate = null;
            this.error = null;
            self.tableParams_promoteCodeList = new NgTableParams({ sorting: self.sorting_promoteCodeList}, {
               dataset: null
            });
            self.tableParams_comsumedCodeList = new NgTableParams({ sorting: self.sorting_comsumedCodeList}, {
               dataset: null
            });


          }
        };



        this.validate = function(){

          self.error= null;   //CLEAN THE ERROR.

          if (self.code == null || self.code.length > 20){
            self.error = "Promote code (Max 20Chars)"
          };

          if (self.isDiscountRate == 'true' && (self.discountValue == null || self.discountValue.length < 1 || self.discountValue < 0 || self.discountValue > 100)){
              self.error = self.error ? self.error + ", Discount rate (1% - 100%)" : "Discount rate (1% - 100%)";
          }else if (self.isDiscountRate == 'false' && (self.discountValue == null || self.discountValue.length < 1 || self.discountValue < 0 || self.discountValue > 999999)){
            self.error = self.error ? self.error + ", Discount amount $(0 - 999999)" : "Discount amount $(0 - 999999)";
          }

          if (self.description == null || self.description.length < 1 || self.description.length > 1024){
            self.error = self.error ? self.error + ", Promotion description (Max 1024Chars)" : "Promotion description (Max 1024Chars)";
          };

          if (self.isForCreditPurchase=='false'){
            if (self.subPromoAppMonths != null){
              var cleanAppMonths=self.subPromoAppMonths.replace(/ /g,'').replace(/\,/g,'');
              let isNum = /^\d+$/.test(cleanAppMonths);
              if (cleanAppMonths != '' && (!isNum || self.subPromoAppMonths.trim().includes(',,') || self.subPromoAppMonths.trim().slice(-1)==',' )){
                self.error = self.error ? self.error + ", Applicable months must be numbers and separated by commmas" : "Applicable months must be numbers and separated by commmas";
              } 
            }
          }

          if (self.error){
            self.error = "Please check the following: " + self.error + ".";
          }else{
            //ALL FIELDS ARE VALID CONVERT THE FIELD TO REQUEST OBJECT
            self.request = {
              code:self.code,
              type:self.type,
              description:self.description,
              isSubscriptionPromo:false,
              subPromoApplicableMonths:"",
              country:self.promo_country,
              currency:self.promo_currency,
              merchantId:self.codeForMerchantProduct
            };

            if (self.isDiscountRate == 'true'){
              self.request.discountRate = self.discountValue / 100;
            }else{
              self.request.discountAmount = self.discountValue;
            }
            if (self.isForCreditPurchase== 'false'){ // subscription promo
              self.request.isSubscriptionPromo = true;
              if (self.subPromoAppMonths!=null) self.request.subPromoApplicableMonths =self.subPromoAppMonths.trim(); 
            }

            if (self.codeStartDate) self.request.startDate = moment(self.codeStartDate,self.DATE_FORMAT).startOf('day').unix();
            if (self.codeExpireDate) self.request.endDate = moment(self.codeExpireDate,self.DATE_FORMAT).endOf('day').unix();
            if (self.codeForUser) self.request.user = self.codeForUser;
            if (self.codeForMerchantProduct) self.request.merchantId = self.codeForMerchantProduct;
            this.createCode();
          }
        }

        ///////////////////////////////////////////////
  	    // SAVE THE CURRENT SORTING OPTIONS. SO WHEN THE TABLE REFRESH, IT WILL HAVE THE SAME SORTING ORDER.
  	    ///////////////////////////////////////////////
        this.saveSortingOptions = function(){
          this.sorting_promoteCodeList = self.tableParams_promoteCodeList._params.sorting;
          this.sorting_comsumedCodeList = self.tableParams_comsumedCodeList._params.sorting;
        }

        ///////////////////////////////////////////////
  	    // GET ALL CONSUMED PROMOTION CODE
  	    ///////////////////////////////////////////////
        this.getConsumedPromoCodeList = function(){
          usSpinnerService.spin('spinner');
          PromoCodeService.listConsumed().$promise.then(function(resp){

            resp.map(function(current,index,arr){
              if (current.user == '') current.user = null;
              if (current.date) {
                current._date = moment.unix(current.date).format("MMM DD,YYYY hh:mm:ss a")
              }
            })

            self.tableParams_comsumedCodeList = new NgTableParams({ sorting: self.sorting_comsumedCodeList}, {
               dataset: resp
            });
            usSpinnerService.stop('spinner');
          },
          function(err) {
            usSpinnerService.stop('spinner');
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":promoCodePage:listConsumedCode - List consumed promotion code error!" + JSON.stringify(err.data.reasons)):'';
          });
        }

        ///////////////////////////////////////////////
  	    // GET ALL AVAILABLE PROMOTION CODE WHICH IS NOT USED.
  	    ///////////////////////////////////////////////
        this.getPromotionCodeList = function(){
          usSpinnerService.spin('spinner');
          PromoCodeService.listActive().$promise.then(function(resp){

            resp.map(function(current,index,arr){
              if (current.user == '') current.user = null;
              if (current.startDate) {
                current._startDate = moment.unix(current.startDate).format(self.DATE_FORMAT);
              }
              if (current.endDate) {
                current._endDate = moment.unix(current.endDate).format(self.DATE_FORMAT);
              }
              switch (current.type) {
                case 'O':
                  current._type = "One-time";
                  break;
                case 'M':
                  current._type = "Multi-use";
                  break;
                case 'U':
                  current._type = "Unique";
                  break;
              }
            })

            self.tableParams_promoteCodeList = new NgTableParams({ sorting: self.sorting_promoteCodeList}, {
               dataset: resp
            });

            usSpinnerService.stop('spinner');
          },
          function(err) {
            usSpinnerService.stop('spinner');
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":promoCodePage:listAddCode - List promotion code error!" + JSON.stringify(err.data.reasons)):'';
          });
        }

        ///////////////////////////////////////////////
  	    // CREATE PROMOTION CODE
  	    ///////////////////////////////////////////////
        this.createCode = function(){
          usSpinnerService.spin('spinner');
          PromoCodeService.create(self.request).$promise.then(function(resp){

            usSpinnerService.stop('spinner');

            self.getPromotionCodeList();
            self.getConsumedPromoCodeList();

          },
          function(err) {
            usSpinnerService.stop('spinner');
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":promoCodePage:createCode - Create promotion code error!" + JSON.stringify(err.data.reasons)):'';
          });
        }


        ///////////////////////////////////////////////
  	    // DELETE PROMOTION CODE
  	    ///////////////////////////////////////////////
        this.deleteCode = function(row,rowForm){
          usSpinnerService.spin('spinner');
          PromoCodeService.delete(row.id).$promise.then(function(resp){

            usSpinnerService.stop('spinner');
            if (resp.status == "Success"){
              self.getPromotionCodeList();
              self.getConsumedPromoCodeList();
            }else{
              usSpinnerService.stop('spinner');
              $rootScope.enableLog ? $log.error($rootScope.UUID + ":promoCodePage:deleteCode - Cannot delete promotion code : " + row.id):'';
            }
          });
        }


        ///////////////////////////////////////////////
  	    // ONLY LOAD THE LISTING IF IT IS SELECTED/VISIBLE
  	    ///////////////////////////////////////////////
        $scope.$watch('promoCodeCtrl.loadOrNot', function(selectedToDisplay) {
          if (selectedToDisplay){
            $translatePartialLoader.addPart('productListing');
            self.getPromotionCodeList();
            self.getConsumedPromoCodeList();
          }
        });

        this.setCountryCurrency = function(country, currency){
          self.promo_country = country;
          self.promo_currency = currency;
        }


      }]
    })
})();

'use strict';
angular.module('coutureApp')
  .component('profile', {
    templateUrl: 'scripts/components/profile/profile/profile.html',
    controllerAs : 'profileCtrl',
    controller: ["$scope", "Session", "$rootScope", "$state", "UserService", "$log", "utilities", function($scope, Session,$rootScope,$state,UserService,$log,utilities) {

      var self = this;
      self.profileName = null;

      this.$onInit = function(){
        $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - profileCtrl"):'';

        if ($rootScope.viewOtherProfile == undefined && !$rootScope.isLogon){
          //DIRECT TO MAIN PAGE, IF THE URL IS ENTERED DIRECTLY
          //INSTEAD OF COMING FROM THE CUSTOM URL
          if(utilities.isShowMainRegion()){
			      $state.go('main');
          } else {
            $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
          }
        }else if ($rootScope.isLogon){
          //$state.go('rental-listings');
          if(utilities.isShowMainRegion()){
            $state.go('rental-listings');
          } else {
            $state.go('rental-listings-multi-region',{country: $rootScope.geoLocation.country});
          }
        }
      }

      ///////////////////////////////////////////////
      // WATCH THE PROFILE CHANGE, AS IT WILL
      // BE AVAILABLE AFTER THE PAGE IS LOADED
      ///////////////////////////////////////////////
      $rootScope.$watch('viewOtherProfile', function(value) {
        if (value != undefined && $rootScope.viewOtherProfile ){
          self.profileName = value;
        }
      });

    }]
  })

'use strict';
angular.module('coutureApp')
  .component('userProfile', {
    templateUrl: 'scripts/components/profile/components/user-profile/user-profile.html',
    controllerAs : 'userProfileCtrl',
    controller: ["$scope", "Session", "$rootScope", "$state", "UserService", "$log", "CONFIG", "$q", "UploadService", "utilities", function($scope, Session,$rootScope,$state,UserService,$log,CONFIG,$q, UploadService, utilities) {

      var self = this;
      $scope.showSaveBanner = false;
      $scope.showSaveProfileImg = false;
      $scope.editAboutMe = false;
      if (!$rootScope.isLogon){
        $scope.profilePhotos = null;
      } else {
        getUserProfile();
      }
      $scope.invalidPhotos = [];
      self.UPLOAD_PHOTO_LIMIT = CONFIG.UPLOAD_PHOTO_LIMIT;
			self.PHOTO_LIMIT_MIN = CONFIG.PHOTO_SIZE_LIMIT_MIN;
			self.PHOTO_LIMIT_MAX = CONFIG.PHOTO_SIZE_LIMIT_MAX;
			self.PHOTO_RESIZE_QTY = CONFIG.PHOTO_RESIZE_RATIO;
			self.PHOTO_RESIZE_WIDTH = CONFIG.PHOTO_RESIZE_WIDTH;
			self.PHOTO_RESIZE_HEIGHT = CONFIG.PHOTO_RESIZE_HEIGHT;
			self.PRODUCT_MIN_PRICE = CONFIG.PRICE_MIN;

      this.$onInit = function(){
        $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - userProfileCtrl"):'';
        $scope.selectedDisplayPhotoIndex = 0;
        $scope.photos = [];
        self.UPLOAD_PHOTO_LIMIT = 1;
        self.PHOTO_LIMIT_MIN = CONFIG.PHOTO_SIZE_LIMIT_MIN;
        self.PHOTO_LIMIT_MAX = CONFIG.PHOTO_SIZE_LIMIT_MAX;
        self.PHOTO_RESIZE_QTY = CONFIG.PHOTO_RESIZE_RATIO;
        self.PHOTO_RESIZE_WIDTH = 690;
        self.PHOTO_RESIZE_HEIGHT = 280;
        self.aboutMe = $rootScope.user ? $rootScope.user.aboutMe : null;
      }

  
      this.checkPhotoLimit = function(files) {
        self.error_photo = null;
        if ($scope.photos.length + files.length > self.UPLOAD_PHOTO_LIMIT){
          $scope.selectedDisplayPhotoIndex = 0;
          // self.error_photo = 'GENERAL.ERROR.MAX_PRODUCT_PHOTO';
        }
      }


      $scope.uploadFiles = function(files) {
	      if (files != null && files.length > 0){
					$scope.profilePhotos = files;
          $scope.showSaveProfileImg = true;
	      }

        
        return ($scope.profilePhotos != null && $scope.profilePhotos.length > 0) ? true : false;
	    };
      
      $scope.uploadProfileImage = function() {
        var tempUserProfile = {
          id:$rootScope.user.userid,
          enabled:$rootScope.user.enabled,
          username:$rootScope.user.username,
          email:$rootScope.user.email,
          firstName:$rootScope.user.firstName,
          lastName:$rootScope.user.lastName,
          phone1:$rootScope.user.phone,
          aboutMe:$rootScope.user.aboutMe,
          profileImg: $rootScope.user.profileImg,
          businessName: $rootScope.user.businessName,
          phoneCode: $rootScope.user.phoneCode,
          merchantCountry: $rootScope.user.merchantCountry
        };
        $scope.showSaveProfileImg = false;

        var promises = [];
        var deferred = $q.defer();
        if ($scope.profilePhotos != null && ($scope.profilePhotos.length > 0 && $scope.profilePhotos[0] != self.profileImg)){
          //ADD OR UDPATE PROFILE IMAGE
          promises.push(deferred.promise);
          UploadService.uploadProfileImg($scope.profilePhotos[0]).then(
            function(resp) {
              tempUserProfile.profileImg = resp[0].PATH;

              UserService.updateProfileImg(resp[0].PATH).$promise.then(function(resp){
                utilities.updateLocalUserProfile(tempUserProfile);
                deferred.resolve();
              },function(err){
                deferred.reject($filter('translate')("GENERAL.ERROR.UPDATE_PERSONAL_INFO"));
              })
            },function(){
              deferred.reject($filter('translate')("GENERAL.ERROR.UPDATE_PERSONAL_INFO"));
            }
          );
        }else if($scope.profilePhotos == null && (self.profileImg != null)){
          UserService.deleteProfileImg().$promise.then(function(resp){
            $rootScope.user.profileImg = null;
          })
        }
      }
  
      this.checkProfileImgLimit = function(files) {
        self.error_photo = null;
        if ($scope.profilePhotos.length + files.length > self.UPLOAD_PHOTO_LIMIT){
          $scope.selectedDisplayPhotoIndex = 0;
          // self.error_photo = 'GENERAL.ERROR.MAX_PRODUCT_PHOTO';
        }
      }

      ///////////////////////////////////////////////
	    // REMOVE PROFILE IMAGE
	    ///////////////////////////////////////////////
      $scope.removeProfileImg = function(){
        var tempUserProfile = {
          id:$rootScope.user.userid,
          enabled:$rootScope.user.enabled,
          username:$rootScope.user.username,
          email:$rootScope.user.email,
          firstName:$rootScope.user.firstName,
          lastName:$rootScope.user.lastName,
          phone1:$rootScope.user.phone,
          aboutMe:$rootScope.user.aboutMe,
          businessName: $rootScope.user.businessName,
          phoneCode: $rootScope.user.phoneCode,
          merchantCountry: $rootScope.user.merchantCountry
        };
        $scope.profilePhotos = null;
        UserService.deleteProfileImg().$promise.then(function(resp){
          $scope.profilePhotos = null;
          tempUserProfile.profileImg = null;
          utilities.updateLocalUserProfile(tempUserProfile);
        })
      }

      function getUserProfile(){
        UserService.retrieveUserProfile().$promise.then(function(resp) {
          $rootScope.user.profileImg = resp.profileImg;
          $scope.profilePhotos = resp.profileImg ? [resp.profileImg]:null;
        }, function(err) {
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":myAccount:getUserProfile - Retrieve User Profile error: " + err.status):'';
          self.error_userProfile = err;
        });
      }
    }]
})

'use strict';
angular.module('coutureApp')
  .component('userBanner', {
    templateUrl: 'scripts/components/profile/components/user-banner/user-banner.html',
    controllerAs : 'userBannerCtrl',
    controller: ["$scope", "Session", "$rootScope", "$state", "UserService", "$log", "CONFIG", "usSpinnerService", "$q", "UploadService", "$filter", "utilities", function($scope, Session,$rootScope,$state,UserService,$log,CONFIG,usSpinnerService, $q, UploadService, $filter, utilities) {

      var self = this;
      $scope.showSaveBanner = false;
      $scope.showSaveProfileImg = false;
      $scope.editAboutMe = false;
      if (!$rootScope.isLogon){
        $scope.profilePhotos = null;
      } else {
        getUserProfile();
      }
      $scope.invalidPhotos = [];
      self.UPLOAD_PHOTO_LIMIT = CONFIG.UPLOAD_PHOTO_LIMIT;
			self.PHOTO_LIMIT_MIN = CONFIG.PHOTO_SIZE_LIMIT_MIN;
			self.PHOTO_LIMIT_MAX = CONFIG.PHOTO_SIZE_LIMIT_MAX;
			self.PHOTO_RESIZE_QTY = CONFIG.PHOTO_RESIZE_RATIO;
			self.PHOTO_RESIZE_WIDTH = CONFIG.PHOTO_RESIZE_WIDTH;
			self.PHOTO_RESIZE_HEIGHT = CONFIG.PHOTO_RESIZE_HEIGHT;
			self.PRODUCT_MIN_PRICE = CONFIG.PRICE_MIN;

      this.$onInit = function(){
        $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - userBannerCtrl"):'';
        $scope.selectedDisplayPhotoIndex = 0;
        $scope.selectedDisplayProfilePhotoIndex = 0;
        $scope.photos = [];
        self.UPLOAD_PHOTO_LIMIT = 1;
        self.PHOTO_LIMIT_MIN = CONFIG.PHOTO_SIZE_LIMIT_MIN;
        self.PHOTO_LIMIT_MAX = CONFIG.PHOTO_SIZE_LIMIT_MAX;
        self.PHOTO_RESIZE_QTY = CONFIG.PHOTO_RESIZE_RATIO;
        self.PHOTO_RESIZE_WIDTH = 690;
        self.PHOTO_RESIZE_HEIGHT = 280;
        self.aboutMe = $rootScope.user ? $rootScope.user.aboutMe : null;
      }

      $scope.uploadBanner = function(files) {
        if (files != null && files.length > 0){
					$scope.photos = files;
          $scope.showSaveBanner = true;
	      }
      };

      $scope.saveBanner = function() {
        usSpinnerService.spin('spinner');
        var promises = [];
        var deferred = $q.defer();
        
        if ($scope.photos && $scope.photos.length > 0){
          promises.push(deferred.promise);

          UploadService.uploadProfileBanner($scope.photos[0]).then(
            function(resp) {
              var profileBanner = resp[0].PATH;
              UserService.updateProfileBanner(profileBanner).$promise.then(function(resp){
                deferred.resolve();
                $scope.showSaveBanner = false;
                usSpinnerService.stop('spinner');
              },function(err){
                $scope.showSaveBanner = false;
                usSpinnerService.stop('spinner');
                deferred.reject($filter('translate')("GENERAL.ERROR.UPDATE_PERSONAL_INFO"));
              })
            },function(){
              $scope.showSaveBanner = false;
              usSpinnerService.stop('spinner');
              deferred.reject($filter('translate')("GENERAL.ERROR.UPDATE_PERSONAL_INFO"));
            }
          );
  
        }
      };

      $scope.deleteBanner = function() {
        $scope.photos = [];
        $rootScope.user.profileBanner = null;
        usSpinnerService.spin('spinner');
        UserService.deleteProfileBanner().$promise.then(function(resp){
          $scope.showSaveBanner = false;
          usSpinnerService.stop('spinner');
        },function(err){
          usSpinnerService.stop('spinner');
          deferred.reject($filter('translate')("GENERAL.ERROR.UPDATE_PERSONAL_INFO"));
        })
      }
  
      this.checkPhotoLimit = function(files) {
        self.error_photo = null;
        if ($scope.photos.length + files.length > self.UPLOAD_PHOTO_LIMIT){
          $scope.selectedDisplayPhotoIndex = 0;
          // self.error_photo = 'GENERAL.ERROR.MAX_PRODUCT_PHOTO';
        }
      }

      $scope.updateAboutMe = function() {
        var user_profile = {
          "aboutMe": self.aboutMe
        };
        UserService.updateAboutMe(user_profile).$promise.then(function(resp) {
          var user = resp.user;
          $scope.editAboutMe = false;
          $rootScope.user.aboutMe = user.aboutMe;
        });
      } 

      $scope.uploadFiles = function(files) {
	      if (files != null && files.length > 0){
					$scope.profilePhotos = files;
          $scope.showSaveProfileImg = true;
	      }

        
        return ($scope.profilePhotos != null && $scope.profilePhotos.length > 0) ? true : false;
	    };
      
      $scope.uploadProfileImage = function() {
        var tempUserProfile = {
          id:$rootScope.user.userid,
          enabled:$rootScope.user.enabled,
          username:$rootScope.user.username,
          email:$rootScope.user.email,
          firstName:$rootScope.user.firstName,
          lastName:$rootScope.user.lastName,
          phone1:$rootScope.user.phone,
          aboutMe:$rootScope.user.aboutMe,
          profileImg: $rootScope.user.profileImg,
          businessName: $rootScope.user.businessName,
          phoneCode: $rootScope.user.phoneCode,
          merchantCountry: $rootScope.user.merchantCountry
        };
        $scope.showSaveProfileImg = false;

        var promises = [];
        var deferred = $q.defer();
        if ($scope.profilePhotos != null && ($scope.profilePhotos.length > 0 && $scope.profilePhotos[0] != self.profileImg)){
          //ADD OR UDPATE PROFILE IMAGE
          promises.push(deferred.promise);
          UploadService.uploadProfileImg($scope.profilePhotos[0]).then(
            function(resp) {
              tempUserProfile.profileImg = resp[0].PATH;

              UserService.updateProfileImg(resp[0].PATH).$promise.then(function(resp){
                utilities.updateLocalUserProfile(tempUserProfile);
                deferred.resolve();
              },function(err){
                deferred.reject($filter('translate')("GENERAL.ERROR.UPDATE_PERSONAL_INFO"));
              })
            },function(){
              deferred.reject($filter('translate')("GENERAL.ERROR.UPDATE_PERSONAL_INFO"));
            }
          );
        }else if($scope.profilePhotos == null && (self.profileImg != null)){
          UserService.deleteProfileImg().$promise.then(function(resp){
            $rootScope.user.profileImg = null;
          })
        }
      }
  
      self.checkProfileImgLimit = function(files) {
        self.error_photo = null;
        if ($scope.profilePhotos.length + files.length > self.UPLOAD_PHOTO_LIMIT){
          $scope.selectedDisplayProfilePhotoIndex = 0;
        }
      }

      ///////////////////////////////////////////////
	    // REMOVE PROFILE IMAGE
	    ///////////////////////////////////////////////
      $scope.removeProfileImg = function(){
        var tempUserProfile = {
          id:$rootScope.user.userid,
          enabled:$rootScope.user.enabled,
          username:$rootScope.user.username,
          email:$rootScope.user.email,
          firstName:$rootScope.user.firstName,
          lastName:$rootScope.user.lastName,
          phone1:$rootScope.user.phone,
          aboutMe:$rootScope.user.aboutMe,
          businessName: $rootScope.user.businessName,
          phoneCode: $rootScope.user.phoneCode,
          merchantCountry: $rootScope.user.merchantCountry,
          profileBanner: $rootScope.user.profileBanner
        };
        $scope.profilePhotos = null;
        UserService.deleteProfileImg().$promise.then(function(resp){
          $scope.profilePhotos = null;
          tempUserProfile.profileImg = null;
          utilities.updateLocalUserProfile(tempUserProfile);
        })
      }

      function getUserProfile(){
        UserService.retrieveUserProfile().$promise.then(function(resp) {
          $rootScope.user.profileImg = resp.profileImg;
          $scope.profilePhotos = resp.profileImg ? [resp.profileImg]:null;
        }, function(err) {
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":myAccount:getUserProfile - Retrieve User Profile error: " + err.status):'';
          self.error_userProfile = err;
        });
      }

    }]
})

'use strict';
angular.module('coutureApp')
  .component('listingMenu', {
    templateUrl: 'scripts/components/profile/components/listing-menu/listing-menu.html',
    controllerAs : 'listingMenuCtrl',
    controller: ["$scope", "$state", "$log", "$rootScope", "AuthService", "USER_ROLES", "utilities", "CONFIG", function($scope,$state,$log,$rootScope,AuthService,USER_ROLES,utilities,CONFIG) {

      var self = this;

      this.$onInit = function(){
        $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - listingMenuCtrl"):'';
        self.isOwnerOrAdmin = false;
        
        if ($rootScope.isLogon){
          self.isOwner = $state.params.otherUsername == $rootScope.user.username.toLowerCase();
          self.isOwnerOrAdmin = self.isOwner || AuthService.isAuthorized(USER_ROLES.admin);
        }

      }

      this.isSelectedRentalListing = function(){
        return $state.includes('rental-listings') || $state.includes('rental-listings-multi-region') || $state.includes('viewOtherUserRentalListings') || $state.includes('viewOtherUserRentalListings-multi-region');
      }

      this.isSelectedBuyListing = function(){
        if(utilities.isShowMainRegion()){
          if ($state.params.otherUsername != null){
            return $state.includes('viewOtherUserBuyListings');
          }
          return $state.includes('buy-listings');
        } else {
          if ($state.params.otherUsername != null){
            return $state.includes('viewOtherUserBuyListings-multi-region');
          }
          return $state.includes('buy-listings-multi-region');
        }
      }

      this.isSelectedStylePosts = function(){
        return $state.includes('style-posts') || $state.includes('style-posts-multi-region') || $state.includes('viewOtherUserStylePosts') || $state.includes('viewOtherUserStylePosts-multi-region');
      }

      this.isSelectedWishLists = function(){
        return $state.includes('wishlists');
      }

      this.gotoRentalListing = function(){
        if ($state.params.otherUsername != null){
          if(utilities.isShowMainRegion()){
            $state.go('viewOtherUserRentalListings',{otherUsername:$state.params.otherUsername});
          } else {
            $state.go('viewOtherUserRentalListings-multi-region',{otherUsername:$state.params.otherUsername,country: $rootScope.geoLocation.country});
          }
        }else{
          if(utilities.isShowMainRegion()){
            $state.go('rental-listings');
          } else {
            $state.go('rental-listings-multi-region',{country: $rootScope.geoLocation.country});
          }
        }
      }

      this.gotoBuyListing = function(){
        if ($state.params.otherUsername != null){
          if(utilities.isShowMainRegion()){
            $state.go('viewOtherUserBuyListings',{otherUsername:$state.params.otherUsername});
          } else {
            $state.go('viewOtherUserBuyListings-multi-region',{otherUsername:$state.params.otherUsername,country: $rootScope.geoLocation.country});
          }
        }else{
          if(utilities.isShowMainRegion()){
            $state.go('buy-listings');
          } else {
            $state.go('buy-listings-multi-region',{country: $rootScope.geoLocation.country});
          }
        }
      }

      this.gotoStylePosts = function(){
        if(self.isOwnerOrAdmin){
          if ($state.params.otherUsername != null){
            if(utilities.isShowMainRegion()){
              $state.go('viewOtherUserStylePosts',{otherUsername:$state.params.otherUsername});
            } else {
              $state.go('viewOtherUserStylePosts-multi-region',{otherUsername:$state.params.otherUsername,country: $rootScope.geoLocation.country});
            }
          }else{
            if(utilities.isShowMainRegion()){
              $state.go('style-posts');
            } else {
              $state.go('style-posts-multi-region',{country: $rootScope.geoLocation.country});
            }
          }
        } else {
          if(utilities.isShowMainRegion()){
            $state.go('search', {min: CONFIG.PRICE_MIN, max: CONFIG.PRICE_MAX,type:CONFIG.DEFAULT_SEARCH_TYPE,sort:CONFIG.DEFAULT_SEARCH_SORT_ORDER});
          } else {
            $state.go('search', {min: CONFIG.PRICE_MIN, max: CONFIG.PRICE_MAX,type:CONFIG.DEFAULT_SEARCH_TYPE,sort:CONFIG.DEFAULT_SEARCH_SORT_ORDER,country: $rootScope.geoLocation.country});
          }
        }
      }

      this.isSelectedDeleted = function(){
        return $state.includes('deleted-listings') || $state.includes('deleted-listings-multi-region') || $state.includes('viewOtherUserDeletedListings') || $state.includes('viewOtherUserDeletedListings-multi-region');
      }

      this.gotoDeletedPosts = function(){
        if(self.isOwnerOrAdmin){
          if ($state.params.otherUsername != null){
            if(utilities.isShowMainRegion()){
              $state.go('viewOtherUserDeletedListings',{otherUsername:$state.params.otherUsername});
            } else {
              $state.go('viewOtherUserDeletedListings-multi-region',{otherUsername:$state.params.otherUsername,country: $rootScope.geoLocation.country});
            }
          }else{
            if(utilities.isShowMainRegion()){
              $state.go('deleted-listings');
            } else {
              $state.go('deleted-listings-multi-region',{country: $rootScope.geoLocation.country});
            }
          }
        } else {
          if(utilities.isShowMainRegion()){
            $state.go('search', {min: CONFIG.PRICE_MIN, max: CONFIG.PRICE_MAX,type:CONFIG.DEFAULT_SEARCH_TYPE,sort:CONFIG.DEFAULT_SEARCH_SORT_ORDER});
          } else {
            $state.go('search', {min: CONFIG.PRICE_MIN, max: CONFIG.PRICE_MAX,type:CONFIG.DEFAULT_SEARCH_TYPE,sort:CONFIG.DEFAULT_SEARCH_SORT_ORDER,country: $rootScope.geoLocation.country});
          }
        }
      }
  }]
})

'use strict';
angular.module('coutureApp')
  .component('salesChannel', {
    templateUrl: 'scripts/components/profile/components/sales-channel/sales-channel.html',
    controllerAs : 'salesChannelCtrl',
    controller: ["$scope", "$state", "$log", "$rootScope", "AuthService", "USER_ROLES", "utilities", "CONFIG", "UserService", function($scope,$state,$log,$rootScope,AuthService,USER_ROLES,utilities,CONFIG, UserService) {

      var self = this;

      this.$onInit = function(){
        $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - salesChannelCtrl"):'';
        self.australiaStoreEnabled = $rootScope.isLogon && $rootScope.user ? $rootScope.user.australiaStoreEnabled : false;

      }

      this.updateAustrliaOnlineStore = function (australiaOnlineStore){
        UserService.updateSalesChannel(australiaOnlineStore).$promise.then(
          function(resp) {
            self.australiaStoreEnabled = australiaOnlineStore;
        },function(err){
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":myAccount:updateAustrliaOnlineStore - Update user profile error"):'';
        })
      }

  }]
})

'use strict';
angular.module('coutureApp')
  .component('myRentals', {
    controllerAs : 'myRentalsCtrl',
    templateUrl: 'scripts/components/my-rentals/my-rentals.html',
    controller: ["$scope", "$rootScope", "$state", "DialogAlertService", "RentalService", "CONFIG", "UserService", "ListingService", "RefDataService", "utilities", "usSpinnerService", "$log", "dateUtilities", "$filter", "priceUtilities", "BuyService", function($scope, $rootScope, $state, DialogAlertService, RentalService, CONFIG, UserService, ListingService,
      RefDataService, utilities, usSpinnerService, $log,dateUtilities,$filter,priceUtilities,BuyService) {

      var self = this;
      this.error_approval = null;
      this.error_pickupAddress = null;
			self.EARNING_FROM = CONFIG.EARNING_FROM;
			self.EARNING_TO = CONFIG.EARNING_TO;
      self.availableForRegion = utilities.isFunctionEnabled();

      //Logic is moved to merchant-transactions.component.js
      this.$onInit = function(){
        $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - myRentals"):'';
        if ($rootScope.isLogon){
          self.proudct_currency = priceUtilities.getCurrency();
          getBillingInfo();
        }
      };

      /////////////////////////////////////////
      //GET BILLING INFO
      /////////////////////////////////////////
      function getBillingInfo(){
        RentalService.preCheck().$promise.then(function(resp) {

          if (resp.pickupAddress === null){
            self.error_pickupAddress = $filter('translate')('GENERAL.ERROR.PAYMENT_OPTIONS_NOT_SETUP');
          }else{
            $scope.hasPaymentOptionsSetup = true;
          }
        }, function(err) {
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":myRentals:getBillingInfo - Error:" + err):'';
        });
      }

    }]
  })

'use strict';
angular.module('coutureApp')
  .component('myRentalsMenu', {
    templateUrl: 'scripts/components/my-rentals/components/my-rentals-menu.html',
    controllerAs : 'myRentalsMenuCtrl',
    controller: ["$scope", "$state", "$log", "$rootScope", "utilities", function($scope,$state,$log,$rootScope, utilities) {

      this.$onInit = function(){
        $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - myRentalsMenuCtrl"):'';
      }

      this.isOrderRequestsSelected = function(){
        return $state.includes('my-rentals') || $state.includes('my-rentals-multi-region');
      }
    
      this.goToOrderRequests = function(){
        if(utilities.isShowMainRegion()){
          $state.go('my-rentals');
        } else {
          $state.go('my-rentals-multi-region', {country: $rootScope.geoLocation.country});
        }
      }

      this.isDispatchingSelected = function(){
        return $state.includes('merchant-dispatching-orders') || $state.includes('merchant-dispatching-orders-multi-region');
      }
    
      this.goToDispatching = function(){
        if(utilities.isShowMainRegion()){
          $state.go('merchant-dispatching-orders');
        } else {
          $state.go('merchant-dispatching-orders-multi-region', {country: $rootScope.geoLocation.country});
        }
      }

      this.isRentalRequestsSelected = function(){
        return $state.includes('merchant-rental-orders') || $state.includes('merchant-rental-orders-multi-region');
      }
    
      this.goToRentalOrders = function(){
        if(utilities.isShowMainRegion()){
          $state.go('merchant-rental-orders');
        } else {
          $state.go('merchant-rental-orders-multi-region', {country: $rootScope.geoLocation.country});
        }
      }

      this.isBuyRequestsSelected = function(){
        return $state.includes('merchant-buy-orders') || $state.includes('merchant-buy-orders-multi-region');
      }
    
      this.goToBuyOrders = function(){
        if(utilities.isShowMainRegion()){
          $state.go('merchant-buy-orders');
        } else {
          $state.go('merchant-buy-orders-multi-region', {country: $rootScope.geoLocation.country});
        }
      }

      this.isAllOrdersSelected = function(){
        return $state.includes('merchant-all-orders') || $state.includes('merchant-all-orders-multi-region');
      }
    
      this.goToAllOrders = function(){
        if(utilities.isShowMainRegion()){
          $state.go('merchant-all-orders');
        } else {
          $state.go('merchant-all-orders-multi-region', {country: $rootScope.geoLocation.country});
        }
      }

      this.isAwaitingDispatchSelected = function(){
        return $state.includes('merchant-awaiting-dispatch') || $state.includes('merchant-awaiting-dispatch-multi-region');
      }
    
      this.goToAwaitingDispatch = function(){
        if(utilities.isShowMainRegion()){
          $state.go('merchant-awaiting-dispatch');
        } else {
          $state.go('merchant-awaiting-dispatch-multi-region', {country: $rootScope.geoLocation.country});
        }
      }

  }]
})

'use strict';
angular.module('coutureApp')
  .component('merchantTransactions', {
    controllerAs : 'merchantTransactionsCtrl',
    templateUrl: 'scripts/components/my-rentals/components/merchant-transactions.html',
    controller: ["$scope", "$rootScope", "$state", "DialogAlertService", "RentalService", "CONFIG", "UserService", "ListingService", "RefDataService", "utilities", "usSpinnerService", "$log", "dateUtilities", "$filter", "priceUtilities", "BuyService", "productStatus", "$uibModal", "TransactionService", "$q", function($scope, $rootScope, $state, DialogAlertService, RentalService, CONFIG, UserService, ListingService,
      RefDataService, utilities, usSpinnerService, $log,dateUtilities,$filter,priceUtilities,BuyService, productStatus,$uibModal, TransactionService, $q) {
        var self = this;
        this.testLocalTxn = false;
        this.rentalRequests = [];
        this.pendingItems = [];
        this.purchaseRequests = [];
        this.pendingPurchaseItems= [];
        this.combinedRequests = [];
        this.periodRented = 7;
        this.selectedPickupTime = [];
        $scope.hasPaymentOptionsSetup = false;
        this.product = {productID:null,approveTxn:null};
        this.error_approval = null;
        this.error_pickupAddress = null;
        self.EARNING_FROM = CONFIG.EARNING_FROM;
        self.EARNING_TO = CONFIG.EARNING_TO;
        $scope.params = {
          query: '',
          queryProducts: '',
          queryEarnings: '',
          queryStatus: '',
        };
        self.selected_shipping = null;

      self.isOrderRequestsSelected = function(){
        return $state.includes('my-rentals') || $state.includes('my-rentals-multi-region');
      }

      self.isDispatchingSelected = function(){
        return $state.includes('merchant-dispatching-orders') || $state.includes('merchant-dispatching-orders-multi-region');
      }

      self.isRentalRequestsSelected = function(){
        return $state.includes('merchant-rental-orders') || $state.includes('merchant-rental-orders-multi-region');
      }

      self.isBuyRequestsSelected = function(){
        return $state.includes('merchant-buy-orders') || $state.includes('merchant-buy-orders-multi-region');
      }

      self.isAllOrdersSelected = function(){
        return $state.includes('merchant-all-orders') || $state.includes('merchant-all-orders-multi-region');
      }

      self.isAwaitingDispatchSelected = function(){
        return $state.includes('merchant-awaiting-dispatch') || $state.includes('merchant-awaiting-dispatch-multi-region');
      }
    
      this.$onInit = function(){
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - merchantRentalTransactions"):'';
          if ($rootScope.isLogon){
            self.proudct_currency = priceUtilities.getCurrency();
            self.displayRental = true;
            self.displayPurchase = true;
            if(self.isAllOrdersSelected()){
              getAllPurchases();
              getAllRentals();
            } else if(self.isOrderRequestsSelected()) {
              getPendingRentals();
              getPendingPurchases();
            } else if(self.isRentalRequestsSelected()) {
              getAllRentals();
              self.displayPurchase = false;
            } else if(self.isBuyRequestsSelected()) {
              getAllPurchases();
              self.displayRental = false;
            }  else if(self.isDispatchingSelected()) {
              getAllPurchases();
              getAllRentals();
            }  else if(self.isAwaitingDispatchSelected()) {
              getAwaitingDispatchRentals();
              getAwaitingDispatchPurchases();
            }  else {
              getPendingRentals();
              self.displayPurchase = false;
            }
            getBillingInfo();
          }
      };
  
        //RENTAL ITEM STATUS IS LOCATED IN LISTINGSERVICE.
        //{1: "Pending", 2: "Approved", 4: "Rejected", 8: "Available", 16: "Rented", 32: "Deleted"}
  
        /////////////////////////////////////////
        //GET BILLING INFO
        /////////////////////////////////////////
        function getBillingInfo(){
          RentalService.preCheck().$promise.then(function(resp) {
            $scope.hasPickUpAddress = false;
            if(resp.pickupAddress){
              $scope.hasPickUpAddress = true;
            }
            if (resp.pickupAddress === null){
              self.error_pickupAddress = $filter('translate')('GENERAL.ERROR.PAYMENT_OPTIONS_NOT_SETUP');
            }else{
              $scope.hasPaymentOptionsSetup = true;
            }
          }, function(err) {
              $rootScope.enableLog ? $log.error($rootScope.UUID + ":myRentals:getBillingInfo - Error:" + err):'';
          });
        }
  
        /////////////////////////////////////////
        //RETRIEVE PICK UP ADDRESS CC-368 NO NEED FOR PICKUP ADDRESS
        /////////////////////////////////////////
        // function retrievePickupAddress(){
        //   UserService.retrievePickupAddressNoToken().$promise.then(function(resp) {
        //     if (resp.address.address1 === null){
        //       self.error_pickupAddress = $filter('translate')('GENERAL.ERROR.PAYMENT_OPTIONS_NOT_SETUP');
        //     }else{
        //       $scope.hasPaymentOptionsSetup = true;
        //     }
        //   }, function(err) {
        //     $rootScope.enableLog ? $log.error($rootScope.UUID + ":myRentals:retrievePickupAddress - Error:" + err.status):'';
        //   });
        // }
  
        /**************************
        //VIEW PRODUCT DETAILS
        **************************/
        this.viewDetails = function(product){
          var productBrand = utilities.getCustomBrandName(product);
          var urlSlug = utilities.getPrettyUrl(product.category.code, product.subCategory.code, productBrand, product.productLine);
          $state.go('listing', {id: product.id, urlSlug: urlSlug});
        };
  
        /**************************
        //CALLBACK FOR PICK A DELIVERY TIME
        **************************/
        function selectedPickupTimeCallback(selectedPickupTimeObject){
  
          //FOR FURTURE DATE
          // if (selectedPickupTimeObject){
            // var pickupTime = new Date(selectedPickupTimeObject.time);
            // $rootScope.enableLog ? $log.info($rootScope.UUID + "selectedPickupTimeCallback : " + pickupTime):'';
            //FOR FURTURE DATE
  
            $rootScope.enableLog ? $log.info($rootScope.UUID + ":myRentals:selectedPickupTimeCallback - Pick up address: " + JSON.stringify(self.pickupAddress)):'';
            $rootScope.enableLog ? $log.info($rootScope.UUID + ":myRentals:selectedPickupTimeCallback - refID: " + self.product.approveTxn.id):'';
            if (self.testLocalTxn){
              removePendingItemExcept(self.product,null);//selectedPickupTimeObject.time);
              self.error_approval = null;
              $rootScope.cc.rentalOrdersCount > 0 ? $rootScope.cc.rentalOrdersCount -=1 : '';
              DialogAlertService.confirmApproval('asdfsdf');
              // DialogAlertService.promptDialog('GENERAL.LABEL.COMPANY_SLOGAN', '', '', '', 'Ok', '', '', false);
            }else{
  
              usSpinnerService.spin('spinner');
  
              RentalService.approvalPending(self.product.approveTxn.id,self.product.approveTxn.rentalPeriod).$promise.then(function() {
                // removePendingItemExcept(self.product,selectedPickupTimeObject.time);
                self.error_approval = null;
                $rootScope.cc.rentalOrdersCount > 0 ? $rootScope.cc.rentalOrdersCount -=1 : '';
                $rootScope.cc.orderRequestsCount = $rootScope.cc.rentalOrdersCount + $rootScope.cc.buyOrdersCount;
                usSpinnerService.stop('spinner');
                DialogAlertService.promptDialog('Thank you, a confirmation e-mail will be sent to you shortly.', '', '', '', 'Ok', '', '', false);
                $state.reload();
              }, function(err) {
                usSpinnerService.stop('spinner');
                $rootScope.enableLog ? $log.error($rootScope.UUID + ":myRentals:selectedPickupTimeCallback - Error approvalPending: " + JSON.stringify(err)):'';
                self.error_approval = "Error: Please try again later.";
                DialogAlertService.promptDialog('Error: Approval rental request. Please try again later. ', '', '', '', 'Ok', '', '', false,'',"RED");
              });
            }
  
          //FOR FURTURE DATE
          // }else{
          //   self.product.approveTxn = null;
          // }
          //FOR FURTURE DATE
        }
  
        /**************************
        //CALLBACK FOR TIMER ENDED, REMOVE THE EXPIRED ITEM IN THE LIST
        **************************/
        this.timeEnded = function(rentalItem,expireTxn){
          removeExpiredItem(rentalItem,expireTxn);
          $scope.$apply();
        };
  
        /**************************
        //RETURN REMAINS TIME FOR APPROVAL
        **************************/
        self.getRemainsTimeForApproval = function(product,rentalItem){
  
          if (!product.instantRental){
          //REQUEST EXPIRE IN 24HRS FROM THE TIME REQUEST SUBMITTED
            var expireTime = new Date(rentalItem.creationDate + (1 * 24 * 60 * 60 * 1000));
            var remains = (expireTime.getTime()/1000).toFixed() - ((Date.now())/1000).toFixed();
            return remains > 0 ? remains : 0;
          }else{
            return 0;
          }
        };
  
        /**************************
        //RENTER RENTAL HISTORY
        **************************/
        this.getEarningAmount = function(periodFee){
          return priceUtilities.getEarning(periodFee);
        }
  
        /**************************
        //RETURN A RENTAL PERIOD STRING
        **************************/
        self.getRentalPeriodString = function (txn){
          moment.tz.setDefault('UTC');
          var s= moment(txn.rentalPeriod.startDate).format('DD MMM YY') + " - " + moment(txn.rentalPeriod.endDate).format('DD MMM YY');
          return s;
        };
  
        /**************************
        //GET A LIST OF PRODUCT PENDING OWNER'S APPROVAL
        **************************/
        function getPendingRentals(){
          usSpinnerService.spin('spinner');
          RentalService.pendingApprovalV2().$promise.then(function(resp) {
            $rootScope.enableLog ? $log.info($rootScope.UUID + ":myRentals:getPendingRentals - My pending: " + JSON.stringify(resp)):'';
  
            //REMOVE THE COUNT FOR INSTANT RENTAL MANUALLY. IN DAY 2 WILL ADD REQUEST RETURN OF ITEM
            resp.forEach(function(rental){
              //moved to calculate backend var earnings = calculateEarnings(rental.rentalCredit, rental.country )
              var status = productStatus.getRentalStatusDisplay(rental.status);
              rental._brandName = rental.product.brandName;
              rental._customerUsername = rental.renterDTO.username;
              rental._rentalPeriod = self.getRentalPeriodString(rental);
              rental._earnings = priceUtilities.formatWithCountryCode(rental.earnings, rental.country);
              rental._productID = rental.product.id + "-" + rental.productItem.id;
              rental._purchasePrice = rental.country + priceUtilities.getConvertedAmount(rental.product.price, rental.country, rental.exchangeRate);
              rental._productQry = rental.product.brandName  + "" + rental.productItem.size + "" + rental.product.color + "" + rental._purchasePrice + "" + rental._productID;
              rental._earningsQry = rental._rentalPeriod + rental._earnings;
              rental._statusQry = CONFIG.TRANSACTION_TYPE_RENT + status + rental.renterDTO.username + rental.id + rental.rentalReferenceNumber;
              rental._statusName = status;
              rental._transactionType = CONFIG.TRANSACTION_TYPE_RENT;
              rental._overallQry = rental._productQry + rental._earningsQry + rental._statusQry;
              //todo how to get timer value
  
              if (!rental.instantRental) {
                self.pendingItems.push(rental);
              }
            });
  
            $rootScope.cc.rentalOrdersCount = self.pendingItems.length;
            $rootScope.cc.orderRequestsCount = $rootScope.cc.rentalOrdersCount + $rootScope.cc.buyOrdersCount;
            self.rentalRequests = self.pendingItems;
            self.combinedRequests.push(...self.rentalRequests);
  
            usSpinnerService.stop('spinner');
          }, function(err) {
            usSpinnerService.stop('spinner');
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":myRentals:getPendingRentals - Error: " + err.status):'';
          });
        }
  
        function getPendingPurchases(){
          usSpinnerService.spin('spinner');
          BuyService.getPendingBuyRequests().$promise.then(function(resp) {
            resp.forEach(function(purchase){
              $rootScope.enableLog ? $log.info($rootScope.UUID + ":myRentals:getPendingPurchases - My pending: " + JSON.stringify(resp)):'';
  
                var purchaseDate = moment(purchase.datePurchased).format('DD MMM YY');
                purchase._purchasedDate = purchaseDate;
                purchase._earnings = priceUtilities.formatWithCountryCode(purchase.earnings, purchase.country);
                purchase._productID = purchase.product.id + "-" + purchase.item.id;
                purchase._purchasePrice = priceUtilities.formatWithCountryCode(purchase.purchasePrice, purchase.country);
                purchase._originalPrice = purchase.country + priceUtilities.getConvertedAmount(purchase.product.price, purchase.country, purchase.exchangeRate);
                purchase._productQry = purchase.product.brandName + "" + purchase.item.size + "" + purchase.product.color + "" + purchase._purchasePrice + "" + purchase._productID;
                purchase._earningsQry =  purchaseDate + purchase._purchasePrice;
                //todo how to get timer value
                purchase._statusQry = CONFIG.TRANSACTION_TYPE_BUY + purchase.customer.username + purchase.id + purchase.purchaseReferenceNumber;
                purchase._transactionType = CONFIG.TRANSACTION_TYPE_BUY;
                purchase._customerUsername = purchase.customer.username;
                purchase._overallQry = purchase._productQry + purchase._earningsQry + purchase._statusQry;
                purchase.groupByKey = "BUY" + purchase.checkoutReferenceNumber + purchase._customerUsername;
                self.pendingPurchaseItems.push(purchase);
              
            });
  
            $rootScope.cc.buyOrdersCount = self.pendingPurchaseItems.length;
            $rootScope.cc.orderRequestsCount = $rootScope.cc.rentalOrdersCount + $rootScope.cc.buyOrdersCount;

            self.purchaseRequests = self.pendingPurchaseItems;
            self.combinedRequests.push(...self.purchaseRequests);
            usSpinnerService.stop('spinner');
          }, function(err) {
            usSpinnerService.stop('spinner');
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":myRentals:getPendingPurchaseList - Error: " + err.status):'';
          });
        }
        /**************************
        //HISTORY
        **************************/
        function getAllRentals(){
          usSpinnerService.spin('spinner');
          RentalService.allRentalOrders().$promise.then(function(resp) {
            $rootScope.enableLog ? $log.info($rootScope.UUID + ":myRentals:getAllRentals - My pending: " + JSON.stringify(resp)):'';
  
            resp.forEach(function(rental){
              var status = productStatus.getRentalStatusDisplay(rental.status);
              var payout = rental.payoutDetails;
              var payoutStatus = payout ? productStatus.getPayoutStatus(payout.payoutStatus) : null;
              var payoutReceived = payout ? (payout.payoutStatus == 'SENT' ? payout.datePaid : null) : null;
              rental._payoutReceived = payoutReceived ? moment(payoutReceived).format('DD MMM YY') : null;
              rental._brandName = rental.product.brandName;
              rental._customerUsername = rental.renterDTO.username;
              rental._rentalPeriod = self.getRentalPeriodString(rental);
              rental._earnings = priceUtilities.formatWithCountryCode(rental.earnings, rental.country);
              rental._productID = rental.product.id + "-" + rental.productItem.id;
              rental._purchasePrice = rental.country + priceUtilities.getConvertedAmount(rental.product.price, rental.country, rental.exchangeRate);
              rental._productQry = rental.product.brandName  + "" + rental.productItem.size + "" + rental.product.color + "" + rental._purchasePrice + "" + rental._productID;
              rental._earningsQry = rental._rentalPeriod + rental._earnings;
              rental._statusName = rental.pendingPickup ? "Pending Pickup" : (payoutStatus ? payoutStatus : status);
              rental._statusQry = CONFIG.TRANSACTION_TYPE_RENT + rental._statusName + rental.renterDTO.username + rental.id+ rental.rentalReferenceNumber;
              rental._transactionType = CONFIG.TRANSACTION_TYPE_RENT;
              rental._overallQry = rental._productQry + rental._earningsQry + rental._statusQry;
              moment.tz.setDefault('UTC');
              var startDt = moment(rental.rentalPeriod.startDate).format('DDMMMYY');
              rental.sortKey = moment(rental.rentalPeriod.startDate).format('YYMMDD');
              rental.groupByKey = "RENT" + rental.checkoutReferenceNumber + rental._customerUsername + startDt;
  
              if(self.isDispatchingSelected()){
                if(rental.status == 2 || rental.status == 400 || rental.status == 410 || rental.status == 8) {
                  self.pendingItems.push(rental);
                }
              } else {
                self.pendingItems.push(rental);
              }
            });
  
            self.rentalRequests = self.pendingItems;
            self.combinedRequests.push(...self.rentalRequests);
  
            usSpinnerService.stop('spinner');
          }, function(err) {
            usSpinnerService.stop('spinner');
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":myRentals:getAllRentals - Error: " + err.status):'';
          });
        }
  
        function getAllPurchases(){
          usSpinnerService.spin('spinner');
          BuyService.getAllBuyOrders().$promise.then(function(resp) {
            $rootScope.enableLog ? $log.info($rootScope.UUID + ":myRentals:getAllPurchases - My pending: " + JSON.stringify(resp)):'';
  
            resp.forEach(function(purchase){
                var purchaseDate = moment(purchase.datePurchased).format('DD MMM YY');
                var status = productStatus.getPurchaseStatusDisplay(purchase.statusCode);
                var payout = purchase.payoutDetails;
                var payoutStatus = payout ? productStatus.getPayoutStatus(payout.payoutStatus) : null;
                var payoutReceived = payout ? (payout.payoutStatus == 'SENT' ? payout.datePaid : null) : null;
                purchase._payoutReceived = payoutReceived ? moment(payoutReceived).format('DD MMM YY') : null;
                purchase._purchasedDate = purchaseDate;
                purchase._earnings = priceUtilities.formatWithCountryCode(purchase.earnings, purchase.country);
                purchase._productID = purchase.product.id + "-" + purchase.item.id;
                purchase._purchasePrice = priceUtilities.formatWithCountryCode(purchase.purchasePrice, purchase.country);
                purchase._originalPrice = purchase.country + priceUtilities.getConvertedAmount(purchase.product.price, purchase.country, purchase.exchangeRate);
                purchase._productQry = purchase.product.brandName + "" + purchase.item.size + "" + purchase.product.color + "" + purchase._purchasePrice + "" + purchase._productID;
                purchase._earningsQry =  purchaseDate + purchase._purchasePrice;
                purchase._statusName = purchase.pendingPickup ? "Pending Pickup" : (payoutStatus ? payoutStatus : status);
                purchase._statusQry = CONFIG.TRANSACTION_TYPE_BUY + purchase.customer.username + purchase.id + purchase._statusName + purchase.purchaseReferenceNumber;
                purchase._transactionType = CONFIG.TRANSACTION_TYPE_BUY;
                purchase._customerUsername = purchase.customer.username;
                purchase._overallQry = purchase._productQry + purchase._earningsQry + purchase._statusQry;
                purchase.groupByKey = "BUY" + purchase.checkoutReferenceNumber + purchase._customerUsername;
                
                if(self.isDispatchingSelected()){
                  if(purchase.statusCode == 2 || purchase.statusCode == 400 || purchase.statusCode == 410 || purchase.statusCode == 8) {
                    self.pendingPurchaseItems.push(purchase);
                  }
                } else {
                  self.pendingPurchaseItems.push(purchase);
                }
              
            });
  
            $rootScope.cc.countBuyOrders = self.pendingPurchaseItems.length;
            self.purchaseRequests = self.pendingPurchaseItems;
            self.combinedRequests.push(...self.purchaseRequests);
            usSpinnerService.stop('spinner');
          }, function(err) {
            usSpinnerService.stop('spinner');
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":myRentals:getPendingPurchaseList - Error: " + err.status):'';
          });
        }
  
        /**************************
        //GET PICKUP TIME FOR DISPLAY PURPOSE
        **************************/
        this.showPickupTime = function(timestamp) {
          var showtime = null;
          if (timestamp) {
            var pickupTime = new Date(timestamp);
            showtime = "Pick up time - ";
            showtime += (utilities.days[pickupTime.getDay()] + " " + pickupTime.getDate() + "/" + (pickupTime.getMonth()+1));
            showtime += ", " + utilities.formatAPMP(pickupTime);
          }
          return showtime;
        };
  
        /**************************
        //DECLINE A RENTAL REQUEST
        **************************/
        this.declinePending = function(rentalItem) {
         if (self.testLocalTxn){
  
           outterFor: for (var index = 0; index < self.rentalRequests.length; index++) {
             innerFor: for (var subIndex = 0; subIndex < self.rentalRequests[index].pendingApprovalRentals.length; subIndex++) {
                if (rentalItem.id === self.rentalRequests[index].pendingApprovalRentals[subIndex].id) {
  
                  if (self.rentalRequests[index].pendingApprovalRentals.length === 1) {
                    self.rentalRequests.splice(index,1);
                  }else{
                     self.rentalRequests[index].pendingApprovalRentals.splice(subIndex,1);
                  }
                  break outterFor;
                }
             }
           }
          }else{
            usSpinnerService.spin('spinner');
            RentalService.declinePending(rentalItem.id).$promise.then(function() {
              usSpinnerService.stop('spinner');
              self.error_approval = null;
              $rootScope.enableLog ? $log.info($rootScope.UUID + ":myRentals:declinePending - Successful: "):'';
              $state.reload();
            }, function(err) {
              usSpinnerService.stop('spinner');
              $rootScope.enableLog ? $log.error($rootScope.UUID + ":myRentals:declinePending - Error: " + JSON.stringify(err)):'';
              self.error_approval = "Error: Please try again later.";
              DialogAlertService.promptDialog('Error: Rejecting rental request. Please try again later. ', '', '', '', 'Ok', '', '', false,'',"RED");
            });
          }
        };

        /**************************
        //DECLINE A BUY REQUEST
        **************************/
        this.declineBuyRequest = function(item) {
          usSpinnerService.spin('spinner');
             BuyService.declineRequest(item.id).$promise.then(function() {
               usSpinnerService.stop('spinner');
               self.error_approval = null;
               $rootScope.enableLog ? $log.info($rootScope.UUID + ":myRentals:declineBuyRequest - Successful: "):'';
               $state.reload();
             }, function(err) {
               usSpinnerService.stop('spinner');
               $rootScope.enableLog ? $log.error($rootScope.UUID + ":myRentals:declineBuyRequest - Error: " + JSON.stringify(err)):'';
               self.error_approval = "Error: Please try again later.";
               DialogAlertService.promptDialog('Error: Rejecting buy request. Please try again later. ', '', '', '', 'Ok', '', '', false,'',"RED");
             });
         };
  
        /**************************
        //ACCEPT A RENTAL REQUEST
        **************************/
        this.approvalPending = function(product,renterTxn) {
            self.product.productID = product.id;
            self.product.approveTxn = renterTxn;
            selectedPickupTimeCallback();           
        };


        this.selectRentalShippingOption = function(product,renterTxn) {
          var modalInstance = $uibModal.open({
            templateUrl: 'views/modals/shipping-options.html',
            controller: ["$scope", "$rootScope", function($scope, $rootScope) {
              var self = this;
              $scope.enableApprove = false;
              var merchant;
              var customer;
              RentalService.retrieveMerchantToCustomerAddress(renterTxn.id).$promise.then(
                function(resp) {
                  if(resp.pickupAddressDTO) {
                    merchant = resp.pickupAddressDTO.address1 
                    + (resp.pickupAddressDTO.address2 ? ", " + resp.pickupAddressDTO.address2 : "")
                    + (resp.pickupAddressDTO.city ? ", " + resp.pickupAddressDTO.city : "")
                    + (resp.pickupAddressDTO.district ? ", " + resp.pickupAddressDTO.district : "")
                    + (resp.pickupAddressDTO.country ? ", " + resp.pickupAddressDTO.country : "")
                    + (resp.pickupAddressDTO.postalCode ? ", " + resp.pickupAddressDTO.postalCode : "");
                  }
                  if(resp.shippingAddressDTO) {
                    customer = resp.shippingAddressDTO.address1 
                    + (resp.shippingAddressDTO.address2 ? ", " + resp.shippingAddressDTO.address2 : "")
                    + (resp.shippingAddressDTO.city ? ", " + resp.shippingAddressDTO.city : "")
                    + (resp.shippingAddressDTO.district ? ", " + resp.shippingAddressDTO.district : "")
                    + (resp.shippingAddressDTO.country ? ", " + resp.shippingAddressDTO.country : "")
                    + (resp.shippingAddressDTO.postalCode ? ", " + resp.shippingAddressDTO.postalCode : "");
                  }
                  $scope.merchantPickupAddress = merchant ? merchant : "Please provide your pickup address.";
                  $scope.customerShippingAddress = customer ? customer : "No shipping address provided.";
              });


              $scope.setShippingOption = function(option){
                self.selected_shipping = option;
                $scope.enableApprove = self.selected_shipping != null;// && $scope.merchantPickupAddress && $scope.customerShippingAddress;
              }
            }]
          });
    
          
        }
        /**************************
        //ACCEPT A BUY REQUEST
        **************************/
        this.approveBuyRequest = function(item) {
            usSpinnerService.spin('spinner');
            BuyService.approveRequest(item.id).$promise.then(function() {
              self.error_approval = null;
              $rootScope.cc.buyOrdersCount > 0 ? $rootScope.cc.buyOrdersCount -=1 : '';
              $rootScope.cc.orderRequestsCount = $rootScope.cc.rentalOrdersCount + $rootScope.cc.buyOrdersCount;
              usSpinnerService.stop('spinner');
              DialogAlertService.promptDialog('Thank you, a confirmation e-mail will be sent to you shortly.', '', '', '', 'Ok', '', '', false);
              $state.reload();
            }, function(err) {
              usSpinnerService.stop('spinner');
              $rootScope.enableLog ? $log.error($rootScope.UUID + ":myRentals:approveBuyRequest - Error approveBuyRequest: " + JSON.stringify(err)):'';
              self.error_approval = "Error: Please try again later.";
              DialogAlertService.promptDialog('Error: Approval buy request. Please try again later. ', '', '', '', 'Ok', '', '', false,'',"RED");
            });
        };
  
        /**************************
        //REMOVE THE ITEM ALREADY EXPRIED FROM THE LIST
        **************************/
        function removeExpiredItem(rentalProduct, timeoutTxn){
  
          var expiredTxn = {productID:null,approveTxn:null};
          expiredTxn.productID = rentalProduct.id;
          expiredTxn.approveTxn = timeoutTxn;
          removePendingItemExcept(expiredTxn,null);
        }
  
  
        /**************************
        //REMOVE THE PENDING RENTAL ITEM IN THE LIST, OR REMOVE ALL ITEM IN THE LIST EXCEPT THE SPECIFIC ONE REMAINS
        **************************/
        function removePendingItemExcept(selectedTxn,selectedPickupTime){
  
          var productIndex = null;
          var approveTxnIndex = null;
          var selectedItem = {};
          for (var mainCounter = 0; mainCounter < self.rentalRequests.length; mainCounter++) {
  
            if (self.rentalRequests[mainCounter].id === selectedTxn.productID){
              for (var subCounter = 0; subCounter < self.rentalRequests[mainCounter].pendingApprovalRentals.length; subCounter++) {
                if (self.rentalRequests[mainCounter].pendingApprovalRentals[subCounter].id === selectedTxn.approveTxn.id && selectedPickupTime != null){
                  //KEEP THE SELECTED ITEM
                  self.rentalRequests[mainCounter].pendingApprovalRentals[subCounter].dateRented = selectedPickupTime;
                  selectedItem = angular.copy(self.rentalRequests[mainCounter].pendingApprovalRentals[subCounter]);
                  break;
                }else if (self.rentalRequests[mainCounter].pendingApprovalRentals[subCounter].id === selectedTxn.approveTxn.id && selectedPickupTime === null){
                  //REMOVE THE SELECTED ITEM
                  $rootScope.enableLog ? $log.info($rootScope.UUID + ":myRentals:removePendingItemExcept - BEFORE THE SELECTED ITEM: " + JSON.stringify(self.rentalRequests[mainCounter].pendingApprovalRentals)):'';
                  self.rentalRequests[mainCounter].pendingApprovalRentals.splice(subCounter,1);
                  var tempArray = angular.copy(self.rentalRequests[mainCounter].pendingApprovalRentals);
                  $rootScope.enableLog ? $log.info($rootScope.UUID + ":myRentals:declinePending - AFTER THE SELECTED ITEM: " + JSON.stringify(self.rentalRequests[mainCounter].pendingApprovalRentals)):'';
                  self.rentalRequests[mainCounter].pendingApprovalRentals = tempArray;
                  break;
                }
              }
              if (selectedPickupTime != null){
                delete self.rentalRequests[mainCounter].pendingApprovalRentals;
                self.rentalRequests[mainCounter].pendingApprovalRentals = [selectedItem];
              }
              break;
            }
          }
        }
  
        $scope.$watch('params', function() {
          //default with current list
          self.rentalRequests = self.pendingItems;
          self.purchaseRequests = self.pendingPurchaseItems;
  
          if ($scope.params.queryProducts){
            self.purchaseRequests = $filter('filter')(self.purchaseRequests,{_productQry:$scope.params.queryProducts});
            self.rentalRequests = $filter('filter')(self.rentalRequests,{_productQry:$scope.params.queryProducts});
          }
          if ($scope.params.queryEarnings){
            self.purchaseRequests = $filter('filter')(self.purchaseRequests,{_earningsQry:$scope.params.queryEarnings});
            self.rentalRequests = $filter('filter')(self.rentalRequests,{_earningsQry:$scope.params.queryEarnings});
          }
          if ($scope.params.queryStatus){
            self.purchaseRequests = $filter('filter')(self.purchaseRequests,{_statusQry:$scope.params.queryStatus});
            self.rentalRequests = $filter('filter')(self.rentalRequests,{_statusQry:$scope.params.queryStatus});
          }
          if ($scope.params.query){
            self.purchaseRequests = $filter('filter')(self.purchaseRequests,{_overallQry:$scope.params.query});
            self.rentalRequests = $filter('filter')(self.rentalRequests,{_overallQry:$scope.params.query});
          }

          self.combinedRequests= [];
          self.combinedRequests.push(...self.rentalRequests);
          self.combinedRequests.push(...self.purchaseRequests);

        }, true);

        function getSortOptions() {
            return [
              {KEY:"-creationDate",VALUE:"Latest"},
              {KEY:"-_productID",VALUE:"Product ID"},
              {KEY:"-_purchasePrice",VALUE:"Purchase Price"},
            ]
        }

        function getProductSortOptions() {
            return [
              {KEY:"-_productID",VALUE:"Product ID"},
              {KEY:"-_purchasePrice",VALUE:"Purchase Price"},
            ]
        }

        function getStatusSortOptions() {
            return [
              {KEY:"-creationDate",VALUE:"Latest"},
              {KEY:"-_customerUsername",VALUE:"Username"},
              {KEY:"-creationDate",VALUE:"Expires in"},
            ]
        }

        function getEarningsSortOptions() {
            return [
              {KEY:"-_earnings",VALUE:"Earnings"},
            ]
        }
      
      self.sortByList = getSortOptions();
      self.sortByProductQry = getProductSortOptions();
      self.sortByStatusQry = getStatusSortOptions();
      self.sortByEarningsQry = getEarningsSortOptions();

      //default
      $scope.params.sortBy = self.sortByList.filter(p => p.KEY == "-creationDate")[0];
      $scope.sortProduct = function(sortBy) {
        $scope.params.sortBy = sortBy;
      };

      function calculateEarnings(credits, currency) {
        return priceUtilities.calculateEarningsByCurrency(credits, currency);
      }
      function getAwaitingDispatchPurchases(){
        usSpinnerService.spin('spinner');
        BuyService.getAwaitingDispatchPurchases().$promise.then(function(resp) {
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":myRentals:getAwaitingDispatchPurchases - My pending: " + JSON.stringify(resp)):'';

          resp.forEach(function(purchase){
              var purchaseDate = moment(purchase.datePurchased).format('DD MMM YY');
              var status = productStatus.getPurchaseStatusDisplay(purchase.statusCode);
              purchase._purchasedDate = purchaseDate;
              purchase._earnings = purchase.country + priceUtilities.currencyFormat(Math.round(purchase.purchasePrice));
              purchase._productID = purchase.product.id + "-" + purchase.item.id;
              purchase._purchasePrice = priceUtilities.formatWithCountryCode(purchase.purchasePrice, purchase.country);
              purchase._originalPrice = purchase.country + priceUtilities.getConvertedAmount(purchase.product.price, purchase.country, purchase.exchangeRate);
              purchase._productQry = purchase.product.brandName + "" + purchase.item.size + "" + purchase.product.color + "" + purchase._purchasePrice + "" + purchase._productID;
              purchase._earningsQry =  purchaseDate + purchase._purchasePrice;
              //todo how to get timer value
              purchase._statusQry = CONFIG.TRANSACTION_TYPE_BUY + purchase.customer.username + purchase.id + status + purchase.purchaseReferenceNumber;
              purchase._transactionType = CONFIG.TRANSACTION_TYPE_BUY;
              purchase._customerUsername = purchase.customer.username;
              purchase._statusName = purchase.pendingPickup ? "Pending Pickup" : status;
              purchase._overallQry = purchase._productQry + purchase._earningsQry + purchase._statusQry;
              purchase.groupByKey = "BUY" + purchase.checkoutReferenceNumber + purchase._customerUsername;
              
              if(self.isDispatchingSelected()){
                if(purchase.statusCode == 2 || purchase.statusCode == 400 || purchase.statusCode == 410 || purchase.statusCode == 8) {
                  self.pendingPurchaseItems.push(purchase);
                }
              } else {
                self.pendingPurchaseItems.push(purchase);
              }
            
          });

          $rootScope.cc.countBuyOrders = self.pendingPurchaseItems.length;
          self.purchaseRequests = self.pendingPurchaseItems;
          self.combinedRequests.push(...self.purchaseRequests);
          usSpinnerService.stop('spinner');
        }, function(err) {
          usSpinnerService.stop('spinner');
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":myRentals:getAwaitingDispatchPurchases - Error: " + err.status):'';
        });
      }
      function getAwaitingDispatchRentals(){
        usSpinnerService.spin('spinner');
        RentalService.getAwaitingDispatchRentals().$promise.then(function(resp) {
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":myRentals:getAwaitingDispatchRentals - My pending: " + JSON.stringify(resp)):'';

          resp.forEach(function(rental){
            var earnings = calculateEarnings(rental.rentalCredit, rental.country )
            var status = productStatus.getRentalStatusDisplay(rental.status);

            rental._brandName = rental.product.brandName;
            rental._customerUsername = rental.renterDTO.username;
            rental._rentalPeriod = self.getRentalPeriodString(rental);
            rental._earnings = earnings;
            rental._productID = rental.product.id + "-" + rental.productItem.id;
            rental._purchasePrice = rental.country + priceUtilities.getConvertedAmount(rental.product.price, rental.country, rental.exchangeRate);
            rental._productQry = rental.product.brandName  + "" + rental.productItem.size + "" + rental.product.color + "" + rental._purchasePrice + "" + rental._productID;
            rental._earningsQry = rental._rentalPeriod + rental._earnings;
            rental._statusQry = CONFIG.TRANSACTION_TYPE_RENT + status + rental.renterDTO.username + rental.id+ rental.rentalReferenceNumber;
            rental._statusName = rental.pendingPickup ? "Pending Pickup" : status;
            rental._transactionType = CONFIG.TRANSACTION_TYPE_RENT;
            rental._overallQry = rental._productQry + rental._earningsQry + rental._statusQry;
            moment.tz.setDefault('UTC');
            var startDt = moment(rental.rentalPeriod.startDate).format('DDMMMYY');
            rental.sortKey = moment(rental.rentalPeriod.startDate).format('YYMMDD');
            rental.groupByKey = "RENT" + rental.checkoutReferenceNumber + rental._customerUsername + startDt;

            self.pendingItems.push(rental);
          });

          self.rentalRequests = self.pendingItems;
          self.combinedRequests.push(...self.rentalRequests);

          usSpinnerService.stop('spinner');
        }, function(err) {
          usSpinnerService.stop('spinner');
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":myRentals:getAwaitingDispatchRentals - Error: " + err.status):'';
        });
      }

      this.showDispatchConfirmation = function(groupByKey, transactionType) {
        var transactionDetails = self.combinedRequests.filter(r => r.groupByKey == groupByKey);
        var orderReference = [];
        var transactions = [];
        var checkoutReferenceNumber;
        if(transactionDetails) {
          transactionDetails.forEach(function(transaction){
            transaction._weight = 0.5;
            transaction._commodityCode = null;
            if(transactionType == CONFIG.TRANSACTION_TYPE_RENT){
              orderReference.push(transaction.id);
              transactions.push(transaction);
            } else {
              orderReference.push(transaction.id);
              transactions.push(transaction);
            }
            checkoutReferenceNumber = transaction.checkoutReferenceNumber;
          });
        }

        if(transactionType == CONFIG.TRANSACTION_TYPE_RENT){
          this.loadRentalDispatch(orderReference, transactionType, checkoutReferenceNumber, transactions);
        } else {
          this.loadBuyDispatch(orderReference, transactionType, checkoutReferenceNumber, transactions);
        }
        
      }

      this.loadRentalDispatch = function(orderReference, transactionType, checkoutReferenceNumber, transactions) {
        var merchantCtry;
        var customerCtry;
        RentalService.retrieveMerchantToCustomerAddress(orderReference[0]).$promise.then(
          function(resp) {
            if(resp.pickupAddressDTO) {
              merchantCtry = resp.pickupAddressDTO.country
            }
            if(resp.shippingAddressDTO) {
              customerCtry = resp.shippingAddressDTO.country
            }
            
            if(merchantCtry == customerCtry){
              $scope.merchantSelfDispatchConfirmation(orderReference, transactionType, checkoutReferenceNumber, transactions);
            } else {
              if($rootScope.user.dispatchType == "SC_COLLECT") {
                $scope.merchantDispatchConfirmation(orderReference, transactionType, checkoutReferenceNumber, transactions);
              } else {
                $scope.merchantSelfDispatchConfirmation(orderReference, transactionType, checkoutReferenceNumber, transactions);
              }
            }

        });
      }

      this.loadBuyDispatch = function(orderReference, transactionType, checkoutReferenceNumber, transactions) {
        var merchantCtry;
        var customerCtry;
        BuyService.retrieveMerchantToCustomerAddress(orderReference[0]).$promise.then(
          function(resp) {
            if(resp.pickupAddressDTO) {
              merchantCtry = resp.pickupAddressDTO.country
            }
            if(resp.shippingAddressDTO) {
              customerCtry = resp.shippingAddressDTO.country
            }
            
            if(merchantCtry == customerCtry){
              $scope.merchantSelfDispatchConfirmation(orderReference, transactionType, checkoutReferenceNumber, transactions);
            } else {
              if($rootScope.user.dispatchType == "SC_COLLECT") {
                $scope.merchantDispatchConfirmation(orderReference, transactionType, checkoutReferenceNumber, transactions);
              } else {
                $scope.merchantSelfDispatchConfirmation(orderReference, transactionType, checkoutReferenceNumber, transactions);
              }
            }

        });
      }

      $scope.merchantDispatchConfirmation = function(orderReference, transactionType, checkoutReferenceNumber, transactions) {
        var modalInstance = $uibModal.open({
          templateUrl:'views/modals/dispatch-confirmation.html',
          backdrop:false,
          keyboard:false,
          controller: ["$scope", "$rootScope", "$log", "usSpinnerService", "CONFIG", "ShippingService", "$state", "utilities", function($scope, $rootScope, $log, usSpinnerService, CONFIG, ShippingService, $state, utilities) {
            const local_timezone = moment.tz.guess();
            var self = this;
            var today = new Date();
            $scope.isSelfDispatch = false;

            //var dateNow = new Date(moment(today).format('YYYY-MM-DDTHH:mmZ'));
            //var currentHH = moment.tz(today,$rootScope.ServerTimezone).format('HH');
            //var nextDay = currentHH > 18 ? 1 : 0; //16 = default shop close 18hh gmt - 120mins pickup window
            //dateNow = new Date(moment.tz(today,local_timezone).add(nextDay, 'day').startOf('day').add(9, 'hour').format('YYYY-MM-DDTHH:mmZ'));
            //$scope.minDate = moment(today).startOf('day').format('YYYY-MM-DDTHH:mm');
            //$scope.maxDate = moment(today).startOf('day').add(9, 'day').format('YYYY-MM-DDTHH:mm');
            $scope.dispatchDetails = {};
            $scope.dispatchDetails.plannedShippingDateAndTime = null;
            $scope.dispatchDetails.weight = CONFIG.PARCEL_WEIGHT;
            $scope.dispatchDetails.length = CONFIG.PARCEL_LENGTH;
            $scope.dispatchDetails.height = CONFIG.PARCEL_HEIGHT;
            $scope.dispatchDetails.width = CONFIG.PARCEL_WIDTH;
            $scope.dispatchDetails.merchantTimezone = local_timezone;
            $scope.isSubmitted = false;
            $scope.isProcessing = false;
            $scope.isAllowDispatch = false;
            $scope.isValid = true;
            $scope.express = {};
            //$scope.express.pickupEarliest = "09:00:00";
            //$scope.express.pickupLatest = "18:00:00";
            $scope.tempDates = [];
            $scope.pickupDates = [];
            $scope.transactions = transactions;
            $scope.selected_id = null;
            calculateWeight();
            $scope.tempPickupDates = [];
            var tempDate = {
              timeRange : [1, 2, 3]
            };
            $scope.tempPickupDates.push(tempDate);
            $scope.tempPickupDates.push(tempDate);
            $scope.tempPickupDates.push(tempDate);

            var currentDate = new Date(moment.tz(today,local_timezone).format('YYYY-MM-DDTHH:mmZ'));
            var currentDateAt18hh = new Date(moment.tz(today,local_timezone).format('YYYY-MM-DDT18:00Z'));
            var currentHour = moment.tz(currentDate,local_timezone).format('HH');
            var currentHourTime = moment.tz(currentDate,local_timezone).format('HH:mm:00');
            var nextDay = moment(currentDate).isSameOrAfter(moment(currentDateAt18hh)) ? 1 : 0; //18 = default shop close 20hh gmt - 120mins pickup window
            
            var promises = [];
            for(let i = nextDay; i <= 5; i++){
              var pickupDate = new Date(moment.tz(currentDate,local_timezone).add(i, 'day').format('YYYY-MM-DDTHH:mmZ'));
              
             
              self.ratesDetails = {};
              self.ratesDetails.checkoutReferenceNumber = checkoutReferenceNumber;
              self.ratesDetails.weight = $scope.dispatchDetails.weight
              self.ratesDetails.length = $scope.dispatchDetails.length;
              self.ratesDetails.height = $scope.dispatchDetails.height;
              self.ratesDetails.width = $scope.dispatchDetails.width;
              self.ratesDetails.plannedShippingDate = moment.tz(pickupDate,local_timezone).utc().format('YYYY-MM-DD');
              
              $scope.errorMsg = null;
              promises.push(ShippingService.retrieveRates(self.ratesDetails).$promise.then(function(resp) {
                if(resp){
                  var expresWorldWideNonDoc = resp.products.filter(p => p.productCode == "P")[0];
                  if(expresWorldWideNonDoc){
                  var localCutoffDateAndTime = expresWorldWideNonDoc.pickupCapabilities.localCutoffDateAndTime;
                  var pickupEarliest = expresWorldWideNonDoc.pickupCapabilities.pickupEarliest;
                  var pickupLatest = expresWorldWideNonDoc.pickupCapabilities.pickupLatest;
                  
                  var localcutoff = new Date(moment.tz(localCutoffDateAndTime,local_timezone).format('YYYY-MM-DDTHH:mmZ'));
                  var earliestTime = new Date(moment(localcutoff).format('YYYY-MM-DD') + " " + pickupEarliest);
                  var closeTime = new Date(moment(localcutoff).format('YYYY-MM-DD') + " " + "18:00:00");
                  var noonTime = new Date(moment(localcutoff).format('YYYY-MM-DD') + " " + "12:00:00");
                  var currentTime = new Date(moment(currentDate).format('YYYY-MM-DD HH:mm:00'));
                  var temp_latestTime = new Date(moment(localcutoff).format('YYYY-MM-DD') + " " + pickupLatest);
                  var latestTime = moment(closeTime).isSameOrAfter(moment(temp_latestTime)) ? temp_latestTime : closeTime;

                  //hold values
                  var holdEarliestTime = moment.tz(earliestTime,local_timezone).format('HH:mm');
                  var holdNoonTime = moment.tz(noonTime,local_timezone).format('HH:mm');
                  var holdLatestTime = moment.tz(latestTime,local_timezone).format('HH:mm');
                  var holdDatePlus30mins = new Date(moment.tz(localcutoff,local_timezone).add(30, 'minutes').format('YYYY-MM-DDTHH:mmZ'))

                  var isAfternoonAvailable = moment(closeTime).isSameOrAfter(moment(noonTime));
                  var isCurrentTimeBeforeEarliest = !moment(currentTime).isSameOrAfter(moment(earliestTime));
                  var isCurrentTimeBeforeLatest = !moment(currentTime).isSameOrAfter(moment(latestTime));
                  var isCurrentTimeBeforeNoon = !moment(currentTime).isSameOrAfter(moment(noonTime));

                  var availablePickupDate = {};
                  availablePickupDate.order = i;
                  availablePickupDate.date = localcutoff;
                  availablePickupDate.selected = false;
                  availablePickupDate.dateDay = moment.tz(localCutoffDateAndTime,local_timezone).format('dddd');
                  availablePickupDate.dateDate = moment.tz(localCutoffDateAndTime,local_timezone).format('MMMM DD');
                  availablePickupDate.timeRange = [];

                  
                  var morningSlot = {};
                  morningSlot.type = "AM";
                  morningSlot.order = 1;
                  morningSlot.display = false;
                  morningSlot.range = holdEarliestTime + " TO " + (isAfternoonAvailable ? holdNoonTime: holdLatestTime);
                  morningSlot.available = isCurrentTimeBeforeNoon;
                  morningSlot.selected = false;
                  morningSlot.closeTime = "14:00";
                  morningSlot.plannedShippingDateTime = isCurrentTimeBeforeEarliest ? earliestTime : holdDatePlus30mins;
                  morningSlot.id = i + "_AM";
                  availablePickupDate.timeRange.push(morningSlot);

                  
                  var afternoonSlot = {};
                  afternoonSlot.type = "PM";
                  afternoonSlot.order = 2;
                  afternoonSlot.display = false;
                  afternoonSlot.range = holdNoonTime + " TO " + holdLatestTime;
                  afternoonSlot.available = isCurrentTimeBeforeLatest && isAfternoonAvailable;
                  afternoonSlot.selected = false;
                  afternoonSlot.closeTime = "20:00";
                  afternoonSlot.plannedShippingDateTime = isCurrentTimeBeforeNoon ? noonTime : holdDatePlus30mins;
                  afternoonSlot.id = i + "_PM";
                  availablePickupDate.timeRange.push(afternoonSlot);

                  var fullSlot = {};
                  fullSlot.type = "";
                  fullSlot.order = 3;
                  fullSlot.display = true;
                  fullSlot.range = holdEarliestTime + " TO " + holdLatestTime;
                  fullSlot.available = isCurrentTimeBeforeLatest;
                  fullSlot.selected = false;
                  fullSlot.closeTime = "20:00";
                  fullSlot.plannedShippingDateTime = isCurrentTimeBeforeEarliest ? earliestTime : holdDatePlus30mins;
                  fullSlot.id = i + "_FULL";
                  availablePickupDate.timeRange.push(fullSlot);

                  availablePickupDate.localcutoff = localcutoff;
                  availablePickupDate.earliestTime = earliestTime;
                  availablePickupDate.latestTime = latestTime;
                  $scope.tempDates.push(availablePickupDate);

                } else {
                  $scope.errorMsg = "Unable to retrieve rates for domestic shipping.";
                }

                }
              },
              function(err) {
                $scope.errorMsg = null;
                  if(err.data) {
                    if(err.data.reasons){
                      switch (err.data.reasons[0].code) {
                        case "UNABLE_TO_RETRIEVE_RATES_420504":
                          $scope.isAllowDispatch = false;
                          $scope.errorMsg = "The origin location is invalid. Please check your pick-up address.";
                          break;
                        case "UNABLE_TO_RETRIEVE_RATES_420505":
                          $scope.isAllowDispatch = false;
                          $scope.errorMsg = "The destination location is invalid. Please check customer's shipping address.";
                          break;
                        case "UNABLE_TO_RETRIEVE_RATES_996":
                          $scope.isAllowDispatch = false;
                          $scope.errorMsg = null;//"Requested pick-up date and time is unavailable.";
                          break;
                        case "UNABLE_TO_RETRIEVE_RATES_Parameters not having correct format":
                          $scope.isAllowDispatch = false;
                          $scope.errorMsg = "Please verify your pick-up address and try again.";
                          break;
                        default:
                          $scope.isAllowDispatch = false;
                          $scope.errorMsg = "System Error - Please try again later.";
                          break;
                      }
                    };
                  }
                  $scope.isAllowDispatch = false;
                  //$rootScope.enableLog ? $log.error($rootScope.UUID + ":Retrieve Rates : error: " + JSON.stringify($scope.errorMsg)) : '';
              }));

              $q.all(promises).then(function() {
                if(promises.length > 3) {
                  $scope.pickupDates = angular.copy($scope.tempDates);
                  $scope.pickupDates.sort(function(a, b){return a.order-b.order;});
                }
              });

            } 

            $scope.selectDateTime = function (timeRange) {
              $scope.selected_id = timeRange.id;
              $scope.selected_plannedShippingDateAndTime = timeRange.plannedShippingDateTime;
              $scope.selected_closeTime = timeRange.closeTime;
              $scope.isAllowDispatch = true;
            }
  
            $scope.dispatchParcel = function () {
              if(self.isValid()){
              $scope.isProcessing = true;
              $scope.errorMsg = null;
              $scope.isSubmitted = true;
              usSpinnerService.spin('spinner');
              var shipmentDetails = {};
              shipmentDetails.plannedShippingDateAndTimeStr = moment.tz($scope.selected_plannedShippingDateAndTime,$rootScope.ServerTimezone).utc().format('YYYY-MM-DDTHH:mmZ');
              shipmentDetails.plannedShippingDateAndTimeDt = new Date(moment.tz($scope.selected_plannedShippingDateAndTime,$rootScope.ServerTimezone).utc());
              shipmentDetails.weight = $scope.dispatchDetails.weight
              shipmentDetails.length = $scope.dispatchDetails.length;
              shipmentDetails.height = $scope.dispatchDetails.height;
              shipmentDetails.width = $scope.dispatchDetails.width;
              shipmentDetails.merchantTimezone = local_timezone;
              shipmentDetails.transactionType = transactionType;
              shipmentDetails.orderID = orderReference;
              shipmentDetails.checkoutReferenceNumber = checkoutReferenceNumber;
              shipmentDetails.shipper = "MERCHANT";
              shipmentDetails.closeTime = $scope.selected_closeTime;
              shipmentDetails.exportDetails = [];

              $scope.transactions.forEach(function(transaction){
                var exportDetails = {};
                exportDetails.orderId = transaction.id;
                exportDetails.weight = transaction._weight;
                exportDetails.commodityCode = transaction._commodityCode;
                shipmentDetails.exportDetails.push(exportDetails);
              });
              
              ShippingService.createMerchantToCustomerShipment(shipmentDetails).$promise.then(function(resp) {
                $scope.isProcessing = false;
                $scope.errorMsg = null;
                usSpinnerService.stop('spinner');
                $scope.dispatchConfirmationNumber = resp.dispatchConfirmationNumber;
                $scope.shipmentTrackingNumber = resp.shipmentTrackingNumber;
                $scope.trackingUrl = CONFIG.DHL_TRACKING_URL+resp.shipmentTrackingNumber;
                
              },
              function(err) {
                $scope.isProcessing = false;
                $scope.isSubmitted = false;
                $scope.errorMsg = null;
                  if(err.data) {
                    if(err.data.reasons){
                      switch (err.data.reasons[0].code) {
                        case "UNABLE_TO_CREATE_SHIPMENT_420504":
                          $scope.isAllowDispatch = false;
                          $scope.errorMsg = "The origin location is invalid. Please check your pick-up address.";
                          break;
                        case "UNABLE_TO_CREATE_SHIPMENT_420505":
                          $scope.isAllowDispatch = false;
                          $scope.errorMsg = "The destination location is invalid. Please check customer's shipping address.";
                          break;
                        case "UNABLE_TO_CREATE_SHIPMENT_996":
                          $scope.isAllowDispatch = false;
                          $scope.errorMsg = "Requested pick-up date and time is unavailable.";
                          break;
                        case "UNABLE_TO_CREATE_SHIPMENT_5006":
                          $scope.isAllowDispatch = false;
                          $scope.errorMsg = "Requested pick-up date and time is unavailable.";
                          break;
                        case "UNABLE_TO_CREATE_SHIPMENT_5001":
                          $scope.isAllowDispatch = false;
                          $scope.errorMsg = "The pickup request is past the booking cutoff time for the pickup location (this includes taking the time zone into consideration if applicable).";
                          break;
                        case "UNABLE_TO_CREATE_SHIPMENT_5002":
                          $scope.isAllowDispatch = false;
                          $scope.errorMsg = "The Pickup time window for a collection to take place is too small (pickup location closing time minus collection time). The minimum pickup time window overlap for your requested origin is a minimum of '120' minutes.";
                          break;
                        case "UNABLE_TO_CREATE_SHIPMENT_5023":
                          $scope.isAllowDispatch = false;
                          $scope.errorMsg = "The Pickup Location Close Time cannot be earlier than Shipment Time.";
                          break;
                        case "UNABLE_TO_CREATE_SHIPMENT_5005":
                          $scope.isAllowDispatch = false;
                          $scope.errorMsg = err.data.reasons[0].message;
                          break;
                        default:
                          $scope.isAllowDispatch = true;
                          $scope.errorMsg = "System Error - Please contact support.";
                          break;
                      }
                    };
                  }
                usSpinnerService.stop('spinner');
                $rootScope.enableLog ? $log.error($rootScope.UUID + ":Dispatch Confirmation : error: " ) : '';
              });
                
              }
            }

            self.isValid = function() {
              var isValid = true;
              
              if ($scope.selected_plannedShippingDateAndTime == null) {
                isValid = false;
                $scope.error_date = 'Please select pickup date and time.';
              }
              
              if ($scope.dispatchDetails.weight == null || $scope.dispatchDetails.weight == 0) {
                isValid = false;
                $scope.error_weight = 'Please input weight (kg).';
              }

              if ($scope.dispatchDetails.height == null || $scope.dispatchDetails.height == 0) {
                isValid = false;
                $scope.error_height = 'Please input height (cm).';
              }

              if ($scope.dispatchDetails.width == null || $scope.dispatchDetails.width == 0) {
                isValid = false;
                $scope.error_width = 'Please input width (cm).';
              }

              if ($scope.dispatchDetails.length == null || $scope.dispatchDetails.length == 0) {
                isValid = false;
                $scope.error_length = 'Please input length (cm).';
              }

              var w = 0;
              $scope.transactions.forEach(function(transaction){
                if (transaction._weight == null || transaction._weight == 0) {
                  isValid = false;
                  $scope.eror_weight = 'Please input weight (kg).';
                } else {
                  w = w + transaction._weight;
                }
                if (transaction._commodityCode == null || transaction._commodityCode == 0) {
                  isValid = false;
                  $scope.eror_commodityCode= 'Please input commodity code.';
                }
              });

              if (w > $scope.dispatchDetails.weight) {
                isValid = false;
                $scope.error_weight = 'Please adjust total weight (kg).';
              }

              $scope.isValid = isValid;
              return isValid;
            }
  
            $scope.downloadLabel = function () {
              //to do add validation
              ShippingService.downloadLabel($scope.shipmentTrackingNumber).$promise.then(function(resp) {},
              function(err) {
                  $rootScope.enableLog ? $log.error($rootScope.UUID + ":Dispatch Confirmation : error: "  ) : '';
              });
            }
  
            $scope.closeDispatch = function() {
              this.$close();
              $state.reload();
            };

            $scope.viewDetails = function(product){
              var productBrand = utilities.getCustomBrandName(product);
              var urlSlug = utilities.getPrettyUrl(product.category.code, product.subCategory.code, productBrand, product.productLine);
              
              var url;
              if(utilities.isShowMainRegion()){
                url = $state.href('listing', {id: product.id, urlSlug: urlSlug});
              } else {
                url = $state.href('listing-multi-region', {id: product.id, urlSlug: urlSlug, country: $rootScope.geoLocation.country});
              }
              window.open(url,'_blank');
            };
  
            function calculateWeight() {
              var w = 0;
              $scope.transactions.forEach(function(transaction){
                if (transaction._weight) {
                  w = w + transaction._weight;
                }
              });

              $scope.dispatchDetails.weight = w;
            }

            $scope.calculateWeight = function(){
              calculateWeight();
            }

            /*$scope.$watch('dispatchDetails.plannedShippingDateAndTime', function() {
              retrieveRates();
            });*/
  
          }]
        });
      }

      $scope.merchantSelfDispatchConfirmation = function(orderReference, transactionType, checkoutReferenceNumber, transactions) {
        var modalInstance = $uibModal.open({
          templateUrl:'views/modals/dispatch-confirmation.html',
          backdrop:false,
          keyboard:false,
          controller: ["$scope", "$rootScope", "$log", "usSpinnerService", "CONFIG", "ShippingService", "$state", "utilities", function($scope, $rootScope, $log, usSpinnerService, CONFIG, ShippingService, $state, utilities) {
            const local_timezone = moment.tz.guess();
            var self = this;
            $scope.isSelfDispatch = true;
            $scope.selfDispatchMessage = "";
            $scope.isValid = true;
            $scope.isSubmitted = false;
            $scope.selfDispatchTrackingUrl = null;
            $scope.selfDispatchTrackingNumber = null;
            $scope.dispatchParcel = function () {
              if(self.isValid()){
                var shipmentDetails = {};
                shipmentDetails.transactionType = transactionType;
                shipmentDetails.orderID = orderReference;
                shipmentDetails.checkoutReferenceNumber= checkoutReferenceNumber;
                shipmentDetails.selfDispatchTrackingNumber = $scope.selfDispatchTrackingNumber;
                shipmentDetails.selfDispatchTrackingUrl = $scope.selfDispatchTrackingUrl;

                TransactionService.createSelfDispatch(shipmentDetails).$promise.then(function(resp) {
                  $scope.isSubmitted = true;
                  $scope.error_trackingNumber = null;
                  $scope.error_trackingUrl = null;
                  
                },
                function(err) {
                  $rootScope.enableLog ? $log.error($rootScope.UUID + ":Dispatch Confirmation : error: " ) : '';
                }
                );
              }
            }
  
            $scope.closeDispatch = function() {
              this.$close();
              $state.reload();
            };
  
            self.isValid = function() {
              var isValid = true;
              
              if ($scope.selfDispatchTrackingNumber == null) {
                isValid = false;
                $scope.error_trackingNumber = 'Please enter tracking number.';
              }
              
              if ($scope.selfDispatchTrackingUrl == null) {
                isValid = false;
                $scope.error_trackingUrl = 'Please enter tracking url.';
              }

              $scope.isValid = isValid;
              return isValid;
            }
          }]
        });
      }
  
}]
})

'use strict';
angular.module('coutureApp')
  .component('merchantAllOrders', {
    controllerAs : 'merchantAllOrdersCtrl',
    templateUrl: 'scripts/components/my-rentals/merchant-all-orders/merchant-all-orders.html',
    controller: ["$scope", "$rootScope", "$state", "DialogAlertService", "RentalService", "CONFIG", "UserService", "ListingService", "RefDataService", "utilities", "usSpinnerService", "$log", "dateUtilities", "$filter", "priceUtilities", "BuyService", "productStatus", function($scope, $rootScope, $state, DialogAlertService, RentalService, CONFIG, UserService, ListingService,
      RefDataService, utilities, usSpinnerService, $log,dateUtilities,$filter,priceUtilities,BuyService,productStatus) {

      var self = this;
      this.error_approval = null;
      this.error_pickupAddress = null;

      //Logic is moved to merchant-transactions.component.js
      this.$onInit = function(){
        $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - merchantAllOrders"):'';
        if ($rootScope.isLogon){
          self.proudct_currency = priceUtilities.getCurrency();
          getBillingInfo();
        }
      };

      /////////////////////////////////////////
      //GET BILLING INFO
      /////////////////////////////////////////
      function getBillingInfo(){
        RentalService.preCheck().$promise.then(function(resp) {
          $scope.hasPickUpAddress = false;
          if(resp.pickupAddress){
            $scope.hasPickUpAddress = true;
          }
          if (resp.pickupAddress === null){
            self.error_pickupAddress = $filter('translate')('GENERAL.ERROR.PAYMENT_OPTIONS_NOT_SETUP');
          }else{
            $scope.hasPaymentOptionsSetup = true;
          }
        }, function(err) {
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":myRentals:getBillingInfo - Error:" + err):'';
        });
      }
  
      }]
    })
  
'use strict';
angular.module('coutureApp')
  .component('merchantBuyOrders', {
    controllerAs : 'merchantBuyOrdersCtrl',
    templateUrl: 'scripts/components/my-rentals/merchant-buy-orders/merchant-buy-orders.html',
    controller: ["$scope", "$rootScope", "$state", "DialogAlertService", "RentalService", "CONFIG", "UserService", "ListingService", "RefDataService", "utilities", "usSpinnerService", "$log", "dateUtilities", "$filter", "priceUtilities", "BuyService", function($scope, $rootScope, $state, DialogAlertService, RentalService, CONFIG, UserService, ListingService,
      RefDataService, utilities, usSpinnerService, $log,dateUtilities,$filter,priceUtilities,BuyService) {

        var self = this;
        this.error_approval = null;
        this.error_pickupAddress = null;
  
        //Logic is moved to merchant-transactions.component.js
        this.$onInit = function(){
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - merchantBuyOrders"):'';
          if ($rootScope.isLogon){
            self.proudct_currency = priceUtilities.getCurrency();
            getBillingInfo();
          }
        };
  
        /////////////////////////////////////////
        //GET BILLING INFO
        /////////////////////////////////////////
        function getBillingInfo(){
          RentalService.preCheck().$promise.then(function(resp) {
            $scope.hasPickUpAddress = false;
            if(resp.pickupAddress){
              $scope.hasPickUpAddress = true;
            }
            if (resp.pickupAddress === null){
              self.error_pickupAddress = $filter('translate')('GENERAL.ERROR.PAYMENT_OPTIONS_NOT_SETUP');
            }else{
              $scope.hasPaymentOptionsSetup = true;
            }
          }, function(err) {
              $rootScope.enableLog ? $log.error($rootScope.UUID + ":myRentals:getBillingInfo - Error:" + err):'';
          });
        }
  
      }]
    })
  

'use strict';
angular.module('coutureApp')
  .component('merchantRentalOrders', {
    controllerAs : 'merchantRentalOrdersCtrl',
    templateUrl: 'scripts/components/my-rentals/merchant-rental-orders/merchant-rental-orders.html',
    controller: ["$scope", "$rootScope", "$state", "DialogAlertService", "RentalService", "CONFIG", "UserService", "ListingService", "RefDataService", "utilities", "usSpinnerService", "$log", "dateUtilities", "$filter", "priceUtilities", function($scope, $rootScope, $state, DialogAlertService, RentalService, CONFIG, UserService, ListingService,
      RefDataService, utilities, usSpinnerService, $log,dateUtilities,$filter,priceUtilities) {


        var self = this;
        this.error_approval = null;
        this.error_pickupAddress = null;
  
        //Logic is moved to merchant-transactions.component.js
        this.$onInit = function(){
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - merchantRentalOrders"):'';
          if ($rootScope.isLogon){
            self.proudct_currency = priceUtilities.getCurrency();
            getBillingInfo();
          }
        };
  
        /////////////////////////////////////////
        //GET BILLING INFO
        /////////////////////////////////////////
        function getBillingInfo(){
          RentalService.preCheck().$promise.then(function(resp) {
            $scope.hasPickUpAddress = false;
            if(resp.pickupAddress){
              $scope.hasPickUpAddress = true;
            }
            if (resp.pickupAddress === null){
              self.error_pickupAddress = $filter('translate')('GENERAL.ERROR.PAYMENT_OPTIONS_NOT_SETUP');
            }else{
              $scope.hasPaymentOptionsSetup = true;
            }
          }, function(err) {
              $rootScope.enableLog ? $log.error($rootScope.UUID + ":myRentals:getBillingInfo - Error:" + err):'';
          });
        }
  
      }]
    })

'use strict';
angular.module('coutureApp')
  .component('merchantAwaitingDispatch', {
    controllerAs : 'merchantAwaitingDispatchCtrl',
    templateUrl: 'scripts/components/my-rentals/merchant-awaiting-dispatch/merchant-awaiting-dispatch.html',
    controller: ["$scope", "$rootScope", "$state", "DialogAlertService", "RentalService", "CONFIG", "UserService", "ListingService", "RefDataService", "utilities", "usSpinnerService", "$log", "dateUtilities", "$filter", "priceUtilities", function($scope, $rootScope, $state, DialogAlertService, RentalService, CONFIG, UserService, ListingService,
      RefDataService, utilities, usSpinnerService, $log,dateUtilities,$filter,priceUtilities) {

        var self = this;
        this.error_approval = null;
        this.error_pickupAddress = null;
  
        //Logic is moved to merchant-transactions.component.js
        this.$onInit = function(){
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - merchantAwaitingDispatch"):'';
          if ($rootScope.isLogon){
            self.proudct_currency = priceUtilities.getCurrency();
            getBillingInfo();
          }
        };
  
        /////////////////////////////////////////
        //GET BILLING INFO
        /////////////////////////////////////////
        function getBillingInfo(){
          self.error_pickupAddress = null;
          RentalService.preCheck().$promise.then(function(resp) {
            $scope.hasPickUpAddress = false;
            if(resp.pickupAddress){
              $scope.hasPickUpAddress = true;
            }
            if (resp.pickupAddress === null){
              self.error_pickupAddress = $filter('translate')('GENERAL.ERROR.PAYMENT_OPTIONS_NOT_SETUP');
            }else{
              $scope.hasPaymentOptionsSetup = true;
            }
          }, function(err) {
              $rootScope.enableLog ? $log.error($rootScope.UUID + ":myRentals:getBillingInfo - Error:" + err):'';
          });
        }

    }]
  })


'use strict';
angular.module('coutureApp')
  .component('merchantDispatchingOrders', {
    controllerAs : 'merchantDispatchingOrdersCtrl',
    templateUrl: 'scripts/components/my-rentals/merchant-dispatching-orders/merchant-dispatching-orders.html',
    controller: ["$scope", "$rootScope", "$state", "DialogAlertService", "RentalService", "CONFIG", "UserService", "ListingService", "RefDataService", "utilities", "usSpinnerService", "$log", "dateUtilities", "$filter", "priceUtilities", function($scope, $rootScope, $state, DialogAlertService, RentalService, CONFIG, UserService, ListingService,
      RefDataService, utilities, usSpinnerService, $log,dateUtilities,$filter,priceUtilities) {

        var self = this;
        this.error_approval = null;
        this.error_pickupAddress = null;
  
        //Logic is moved to merchant-transactions.component.js
        this.$onInit = function(){
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - merchantDispatchingOrders"):'';
          if ($rootScope.isLogon){
            self.proudct_currency = priceUtilities.getCurrency();
            getBillingInfo();
          }
        };
  
        /////////////////////////////////////////
        //GET BILLING INFO
        /////////////////////////////////////////
        function getBillingInfo(){
          RentalService.preCheck().$promise.then(function(resp) {
            $scope.hasPickUpAddress = false;
            if(resp.pickupAddress){
              $scope.hasPickUpAddress = true;
            }
            if (resp.pickupAddress === null){
              self.error_pickupAddress = $filter('translate')('GENERAL.ERROR.PAYMENT_OPTIONS_NOT_SETUP');
            }else{
              $scope.hasPaymentOptionsSetup = true;
            }
          }, function(err) {
              $rootScope.enableLog ? $log.error($rootScope.UUID + ":myRentals:getBillingInfo - Error:" + err):'';
          });
        }

    }]
  })


'use strict';

angular.module('coutureApp')
  .component('orderHistory', {
    controllerAs : 'orderHistoryCtrl',
    templateUrl: 'scripts/components/order-history/order-history.html',
    controller: ["$scope", "$http", "RentalService", "envService", "utilities", "priceUtilities", "$state", "$rootScope", "$log", "$filter", "usSpinnerService", "ListingService", "productStatus", "RefDataService", "CONFIG", "$uibModal", "TransactionService", "DialogAlertService", "$translatePartialLoader", function($scope, $http,RentalService,envService,utilities,priceUtilities,$state,$rootScope, $log,$filter,
       usSpinnerService,ListingService,productStatus,RefDataService,CONFIG,$uibModal,TransactionService,DialogAlertService,$translatePartialLoader) {

      //DEFINE SCOPE OF this
      var self = this;

      this.$onInit = function(){
        $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - orderHistory"):'';
        self.availableForRegion = utilities.isShowMainRegion();
        self.proudct_currency = priceUtilities.getCurrency();

        if ($rootScope.isLogon){
          self.getHistory();
        }
      }
      $translatePartialLoader.addPart('checkout');
      // $translatePartialLoader.addPart('productListing');

      $scope.params = {
          limit: 20,
          query: '',
          currentPage: 1,
          totalItems: 0
      };

      // pagination
      $scope.maxSize = 6;
      $scope.setPage = function(pageNo) {
          $scope.params.currentPage = pageNo;
      };

      // watch for any changes on params
      // then execute get orders
      $scope.$watch('params', function() {
        if ($scope.params.query){
          $scope.orders = $filter('filter')(self.originalData,{_searchBrand:$scope.params.query});
        }else{
          $scope.orders = self.originalData;
        }
      }, true);

      self.sortByList = RefDataService.getSortBy_OrderHistory();
      $scope.params.sortBy = self.sortByList.filter(p => p.KEY == CONFIG.DEFAULT_SORT_ORDER_HISTORY)[0];

      ////////////////////////////
      // sort by section
      ////////////////////////////
      $scope.sortProduct = function(sortBy) {
        $scope.params.sortBy = sortBy;
      };

      //////////////////////////////////
      //USER PRODUCT HISTORY
      //////////////////////////////////
      this.getHistory = function (){
        usSpinnerService.spin('spinner');
        var country = $rootScope.geoLocation.country;
        RentalService.history(country).$promise.then(function(resp) {

          resp.forEach(function(currentValue){
            currentValue.product.pictures.forEach(function(item) {
                item._url = item.pathSrc === 'shopify' ? item.path : (envService.read('IMG_DOMAIN') + "/" + item.path);
            });
            var status = self.productHistoryStatus(currentValue.status,currentValue.instantRental);
            currentValue.product.brand = utilities.getCustomBrandName(currentValue.product);
            currentValue._searchDesc = currentValue.product.cleanProductDescription;
            currentValue._rentalProtection = priceUtilities.getRentalProtectionFee(currentValue.netTagPrice);
            currentValue._nonReturnFee = priceUtilities.getNonReturnFeeWithTagPrice(currentValue.netTagPrice);
            currentValue._price = currentValue.country + priceUtilities.getConvertedAmount(currentValue.product.price, currentValue.country, currentValue.exchangeRate);
            if(currentValue.deliveryMethod  == 'SC_COLLECT'){
              currentValue._trackingURL = CONFIG.DHL_TRACKING_URL + currentValue.shipmentTrackingNumber;
            }
            currentValue._rentalPeriod = self.getRentalPeriodString(currentValue);
            currentValue._productID = self.getProductID(currentValue);
            currentValue._checkoutDate = self.getCheckoutDate(currentValue);
            currentValue._groupByKey = currentValue.checkoutReferenceNumber + currentValue._rentalPeriod;
            currentValue.netTagPrice = currentValue.product.price;
            currentValue._searchBrand = currentValue.product.brand + currentValue.rentalReferenceNumber + status + currentValue.checkoutReferenceNumber + currentValue._productID + currentValue.product.ownerDTO.username;
            currentValue._scheduleReturn = !currentValue.returnScheduled && currentValue.status == 8 && (currentValue.workflowStatus == 420 || currentValue.workflowStatus == 430);
          });

          resp.forEach(function(currentValue){
            var returnAvailable = resp.filter(order => order._groupByKey == currentValue._groupByKey && (order.workflowStatus == 420 || order.workflowStatus == 430));
            currentValue._returnAvailable = returnAvailable.length > 0;
          })

          resp.sort(function(a, b){return b.id-a.id});

          $scope.orders = resp;
          $scope.params.totalItems = resp.length;
          self.originalData = angular.copy(resp);

          usSpinnerService.stop('spinner');
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":orderHistory:getHistory: - Successful"):'';
        }, function(err) {
          usSpinnerService.stop('spinner');
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":orderHistory:getHistory: - Error:" + err.status):'';
        });
      }

      /**************************
      //RETURN PRODUCT ID
      **************************/
      this.getProductID = function(order){
        if (order.productItem !== null){
          return `${order.product.id}-${order.productItem.id}`;
        }else{
          return order.product.id;
        }
      };

      /**************************
      //RETURN A RENTAL PERIOD STRING
      **************************/
      this.getRentalPeriodString = function(txn){
        if (txn.dateRented && txn.dateReturn){
          moment.tz.setDefault('UTC');
          return moment(txn.dateRented).format('DD MMM YY') + " - " + moment(txn.dateReturn).format('DD MMM YY');
        }else{
          return "N/A";
        }
      };

      this.getCheckoutDate = function(txn){
        if (txn.creationDate){
          moment.tz.setDefault('UTC');
          return moment(txn.creationDate).format('DD MMM YY');
        }else{
          return "N/A";
        }
      };

      /**************************
      //VIEW PRODUCT DETAILS
      **************************/
      this.viewDetails = function(order){
        var productBrand = utilities.getCustomBrandName(order.product);
        var urlSlug = utilities.getPrettyUrl(order.product.category.code, order.product.subCategory.code, productBrand, order.product.productLine);
        var url;
        if(utilities.isShowMainRegion()){
          url = $state.href('listing', {id: order.product.id, urlSlug: urlSlug});
        } else {
          url = $state.href('listing-multi-region', {id: order.product.id, urlSlug: urlSlug, country: $rootScope.geoLocation.country});
        }          
        window.open(url,'_blank');
      }

      /**************************
      //GET ORDER HISTORY STATUS
      **************************/
      this.productHistoryStatus = function(statusCode, isInstantRental){
        if (isInstantRental && (statusCode==1 || statusCode==2)){
          return "Awaiting Dispatch";
        } else return productStatus.getRentalStatusDisplay(statusCode);
      }

      self.viewInvoice = function(checkoutReferenceNumber){
        TransactionService.viewInvoice(checkoutReferenceNumber).$promise.then(function(resp){
          DialogAlertService.viewInvoice(checkoutReferenceNumber,resp);
        },function(err){
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":orderHistory:viewInvoice - Error: " + JSON.stringify(err.data)):'';
        })
      }

      this.buyNow = function(order){
        var modalInstance = $uibModal.open({
          templateUrl: 'views/modals/buy-now.html',
          backdrop:'static',
          controller: ["$scope", "$rootScope", function($scope, $rootScope) {
            var self = this;
            $scope.showBuyNow = true;
            $scope.product_currency = priceUtilities.getCurrency();
            order.originalPrice = priceUtilities.getFormattedAmountByRate(order.product.price);
            order.buyNowPrice = priceUtilities.getFormattedAmountByRate(order.purchasePrice);
            $scope.order = order;
  
            $scope.viewOrderDetails = function() {
              var productBrand = utilities.getCustomBrandName(order.product);
              var urlSlug = utilities.getPrettyUrl(order.product.category.code, order.product.subCategory.code, productBrand, order.product.productLine);
              var url;
              if(utilities.isShowMainRegion()){
                url = $state.href('listing', {id: order.product.id, urlSlug: urlSlug});
              } else {
                url = $state.href('listing-multi-region', {id: order.product.id, urlSlug: urlSlug, country: $rootScope.geoLocation.country});
              }          
              window.open(url,'_blank');
            };

            $scope.getProductID = function(order){
              if (order.productItem !== null){
                return `${order.product.id}-${order.productItem.id}`;
              }else{
                return order.product.id;
              }
            }

            $scope.getRentalPeriodString = function(txn){
              if (txn.dateRented && txn.dateReturn){
                moment.tz.setDefault('UTC');
                return moment(txn.dateRented).format('DD MMM YY') + " - " + moment(txn.dateReturn).format('DD MMM YY');
              }else{
                return "N/A";
              }
            };

            $scope.productHistoryStatus = function(statusCode, isInstantRental){
              if (isInstantRental && (statusCode==1 || statusCode==2)){
                return "Awaiting Dispatch";
              } else return productStatus.getRentalStatusDisplay(statusCode);
            }

            $scope.buyNow = function(rentalOrder){
              $scope.showBuyNow = false;
              RentalService.buyNow(rentalOrder.id, $rootScope.geoLocation.country, $rootScope.geoLocation.currency, $rootScope.geoLocation.rate).$promise.then(
                function(resp) {
                  $scope.showBuyNow = false;
                },
                function(err) {
                  $rootScope.enableLog ? $log.error($rootScope.UUID + ':buyNow - buyNow error: ' + err ) : '';
                }
              );
            }

            $scope.closeBuyNow = function() {
              if(!$scope.showBuyNow) {
                $state.go('customer-buy-orders');
              } 
              this.$close();
            };



          }]
        });
  
        
      }

      this.getCoverageAmount = function(country) {
        if(country == CONFIG.COUNTRY_CURRENCY_CODE.SG.country_code){
          return country + priceUtilities.currencyFormat(CONFIG.SG_PROTECTION_FEE);
        }

        return country + priceUtilities.currencyFormat(CONFIG.HK_PROTECTION_FEE);
      }

      this.goToReturn = function(){ 
        window.open('https://stylecarousel.com/landing/return-order/','_blank');
      }


      this.scheduleReturn = function(selectedTransactions){
        var modalInstance = $uibModal.open({
          templateUrl: 'views/modals/schedule-return.html',
          backdrop:'static',
          controller: ["$scope", "$rootScope", "UserService", "RentalService", function($scope, $rootScope, UserService, RentalService) {
            UserService.retrieveShippingAddressV2().$promise.then(function(resp) {
              var deliveryAddress = resp.address;
              $scope.address = deliveryAddress.address1 
              + (deliveryAddress.address2 ? ", " : "") + deliveryAddress.address2 
              + (deliveryAddress.city ? ", " : "") + deliveryAddress.city
              + (deliveryAddress.district ? ", " : "") + deliveryAddress.district
              + (deliveryAddress.country ? ", " : "") + deliveryAddress.country
              + (deliveryAddress.postalCode ? ", " : "") + deliveryAddress.postalCode;
            });

            $scope.scheduledCollection = 'AM Today';
            $scope.otherSelected =false;
            $scope.otherTime = '';
            $scope.collectionTime = [{
              name: 'AM Today',
              checked: true,
            }, {
              name: 'PM Today',
              checked: false,
            }, {
              name: 'AM Next Day',
              checked: false,
            }, {
              name: 'PM Next Day',
              checked: false,
            }, {
              name: 'Other',
              checked: false,
            }
            ]

            $scope.selectedCollectionTime = true;
            $scope.confirmation = true; 
            $scope.transactions = selectedTransactions.filter(o => o._scheduleReturn);
            $scope.submitted = false;
            checkReturn();
            $scope.enableButton = function() {
              checkReturn();
            };

            function checkReturn() {
              var transactions = selectedTransactions.filter(o => o._scheduleReturn);
              $scope.isReturnEnabled = transactions.length > 0 && $scope.confirmation && $scope.selectedCollectionTime && $scope.address != '';
            }

            $scope.closeScheduleReturn = function() {
              if($scope.submitted) {
                $state.reload();
              } 
              this.$close();
            };

            $scope.updateTime = function(position, collectionTime) {
              var selectedScheduledCollection = "";
              collectionTime[position].checked = !collectionTime[position].checked;
              
              collectionTime.forEach(function(time, index) {
                if(time.checked){
                  if(time.name=='Other'){
                    $scope.otherSelected = true;
                  } else {
                    selectedScheduledCollection = selectedScheduledCollection + (selectedScheduledCollection != "" ? ", " : "") + time.name;
                    $scope.otherSelected = false;
                  }
                } else {
                  if(time.name=='Other'){
                    $scope.otherTime = "";
                    $scope.otherSelected = false;
                  }
                }
              });
              $scope.scheduledCollection = selectedScheduledCollection;
              var selectedCollectionTime = collectionTime.filter(o => o.checked);
              $scope.selectedCollectionTime = selectedCollectionTime.length > 0;
              $scope.enableButton();
            }

            $scope.scheduleReturn = function() {
              var returnCollectionTime = $scope.scheduledCollection + ($scope.otherSelected && $scope.otherTime != '' ? ($scope.scheduledCollection != '' ? ', ' : '') + $scope.otherTime: '');
              if($scope.transactions.length > 0){
                var selectedReferenceNumber = [];
                $scope.transactions.forEach(function(item) {
                  if(item._scheduleReturn){
                    selectedReferenceNumber.push(item.rentalReferenceNumber);
                  }
                });
                $scope.returnDetails = {
                  'returnCollectionTime': returnCollectionTime,
                  'returnCollectionAddress': $scope.address,
                  'returnConfirmation': $scope.confirmation,
                  'checkoutReferenceNumber': $scope.transactions[0].checkoutReferenceNumber,
                  'rentalReferenceNumber': selectedReferenceNumber
                };

                $scope.submitted = true;
                RentalService.scheduleReturn($scope.returnDetails).$promise.then(
                  function(resp) {
                    $scope.submitted = true;
                  },
                  function(err) {
                    $scope.submitted = false;
                    $rootScope.enableLog ? $log.error($rootScope.UUID + ':scheduleReturn - scheduleReturn error: ' + err ) : '';
                  }
                );

              }
            };


          }]
        });
  
        
      }

    }]
  })

'use strict';
angular.module('coutureApp')
  .component('orderHistoryMenu', {
    templateUrl: 'scripts/components/order-history/components/order-history-menu.html',
    controllerAs : 'orderHistoryMenuCtrl',
    controller: ["$scope", "$state", "$log", "$rootScope", "utilities", function($scope,$state,$log,$rootScope, utilities) {

      this.$onInit = function(){
        $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - orderHistoryMenuCtrl"):'';
      }

      this.isBuyRequestsSelected = function(){
        return $state.includes('customer-buy-orders') || $state.includes('customer-buy-orders-multi-region');
      }
    
      this.goToBuyOrders = function(){
        if(utilities.isShowMainRegion()){
          $state.go('customer-buy-orders');
        } else {
          $state.go('customer-buy-orders-multi-region', {country: $rootScope.geoLocation.country});
        }
      }

      this.isRentalRequestsSelected = function(){
        return $state.includes('order-history') || $state.includes('order-history-multi-region');
      }
    
      this.goToRentalOrders = function(){
        if(utilities.isShowMainRegion()){
          $state.go('order-history');
        } else {
          $state.go('order-history-multi-region', {country: $rootScope.geoLocation.country});
        }
      }

  }]
})

'use strict';

angular.module('coutureApp')
  .component('customerBuyOrders', {
    controllerAs : 'customerBuyOrdersCtrl',
    templateUrl: 'scripts/components/order-history/customer-buy-orders/customer-buy-orders.html',
    controller: ["$scope", "$http", "RentalService", "envService", "utilities", "priceUtilities", "$state", "$rootScope", "$log", "$filter", "usSpinnerService", "ListingService", "productStatus", "RefDataService", "CONFIG", "BuyService", "TransactionService", "DialogAlertService", "$translatePartialLoader", function($scope, $http,RentalService,envService,utilities,priceUtilities,$state,$rootScope, $log,$filter,
       usSpinnerService,ListingService,productStatus,RefDataService,CONFIG,BuyService,TransactionService,DialogAlertService,$translatePartialLoader) {

      //DEFINE SCOPE OF this
      var self = this;

      this.$onInit = function(){
        $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - customerBuyOrders"):'';

        self.product_currency = priceUtilities.getCurrency();
        if ($rootScope.isLogon){
          self.getHistory();
        }
      }
      // $translatePartialLoader.addPart('productListing');
      $translatePartialLoader.addPart('checkout');

      $scope.params = {
          limit: 20,
          query: '',
          currentPage: 1,
          totalItems: 0
      };

      // pagination
      $scope.maxSize = 6;
      $scope.setPage = function(pageNo) {
          $scope.params.currentPage = pageNo;
      };

      // watch for any changes on params
      // then execute get orders
      $scope.$watch('params', function() {
        if ($scope.params.query){
          $scope.orders = $filter('filter')(self.originalData,{_searchBrand:$scope.params.query});
        }else{
          $scope.orders = self.originalData;
        }
      }, true);

      self.sortByList = RefDataService.getSortBy_OrderBuyHistory();
      $scope.params.sortBy = self.sortByList.filter(p => p.KEY == CONFIG.DEFAULT_SORT_ORDER_HISTORY)[0];

      ////////////////////////////
      // sort by section
      ////////////////////////////
      $scope.sortProduct = function(sortBy) {
        $scope.params.sortBy = sortBy;
      };

      //////////////////////////////////
      //USER PRODUCT HISTORY
      //////////////////////////////////
      this.getHistory = function (){
        usSpinnerService.spin('spinner');
        BuyService.getAllBuyOrdersByCustomer().$promise.then(function(resp) {

          resp.forEach(function(currentValue){
            currentValue.product.pictures.forEach(function(item) {
                item._url = item.pathSrc === 'shopify' ? item.path : (envService.read('IMG_DOMAIN') + "/" + item.path);
            });
            var purchaseDate = moment(currentValue.datePurchased).format('DD MMM YY');
            var status = productStatus.getPurchaseStatusDisplay(currentValue.statusCode);
            currentValue._purchasedDate = purchaseDate;
            currentValue._purchasePrice = currentValue.purchasePrice;
            currentValue._productID = currentValue.product.id + "-" + currentValue.item.id;
            currentValue._statusName = status;
            currentValue._merchantUsername = currentValue.product.ownerDTO.username;
            currentValue._searchBrand = currentValue.product.brandName + currentValue.id + status + currentValue._purchasedDate + currentValue._productID + currentValue._merchantUsername + currentValue.purchaseReferenceNumber + currentValue.checkoutReferenceNumber;
            if(currentValue.deliveryMethod  == 'SC_COLLECT'){
              currentValue._trackingURL = CONFIG.DHL_TRACKING_URL + currentValue.shipmentTrackingNumber;
            }
          })

          $scope.orders = resp;
          $scope.params.totalItems = resp.length;
          self.originalData = angular.copy(resp);
          usSpinnerService.stop('spinner');
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":orderHistory:getHistory: - Successful"):'';
        }, function(err) {
          usSpinnerService.stop('spinner');
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":orderHistory:getHistory: - Error:" + err.status):'';
        });
      }

      /**************************
      //RETURN PRODUCT ID
      **************************/
      this.getProductID = function(order){
        if (order.item !== null){
          return `${order.product.id}-${order.item.id}`;
        }else{
          return order.product.id;
        }
      };

      /**************************
      //RETURN A RENTAL PERIOD STRING
      **************************/
      this.getRentalPeriodString = function(txn){
        if (txn.dateRented && txn.dateReturn){
          moment.tz.setDefault('UTC');
          return moment(txn.dateRented).format('DD MMM YY') + " - " + moment(txn.dateReturn).format('DD MMM YY');
        }else{
          return "N/A";
        }
      };

      /**************************
      //VIEW PRODUCT DETAILS
      **************************/
      this.viewDetails = function(order){
        var productBrand = utilities.getCustomBrandName(order.product);
        var urlSlug = utilities.getPrettyUrl(order.product.category.code, order.product.subCategory.code, productBrand, order.product.productLine);
        $state.go('listing', {id: order.product.id, urlSlug: urlSlug});
      }

      /**************************
      //GET ORDER HISTORY STATUS
      **************************/
      this.productHistoryStatus = function(statusCode, isInstantRental){
        if (isInstantRental && (statusCode==1 || statusCode==2)){
          return "Awaiting Dispatch";
        } else return productStatus.getRentalStatusDisplay(statusCode);
      }

      self.viewInvoice = function(checkoutReferenceNumber){
        TransactionService.viewInvoice(checkoutReferenceNumber).$promise.then(function(resp){
          DialogAlertService.viewInvoice(checkoutReferenceNumber,resp);
        },function(err){
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":orderHistory:viewInvoice - Error: " + JSON.stringify(err.data)):'';
        })
      }

    }]
  })

'use strict';
angular.module('coutureApp')
  .component('wishlists', {
    controllerAs : 'wishlistsCtrl',
    templateUrl: 'scripts/components/profile/wishlists/wishlists.html',
    controller: ["$rootScope", "$state", "$log", "$scope", "$filter", "usSpinnerService", "utilities", "RefDataService", "CONFIG", "priceUtilities", "WishlistService", "envService", "DialogAlertService", "$timeout", "$anchorScroll", "ListingService", "CalendarService", "Session", "CartService", function($rootScope,$state, $log,$scope, $filter, usSpinnerService, utilities,RefDataService, CONFIG, priceUtilities,WishlistService,envService,DialogAlertService, $timeout, $anchorScroll,ListingService, CalendarService, Session, CartService) {


      var self = this;

      this.$onInit = function(){
        $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - wishlists "):'';
        self.sizeForAllCategory = RefDataService.getSizeList(); 
        if (!$rootScope.isLogon){
          if(utilities.isShowMainRegion()){
			      $state.go('main');
          } else {
            $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
          }
        } else {
          self.sizeList = RefDataService.getSizeFlatList();
          self.allCategorySizes = RefDataService.getSizeList();
          self.product_currency = priceUtilities.getCurrency();
          self.getUserWishlistByProduct();
        }
      }

      this.getUserWishlistByProduct = function (){
        usSpinnerService.spin('spinner');
        WishlistService.getUserWishlistByProduct($rootScope.geoLocation.country).$promise.then(
          function(resp) {
            $rootScope.enableLog ? $log.info($rootScope.UUID + ":wishlistsCtrl:List Wishlist: " + JSON.stringify(resp.length)) : '';
            

            handleSearchResult(resp);
            $scope.wishlists = resp;
            $scope.params.totalItems = resp.length;
            self.originalData = angular.copy(resp);
            
          },
          function(err) {
            usSpinnerService.stop('spinner');
            self.lk_search = false;
            self.lk_loadMore = false;
            if (err.data) {
              $rootScope.enableLog ? $log.error($rootScope.UUID + ":wishlistsCtrl:List Wishlist err: " + err.data.reasons[0].message) : '';
            } else {
              $rootScope.enableLog ? $log.error($rootScope.UUID + ":wishlistsCtrl:List Wishlist err: " + JSON.stringify(err)) : '';
            }
        });
      }

      function handleSearchResult(resp){

      //SHOW DIFFERENT SIZES IN THE LISTING PAGE
      resp.forEach(product => {
        product.hasSize = product.sizes.filter(s => s.available).length > 0;
        product.pictures.forEach(function(item) {
          item._url = item.pathSrc === 'shopify' ? item.path : envService.read('IMG_DOMAIN') + "/" + item.path;
        });
      });
      

      self.lk_search = false;
      usSpinnerService.stop('spinner');


      }

      this.getMainPhoto = function(product){
        return utilities.getMainPhoto(product);
      }
      this.getDisplayPhoto = function(product, position){
        return utilities.getDisplayPhoto(product, position);
      }

      this.showListing = function(id, product) {
        utilities.showListing(id, product);
      };

      this.showListingWithTransactionType = function(id, product, type) {
        $rootScope.transactionType = type;
        utilities.showListing(id, product);
      };

      this.getDisplayPrice = function(product) {
        return priceUtilities.getDisplayPriceV2(product);
      }

      this.getDisplayPurchasePrice = function(product) {
        return priceUtilities.getDisplayPurchasePriceV2(product);
      }

      this.getDisplayTagOrigPrice = function(product){
        return priceUtilities.getDisplayTagOrigPrice(product);
      }
      
      this.toggleWishlist = function(product) {
        self.displayedProductWishlist = product.id;
        self.isWishlistDisabled = true;
        var allSizes = product.sizes;
        for (var index in allSizes) {
          var sizeWishlist = allSizes[index].wishlist;
          if(sizeWishlist){
            self.isWishlistDisabled = false;
            break;
          }
        }
      }

      this.saveWishlist = function(product){
        DialogAlertService.saveWishlist(product);
      }

      this.getUserWishlist = function (){
        usSpinnerService.spin('spinner');
        WishlistService.getUserWishlist().$promise.then(function(resp) {
          resp.forEach(function(wl){
            wl._searchBrand = wl.product.brand;
            wl.product.pictureUrl =  wl.product.pictureSrc === 'shopify' ? wl.product.picturePath : (envService.read('IMG_DOMAIN') + "/" + wl.product.picturePath);

            var originalPrice = wl.product.price;
            var oneMthPlan = priceUtilities.getSubscriptionPlanDetails(CONFIG.PLAN_SUBSCRIPTION_4);
            var basePrice = CONFIG.PLAN_1_MTH_CREDIT_PRICE;
            var targetPrice = basePrice;
            var currency = $rootScope.geoLocation.currency ? $rootScope.geoLocation.currency : self.product_currency;
            var country = $rootScope.geoLocation.country ? $rootScope.geoLocation.country : self.product_currency;
            if(currency == CONFIG.COUNTRY_CURRENCY_CODE.SG.currency_code || currency == CONFIG.COUNTRY_CURRENCY_CODE.HK.currency_code){
              targetPrice = priceUtilities.getAmountByOriginalAmountAndCurrency(basePrice, currency);
              originalPrice =priceUtilities.getAmountByOriginalAmountAndCurrency(originalPrice, currency);
            } else {
              targetPrice = Math.round(basePrice);
              originalPrice = Math.round(originalPrice);
            }

            wl.product.productPrice = country + "" + priceUtilities.currencyFormat(originalPrice);
            wl.product.rentalPrice = country + "" + priceUtilities.currencyFormat(targetPrice * wl.product.credit);
            wl._sortPrice = originalPrice;
          });

          $scope.wishlists = resp;
          $scope.params.totalItems = resp.length;
          self.originalData = angular.copy(resp);
            
          usSpinnerService.stop('spinner');
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":orderHistory:getUserWishlistHistory: - Successful"):'';
        }, function(err) {
          usSpinnerService.stop('spinner');
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":orderHistory:getUserWishlist: - Error:" + err.status):'';
        });
      }

      $scope.params = {
        limit: 20,
        query: '',
        currentPage: 1,
        totalItems: 0
      };

      // pagination
      $scope.maxSize = 6;
      $scope.setPage = function(pageNo) {
          $scope.params.currentPage = pageNo;
      };

      $scope.$watch('params', function() {
        if ($scope.params.query){
          $scope.wishlists = $filter('filter')(self.originalData,{_searchValue:$scope.params.query});
        }else{
          $scope.wishlists = self.originalData;
        }
      }, true);

      self.sortByList = RefDataService.getSortByWishlist();
      $scope.params.sortBy = self.sortByList.filter(p => p.KEY == CONFIG.DEFAULT_SORT_WISHLIST)[0];

      ////////////////////////////
      // sort by section
      ////////////////////////////
      $scope.sortProduct = function(sortBy) {
        $scope.params.sortBy = sortBy;
      };

      this.viewDetails = function(product, transactionType){
        $rootScope.transactionType = transactionType;
        var urlSlug = utilities.getPrettyUrl(product.category.code, product.subCategory.code, product.brandName, product.productLine);
        
        if(utilities.isShowMainRegion()){
          $state.go('listing', {id: product.id, urlSlug: urlSlug});
        } else {
          $state.go('listing-multi-region', {id: product.id, urlSlug: urlSlug, country: $rootScope.geoLocation.country});
        }
      }

      this.deleteWishlist = function(wishlistID){
        WishlistService.deleteWishlist(wishlistID).$promise.then(function(){
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":deleteWishlist - Deleted successfully " + wishlistID):'';
          
          if(utilities.isShowMainRegion()){
            $state.go("wishlists", {}, {'reload' : true});
          } else {
            $state.go("wishlists-multi-region", {country: $rootScope.geoLocation.country}, {'reload' : true});
          }
        },
        function(err){
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":deleteWishlist - Error delete " + productID + " : " + JSON.stringify(err)):'';
          DialogAlertService.promptDialog('Unable to delete wishlist. Please contact admin for assistance. ', '', '', '', 'GENERAL.LABEL.OK', '', '', false,'',"RED");
        });
      }

      this.updateSubscription = function(product, subscription){
        WishlistService.updateSubscription(product.id, subscription).$promise.then(function(){
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":updateWishlist - Updated successfully "):'';
          
          product.existInWishlistNotification = subscription;
        },
        function(err){
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":updateWishlist - Error delete " + " : " + JSON.stringify(err)):'';
          DialogAlertService.promptDialog('Unable to update wishlist. Please contact admin for assistance. ', '', '', '', 'GENERAL.LABEL.OK', '', '', false,'',"RED");
        });
      }

      self.addToCartRent = function(wishlist){

        ListingService.getListing(wishlist.productId).$promise.then(
        function(resp) {
          self.listing = resp;
          self.listing._origIrItems = angular.copy(self.listing.ir_items);
          self.listing._origRrItems = angular.copy(self.listing.rr_items);
          self.listing._availableSize = combineSizes(self.listing._origIrItems,self.listing._origRrItems,self.listing.items);
          self.listing._availableSize.sort(function(a, b){return a.sizePosition-b.sizePosition;});

          var selectedSize = self.listing._availableSize.filter(
            sizeObj => sizeObj.size === wishlist.size
            )[0];
          self.setProductSize(selectedSize,  wishlist.itemCondition);

          var rental = {
            cartID: null, 
            productID: wishlist.productId, 
            product: self.listing, 
            size: wishlist.size, 
            selectedDate: null,
            transactionType: CONFIG.TRANSACTION_TYPE_RENT,
            itemCondition: wishlist.itemCondition
          };

           //GET THE UNIQUE KEY FOR THE SELECTED PRODUCT SIZE.
            const keysInCartForSelectedSize = $rootScope.cc.cart
            .filter(
              cartItem => 
                cartItem.size === self.selectedSize && 
                cartItem.itemCondition === wishlist.itemCondition && 
                cartItem.productID === rental.productID
            )
            .map(cartItem => cartItem.cartID);


            // GET THE PRODUCT KEYS ARRAY FOR EACH DIFFERENT PRODUCT SIZE (EG. 'PRODUCTID-SUBITEMID')
          const allKeysForSelectedSizeOnly = self.listing._availableSize
            .filter(sizeObj => sizeObj.size === self.selectedSize);

          const allKeysForSelectedSizeAndCondition = allKeysForSelectedSizeOnly[0].subItems
              .filter(sizeObj => sizeObj.itemCondition === wishlist.itemCondition);

          const allKeysForSelectedSize = allKeysForSelectedSizeAndCondition
            .map(selectedSizeObj => selectedSizeObj.keys)
            .flat();

            if (keysInCartForSelectedSize.length > 0 && 
              keysInCartForSelectedSize.length < allKeysForSelectedSize.length) {
    
            //ALREADY HAVE PRODUCT IN CART, ADD ANOTHER PRODUCT OF THE SAME SIZE TO CART
            let availableKeysForSelectedSize = [...allKeysForSelectedSize];
    
            keysInCartForSelectedSize.forEach(cartKey => {
              availableKeysForSelectedSize = availableKeysForSelectedSize.filter(
                availableKey => availableKey != cartKey
              );
            });
    
            rental.cartID = availableKeysForSelectedSize[0];
    
          } else if (keysInCartForSelectedSize.length === 0) {
    
            //FIRST PRODUCT OF SELECTED SIZE ADDED TO THE CART
            rental.cartID = allKeysForSelectedSize[0];
            
          } else {
            //MAX AVAILABLE ITEM REACHED
            DialogAlertService.promptDialog('Max available item reached and added to cart.', '', '', '', 'Ok', '', '', false);
            return;
          }

          CalendarService.openCalendar(function() {
          
            //CHECKOUT DIRECTLY
            if (rental.product != null && rental.selectedDate != null){
                utilities.replaceItemInArray(rental,$rootScope.cc.cart);
                //STORE PRODUCT ID IN LOCAL SERVICE
                    var sessionCartDetails = {
                      cartID:rental.cartID, 
                      productID:self.listing.id, 
                      size:self.selectedSize, 
                      startDate: rental.selectedDate.START_DATE,
                      returnDate: rental.selectedDate.RETURN_DATE,
                      transactionType: CONFIG.TRANSACTION_TYPE_RENT, 
                      price: {
                        purchasePrice: self.listing.purchasePrice,
                        originalPrice: self.listing.price,
                        salePrice: self.listing.salePrice
                      },
                      itemCondition: wishlist.itemCondition,
                      country: $rootScope.geoLocation.country
                    };
                    Session.updateCartV2(sessionCartDetails);
                    CartService.captureAddToCart(self.listing, rental);
                    var cartDetails = {
                      'cartID' : rental.cartID, 
                      'productID' : self.listing.id, 
                      'size' : self.selectedSize, 
                      'startDate' : rental.selectedDate.START_DATE, 
                      'returnDate' : rental.selectedDate.RETURN_DATE, 
                      'transactionType' : CONFIG.TRANSACTION_TYPE_RENT, 
                      'itemCondition' : self.lowestCondition,
                      'bundleID': rental.bundleID,
                      'country': $rootScope.geoLocation.country
                    };
                    CartService.addCart(cartDetails);
                    //self.calculatePricing();
                    usSpinnerService.spin('spinner');
                    $timeout(() => {
                      usSpinnerService.stop('spinner');
                      if(utilities.isShowMainRegion()){
                        $state.go('checkout');
                      } else {
                        $state.go('checkout-multi-region', {country: $rootScope.geoLocation.country});
                      }
                    },1500);
                    self.deleteWishlist(wishlist.wishlistID);
            }
  
          }, function() {
  
            //SAVED TO CART
            if (rental.product != null && rental.selectedDate != null){
                utilities.replaceItemInArray(rental,$rootScope.cc.cart);
                //STORE PRODUCT ID IN LOCAL SERVICE
                var sessionCartDetails = {
                      cartID:rental.cartID, 
                      productID:self.listing.id, 
                      size:self.selectedSize, 
                      startDate: rental.selectedDate.START_DATE,
                      returnDate: rental.selectedDate.RETURN_DATE,
                      transactionType: CONFIG.TRANSACTION_TYPE_RENT, 
                      price: {
                        purchasePrice: self.listing.purchasePrice,
                        originalPrice: self.listing.price,
                        salePrice: self.listing.salePrice
                      },
                      itemCondition: wishlist.itemCondition,
                      bundleID: rental.bundleID,
                      country: $rootScope.geoLocation.country
                };
                Session.updateCartV2(sessionCartDetails);
                var cartDetails = {
                  'cartID' : rental.cartID, 
                  'productID' : self.listing.id, 
                  'size' : self.selectedSize, 
                  'startDate' : rental.selectedDate.START_DATE, 
                  'returnDate' : rental.selectedDate.RETURN_DATE, 
                  'transactionType' : CONFIG.TRANSACTION_TYPE_RENT, 
                  'itemCondition' : wishlist.itemCondition,
                  'bundleID': rental.bundleID,
                  'country': $rootScope.geoLocation.country
                };
                CartService.addCart(cartDetails);
                CartService.captureAddToCart(self.listing, rental);
                self.deleteWishlist(wishlist.wishlistID);
              }
  
          }, function(date) {
              rental.selectedDate={'START_DATE':null, 'RETURN_DATE':null};
              rental.selectedDate.START_DATE = moment(date).format('x');
              rental.selectedDate.RETURN_DATE = moment(Number(rental.selectedDate.START_DATE)).add(CONFIG.DEFAULT_RENTAL_DURATION,'d').format('x');
          }, utilities.getAvailableDatesWithSize(self.selectedSize,self.listing,wishlist.itemCondition),self.listing.credit, CONFIG.DEFAULT_RENTAL_WEEK);
          
        });
  
  
    }

    self.addToCartBuy = function(wishlist){

      ListingService.getListing(wishlist.productId).$promise.then(
      function(resp) {
        self.listing = resp;
        self.listing._origIrItems = angular.copy(self.listing.ir_items);
        self.listing._origRrItems = angular.copy(self.listing.rr_items);
        self.listing._availableSize = combineSizes(self.listing._origIrItems,self.listing._origRrItems,self.listing.items);
        self.listing._availableSize.sort(function(a, b){return a.sizePosition-b.sizePosition;});

        var selectedSize = self.listing._availableSize.filter(
          sizeObj => sizeObj.size === wishlist.size
          )[0];
        self.setProductSize(selectedSize,  wishlist.itemCondition);

        var rental = {
          cartID: null, 
          productID: wishlist.productId, 
          product: self.listing, 
          size: wishlist.size, 
          selectedDate: null,
          transactionType: CONFIG.TRANSACTION_TYPE_BUY,
          itemCondition: wishlist.itemCondition,
          price: {
            purchasePrice: self.listing.purchasePrice,
            originalPrice: self.listing.price,
            salePrice: self.listing.salePrice
          },
        };

         //GET THE UNIQUE KEY FOR THE SELECTED PRODUCT SIZE.
          const keysInCartForSelectedSize = $rootScope.cc.cart
          .filter(
            cartItem => 
              cartItem.size === self.selectedSize && 
              cartItem.itemCondition === wishlist.itemCondition && 
              cartItem.productID === rental.productID
          )
          .map(cartItem => cartItem.cartID);


          // GET THE PRODUCT KEYS ARRAY FOR EACH DIFFERENT PRODUCT SIZE (EG. 'PRODUCTID-SUBITEMID')
        const allKeysForSelectedSizeOnly = self.listing._availableSize
          .filter(sizeObj => sizeObj.size === self.selectedSize);

        const allKeysForSelectedSizeAndCondition = allKeysForSelectedSizeOnly[0].subItems
            .filter(sizeObj => sizeObj.itemCondition === wishlist.itemCondition);

        const allKeysForSelectedSize = allKeysForSelectedSizeAndCondition
          .map(selectedSizeObj => selectedSizeObj.keys)
          .flat();

          if (keysInCartForSelectedSize.length > 0 && 
            keysInCartForSelectedSize.length < allKeysForSelectedSize.length) {
  
          //ALREADY HAVE PRODUCT IN CART, ADD ANOTHER PRODUCT OF THE SAME SIZE TO CART
          let availableKeysForSelectedSize = [...allKeysForSelectedSize];
  
          keysInCartForSelectedSize.forEach(cartKey => {
            availableKeysForSelectedSize = availableKeysForSelectedSize.filter(
              availableKey => availableKey != cartKey
            );
          });
  
          rental.cartID = availableKeysForSelectedSize[0];
  
        } else if (keysInCartForSelectedSize.length === 0) {
  
          //FIRST PRODUCT OF SELECTED SIZE ADDED TO THE CART
          rental.cartID = allKeysForSelectedSize[0];
          
        } else {
          //MAX AVAILABLE ITEM REACHED
          DialogAlertService.promptDialog('Max available item reached and added to cart.', '', '', '', 'Ok', '', '', false);
          return;
        }
        var sessionCartDetails = {
          cartID:rental.cartID, 
          productID:self.listing.id, 
          size:self.selectedSize, 
          startDate: null,
          returnDate: null,
          transactionType: CONFIG.TRANSACTION_TYPE_BUY, 
          price: {
            purchasePrice: self.listing.purchasePrice,
            originalPrice: self.listing.price,
            salePrice: self.listing.salePrice
          },
          itemCondition : wishlist.itemCondition,
          bundleID : rental.bundleID,
          country: $rootScope.geoLocation.country
        };
        
        utilities.replaceItemInArray(rental,$rootScope.cc.cart);
        Session.updateCartV2(sessionCartDetails);

        var cartDetails = {
          'cartID' : rental.cartID, 
          'productID' : self.listing.id, 
          'size' : self.selectedSize, 
          'startDate' : null, 
          'returnDate' : null, 
          'transactionType' : CONFIG.TRANSACTION_TYPE_BUY, 
          'itemCondition' : wishlist.itemCondition,
          'bundleID': null,
          'country': $rootScope.geoLocation.country
        };
        CartService.addCart(cartDetails);
        CartService.captureAddToCart(self.listing, rental);
        DialogAlertService.displayAddToCartBuyConfirmation(cartDetails, self.listing);
        self.deleteWishlist(wishlist.wishlistID);
        
        
        
      });


    }

      //CONSOLIDATE BOTH IR AND RR SIZE IN TO A NEW ARRAY
    function combineSizes(instantRental,requestRental,fullList){
      var tempSize = [];
      var tempSizeIndex;
      if (instantRental){
        instantRental.forEach((item, i) => {
          tempSizeIndex = tempSize.findIndex(p=> p.size === item.size);
          if (tempSizeIndex !== -1){
            var tempSubItems = {};
            tempSubItems.itemCondition = item.itemCondition;
            tempSubItems.itemConditionPosition = item.itemConditionPosition;
            tempSubItems.availableQuantityForRental = item.availableQuantityForRental;
            var subItems = tempSize[tempSizeIndex].subItems;
            subItems.push(tempSubItems);
            tempSize[tempSizeIndex].subItems = subItems;
            tempSize[tempSizeIndex].availableQuantityForRental += item.availableQuantityForRental;
           
          }else{
            var subItems = {};
            subItems.itemCondition = item.itemCondition;
            subItems.itemConditionPosition = item.itemConditionPosition;
            subItems.availableQuantityForRental = item.availableQuantityForRental;
            item.subItems = [subItems];
            tempSize.push(item);
          }
        });
      }
      if (tempSize && requestRental){
        requestRental.forEach((item, i) => {
          tempSizeIndex = tempSize.findIndex(p=> p.size === item.size);
          if (tempSizeIndex !== -1){
            var subItems = tempSize[tempSizeIndex].subItems;
            var subIndex = subItems.findIndex(p=> p.itemCondition === item.itemCondition);
            if (subIndex !== -1){
              subItems[subIndex].availableQuantityForRental += item.availableQuantityForRental;
            } else {
              var tempSubItems = {};
              tempSubItems.itemCondition = item.itemCondition;
              tempSubItems.itemConditionPosition = item.itemConditionPosition;
              tempSubItems.availableQuantityForRental = item.availableQuantityForRental;
              subItems.push(tempSubItems);
              tempSize[tempSizeIndex].subItems = subItems;
            }

            
            tempSize[tempSizeIndex].availableQuantityForRental += item.availableQuantityForRental;
          }else{
            var subItems = {};
            subItems.itemCondition = item.itemCondition;
            subItems.itemConditionPosition = item.itemConditionPosition;
            subItems.availableQuantityForRental = item.availableQuantityForRental;
            item.subItems = [subItems];
            tempSize.push(item);
          }
        });
      }

      //ADD THE KEY (MASTERID + SUBITEM) TO THE ASSOCIATED COMBINED SIZE AS AN ARRAY.
      //THE PURPOSE OF THE KEY IS TO UNIQUELY ID THE PRODUCT IN THE CART, SO REMOVAL/CHANGE DATE FOR THE SPECIFIC ITEM CAN BE DONE.
      if (tempSize && tempSize.length > 0){
        //MORE THEN ONE SIZE PER PRODUCT
        tempSize.forEach((item) => {
          //PRODUCT WITH STATUS AVAILABLE_INSTANT OR AVAILABLE (REFER TO PRODUCTSTATUS.JS)
          item.keys = fullList.filter(p=> p.size ==item.size && (p.status == 6 || p.status == 8)).map(m=> fullList[0].productId + "-" + m.id); 
          item.subItems.forEach((sub) => {
            sub.keys = fullList.filter(p=> p.size ==item.size && p.condition == sub.itemCondition && (p.status == 6 || p.status == 8)).map(m=> fullList[0].productId + "-" + m.id); 
          });
          item.subItems.sort(function(a, b){return a.itemConditionPosition-b.itemConditionPosition;});
          var lowestAvailableCondition = item.subItems[0];
          item.itemCondition = lowestAvailableCondition.itemCondition;
          item.itemConditionPosition = lowestAvailableCondition.itemConditionPosition;

          var rentalOptions = item.subItems.filter(i => i.itemConditionPosition >= 2);
          if(rentalOptions.length > 0){
            var rentalLowestAvailableCondition = rentalOptions[0];
            item.rentalLowestAvailableCondition = rentalLowestAvailableCondition.itemCondition;
            item.rentalLowestAvailableConditionPosition = rentalLowestAvailableCondition.itemConditionPosition;
          }

          item.subItems.sort(function(a, b){return b.itemConditionPosition-a.itemConditionPosition;});
          var highestAvailableCondition = item.subItems[0];
          item.highestAvailableCondition = highestAvailableCondition.itemCondition;
          item.highestAvailableConditionPosition = highestAvailableCondition.itemConditionPosition;

        });
      }else{
        //ONE SIZE PER PRODUCT
        var productDetails = fullList.filter(p=> (p.status == 6 || p.status == 8));
        if (productDetails && productDetails.length > 0){
          var item = {
            size:productDetails.size ,
            availableQuantityForRental:1, 
            keys:[productDetails['productId'] + "-" + productDetails['id']],
            sizeValue:productDetails.sizeValue
          };
          tempSize.push(item);
        }
      }

      var unavailableSizes = {};
      var sizesByCategory = self.sizeForAllCategory.filter(s => s.category === self.listing.category.name);
      if(sizesByCategory && sizesByCategory.length > 0){
        sizesByCategory[0].options.forEach(size => {
          var checkExist = tempSize.filter(temp => {
            return size.key == temp.size;
          });
          if(!checkExist || checkExist.length === 0){
            var item = {
              size:size.key,
              availableQuantityForRental:0, 
              keys: "",
              sizeValue:size.value,
              sizePosition: size.position
            };
            // check if item is returning soon, status not in 6,8,4,32,108,109,120
            var filterReturningSoon = fullList.filter(p=> p.size == size.key && (p.status != 6 || p.status != 8 ||  p.status != 4 || p.status != 32 || p.status != 108 || p.status != 109 || p.status != 120));
            item.isReturningSoon = filterReturningSoon.length > 0;
            tempSize.push(item);
          }
        });
      }
      
      return tempSize;
    }

    this.setProductSize = function(availebleSizeObj, itemCondition){
      self.selectedSize = availebleSizeObj.size;
      self.selectedSizeValue = availebleSizeObj.sizeValue;

      const allKeysForSelectedSizeOnly = self.listing._availableSize
        .filter(sizeObj => sizeObj.size === self.selectedSize);

      const selectedSizeKeys = allKeysForSelectedSizeOnly[0].subItems
          .filter(sizeObj => sizeObj.itemCondition === itemCondition)[0].keys;

      this.isEveryAvailableSizeInCart(selectedSizeKeys);
      
    }

    this.isEveryAvailableSizeInCart = function(sizeKeys){
      let cartKeys = $rootScope.cc.cart.map(cartItem => cartItem.cartID);
      return !sizeKeys.every(key => cartKeys.includes(key));
    }

    this.getDisplayBrand = function(product){
      return utilities.getCustomBrandName(product);
    }
    
    this.isSalePriceSameWithOrigPrice = function(product){
      return priceUtilities.isSalePriceSameWithOrigPrice(product.price, product.discountRate)
    }
      
  }]
})

'use strict';
angular.module('coutureApp')
  .component('rentalListings', {
    controllerAs : 'rentalListingsCtrl',
    templateUrl: 'scripts/components/profile/rental-listings/rental-listings.html',
    controller: ["$rootScope", "$scope", "$state", "$stateParams", "$http", "RefDataService", "ListingService", "DialogAlertService", "utilities", "priceUtilities", "usSpinnerService", "$log", "CONFIG", "Session", "UserService", "$timeout", "$anchorScroll", "$window", "envService", "$translate", "SeoService", "USER_ROLES", "AuthService", function($rootScope,$scope, $state, $stateParams, $http,RefDataService,ListingService,DialogAlertService,
      utilities, priceUtilities,usSpinnerService,$log,CONFIG,Session,UserService,$timeout,$anchorScroll,$window,envService,$translate,SeoService,USER_ROLES,AuthService) {

      var self= this;

      this.$onInit = function(){
        $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - rentalListings"):'';
        self.allCategorySizes = RefDataService.getSizeList();
        self.rentalFilter = {};

        $rootScope.transactionType = CONFIG.TRANSACTION_TYPE_RENT;
        $scope.pageSelector_pgNum = 1;
        self.currentPageCount = 1;
        self.lk_loadMore = true; // Prevent loading of more results initially
        $scope.sortByList = RefDataService.getSortByList_Listings();
        self.setSortListWithDefault(CONFIG.DEFAULT_SORT_RENTAL_LISTING);
        $scope.productOptions = RefDataService.GetProductOptionsLabel();
        self.proudct_currency = priceUtilities.getCurrency();
        $scope.pageSelector_maxSize = 3;
        $scope.pageSelector_itemPerPage = CONFIG.ITEM_PER_PAGE;
        self.availableForRegion = utilities.isFunctionEnabled();
        self.collectionList = RefDataService.getCollections();

        self.isOwner = false;

        $scope.isAdmin = false;
        if (AuthService.isAuthorized(USER_ROLES.admin)){
          $scope.isAdmin = true;
        } 
        self.shopName = $state.params.otherUsername == null ? $rootScope.user.username : $state.params.otherUsername;
        self.buttonName = "See all " + self.shopName + " on Style Carousel";
        $rootScope.filterDesignerByOwner = null;

        if ($state.params.otherUsername == null && !$rootScope.isLogon){
          //NOT ALLOWED TO TYPE IN URL DIRECTLY
          $state.go('main');
        }else if ($state.params.otherUsername){

          $rootScope.filterDesignerByOwner = $state.params.otherUsername;
          loadOtherUserProfile();
        }else if ($rootScope.isLogon){
          self.profileName = $rootScope.user.username;
          $rootScope.filterDesignerByOwner = $rootScope.user.username;
          self.isOwner = true;
          self.getRentalListings($scope.pageSelector_pgNum);
        }
      }

      //////////////////////////////////////////
      //  LOAD RENTAL LISTING FOR OTHER PROFILE.
      //////////////////////////////////////////
      function loadOtherUserProfile(){
        UserService.isUserExists($state.params.otherUsername).$promise.then(function(resp){
          var otherUser = $state.params.otherUsername ? $state.params.otherUsername.toLowerCase() : "";
          var currentUser = $rootScope.isLogon ? ($rootScope.user.username ? $rootScope.user.username.toLowerCase() : "") : "";
          var isShopOwner = currentUser == otherUser;
          if(CONFIG.COUNTRY_CURRENCY_CODE.AU.country_code == $rootScope.geoLocation.country 
            && !resp.australiaStoreEnabled 
            && !isShopOwner){
            $state.go('main');
          } else {
            if(!$scope.isAdmin && !isShopOwner){

            $window.location.href = envService.read('APP_URL') + "/" + $state.params.otherUsername;
            }
            if (resp.profileImg && resp.profileImg.indexOf('https://') == -1){
              resp.profileImg = envService.read('IMG_DOMAIN') + "/" + resp.profileImg;
            }else if (resp.profileImg && resp.profileImg.indexOf('https://') != -1){
              //DO NOTHING, PROFILE FROM SOCIAL ACCOUNT
            }else{
              resp.profileImg = null;
            }
            
            if (resp.profileBanner && resp.profileBanner.indexOf('https://') == -1){
            resp.profileBanner = envService.read('IMG_DOMAIN') + "/" + resp.profileBanner;
            }else if (resp.profileBanner && resp.profileBanner.indexOf('https://') != -1){
              //DO NOTHING, PROFILE FROM SOCIAL ACCOUNT
            }else{
              resp.profileBanner = null;
            }
            $rootScope.viewOtherProfile = resp;
            //$rootScope.viewOtherProfile.profileBanner = "https://stylecarousel.com/landing/wp-content/uploads/2022/06/1-3.png";
            self.profileName = $rootScope.viewOtherProfile.username;
            self.getRentalListings();
            $anchorScroll('top');
          }
        },function(err){
          delete($rootScope.viewOtherProfile);
          if(utilities.isShowMainRegion()){
            $state.go('main');
          } else {
            $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
          }
        });
      }

      // var init
  	  $scope.params = {
  		  limit: 20,
  		  filters: [],
  		  sortBy: null,
  		  currentPage: 1,
  		  totalItems: 0
  	  };

      /////////////////////////////////////////////////
      //  GET THE INDEX OF THE DEFAULT SORT ITEM ON THE LIST
      /////////////////////////////////////////////////
      this.setSortListWithDefault = function(defaultKey){
        $scope.params.sortBy = $scope.sortByList.filter(p => p.KEY == defaultKey)[0];
      }

      /////////////////////////////////////////////////
      //  CHECK IF THE PRODUCT IS AVAILABLE FOR RENTAL
      /////////////////////////////////////////////////
      this.isAvailable = function (product){
        return utilities.isProductAvailableForRental(product);
      }

      //////////////////////////////////////////
      //  DELETE LISTINGS
      //////////////////////////////////////////
      this.removeListings = function(productID){
        var delete_product_id = productID;
        // Prompt dialog for user to confirm with deletion
        DialogAlertService.promptDialog('GENERAL.DIALOG_TITLE.CONFIRM_DELETE', 'lg', true, 'GENERAL.BUTTON.CANCEL', 'GENERAL.BUTTON.CONFIRM',
        function() {
          ListingService.deleteByProduct(delete_product_id).$promise.then(function(){
            $rootScope.enableLog ? $log.info($rootScope.UUID + ":rentalListings:removeListings - Deleted successfully " + productID):'';
            
            //$state.go("rental-listings", {}, {'reload' : true});
            if(utilities.isShowMainRegion()){
              $state.go("viewOtherUserRentalListings", {otherUsername:$state.params.otherUsername}, {'reload' : true});
            } else {
              $state.go("viewOtherUserRentalListings-multi-region", {country: $rootScope.geoLocation.country, otherUsername:$state.params.otherUsername}, {'reload' : true});
            }
          },
          function(err){
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":rentalListings:removeListings - Error delete " + delete_product_id + " : " + JSON.stringify(err)):'';
            DialogAlertService.promptDialog('Status of product (ID: '+ delete_product_id +') prevents deletion. Please contact admin for assistance. ', '', '', '', 'GENERAL.LABEL.OK', '', '', false,'',"RED");
          });
        });
      }

      
      //////////////////////////////////////////
      //  ADD / REMOVE COLLECTION
      //////////////////////////////////////////
      this.toggleCollection = function(product){
        self.displayedProductWishlist = false;
        if(self.displayedProductCollection == product.id && self.displayedProductCollection){
          self.displayedProductCollection = false;
        } else {
          self.displayedProductCollection = product.id;
        }
      }

      this.saveCollection = function(product, order, collection) {
        usSpinnerService.spin('spinner');
        var productCollection = {};
        if(collection.key == 'two-for-one'){
          productCollection.selected = !collection.selected;
        } else {
          productCollection.selected = order.feature;
        }
        productCollection.code = collection.key;
        productCollection.name = collection.key;
        productCollection.order = order.key;

        product.allCollections.forEach(function(c){
          if(c.key == collection.key){
            c.selected = productCollection.selected;
          }
        });

        var update_listing = {
          id: product.id,
          collection: productCollection
        };
        ListingService.updateCollection(update_listing).$promise.then(function(resp) {
          usSpinnerService.stop('spinner');
          product.existInCollection = resp.recommended;
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":toggleCollection - Listing updated successfully (" + update_listing.id + ")") : '';
        }, function(err) {
          usSpinnerService.stop('spinner');
          self.lk_listing = false;
          DialogAlertService.promptDialog('Add to collection failed. Please try again later.', '', '', '', '', '', '', true, '', 'RED');
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":toggleCollection - Listing edit error.") : '';
        })
      }
      //////////////////////////////////////////
      //  GET THE LIST OF USER POSTED LISTING
      //////////////////////////////////////////
      this.getRentalListings = function(pgNum) {
        usSpinnerService.spin('spinner');
        self.lk_retrieveListing = true;
        var filters = prepareParam({
          owner:self.profileName,
          page:pgNum,
          sort:$scope.params.sortBy.KEY,
          type:CONFIG.RENTAL_LISTING,
          brand: self.rentalFilter.brand,
          category: self.rentalFilter.category,
          subCategory: self.rentalFilter.subCategory,
          priceMin: self.rentalFilter.min,
          priceMax: self.rentalFilter.max,
          creditMin: self.rentalFilter.creditMin,
          creditMax: self.rentalFilter.creditMax,
          color: self.rentalFilter.color,
          size: self.rentalFilter.size, 
          itemCondition: self.rentalFilter.itemCondition,
          country: $rootScope.geoLocation.country,
          rentStatus: self.rentalFilter.rentStatus,
        });
        ListingService.getListingByOwner(filters).$promise.then(function(resp) {
            var finalProductList = [];
            var totalPageCount,totalRecordCount;

            //CHECK IF ITEM IS A LISTING. IF NOT REMOVE IT FROM THE LIST
            resp.forEach(function(item, index, arr) {
              if (!item['searchResult']) {
                item.type === CONFIG.RENTAL_LISTING ? finalProductList.push(item) : '';
                item._page = self.currentPageCount;
              } else {
                totalRecordCount = item['searchResult']['totalRecordCount'];
                totalPageCount = item['searchResult']['totalPageCount'];
                arr.pop();
              }
            });

            $scope.params.totalItems = totalRecordCount;

            var tmpResult = $scope.result ? angular.copy($scope.result) : [];
            $scope.result = tmpResult.concat(finalProductList);
            (self.currentPageCount >= totalPageCount || $scope.params.totalItems === 0) ? self.lk_loadMore = true: self.lk_loadMore = false;


            $scope.result.forEach(product => {
              product.hasSize = product.sizes.filter(s => s.available).length > 0;

              var allCollections = [];
              self.collectionList.forEach(c => {
                var collection = {};
                collection.key = c.key;
                collection.value = c.value;
                collection.order = c.order;
                if(c.key === "two-for-one"){
                  collection.selected = product.bundle;
                } else if(c.key === "main-collection"){
                  collection.selected = product.recommended;
                }
                allCollections.push(collection);
              });
              product.allCollections = allCollections;
              product.allCollections.sort(function(a, b){return a.position-b.position;});
            });


            $rootScope.enableLog ? $log.info($rootScope.UUID + ":rentalListings:getRentalListings - My Listing"):'';
            self.lk_retrieveListing = false;

            //SAVE THE LAST PRODUCT ID WHERE THE USER HAS SCROLLED TO, BEFORE THE NEW ITEMS LOADED
            //MOVE THE LIST BACK TO THE LAST POSITION. SCROLL TO THE TOP OF THE LIST FOR NEWLY SEARCH PAGE FOR MOBILE VIEW
            self.scrollLastItemID = tmpResult.length > 0 ? tmpResult[tmpResult.length-1].id : $scope.result.length > 0 && self.isMobileView() ? $scope.result[0].id : null;
            $timeout(function() {
              $anchorScroll(self.scrollLastItemID);
            }, 400);

            usSpinnerService.stop('spinner');
            setMetadata();
          }, function(err) {
            usSpinnerService.stop('spinner');
            lk_retrieveListing = false;
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":rentalListings:getRentalListings - Error: " + JSON.stringify(err)):'';
          });
      };

      //////////////////////////////////////////
      //  SHOW THE PRODUCT LISTING, BASED ON THE LISTING ID
      //////////////////////////////////////////
      this.showListing = function(productID, product) {
        var productBrand = utilities.getCustomBrandName(product);
        var urlSlug = utilities.getPrettyUrl(product.category.code, product.subCategory.code, productBrand, product.productLine);
        if(utilities.isShowMainRegion()){
          $state.go('listing', {id: productID, urlSlug: urlSlug});
        } else {
          $state.go('listing-multi-region', {id: productID, urlSlug: urlSlug, country: $rootScope.geoLocation.country});
        }
      };

      this.showListingByTransaction = function(productID, product, transactionType) {
        $rootScope.transactionType = transactionType;
        this.showListing(productID, product);
      };


      //////////////////////////////////////////
      //  APPLY ORDER BY FOR THE LISTING
      //////////////////////////////////////////
      $scope.sortProduct = function(sortBy) {
        $scope.params.sortBy = sortBy;

        //CLEAR THE PREVIOUS SEARCH RESULT AND CHANGE THE SORT ORDER.
        $scope.result = [];
        self.currentPageCount = 1;
        $scope.pageSelector_pgNum = self.currentPageCount;
        self.getRentalListings(self.currentPageCount);
      };

      //////////////////////////////////////////////////////////////////
      //ADD SPECIAL LOGIC WHEN USER ENTER OTHER BRAND, THE req_listing WILL REMAINS '-- OTHER BRAND --'
      //BUT THE ACTUAL BRAND WILL BE STORED IN TAG. HOWEVER IT WILL NOT GOING TO DISPLAY ON SCREEN.
      //////////////////////////////////////////////////////////////////
      this.getDisplayBrand = function(product){
        return utilities.getCustomBrandName(product);
      }

      // NO PAGING, WILL LOAD ALL THE ITEMS
      // $scope.maxSize = 5;
      // $scope.setPage = function(pageNo) {
		  // $scope.params.currentPage = pageNo;
      // };

      //////////////////////////////////////////
      //  GET RENTAL PRICE
      //////////////////////////////////////////
      this.getRentalPrice = function(price, discountRate) {
        return priceUtilities.getRentalPrice(price,discountRate);
      };

      //////////////////////////////////////////
      //  SHOW THE DISCOUNTED PRICE OF THE PRODUCT
      //////////////////////////////////////////
      function getTagPrice(price, discountRate) {
        return discountRate > 0 ? price*(1-discountRate) : price;
      };

      this.getDisplayTagOrigPrice = function(product){
        var price = priceUtilities.getAmountByRate(product.price);
        
        return priceUtilities.currencyFormat(Math.round(price));
      }

      //////////////////////////////////////////////////////////////////
      // UPDATE PAGINGATION IN THE SEARCH.COMPONENT WITH THE CURRENT PRODUCT
      // PAGE NUMBER AS IT DISPLAY ON SCREEN.
      //////////////////////////////////////////////////////////////////
      angular.element(window).bind('scroll', function (scope, element, attrs) {

        var domID;
        var pageNUM;
        var foundStartOfView = false;   //LOCATE THE START OF THE SCREEN WHERE USER INVIEW.

        if ($scope.result == undefined)
          return;

        //LOOP THRU ALL THE PRODUCTS RETURNED
        for (var i = 0; i < $scope.result.length; i++) {

          if ($window.document.getElementsByClassName('pageNum')[i] != undefined){
            //FOUND THE LOCATION ID OF EACH PRODUCT WHICH DEFINE IT IS STILL ON SCREEN.
            domID = $window.document.getElementsByClassName('pageNum')[i].getAttribute('id');

            if (!utilities.inViewPort(domID) && foundStartOfView){
              //THIS PRODUCT IS NO LONGER IN USER'S VIEW. EXIT THE SEARCH
              break;
            }else if(utilities.inViewPort(domID)){
              //THE CURRENT PRODUCT IS IN USER'S VIEW
              foundStartOfView = true;
              pageNUM = $window.document.getElementsByClassName('pageNum')[i].getAttribute('page');
            }
          }
        }

        //UPDATE THE SEARCH COMPONENT PAGINGATION PAGE NUM
        if (pageNUM && !isNaN(pageNUM)){
          $scope.pageSelector_pgNum = pageNUM;
          $scope.$apply();
        }
      });


      ////////////////////////////
      //  SCROLL DOWN TO LOAD MORE
      ////////////////////////////
      this.loadMoreListings = function() {
        if (!self.lk_loadMore && !self.lk_retrieveListing && self.currentPageCount) {
          self.lk_loadMore = true;
          self.currentPageCount++;
          $scope.pageSelector_pgNum = self.currentPageCount;
          $scope.params.currentPage = self.currentPageCount;
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":rentalListingsCtrl:loadMoreListings - Loading more rental listing from page " + self.currentPageCount) : '';
          Session.prev_ListingParams = angular.copy(self.prev_ListingParams_local);
          self.getRentalListings(self.currentPageCount);
        }
      };

      ////////////////////////////
      // REFRESH THE SERACH RESULT
      // BASED ON THE PAGE CLICK
      ////////////////////////////
      self.pageSelectorClick = function(){
        Session.prev_ListingResult = [];
        $scope.result = [];
        $scope.params.currentPage = $scope.pageSelector_pgNum;
        self.currentPageCount = $scope.params.currentPage;
        var searchParams = self.prev_ListingParams_local ? self.prev_ListingParams_local : Session.prev_ListingParams;
        self.getRentalListings($scope.pageSelector_pgNum);
      }

      ////////////////////////////
      // DETECT MOBILE VIEW
      ////////////////////////////
      self.isMobileView = function(){
        return utilities.isMobileView();
      }

      ////////////////////////////
      //  CONVERT THE URL PARAMETERS TO SERVICE API PARAMETERS
      ////////////////////////////
      function prepareParam(params) {
        return {
          owner:params.owner,
          brand: params.brand,
          category: params.category,
          subCategory: params.subCategory,
          priceMin: params.min,
          priceMax: params.max,
          rentalFeeMin: params.feeMin,
          rentalFeeMax: params.feeMax,
          creditMin: params.creditMin,
          creditMax: params.creditMax,
          color: params.color,
          rentStatus: params.rentStatus,
          sort: params.sort,
          size: params.size,
          discountRateMin: params.fdmin,
          discountRateMax: params.fdmax,
          page: params.page,
          tags: params.q,
          types: params.type,
          itemCondition: params.itemCondition,
          country: $rootScope.geoLocation.country
        };
      }


    function setMetadata() {
      var metaKeywords = ["Rent", "Buy", "Style Carousel", "StyleCarousel"];
      var metaBrand;
      if($state.params.otherUsername){
        //Brand
        metaBrand = $state.params.otherUsername;
        metaKeywords.push($state.params.otherUsername);
      }

      var noStyleNotes = $translate.instant('LISTING.LABEL.NO_STYLE_NOTES', {brand: metaBrand});
      var metadata = {
        description : metaBrand ? noStyleNotes : "",
        keywords : metaBrand ? metaKeywords.join(",") : "",
        title : metaBrand ? "Rent | " + utilities.capitalizeFirstLetter(metaBrand) + " " + " at Style Carousel" : "",
      };
      SeoService.setMetaDataTags(metadata);
    };

    $rootScope.$on("CallFilterRentals", function(evt, data){
      $scope.result = []
      if(data) {
        self.rentalFilter = {};
        self.rentalFilter.brand = data.brand,
        self.rentalFilter.category = data.category,
        self.rentalFilter.subCategory = data.subCategory,
        self.rentalFilter.min = data.min,
        self.rentalFilter.max = data.max,
        self.rentalFilter.creditMin = data.creditMin,
        self.rentalFilter.creditMax = data.creditMax,
        self.rentalFilter.color = data.color,
        self.rentalFilter.size = data.size,
        self.rentalFilter.itemCondition = data.itemCondition,
        self.rentalFilter.rentStatus = data.status
      }
      self.getRentalListings();
    });
    
    
    this.getDisplayPrice = function(product) {
      return priceUtilities.getDisplayPriceV2(product);
    }

    this.getDisplayPurchasePrice = function(product) {
      return priceUtilities.getDisplayPurchasePriceV2(product);
    }

    this.getDisplayPhoto = function(product, position){
      return utilities.getDisplayPhoto(product, position);
    }
    
    this.toggleWishlist = function(product) {
      self.displayedProductWishlist = product.id;
      self.isWishlistDisabled = true;
      var allSizes = product.sizes;
      for (var index in allSizes) {
        var sizeWishlist = allSizes[index].wishlist;
        if(sizeWishlist){
          self.isWishlistDisabled = false;
          break;
        }
      }
    }


    this.saveWishlist = function(product){
      DialogAlertService.saveWishlist(product);
    }
    
    this.isSalePriceSameWithOrigPrice = function(product){
      return priceUtilities.isSalePriceSameWithOrigPrice(product.price, product.discountRate)
    }

    this.getProductWith = function(){
      if(utilities.isShowMainRegion()){
        $state.go('search', {q:self.shopName,mm:true,brand: null,category: null,min: CONFIG.PRICE_MIN,max: CONFIG.PRICE_MAX,fdmin: null,fdmax: null,feeMin:null,feeMax:null,fp: null,type:CONFIG.DEFAULT_SEARCH_TYPE,page:null,status:null,sort:CONFIG.DEFAULT_SEARCH_SORT_ORDER,color:null,size:null});
      } else {
        $state.go('search-multi-region', {q:self.shopName,mm:true,brand: null,category: null,min: CONFIG.PRICE_MIN,max: CONFIG.PRICE_MAX,fdmin: null,fdmax: null,feeMin:null,feeMax:null,fp: null,type:CONFIG.DEFAULT_SEARCH_TYPE,page:null,status:null,sort:CONFIG.DEFAULT_SEARCH_SORT_ORDER,color:null,size:null,country: $rootScope.geoLocation.country});
      }
    }


    this.isPriceDisplay = function(){
      return priceUtilities.isPriceDisplay();
    }


    this.getDisplayRentalPrice = function(product) {
      return priceUtilities.getListingRentalPrice(product, 1);
    }
    
    }]
})

'use strict';
angular.module('coutureApp')
  .component('rentalListingFilter', {
    controllerAs : 'rentalListingFilterCtrl',
    templateUrl: 'scripts/components/profile/rental-listings/components/rental-listing-filter.html',
    controller: ["$rootScope", "$scope", "$state", "CartService", "AuthService", "utilities", "$filter", "ListingService", "FavoriteService", "$http", "DialogAlertService", "$anchorScroll", "Session", "usSpinnerService", "$location", "$log", "$injector", "USER_ROLES", "$translatePartialLoader", "RefDataService", "menuBarsService", "RentalService", "CONFIG", "$timeout", "authCheck", "$translate", "SeoService", "CalendarService", function($rootScope, $scope, $state, CartService, AuthService, utilities, $filter, ListingService, FavoriteService,
      $http, DialogAlertService, $anchorScroll, Session, usSpinnerService, $location, $log,$injector,USER_ROLES,
      $translatePartialLoader, RefDataService, menuBarsService, RentalService,CONFIG,$timeout,authCheck,$translate,SeoService,CalendarService) {
  
      var self = this;
  
      // Double submit locks
      self.lk_search = false;
      self.lk_get = false;
      self.lk_fav = false;
      self.lk_del = false;
      self.lk_loadMore = true; // Prevent loading of more results initially
      self.scrollLastItemID = null;
  
      // Search result
      self.result = [];
      self.originalResult = [];
  
      // Controller level trigger to allow/prevent repeated search, e.g. view change
      self.prev_searchParams_local = null;
  
      // Configurations
      self.noWrap = false; // Repeat image loop?
      self.accordionDetailsOpen = true;
      self.ratingMax = 5;
      self.ratingReadOnly = false;
      $scope.isSideFilterActive = true;
      $scope.selectedFilterCategory = null;
      $scope.selectedCategoryItem = [];
      $scope.pageSelector_maxSize = 3;
      $scope.pageSelector_itemPerPage = CONFIG.ITEM_PER_PAGE;
      $scope.topFilter = {
        earliestFilter: false,
        date: false,
        size: false
      };
      self.unavailableDates = {};
      $scope.isDateSelected = false;
      $scope.events = [];
      $scope.calendarView = 'month';
      $scope.viewDate = new Date(moment().startOf('month').format('LLLL'));
      $scope.currentMonth = moment($scope.viewDate).format('MMMM');
  
      var expectedDeliveryDateInDays = 0;
      var EndDateInDays = CONFIG.DEFAULT_RENTAL_DURATION;
  
      //Filter Brand, Filter Category, Filter Price Min, etc
      //Can be "latest", "priceAsc", "priceDesc", "brandAsc", "brandDesc".  Default is "latest", which sort descendingly by modified and creation date.
      self.filtersParams = {
        brand: undefined,
        category: undefined,
        subCategory: undefined,
        min: CONFIG.PRICE_MIN, //TODO: integrate with registration changes
        max: CONFIG.PRICE_MAX, //TODO: integrate with registration changes
        creditMin: CONFIG.CREDIT_MIN,
        creditMax: CONFIG.CREDIT_MAX,
        feeMin: undefined,
        feeMax: undefined,
        color: undefined,
        status: undefined,
        sort: CONFIG.DEFAULT_SEARCH_SORT_ORDER,
        size: undefined,
        fdmin: undefined,
        fdmax: undefined,
        page: "1",
        q: undefined,
        type: CONFIG.DEFAULT_SEARCH_TYPE,
        startDate: null,
        endDate: null,
        country: $rootScope.geoLocation.country,
        itemCondition: null
      };
  
      //////////////////////////////////////////
      // PAGE INITIALIZE METHOD
      //////////////////////////////////////////
      this.$onInit = function() {
  
        $scope.params = {
          limit: 20,
          query: $state.params.q,
          filters: [],
          sortBy: null,
          currentPage: 1,
          totalItems: 0,
          priceFilter: {
            min: CONFIG.PRICE_MIN,
            max: CONFIG.PRICE_MAX
          },
          creditFilter: {
            min: CONFIG.CREDIT_MIN,
            max: CONFIG.CREDIT_MAX
          }
        };
  
        //SET THE FILTER DEFAULT VALUE
        $scope.slider = {
          minValue: CONFIG.PRICE_MIN,
          maxValue: CONFIG.PRICE_MAX,
          options: {
            floor: parseInt(CONFIG.PRICE_MIN),
            ceil: parseInt(CONFIG.PRICE_MAX),
            step: 1000,
            logScale: true,
            translate: function(value, sliderId, label) {
              switch (label) {
                case 'model':
                  $scope.params.priceFilter.min = value;
                  break;
  
                case 'high':
                  $scope.params.priceFilter.max = value;
                  break;
              }
              return $filter('currency')(value, '$', 0);
            }
          }
        };
  
        //SET THE FILTER DEFAULT VALUE
        $scope.creditSlider = {
          minValue: CONFIG.CREDIT_MIN,
          maxValue: CONFIG.CREDIT_MAX,
          options: {
            floor: parseInt(CONFIG.CREDIT_MIN),
            ceil: parseInt(CONFIG.CREDIT_MAX),
            step: 1,
            logScale: true,
            translate: function(value, sliderId, label) {
              switch (label) {
                case 'model':
                  $scope.params.creditFilter.min = value;
                  break;
  
                case 'high':
                  $scope.params.creditFilter.max = value;
                  break;
              }
              return value;
            }
          }
        };
  
  
        self.sortByList = RefDataService.getSortByList_Listings();
        $scope.params.sortBy = self.sortByList.filter(p => p.KEY == CONFIG.DEFAULT_SEARCH_SORT_ORDER)[0];
  
        loadFilter();
  
        self.sizeList = RefDataService.getSizeFlatList();
        self.allCategorySizes = RefDataService.getSizeList();
        self.itemConditionFilterList = RefDataService.getItemConditionsFilter();
        
        self.filtersParams.country = $rootScope.geoLocation.country;
  
        self.isOwner = $rootScope.isLogon && ($state.includes('rental-listings') || $state.includes('rental-listings-multi-region') || $state.includes('buy-listings') || $state.includes('buy-listings-multi-region'));
      };
  
      ////////////////////////////
      //  LOAD UP ALL FILTER OPTIONS
      ////////////////////////////
      function loadFilter() {
        // GET SEARCH FITLER AND SORTING DATA AS A JSON
        $http.get('scripts/config/search-filters.json').then(function successCallback(response) {
          self.filterList = response.data.filterList;
  
          //REPLACE THE FILTER CATEGORY LIST
          RefDataService.getCategories().$promise.then(function(resp) {
            var tempCat = [];
            resp.forEach(function(item, index) {
              var tempSubCat = [];
              var subCategories = item.subCategory;
  
              if(subCategories.length > 0){
                subCategories.forEach(function(subItem, subIndex) {
                  tempSubCat.push({
                    key: subItem.id,
                    value: subItem.name,
                    position : subItem.position,
                    level : subItem.level
                  });
                });
              }
  
              tempCat.push({
                key: item.id,
                value: item.name,
                position : item.position,
                subCategories : tempSubCat,
                level : item.level
              });
  
            });
            (self.filterList && self.filterList[0].title.toUpperCase() === "category".toUpperCase()) ? self.filterList[0].keywords = tempCat: '';
          });
  
          //REPLACE THE FILTER DESIGNER LIST
          RefDataService.getSelectedBrands($rootScope.filterDesignerByOwner).$promise.then(function(resp) {
            self.brandList = resp;
            var brandArray = [];
            resp.forEach(function(item, index) {
              brandArray.push({
                key: item,
                value: item,
                plainTextValue: item.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
              });
            });
            (self.filterList && self.filterList[3].title.toUpperCase() === "designer".toUpperCase()) ? self.filterList[3].keywords = brandArray: '';
          });
  
          //REPLACE THE FILTER COLOR LIST
          var colorArray = [];
          utilities.getColorList().forEach(function(item, index) {
            colorArray.push({
              key: item.id,
              value: item.name
            });
          });
          (self.filterList && self.filterList[2].title.toUpperCase() === "Color".toUpperCase()) ? self.filterList[2].keywords = colorArray: '';
  
          //REPLACE THE FILTER SIZE LIST
          var sizeArray = [];
          RefDataService.getSizeList().$promise.then(function(resp){
            resp.forEach(function(item, index) {
              sizeArray.push({
                key: item.category,
                value: item.options
              });
            });
          });
          (self.filterList && self.filterList[1].title.toUpperCase() === "Size".toUpperCase()) ? self.filterList[1].keywords = sizeArray: '';
  
          var itemConditionArray = []
          RefDataService.getItemConditionsFilter().forEach(function(item, index) {
            itemConditionArray.push({
              key: item.key,
              value: item.value
            });
          });
          (self.filterList && self.filterList[7].title.toUpperCase() === "Item Condition".toUpperCase()) ? self.filterList[7].keywords = itemConditionArray: '';

        }, function errorCallback(response) {
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":rentalListingFilterCtrl:onInit - Error loading filter: " + response.statusText) : '';
        });
      }
  
  
  
      ////////////////////////////
      //  TOOGLE TO SHOW AND HIDE THE  FILTER BAR
      ////////////////////////////
      $scope.toggleFilter = function(params) {
  
        if (params.selected) {
          let index = $scope.params.filters.map(function(o) {
            return String(o.key) === String(params.key)? o.value.key : '';
          }).indexOf(params.value.key);
          if (index !== -1) {
            $scope.params.filters.splice(index, 1);
          }
  
        } else if (params.value) {
  
          $scope.params.filters.push({
            key: params.key,
            value: params.value
          });
        }
        $rootScope.enableLog ? $log.info($rootScope.UUID + ":rentalListingFilterCtrl:$toggleFilter(scope.params) - " + JSON.stringify($scope.params.filters)) : '';
        return params.selected = !params.selected;
      };
  
      $scope.toggleFilterCategory = function(params, hasSubCategory) {
        if(hasSubCategory){
          var selectedSubCategories = $scope.params.filters.filter(p => p.value.level > 1);
          if(selectedSubCategories.length > 0 && !params.selected){
            return $scope.toggleFilter(params);
          } else {
            return $scope.toggleFilter(params);
          }
        } else {
          return $scope.toggleFilter(params);
        }
      }
  
      $scope.toggleFilterSubCategory = function(paramsSubCategory, paramsRootCategory) {
        var isSubCategorySelected = $scope.toggleFilter(paramsSubCategory);
        var selectedSubCategories = $scope.params.filters.filter(p => p.value.level > 1);
  
        if(isSubCategorySelected && paramsRootCategory.selected){
          return true;
        }
  
        if(selectedSubCategories.length == 0){
          return $scope.toggleFilter(paramsRootCategory);
        }
  
        return isSubCategorySelected;
      }
  
  
      ////////////////////////////
      //  CHECK IF THE FILTER IS BEING SELECTED.
      ////////////////////////////
      self.isFilterSelected = function(filterOptionKey,selectedOptionKey){
        var isSelected = false;
        $scope.params.filters.forEach(function(current,index,array){
          if (current.key === String(filterOptionKey) && selectedOptionKey.key === current.value.key){
            isSelected = true;
          }
        })
        return isSelected;
      }
  
      self.isFilterSelectedCategory = function(filterOptionKey, selectedOptionKey, hasSubCategory) {
        if(hasSubCategory){
          var selectedSubCategories = $scope.params.filters.filter(p => p.value.level > 1);
          var selected = selectedSubCategories.length > 0;
          return selected;
        } else {
          return self.isFilterSelected(filterOptionKey, selectedOptionKey);
        }
      }
  
      ////////////////////////////
      //  APPLY SEARCH FILTERS
      ////////////////////////////
      self.applyFilters = function() {
        setFilterParams();
        if($location.path().includes('rental-listings')) {
          $rootScope.$emit("CallFilterRentals", self.filtersParams);
        } else if($location.path().includes('buy-listings')) {
          $rootScope.$emit("CallFilterBuy", self.filtersParams);
        } else if($location.path().includes('deleted-listings')) {
          $rootScope.$emit("CallFilterDeleted", self.filtersParams);
        } else if($location.path().includes('style-post')) {
          $rootScope.$emit("CallFilterStylePost", self.filtersParams);
        }
      }
  
      ////////////////////////////
      //  APPLY SEARCH FILTERS
      ////////////////////////////
      function setFilterParams(){
        $rootScope.enableLog ? $log.info($rootScope.UUID + ":rentalListingFilterCtrl:setFilterParams") : '';
  
        self.filtersParams.min = String($scope.params.priceFilter.min);
        self.filtersParams.max = String($scope.params.priceFilter.max);
        self.filtersParams.creditMin = String($scope.params.creditFilter.min);
        self.filtersParams.creditMax = String($scope.params.creditFilter.max);
  
        // THE FILTER PARAMETERS, AS THESE ARE MULTI-SELECT VALUE
        self.filtersParams.category = undefined;
        self.filtersParams.subCategory = undefined;
        self.filtersParams.sort = undefined;
        self.filtersParams.color = undefined;
        self.filtersParams.brand = undefined;
        self.filtersParams.size = undefined;
        self.filtersParams.status = undefined;
        self.filtersParams.type = CONFIG.DEFAULT_SEARCH_TYPE;
        self.filtersParams.startDate = null;
        self.filtersParams.endDate = null;
        self.filtersParams.country = $rootScope.geoLocation.country;
  
        //LOOP THRU ALL FILTER PARAMETERS
        for (var item in $scope.params.filters) {
  
          //THE SELECTED FILTER OPTIONS. EG. CATEGORY, COLOR, DESIGNER, RENTAL
          var selectedItem = $scope.params.filters[item].value;
  
          switch ($scope.params.filters[item].key) {
  
            //CATEGORY
            case "0":
              if(selectedItem.level == 1){
                self.filtersParams.category = self.filtersParams.category ? self.filtersParams.category + "|" + $scope.params.filters[item].value.value : $scope.params.filters[item].value.value;
              } else {
                self.filtersParams.subCategory = self.filtersParams.subCategory ? self.filtersParams.subCategory + "|" + $scope.params.filters[item].value.value : $scope.params.filters[item].value.value;
              }
              break;
  
              //SIZE
            case "1":
              self.filtersParams.size = self.filtersParams.size ? self.filtersParams.size + "|" + $scope.params.filters[item].value.key : $scope.params.filters[item].value.key;
              break;
  
              //COLOR
            case "2":
              self.filtersParams.color = self.filtersParams.color ? self.filtersParams.color + "|" + $scope.params.filters[item].value.value : $scope.params.filters[item].value.value;
              break;
  
              //DESIGNER/BRAND
            case "3":
              self.filtersParams.brand = self.filtersParams.brand ? self.filtersParams.brand + "|" + $scope.params.filters[item].value.value : $scope.params.filters[item].value.value;
              break;
  
              //RENTAL
            case "4":
              //"instant" (Instant Rental), "rental" (Rental Request), "rented" (Checked Out)
              switch ($scope.params.filters[item].value.key) {
                case "IR":
                  self.filtersParams.status = self.filtersParams.status ? self.filtersParams.status + "|" + "instant" : self.filtersParams.status = "instant";
                  break;
  
                case "RR":
                  self.filtersParams.status = self.filtersParams.status ? self.filtersParams.status + "|" + "rental" : self.filtersParams.status = "rental";
                  break;
  
                case "CO":
                  self.filtersParams.status = self.filtersParams.status ? self.filtersParams.status + "|" + "rented" : self.filtersParams.status = "rented";
                  break;
              };
              break;
  
            //VIEW
            case "5":
              self.filtersParams.type = self.filtersParams.type = '1' ? self.filtersParams.type = "1|2" : self.filtersParams.type = '1';
              break;
  
            case "6":
              switch ($scope.params.filters[item].value.key) {
                case "StartDate":
                  self.filtersParams.startDate  = $scope.params.filters[item].value.value;
                  break;
                case "EndDate":
                  self.filtersParams.endDate  =$scope.params.filters[item].value.value;
                  break;
              }
              break;

            //ITEM CONDITION
            case "7":
              self.filtersParams.itemCondition = self.filtersParams.itemCondition ? self.filtersParams.itemCondition + "|" + $scope.params.filters[item].value.value : $scope.params.filters[item].value.value;
            break;
  
          };
        }
  
        self.filtersParams.sort = $scope.params.sortBy.KEY;
      }
  
  
      ////////////////////////////
      //  CLEAR FILTERS
      ////////////////////////////
      self.clearFilters = function() {
        $rootScope.enableLog ? $log.info($rootScope.UUID + ":rentalListingFilterCtrl:clearFilters") : '';
        $scope.params.filters = [];
        self.filtersParams.category = undefined;
        self.filtersParams.subCategory = undefined;
        self.filtersParams.color = undefined;
        self.filtersParams.brand = undefined;
        self.filtersParams.size = undefined;
        self.filtersParams.status = undefined;
        self.filtersParams.startDate = null;
        self.filtersParams.endDate = null;
        self.filtersParams.country = $rootScope.geoLocation.country;
        self.filtersParams.min = CONFIG.PRICE_MIN;
        self.filtersParams.max = CONFIG.PRICE_MAX;
        self.filtersParams.creditMin = CONFIG.CREDIT_MIN;
        self.filtersParams.creditMax = CONFIG.CREDIT_MAX;
        self.filtersParams.page = "1";
        self.filtersParams.sort = $scope.params.sortBy.KEY;
        self.filtersParams.type = CONFIG.DEFAULT_SEARCH_TYPE;
        self.filtersParams.itemCondition = null;
        if($location.path().includes('rental-listings')) {
          $rootScope.$emit("CallFilterRentals", self.filtersParams);
        } else {
          $rootScope.$emit("CallFilterBuy", self.filtersParams);
        }
      };

      $scope.toggleSideFilter = function() {
        utilities.goToTop();
      };
    }]
})

'use strict';
angular.module('coutureApp')
  .component('buyListings', {
    controllerAs : 'buyListingsCtrl',
    templateUrl: 'scripts/components/profile/buy-listings/buy-listings.html',
    controller: ["$rootScope", "$scope", "$state", "$stateParams", "$http", "RefDataService", "ListingService", "DialogAlertService", "utilities", "priceUtilities", "usSpinnerService", "$log", "CONFIG", "Session", "UserService", "$timeout", "$anchorScroll", "$window", "envService", "$translate", "SeoService", "AuthService", "USER_ROLES", function($rootScope,$scope, $state, $stateParams, $http,RefDataService,ListingService,DialogAlertService,
      utilities, priceUtilities,usSpinnerService,$log,CONFIG,Session,UserService,$timeout,$anchorScroll,$window,envService,$translate,SeoService,AuthService, USER_ROLES) {

      var self= this;

      this.$onInit = function(){
        $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - buyListings"):'';
        self.allCategorySizes = RefDataService.getSizeList();
        self.rentalFilter = {};

        $rootScope.transactionType = CONFIG.TRANSACTION_TYPE_BUY;
        $scope.pageSelector_pgNum = 1;
        self.currentPageCount = 1;
        self.lk_loadMore = true; // Prevent loading of more results initially
        $scope.sortByList = RefDataService.getSortByList_Listings();
        self.setSortListWithDefault(CONFIG.DEFAULT_SORT_RENTAL_LISTING);
        $scope.productOptions = RefDataService.GetProductOptionsLabel();
        self.proudct_currency = priceUtilities.getCurrency();
        $scope.pageSelector_maxSize = 3;
        $scope.pageSelector_itemPerPage = CONFIG.ITEM_PER_PAGE;
        self.availableForRegion = utilities.isFunctionEnabled();
        self.collectionList = RefDataService.getCollections();

        self.isOwner = false;

        $scope.isAdmin = false;
        if (AuthService.isAuthorized(USER_ROLES.admin)){
          $scope.isAdmin = true;
        } 
        self.shopName = $state.params.otherUsername == null ? $rootScope.user.username : $state.params.otherUsername;
        self.buttonName = "See all " + self.shopName + " on Style Carousel";
        $rootScope.filterDesignerByOwner = null;

        if ($state.params.otherUsername == null && !$rootScope.isLogon){
          //NOT ALLOWED TO TYPE IN URL DIRECTLY
          $state.go('main');
        }else if ($state.params.otherUsername){

          $rootScope.filterDesignerByOwner = $state.params.otherUsername;
          loadOtherUserProfile();
        }else if ($rootScope.isLogon){
          self.profileName = $rootScope.user.username;
          $rootScope.filterDesignerByOwner = $rootScope.user.username;
          self.isOwner = true;
          self.getBuyListings($scope.pageSelector_pgNum);
        }
      }

      //////////////////////////////////////////
      //  LOAD RENTAL LISTING FOR OTHER PROFILE.
      //////////////////////////////////////////
      function loadOtherUserProfile(){
        UserService.isUserExists($state.params.otherUsername).$promise.then(function(resp){
          var otherUser = $state.params.otherUsername ? $state.params.otherUsername.toLowerCase() : "";
          var currentUser = $rootScope.isLogon ? ($rootScope.user.username ? $rootScope.user.username.toLowerCase() : "") : "";
          var isShopOwner = currentUser == otherUser;
          if(CONFIG.COUNTRY_CURRENCY_CODE.AU.country_code == $rootScope.geoLocation.country 
            && !resp.australiaStoreEnabled 
            && !isShopOwner){
            $state.go('main');
          } else {
            if (resp.profileImg && resp.profileImg.indexOf('https://') == -1){
              resp.profileImg = envService.read('IMG_DOMAIN') + "/" + resp.profileImg;
            }else if (resp.profileImg && resp.profileImg.indexOf('https://') != -1){
              //DO NOTHING, PROFILE FROM SOCIAL ACCOUNT
            }else{
              resp.profileImg = null;
            }
            
            if (resp.profileBanner && resp.profileBanner.indexOf('https://') == -1){
            resp.profileBanner = envService.read('IMG_DOMAIN') + "/" + resp.profileBanner;
            }else if (resp.profileBanner && resp.profileBanner.indexOf('https://') != -1){
              //DO NOTHING, PROFILE FROM SOCIAL ACCOUNT
            }else{
              resp.profileBanner = null;
            }
            $rootScope.viewOtherProfile = resp;
            //$rootScope.viewOtherProfile.profileBanner = "https://stylecarousel.com/landing/wp-content/uploads/2022/06/1-3.png";
            self.profileName = $rootScope.viewOtherProfile.username;
            self.getBuyListings();
            $anchorScroll('top');
          }
        },function(err){
          delete($rootScope.viewOtherProfile);
          if(utilities.isShowMainRegion()){
            $state.go('main');
          } else {
            $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
          }
        });
      }

      // var init
  	  $scope.params = {
  		  limit: 20,
  		  filters: [],
  		  sortBy: null,
  		  currentPage: 1,
  		  totalItems: 0
  	  };

      /////////////////////////////////////////////////
      //  GET THE INDEX OF THE DEFAULT SORT ITEM ON THE LIST
      /////////////////////////////////////////////////
      this.setSortListWithDefault = function(defaultKey){
        $scope.params.sortBy = $scope.sortByList.filter(p => p.KEY == defaultKey)[0];
      }

      /////////////////////////////////////////////////
      //  CHECK IF THE PRODUCT IS AVAILABLE FOR RENTAL
      /////////////////////////////////////////////////
      this.isAvailable = function (product){
        return utilities.isProductAvailableForRental(product);
      }

      //////////////////////////////////////////
      //  DELETE LISTINGS
      //////////////////////////////////////////
      this.removeListings = function(productID){
        var delete_product_id = productID;
        // Prompt dialog for user to confirm with deletion
        DialogAlertService.promptDialog('GENERAL.DIALOG_TITLE.CONFIRM_DELETE', 'lg', true, 'GENERAL.BUTTON.CANCEL', 'GENERAL.BUTTON.CONFIRM',
        function() {
          ListingService.deleteByProduct(delete_product_id).$promise.then(function(){
            $rootScope.enableLog ? $log.info($rootScope.UUID + ":buyListings:removeListings - Deleted successfully " + productID):'';
            
            //$state.go("rental-listings", {}, {'reload' : true});
            if(utilities.isShowMainRegion()){
              $state.go("viewOtherUserbuyListings", {otherUsername:$state.params.otherUsername}, {'reload' : true});
            } else {
              $state.go("viewOtherUserbuyListings-multi-region", {country: $rootScope.geoLocation.country, otherUsername:$state.params.otherUsername}, {'reload' : true});
            }
          },
          function(err){
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":buyListings:removeListings - Error delete " + delete_product_id + " : " + JSON.stringify(err)):'';
            DialogAlertService.promptDialog('Status of product (ID: '+ delete_product_id +') prevents deletion. Please contact admin for assistance. ', '', '', '', 'GENERAL.LABEL.OK', '', '', false,'',"RED");
          });
        });
      }

      
      //////////////////////////////////////////
      //  ADD / REMOVE COLLECTION
      //////////////////////////////////////////
      this.toggleCollection = function(product){
        self.displayedProductWishlist = false;
        if(self.displayedProductCollection == product.id && self.displayedProductCollection){
          self.displayedProductCollection = false;
        } else {
          self.displayedProductCollection = product.id;
        }
      }

      this.saveCollection = function(product, order, collection) {
        usSpinnerService.spin('spinner');
        var productCollection = {};
        if(collection.key == 'two-for-one'){
          productCollection.selected = !collection.selected;
        } else {
          productCollection.selected = order.feature;
        }
        productCollection.code = collection.key;
        productCollection.name = collection.key;
        productCollection.order = order.key;

        product.allCollections.forEach(function(c){
          if(c.key == collection.key){
            c.selected = productCollection.selected;
          }
        });

        var update_listing = {
          id: product.id,
          collection: productCollection
        };
        ListingService.updateCollection(update_listing).$promise.then(function(resp) {
          usSpinnerService.stop('spinner');
          product.existInCollection = resp.recommended;
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":toggleCollection - Listing updated successfully (" + update_listing.id + ")") : '';
        }, function(err) {
          usSpinnerService.stop('spinner');
          self.lk_listing = false;
          DialogAlertService.promptDialog('Add to collection failed. Please try again later.', '', '', '', '', '', '', true, '', 'RED');
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":toggleCollection - Listing edit error.") : '';
        })
      }
      //////////////////////////////////////////
      //  GET THE LIST OF USER POSTED LISTING
      //////////////////////////////////////////
      this.getBuyListings = function(pgNum) {
        usSpinnerService.spin('spinner');
        self.lk_retrieveListing = true;
        var filters = prepareParam({
          owner:self.profileName,
          page:pgNum,
          sort:$scope.params.sortBy.KEY,
          type:CONFIG.RENTAL_LISTING,
          brand: self.rentalFilter.brand,
          category: self.rentalFilter.category,
          subCategory: self.rentalFilter.subCategory,
          priceMin: self.rentalFilter.min,
          priceMax: self.rentalFilter.max,
          creditMin: self.rentalFilter.creditMin,
          creditMax: self.rentalFilter.creditMax,
          color: self.rentalFilter.color,
          size: self.rentalFilter.size, 
          itemCondition: self.rentalFilter.itemCondition,
          country: $rootScope.geoLocation.country,
          rentStatus: self.rentalFilter.rentStatus,
        });
        ListingService.getListingByOwner(filters).$promise.then(function(resp) {
            var finalProductList = [];
            var totalPageCount,totalRecordCount;

            //CHECK IF ITEM IS A LISTING. IF NOT REMOVE IT FROM THE LIST
            resp.forEach(function(item, index, arr) {
              if (!item['searchResult']) {
                item.type === CONFIG.RENTAL_LISTING ? finalProductList.push(item) : '';
                item._page = self.currentPageCount;
              } else {
                totalRecordCount = item['searchResult']['totalRecordCount'];
                totalPageCount = item['searchResult']['totalPageCount'];
                arr.pop();
              }
            });

            $scope.params.totalItems = totalRecordCount;

            var tmpResult = $scope.result ? angular.copy($scope.result) : [];
            $scope.result = tmpResult.concat(finalProductList);
            (self.currentPageCount >= totalPageCount || $scope.params.totalItems === 0) ? self.lk_loadMore = true: self.lk_loadMore = false;


            $scope.result.forEach(product => {
              product.hasSize = product.sizes.filter(s => s.available).length > 0;

              var allCollections = [];
              self.collectionList.forEach(c => {
                var collection = {};
                collection.key = c.key;
                collection.value = c.value;
                collection.order = c.order;
                if(c.key === "two-for-one"){
                  collection.selected = product.bundle;
                } else if(c.key === "main-collection"){
                  collection.selected = product.recommended;
                }
                allCollections.push(collection);
              });
              product.allCollections = allCollections;
              product.allCollections.sort(function(a, b){return a.position-b.position;});
            });


            $rootScope.enableLog ? $log.info($rootScope.UUID + ":buyListings:getBuyListings - My Listing"):'';
            self.lk_retrieveListing = false;

            //SAVE THE LAST PRODUCT ID WHERE THE USER HAS SCROLLED TO, BEFORE THE NEW ITEMS LOADED
            //MOVE THE LIST BACK TO THE LAST POSITION. SCROLL TO THE TOP OF THE LIST FOR NEWLY SEARCH PAGE FOR MOBILE VIEW
            self.scrollLastItemID = tmpResult.length > 0 ? tmpResult[tmpResult.length-1].id : $scope.result.length > 0 && self.isMobileView() ? $scope.result[0].id : null;
            $timeout(function() {
              $anchorScroll(self.scrollLastItemID);
            }, 400);

            usSpinnerService.stop('spinner');
            setMetadata();
          }, function(err) {
            usSpinnerService.stop('spinner');
            lk_retrieveListing = false;
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":buyListings:getBuyListings - Error: " + JSON.stringify(err)):'';
          });
      };

      //////////////////////////////////////////
      //  SHOW THE PRODUCT LISTING, BASED ON THE LISTING ID
      //////////////////////////////////////////
      this.showListing = function(productID, product) {
        var productBrand = utilities.getCustomBrandName(product);
        var urlSlug = utilities.getPrettyUrl(product.category.code, product.subCategory.code, productBrand, product.productLine);
        if(utilities.isShowMainRegion()){
          $state.go('listing', {id: productID, urlSlug: urlSlug});
        } else {
          $state.go('listing-multi-region', {id: productID, urlSlug: urlSlug, country: $rootScope.geoLocation.country});
        }
      };

      this.showListingByTransaction = function(productID, product, transactionType) {
        $rootScope.transactionType = transactionType;
        this.showListing(productID, product);
      };


      //////////////////////////////////////////
      //  APPLY ORDER BY FOR THE LISTING
      //////////////////////////////////////////
      $scope.sortProduct = function(sortBy) {
        $scope.params.sortBy = sortBy;

        //CLEAR THE PREVIOUS SEARCH RESULT AND CHANGE THE SORT ORDER.
        $scope.result = [];
        self.currentPageCount = 1;
        $scope.pageSelector_pgNum = self.currentPageCount;
        self.getBuyListings(self.currentPageCount);
      };

      //////////////////////////////////////////////////////////////////
      //ADD SPECIAL LOGIC WHEN USER ENTER OTHER BRAND, THE req_listing WILL REMAINS '-- OTHER BRAND --'
      //BUT THE ACTUAL BRAND WILL BE STORED IN TAG. HOWEVER IT WILL NOT GOING TO DISPLAY ON SCREEN.
      //////////////////////////////////////////////////////////////////
      this.getDisplayBrand = function(product){
        return utilities.getCustomBrandName(product);
      }

      // NO PAGING, WILL LOAD ALL THE ITEMS
      // $scope.maxSize = 5;
      // $scope.setPage = function(pageNo) {
		  // $scope.params.currentPage = pageNo;
      // };

      //////////////////////////////////////////
      //  GET RENTAL PRICE
      //////////////////////////////////////////
      this.getRentalPrice = function(price, discountRate) {
        return priceUtilities.getRentalPrice(price,discountRate);
      };

      //////////////////////////////////////////
      //  SHOW THE DISCOUNTED PRICE OF THE PRODUCT
      //////////////////////////////////////////
      function getTagPrice(price, discountRate) {
        return discountRate > 0 ? price*(1-discountRate) : price;
      };

      this.getDisplayTagOrigPrice = function(product){
        var price = priceUtilities.getAmountByRate(product.price);
        
        return priceUtilities.currencyFormat(Math.round(price));
      }

      //////////////////////////////////////////////////////////////////
      // UPDATE PAGINGATION IN THE SEARCH.COMPONENT WITH THE CURRENT PRODUCT
      // PAGE NUMBER AS IT DISPLAY ON SCREEN.
      //////////////////////////////////////////////////////////////////
      angular.element(window).bind('scroll', function (scope, element, attrs) {

        var domID;
        var pageNUM;
        var foundStartOfView = false;   //LOCATE THE START OF THE SCREEN WHERE USER INVIEW.

        if ($scope.result == undefined)
          return;

        //LOOP THRU ALL THE PRODUCTS RETURNED
        for (var i = 0; i < $scope.result.length; i++) {

          if ($window.document.getElementsByClassName('pageNum')[i] != undefined){
            //FOUND THE LOCATION ID OF EACH PRODUCT WHICH DEFINE IT IS STILL ON SCREEN.
            domID = $window.document.getElementsByClassName('pageNum')[i].getAttribute('id');

            if (!utilities.inViewPort(domID) && foundStartOfView){
              //THIS PRODUCT IS NO LONGER IN USER'S VIEW. EXIT THE SEARCH
              break;
            }else if(utilities.inViewPort(domID)){
              //THE CURRENT PRODUCT IS IN USER'S VIEW
              foundStartOfView = true;
              pageNUM = $window.document.getElementsByClassName('pageNum')[i].getAttribute('page');
            }
          }
        }

        //UPDATE THE SEARCH COMPONENT PAGINGATION PAGE NUM
        if (pageNUM && !isNaN(pageNUM)){
          $scope.pageSelector_pgNum = pageNUM;
          $scope.$apply();
        }
      });


      ////////////////////////////
      //  SCROLL DOWN TO LOAD MORE
      ////////////////////////////
      this.loadMoreListings = function() {
        if (!self.lk_loadMore && !self.lk_retrieveListing && self.currentPageCount) {
          self.lk_loadMore = true;
          self.currentPageCount++;
          $scope.pageSelector_pgNum = self.currentPageCount;
          $scope.params.currentPage = self.currentPageCount;
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":buyListingsCtrl:loadMoreListings - Loading more rental listing from page " + self.currentPageCount) : '';
          Session.prev_ListingParams = angular.copy(self.prev_ListingParams_local);
          self.getBuyListings(self.currentPageCount);
        }
      };

      ////////////////////////////
      // REFRESH THE SERACH RESULT
      // BASED ON THE PAGE CLICK
      ////////////////////////////
      self.pageSelectorClick = function(){
        Session.prev_ListingResult = [];
        $scope.result = [];
        $scope.params.currentPage = $scope.pageSelector_pgNum;
        self.currentPageCount = $scope.params.currentPage;
        var searchParams = self.prev_ListingParams_local ? self.prev_ListingParams_local : Session.prev_ListingParams;
        self.getBuyListings($scope.pageSelector_pgNum);
      }

      ////////////////////////////
      // DETECT MOBILE VIEW
      ////////////////////////////
      self.isMobileView = function(){
        return utilities.isMobileView();
      }

      ////////////////////////////
      //  CONVERT THE URL PARAMETERS TO SERVICE API PARAMETERS
      ////////////////////////////
      function prepareParam(params) {
        return {
          owner:params.owner,
          brand: params.brand,
          category: params.category,
          subCategory: params.subCategory,
          priceMin: params.min,
          priceMax: params.max,
          rentalFeeMin: params.feeMin,
          rentalFeeMax: params.feeMax,
          creditMin: params.creditMin,
          creditMax: params.creditMax,
          color: params.color,
          rentStatus: params.rentStatus,
          sort: params.sort,
          size: params.size,
          discountRateMin: params.fdmin,
          discountRateMax: params.fdmax,
          page: params.page,
          tags: params.q,
          types: params.type,
          itemCondition: params.itemCondition,
          country: $rootScope.geoLocation.country
        };
      }


    function setMetadata() {
      var metaKeywords = ["Rent", "Buy", "Style Carousel", "StyleCarousel"];
      var metaBrand;
      if($state.params.otherUsername){
        //Brand
        metaBrand = $state.params.otherUsername;
        metaKeywords.push($state.params.otherUsername);
      }

      var noStyleNotes = $translate.instant('LISTING.LABEL.NO_STYLE_NOTES', {brand: metaBrand});
      var metadata = {
        description : metaBrand ? noStyleNotes : "",
        keywords : metaBrand ? metaKeywords.join(",") : "",
        title : metaBrand ? "Rent | " + utilities.capitalizeFirstLetter(metaBrand) + " " + " at Style Carousel" : "",
      };
      SeoService.setMetaDataTags(metadata);
    };

    $rootScope.$on("CallFilterBuy", function(evt, data){
      $scope.result = []
      if(data) {
        self.rentalFilter = {};
        self.rentalFilter.brand = data.brand,
        self.rentalFilter.category = data.category,
        self.rentalFilter.subCategory = data.subCategory,
        self.rentalFilter.min = data.min,
        self.rentalFilter.max = data.max,
        self.rentalFilter.creditMin = data.creditMin,
        self.rentalFilter.creditMax = data.creditMax,
        self.rentalFilter.color = data.color,
        self.rentalFilter.size = data.size,
        self.rentalFilter.itemCondition = data.itemCondition,
        self.rentalFilter.rentStatus = data.status
      }
      self.getBuyListings();
    });
    
    
    this.getDisplayPrice = function(product) {
      return priceUtilities.getDisplayPriceV2(product);
    }

    this.getDisplayPurchasePrice = function(product) {
      return priceUtilities.getDisplayPurchasePriceV2(product);
    }

    this.getDisplayPhoto = function(product, position){
      return utilities.getDisplayPhoto(product, position);
    }
    
    this.toggleWishlist = function(product) {
      self.displayedProductWishlist = product.id;
      self.isWishlistDisabled = true;
      var allSizes = product.sizes;
      for (var index in allSizes) {
        var sizeWishlist = allSizes[index].wishlist;
        if(sizeWishlist){
          self.isWishlistDisabled = false;
          break;
        }
      }
    }


    this.saveWishlist = function(product){
      DialogAlertService.saveWishlist(product);
    }
    
    this.isSalePriceSameWithOrigPrice = function(product){
      return priceUtilities.isSalePriceSameWithOrigPrice(product.price, product.discountRate)
    }

    this.getProductWith = function(){
      if(utilities.isShowMainRegion()){
        $state.go('search', {q:self.shopName,mm:true,brand: null,category: null,min: CONFIG.PRICE_MIN,max: CONFIG.PRICE_MAX,fdmin: null,fdmax: null,feeMin:null,feeMax:null,fp: null,type:CONFIG.DEFAULT_SEARCH_TYPE,page:null,status:null,sort:CONFIG.DEFAULT_SEARCH_SORT_ORDER,color:null,size:null});
      } else {
        $state.go('search-multi-region', {q:self.shopName,mm:true,brand: null,category: null,min: CONFIG.PRICE_MIN,max: CONFIG.PRICE_MAX,fdmin: null,fdmax: null,feeMin:null,feeMax:null,fp: null,type:CONFIG.DEFAULT_SEARCH_TYPE,page:null,status:null,sort:CONFIG.DEFAULT_SEARCH_SORT_ORDER,color:null,size:null,country: $rootScope.geoLocation.country});
      }
    }
    
    }]
})

'use strict';
angular.module('coutureApp')
  .component('stylePosts', {
    controllerAs : 'stylePostsCtrl',
    templateUrl: 'scripts/components/profile/style-posts/style-posts.html',
    controller: ["$rootScope", "$scope", "$state", "$stateParams", "$http", "RefDataService", "ListingService", "DialogAlertService", "utilities", "usSpinnerService", "$log", "CONFIG", "UserService", "$timeout", "$anchorScroll", "$window", "Session", "envService", "priceUtilities", "AuthService", "USER_ROLES", "$translate", function($rootScope,$scope, $state, $stateParams, $http,RefDataService,ListingService,DialogAlertService,
      utilities, usSpinnerService,$log,CONFIG,UserService,$timeout,$anchorScroll,$window,Session,envService,priceUtilities,AuthService,USER_ROLES,$translate) {

      var self= this;

      this.$onInit = function(){
        $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - stylePosts"):'';
        self.allCategorySizes = RefDataService.getSizeList();
        self.rentalFilter = {};

        $rootScope.transactionType = CONFIG.TRANSACTION_TYPE_RENT;
        $scope.pageSelector_pgNum = 1;
        self.currentPageCount = 1;
        self.lk_loadMore = true; // Prevent loading of more results initially
        $scope.sortByList = RefDataService.getSortByList_Listings();
        self.setSortListWithDefault(CONFIG.DEFAULT_SORT_RENTAL_LISTING);
        $scope.productOptions = RefDataService.GetProductOptionsLabel();
        self.proudct_currency = priceUtilities.getCurrency();
        $scope.pageSelector_maxSize = 3;
        $scope.pageSelector_itemPerPage = CONFIG.ITEM_PER_PAGE;
        self.collectionList = RefDataService.getCollections();

        self.isOwner = false;

        $scope.isAdmin = false;
        if (AuthService.isAuthorized(USER_ROLES.admin)){
          $scope.isAdmin = true;
        } 
        self.shopName = $state.params.otherUsername == null ? $rootScope.user.username : $state.params.otherUsername;
        self.buttonName = "See all " + self.shopName + " on Style Carousel";
        $rootScope.filterDesignerByOwner = null;

        self.isOwnerOrAdmin = false;
        
        if ($rootScope.isLogon){
          self.isOwner = $state.params.otherUsername == $rootScope.user.username.toLowerCase();
          self.isOwnerOrAdmin = self.isOwner || AuthService.isAuthorized(USER_ROLES.admin);
        }
        if ($state.params.otherUsername == null && !$rootScope.isLogon){
          //NOT ALLOWED TO TYPE IN URL DIRECTLY
          if(utilities.isShowMainRegion()){
			      $state.go('main');
          } else {
            $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
          }
        }else if ($state.params.otherUsername){
          if(self.isOwnerOrAdmin){
            loadOtherUserProfile();
          } else {
            if(utilities.isShowMainRegion()){
			      $state.go('main');
            } else {
              $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
            }
          }
        }else if ($rootScope.isLogon){
          self.profileName = $rootScope.user.username;
          $rootScope.filterDesignerByOwner = $rootScope.user.username;
          self.isOwner = true;
          self.getStylePosts($scope.pageSelector_pgNum);
        }
      }

      //////////////////////////////////////////
      //  LOAD RENTAL LISTING FOR OTHER PROFILE.
      //////////////////////////////////////////
      function loadOtherUserProfile(){
        UserService.isUserExists($state.params.otherUsername).$promise.then(function(resp){
          var otherUser = $state.params.otherUsername ? $state.params.otherUsername.toLowerCase() : "";
          var currentUser = $rootScope.isLogon ? ($rootScope.user.username ? $rootScope.user.username.toLowerCase() : "") : "";
          var isShopOwner = currentUser == otherUser;
          if(CONFIG.COUNTRY_CURRENCY_CODE.AU.country_code == $rootScope.geoLocation.country 
            && !resp.australiaStoreEnabled 
            && !isShopOwner){
            $state.go('main');
          } else {
            if (resp.profileImg && resp.profileImg.indexOf('https://') == -1){
              resp.profileImg = envService.read('IMG_DOMAIN') + "/" + resp.profileImg;
            }else if (resp.profileImg && resp.profileImg.indexOf('https://') != -1){
              //DO NOTHING, PROFILE FROM SOCIAL ACCOUNT
            }else{
              resp.profileImg = null;
            }
            
            if (resp.profileBanner && resp.profileBanner.indexOf('https://') == -1){
            resp.profileBanner = envService.read('IMG_DOMAIN') + "/" + resp.profileBanner;
            }else if (resp.profileBanner && resp.profileBanner.indexOf('https://') != -1){
              //DO NOTHING, PROFILE FROM SOCIAL ACCOUNT
            }else{
              resp.profileBanner = null;
            }
            $rootScope.viewOtherProfile = resp;
            //$rootScope.viewOtherProfile.profileBanner = "https://stylecarousel.com/landing/wp-content/uploads/2022/06/1-3.png";
            self.profileName = $rootScope.viewOtherProfile.username;
            self.getStylePosts();
            $anchorScroll('top');
          }
        },function(err){
          delete($rootScope.viewOtherProfile);
          if(utilities.isShowMainRegion()){
            $state.go('main');
          } else {
            $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
          }
        });
      }

      // var init
  	  $scope.params = {
  		  limit: 20,
  		  filters: [],
  		  sortBy: null,
  		  currentPage: 1,
  		  totalItems: 0
  	  };

      /////////////////////////////////////////////////
      //  GET THE INDEX OF THE DEFAULT SORT ITEM ON THE LIST
      /////////////////////////////////////////////////
      this.setSortListWithDefault = function(defaultKey){
        $scope.params.sortBy = $scope.sortByList.filter(p => p.KEY == defaultKey)[0];
      }

      /////////////////////////////////////////////////
      //  CHECK IF THE PRODUCT IS AVAILABLE FOR RENTAL
      /////////////////////////////////////////////////
      this.isAvailable = function (product){
        return utilities.isProductAvailableForRental(product);
      }

      //////////////////////////////////////////
      //  DELETE LISTINGS
      //////////////////////////////////////////
      this.removeListings = function(productID){
        var delete_product_id = productID;
        // Prompt dialog for user to confirm with deletion
        DialogAlertService.promptDialog('GENERAL.DIALOG_TITLE.CONFIRM_DELETE', 'lg', true, 'GENERAL.BUTTON.CANCEL', 'GENERAL.BUTTON.CONFIRM',
        function() {
          ListingService.deleteByProduct(delete_product_id).$promise.then(function(){
            $rootScope.enableLog ? $log.info($rootScope.UUID + ":stylePosts:removeListings - Deleted successfully " + productID):'';
            
            //$state.go("rental-listings", {}, {'reload' : true});
            if(utilities.isShowMainRegion()){
              $state.go("viewOtherUserStylePosts", {otherUsername:$state.params.otherUsername}, {'reload' : true});
            } else {
              $state.go("viewOtherUserStylePosts-multi-region", {country: $rootScope.geoLocation.country, otherUsername:$state.params.otherUsername}, {'reload' : true});
            }
          },
          function(err){
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":stylePosts:removeListings - Error delete " + delete_product_id + " : " + JSON.stringify(err)):'';
            DialogAlertService.promptDialog('Status of product (ID: '+ delete_product_id +') prevents deletion. Please contact admin for assistance. ', '', '', '', 'GENERAL.LABEL.OK', '', '', false,'',"RED");
          });
        });
      }

      
      //////////////////////////////////////////
      //  ADD / REMOVE COLLECTION
      //////////////////////////////////////////
      this.toggleCollection = function(product){
        self.displayedProductWishlist = false;
        if(self.displayedProductCollection == product.id && self.displayedProductCollection){
          self.displayedProductCollection = false;
        } else {
          self.displayedProductCollection = product.id;
        }
      }
      //////////////////////////////////////////
      //  GET THE LIST OF USER POSTED LISTING
      //////////////////////////////////////////
      this.getStylePosts = function(pgNum) {
        usSpinnerService.spin('spinner');
        self.lk_retrieveListing = true;
        var filters = prepareParam({
          owner:self.profileName,
          page:pgNum,
          sort:$scope.params.sortBy.KEY,
          type:CONFIG.STYLE_POST,
          brand: self.rentalFilter.brand,
          category: self.rentalFilter.category,
          subCategory: self.rentalFilter.subCategory,
          priceMin: self.rentalFilter.min,
          priceMax: self.rentalFilter.max,
          creditMin: self.rentalFilter.creditMin,
          creditMax: self.rentalFilter.creditMax,
          color: self.rentalFilter.color,
          size: self.rentalFilter.size, 
          itemCondition: self.rentalFilter.itemCondition,
          country: $rootScope.geoLocation.country,
          rentStatus: self.rentalFilter.rentStatus,
        });
        ListingService.getListingByOwner(filters).$promise.then(function(resp) {
            var finalProductList = [];
            var totalPageCount,totalRecordCount;

            //CHECK IF ITEM IS A LISTING. IF NOT REMOVE IT FROM THE LIST
            resp.forEach(function(item, index, arr) {
              if (!item['searchResult']) {
                item.type === CONFIG.STYLE_POST ? finalProductList.push(item) : '';
                item._page = self.currentPageCount;
              } else {
                totalRecordCount = item['searchResult']['totalRecordCount'];
                totalPageCount = item['searchResult']['totalPageCount'];
                arr.pop();
              }
            });

            $scope.params.totalItems = totalRecordCount;

            var tmpResult = $scope.result ? angular.copy($scope.result) : [];
            $scope.result = tmpResult.concat(finalProductList);
            (self.currentPageCount >= totalPageCount || $scope.params.totalItems === 0) ? self.lk_loadMore = true: self.lk_loadMore = false;


            $scope.result.forEach(product => {
              product.hasSize = product.sizes.filter(s => s.available).length > 0;

              var allCollections = [];
              self.collectionList.forEach(c => {
                var collection = {};
                collection.key = c.key;
                collection.value = c.value;
                collection.order = c.order;
                if(c.key === "two-for-one"){
                  collection.selected = product.bundle;
                } else if(c.key === "main-collection"){
                  collection.selected = product.recommended;
                }
                allCollections.push(collection);
              });
              product.allCollections = allCollections;
              product.allCollections.sort(function(a, b){return a.position-b.position;});
            });


            $rootScope.enableLog ? $log.info($rootScope.UUID + ":stylePosts:getStylePosts - My Listing"):'';
            self.lk_retrieveListing = false;

            //SAVE THE LAST PRODUCT ID WHERE THE USER HAS SCROLLED TO, BEFORE THE NEW ITEMS LOADED
            //MOVE THE LIST BACK TO THE LAST POSITION. SCROLL TO THE TOP OF THE LIST FOR NEWLY SEARCH PAGE FOR MOBILE VIEW
            self.scrollLastItemID = tmpResult.length > 0 ? tmpResult[tmpResult.length-1].id : $scope.result.length > 0 && self.isMobileView() ? $scope.result[0].id : null;
            $timeout(function() {
              $anchorScroll(self.scrollLastItemID);
            }, 400);

            usSpinnerService.stop('spinner');
          }, function(err) {
            usSpinnerService.stop('spinner');
            lk_retrieveListing = false;
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":stylePosts:getStylePosts - Error: " + JSON.stringify(err)):'';
          });
      };

      //////////////////////////////////////////
      //  SHOW THE PRODUCT LISTING, BASED ON THE LISTING ID
      //////////////////////////////////////////
      this.showListing = function(productID, product) {
        var productBrand = utilities.getCustomBrandName(product);
        var urlSlug = utilities.getPrettyUrl(product.category.code, product.subCategory.code, productBrand, product.productLine);
        if(utilities.isShowMainRegion()){
          $state.go('listing', {id: productID, urlSlug: urlSlug});
        } else {
          $state.go('listing-multi-region', {id: productID, urlSlug: urlSlug, country: $rootScope.geoLocation.country});
        }
      };

      this.showListingByTransaction = function(productID, product, transactionType) {
        $rootScope.transactionType = transactionType;
        this.showListing(productID, product);
      };


      //////////////////////////////////////////
      //  APPLY ORDER BY FOR THE LISTING
      //////////////////////////////////////////
      $scope.sortProduct = function(sortBy) {
        $scope.params.sortBy = sortBy;

        //CLEAR THE PREVIOUS SEARCH RESULT AND CHANGE THE SORT ORDER.
        $scope.result = [];
        self.currentPageCount = 1;
        $scope.pageSelector_pgNum = self.currentPageCount;
        self.getStylePosts(self.currentPageCount);
      };

      //////////////////////////////////////////////////////////////////
      //ADD SPECIAL LOGIC WHEN USER ENTER OTHER BRAND, THE req_listing WILL REMAINS '-- OTHER BRAND --'
      //BUT THE ACTUAL BRAND WILL BE STORED IN TAG. HOWEVER IT WILL NOT GOING TO DISPLAY ON SCREEN.
      //////////////////////////////////////////////////////////////////
      this.getDisplayBrand = function(product){
        return utilities.getCustomBrandName(product);
      }

      // NO PAGING, WILL LOAD ALL THE ITEMS
      // $scope.maxSize = 5;
      // $scope.setPage = function(pageNo) {
		  // $scope.params.currentPage = pageNo;
      // };

      //////////////////////////////////////////
      //  GET RENTAL PRICE
      //////////////////////////////////////////
      this.getRentalPrice = function(price, discountRate) {
        return priceUtilities.getRentalPrice(price,discountRate);
      };

      //////////////////////////////////////////
      //  SHOW THE DISCOUNTED PRICE OF THE PRODUCT
      //////////////////////////////////////////
      function getTagPrice(price, discountRate) {
        return discountRate > 0 ? price*(1-discountRate) : price;
      };

      this.getDisplayTagOrigPrice = function(product){
        var price = priceUtilities.getAmountByRate(product.price);
        
        return priceUtilities.currencyFormat(Math.round(price));
      }

      //////////////////////////////////////////////////////////////////
      // UPDATE PAGINGATION IN THE SEARCH.COMPONENT WITH THE CURRENT PRODUCT
      // PAGE NUMBER AS IT DISPLAY ON SCREEN.
      //////////////////////////////////////////////////////////////////
      angular.element(window).bind('scroll', function (scope, element, attrs) {

        var domID;
        var pageNUM;
        var foundStartOfView = false;   //LOCATE THE START OF THE SCREEN WHERE USER INVIEW.

        if ($scope.result == undefined)
          return;

        //LOOP THRU ALL THE PRODUCTS RETURNED
        for (var i = 0; i < $scope.result.length; i++) {

          if ($window.document.getElementsByClassName('pageNum')[i] != undefined){
            //FOUND THE LOCATION ID OF EACH PRODUCT WHICH DEFINE IT IS STILL ON SCREEN.
            domID = $window.document.getElementsByClassName('pageNum')[i].getAttribute('id');

            if (!utilities.inViewPort(domID) && foundStartOfView){
              //THIS PRODUCT IS NO LONGER IN USER'S VIEW. EXIT THE SEARCH
              break;
            }else if(utilities.inViewPort(domID)){
              //THE CURRENT PRODUCT IS IN USER'S VIEW
              foundStartOfView = true;
              pageNUM = $window.document.getElementsByClassName('pageNum')[i].getAttribute('page');
            }
          }
        }

        //UPDATE THE SEARCH COMPONENT PAGINGATION PAGE NUM
        if (pageNUM && !isNaN(pageNUM)){
          $scope.pageSelector_pgNum = pageNUM;
          $scope.$apply();
        }
      });


      ////////////////////////////
      //  SCROLL DOWN TO LOAD MORE
      ////////////////////////////
      this.loadMoreListings = function() {
        if (!self.lk_loadMore && !self.lk_retrieveListing && self.currentPageCount) {
          self.lk_loadMore = true;
          self.currentPageCount++;
          $scope.pageSelector_pgNum = self.currentPageCount;
          $scope.params.currentPage = self.currentPageCount;
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":stylePostsCtrl:loadMoreListings - Loading more rental listing from page " + self.currentPageCount) : '';
          Session.prev_ListingParams = angular.copy(self.prev_ListingParams_local);
          self.getStylePosts(self.currentPageCount);
        }
      };

      ////////////////////////////
      // REFRESH THE SERACH RESULT
      // BASED ON THE PAGE CLICK
      ////////////////////////////
      self.pageSelectorClick = function(){
        Session.prev_ListingResult = [];
        $scope.result = [];
        $scope.params.currentPage = $scope.pageSelector_pgNum;
        self.currentPageCount = $scope.params.currentPage;
        var searchParams = self.prev_ListingParams_local ? self.prev_ListingParams_local : Session.prev_ListingParams;
        self.getStylePosts($scope.pageSelector_pgNum);
      }

      ////////////////////////////
      // DETECT MOBILE VIEW
      ////////////////////////////
      self.isMobileView = function(){
        return utilities.isMobileView();
      }

      ////////////////////////////
      //  CONVERT THE URL PARAMETERS TO SERVICE API PARAMETERS
      ////////////////////////////
      function prepareParam(params) {
        return {
          owner:params.owner,
          brand: params.brand,
          category: params.category,
          subCategory: params.subCategory,
          priceMin: params.min,
          priceMax: params.max,
          rentalFeeMin: params.feeMin,
          rentalFeeMax: params.feeMax,
          creditMin: params.creditMin,
          creditMax: params.creditMax,
          color: params.color,
          rentStatus: params.rentStatus,
          sort: params.sort,
          size: params.size,
          discountRateMin: params.fdmin,
          discountRateMax: params.fdmax,
          page: params.page,
          tags: params.q,
          types: params.type,
          itemCondition: params.itemCondition,
          country: $rootScope.geoLocation.country
        };
      }



    $rootScope.$on("CallFilterRentals", function(evt, data){
      $scope.result = []
      if(data) {
        self.rentalFilter = {};
        self.rentalFilter.brand = data.brand,
        self.rentalFilter.category = data.category,
        self.rentalFilter.subCategory = data.subCategory,
        self.rentalFilter.min = data.min,
        self.rentalFilter.max = data.max,
        self.rentalFilter.creditMin = data.creditMin,
        self.rentalFilter.creditMax = data.creditMax,
        self.rentalFilter.color = data.color,
        self.rentalFilter.size = data.size,
        self.rentalFilter.itemCondition = data.itemCondition,
        self.rentalFilter.rentStatus = data.status
      }
      self.getStylePosts();
    });
    
    
    this.getDisplayPrice = function(product) {
      return priceUtilities.getDisplayPriceV2(product);
    }

    this.getDisplayPurchasePrice = function(product) {
      return priceUtilities.getDisplayPurchasePriceV2(product);
    }

    this.getDisplayPhoto = function(product, position){
      return utilities.getDisplayPhoto(product, position);
    }
    
    this.toggleWishlist = function(product) {
      self.displayedProductWishlist = product.id;
      self.isWishlistDisabled = true;
      var allSizes = product.sizes;
      for (var index in allSizes) {
        var sizeWishlist = allSizes[index].wishlist;
        if(sizeWishlist){
          self.isWishlistDisabled = false;
          break;
        }
      }
    }


    this.saveWishlist = function(product){
      DialogAlertService.saveWishlist(product);
    }
    
    this.isSalePriceSameWithOrigPrice = function(product){
      return priceUtilities.isSalePriceSameWithOrigPrice(product.price, product.discountRate)
    }

    this.getProductWith = function(){
      if(utilities.isShowMainRegion()){
        $state.go('search', {q:self.shopName,mm:true,brand: null,category: null,min: CONFIG.PRICE_MIN,max: CONFIG.PRICE_MAX,fdmin: null,fdmax: null,feeMin:null,feeMax:null,fp: null,type:CONFIG.DEFAULT_SEARCH_TYPE,page:null,status:null,sort:CONFIG.DEFAULT_SEARCH_SORT_ORDER,color:null,size:null});
      } else {
        $state.go('search-multi-region', {q:self.shopName,mm:true,brand: null,category: null,min: CONFIG.PRICE_MIN,max: CONFIG.PRICE_MAX,fdmin: null,fdmax: null,feeMin:null,feeMax:null,fp: null,type:CONFIG.DEFAULT_SEARCH_TYPE,page:null,status:null,sort:CONFIG.DEFAULT_SEARCH_SORT_ORDER,color:null,size:null,country: $rootScope.geoLocation.country});
      }
    }

    $rootScope.$on("CallFilterStylePost", function(evt, data){
      $scope.result = []
      if(data) {
        self.rentalFilter = {};
        self.rentalFilter.brand = data.brand,
        self.rentalFilter.category = data.category,
        self.rentalFilter.subCategory = data.subCategory,
        self.rentalFilter.min = data.min,
        self.rentalFilter.max = data.max,
        self.rentalFilter.creditMin = data.creditMin,
        self.rentalFilter.creditMax = data.creditMax,
        self.rentalFilter.color = data.color,
        self.rentalFilter.size = data.size,
        self.rentalFilter.itemCondition = data.itemCondition,
        self.rentalFilter.rentStatus = data.status
        self.rentalFilter.type = CONFIG.STYLE_POST;
      }
      self.getDeletedListings();
    });
    
    }]
})

'use strict';
angular.module('coutureApp')
  .component('deletedListings', {
    controllerAs : 'deletedListingsCtrl',
    templateUrl: 'scripts/components/profile/deleted-listings/deleted-listings.html',
    controller: ["$rootScope", "$scope", "$state", "$stateParams", "$http", "RefDataService", "ListingService", "DialogAlertService", "utilities", "priceUtilities", "usSpinnerService", "$log", "CONFIG", "Session", "UserService", "$timeout", "$anchorScroll", "$window", "envService", "$translate", "SeoService", "USER_ROLES", "AuthService", function($rootScope,$scope, $state, $stateParams, $http,RefDataService,ListingService,DialogAlertService,
      utilities, priceUtilities,usSpinnerService,$log,CONFIG,Session,UserService,$timeout,$anchorScroll,$window,envService,$translate,SeoService,USER_ROLES,AuthService) {

      var self= this;

      this.$onInit = function(){
        $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - deletedListings"):'';
        self.allCategorySizes = RefDataService.getSizeList();
        self.rentalFilter = {};

        $rootScope.transactionType = CONFIG.TRANSACTION_TYPE_RENT;
        $scope.pageSelector_pgNum = 1;
        self.currentPageCount = 1;
        self.lk_loadMore = true; // Prevent loading of more results initially
        $scope.sortByList = RefDataService.getSortByList_Listings();
        self.setSortListWithDefault(CONFIG.DEFAULT_SORT_RENTAL_LISTING);
        $scope.productOptions = RefDataService.GetProductOptionsLabel();
        self.proudct_currency = priceUtilities.getCurrency();
        $scope.pageSelector_maxSize = 3;
        $scope.pageSelector_itemPerPage = CONFIG.ITEM_PER_PAGE;
        self.availableForRegion = utilities.isFunctionEnabled();
        self.collectionList = RefDataService.getCollections();

        self.isOwner = false;

        $scope.isAdmin = false;
        if (AuthService.isAuthorized(USER_ROLES.admin)){
          $scope.isAdmin = true;
        } 
        self.shopName = $state.params.otherUsername == null ? $rootScope.user.username : $state.params.otherUsername;
        self.buttonName = "See all " + self.shopName + " on Style Carousel";
        $rootScope.filterDesignerByOwner = null;

        self.isOwnerOrAdmin = false;
        
        if ($rootScope.isLogon){
          self.isOwner = $state.params.otherUsername == $rootScope.user.username.toLowerCase();
          self.isOwnerOrAdmin = self.isOwner || AuthService.isAuthorized(USER_ROLES.admin);
        }

        if ($state.params.otherUsername == null && !$rootScope.isLogon){
          //NOT ALLOWED TO TYPE IN URL DIRECTLY
            if(utilities.isShowMainRegion()){
			        $state.go('main');
            } else {
              $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
            }
        }else if ($state.params.otherUsername){
          if(self.isOwnerOrAdmin){
            $rootScope.filterDesignerByOwner = $state.params.otherUsername;
            loadOtherUserProfile();
          } else {
            if(utilities.isShowMainRegion()){
			        $state.go('main');
            } else {
              $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
            }
          }

        }else if ($rootScope.isLogon){
          self.profileName = $rootScope.user.username;
          $rootScope.filterDesignerByOwner = $rootScope.user.username;
          self.isOwner = true;
          self.getDeletedListings($scope.pageSelector_pgNum);
        }
      }

      //////////////////////////////////////////
      //  LOAD RENTAL LISTING FOR OTHER PROFILE.
      //////////////////////////////////////////
      function loadOtherUserProfile(){
        UserService.isUserExists($state.params.otherUsername).$promise.then(function(resp){
          var otherUser = $state.params.otherUsername ? $state.params.otherUsername.toLowerCase() : "";
          var currentUser = $rootScope.isLogon ? ($rootScope.user.username ? $rootScope.user.username.toLowerCase() : "") : "";
          var isShopOwner = currentUser == otherUser;
          if(CONFIG.COUNTRY_CURRENCY_CODE.AU.country_code == $rootScope.geoLocation.country 
            && !resp.australiaStoreEnabled 
            && !isShopOwner){
            $state.go('main');
          } else {
            if (resp.profileImg && resp.profileImg.indexOf('https://') == -1){
              resp.profileImg = envService.read('IMG_DOMAIN') + "/" + resp.profileImg;
            }else if (resp.profileImg && resp.profileImg.indexOf('https://') != -1){
              //DO NOTHING, PROFILE FROM SOCIAL ACCOUNT
            }else{
              resp.profileImg = null;
            }
            
            if (resp.profileBanner && resp.profileBanner.indexOf('https://') == -1){
            resp.profileBanner = envService.read('IMG_DOMAIN') + "/" + resp.profileBanner;
            }else if (resp.profileBanner && resp.profileBanner.indexOf('https://') != -1){
              //DO NOTHING, PROFILE FROM SOCIAL ACCOUNT
            }else{
              resp.profileBanner = null;
            }
            $rootScope.viewOtherProfile = resp;
            //$rootScope.viewOtherProfile.profileBanner = "https://stylecarousel.com/landing/wp-content/uploads/2022/06/1-3.png";
            self.profileName = $rootScope.viewOtherProfile.username;
            self.getDeletedListings();
            $anchorScroll('top');
          }
        },function(err){
          delete($rootScope.viewOtherProfile);
          if(utilities.isShowMainRegion()){
            $state.go('main');
          } else {
            $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
          }
        });
      }

      // var init
  	  $scope.params = {
  		  limit: 20,
  		  filters: [],
  		  sortBy: null,
  		  currentPage: 1,
  		  totalItems: 0
  	  };

      /////////////////////////////////////////////////
      //  GET THE INDEX OF THE DEFAULT SORT ITEM ON THE LIST
      /////////////////////////////////////////////////
      this.setSortListWithDefault = function(defaultKey){
        $scope.params.sortBy = $scope.sortByList.filter(p => p.KEY == defaultKey)[0];
      }

      /////////////////////////////////////////////////
      //  CHECK IF THE PRODUCT IS AVAILABLE FOR RENTAL
      /////////////////////////////////////////////////
      this.isAvailable = function (product){
        return utilities.isProductAvailableForRental(product);
      }

      //////////////////////////////////////////
      //  DELETE LISTINGS
      //////////////////////////////////////////
      this.removeListings = function(productID){
        var delete_product_id = productID;
        // Prompt dialog for user to confirm with deletion
        DialogAlertService.promptDialog('GENERAL.DIALOG_TITLE.CONFIRM_DELETE', 'lg', true, 'GENERAL.BUTTON.CANCEL', 'GENERAL.BUTTON.CONFIRM',
        function() {
          ListingService.deleteByProduct(delete_product_id).$promise.then(function(){
            $rootScope.enableLog ? $log.info($rootScope.UUID + ":rentalListings:removeListings - Deleted successfully " + productID):'';
            
            //$state.go("rental-listings", {}, {'reload' : true});
            if(utilities.isShowMainRegion()){
              $state.go("viewOtherUserRentalListings", {otherUsername:$state.params.otherUsername}, {'reload' : true});
            } else {
              $state.go("viewOtherUserRentalListings-multi-region", {country: $rootScope.geoLocation.country, otherUsername:$state.params.otherUsername}, {'reload' : true});
            }
          },
          function(err){
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":rentalListings:removeListings - Error delete " + delete_product_id + " : " + JSON.stringify(err)):'';
            DialogAlertService.promptDialog('Status of product (ID: '+ delete_product_id +') prevents deletion. Please contact admin for assistance. ', '', '', '', 'GENERAL.LABEL.OK', '', '', false,'',"RED");
          });
        });
      }

      
      //////////////////////////////////////////
      //  ADD / REMOVE COLLECTION
      //////////////////////////////////////////
      this.toggleCollection = function(product){
        self.displayedProductWishlist = false;
        if(self.displayedProductCollection == product.id && self.displayedProductCollection){
          self.displayedProductCollection = false;
        } else {
          self.displayedProductCollection = product.id;
        }
      }

      this.saveCollection = function(product, order, collection) {
        usSpinnerService.spin('spinner');
        var productCollection = {};
        if(collection.key == 'two-for-one'){
          productCollection.selected = !collection.selected;
        } else {
          productCollection.selected = order.feature;
        }
        productCollection.code = collection.key;
        productCollection.name = collection.key;
        productCollection.order = order.key;

        product.allCollections.forEach(function(c){
          if(c.key == collection.key){
            c.selected = productCollection.selected;
          }
        });

        var update_listing = {
          id: product.id,
          collection: productCollection
        };
        ListingService.updateCollection(update_listing).$promise.then(function(resp) {
          usSpinnerService.stop('spinner');
          product.existInCollection = resp.recommended;
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":toggleCollection - Listing updated successfully (" + update_listing.id + ")") : '';
        }, function(err) {
          usSpinnerService.stop('spinner');
          self.lk_listing = false;
          DialogAlertService.promptDialog('Add to collection failed. Please try again later.', '', '', '', '', '', '', true, '', 'RED');
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":toggleCollection - Listing edit error.") : '';
        })
      }
      //////////////////////////////////////////
      //  GET THE LIST OF USER POSTED LISTING
      //////////////////////////////////////////
      this.getDeletedListings = function(pgNum) {
        usSpinnerService.spin('spinner');
        self.lk_retrieveListing = true;
        var filters = prepareParam({
          owner:self.profileName,
          page:pgNum,
          sort:$scope.params.sortBy.KEY,
          brand: self.rentalFilter.brand,
          category: self.rentalFilter.category,
          subCategory: self.rentalFilter.subCategory,
          priceMin: self.rentalFilter.min,
          priceMax: self.rentalFilter.max,
          creditMin: self.rentalFilter.creditMin,
          creditMax: self.rentalFilter.creditMax,
          color: self.rentalFilter.color,
          size: self.rentalFilter.size, 
          itemCondition: self.rentalFilter.itemCondition,
          country: $rootScope.geoLocation.country,
          rentStatus: self.rentalFilter.rentStatus,
          type:CONFIG.DELETED_LISTING
        });
        ListingService.getListingByOwner(filters).$promise.then(function(resp) {
            var finalProductList = [];
            var totalPageCount,totalRecordCount;

            //CHECK IF ITEM IS A LISTING. IF NOT REMOVE IT FROM THE LIST
            resp.forEach(function(item, index, arr) {
              if (!item['searchResult']) {
                finalProductList.push(item);
                item._page = self.currentPageCount;
              } else {
                totalRecordCount = item['searchResult']['totalRecordCount'];
                totalPageCount = item['searchResult']['totalPageCount'];
                arr.pop();
              }
            });

            $scope.params.totalItems = totalRecordCount;

            var tmpResult = $scope.result ? angular.copy($scope.result) : [];
            $scope.result = tmpResult.concat(finalProductList);
            (self.currentPageCount >= totalPageCount || $scope.params.totalItems === 0) ? self.lk_loadMore = true: self.lk_loadMore = false;


            $scope.result.forEach(product => {
              product.hasSize = product.sizes.filter(s => s.available).length > 0;

              var allCollections = [];
              self.collectionList.forEach(c => {
                var collection = {};
                collection.key = c.key;
                collection.value = c.value;
                collection.order = c.order;
                if(c.key === "two-for-one"){
                  collection.selected = product.bundle;
                } else if(c.key === "main-collection"){
                  collection.selected = product.recommended;
                }
                allCollections.push(collection);
              });
              product.allCollections = allCollections;
              product.allCollections.sort(function(a, b){return a.position-b.position;});
            });


            $rootScope.enableLog ? $log.info($rootScope.UUID + ":rentalListings:getDeletedListings - My Listing"):'';
            self.lk_retrieveListing = false;

            //SAVE THE LAST PRODUCT ID WHERE THE USER HAS SCROLLED TO, BEFORE THE NEW ITEMS LOADED
            //MOVE THE LIST BACK TO THE LAST POSITION. SCROLL TO THE TOP OF THE LIST FOR NEWLY SEARCH PAGE FOR MOBILE VIEW
            self.scrollLastItemID = tmpResult.length > 0 ? tmpResult[tmpResult.length-1].id : $scope.result.length > 0 && self.isMobileView() ? $scope.result[0].id : null;
            $timeout(function() {
              $anchorScroll(self.scrollLastItemID);
            }, 400);

            usSpinnerService.stop('spinner');
          }, function(err) {
            usSpinnerService.stop('spinner');
            lk_retrieveListing = false;
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":rentalListings:getDeletedListings - Error: " + JSON.stringify(err)):'';
          });
      };

      //////////////////////////////////////////
      //  SHOW THE PRODUCT LISTING, BASED ON THE LISTING ID
      //////////////////////////////////////////
      this.showListing = function(productID, product) {
        var productBrand = utilities.getCustomBrandName(product);
        var urlSlug = utilities.getPrettyUrl(product.category.code, product.subCategory.code, productBrand, product.productLine);
        if(utilities.isShowMainRegion()){
          $state.go('listing', {id: productID, urlSlug: urlSlug});
        } else {
          $state.go('listing-multi-region', {id: productID, urlSlug: urlSlug, country: $rootScope.geoLocation.country});
        }
      };

      this.showListingByTransaction = function(productID, product, transactionType) {
        $rootScope.transactionType = transactionType;
        this.showListing(productID, product);
      };


      //////////////////////////////////////////
      //  APPLY ORDER BY FOR THE LISTING
      //////////////////////////////////////////
      $scope.sortProduct = function(sortBy) {
        $scope.params.sortBy = sortBy;

        //CLEAR THE PREVIOUS SEARCH RESULT AND CHANGE THE SORT ORDER.
        $scope.result = [];
        self.currentPageCount = 1;
        $scope.pageSelector_pgNum = self.currentPageCount;
        self.getDeletedListings(self.currentPageCount);
      };

      //////////////////////////////////////////////////////////////////
      //ADD SPECIAL LOGIC WHEN USER ENTER OTHER BRAND, THE req_listing WILL REMAINS '-- OTHER BRAND --'
      //BUT THE ACTUAL BRAND WILL BE STORED IN TAG. HOWEVER IT WILL NOT GOING TO DISPLAY ON SCREEN.
      //////////////////////////////////////////////////////////////////
      this.getDisplayBrand = function(product){
        return utilities.getCustomBrandName(product);
      }

      // NO PAGING, WILL LOAD ALL THE ITEMS
      // $scope.maxSize = 5;
      // $scope.setPage = function(pageNo) {
		  // $scope.params.currentPage = pageNo;
      // };

      //////////////////////////////////////////
      //  GET RENTAL PRICE
      //////////////////////////////////////////
      this.getRentalPrice = function(price, discountRate) {
        return priceUtilities.getRentalPrice(price,discountRate);
      };

      //////////////////////////////////////////
      //  SHOW THE DISCOUNTED PRICE OF THE PRODUCT
      //////////////////////////////////////////
      function getTagPrice(price, discountRate) {
        return discountRate > 0 ? price*(1-discountRate) : price;
      };

      this.getDisplayTagOrigPrice = function(product){
        var price = priceUtilities.getAmountByRate(product.price);
        
        return priceUtilities.currencyFormat(Math.round(price));
      }

      //////////////////////////////////////////////////////////////////
      // UPDATE PAGINGATION IN THE SEARCH.COMPONENT WITH THE CURRENT PRODUCT
      // PAGE NUMBER AS IT DISPLAY ON SCREEN.
      //////////////////////////////////////////////////////////////////
      angular.element(window).bind('scroll', function (scope, element, attrs) {

        var domID;
        var pageNUM;
        var foundStartOfView = false;   //LOCATE THE START OF THE SCREEN WHERE USER INVIEW.

        if ($scope.result == undefined)
          return;

        //LOOP THRU ALL THE PRODUCTS RETURNED
        for (var i = 0; i < $scope.result.length; i++) {

          if ($window.document.getElementsByClassName('pageNum')[i] != undefined){
            //FOUND THE LOCATION ID OF EACH PRODUCT WHICH DEFINE IT IS STILL ON SCREEN.
            domID = $window.document.getElementsByClassName('pageNum')[i].getAttribute('id');

            if (!utilities.inViewPort(domID) && foundStartOfView){
              //THIS PRODUCT IS NO LONGER IN USER'S VIEW. EXIT THE SEARCH
              break;
            }else if(utilities.inViewPort(domID)){
              //THE CURRENT PRODUCT IS IN USER'S VIEW
              foundStartOfView = true;
              pageNUM = $window.document.getElementsByClassName('pageNum')[i].getAttribute('page');
            }
          }
        }

        //UPDATE THE SEARCH COMPONENT PAGINGATION PAGE NUM
        if (pageNUM && !isNaN(pageNUM)){
          $scope.pageSelector_pgNum = pageNUM;
          $scope.$apply();
        }
      });


      ////////////////////////////
      //  SCROLL DOWN TO LOAD MORE
      ////////////////////////////
      this.loadMoreListings = function() {
        if (!self.lk_loadMore && !self.lk_retrieveListing && self.currentPageCount) {
          self.lk_loadMore = true;
          self.currentPageCount++;
          $scope.pageSelector_pgNum = self.currentPageCount;
          $scope.params.currentPage = self.currentPageCount;
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":rentalListingsCtrl:loadMoreListings - Loading more rental listing from page " + self.currentPageCount) : '';
          Session.prev_ListingParams = angular.copy(self.prev_ListingParams_local);
          self.getDeletedListings(self.currentPageCount);
        }
      };

      ////////////////////////////
      // REFRESH THE SERACH RESULT
      // BASED ON THE PAGE CLICK
      ////////////////////////////
      self.pageSelectorClick = function(){
        Session.prev_ListingResult = [];
        $scope.result = [];
        $scope.params.currentPage = $scope.pageSelector_pgNum;
        self.currentPageCount = $scope.params.currentPage;
        var searchParams = self.prev_ListingParams_local ? self.prev_ListingParams_local : Session.prev_ListingParams;
        self.getDeletedListings($scope.pageSelector_pgNum);
      }

      ////////////////////////////
      // DETECT MOBILE VIEW
      ////////////////////////////
      self.isMobileView = function(){
        return utilities.isMobileView();
      }

      ////////////////////////////
      //  CONVERT THE URL PARAMETERS TO SERVICE API PARAMETERS
      ////////////////////////////
      function prepareParam(params) {
        return {
          owner:params.owner,
          brand: params.brand,
          category: params.category,
          subCategory: params.subCategory,
          priceMin: params.min,
          priceMax: params.max,
          rentalFeeMin: params.feeMin,
          rentalFeeMax: params.feeMax,
          creditMin: params.creditMin,
          creditMax: params.creditMax,
          color: params.color,
          rentStatus: params.rentStatus,
          sort: params.sort,
          size: params.size,
          discountRateMin: params.fdmin,
          discountRateMax: params.fdmax,
          page: params.page,
          tags: params.q,
          types: params.type,
          itemCondition: params.itemCondition,
          country: $rootScope.geoLocation.country
        };
      }



    $rootScope.$on("CallFilterDeleted", function(evt, data){
      $scope.result = []
      if(data) {
        self.rentalFilter = {};
        self.rentalFilter.brand = data.brand,
        self.rentalFilter.category = data.category,
        self.rentalFilter.subCategory = data.subCategory,
        self.rentalFilter.min = data.min,
        self.rentalFilter.max = data.max,
        self.rentalFilter.creditMin = data.creditMin,
        self.rentalFilter.creditMax = data.creditMax,
        self.rentalFilter.color = data.color,
        self.rentalFilter.size = data.size,
        self.rentalFilter.itemCondition = data.itemCondition,
        self.rentalFilter.rentStatus = data.status
        self.rentalFilter.type = CONFIG.DELETED_LISTING;
      }
      self.getDeletedListings();
    });
    
    
    this.getDisplayPrice = function(product) {
      return priceUtilities.getDisplayPriceV2(product);
    }

    this.getDisplayPurchasePrice = function(product) {
      return priceUtilities.getDisplayPurchasePriceV2(product);
    }

    this.getDisplayPhoto = function(product, position){
      return utilities.getDisplayPhoto(product, position);
    }
    
    this.toggleWishlist = function(product) {
      self.displayedProductWishlist = product.id;
      self.isWishlistDisabled = true;
      var allSizes = product.sizes;
      for (var index in allSizes) {
        var sizeWishlist = allSizes[index].wishlist;
        if(sizeWishlist){
          self.isWishlistDisabled = false;
          break;
        }
      }
    }


    this.saveWishlist = function(product){
      DialogAlertService.saveWishlist(product);
    }
    
    this.isSalePriceSameWithOrigPrice = function(product){
      return priceUtilities.isSalePriceSameWithOrigPrice(product.price, product.discountRate)
    }

    this.getProductWith = function(){
      if(utilities.isShowMainRegion()){
        $state.go('search', {q:self.shopName,mm:true,brand: null,category: null,min: CONFIG.PRICE_MIN,max: CONFIG.PRICE_MAX,fdmin: null,fdmax: null,feeMin:null,feeMax:null,fp: null,type:CONFIG.DEFAULT_SEARCH_TYPE,page:null,status:null,sort:CONFIG.DEFAULT_SEARCH_SORT_ORDER,color:null,size:null});
      } else {
        $state.go('search-multi-region', {q:self.shopName,mm:true,brand: null,category: null,min: CONFIG.PRICE_MIN,max: CONFIG.PRICE_MAX,fdmin: null,fdmax: null,feeMin:null,feeMax:null,fp: null,type:CONFIG.DEFAULT_SEARCH_TYPE,page:null,status:null,sort:CONFIG.DEFAULT_SEARCH_SORT_ORDER,color:null,size:null,country: $rootScope.geoLocation.country});
      }
    }
    
    }]
})

'use strict';
angular.module('coutureApp')
  .component('accountVerified', {
    controllerAs : 'accountVerifiedCtrl',
    templateUrl: 'scripts/components/account-verified/account-verified.html',
    controller: ["$scope", "$state", "$rootScope", "$log", "$anchorScroll", "utilities", "usSpinnerService", "UserService", function($scope, $state,$rootScope,$log,$anchorScroll,utilities,usSpinnerService,UserService) {

      var self = this;
      
      this.$onInit = function(){
        $scope.registeredUsername = $rootScope.registeredUsername;
        $scope.registeredEmailAddress = $rootScope.registeredEmailAddress;
        $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - accountVerified"):'';
        utilities.goToTop();
      }

      $scope.resendVerificationEmail = function() {
        usSpinnerService.spin('spinner');
        UserService.resendVerificationEmail($scope.registeredUsername).$promise.then(
          function(resp){
            usSpinnerService.stop('spinner');
            self.lk_reg = false;
            $scope.showVerificationEmailRequest = true;
            $scope.showResendVerification = false;
            $scope.isShowSignin = false;
            $anchorScroll('top');
          },
          function(err){
            usSpinnerService.stop('spinner');
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":accountVerifiedCtrl:resendVerificationEmail - Error: " + err):'';
          });
      };

  }]
})

'use strict';
angular.module('coutureApp')
  .component('accountVerifiedQuickSignUp', {
    controllerAs : 'accountVerifiedQuickSignUpCtrl',
    templateUrl: 'scripts/components/account-verified-quick-sign-up/account-verified-quick-sign-up.html',
    controller: ["$scope", "$state", "$rootScope", "$log", "$anchorScroll", "utilities", "usSpinnerService", "UserService", function($scope, $state,$rootScope,$log,$anchorScroll,utilities,usSpinnerService,UserService) {

      var self = this;
      
      this.$onInit = function(){
        $scope.registeredUsername = $rootScope.registeredUsername;
        $scope.registeredEmailAddress = $rootScope.registeredEmailAddress;
        $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - accountVerifiedQuickSignUp"):'';
        utilities.goToTop();
      }

      $scope.resendVerificationEmail = function() {
        usSpinnerService.spin('spinner');
        UserService.resendVerificationEmail($scope.registeredUsername).$promise.then(
          function(resp){
            usSpinnerService.stop('spinner');
            self.lk_reg = false;
            $scope.showVerificationEmailRequest = true;
            $scope.showResendVerification = false;
            $scope.isShowSignin = false;
            $anchorScroll('top');
          },
          function(err){
            usSpinnerService.stop('spinner');
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":accountVerifiedQuickSignUpCtrl:resendVerificationEmail - Error: " + err):'';
          });
      };

  }]
})

'use strict';
angular.module('coutureApp')
  .component('signUpThankYou', {
    controllerAs : 'signUpCtrl',
    templateUrl: 'scripts/components/sign-up-thank-you/sign-up-thank-you.html',
    controller: ["$scope", "$state", "$rootScope", "$log", "utilities", "UserService", "usSpinnerService", "AuthService", "ErrorHandler", "Session", "DialogAlertService", "$filter", "RefDataService", "$translatePartialLoader", "$anchorScroll", function($scope, $state,$rootScope,$log,utilities,UserService,usSpinnerService,AuthService,ErrorHandler,Session,DialogAlertService,$filter,RefDataService,$translatePartialLoader,$anchorScroll) {

      var self = this;
      $translatePartialLoader.addPart('logon_off');
      this.$onInit = function(){
        self.signUpPromoCode = "WELCOME10";
        self.signUpPromoDescription = "10%";
        var referralDetails = Session.getReferralRewardCode();
        
        if(referralDetails) {
          self.signUpPromoCode = referralDetails.rewardCode;
          self.signUpPromoDescription = referralDetails.rewardDescription;
        }
        
        $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - signUpThankYou"):'';
        utilities.goToTop();
      }


      this.goToStylePass = function() {
        window.open("https://stylecarousel.com/landing/stylepass", '_blank');
      }
  }]
})

'use strict';
angular.module('coutureApp')
  .component('activateQuickRegister', {
    controllerAs : 'aqrCtrl',
    templateUrl: 'scripts/components/activate-quick-register/activate-quick-register.html',
    controller: ["$scope", "$state", "$rootScope", "$log", "utilities", "UserService", "usSpinnerService", "AuthService", "ErrorHandler", "Session", "DialogAlertService", "$filter", "RefDataService", "$translatePartialLoader", "$anchorScroll", function($scope, $state,$rootScope,$log,utilities,UserService,usSpinnerService,AuthService,ErrorHandler,Session,DialogAlertService,$filter,RefDataService,$translatePartialLoader,$anchorScroll) {

      var self = this;
      $translatePartialLoader.addPart('logon_off');
      this.$onInit = function(){
        $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - accountQuickRegister"):'';
        

        $scope.phoneCodeList = RefDataService.getCountryList();
        self.defaultPhoneCode = utilities.getLocationPhoneCode();
        self.phoneCodeFlag = utilities.getPhoneCountryFlag(self.defaultPhoneCode);
        if($state.params.token) {
          self.token = $state.params.token;
          UserService.getActivationDate(self.token).$promise.then(
            function(resp){
            self.activationDate = resp ? resp.activationDate : null;
            self.isActivated = self.activationDate !== null;
            var date = self.activationDate === null ? new Date() : new Date(self.activationDate);
            self.activationMessage = 'Your account has been activated successfully on ' + date + '!';
            utilities.goToTop();
          });

          // REGISTRATION MODEL
          self.reg_info = {
                "username": "",
                "password": "",
                "email": "",
                "firstName": "",
                "lastName": "",
                "phone1": "",
                "phoneCode": self.defaultPhoneCode
          };

          self.clickedSubmitted = false;
          self.activateStatus = false;

          self.error_msg = {
            "password":"Passwords don’t match or have less than 8 characters.",
            "name": "Please enter your name.",
            "phonenum": "Please enter your phone number.",
            "username": "Please enter a valid username."
          };

          self.resetErrorMsg()
          self.formError = false;
          $scope.phoneCodeList = RefDataService.getCountryList();
        }else{
          DialogAlertService.promptDialog("Error activate the account, please contact StyleCarousel support.", '', '', '', 'GENERAL.LABEL.OK', backToMain(), '', false,'',"RED");
        }
      }

      function backToMain(){
        if(utilities.isShowMainRegion()){
          $state.go('main');
        } else {
          $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
        }
      }

      ////////////////////////////
      //  USER REGISTRATION SERVICE
      ////////////////////////////
    	this.signUp = function(event) {
        self.clickedSubmitted = true;
        self.validateForm();

        if (!self.formError){
          self.errors = "";
          usSpinnerService.spin('spinner');
      		self.lk_reg = true;
          UserService.quickRegActivateToken(self.token).$promise.then(function(resp){
            UserService.quickRegCompleteAccountInfo(self.reg_info).$promise.then(
        			function(resp){
                var date = new Date();
        				usSpinnerService.stop('spinner');
        				self.lk_reg = false;
                self.clickedSubmitted = false;
        				$log.info('Activated '+ self.reg_info.username +' succeeded on ' + date);
                self.activateStatus = true;
                self.isActivated = true;
                utilities.goToTop();
        			},
        			function(err){
        				usSpinnerService.stop('spinner');
        				self.lk_reg = false;
        				var err = ErrorHandler.resolveErrorToString(err);
        				self.errors = err;
                AuthService.logoff();
                $rootScope.isLogon = false;
                $rootScope.enableLog ? $log.error($rootScope.UUID + ":aqrCtrl:signUp - Quick Registration error: " + err):'';
      			});
          },function(err){
            usSpinnerService.stop('spinner');
            self.lk_reg = false;
            self.clickedSubmitted = false;
            var err = ErrorHandler.resolveErrorToString(err);
            self.errors = $filter('translate')('GENERAL.ERROR.SYS_ERR_TOKEN');
            AuthService.logoff();
            $rootScope.isLogon = false;
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":aqrCtrl:signUp - Quick Registration Token Error: " + err):'';
          })
        }
    	};


      ////////////////////////////
      //  RESET REGISTRATION ERROR MESSAGE
      ////////////////////////////
      this.resetErrorMsg = function(){
        self.formError = false;
        self.errors = false;
        self.reg_errors = {
          "password":false,
          "name":false,
          "username":false,
          "phonenum":false
        };
        self.usernameErr = false;
      }

      ////////////////////////////
      //FORM VALIDATION
      ////////////////////////////
      this.validateUsername = function(){
        if (self.reg_info.username == ""){
          self.usernameErr = false;
        }
        self.usernameErr = !utilities.isUsernameValid(self.reg_info.username);
      }
      this.validateForm = function(){
        if (self.clickedSubmitted){
          self.resetErrorMsg();

          if (self.reg_info.username == "" || !utilities.isUsernameValid(self.reg_info.username)){
            self.reg_errors.username = true;
          }
          if (self.reg_info.firstName == "" || self.reg_info.lastName == ""){
            self.reg_errors.name = true;
          }
          if (self.reg_info.phone1 == ""){
            self.reg_errors.phonenum = true;
          }
          if (self.reg_info.password == ""){
            self.reg_errors.password = true;
          }

          utilities.validatePassword(self.register_password , self.reg_info.password) ? self.reg_errors.password = true : '';

          for (let key in self.reg_errors){
             if(self.reg_errors.hasOwnProperty(key) && self.reg_errors[key]){
               self.formError = true;
             }
          }
        }
      }


      $scope.setSelectedPhoneCode = function(countryCode, phoneCode, phoneCodeFlag) {
        self.reg_info.phoneCode = countryCode + " " + phoneCode;
        self.phoneCodeFlag = phoneCodeFlag;
      }

      this.goShop = function() {
        if(utilities.isShowMainRegion()){
          $state.go('main');
        } else {
          $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
        }
      }

      this.goToStylePass = function() {
        window.open("https://stylecarousel.com/landing/stylepass", '_blank');
      }
      
      $('.dropdown-menu').find('input').click(function (e) {
        e.stopPropagation();
      });
  }]
})

'use strict';

/**
 * @ngdoc function
 * @name coutureApp.controller:listingsEditCtrl
 * @description
 * # listingsEditCtrl
 * Controller of the coutureApp
 */
angular.module('coutureApp')
  .component('listingsEdit', {
    controllerAs: 'listingsEditCtrl',
    templateUrl: 'scripts/components/listings-edit/listings-edit.html',
    controller: ["$scope", "$state", "Session", "$rootScope", "ListingService", "$http", "$log", "$stateParams", "$sce", "$translate", "$filter", "NgTableParams", "ProductService", "Upload", "utilities", "AuthService", "RefDataService", "$q", "$anchorScroll", "UploadService", "usSpinnerService", "DialogAlertService", "priceUtilities", "ErrorHandler", "CONFIG", "productStatus", "USER_ROLES", function($scope, $state, Session, $rootScope, ListingService, $http, $log, $stateParams, $sce, $translate, $filter, NgTableParams, ProductService,
      Upload, utilities, AuthService, RefDataService, $q, $anchorScroll, UploadService, usSpinnerService, DialogAlertService, priceUtilities, ErrorHandler, CONFIG,
      productStatus, USER_ROLES) {

      var self = this;

      // DISABLE FEATURE WHERE SAME PRODUCT HAD MORE THEN 1 SIZE OR SUB-ITEMS.
      self.isMultiSizeFeatureEnable = CONFIG.LISTING_SUPPORT_MULTISIZE;
      $scope.editSize = self.isMultiSizeFeatureEnable ? false: true;

      self.sizeForAllCategory = null;

      //THE SPECIFIC FIELDS USED FOR CUSTOMER ENTER BRAND NOT ON THE PRODUCT LIST
      self.isSelectedOtherBrand = false;
      self.otherBrandName = '';
      self.duplicateMode = false;

      // original price section
      $scope.originalPrice = null;

      self.UPLOAD_PHOTO_LIMIT = CONFIG.UPLOAD_PHOTO_LIMIT;
      self.PHOTO_LIMIT_MIN = CONFIG.PHOTO_SIZE_LIMIT_MIN;
      self.PHOTO_LIMIT_MAX = CONFIG.PHOTO_SIZE_LIMIT_MAX;
      self.PHOTO_RESIZE_QTY = CONFIG.PHOTO_RESIZE_RATIO;
      self.PHOTO_RESIZE_WIDTH = CONFIG.PHOTO_RESIZE_WIDTH;
      self.PHOTO_RESIZE_HEIGHT = CONFIG.PHOTO_RESIZE_HEIGHT;
      self.PRODUCT_MIN_PRICE = CONFIG.PRICE_MIN;
      self.EARNING_FROM = CONFIG.EARNING_FROM;
      self.EARNING_TO = CONFIG.EARNING_TO;

      self.childProductSizeHT = {};
      $scope.originalSizeList = [];
      $scope.tempSizeList = [];

      self.proudct_currency = priceUtilities.getCurrency();
      $scope.earning_toolTip_html = $sce.trustAsHtml($filter('translate')("LISTING.LABEL.EARNING_TOOLTIP_HTML"));

      $scope.leftArrow = '/assets/images/ArrowLeft.png';
      $scope.rightArrow = '/assets/images/ArrowRight.png';

      // select a category section
      $scope.selectedCategory = null;

      $scope.selectedBrand = null;
      $scope.selectedColor = null;
      $scope.selectedTags = null;

      // item condition section
      $scope.conditionTooltip = $sce.trustAsHtml('<p>NEW<br/>Preowned Never Worn<br/>(with / without tags and no alterations)</p>');
      $scope.conditionTooltip += $sce.trustAsHtml('<p>PRISTINE<br/>Preowned Worn Once or Twice<br/>(with no obvious flaws)</p>');
      $scope.conditionTooltip += $sce.trustAsHtml('<p>EXCELLENT<br/>Preowned (with slight or small imperfections)</p>');
      $scope.selectedCondition = null;

      $scope.selectedAlter = null;
      $scope.anythingElse = null;

      // tag price section
      $scope.tagPrice = null;
      $scope.priceDiscount = 0;
			self.lowestPlan = priceUtilities.getSubscriptionPlanDetails(CONFIG.PLAN_SUBSCRIPTION_4)
			self.lowestPlanPrice = priceUtilities.getDiscountedCreditPrice($rootScope.geoLocation.country);


      self.$onInit = function() {

        $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - listingsEdit") : '';
        if ($rootScope.isLogon) {
          if (!$state.params.id) {
            if(utilities.isShowMainRegion()){
              $state.go('main');
            } else {
              $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
            }
          } else {
            if($rootScope.geoLocation.country === CONFIG.COUNTRY_CURRENCY_CODE.SG.country_code){
              RefDataService.getForexList().$promise.then(function(resp) {
                self.forex = resp;
                var f = self.forex.filter(f=>f.currency == CONFIG.COUNTRY_CURRENCY_CODE.SG.currency_code);
                
                $scope.sgdForex = f.length > 0 ? f[0].amount : 1;
              });
            }

            if ($state.params.duplicate) {
              self.duplicateMode = true
            };
            $scope.productID = $state.params.id;
            self.getProductDetails($scope.productID);
            self.loadCategory();
            $scope.colors = utilities.getColorList();

            $scope.photos = [];
            $scope.selectedDisplayPhotoIndex = 0;

            RefDataService.getBrands().$promise.then(function(resp) {
              self.brandList = resp;
              self.brandList.unshift({
                'id': 'OTHER',
                'name': '-- Other Brand --'
              });
            });

			      self.sizeForAllCategory = RefDataService.getSizeList();
            self.itemConditions = RefDataService.getItemConditions();

            
          }
          if (AuthService.isAuthorized(USER_ROLES.admin)){
						$scope.isAdmin = true;
					}
        } else {
          DialogAlertService.openLogon(function(){
            $state.reload();
          },function(){
          if(utilities.isShowMainRegion()){
			      $state.go('main');
          } else {
            $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
          }
          });
        }
      }


      self.loadSizes = function() {
        RefDataService.getSizeList().$promise.then(function(resp) {
          self.sizeForAllCategory = resp;
          getFilteredSizeList();
        });
      }

      //////////////////////////////////////////////////////////////
      //CONSOLIDATE THE SIZE INTO A HashTable with {KEY:SKU VALUE:[ChildProduct]}
      //////////////////////////////////////////////////////////////
      function getChildProductSizeHT(childProducts) {
        var tempHT = {};
        if (childProducts) {
          childProducts.forEach((item, i) => {
            var key = item.size + item.condition;
            if (tempHT[key] !== undefined) {
              tempHT[key].list.push(item);
            } else {
              tempHT[key] = {
                'list': [item],
                'size': item.size,
                'sizeValue': item.sizeValue,
                'sizePosition': item.sizePosition,
                'condition': item.condition,
                'conditionValue': item.conditionValue,
                'qty': item.qty
              };
            }
          });
        }
        return tempHT;
      }

      ////////////////////////////////////////////////
      //FUNCTION COMPARE THE ORIGINAL SIZE LIST AND THE TEMP SIZE LIST
      //RESULT self.sizeChange WITH 2 ARRAYS, WHICH CONTAINS ADDED SIZE/QTY AND REMOVED SIZE/QTY
      //OWNER CAN REMOVE AVAIABLE AND AVAIABLE-INSTANT SIZE. ADMIN CAN REMOVE ALL STATUS.
      //COMPARE THE ORIGINAL LIST WITH THE MOD LIST.
      //ALSO IT WILL RETURN FALSE IS VALIDATE ERROR, ELSE TRUE
      ////////////////////////////////////////////////
      $scope.isSizeListValid = function() {
        var validateError = false;
        var tempSizeHT = getChildProductSizeHT($scope.tempSizeList);

        if (tempSizeHT['undefined']){
          //ADDED NEW SIZE AND QTY, BUT NO SIZE IS SELECTED.
          return validateError;
        }else{
          validateError = true;
        }

        self.sizeChange = {
          'ADDED': [],
          'REMOVED': []
        };


        Object.keys(self.childProductSizeHT).forEach((key) => {
          if (tempSizeHT[key] === undefined) {
            self.sizeChange.REMOVED.push({
              'size': self.childProductSizeHT[key].list[0].size,
              'qty': self.childProductSizeHT[key].list.length,
              'condition': self.childProductSizeHT[key].list[0].condition
            });

          } else if (tempSizeHT[key].list[0].qty === undefined) {
            self.sizeChange.REMOVED.push({
              'size': self.childProductSizeHT[key].list[0].size,
              'qty': self.childProductSizeHT[key].list.length,
              'condition': self.childProductSizeHT[key].list[0].condition
            });

          } else if (tempSizeHT[key].list[0].qty < self.childProductSizeHT[key].list.length) {
            self.sizeChange.REMOVED.push({
              'size': self.childProductSizeHT[key].list[0].size,
              'qty': self.childProductSizeHT[key].list.length - tempSizeHT[key].list[0].qty,
              'condition': self.childProductSizeHT[key].list[0].condition
            });

          } else if (tempSizeHT[key].list[0].qty > self.childProductSizeHT[key].list.length) {
            self.sizeChange.ADDED.push({
              'size': tempSizeHT[key].list[0].size,
              'qty': tempSizeHT[key].list[0].qty - self.childProductSizeHT[key].list.length,
              'condition': tempSizeHT[key].list[0].condition
            });

          }
        });

        Object.keys(tempSizeHT).forEach((key) => {
          if (self.childProductSizeHT[key] === undefined) {
            self.sizeChange.ADDED.push({
              'size': tempSizeHT[key].list[0].size,
              'qty': tempSizeHT[key].list[0].qty,
              'condition': tempSizeHT[key].list[0].condition
            });
          }
        })

        $rootScope.enableLog ? $log.info($rootScope.UUID + ":listingsEdit:isSizeListValid - " + JSON.stringify(self.sizeChange)) : '';
        return true;
      }



      ////////////////////////////////////////////////
      //CREATE A PRODUCT SIZE HT FOR COMPARE CHANGED SIZE VS ORIGINAL SIZE & QTY
      //CREATE A ORIGINAL SIZE LIST AS REFERENCE TO COMPARE EDIT OF SIZE/QTY
      //CREATE A TEMP SIZE LIST FOR EDIT
      ////////////////////////////////////////////////
      function getChildProductList(productID) {
        //RESET VALUES
        $scope.tempSizeList = [];
        self.childProductSizeHT = {};
        $scope.originalSizeList = [];

        ProductService.getChildProductList(productID).$promise.then(function(resp) {
          self.childProductSizeHT = getChildProductSizeHT(resp);
          Object.keys(self.childProductSizeHT).forEach((item, i) => {
            $scope.originalSizeList.push({
              'size': self.childProductSizeHT[item].size,
              'qty': self.childProductSizeHT[item].list.length,
              'disabledSizeChange': self.isMultiSizeFeatureEnable ? true:false,  //ALLOW TO CHANGE PRODUCT SIZE ONLY IF THE MULTI SIZE FEATURE IS NOT AVAILABLE.
              'desc': self.childProductSizeHT[item].size,
              'sizeValue': self.childProductSizeHT[item].sizeValue,
              'sizePosition': self.childProductSizeHT[item].sizePosition,
              'condition': self.childProductSizeHT[item].condition,
              'conditionValue': self.childProductSizeHT[item].conditionValue
            })
          })
          angular.copy($scope.originalSizeList, $scope.tempSizeList);
          $scope.tempSizeList.sort(function(a, b){return a.sizePosition-b.sizePosition;});
        }, function(err) {
          $rootScope.enableLog ? $log.error($rootScope.UUID + ":listingsEdit:getChildProductList - Issue getting child products.") : '';
        });
      }

      ////////////////////////////////////////////////
      //ADD NEW SIZE AND QTY TO THE PRODUCT.
      ////////////////////////////////////////////////
      $scope.addSize = function() {
        getFilteredSizeList();
        //CREATE A DEFAULT BLANK VALUE
        $scope.tempSizeList.push({
          value: "",
          'qty': 1,
          'condition': 'NEW',
          'conditionValue': 'New'
        });
      }

      ////////////////////////////////////////////////
      //REMOVE THE SELECTED SIZE
      ////////////////////////////////////////////////
      $scope.deleteSize = function(removeSize) {

        for (var i = 0; i < $scope.tempSizeList.length; i++) {
          if ($scope.tempSizeList[i] === removeSize) {
            $scope.tempSizeList.splice(i, 1);
            break;
          }
        }
        getFilteredSizeList();
      }


      $scope.photoToDisplay = function(photo) {
        return (photo && photo._url) ? photo._url : photo;
      }

      // brand section
      $scope.toggleDropdown = function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        $scope.status.isopen = !$scope.status.isopen;
      };


      $scope.setDiscountAndCredit = function() {
        $scope.setDiscount();
        self.listing.credit = priceUtilities.returnEquivalentCreditValue(self.listing.price);
        self.calculateEarnings();
      }
      $scope.setDiscount = function() {
        self.error_original_price = null;
        if ($scope.originalPrice > 0 && $scope.originalPrice != self.listing.price && (self.listing.price == undefined || $scope.originalPrice > self.listing.price)) {
          $scope.priceDiscount = priceUtilities.setDiscount($scope.originalPrice, self.listing.price);
        } else {
          $scope.priceDiscount = 0;
        }
        self.listing.discountRate = priceUtilities.setDiscount($scope.originalPrice, self.listing.price)
      };


      ///////////////////////////////////////////////
      // SET THE USER ENTERED DATA IN TO THE LISTING PARAMETERS AND CLEAR THE ERROR MSG
      ///////////////////////////////////////////////
      self.setSelected = function(type, selectedValue) {
        switch (type) {
          case 'category':
            self.error_category = null;
            self.listing.category = selectedValue;
            self.subcategoryList = self.listing.category.subCategory;
            getFilteredSizeList();
            break;
          case 'subcategory':
            self.error_subcategory = null;
            self.listing.subCategory = selectedValue;
            break;
          case 'brand':
            self.error_brand = null;
            if (selectedValue) {
              self.listing.brand = selectedValue.name;
              //ADD SPECIAL LOGIC WHEN USER ENTER OTHER BRAND, THE listing WILL REMAINS '-- OTHER BRAND --'
              //BUT THE ACTUAL BRAND WILL BE STORED IN TAG. HOWEVER IT WILL NOT GOING TO DISPLAY ON SCREEN.
              if (selectedValue.name == '-- Other Brand --') {
                self.isSelectedOtherBrand = true;
              } else {
                self.isSelectedOtherBrand = false;
              }
            }
            break;
          case 'color':
            self.error_color = null;
            self.listing.color = selectedValue.name;
            break;
          case 'condition':
            $scope.selectedCondition = selectedValue;
            break;
            // case 'credit':
            // 	self.error_credit= null;
            //   self.listing.credit= selectedValue;
            //   // self.listing.credit= selectedValue.KEY;
            // 	// self.selectedCredit= selectedValue.VALUE;
            //   break;
          case 'alter':
            $scope.selectedAlter = selectedValue;
            break;
        }
      };


      //////////////////////////////////////////
      //SET THE SELECTED PRODUCT SIZE
      //////////////////////////////////////////
      self.setSize = function(list, sizeObj) {
        list.size = sizeObj.key
        list.desc = sizeObj.value,
        list.sizeValue = sizeObj.value;
      }
      self.setCondition = function(list, conditionObj) {
        list.condition = conditionObj.key
        list.conditionValue = conditionObj.value;
      }

      //////////////////////////////////////////
      //GET ESTIMATE EARNING FOR RENTAL ITEM
      //////////////////////////////////////////
      self.getEarningAmount = function(periodFee) {
        return priceUtilities.getEarning(periodFee);
      }

      ///////////////////////////////////////////////
      // SET THE USER ENTERED DATA IN TO THE listing PARAMETERS AND CLEAR THE ERROR MSG
      ///////////////////////////////////////////////
      $scope.$watch('invalidPhotos', function(invalidPhotos) {
        if (invalidPhotos != null && invalidPhotos.length > 0) {
          self.error_photo = $filter('translate')("GENERAL.ERROR.INVALID_PRODUCT_PHOTO1") + self.PHOTO_LIMIT_MIN + $filter('translate')(
            "GENERAL.ERROR.INVALID_PRODUCT_PHOTO2") + self.PHOTO_LIMIT_MAX;
        }
      });


      ////////////////////////////////////////////////////////////////
      //  TRIGGER THE FUNCTION TO UPDATE THE LISTING
      ////////////////////////////////////////////////////////////////
      $scope.saveClose = function() {
        if (self.validate() && !self.lk_listing) {
          self.update();
          // self.duplicateMode ? self.saveNew() : self.update();
        } else {
          self.lk_listing = false;
          $anchorScroll('top');
        }
      };



      ////////////////////////////////////////////////////////////////
      //  SAVE AS NEW LISTING
      ////////////////////////////////////////////////////////////////
      self.saveNew = function(listingDetails) {

        //REMOVE THESE FIELDS RETURNED FROM EXISTING RECORD AS THIS IS NOT NEEDED FOR NEW LISTING.
        delete listingDetails.rentalPeriod;
        delete listingDetails.pendingApprovalRentals;
        delete listingDetails.rentalPeriod;
        delete listingDetails.status;
        delete listingDetails.modifyDate;
        delete listingDetails.instantRental;
        delete listingDetails.creationDate;
        delete listingDetails.canRental;
        delete listingDetails.owner;
        delete listingDetails.id;
        delete listingDetails.myFavorite;
        delete listingDetails.numberOfFavorite;
        delete listingDetails.pictures;
        var config = {
          headers: {
            'Accept': "image/jpeg",
            'Access-Control-Allow-Origin': '*',
            'Vary': '*'
          }
        };

        var ownPhoto = [];
        ownPhoto = $scope.photos.map(p => {
          if (p._url) {
            $http.get(p._url, config).then(function(response) {
              var myBuffer = new Uint8Array(response.data);
              return new Blob([myBuffer], {
                type: 'image/jpeg;charset=UTF-8'
              });
            });
          } else {
            return p;
          }
        })

        self.lk_listing = false;
        usSpinnerService.stop('spinner');

      }


      //////////////////////////////////////////
      // TOGGLE EDIT SIZE FLAG
      // TOGGLE THE VALUE IN THE HTML CANNOT REFRESH THE VALUE
      //////////////////////////////////////////
      self.toggleEditSize = function(){
        $scope.editSize = !$scope.editSize;
      }


      //////////////////////////////////////////
      // SAVE SIZE & QTY CHANGES
      // CHANGE PRODUCT SIZE MEANING REMOVE OLD SIZE AND THEN ADD NEW SIZE.
      //////////////////////////////////////////
      $scope.saveSizeChange = function(){
        if (!$scope.isSizeListValid()){
          DialogAlertService.promptDialog("Please select a size to be added.", '', '', '', '', '', '', true, '', 'RED');
          return;
        }

        $scope.editSize = !$scope.editSize;

        var promises = updateProductItems();
        // HANDLE THE ERRORS
        $q.all(promises).then(function(resp) {
          if (promises.length > 0){
            getChildProductList(self.listing.id);
          }

        },function(err){
          //AS THE ERROR MIGHT HAVE PARTIAL SUCCESSFUL OF ADD/REMOVE SIZE.
          //DISCARD THE CHANGES AND HAVE THE EDIT START OVER

          angular.copy($scope.originalSizeList, $scope.tempSizeList);
          var msg = ErrorHandler.resolveError(err).toString();
          msg += ". Size information will be reloaded.";
          DialogAlertService.promptDialog(msg, '', '', '', '', '', '', true, '', 'RED');
          if (err.data) {
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":listingsEdit:saveSizeChange - Save size error: " + err.data.reasons[0].message + " (" + self.listing.id + ")") : '';
          } else {
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":listingsEdit:saveSizeChange - ave size error: " + err + " (" + self.listing.id + ")") : '';
          }
        })

      }

      //////////////////////////////////////////
      // RETURN AN PROMISES ARRAY OF ADD OR REMOVE SIZE
      //////////////////////////////////////////
      function updateProductItems(){
        var promises = [];
        var productItems =
        {
          'itemsToBeAdded': [],
          'itemsToBeDeleted': []
        };

        angular.copy(self.sizeChange.ADDED, productItems.itemsToBeAdded);
        angular.copy(self.sizeChange.REMOVED, productItems.itemsToBeDeleted);
        $rootScope.enableLog ? $log.info($rootScope.UUID + ":listingsEdit:updateProductItems - " + JSON.stringify(productItems)) : '';
        promises.push(ProductService.updateProductItem(self.listing.id, productItems).$promise);
        return promises;
      }




      //////////////////////////////////////////
      //  DISCARD SIZE & QTY CHANGES
      //////////////////////////////////////////
      $scope.discardSizeChange = function(){
        $scope.editSize = !$scope.editSize;

        //GET CHILD PRODUCTS (SIZE, QTY)
        angular.copy($scope.originalSizeList, $scope.tempSizeList);

        $scope.tempSizeList.sort(function(a, b){return a.sizePosition-b.sizePosition;});
        $scope.isSizeListValid();
      }


      //////////////////////////////////////////
      //  GET THE PRODUCT LISTING DETAILS
      //////////////////////////////////////////
      self.getProductDetails = function(id) {
        var startTime = new Date();

        ListingService.getListing(id).$promise.then(
          function(resp) {
            var endTime = new Date();
            $rootScope.enableLog ? $log.info($rootScope.UUID + ":listingsEdit:getProductDetails - retrieved in " + (endTime - startTime) + 'ms. (' + id + ")") : '';
            self.listing = resp;

            if (self.listing.price > 0 && $rootScope.geoLocation.country == CONFIG.COUNTRY_CURRENCY_CODE.SG.country_code){
              var amt = self.listing.price * $scope.sgdForex;
              self.listing.price = Math.round(amt);
            }

            self.subcategoryList = getFilteredSubcategoryList(self.listing.category);
            $scope.originalPrice = resp.price;

            //RETURN THE SIZE OBJECT {KEY:'IT36', VALUE:'EU35 / IT35 / FR36 / US5 / UK2'} BASED ON THE SIZEKEY
            var foundSizeObject = utilities.returnMatchedSizeObject(self.listing.category, resp.size);

            //THE SIZE PROPERTY IS NOT LONG NEEDED, AS SIZE IS BASED ON SUB-PRODUCT
            delete self.listing.size;

            if (self.listing.discountRate > 0) {
              $scope.priceDiscount = self.listing.discountRate;
              $scope.originalPrice = angular.copy(resp.price);
              self.listing.price = Math.round(resp.price * (1 - resp.discountRate));
            }
            $scope.setDiscount();

            //REORDER THE PHOTO AS PER THE PICORDER
            var newReOrderedPictures = [];
            resp.pictures.forEach(function(pic, index) {
              newReOrderedPictures.push(resp.pictures.filter(function(p) {
                return p.picOrder == index
              })[0]);
            })
            $scope.photos = newReOrderedPictures;

            $scope.selectedDisplayPhotoIndex = 0;

            //STATUS CODE = 8 (AVAILABLE)
            self.isEdit = utilities.isProductEditable(resp); //  resp.status != 8 ? false : true;
            self.listing._isOwner = self.isEdit ? true : false;

            if (!self.listing._isOwner || !self.isEdit) {
              if(utilities.isShowMainRegion()){
                $state.go('main');
              } else {
                $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
              }
            }

            self.listing.brand = resp.brand;
            //ADD SPECIAL LOGIC WHEN USER ENTER OTHER BRAND, THE listing WILL REMAINS '-- OTHER BRAND --'
            //BUT THE ACTUAL BRAND WILL BE STORED IN TAG. HOWEVER IT WILL NOT GOING TO DISPLAY ON SCREEN.
            if (self.listing.brand === '-- Other Brand --') {
              self.isSelectedOtherBrand = true;
            }

            $scope.tags = [];
            // Extract distinct tags into String array
            for (var i = 0; i < resp.tags.length; i++) {
              //SPECIAL HANDLING, THE TAG WITH PREFIX/PROFIX OF *^/ MEAN IT IS A 'OTHER BRAND' ENTERED BY CUSTOMER.
              //IT SHOULD NOT BE SHOW UP IN TAG.
              if (!resp.tags[i].capitalName.includes("*^/")) {
                if (resp.tags[i].capitalName.length > 0 && !$scope.tags.includes(resp.tags[i].capitalName)) {
                  $scope.tags.push(resp.tags[i].capitalName);
                }
              } else {
                self.otherBrandName = utilities.getCustomBrandName(resp);
              }
            }
            $scope.lookBook = [];
            for (var i = 0; i < resp.lookBook.length; i++) {
              $scope.lookBook.push(resp.lookBook[i].productId);
            }

            //GET CHILD PRODUCTS (SIZE, QTY)
            getChildProductList(self.listing.id);
            self.listing.credit = resp.credit;
            self.loadSizes();
            self.calculateEarnings();
          },
          function(err) {
            DialogAlertService.promptDialog(ErrorHandler.resolveError(err).toString(), '', '', '', '', '', '', true, '', 'RED');
            if (err.data) {
              $rootScope.enableLog ? $log.error($rootScope.UUID + ":listingsEdit:getProductDetails - Search error: " + err.data.reasons[0].message + " (" + self.listing.id + ")") : '';
            } else {
              $rootScope.enableLog ? $log.error($rootScope.UUID + ":listingsEdit:getProductDetails - Search error: " + err + " (" + self.listing.id + ")") : '';
            }
            if(utilities.isShowMainRegion()){
              $state.go('main');
            } else {
              $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
            }
          });
      };


      //////////////////////////////////////////
      //GET RENTAL PRICE
      //////////////////////////////////////////
      function getRentalPrice(discountRate) {
        if ($scope.originalPrice) {
          return priceUtilities.getRentalPrice($scope.originalPrice, discountRate);
        } else {
          return self.listing ? priceUtilities.getRentalPrice(self.listing.price, discountRate) : 0;
        }
      }

      //////////////////////////////////////////
      //GET RENTAL PRICE RANGE FOR DISPLAY PURPOSE
      //////////////////////////////////////////
      self.getRentalPriceRange = function(discountRate) {
        var rentalPrice = getRentalPrice(discountRate);
        if (self.listing && self.listing.price && (self.listing.price <= $scope.originalPrice || !$scope.originalPrice)) {
          return self.proudct_currency + "$" + Math.round(getRentalPrice(discountRate) * 0.7) + " - $" + Math.round(getRentalPrice(discountRate));
        } else {
          return "---"
        }
      }


      ///////////////////////////////////////////////
      // RETURN THE LIST OF CATEGORY
      ///////////////////////////////////////////////
      self.loadCategory = function() {
        RefDataService.getCategories().$promise.then(function(resp) {

          for (var i = 0; i < resp.length; i++) {

            switch (resp[i].name.toLowerCase()) {
              case "accessories":
                resp[i]['icon'] = "icon-accessories";
                break;

              case "clothing":
                resp[i]['icon'] = "icon-clothings";
                break;

              case "bags & luggage":
                resp[i]['icon'] = "icon-bags";
                break;

              case "shoes":
                resp[i]['icon'] = "icon-shoes";
                break;
              default:

            }
          }
          self.categoryList = resp;
        })
      }

      ///////////////////////////////////////////////
      // FITLER THE VALUE OF THE SIZE DDL BASED ON THE CATEGORY
      ///////////////////////////////////////////////
      function getFilteredSizeList() {

        self.displaySizeTitle = [];
        //CREATE FILTER SIZE BASED ON CATEGORY eg.Clothing , Accessories, Bags & Luggage, Shoes
        for (var item in self.sizeForAllCategory) {

          //EXTRACT ONLY THE SIZE FOR THE MATCHING CATEGORY
          if (self.sizeForAllCategory[item].category !== undefined && self.sizeForAllCategory[item].category.toUpperCase() === self.listing.category.name.toUpperCase()) {
            //SIZE FOR THE MATCHED ONE CATEGORY
            for (var size in self.sizeForAllCategory[item].options) {

              //ONLY ADD THE SIZE TO THE DISPLAY SIZE LIST IF IT IS NOT ALREADY IN THE PRODUCT LISTING
              //logic removed to cater for different item conditions
              //if ($scope.tempSizeList.find(p => p.size === self.sizeForAllCategory[item].options[size].key) === undefined) {
                //VALUE OF THE SPECIFIC SIZE OF THE TITLE
                self.displaySizeTitle.push(self.sizeForAllCategory[item].options[size]);
              //}
            }
          }
        }
      }

      ////////////////////////////////////////////////////////////////
      //  REMOVE THE SELECTED PHOTO
      ////////////////////////////////////////////////////////////////
      self.markPhotoToDeleteWithIndex = function(index) {

        //PHOTOS POSITION CHANGED, CONSIDER ALL PHOTOS NEW AND DELETE ALL OLD PHOTOS
        $scope.invalidPhotos = null;
        $scope.photos.splice(index, 1);
        $scope.selectedDisplayPhotoIndex = index != 0 ? index - 1 : 0;
      }

      ////////////////////////////////////////////////////////////////
      //  DISPLAY THE SELECTED THUMBNAIL IN THE BIG VIEW
      ////////////////////////////////////////////////////////////////
      self.displayPhoto = function(selectedPhotoIndex) {
        $scope.selectedDisplayPhotoIndex = selectedPhotoIndex;
      }

      $scope.movePhotoEnabled = function() {
        return ($scope.photos && $scope.photos.length > 1);
      }

      ////////////////////////////////////////////////////////////////
      //  MOVE CURRENT PHOTO TO LEFT
      ////////////////////////////////////////////////////////////////
      $scope.leftClick = function(photoIndex) {
        if (photoIndex > 0) {
          var tempPhoto = $scope.photos[photoIndex];
          $scope.photos.splice(photoIndex, 1);
          $scope.photos.splice(photoIndex - 1, 0, tempPhoto);
          $scope.selectedDisplayPhotoIndex = photoIndex - 1;
        }
      }


      ////////////////////////////////////////////////////////////////
      //  MOVE CURRENT PHOTO TO RIGHT
      ////////////////////////////////////////////////////////////////
      $scope.rightClick = function(photoIndex) {
        if (photoIndex != $scope.photos.length - 1 && $scope.photos.length > 1) {
          var tempPhoto = $scope.photos[photoIndex];
          $scope.photos.splice(photoIndex, 1);
          $scope.photos.splice(photoIndex + 1, 0, tempPhoto);
          $scope.selectedDisplayPhotoIndex = photoIndex + 1;
        }
      }



      ////////////////////////////////////////////////////////////////
      //  CHECK IF IT IS SELECTED THE UPLOAD PHOTO BUTTON
      ////////////////////////////////////////////////////////////////
      self.isUploadPhotoButton = function(selectedPhoto) {
        if ($scope.photos != undefined){
          return $scope.photos.length < self.UPLOAD_PHOTO_LIMIT;
        }else{
          return false;
        }
      }

      ////////////////////////////////////////////////////////////////
      //  UPLOAD PHOTO
      ////////////////////////////////////////////////////////////////
      $scope.uploadFiles = function(files, isProductImage) {
        if (files.length > 0 && $scope.photos) {
          //ONLY ADD THE ALLOWED PHOTOS TO THE MODEL, BASED ON THE MAX PHOTO ALLOWED SIZE
          var allowPhotos = self.UPLOAD_PHOTO_LIMIT - $scope.photos.length > 0 ? self.UPLOAD_PHOTO_LIMIT - $scope.photos.length : self.UPLOAD_PHOTO_LIMIT;
          $scope.photos = files.splice(0, allowPhotos).concat($scope.photos);
          $scope.selectedDisplayPhotoIndex = 0;

        }
      };

      ///////////////////////////////////////////////
      // DISCARD EDIT MODE
      ///////////////////////////////////////////////
      $scope.discardClose = function() {
        window.history.back();
      };

      ///////////////////////////////////////////////
      // LIMITED TO ONLY ALLOW UPLOAD_PHOTO_LIMIT PHOTOS TO BE ADDED
      ///////////////////////////////////////////////
      self.checkPhotoLimit = function(files) {

        self.error_photo = null;
        if ($scope.photos.length + files.length > self.UPLOAD_PHOTO_LIMIT) {
          $scope.selectedDisplayPhotoIndex = 0;
          // self.error_photo = "GENERAL.ERROR.MAX_PRODUCT_PHOTO";
        }
      }


      ///////////////////////////////////////////////
      // UPDATE THE LISTING
      ///////////////////////////////////////////////
      self.update = function() {
        self.lk_listing = true;
        usSpinnerService.spin('spinner');

        var update_listing = {};

        // Resolve brand name
        if (update_listing.brand == '-- Other Brand --') {
          update_listing.brand = self.otherBrand.toUpperCase();
        } else {
          update_listing.brand = self.listing.brand;
        }

        // TRANSFER THE DATA FROM SOURCE TO DESTINATION
        Object.keys(self.listing).forEach(function(key, index) {
          if (key !== 'tags' && key.indexOf('$') === -1 && key !== 'pictures') {
            update_listing[key] = self.listing[key];
          } else if (key === 'pictures') {

            //COMBINE THE EXISTINGS PHOTO AND THE NEWLY ADDED PHOTOS INTO THE LIST
            //IN THE SAME ORDER AS IT SHOWN ON SCREEN.
            update_listing.pictures = [];
            $scope.photos.forEach(function(item, index, array) {
              var posInPositionedPhoto = self.listing.pictures.map(p => p.path).indexOf(item.path);
              if (posInPositionedPhoto != -1) {
                self.listing.pictures[posInPositionedPhoto].picOrder = index;
                // update_listing.pictures[index] = angular.copy(self.listing.pictures[posInPositionedPhoto]);
                update_listing.pictures[index] = self.listing.pictures[posInPositionedPhoto];
              } else {
                //ADD NEW PHOTO TO THE UPDATE LIST
                item.newName = utilities.getNewPhotoFilename(item);
                item.picOrder = index;
                update_listing.pictures.push(item);
              }
            })
          }
        });

        //THE LISTING.PRICE STORED THE ORIGINAL PRICE IF NO DISCOUNT OR PRICE BEFORE DISCOUNT
        if ($scope.priceDiscount) {
          update_listing.discountRate = $scope.priceDiscount;
          update_listing.price = $scope.originalPrice;
        } else {
          update_listing.discountRate = 0;
        }

        if (update_listing.price > 0 && $rootScope.geoLocation.country == CONFIG.COUNTRY_CURRENCY_CODE.SG.country_code){
          var amt = update_listing.price / $scope.sgdForex;
          update_listing.price = Math.round(amt);
        }

        // Resolved tags
        if (!!$scope.tags) {
          update_listing['tags'] = resolveTags($scope.tags);
        }
        if (!!$scope.lookBook) {
	        update_listing['lookBook'] = resolveCompleteTheLook($scope.lookBook);
	      }
        update_listing.credit = self.listing.credit;

        var promises = [];
        var addedPhotos = [];
        for (var indexCounter in $scope.photos) {
          //IF THE PHOTO HAD NO ID, MEAN THIS IS A NEW PHOTO
          if (!$scope.photos[indexCounter].id) {
            addedPhotos.push($scope.photos[indexCounter]);
          }
        }

        if (self.duplicateMode) {
          self.saveNew(update_listing);
        } else {

          // ADD NEW IMAGES SERVICES
          if (addedPhotos && addedPhotos.length > 0) {
            $rootScope.enableLog ? $log.info($rootScope.UUID + ":listingsEdit:update - Uploading " + addedPhotos.length + " photos") : '';

            promises.push(UploadService.uploadPhotosWithPaths(addedPhotos, update_listing.id).then(function(res) {
              //ADD THE PATH INFORMATION TO THE NEWLY ADDED PHOTOS
              update_listing.pictures.forEach(photo => {
                var newPhotoNameArray = res.map(newPhotoPath => newPhotoPath.FILENAME);
                var newPhotoIndex = newPhotoNameArray.indexOf(photo.newName);
                if (newPhotoIndex != -1) {
                  photo.product = update_listing.id;
                  photo.path = res[newPhotoIndex].PATH;
                } else {
                  //EXISTING PHOTO, NO NEED TO ADD PATH INFORMATION TO IT.
                }
              })
            }));
          }

          //ONLY REQUIRE TO PROCESS CHANGE SIZE WHEN SAME PRODUCT MULTI SIZE FEATURE IS DISABLED.
          if (!self.isMultiSizeFeatureEnable){
            $scope.isSizeListValid();
            promises.concat(updateProductItems());
          }

          // Update listing
          $q.all(promises).then(function() {
              ListingService.update(update_listing).$promise.then(function() {
                $rootScope.enableLog ? $log.info($rootScope.UUID + ":listingsEdit:update - Listing updated successfully (" + update_listing.id + ")") : '';
                usSpinnerService.stop('spinner');
                DialogAlertService.promptDialog('Listing updated successfully.', '', '', '', '', function() {
                  if(utilities.isShowMainRegion()){
                    $state.go("listing", {id: update_listing.id})
                  } else {
                    $state.go('listing-multi-region', {id: update_listing.id, country: $rootScope.geoLocation.country});
                  }
                }, '', true);
              }, function(err) {
                self.lk_listing = false;
                usSpinnerService.stop('spinner');
                DialogAlertService.promptDialog('Listing update failed. Please try again later.', '', '', '', '', '', '', true, '', 'RED');
                $rootScope.enableLog ? $log.error($rootScope.UUID + ":listingsEdit:update - Listing edit error.") : '';
              })
            },
            function(err) {
              self.lk_listing = false;
              usSpinnerService.stop('spinner');
              DialogAlertService.promptDialog('Listing update failed. Please try again later.', '', '', '', '', '', '', true, '', 'RED');
              $rootScope.enableLog ? $log.error($rootScope.UUID + ":listingsEdit:update - Listing edit error upload photo error.") : '';
            });
        }
      };

      function resolveCompleteTheLook(productIds) {

        var newProductIds = [];
        if (!!productIds){
          // Remove duplicates
          var tmp = [];
          for (var i = 0; i < productIds.length; i++) {
            if (!tmp.includes(productIds[i].text)) {
              tmp.push(productIds[i].text);
            }
          }
  
          // Build list
          for (var i = 0; i < tmp.length; i++) {
            newProductIds.push({'productId': tmp[i]});
          }
        }
  
          return newProductIds;
      };

      ///////////////////////////////////////////
      // FUNCTION THAT MOVE THE CONTENT OF THE ARRAY
      // FROM ONE POSITION TO ANOTHER POSITION
      ///////////////////////////////////////////
      function move(val, from, to) {
        val.splice(to, 0, val.splice(from, 1)[0])
        return val;
      }

      function resolveTags(tags) {

        var newTags = [];
        if (!!tags) {
          // Remove duplicates
          var tmp = [];
          for (var i = 0; i < tags.length; i++) {
            if (!tmp.includes(tags[i].text.toUpperCase())) {
              tmp.push(tags[i].text.toUpperCase());
            }
          }

          // Build tag list
          for (var i = 0; i < tmp.length; i++) {
            newTags.push({
              "name": tmp[i]
            });
          }
        }

        //SPECIAL LOGIC FOR OTHER BRAND, IT WILL STORED AS A TAG WITH */new brand*/ IN IT.
        if (self.isSelectedOtherBrand) {
          //GLOBALLY REPLACE ' ' WITH '-'
          var regEx = / /gi
          newTags.push({
            "name": "*^/" + self.otherBrandName.replace(regEx, "-").toUpperCase()
          });
        }

        return newTags;
      };


      ///////////////////////////////////////////////
      // VALIDATION METHOD BEFORE UPDATE LISTING.
      // THE VALIDATION METHOD WILL ALSO TRIGGER THE ERROR MSG FOR EACH FIELD
      ///////////////////////////////////////////////
      self.validate = function() {
        var isValid = true;

        if ($scope.photos.length === 0) {
          isValid = false;
          self.error_photo = "GENERAL.ERROR.MISSING_PRODUCT_PHOTO";
        }

        if (!self.listing.category.id) {
          isValid = false;
          self.error_category = "GENERAL.ERROR.MISSING_PRODUCT_CATEGORY";
        }

	      if (!self.listing.subCategory.id && self.listing.category.code === 'CLOTHING') {
	        isValid = false;
			    self.error_subcategory = 'GENERAL.ERROR.MISSING_PRODUCT_SUBCATEGORY';
	      }

        if (!self.listing.brand) {
          isValid = false;
          self.error_brand = "GENERAL.ERROR.MISSING_PRODUCT_BRAND";
        }

        if (!self.listing.productLine) {
          self.error_productLine = "GENERAL.ERROR.MISSING_PRODUCTLINE"
          isValid = false;
        }

        if (self.isSelectedOtherBrand && self.otherBrandName.length == 0) {
          isValid = false;
          self.error_brand = "GENERAL.ERROR.MISSING_PRODUCT_BRAND";
        }

        if (!self.listing.credit) {
          self.error_size = "GENERAL.ERROR.MISSING_CREDIT_VALUE"
          isValid = false;
        }

        if (!self.listing.color) {
          self.error_color = "GENERAL.ERROR.MISSING_PRODUCT_COLOR"
          isValid = false;
        }

        //   ORIGINAL PRICING IS ONLY REQUIRED FOR LISTING, NOT STYLE POST.
        if (self.listing.type === 1) {
          if (!$scope.originalPrice) {
            isValid = false;
            self.error_original_price = "GENERAL.ERROR.MISSING_PRODUCT_ORIGINAL_PRICE";
          } else if ($scope.originalPrice < self.PRODUCT_MIN_PRICE) {
            isValid = false;
            self.error_original_price = "GENERAL.ERROR.INVALID_PRODUCT_ORIGINAL_PRICE"
          } else if ($scope.originalPrice < self.listing.price) {
            isValid = false;
            self.error_original_price = "GENERAL.ERROR.INVALID_PRODUCT_ORIGINAL_PRICE_2"
          }
        }


        if(self.listing.description){
          self.error_productStyleNotes = null;
          if(utilities.containsEmoji(self.listing.description)){
            isValid = false;
            self.error_productStyleNotes = "GENERAL.ERROR.INVALID_ADDITIONAL_DESCRIPTION"
          }
        }

        return isValid;
      }

    function getFilteredSubcategoryList(selectedCategory) {
      for (var item in self.categoryList) {
        if (self.categoryList[item].code !== undefined && self.categoryList[item].code === selectedCategory.code) {
          return self.subcategoryList = self.categoryList[item].subCategory;
        }
      }
    }

		self.calculateEarnings = function() {
			self._earnings = priceUtilities.calculateEarningsByCurrency(self.listing.credit, $rootScope.geoLocation.country);
			self._dollarAmount = self.proudct_currency + "" + priceUtilities.currencyFormat(self.lowestPlanPrice * self.listing.credit);
		}
      
    }]
  })

'use strict';

/**
 * @ngdoc service
 * @name coutureApp.menuBarsService
 * @description
 * # menuBarsService
 * Factory in the coutureApp.
 */
angular.module('coutureApp')
    .factory('menuBarsService', ["$rootScope", "$anchorScroll", "priceUtilities", "$location", function($rootScope, $anchorScroll,priceUtilities,$location) {

			var menuService = {};

      menuService.toggleSidebar = function(toggle) {

        //ALLOW TO TOGGLE THE SIDEBAR IF CURRENTLY NOT IN CHECKOUT PAGE.
        if (!$location.path().includes('checkout')){
          let bodyInnerHeight = document.body.offsetHeight;
          document.querySelector('.checkout-sidebar').style.height = `${bodyInnerHeight}px`;
          document.querySelector('.checkout-sidebar .-sidebar-wrapper').style.height = `${bodyInnerHeight}px`;

          $rootScope.isCheckoutSidebarActive = !$rootScope.isCheckoutSidebarActive;
          $rootScope.isWishlistSidebarActive = toggle;
          if(toggle) $anchorScroll('top');
        }
      },
      menuService.closeSidebar = function() {
          $rootScope.isCheckoutSidebarActive = false;
      },
			menuService.toggleWishlistSidebarOnHover = function() {
				let isWishlistHovered = document.querySelector('.-wishlist.on-drag-hover');
        if(isWishlistHovered) {
          this.toggleSidebar(true);
        }
			}

  	return menuService;
}]);

'use strict';
angular.module('coutureApp')
  .component('shopify', {
    controllerAs : 'shopifyCtrl',
    templateUrl: 'scripts/components/shopify/shopify.html',
    controller: ["$scope", "$state", "$rootScope", "$log", "$anchorScroll", function($scope, $state,$rootScope,$log,$anchorScroll) {

      var self = this;
      this.$onInit = function(){
        $anchorScroll('topSticky');
        $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - shopifyCtrl"):'';

        $scope.shopifyUrl = "https://" + $state.params.shopName + ".myshopify.com/admin/apps";
      }

      

  }]
})

'use strict';

(function(){
  angular.module('coutureApp')
    .component('referrals', {
      templateUrl: 'scripts/components/referrals/referrals.html',
      controllerAs : 'ctrl',
      bindings: {
        loadOrNot: '<'
      },
      controller: ["$rootScope", "$scope", "NgTableParams", "$state", "USER_ROLES", "ReferralService", "AuthService", "$log", "usSpinnerService", "utilities", function($rootScope,$scope,NgTableParams,$state,USER_ROLES,ReferralService,AuthService,$log,usSpinnerService,utilities) {

        this.$onInit = function(){
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - referrals"):'';
          if (!$rootScope.isLogon || !AuthService.isAuthorized(USER_ROLES.admin)){
            if(utilities.isShowMainRegion()){
              $state.go('main');
            } else {
              $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
            }
          }else{
            
          }
        };

        var self = this;

        ///////////////////////////////////////////////
  	    // ONLY LOAD THE LISTING IF IT IS SELECTED/VISIBLE
  	    ///////////////////////////////////////////////
        $scope.$watch('ctrl.loadOrNot', function(selectedToDisplay) {
          if (selectedToDisplay){
            self.originalData = [];
            self.loadReferrals();
          }
        });

        //LOAD ALL THE RENTAL PRODUCTS
        this.loadReferrals = function(){
          self.referrerFilter = {
            'advocate': {
              id: "text",
              placeholder: "Referrer / Advocate"
            }
          };
          self.refereeFilter = {
            'friend': {
              id: "text",
              placeholder: "Referee / Friend"
            }
          };
          self.subscribedFilter = {
            'friendSubscribed': {
              id: "text",
              placeholder: "Subscribed"
            }
          };
          self.referralRewardFilter = {
            'advocatePromoCode': {
              id: "text",
              placeholder: "Referrer Reward"
            }
          };

          self.tableParams = new NgTableParams({ 
            page: 1,
            count: 15,
            sorting: { 
              updatedDate: "DESC"
            },
          }, {
            counts:[15],
            getData: function(params) {
              usSpinnerService.spin('spinner');

              var tableFilters = params._params.filter;
              var filterParams = {};
              var tableParams = params._params;
              var sort = params._params.sorting;
              var sortType = null;
              var sortDir = null;
              
              if(sort.advocate){
                sortType = "advocate";
                sortDir = sort.advocate;
              } else if(sort.friend){
                sortType = "friend";
                sortDir = sort.friend;
              } else if(sort.friendSubscribed){
                sortType = "friendSubscribed";
                sortDir = sort.friendSubscribed;
              } else {
                sortType = "referralId";
                sortDir = "DESC";
              }
              

              filterParams.page = tableParams.page;
              filterParams.advocate = tableFilters.advocate ? tableFilters.advocate : null;
              filterParams.friend = tableFilters.friend ? tableFilters.friend : null;
              filterParams.subscribed = tableFilters.friendSubscribed ? tableFilters.friendSubscribed : null;
              filterParams.signedup = tableFilters.friendSignedUp ? tableFilters.friendSignedUp : null;
              filterParams.advocatePromo = tableFilters.advocatePromoCode ? tableFilters.advocatePromoCode : null;
              filterParams.sortType = sortType;
              filterParams.sortDirection = sortDir;

              var list = [];
              return ReferralService.getReferralList(filterParams).$promise.then(function(resp) {
                $scope.data = resp.referrals;
                self.totalShare = resp.totalShare;
                self.totalView = resp.totalView;
                self.totalSignUp = resp.totalSignUp;
                self.totalSubscription = resp.totalSubscription;
                var totalRecordCount = resp.recordCount;
                var totalPageCount = resp.recordPage;

                for (var i = 0; i < $scope.data.length; i++) {
                  var tempResponse = $scope.data[i];
                  tempResponse._updatedDate = moment(new Date(tempResponse.updatedDate)).format('D/M/YYYY');
                  list.push(tempResponse);
                }
                
                list.sort(function(a, b){return b.updatedDate-a.updatedDate;});

                usSpinnerService.stop('spinner');
                params.total(totalRecordCount);
                return list;
              },
              function(err) {
                usSpinnerService.stop('spinner');
                $rootScope.enableLog ? $log.error($rootScope.UUID + ":referrals:loadReferrals - Error: " + JSON.stringify(err.data.reasons)):'';
              });
            }
          });
        };

      }]
    })
})();

'use strict';

(function(){
  angular.module('coutureApp')
    .component('overduePayments', {
      templateUrl: 'scripts/components/overdue-payments/overdue-payments.html',
      controllerAs : 'ctrl',
      bindings: {
        loadOrNot: '<'
      },
      controller: ["$rootScope", "$scope", "NgTableParams", "$state", "USER_ROLES", "RentalService", "AuthService", "$log", "usSpinnerService", "utilities", "priceUtilities", "$filter", "DialogAlertService", function($rootScope,$scope,NgTableParams,$state,USER_ROLES,RentalService,AuthService,$log,usSpinnerService,utilities, priceUtilities, $filter, DialogAlertService) {

        this.$onInit = function(){
          $rootScope.enableLog ? $log.info($rootScope.UUID + ":Loading - overdue payments"):'';
          if (!$rootScope.isLogon || !AuthService.isAuthorized(USER_ROLES.admin)){
            if(utilities.isShowMainRegion()){
              $state.go('main');
            } else {
              $state.go('main-multi-region', {country: $rootScope.geoLocation.country});
            }
          }else{
            
          }
        };

        var self = this;

        ///////////////////////////////////////////////
  	    // ONLY LOAD THE LISTING IF IT IS SELECTED/VISIBLE
  	    ///////////////////////////////////////////////
        $scope.$watch('ctrl.loadOrNot', function(selectedToDisplay) {
          if (selectedToDisplay){
            self.originalData = [];
            self.loadOverduePayments();
          }
        });

        //LOAD ALL THE RENTAL PRODUCTS
        this.loadOverduePayments = function(){
          usSpinnerService.spin('spinner');
          RentalService.getOverduePayments().$promise.then(function(resp) {
            for (var i = 0; i < resp.length; i++) {
              resp[i]._overdueAmount = resp[i].country + priceUtilities.currencyFormat(resp[i].overdueAmount);
              resp[i].charge = false;
            }

            resp.sort(function(a, b){return b.dueWhen-a.dueWhen;});

            self.tableParams = new NgTableParams({}, {
              filterOptions: {
                filterLayout: "horizontal"
              },
              dataset: resp
            });
            

            usSpinnerService.stop('spinner');
          },
          function(err) {
            usSpinnerService.stop('spinner');
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":referrals:loadOverduePayments - Error: " + JSON.stringify(err.data.reasons)):'';
          });
        };

        self.chargeOverduePayment = function(invoiceId, row) {
          row.charge = true;
          RentalService.preauthOverduePayment(invoiceId).$promise.then(function(resp) {
            $rootScope.enableLog ? $log.info($rootScope.UUID + ":preauthOverduePayment - Preauth Successful."):'';

            RentalService.chargeOverduePayment(invoiceId).$promise.then(function(resp) {
              $rootScope.enableLog ? $log.info($rootScope.UUID + ":chargeOverduePayment - Preauth Successful."):'';
              DialogAlertService.promptDialog('User successfully charged ', '', '', '', 'GENERAL.LABEL.OK', '', '', false);
              
            }, function(err) {
              row.charge = true;
              $rootScope.enableLog ? $log.error($rootScope.UUID + ":chargeOverduePayment - Error: " + err):"";
                
                if(err.data && err.data.reasons && err.data.reasons[0]){
                  switch (err.data.reasons[0].code) {
                    case "FAILED_TO_CREATE_CUSTOMER_OBJECT":
                      self.error_txn = $filter('translate')('GENERAL.ERROR.FAILED_TO_CREATE_CUSTOMER_OBJECT');
                      break;
                    case "CARD_DECLINED":
                      self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_DECLINED');
                      break;
                    case "CARD_INCORRECT_CVC":
                      self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_INCORRECT_CVC');
                      break;
                    case "CARD_INCORRECT_NUMBER":
                      self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_INCORRECT_NUMBER');
                      break;
                    case "CARD_EXPIRED":
                      self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_EXPIRED');
                      break;
                    default:
                      self.error_txn = $filter('translate')('GENERAL.ERROR.PROFILE_ERROR');
                      break;
                  }
                } else {
                  self.error_txn = $filter('translate')('GENERAL.ERROR.PROFILE_ERROR');
                }
  
              DialogAlertService.promptDialog(self.error_txn, '', '', '', 'Ok', '', '', false,'',"RED");
            });

          }, function(err) {
            row.charge = false;
            $rootScope.enableLog ? $log.error($rootScope.UUID + ":preauthOverduePayment - Error: " + err):"";
              
              if(err.data && err.data.reasons && err.data.reasons[0]){
                switch (err.data.reasons[0].code) {
                  case "FAILED_TO_CREATE_CUSTOMER_OBJECT":
                    self.error_txn = $filter('translate')('GENERAL.ERROR.FAILED_TO_CREATE_CUSTOMER_OBJECT');
                    break;
                  case "CARD_DECLINED":
                    self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_DECLINED');
                    break;
                  case "CARD_INCORRECT_CVC":
                    self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_INCORRECT_CVC');
                    break;
                  case "CARD_INCORRECT_NUMBER":
                    self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_INCORRECT_NUMBER');
                    break;
                  case "CARD_EXPIRED":
                    self.error_txn = $filter('translate')('GENERAL.ERROR.CARD_EXPIRED');
                    break;
                  case "BILLING_ERROR":
                    self.error_txn = "Card info not available.";
                    break;
                  case "INVOICE_VOIDED_ERROR":
                    self.error_txn = "This invoice has been voided and cannot be charged.";
                    break;
                  case "INVOICE_VALUE_ERROR":
                    self.error_txn = "This invoice due amount is zero.";
                    break;
                  case "INVOICE_CHARGED_ERROR":
                    self.error_txn = "This invoice has been charged already.";
                    break;
                  default:
                    self.error_txn = $filter('translate')('GENERAL.ERROR.PROFILE_ERROR');
                    break;
                }
              } else {
                self.error_txn = $filter('translate')('GENERAL.ERROR.PROFILE_ERROR');
              }

            DialogAlertService.promptDialog(self.error_txn, '', '', '', 'Ok', '', '', false,'',"RED");
          });
        }

      }]
    })
})();
